var RB = Object.defineProperty;
var GB = (t, A, e) => A in t ? RB(t, A, { enumerable: !0, configurable: !0, writable: !0, value: e }) : t[A] = e;
var ye = (t, A, e) => GB(t, typeof A != "symbol" ? A + "" : A, e);
/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var ml = function(t, A) {
  return ml = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, r) {
    e.__proto__ = r;
  } || function(e, r) {
    for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
  }, ml(t, A);
};
function Ur(t, A) {
  if (typeof A != "function" && A !== null)
    throw new TypeError("Class extends value " + String(A) + " is not a constructor or null");
  ml(t, A);
  function e() {
    this.constructor = t;
  }
  t.prototype = A === null ? Object.create(A) : (e.prototype = A.prototype, new e());
}
var Ql = function() {
  return Ql = Object.assign || function(A) {
    for (var e, r = 1, n = arguments.length; r < n; r++) {
      e = arguments[r];
      for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && (A[i] = e[i]);
    }
    return A;
  }, Ql.apply(this, arguments);
};
function Ot(t, A, e, r) {
  function n(i) {
    return i instanceof e ? i : new e(function(o) {
      o(i);
    });
  }
  return new (e || (e = Promise))(function(i, o) {
    function s(h) {
      try {
        u(r.next(h));
      } catch (p) {
        o(p);
      }
    }
    function c(h) {
      try {
        u(r.throw(h));
      } catch (p) {
        o(p);
      }
    }
    function u(h) {
      h.done ? i(h.value) : n(h.value).then(s, c);
    }
    u((r = r.apply(t, [])).next());
  });
}
function St(t, A) {
  var e = { label: 0, sent: function() {
    if (i[0] & 1) throw i[1];
    return i[1];
  }, trys: [], ops: [] }, r, n, i, o;
  return o = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function s(u) {
    return function(h) {
      return c([u, h]);
    };
  }
  function c(u) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; e; ) try {
      if (r = 1, n && (i = u[0] & 2 ? n.return : u[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, u[1])).done) return i;
      switch (n = 0, i && (u = [u[0] & 2, i.value]), u[0]) {
        case 0:
        case 1:
          i = u;
          break;
        case 4:
          return e.label++, { value: u[1], done: !1 };
        case 5:
          e.label++, n = u[1], u = [0];
          continue;
        case 7:
          u = e.ops.pop(), e.trys.pop();
          continue;
        default:
          if (i = e.trys, !(i = i.length > 0 && i[i.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            e = 0;
            continue;
          }
          if (u[0] === 3 && (!i || u[1] > i[0] && u[1] < i[3])) {
            e.label = u[1];
            break;
          }
          if (u[0] === 6 && e.label < i[1]) {
            e.label = i[1], i = u;
            break;
          }
          if (i && e.label < i[2]) {
            e.label = i[2], e.ops.push(u);
            break;
          }
          i[2] && e.ops.pop(), e.trys.pop();
          continue;
      }
      u = A.call(t, e);
    } catch (h) {
      u = [6, h], n = 0;
    } finally {
      r = i = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}
function Ms(t, A, e) {
  if (arguments.length === 2) for (var r = 0, n = A.length, i; r < n; r++)
    (i || !(r in A)) && (i || (i = Array.prototype.slice.call(A, 0, r)), i[r] = A[r]);
  return t.concat(i || A);
}
var Bn = (
  /** @class */
  (function() {
    function t(A, e, r, n) {
      this.left = A, this.top = e, this.width = r, this.height = n;
    }
    return t.prototype.add = function(A, e, r, n) {
      return new t(this.left + A, this.top + e, this.width + r, this.height + n);
    }, t.fromClientRect = function(A, e) {
      return new t(e.left + A.windowBounds.left, e.top + A.windowBounds.top, e.width, e.height);
    }, t.fromDOMRectList = function(A, e) {
      var r = Array.from(e).find(function(n) {
        return n.width !== 0;
      });
      return r ? new t(r.left + A.windowBounds.left, r.top + A.windowBounds.top, r.width, r.height) : t.EMPTY;
    }, t.EMPTY = new t(0, 0, 0, 0), t;
  })()
), Go = function(t, A) {
  return Bn.fromClientRect(t, A.getBoundingClientRect());
}, VB = function(t) {
  var A = t.body, e = t.documentElement;
  if (!A || !e)
    throw new Error("Unable to get document size");
  var r = Math.max(Math.max(A.scrollWidth, e.scrollWidth), Math.max(A.offsetWidth, e.offsetWidth), Math.max(A.clientWidth, e.clientWidth)), n = Math.max(Math.max(A.scrollHeight, e.scrollHeight), Math.max(A.offsetHeight, e.offsetHeight), Math.max(A.clientHeight, e.clientHeight));
  return new Bn(0, 0, r, n);
}, Vo = function(t) {
  for (var A = [], e = 0, r = t.length; e < r; ) {
    var n = t.charCodeAt(e++);
    if (n >= 55296 && n <= 56319 && e < r) {
      var i = t.charCodeAt(e++);
      (i & 64512) === 56320 ? A.push(((n & 1023) << 10) + (i & 1023) + 65536) : (A.push(n), e--);
    } else
      A.push(n);
  }
  return A;
}, $e = function() {
  for (var t = [], A = 0; A < arguments.length; A++)
    t[A] = arguments[A];
  if (String.fromCodePoint)
    return String.fromCodePoint.apply(String, t);
  var e = t.length;
  if (!e)
    return "";
  for (var r = [], n = -1, i = ""; ++n < e; ) {
    var o = t[n];
    o <= 65535 ? r.push(o) : (o -= 65536, r.push((o >> 10) + 55296, o % 1024 + 56320)), (n + 1 === e || r.length > 16384) && (i += String.fromCharCode.apply(String, r), r.length = 0);
  }
  return i;
}, Yu = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", jB = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var Ks = 0; Ks < Yu.length; Ks++)
  jB[Yu.charCodeAt(Ks)] = Ks;
var zu = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Ta = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var Rs = 0; Rs < zu.length; Rs++)
  Ta[zu.charCodeAt(Rs)] = Rs;
var qB = function(t) {
  var A = t.length * 0.75, e = t.length, r, n = 0, i, o, s, c;
  t[t.length - 1] === "=" && (A--, t[t.length - 2] === "=" && A--);
  var u = typeof ArrayBuffer < "u" && typeof Uint8Array < "u" && typeof Uint8Array.prototype.slice < "u" ? new ArrayBuffer(A) : new Array(A), h = Array.isArray(u) ? u : new Uint8Array(u);
  for (r = 0; r < e; r += 4)
    i = Ta[t.charCodeAt(r)], o = Ta[t.charCodeAt(r + 1)], s = Ta[t.charCodeAt(r + 2)], c = Ta[t.charCodeAt(r + 3)], h[n++] = i << 2 | o >> 4, h[n++] = (o & 15) << 4 | s >> 2, h[n++] = (s & 3) << 6 | c & 63;
  return u;
}, WB = function(t) {
  for (var A = t.length, e = [], r = 0; r < A; r += 2)
    e.push(t[r + 1] << 8 | t[r]);
  return e;
}, XB = function(t) {
  for (var A = t.length, e = [], r = 0; r < A; r += 4)
    e.push(t[r + 3] << 24 | t[r + 2] << 16 | t[r + 1] << 8 | t[r]);
  return e;
}, hi = 5, eu = 11, Nc = 2, JB = eu - hi, l0 = 65536 >> hi, YB = 1 << hi, _c = YB - 1, zB = 1024 >> hi, ZB = l0 + zB, $B = ZB, Ad = 32, ed = $B + Ad, td = 65536 >> eu, rd = 1 << JB, nd = rd - 1, Zu = function(t, A, e) {
  return t.slice ? t.slice(A, e) : new Uint16Array(Array.prototype.slice.call(t, A, e));
}, id = function(t, A, e) {
  return t.slice ? t.slice(A, e) : new Uint32Array(Array.prototype.slice.call(t, A, e));
}, ad = function(t, A) {
  var e = qB(t), r = Array.isArray(e) ? XB(e) : new Uint32Array(e), n = Array.isArray(e) ? WB(e) : new Uint16Array(e), i = 24, o = Zu(n, i / 2, r[4] / 2), s = r[5] === 2 ? Zu(n, (i + r[4]) / 2) : id(r, Math.ceil((i + r[4]) / 4));
  return new sd(r[0], r[1], r[2], r[3], o, s);
}, sd = (
  /** @class */
  (function() {
    function t(A, e, r, n, i, o) {
      this.initialValue = A, this.errorValue = e, this.highStart = r, this.highValueIndex = n, this.index = i, this.data = o;
    }
    return t.prototype.get = function(A) {
      var e;
      if (A >= 0) {
        if (A < 55296 || A > 56319 && A <= 65535)
          return e = this.index[A >> hi], e = (e << Nc) + (A & _c), this.data[e];
        if (A <= 65535)
          return e = this.index[l0 + (A - 55296 >> hi)], e = (e << Nc) + (A & _c), this.data[e];
        if (A < this.highStart)
          return e = ed - td + (A >> eu), e = this.index[e], e += A >> hi & nd, e = this.index[e], e = (e << Nc) + (A & _c), this.data[e];
        if (A <= 1114111)
          return this.data[this.highValueIndex];
      }
      return this.errorValue;
    }, t;
  })()
), $u = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", od = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var Gs = 0; Gs < $u.length; Gs++)
  od[$u.charCodeAt(Gs)] = Gs;
var cd = "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", Af = 50, ld = 1, u0 = 2, f0 = 3, ud = 4, fd = 5, ef = 7, h0 = 8, tf = 9, Tn = 10, Fl = 11, rf = 12, Ul = 13, hd = 14, Oa = 15, bl = 16, Vs = 17, Ia = 18, Bd = 19, nf = 20, yl = 21, Sa = 22, Dc = 23, Ni = 24, zt = 25, ka = 26, Pa = 27, _i = 28, dd = 29, li = 30, gd = 31, js = 32, qs = 33, El = 34, Ll = 35, xl = 36, Ya = 37, Il = 38, vo = 39, Co = 40, Tc = 41, B0 = 42, pd = 43, wd = [9001, 65288], d0 = "!", he = "×", Ws = "÷", Sl = ad(cd), on = [li, xl], Hl = [ld, u0, f0, fd], g0 = [Tn, h0], af = [Pa, ka], vd = Hl.concat(g0), sf = [Il, vo, Co, El, Ll], Cd = [Oa, Ul], md = function(t, A) {
  A === void 0 && (A = "strict");
  var e = [], r = [], n = [];
  return t.forEach(function(i, o) {
    var s = Sl.get(i);
    if (s > Af ? (n.push(!0), s -= Af) : n.push(!1), ["normal", "auto", "loose"].indexOf(A) !== -1 && [8208, 8211, 12316, 12448].indexOf(i) !== -1)
      return r.push(o), e.push(bl);
    if (s === ud || s === Fl) {
      if (o === 0)
        return r.push(o), e.push(li);
      var c = e[o - 1];
      return vd.indexOf(c) === -1 ? (r.push(r[o - 1]), e.push(c)) : (r.push(o), e.push(li));
    }
    if (r.push(o), s === gd)
      return e.push(A === "strict" ? yl : Ya);
    if (s === B0 || s === dd)
      return e.push(li);
    if (s === pd)
      return i >= 131072 && i <= 196605 || i >= 196608 && i <= 262141 ? e.push(Ya) : e.push(li);
    e.push(s);
  }), [r, e, n];
}, Oc = function(t, A, e, r) {
  var n = r[e];
  if (Array.isArray(t) ? t.indexOf(n) !== -1 : t === n)
    for (var i = e; i <= r.length; ) {
      i++;
      var o = r[i];
      if (o === A)
        return !0;
      if (o !== Tn)
        break;
    }
  if (n === Tn)
    for (var i = e; i > 0; ) {
      i--;
      var s = r[i];
      if (Array.isArray(t) ? t.indexOf(s) !== -1 : t === s)
        for (var c = e; c <= r.length; ) {
          c++;
          var o = r[c];
          if (o === A)
            return !0;
          if (o !== Tn)
            break;
        }
      if (s !== Tn)
        break;
    }
  return !1;
}, of = function(t, A) {
  for (var e = t; e >= 0; ) {
    var r = A[e];
    if (r === Tn)
      e--;
    else
      return r;
  }
  return 0;
}, Qd = function(t, A, e, r, n) {
  if (e[r] === 0)
    return he;
  var i = r - 1;
  if (Array.isArray(n) && n[i] === !0)
    return he;
  var o = i - 1, s = i + 1, c = A[i], u = o >= 0 ? A[o] : 0, h = A[s];
  if (c === u0 && h === f0)
    return he;
  if (Hl.indexOf(c) !== -1)
    return d0;
  if (Hl.indexOf(h) !== -1 || g0.indexOf(h) !== -1)
    return he;
  if (of(i, A) === h0)
    return Ws;
  if (Sl.get(t[i]) === Fl || (c === js || c === qs) && Sl.get(t[s]) === Fl || c === ef || h === ef || c === tf || [Tn, Ul, Oa].indexOf(c) === -1 && h === tf || [Vs, Ia, Bd, Ni, _i].indexOf(h) !== -1 || of(i, A) === Sa || Oc(Dc, Sa, i, A) || Oc([Vs, Ia], yl, i, A) || Oc(rf, rf, i, A))
    return he;
  if (c === Tn)
    return Ws;
  if (c === Dc || h === Dc)
    return he;
  if (h === bl || c === bl)
    return Ws;
  if ([Ul, Oa, yl].indexOf(h) !== -1 || c === hd || u === xl && Cd.indexOf(c) !== -1 || c === _i && h === xl || h === nf || on.indexOf(h) !== -1 && c === zt || on.indexOf(c) !== -1 && h === zt || c === Pa && [Ya, js, qs].indexOf(h) !== -1 || [Ya, js, qs].indexOf(c) !== -1 && h === ka || on.indexOf(c) !== -1 && af.indexOf(h) !== -1 || af.indexOf(c) !== -1 && on.indexOf(h) !== -1 || // (PR | PO) × ( OP | HY )? NU
  [Pa, ka].indexOf(c) !== -1 && (h === zt || [Sa, Oa].indexOf(h) !== -1 && A[s + 1] === zt) || // ( OP | HY ) × NU
  [Sa, Oa].indexOf(c) !== -1 && h === zt || // NU ×	(NU | SY | IS)
  c === zt && [zt, _i, Ni].indexOf(h) !== -1)
    return he;
  if ([zt, _i, Ni, Vs, Ia].indexOf(h) !== -1)
    for (var p = i; p >= 0; ) {
      var w = A[p];
      if (w === zt)
        return he;
      if ([_i, Ni].indexOf(w) !== -1)
        p--;
      else
        break;
    }
  if ([Pa, ka].indexOf(h) !== -1)
    for (var p = [Vs, Ia].indexOf(c) !== -1 ? o : i; p >= 0; ) {
      var w = A[p];
      if (w === zt)
        return he;
      if ([_i, Ni].indexOf(w) !== -1)
        p--;
      else
        break;
    }
  if (Il === c && [Il, vo, El, Ll].indexOf(h) !== -1 || [vo, El].indexOf(c) !== -1 && [vo, Co].indexOf(h) !== -1 || [Co, Ll].indexOf(c) !== -1 && h === Co || sf.indexOf(c) !== -1 && [nf, ka].indexOf(h) !== -1 || sf.indexOf(h) !== -1 && c === Pa || on.indexOf(c) !== -1 && on.indexOf(h) !== -1 || c === Ni && on.indexOf(h) !== -1 || on.concat(zt).indexOf(c) !== -1 && h === Sa && wd.indexOf(t[s]) === -1 || on.concat(zt).indexOf(h) !== -1 && c === Ia)
    return he;
  if (c === Tc && h === Tc) {
    for (var d = e[i], y = 1; d > 0 && (d--, A[d] === Tc); )
      y++;
    if (y % 2 !== 0)
      return he;
  }
  return c === js && h === qs ? he : Ws;
}, Fd = function(t, A) {
  A || (A = { lineBreak: "normal", wordBreak: "normal" });
  var e = md(t, A.lineBreak), r = e[0], n = e[1], i = e[2];
  (A.wordBreak === "break-all" || A.wordBreak === "break-word") && (n = n.map(function(s) {
    return [zt, li, B0].indexOf(s) !== -1 ? Ya : s;
  }));
  var o = A.wordBreak === "keep-all" ? i.map(function(s, c) {
    return s && t[c] >= 19968 && t[c] <= 40959;
  }) : void 0;
  return [r, n, o];
}, Ud = (
  /** @class */
  (function() {
    function t(A, e, r, n) {
      this.codePoints = A, this.required = e === d0, this.start = r, this.end = n;
    }
    return t.prototype.slice = function() {
      return $e.apply(void 0, this.codePoints.slice(this.start, this.end));
    }, t;
  })()
), bd = function(t, A) {
  var e = Vo(t), r = Fd(e, A), n = r[0], i = r[1], o = r[2], s = e.length, c = 0, u = 0;
  return {
    next: function() {
      if (u >= s)
        return { done: !0, value: null };
      for (var h = he; u < s && (h = Qd(e, i, n, ++u, o)) === he; )
        ;
      if (h !== he || u === s) {
        var p = new Ud(e, h, c, u);
        return c = u, { value: p, done: !1 };
      }
      return { done: !0, value: null };
    }
  };
}, yd = 1, Ed = 2, es = 4, cf = 8, xo = 10, lf = 47, Ga = 92, Ld = 9, xd = 32, Xs = 34, Ha = 61, Id = 35, Sd = 36, Hd = 37, Js = 39, Ys = 40, Na = 41, Nd = 95, Mt = 45, _d = 33, Dd = 60, Td = 62, Od = 64, kd = 91, Pd = 93, Md = 61, Kd = 123, zs = 63, Rd = 125, uf = 124, Gd = 126, Vd = 128, ff = 65533, kc = 42, fi = 43, jd = 44, qd = 58, Wd = 59, za = 46, Xd = 0, Jd = 8, Yd = 11, zd = 14, Zd = 31, $d = 127, Tr = -1, p0 = 48, w0 = 97, v0 = 101, Ag = 102, eg = 117, tg = 122, C0 = 65, m0 = 69, Q0 = 70, rg = 85, ng = 90, Ht = function(t) {
  return t >= p0 && t <= 57;
}, ig = function(t) {
  return t >= 55296 && t <= 57343;
}, Di = function(t) {
  return Ht(t) || t >= C0 && t <= Q0 || t >= w0 && t <= Ag;
}, ag = function(t) {
  return t >= w0 && t <= tg;
}, sg = function(t) {
  return t >= C0 && t <= ng;
}, og = function(t) {
  return ag(t) || sg(t);
}, cg = function(t) {
  return t >= Vd;
}, Zs = function(t) {
  return t === xo || t === Ld || t === xd;
}, Io = function(t) {
  return og(t) || cg(t) || t === Nd;
}, hf = function(t) {
  return Io(t) || Ht(t) || t === Mt;
}, lg = function(t) {
  return t >= Xd && t <= Jd || t === Yd || t >= zd && t <= Zd || t === $d;
}, Dn = function(t, A) {
  return t !== Ga ? !1 : A !== xo;
}, $s = function(t, A, e) {
  return t === Mt ? Io(A) || Dn(A, e) : Io(t) ? !0 : !!(t === Ga && Dn(t, A));
}, Pc = function(t, A, e) {
  return t === fi || t === Mt ? Ht(A) ? !0 : A === za && Ht(e) : Ht(t === za ? A : t);
}, ug = function(t) {
  var A = 0, e = 1;
  (t[A] === fi || t[A] === Mt) && (t[A] === Mt && (e = -1), A++);
  for (var r = []; Ht(t[A]); )
    r.push(t[A++]);
  var n = r.length ? parseInt($e.apply(void 0, r), 10) : 0;
  t[A] === za && A++;
  for (var i = []; Ht(t[A]); )
    i.push(t[A++]);
  var o = i.length, s = o ? parseInt($e.apply(void 0, i), 10) : 0;
  (t[A] === m0 || t[A] === v0) && A++;
  var c = 1;
  (t[A] === fi || t[A] === Mt) && (t[A] === Mt && (c = -1), A++);
  for (var u = []; Ht(t[A]); )
    u.push(t[A++]);
  var h = u.length ? parseInt($e.apply(void 0, u), 10) : 0;
  return e * (n + s * Math.pow(10, -o)) * Math.pow(10, c * h);
}, fg = {
  type: 2
  /* LEFT_PARENTHESIS_TOKEN */
}, hg = {
  type: 3
  /* RIGHT_PARENTHESIS_TOKEN */
}, Bg = {
  type: 4
  /* COMMA_TOKEN */
}, dg = {
  type: 13
  /* SUFFIX_MATCH_TOKEN */
}, gg = {
  type: 8
  /* PREFIX_MATCH_TOKEN */
}, pg = {
  type: 21
  /* COLUMN_TOKEN */
}, wg = {
  type: 9
  /* DASH_MATCH_TOKEN */
}, vg = {
  type: 10
  /* INCLUDE_MATCH_TOKEN */
}, Cg = {
  type: 11
  /* LEFT_CURLY_BRACKET_TOKEN */
}, mg = {
  type: 12
  /* RIGHT_CURLY_BRACKET_TOKEN */
}, Qg = {
  type: 14
  /* SUBSTRING_MATCH_TOKEN */
}, Ao = {
  type: 23
  /* BAD_URL_TOKEN */
}, Fg = {
  type: 1
  /* BAD_STRING_TOKEN */
}, Ug = {
  type: 25
  /* CDO_TOKEN */
}, bg = {
  type: 24
  /* CDC_TOKEN */
}, yg = {
  type: 26
  /* COLON_TOKEN */
}, Eg = {
  type: 27
  /* SEMICOLON_TOKEN */
}, Lg = {
  type: 28
  /* LEFT_SQUARE_BRACKET_TOKEN */
}, xg = {
  type: 29
  /* RIGHT_SQUARE_BRACKET_TOKEN */
}, Ig = {
  type: 31
  /* WHITESPACE_TOKEN */
}, Nl = {
  type: 32
  /* EOF_TOKEN */
}, F0 = (
  /** @class */
  (function() {
    function t() {
      this._value = [];
    }
    return t.prototype.write = function(A) {
      this._value = this._value.concat(Vo(A));
    }, t.prototype.read = function() {
      for (var A = [], e = this.consumeToken(); e !== Nl; )
        A.push(e), e = this.consumeToken();
      return A;
    }, t.prototype.consumeToken = function() {
      var A = this.consumeCodePoint();
      switch (A) {
        case Xs:
          return this.consumeStringToken(Xs);
        case Id:
          var e = this.peekCodePoint(0), r = this.peekCodePoint(1), n = this.peekCodePoint(2);
          if (hf(e) || Dn(r, n)) {
            var i = $s(e, r, n) ? Ed : yd, o = this.consumeName();
            return { type: 5, value: o, flags: i };
          }
          break;
        case Sd:
          if (this.peekCodePoint(0) === Ha)
            return this.consumeCodePoint(), dg;
          break;
        case Js:
          return this.consumeStringToken(Js);
        case Ys:
          return fg;
        case Na:
          return hg;
        case kc:
          if (this.peekCodePoint(0) === Ha)
            return this.consumeCodePoint(), Qg;
          break;
        case fi:
          if (Pc(A, this.peekCodePoint(0), this.peekCodePoint(1)))
            return this.reconsumeCodePoint(A), this.consumeNumericToken();
          break;
        case jd:
          return Bg;
        case Mt:
          var s = A, c = this.peekCodePoint(0), u = this.peekCodePoint(1);
          if (Pc(s, c, u))
            return this.reconsumeCodePoint(A), this.consumeNumericToken();
          if ($s(s, c, u))
            return this.reconsumeCodePoint(A), this.consumeIdentLikeToken();
          if (c === Mt && u === Td)
            return this.consumeCodePoint(), this.consumeCodePoint(), bg;
          break;
        case za:
          if (Pc(A, this.peekCodePoint(0), this.peekCodePoint(1)))
            return this.reconsumeCodePoint(A), this.consumeNumericToken();
          break;
        case lf:
          if (this.peekCodePoint(0) === kc)
            for (this.consumeCodePoint(); ; ) {
              var h = this.consumeCodePoint();
              if (h === kc && (h = this.consumeCodePoint(), h === lf))
                return this.consumeToken();
              if (h === Tr)
                return this.consumeToken();
            }
          break;
        case qd:
          return yg;
        case Wd:
          return Eg;
        case Dd:
          if (this.peekCodePoint(0) === _d && this.peekCodePoint(1) === Mt && this.peekCodePoint(2) === Mt)
            return this.consumeCodePoint(), this.consumeCodePoint(), Ug;
          break;
        case Od:
          var p = this.peekCodePoint(0), w = this.peekCodePoint(1), d = this.peekCodePoint(2);
          if ($s(p, w, d)) {
            var o = this.consumeName();
            return { type: 7, value: o };
          }
          break;
        case kd:
          return Lg;
        case Ga:
          if (Dn(A, this.peekCodePoint(0)))
            return this.reconsumeCodePoint(A), this.consumeIdentLikeToken();
          break;
        case Pd:
          return xg;
        case Md:
          if (this.peekCodePoint(0) === Ha)
            return this.consumeCodePoint(), gg;
          break;
        case Kd:
          return Cg;
        case Rd:
          return mg;
        case eg:
        case rg:
          var y = this.peekCodePoint(0), b = this.peekCodePoint(1);
          return y === fi && (Di(b) || b === zs) && (this.consumeCodePoint(), this.consumeUnicodeRangeToken()), this.reconsumeCodePoint(A), this.consumeIdentLikeToken();
        case uf:
          if (this.peekCodePoint(0) === Ha)
            return this.consumeCodePoint(), wg;
          if (this.peekCodePoint(0) === uf)
            return this.consumeCodePoint(), pg;
          break;
        case Gd:
          if (this.peekCodePoint(0) === Ha)
            return this.consumeCodePoint(), vg;
          break;
        case Tr:
          return Nl;
      }
      return Zs(A) ? (this.consumeWhiteSpace(), Ig) : Ht(A) ? (this.reconsumeCodePoint(A), this.consumeNumericToken()) : Io(A) ? (this.reconsumeCodePoint(A), this.consumeIdentLikeToken()) : { type: 6, value: $e(A) };
    }, t.prototype.consumeCodePoint = function() {
      var A = this._value.shift();
      return typeof A > "u" ? -1 : A;
    }, t.prototype.reconsumeCodePoint = function(A) {
      this._value.unshift(A);
    }, t.prototype.peekCodePoint = function(A) {
      return A >= this._value.length ? -1 : this._value[A];
    }, t.prototype.consumeUnicodeRangeToken = function() {
      for (var A = [], e = this.consumeCodePoint(); Di(e) && A.length < 6; )
        A.push(e), e = this.consumeCodePoint();
      for (var r = !1; e === zs && A.length < 6; )
        A.push(e), e = this.consumeCodePoint(), r = !0;
      if (r) {
        var n = parseInt($e.apply(void 0, A.map(function(c) {
          return c === zs ? p0 : c;
        })), 16), i = parseInt($e.apply(void 0, A.map(function(c) {
          return c === zs ? Q0 : c;
        })), 16);
        return { type: 30, start: n, end: i };
      }
      var o = parseInt($e.apply(void 0, A), 16);
      if (this.peekCodePoint(0) === Mt && Di(this.peekCodePoint(1))) {
        this.consumeCodePoint(), e = this.consumeCodePoint();
        for (var s = []; Di(e) && s.length < 6; )
          s.push(e), e = this.consumeCodePoint();
        var i = parseInt($e.apply(void 0, s), 16);
        return { type: 30, start: o, end: i };
      } else
        return { type: 30, start: o, end: o };
    }, t.prototype.consumeIdentLikeToken = function() {
      var A = this.consumeName();
      return A.toLowerCase() === "url" && this.peekCodePoint(0) === Ys ? (this.consumeCodePoint(), this.consumeUrlToken()) : this.peekCodePoint(0) === Ys ? (this.consumeCodePoint(), { type: 19, value: A }) : { type: 20, value: A };
    }, t.prototype.consumeUrlToken = function() {
      var A = [];
      if (this.consumeWhiteSpace(), this.peekCodePoint(0) === Tr)
        return { type: 22, value: "" };
      var e = this.peekCodePoint(0);
      if (e === Js || e === Xs) {
        var r = this.consumeStringToken(this.consumeCodePoint());
        return r.type === 0 && (this.consumeWhiteSpace(), this.peekCodePoint(0) === Tr || this.peekCodePoint(0) === Na) ? (this.consumeCodePoint(), { type: 22, value: r.value }) : (this.consumeBadUrlRemnants(), Ao);
      }
      for (; ; ) {
        var n = this.consumeCodePoint();
        if (n === Tr || n === Na)
          return { type: 22, value: $e.apply(void 0, A) };
        if (Zs(n))
          return this.consumeWhiteSpace(), this.peekCodePoint(0) === Tr || this.peekCodePoint(0) === Na ? (this.consumeCodePoint(), { type: 22, value: $e.apply(void 0, A) }) : (this.consumeBadUrlRemnants(), Ao);
        if (n === Xs || n === Js || n === Ys || lg(n))
          return this.consumeBadUrlRemnants(), Ao;
        if (n === Ga)
          if (Dn(n, this.peekCodePoint(0)))
            A.push(this.consumeEscapedCodePoint());
          else
            return this.consumeBadUrlRemnants(), Ao;
        else
          A.push(n);
      }
    }, t.prototype.consumeWhiteSpace = function() {
      for (; Zs(this.peekCodePoint(0)); )
        this.consumeCodePoint();
    }, t.prototype.consumeBadUrlRemnants = function() {
      for (; ; ) {
        var A = this.consumeCodePoint();
        if (A === Na || A === Tr)
          return;
        Dn(A, this.peekCodePoint(0)) && this.consumeEscapedCodePoint();
      }
    }, t.prototype.consumeStringSlice = function(A) {
      for (var e = 5e4, r = ""; A > 0; ) {
        var n = Math.min(e, A);
        r += $e.apply(void 0, this._value.splice(0, n)), A -= n;
      }
      return this._value.shift(), r;
    }, t.prototype.consumeStringToken = function(A) {
      var e = "", r = 0;
      do {
        var n = this._value[r];
        if (n === Tr || n === void 0 || n === A)
          return e += this.consumeStringSlice(r), { type: 0, value: e };
        if (n === xo)
          return this._value.splice(0, r), Fg;
        if (n === Ga) {
          var i = this._value[r + 1];
          i !== Tr && i !== void 0 && (i === xo ? (e += this.consumeStringSlice(r), r = -1, this._value.shift()) : Dn(n, i) && (e += this.consumeStringSlice(r), e += $e(this.consumeEscapedCodePoint()), r = -1));
        }
        r++;
      } while (!0);
    }, t.prototype.consumeNumber = function() {
      var A = [], e = es, r = this.peekCodePoint(0);
      for ((r === fi || r === Mt) && A.push(this.consumeCodePoint()); Ht(this.peekCodePoint(0)); )
        A.push(this.consumeCodePoint());
      r = this.peekCodePoint(0);
      var n = this.peekCodePoint(1);
      if (r === za && Ht(n))
        for (A.push(this.consumeCodePoint(), this.consumeCodePoint()), e = cf; Ht(this.peekCodePoint(0)); )
          A.push(this.consumeCodePoint());
      r = this.peekCodePoint(0), n = this.peekCodePoint(1);
      var i = this.peekCodePoint(2);
      if ((r === m0 || r === v0) && ((n === fi || n === Mt) && Ht(i) || Ht(n)))
        for (A.push(this.consumeCodePoint(), this.consumeCodePoint()), e = cf; Ht(this.peekCodePoint(0)); )
          A.push(this.consumeCodePoint());
      return [ug(A), e];
    }, t.prototype.consumeNumericToken = function() {
      var A = this.consumeNumber(), e = A[0], r = A[1], n = this.peekCodePoint(0), i = this.peekCodePoint(1), o = this.peekCodePoint(2);
      if ($s(n, i, o)) {
        var s = this.consumeName();
        return { type: 15, number: e, flags: r, unit: s };
      }
      return n === Hd ? (this.consumeCodePoint(), { type: 16, number: e, flags: r }) : { type: 17, number: e, flags: r };
    }, t.prototype.consumeEscapedCodePoint = function() {
      var A = this.consumeCodePoint();
      if (Di(A)) {
        for (var e = $e(A); Di(this.peekCodePoint(0)) && e.length < 6; )
          e += $e(this.consumeCodePoint());
        Zs(this.peekCodePoint(0)) && this.consumeCodePoint();
        var r = parseInt(e, 16);
        return r === 0 || ig(r) || r > 1114111 ? ff : r;
      }
      return A === Tr ? ff : A;
    }, t.prototype.consumeName = function() {
      for (var A = ""; ; ) {
        var e = this.consumeCodePoint();
        if (hf(e))
          A += $e(e);
        else if (Dn(e, this.peekCodePoint(0)))
          A += $e(this.consumeEscapedCodePoint());
        else
          return this.reconsumeCodePoint(e), A;
      }
    }, t;
  })()
), U0 = (
  /** @class */
  (function() {
    function t(A) {
      this._tokens = A;
    }
    return t.create = function(A) {
      var e = new F0();
      return e.write(A), new t(e.read());
    }, t.parseValue = function(A) {
      return t.create(A).parseComponentValue();
    }, t.parseValues = function(A) {
      return t.create(A).parseComponentValues();
    }, t.prototype.parseComponentValue = function() {
      for (var A = this.consumeToken(); A.type === 31; )
        A = this.consumeToken();
      if (A.type === 32)
        throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
      this.reconsumeToken(A);
      var e = this.consumeComponentValue();
      do
        A = this.consumeToken();
      while (A.type === 31);
      if (A.type === 32)
        return e;
      throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
    }, t.prototype.parseComponentValues = function() {
      for (var A = []; ; ) {
        var e = this.consumeComponentValue();
        if (e.type === 32)
          return A;
        A.push(e), A.push();
      }
    }, t.prototype.consumeComponentValue = function() {
      var A = this.consumeToken();
      switch (A.type) {
        case 11:
        case 28:
        case 2:
          return this.consumeSimpleBlock(A.type);
        case 19:
          return this.consumeFunction(A);
      }
      return A;
    }, t.prototype.consumeSimpleBlock = function(A) {
      for (var e = { type: A, values: [] }, r = this.consumeToken(); ; ) {
        if (r.type === 32 || Hg(r, A))
          return e;
        this.reconsumeToken(r), e.values.push(this.consumeComponentValue()), r = this.consumeToken();
      }
    }, t.prototype.consumeFunction = function(A) {
      for (var e = {
        name: A.value,
        values: [],
        type: 18
        /* FUNCTION */
      }; ; ) {
        var r = this.consumeToken();
        if (r.type === 32 || r.type === 3)
          return e;
        this.reconsumeToken(r), e.values.push(this.consumeComponentValue());
      }
    }, t.prototype.consumeToken = function() {
      var A = this._tokens.shift();
      return typeof A > "u" ? Nl : A;
    }, t.prototype.reconsumeToken = function(A) {
      this._tokens.unshift(A);
    }, t;
  })()
), ts = function(t) {
  return t.type === 15;
}, Aa = function(t) {
  return t.type === 17;
}, Le = function(t) {
  return t.type === 20;
}, Sg = function(t) {
  return t.type === 0;
}, _l = function(t, A) {
  return Le(t) && t.value === A;
}, b0 = function(t) {
  return t.type !== 31;
}, $i = function(t) {
  return t.type !== 31 && t.type !== 4;
}, Mr = function(t) {
  var A = [], e = [];
  return t.forEach(function(r) {
    if (r.type === 4) {
      if (e.length === 0)
        throw new Error("Error parsing function args, zero tokens for arg");
      A.push(e), e = [];
      return;
    }
    r.type !== 31 && e.push(r);
  }), e.length && A.push(e), A;
}, Hg = function(t, A) {
  return A === 11 && t.type === 12 || A === 28 && t.type === 29 ? !0 : A === 2 && t.type === 3;
}, Rn = function(t) {
  return t.type === 17 || t.type === 15;
}, at = function(t) {
  return t.type === 16 || Rn(t);
}, y0 = function(t) {
  return t.length > 1 ? [t[0], t[1]] : [t[0]];
}, Ut = {
  type: 17,
  number: 0,
  flags: es
}, tu = {
  type: 16,
  number: 50,
  flags: es
}, On = {
  type: 16,
  number: 100,
  flags: es
}, Ma = function(t, A, e) {
  var r = t[0], n = t[1];
  return [De(r, A), De(typeof n < "u" ? n : r, e)];
}, De = function(t, A) {
  if (t.type === 16)
    return t.number / 100 * A;
  if (ts(t))
    switch (t.unit) {
      case "rem":
      case "em":
        return 16 * t.number;
      // TODO use correct font-size
      case "px":
      default:
        return t.number;
    }
  return t.number;
}, E0 = "deg", L0 = "grad", x0 = "rad", I0 = "turn", jo = {
  name: "angle",
  parse: function(t, A) {
    if (A.type === 15)
      switch (A.unit) {
        case E0:
          return Math.PI * A.number / 180;
        case L0:
          return Math.PI / 200 * A.number;
        case x0:
          return A.number;
        case I0:
          return Math.PI * 2 * A.number;
      }
    throw new Error("Unsupported angle type");
  }
}, S0 = function(t) {
  return t.type === 15 && (t.unit === E0 || t.unit === L0 || t.unit === x0 || t.unit === I0);
}, H0 = function(t) {
  var A = t.filter(Le).map(function(e) {
    return e.value;
  }).join(" ");
  switch (A) {
    case "to bottom right":
    case "to right bottom":
    case "left top":
    case "top left":
      return [Ut, Ut];
    case "to top":
    case "bottom":
      return lr(0);
    case "to bottom left":
    case "to left bottom":
    case "right top":
    case "top right":
      return [Ut, On];
    case "to right":
    case "left":
      return lr(90);
    case "to top left":
    case "to left top":
    case "right bottom":
    case "bottom right":
      return [On, On];
    case "to bottom":
    case "top":
      return lr(180);
    case "to top right":
    case "to right top":
    case "left bottom":
    case "bottom left":
      return [On, Ut];
    case "to left":
    case "right":
      return lr(270);
  }
  return 0;
}, lr = function(t) {
  return Math.PI * t / 180;
}, Mn = {
  name: "color",
  parse: function(t, A) {
    if (A.type === 18) {
      var e = Ng[A.name];
      if (typeof e > "u")
        throw new Error('Attempting to parse an unsupported color function "' + A.name + '"');
      return e(t, A.values);
    }
    if (A.type === 5) {
      if (A.value.length === 3) {
        var r = A.value.substring(0, 1), n = A.value.substring(1, 2), i = A.value.substring(2, 3);
        return kn(parseInt(r + r, 16), parseInt(n + n, 16), parseInt(i + i, 16), 1);
      }
      if (A.value.length === 4) {
        var r = A.value.substring(0, 1), n = A.value.substring(1, 2), i = A.value.substring(2, 3), o = A.value.substring(3, 4);
        return kn(parseInt(r + r, 16), parseInt(n + n, 16), parseInt(i + i, 16), parseInt(o + o, 16) / 255);
      }
      if (A.value.length === 6) {
        var r = A.value.substring(0, 2), n = A.value.substring(2, 4), i = A.value.substring(4, 6);
        return kn(parseInt(r, 16), parseInt(n, 16), parseInt(i, 16), 1);
      }
      if (A.value.length === 8) {
        var r = A.value.substring(0, 2), n = A.value.substring(2, 4), i = A.value.substring(4, 6), o = A.value.substring(6, 8);
        return kn(parseInt(r, 16), parseInt(n, 16), parseInt(i, 16), parseInt(o, 16) / 255);
      }
    }
    if (A.type === 20) {
      var s = hn[A.value.toUpperCase()];
      if (typeof s < "u")
        return s;
    }
    return hn.TRANSPARENT;
  }
}, Kn = function(t) {
  return (255 & t) === 0;
}, dt = function(t) {
  var A = 255 & t, e = 255 & t >> 8, r = 255 & t >> 16, n = 255 & t >> 24;
  return A < 255 ? "rgba(" + n + "," + r + "," + e + "," + A / 255 + ")" : "rgb(" + n + "," + r + "," + e + ")";
}, kn = function(t, A, e, r) {
  return (t << 24 | A << 16 | e << 8 | Math.round(r * 255) << 0) >>> 0;
}, Bf = function(t, A) {
  if (t.type === 17)
    return t.number;
  if (t.type === 16) {
    var e = A === 3 ? 1 : 255;
    return A === 3 ? t.number / 100 * e : Math.round(t.number / 100 * e);
  }
  return 0;
}, df = function(t, A) {
  var e = A.filter($i);
  if (e.length === 3) {
    var r = e.map(Bf), n = r[0], i = r[1], o = r[2];
    return kn(n, i, o, 1);
  }
  if (e.length === 4) {
    var s = e.map(Bf), n = s[0], i = s[1], o = s[2], c = s[3];
    return kn(n, i, o, c);
  }
  return 0;
};
function Mc(t, A, e) {
  return e < 0 && (e += 1), e >= 1 && (e -= 1), e < 1 / 6 ? (A - t) * e * 6 + t : e < 1 / 2 ? A : e < 2 / 3 ? (A - t) * 6 * (2 / 3 - e) + t : t;
}
var gf = function(t, A) {
  var e = A.filter($i), r = e[0], n = e[1], i = e[2], o = e[3], s = (r.type === 17 ? lr(r.number) : jo.parse(t, r)) / (Math.PI * 2), c = at(n) ? n.number / 100 : 0, u = at(i) ? i.number / 100 : 0, h = typeof o < "u" && at(o) ? De(o, 1) : 1;
  if (c === 0)
    return kn(u * 255, u * 255, u * 255, 1);
  var p = u <= 0.5 ? u * (c + 1) : u + c - u * c, w = u * 2 - p, d = Mc(w, p, s + 1 / 3), y = Mc(w, p, s), b = Mc(w, p, s - 1 / 3);
  return kn(d * 255, y * 255, b * 255, h);
}, Ng = {
  hsl: gf,
  hsla: gf,
  rgb: df,
  rgba: df
}, Va = function(t, A) {
  return Mn.parse(t, U0.create(A).parseComponentValue());
}, hn = {
  ALICEBLUE: 4042850303,
  ANTIQUEWHITE: 4209760255,
  AQUA: 16777215,
  AQUAMARINE: 2147472639,
  AZURE: 4043309055,
  BEIGE: 4126530815,
  BISQUE: 4293182719,
  BLACK: 255,
  BLANCHEDALMOND: 4293643775,
  BLUE: 65535,
  BLUEVIOLET: 2318131967,
  BROWN: 2771004159,
  BURLYWOOD: 3736635391,
  CADETBLUE: 1604231423,
  CHARTREUSE: 2147418367,
  CHOCOLATE: 3530104575,
  CORAL: 4286533887,
  CORNFLOWERBLUE: 1687547391,
  CORNSILK: 4294499583,
  CRIMSON: 3692313855,
  CYAN: 16777215,
  DARKBLUE: 35839,
  DARKCYAN: 9145343,
  DARKGOLDENROD: 3095837695,
  DARKGRAY: 2846468607,
  DARKGREEN: 6553855,
  DARKGREY: 2846468607,
  DARKKHAKI: 3182914559,
  DARKMAGENTA: 2332068863,
  DARKOLIVEGREEN: 1433087999,
  DARKORANGE: 4287365375,
  DARKORCHID: 2570243327,
  DARKRED: 2332033279,
  DARKSALMON: 3918953215,
  DARKSEAGREEN: 2411499519,
  DARKSLATEBLUE: 1211993087,
  DARKSLATEGRAY: 793726975,
  DARKSLATEGREY: 793726975,
  DARKTURQUOISE: 13554175,
  DARKVIOLET: 2483082239,
  DEEPPINK: 4279538687,
  DEEPSKYBLUE: 12582911,
  DIMGRAY: 1768516095,
  DIMGREY: 1768516095,
  DODGERBLUE: 512819199,
  FIREBRICK: 2988581631,
  FLORALWHITE: 4294635775,
  FORESTGREEN: 579543807,
  FUCHSIA: 4278255615,
  GAINSBORO: 3705462015,
  GHOSTWHITE: 4177068031,
  GOLD: 4292280575,
  GOLDENROD: 3668254975,
  GRAY: 2155905279,
  GREEN: 8388863,
  GREENYELLOW: 2919182335,
  GREY: 2155905279,
  HONEYDEW: 4043305215,
  HOTPINK: 4285117695,
  INDIANRED: 3445382399,
  INDIGO: 1258324735,
  IVORY: 4294963455,
  KHAKI: 4041641215,
  LAVENDER: 3873897215,
  LAVENDERBLUSH: 4293981695,
  LAWNGREEN: 2096890111,
  LEMONCHIFFON: 4294626815,
  LIGHTBLUE: 2916673279,
  LIGHTCORAL: 4034953471,
  LIGHTCYAN: 3774873599,
  LIGHTGOLDENRODYELLOW: 4210742015,
  LIGHTGRAY: 3553874943,
  LIGHTGREEN: 2431553791,
  LIGHTGREY: 3553874943,
  LIGHTPINK: 4290167295,
  LIGHTSALMON: 4288707327,
  LIGHTSEAGREEN: 548580095,
  LIGHTSKYBLUE: 2278488831,
  LIGHTSLATEGRAY: 2005441023,
  LIGHTSLATEGREY: 2005441023,
  LIGHTSTEELBLUE: 2965692159,
  LIGHTYELLOW: 4294959359,
  LIME: 16711935,
  LIMEGREEN: 852308735,
  LINEN: 4210091775,
  MAGENTA: 4278255615,
  MAROON: 2147483903,
  MEDIUMAQUAMARINE: 1724754687,
  MEDIUMBLUE: 52735,
  MEDIUMORCHID: 3126187007,
  MEDIUMPURPLE: 2473647103,
  MEDIUMSEAGREEN: 1018393087,
  MEDIUMSLATEBLUE: 2070474495,
  MEDIUMSPRINGGREEN: 16423679,
  MEDIUMTURQUOISE: 1221709055,
  MEDIUMVIOLETRED: 3340076543,
  MIDNIGHTBLUE: 421097727,
  MINTCREAM: 4127193855,
  MISTYROSE: 4293190143,
  MOCCASIN: 4293178879,
  NAVAJOWHITE: 4292783615,
  NAVY: 33023,
  OLDLACE: 4260751103,
  OLIVE: 2155872511,
  OLIVEDRAB: 1804477439,
  ORANGE: 4289003775,
  ORANGERED: 4282712319,
  ORCHID: 3664828159,
  PALEGOLDENROD: 4008225535,
  PALEGREEN: 2566625535,
  PALETURQUOISE: 2951671551,
  PALEVIOLETRED: 3681588223,
  PAPAYAWHIP: 4293907967,
  PEACHPUFF: 4292524543,
  PERU: 3448061951,
  PINK: 4290825215,
  PLUM: 3718307327,
  POWDERBLUE: 2967529215,
  PURPLE: 2147516671,
  REBECCAPURPLE: 1714657791,
  RED: 4278190335,
  ROSYBROWN: 3163525119,
  ROYALBLUE: 1097458175,
  SADDLEBROWN: 2336560127,
  SALMON: 4202722047,
  SANDYBROWN: 4104413439,
  SEAGREEN: 780883967,
  SEASHELL: 4294307583,
  SIENNA: 2689740287,
  SILVER: 3233857791,
  SKYBLUE: 2278484991,
  SLATEBLUE: 1784335871,
  SLATEGRAY: 1887473919,
  SLATEGREY: 1887473919,
  SNOW: 4294638335,
  SPRINGGREEN: 16744447,
  STEELBLUE: 1182971135,
  TAN: 3535047935,
  TEAL: 8421631,
  THISTLE: 3636451583,
  TOMATO: 4284696575,
  TRANSPARENT: 0,
  TURQUOISE: 1088475391,
  VIOLET: 4001558271,
  WHEAT: 4125012991,
  WHITE: 4294967295,
  WHITESMOKE: 4126537215,
  YELLOW: 4294902015,
  YELLOWGREEN: 2597139199
}, _g = {
  name: "background-clip",
  initialValue: "border-box",
  prefix: !1,
  type: 1,
  parse: function(t, A) {
    return A.map(function(e) {
      if (Le(e))
        switch (e.value) {
          case "padding-box":
            return 1;
          case "content-box":
            return 2;
        }
      return 0;
    });
  }
}, Dg = {
  name: "background-color",
  initialValue: "transparent",
  prefix: !1,
  type: 3,
  format: "color"
}, qo = function(t, A) {
  var e = Mn.parse(t, A[0]), r = A[1];
  return r && at(r) ? { color: e, stop: r } : { color: e, stop: null };
}, pf = function(t, A) {
  var e = t[0], r = t[t.length - 1];
  e.stop === null && (e.stop = Ut), r.stop === null && (r.stop = On);
  for (var n = [], i = 0, o = 0; o < t.length; o++) {
    var s = t[o].stop;
    if (s !== null) {
      var c = De(s, A);
      c > i ? n.push(c) : n.push(i), i = c;
    } else
      n.push(null);
  }
  for (var u = null, o = 0; o < n.length; o++) {
    var h = n[o];
    if (h === null)
      u === null && (u = o);
    else if (u !== null) {
      for (var p = o - u, w = n[u - 1], d = (h - w) / (p + 1), y = 1; y <= p; y++)
        n[u + y - 1] = d * y;
      u = null;
    }
  }
  return t.map(function(b, S) {
    var Q = b.color;
    return { color: Q, stop: Math.max(Math.min(1, n[S] / A), 0) };
  });
}, Tg = function(t, A, e) {
  var r = A / 2, n = e / 2, i = De(t[0], A) - r, o = n - De(t[1], e);
  return (Math.atan2(o, i) + Math.PI * 2) % (Math.PI * 2);
}, Og = function(t, A, e) {
  var r = typeof t == "number" ? t : Tg(t, A, e), n = Math.abs(A * Math.sin(r)) + Math.abs(e * Math.cos(r)), i = A / 2, o = e / 2, s = n / 2, c = Math.sin(r - Math.PI / 2) * s, u = Math.cos(r - Math.PI / 2) * s;
  return [n, i - u, i + u, o - c, o + c];
}, Qr = function(t, A) {
  return Math.sqrt(t * t + A * A);
}, wf = function(t, A, e, r, n) {
  var i = [
    [0, 0],
    [0, A],
    [t, 0],
    [t, A]
  ];
  return i.reduce(function(o, s) {
    var c = s[0], u = s[1], h = Qr(e - c, r - u);
    return (n ? h < o.optimumDistance : h > o.optimumDistance) ? {
      optimumCorner: s,
      optimumDistance: h
    } : o;
  }, {
    optimumDistance: n ? 1 / 0 : -1 / 0,
    optimumCorner: null
  }).optimumCorner;
}, kg = function(t, A, e, r, n) {
  var i = 0, o = 0;
  switch (t.size) {
    case 0:
      t.shape === 0 ? i = o = Math.min(Math.abs(A), Math.abs(A - r), Math.abs(e), Math.abs(e - n)) : t.shape === 1 && (i = Math.min(Math.abs(A), Math.abs(A - r)), o = Math.min(Math.abs(e), Math.abs(e - n)));
      break;
    case 2:
      if (t.shape === 0)
        i = o = Math.min(Qr(A, e), Qr(A, e - n), Qr(A - r, e), Qr(A - r, e - n));
      else if (t.shape === 1) {
        var s = Math.min(Math.abs(e), Math.abs(e - n)) / Math.min(Math.abs(A), Math.abs(A - r)), c = wf(r, n, A, e, !0), u = c[0], h = c[1];
        i = Qr(u - A, (h - e) / s), o = s * i;
      }
      break;
    case 1:
      t.shape === 0 ? i = o = Math.max(Math.abs(A), Math.abs(A - r), Math.abs(e), Math.abs(e - n)) : t.shape === 1 && (i = Math.max(Math.abs(A), Math.abs(A - r)), o = Math.max(Math.abs(e), Math.abs(e - n)));
      break;
    case 3:
      if (t.shape === 0)
        i = o = Math.max(Qr(A, e), Qr(A, e - n), Qr(A - r, e), Qr(A - r, e - n));
      else if (t.shape === 1) {
        var s = Math.max(Math.abs(e), Math.abs(e - n)) / Math.max(Math.abs(A), Math.abs(A - r)), p = wf(r, n, A, e, !1), u = p[0], h = p[1];
        i = Qr(u - A, (h - e) / s), o = s * i;
      }
      break;
  }
  return Array.isArray(t.size) && (i = De(t.size[0], r), o = t.size.length === 2 ? De(t.size[1], n) : i), [i, o];
}, Pg = function(t, A) {
  var e = lr(180), r = [];
  return Mr(A).forEach(function(n, i) {
    if (i === 0) {
      var o = n[0];
      if (o.type === 20 && o.value === "to") {
        e = H0(n);
        return;
      } else if (S0(o)) {
        e = jo.parse(t, o);
        return;
      }
    }
    var s = qo(t, n);
    r.push(s);
  }), {
    angle: e,
    stops: r,
    type: 1
    /* LINEAR_GRADIENT */
  };
}, eo = function(t, A) {
  var e = lr(180), r = [];
  return Mr(A).forEach(function(n, i) {
    if (i === 0) {
      var o = n[0];
      if (o.type === 20 && ["top", "left", "right", "bottom"].indexOf(o.value) !== -1) {
        e = H0(n);
        return;
      } else if (S0(o)) {
        e = (jo.parse(t, o) + lr(270)) % lr(360);
        return;
      }
    }
    var s = qo(t, n);
    r.push(s);
  }), {
    angle: e,
    stops: r,
    type: 1
    /* LINEAR_GRADIENT */
  };
}, Mg = function(t, A) {
  var e = lr(180), r = [], n = 1, i = 0, o = 3, s = [];
  return Mr(A).forEach(function(c, u) {
    var h = c[0];
    if (u === 0) {
      if (Le(h) && h.value === "linear") {
        n = 1;
        return;
      } else if (Le(h) && h.value === "radial") {
        n = 2;
        return;
      }
    }
    if (h.type === 18) {
      if (h.name === "from") {
        var p = Mn.parse(t, h.values[0]);
        r.push({ stop: Ut, color: p });
      } else if (h.name === "to") {
        var p = Mn.parse(t, h.values[0]);
        r.push({ stop: On, color: p });
      } else if (h.name === "color-stop") {
        var w = h.values.filter($i);
        if (w.length === 2) {
          var p = Mn.parse(t, w[1]), d = w[0];
          Aa(d) && r.push({
            stop: { type: 16, number: d.number * 100, flags: d.flags },
            color: p
          });
        }
      }
    }
  }), n === 1 ? {
    angle: (e + lr(180)) % lr(360),
    stops: r,
    type: n
  } : { size: o, shape: i, stops: r, position: s, type: n };
}, N0 = "closest-side", _0 = "farthest-side", D0 = "closest-corner", T0 = "farthest-corner", O0 = "circle", k0 = "ellipse", P0 = "cover", M0 = "contain", Kg = function(t, A) {
  var e = 0, r = 3, n = [], i = [];
  return Mr(A).forEach(function(o, s) {
    var c = !0;
    if (s === 0) {
      var u = !1;
      c = o.reduce(function(p, w) {
        if (u)
          if (Le(w))
            switch (w.value) {
              case "center":
                return i.push(tu), p;
              case "top":
              case "left":
                return i.push(Ut), p;
              case "right":
              case "bottom":
                return i.push(On), p;
            }
          else (at(w) || Rn(w)) && i.push(w);
        else if (Le(w))
          switch (w.value) {
            case O0:
              return e = 0, !1;
            case k0:
              return e = 1, !1;
            case "at":
              return u = !0, !1;
            case N0:
              return r = 0, !1;
            case P0:
            case _0:
              return r = 1, !1;
            case M0:
            case D0:
              return r = 2, !1;
            case T0:
              return r = 3, !1;
          }
        else if (Rn(w) || at(w))
          return Array.isArray(r) || (r = []), r.push(w), !1;
        return p;
      }, c);
    }
    if (c) {
      var h = qo(t, o);
      n.push(h);
    }
  }), {
    size: r,
    shape: e,
    stops: n,
    position: i,
    type: 2
    /* RADIAL_GRADIENT */
  };
}, to = function(t, A) {
  var e = 0, r = 3, n = [], i = [];
  return Mr(A).forEach(function(o, s) {
    var c = !0;
    if (s === 0 ? c = o.reduce(function(h, p) {
      if (Le(p))
        switch (p.value) {
          case "center":
            return i.push(tu), !1;
          case "top":
          case "left":
            return i.push(Ut), !1;
          case "right":
          case "bottom":
            return i.push(On), !1;
        }
      else if (at(p) || Rn(p))
        return i.push(p), !1;
      return h;
    }, c) : s === 1 && (c = o.reduce(function(h, p) {
      if (Le(p))
        switch (p.value) {
          case O0:
            return e = 0, !1;
          case k0:
            return e = 1, !1;
          case M0:
          case N0:
            return r = 0, !1;
          case _0:
            return r = 1, !1;
          case D0:
            return r = 2, !1;
          case P0:
          case T0:
            return r = 3, !1;
        }
      else if (Rn(p) || at(p))
        return Array.isArray(r) || (r = []), r.push(p), !1;
      return h;
    }, c)), c) {
      var u = qo(t, o);
      n.push(u);
    }
  }), {
    size: r,
    shape: e,
    stops: n,
    position: i,
    type: 2
    /* RADIAL_GRADIENT */
  };
}, Rg = function(t) {
  return t.type === 1;
}, Gg = function(t) {
  return t.type === 2;
}, ru = {
  name: "image",
  parse: function(t, A) {
    if (A.type === 22) {
      var e = {
        url: A.value,
        type: 0
        /* URL */
      };
      return t.cache.addImage(A.value), e;
    }
    if (A.type === 18) {
      var r = K0[A.name];
      if (typeof r > "u")
        throw new Error('Attempting to parse an unsupported image function "' + A.name + '"');
      return r(t, A.values);
    }
    throw new Error("Unsupported image type " + A.type);
  }
};
function Vg(t) {
  return !(t.type === 20 && t.value === "none") && (t.type !== 18 || !!K0[t.name]);
}
var K0 = {
  "linear-gradient": Pg,
  "-moz-linear-gradient": eo,
  "-ms-linear-gradient": eo,
  "-o-linear-gradient": eo,
  "-webkit-linear-gradient": eo,
  "radial-gradient": Kg,
  "-moz-radial-gradient": to,
  "-ms-radial-gradient": to,
  "-o-radial-gradient": to,
  "-webkit-radial-gradient": to,
  "-webkit-gradient": Mg
}, jg = {
  name: "background-image",
  initialValue: "none",
  type: 1,
  prefix: !1,
  parse: function(t, A) {
    if (A.length === 0)
      return [];
    var e = A[0];
    return e.type === 20 && e.value === "none" ? [] : A.filter(function(r) {
      return $i(r) && Vg(r);
    }).map(function(r) {
      return ru.parse(t, r);
    });
  }
}, qg = {
  name: "background-origin",
  initialValue: "border-box",
  prefix: !1,
  type: 1,
  parse: function(t, A) {
    return A.map(function(e) {
      if (Le(e))
        switch (e.value) {
          case "padding-box":
            return 1;
          case "content-box":
            return 2;
        }
      return 0;
    });
  }
}, Wg = {
  name: "background-position",
  initialValue: "0% 0%",
  type: 1,
  prefix: !1,
  parse: function(t, A) {
    return Mr(A).map(function(e) {
      return e.filter(at);
    }).map(y0);
  }
}, Xg = {
  name: "background-repeat",
  initialValue: "repeat",
  prefix: !1,
  type: 1,
  parse: function(t, A) {
    return Mr(A).map(function(e) {
      return e.filter(Le).map(function(r) {
        return r.value;
      }).join(" ");
    }).map(Jg);
  }
}, Jg = function(t) {
  switch (t) {
    case "no-repeat":
      return 1;
    case "repeat-x":
    case "repeat no-repeat":
      return 2;
    case "repeat-y":
    case "no-repeat repeat":
      return 3;
    case "repeat":
    default:
      return 0;
  }
}, Xi;
(function(t) {
  t.AUTO = "auto", t.CONTAIN = "contain", t.COVER = "cover";
})(Xi || (Xi = {}));
var Yg = {
  name: "background-size",
  initialValue: "0",
  prefix: !1,
  type: 1,
  parse: function(t, A) {
    return Mr(A).map(function(e) {
      return e.filter(zg);
    });
  }
}, zg = function(t) {
  return Le(t) || at(t);
}, Wo = function(t) {
  return {
    name: "border-" + t + "-color",
    initialValue: "transparent",
    prefix: !1,
    type: 3,
    format: "color"
  };
}, Zg = Wo("top"), $g = Wo("right"), A2 = Wo("bottom"), e2 = Wo("left"), Xo = function(t) {
  return {
    name: "border-radius-" + t,
    initialValue: "0 0",
    prefix: !1,
    type: 1,
    parse: function(A, e) {
      return y0(e.filter(at));
    }
  };
}, t2 = Xo("top-left"), r2 = Xo("top-right"), n2 = Xo("bottom-right"), i2 = Xo("bottom-left"), Jo = function(t) {
  return {
    name: "border-" + t + "-style",
    initialValue: "solid",
    prefix: !1,
    type: 2,
    parse: function(A, e) {
      switch (e) {
        case "none":
          return 0;
        case "dashed":
          return 2;
        case "dotted":
          return 3;
        case "double":
          return 4;
      }
      return 1;
    }
  };
}, a2 = Jo("top"), s2 = Jo("right"), o2 = Jo("bottom"), c2 = Jo("left"), Yo = function(t) {
  return {
    name: "border-" + t + "-width",
    initialValue: "0",
    type: 0,
    prefix: !1,
    parse: function(A, e) {
      return ts(e) ? e.number : 0;
    }
  };
}, l2 = Yo("top"), u2 = Yo("right"), f2 = Yo("bottom"), h2 = Yo("left"), B2 = {
  name: "color",
  initialValue: "transparent",
  prefix: !1,
  type: 3,
  format: "color"
}, d2 = {
  name: "direction",
  initialValue: "ltr",
  prefix: !1,
  type: 2,
  parse: function(t, A) {
    switch (A) {
      case "rtl":
        return 1;
      case "ltr":
      default:
        return 0;
    }
  }
}, g2 = {
  name: "display",
  initialValue: "inline-block",
  prefix: !1,
  type: 1,
  parse: function(t, A) {
    return A.filter(Le).reduce(
      function(e, r) {
        return e | p2(r.value);
      },
      0
      /* NONE */
    );
  }
}, p2 = function(t) {
  switch (t) {
    case "block":
    case "-webkit-box":
      return 2;
    case "inline":
      return 4;
    case "run-in":
      return 8;
    case "flow":
      return 16;
    case "flow-root":
      return 32;
    case "table":
      return 64;
    case "flex":
    case "-webkit-flex":
      return 128;
    case "grid":
    case "-ms-grid":
      return 256;
    case "ruby":
      return 512;
    case "subgrid":
      return 1024;
    case "list-item":
      return 2048;
    case "table-row-group":
      return 4096;
    case "table-header-group":
      return 8192;
    case "table-footer-group":
      return 16384;
    case "table-row":
      return 32768;
    case "table-cell":
      return 65536;
    case "table-column-group":
      return 131072;
    case "table-column":
      return 262144;
    case "table-caption":
      return 524288;
    case "ruby-base":
      return 1048576;
    case "ruby-text":
      return 2097152;
    case "ruby-base-container":
      return 4194304;
    case "ruby-text-container":
      return 8388608;
    case "contents":
      return 16777216;
    case "inline-block":
      return 33554432;
    case "inline-list-item":
      return 67108864;
    case "inline-table":
      return 134217728;
    case "inline-flex":
      return 268435456;
    case "inline-grid":
      return 536870912;
  }
  return 0;
}, w2 = {
  name: "float",
  initialValue: "none",
  prefix: !1,
  type: 2,
  parse: function(t, A) {
    switch (A) {
      case "left":
        return 1;
      case "right":
        return 2;
      case "inline-start":
        return 3;
      case "inline-end":
        return 4;
    }
    return 0;
  }
}, v2 = {
  name: "letter-spacing",
  initialValue: "0",
  prefix: !1,
  type: 0,
  parse: function(t, A) {
    return A.type === 20 && A.value === "normal" ? 0 : A.type === 17 || A.type === 15 ? A.number : 0;
  }
}, So;
(function(t) {
  t.NORMAL = "normal", t.STRICT = "strict";
})(So || (So = {}));
var C2 = {
  name: "line-break",
  initialValue: "normal",
  prefix: !1,
  type: 2,
  parse: function(t, A) {
    switch (A) {
      case "strict":
        return So.STRICT;
      case "normal":
      default:
        return So.NORMAL;
    }
  }
}, m2 = {
  name: "line-height",
  initialValue: "normal",
  prefix: !1,
  type: 4
  /* TOKEN_VALUE */
}, vf = function(t, A) {
  return Le(t) && t.value === "normal" ? 1.2 * A : t.type === 17 ? A * t.number : at(t) ? De(t, A) : A;
}, Q2 = {
  name: "list-style-image",
  initialValue: "none",
  type: 0,
  prefix: !1,
  parse: function(t, A) {
    return A.type === 20 && A.value === "none" ? null : ru.parse(t, A);
  }
}, F2 = {
  name: "list-style-position",
  initialValue: "outside",
  prefix: !1,
  type: 2,
  parse: function(t, A) {
    switch (A) {
      case "inside":
        return 0;
      case "outside":
      default:
        return 1;
    }
  }
}, Dl = {
  name: "list-style-type",
  initialValue: "none",
  prefix: !1,
  type: 2,
  parse: function(t, A) {
    switch (A) {
      case "disc":
        return 0;
      case "circle":
        return 1;
      case "square":
        return 2;
      case "decimal":
        return 3;
      case "cjk-decimal":
        return 4;
      case "decimal-leading-zero":
        return 5;
      case "lower-roman":
        return 6;
      case "upper-roman":
        return 7;
      case "lower-greek":
        return 8;
      case "lower-alpha":
        return 9;
      case "upper-alpha":
        return 10;
      case "arabic-indic":
        return 11;
      case "armenian":
        return 12;
      case "bengali":
        return 13;
      case "cambodian":
        return 14;
      case "cjk-earthly-branch":
        return 15;
      case "cjk-heavenly-stem":
        return 16;
      case "cjk-ideographic":
        return 17;
      case "devanagari":
        return 18;
      case "ethiopic-numeric":
        return 19;
      case "georgian":
        return 20;
      case "gujarati":
        return 21;
      case "gurmukhi":
        return 22;
      case "hebrew":
        return 22;
      case "hiragana":
        return 23;
      case "hiragana-iroha":
        return 24;
      case "japanese-formal":
        return 25;
      case "japanese-informal":
        return 26;
      case "kannada":
        return 27;
      case "katakana":
        return 28;
      case "katakana-iroha":
        return 29;
      case "khmer":
        return 30;
      case "korean-hangul-formal":
        return 31;
      case "korean-hanja-formal":
        return 32;
      case "korean-hanja-informal":
        return 33;
      case "lao":
        return 34;
      case "lower-armenian":
        return 35;
      case "malayalam":
        return 36;
      case "mongolian":
        return 37;
      case "myanmar":
        return 38;
      case "oriya":
        return 39;
      case "persian":
        return 40;
      case "simp-chinese-formal":
        return 41;
      case "simp-chinese-informal":
        return 42;
      case "tamil":
        return 43;
      case "telugu":
        return 44;
      case "thai":
        return 45;
      case "tibetan":
        return 46;
      case "trad-chinese-formal":
        return 47;
      case "trad-chinese-informal":
        return 48;
      case "upper-armenian":
        return 49;
      case "disclosure-open":
        return 50;
      case "disclosure-closed":
        return 51;
      case "none":
      default:
        return -1;
    }
  }
}, zo = function(t) {
  return {
    name: "margin-" + t,
    initialValue: "0",
    prefix: !1,
    type: 4
    /* TOKEN_VALUE */
  };
}, U2 = zo("top"), b2 = zo("right"), y2 = zo("bottom"), E2 = zo("left"), L2 = {
  name: "overflow",
  initialValue: "visible",
  prefix: !1,
  type: 1,
  parse: function(t, A) {
    return A.filter(Le).map(function(e) {
      switch (e.value) {
        case "hidden":
          return 1;
        case "scroll":
          return 2;
        case "clip":
          return 3;
        case "auto":
          return 4;
        case "visible":
        default:
          return 0;
      }
    });
  }
}, x2 = {
  name: "overflow-wrap",
  initialValue: "normal",
  prefix: !1,
  type: 2,
  parse: function(t, A) {
    switch (A) {
      case "break-word":
        return "break-word";
      case "normal":
      default:
        return "normal";
    }
  }
}, Zo = function(t) {
  return {
    name: "padding-" + t,
    initialValue: "0",
    prefix: !1,
    type: 3,
    format: "length-percentage"
  };
}, I2 = Zo("top"), S2 = Zo("right"), H2 = Zo("bottom"), N2 = Zo("left"), _2 = {
  name: "text-align",
  initialValue: "left",
  prefix: !1,
  type: 2,
  parse: function(t, A) {
    switch (A) {
      case "right":
        return 2;
      case "center":
      case "justify":
        return 1;
      case "left":
      default:
        return 0;
    }
  }
}, D2 = {
  name: "position",
  initialValue: "static",
  prefix: !1,
  type: 2,
  parse: function(t, A) {
    switch (A) {
      case "relative":
        return 1;
      case "absolute":
        return 2;
      case "fixed":
        return 3;
      case "sticky":
        return 4;
    }
    return 0;
  }
}, T2 = {
  name: "text-shadow",
  initialValue: "none",
  type: 1,
  prefix: !1,
  parse: function(t, A) {
    return A.length === 1 && _l(A[0], "none") ? [] : Mr(A).map(function(e) {
      for (var r = {
        color: hn.TRANSPARENT,
        offsetX: Ut,
        offsetY: Ut,
        blur: Ut
      }, n = 0, i = 0; i < e.length; i++) {
        var o = e[i];
        Rn(o) ? (n === 0 ? r.offsetX = o : n === 1 ? r.offsetY = o : r.blur = o, n++) : r.color = Mn.parse(t, o);
      }
      return r;
    });
  }
}, O2 = {
  name: "text-transform",
  initialValue: "none",
  prefix: !1,
  type: 2,
  parse: function(t, A) {
    switch (A) {
      case "uppercase":
        return 2;
      case "lowercase":
        return 1;
      case "capitalize":
        return 3;
    }
    return 0;
  }
}, k2 = {
  name: "transform",
  initialValue: "none",
  prefix: !0,
  type: 0,
  parse: function(t, A) {
    if (A.type === 20 && A.value === "none")
      return null;
    if (A.type === 18) {
      var e = K2[A.name];
      if (typeof e > "u")
        throw new Error('Attempting to parse an unsupported transform function "' + A.name + '"');
      return e(A.values);
    }
    return null;
  }
}, P2 = function(t) {
  var A = t.filter(function(e) {
    return e.type === 17;
  }).map(function(e) {
    return e.number;
  });
  return A.length === 6 ? A : null;
}, M2 = function(t) {
  var A = t.filter(function(c) {
    return c.type === 17;
  }).map(function(c) {
    return c.number;
  }), e = A[0], r = A[1];
  A[2], A[3];
  var n = A[4], i = A[5];
  A[6], A[7], A[8], A[9], A[10], A[11];
  var o = A[12], s = A[13];
  return A[14], A[15], A.length === 16 ? [e, r, n, i, o, s] : null;
}, K2 = {
  matrix: P2,
  matrix3d: M2
}, Cf = {
  type: 16,
  number: 50,
  flags: es
}, R2 = [Cf, Cf], G2 = {
  name: "transform-origin",
  initialValue: "50% 50%",
  prefix: !0,
  type: 1,
  parse: function(t, A) {
    var e = A.filter(at);
    return e.length !== 2 ? R2 : [e[0], e[1]];
  }
}, V2 = {
  name: "visible",
  initialValue: "none",
  prefix: !1,
  type: 2,
  parse: function(t, A) {
    switch (A) {
      case "hidden":
        return 1;
      case "collapse":
        return 2;
      case "visible":
      default:
        return 0;
    }
  }
}, ja;
(function(t) {
  t.NORMAL = "normal", t.BREAK_ALL = "break-all", t.KEEP_ALL = "keep-all";
})(ja || (ja = {}));
var j2 = {
  name: "word-break",
  initialValue: "normal",
  prefix: !1,
  type: 2,
  parse: function(t, A) {
    switch (A) {
      case "break-all":
        return ja.BREAK_ALL;
      case "keep-all":
        return ja.KEEP_ALL;
      case "normal":
      default:
        return ja.NORMAL;
    }
  }
}, q2 = {
  name: "z-index",
  initialValue: "auto",
  prefix: !1,
  type: 0,
  parse: function(t, A) {
    if (A.type === 20)
      return { auto: !0, order: 0 };
    if (Aa(A))
      return { auto: !1, order: A.number };
    throw new Error("Invalid z-index number parsed");
  }
}, R0 = {
  name: "time",
  parse: function(t, A) {
    if (A.type === 15)
      switch (A.unit.toLowerCase()) {
        case "s":
          return 1e3 * A.number;
        case "ms":
          return A.number;
      }
    throw new Error("Unsupported time type");
  }
}, W2 = {
  name: "opacity",
  initialValue: "1",
  type: 0,
  prefix: !1,
  parse: function(t, A) {
    return Aa(A) ? A.number : 1;
  }
}, X2 = {
  name: "text-decoration-color",
  initialValue: "transparent",
  prefix: !1,
  type: 3,
  format: "color"
}, J2 = {
  name: "text-decoration-line",
  initialValue: "none",
  prefix: !1,
  type: 1,
  parse: function(t, A) {
    return A.filter(Le).map(function(e) {
      switch (e.value) {
        case "underline":
          return 1;
        case "overline":
          return 2;
        case "line-through":
          return 3;
        case "none":
          return 4;
      }
      return 0;
    }).filter(function(e) {
      return e !== 0;
    });
  }
}, Y2 = {
  name: "font-family",
  initialValue: "",
  prefix: !1,
  type: 1,
  parse: function(t, A) {
    var e = [], r = [];
    return A.forEach(function(n) {
      switch (n.type) {
        case 20:
        case 0:
          e.push(n.value);
          break;
        case 17:
          e.push(n.number.toString());
          break;
        case 4:
          r.push(e.join(" ")), e.length = 0;
          break;
      }
    }), e.length && r.push(e.join(" ")), r.map(function(n) {
      return n.indexOf(" ") === -1 ? n : "'" + n + "'";
    });
  }
}, z2 = {
  name: "font-size",
  initialValue: "0",
  prefix: !1,
  type: 3,
  format: "length"
}, Z2 = {
  name: "font-weight",
  initialValue: "normal",
  type: 0,
  prefix: !1,
  parse: function(t, A) {
    if (Aa(A))
      return A.number;
    if (Le(A))
      switch (A.value) {
        case "bold":
          return 700;
        case "normal":
        default:
          return 400;
      }
    return 400;
  }
}, $2 = {
  name: "font-variant",
  initialValue: "none",
  type: 1,
  prefix: !1,
  parse: function(t, A) {
    return A.filter(Le).map(function(e) {
      return e.value;
    });
  }
}, Ap = {
  name: "font-style",
  initialValue: "normal",
  prefix: !1,
  type: 2,
  parse: function(t, A) {
    switch (A) {
      case "oblique":
        return "oblique";
      case "italic":
        return "italic";
      case "normal":
      default:
        return "normal";
    }
  }
}, ht = function(t, A) {
  return (t & A) !== 0;
}, ep = {
  name: "content",
  initialValue: "none",
  type: 1,
  prefix: !1,
  parse: function(t, A) {
    if (A.length === 0)
      return [];
    var e = A[0];
    return e.type === 20 && e.value === "none" ? [] : A;
  }
}, tp = {
  name: "counter-increment",
  initialValue: "none",
  prefix: !0,
  type: 1,
  parse: function(t, A) {
    if (A.length === 0)
      return null;
    var e = A[0];
    if (e.type === 20 && e.value === "none")
      return null;
    for (var r = [], n = A.filter(b0), i = 0; i < n.length; i++) {
      var o = n[i], s = n[i + 1];
      if (o.type === 20) {
        var c = s && Aa(s) ? s.number : 1;
        r.push({ counter: o.value, increment: c });
      }
    }
    return r;
  }
}, rp = {
  name: "counter-reset",
  initialValue: "none",
  prefix: !0,
  type: 1,
  parse: function(t, A) {
    if (A.length === 0)
      return [];
    for (var e = [], r = A.filter(b0), n = 0; n < r.length; n++) {
      var i = r[n], o = r[n + 1];
      if (Le(i) && i.value !== "none") {
        var s = o && Aa(o) ? o.number : 0;
        e.push({ counter: i.value, reset: s });
      }
    }
    return e;
  }
}, np = {
  name: "duration",
  initialValue: "0s",
  prefix: !1,
  type: 1,
  parse: function(t, A) {
    return A.filter(ts).map(function(e) {
      return R0.parse(t, e);
    });
  }
}, ip = {
  name: "quotes",
  initialValue: "none",
  prefix: !0,
  type: 1,
  parse: function(t, A) {
    if (A.length === 0)
      return null;
    var e = A[0];
    if (e.type === 20 && e.value === "none")
      return null;
    var r = [], n = A.filter(Sg);
    if (n.length % 2 !== 0)
      return null;
    for (var i = 0; i < n.length; i += 2) {
      var o = n[i].value, s = n[i + 1].value;
      r.push({ open: o, close: s });
    }
    return r;
  }
}, mf = function(t, A, e) {
  if (!t)
    return "";
  var r = t[Math.min(A, t.length - 1)];
  return r ? e ? r.open : r.close : "";
}, ap = {
  name: "box-shadow",
  initialValue: "none",
  type: 1,
  prefix: !1,
  parse: function(t, A) {
    return A.length === 1 && _l(A[0], "none") ? [] : Mr(A).map(function(e) {
      for (var r = {
        color: 255,
        offsetX: Ut,
        offsetY: Ut,
        blur: Ut,
        spread: Ut,
        inset: !1
      }, n = 0, i = 0; i < e.length; i++) {
        var o = e[i];
        _l(o, "inset") ? r.inset = !0 : Rn(o) ? (n === 0 ? r.offsetX = o : n === 1 ? r.offsetY = o : n === 2 ? r.blur = o : r.spread = o, n++) : r.color = Mn.parse(t, o);
      }
      return r;
    });
  }
}, sp = {
  name: "paint-order",
  initialValue: "normal",
  prefix: !1,
  type: 1,
  parse: function(t, A) {
    var e = [
      0,
      1,
      2
      /* MARKERS */
    ], r = [];
    return A.filter(Le).forEach(function(n) {
      switch (n.value) {
        case "stroke":
          r.push(
            1
            /* STROKE */
          );
          break;
        case "fill":
          r.push(
            0
            /* FILL */
          );
          break;
        case "markers":
          r.push(
            2
            /* MARKERS */
          );
          break;
      }
    }), e.forEach(function(n) {
      r.indexOf(n) === -1 && r.push(n);
    }), r;
  }
}, op = {
  name: "-webkit-text-stroke-color",
  initialValue: "currentcolor",
  prefix: !1,
  type: 3,
  format: "color"
}, cp = {
  name: "-webkit-text-stroke-width",
  initialValue: "0",
  type: 0,
  prefix: !1,
  parse: function(t, A) {
    return ts(A) ? A.number : 0;
  }
}, lp = (
  /** @class */
  (function() {
    function t(A, e) {
      var r, n;
      this.animationDuration = xA(A, np, e.animationDuration), this.backgroundClip = xA(A, _g, e.backgroundClip), this.backgroundColor = xA(A, Dg, e.backgroundColor), this.backgroundImage = xA(A, jg, e.backgroundImage), this.backgroundOrigin = xA(A, qg, e.backgroundOrigin), this.backgroundPosition = xA(A, Wg, e.backgroundPosition), this.backgroundRepeat = xA(A, Xg, e.backgroundRepeat), this.backgroundSize = xA(A, Yg, e.backgroundSize), this.borderTopColor = xA(A, Zg, e.borderTopColor), this.borderRightColor = xA(A, $g, e.borderRightColor), this.borderBottomColor = xA(A, A2, e.borderBottomColor), this.borderLeftColor = xA(A, e2, e.borderLeftColor), this.borderTopLeftRadius = xA(A, t2, e.borderTopLeftRadius), this.borderTopRightRadius = xA(A, r2, e.borderTopRightRadius), this.borderBottomRightRadius = xA(A, n2, e.borderBottomRightRadius), this.borderBottomLeftRadius = xA(A, i2, e.borderBottomLeftRadius), this.borderTopStyle = xA(A, a2, e.borderTopStyle), this.borderRightStyle = xA(A, s2, e.borderRightStyle), this.borderBottomStyle = xA(A, o2, e.borderBottomStyle), this.borderLeftStyle = xA(A, c2, e.borderLeftStyle), this.borderTopWidth = xA(A, l2, e.borderTopWidth), this.borderRightWidth = xA(A, u2, e.borderRightWidth), this.borderBottomWidth = xA(A, f2, e.borderBottomWidth), this.borderLeftWidth = xA(A, h2, e.borderLeftWidth), this.boxShadow = xA(A, ap, e.boxShadow), this.color = xA(A, B2, e.color), this.direction = xA(A, d2, e.direction), this.display = xA(A, g2, e.display), this.float = xA(A, w2, e.cssFloat), this.fontFamily = xA(A, Y2, e.fontFamily), this.fontSize = xA(A, z2, e.fontSize), this.fontStyle = xA(A, Ap, e.fontStyle), this.fontVariant = xA(A, $2, e.fontVariant), this.fontWeight = xA(A, Z2, e.fontWeight), this.letterSpacing = xA(A, v2, e.letterSpacing), this.lineBreak = xA(A, C2, e.lineBreak), this.lineHeight = xA(A, m2, e.lineHeight), this.listStyleImage = xA(A, Q2, e.listStyleImage), this.listStylePosition = xA(A, F2, e.listStylePosition), this.listStyleType = xA(A, Dl, e.listStyleType), this.marginTop = xA(A, U2, e.marginTop), this.marginRight = xA(A, b2, e.marginRight), this.marginBottom = xA(A, y2, e.marginBottom), this.marginLeft = xA(A, E2, e.marginLeft), this.opacity = xA(A, W2, e.opacity);
      var i = xA(A, L2, e.overflow);
      this.overflowX = i[0], this.overflowY = i[i.length > 1 ? 1 : 0], this.overflowWrap = xA(A, x2, e.overflowWrap), this.paddingTop = xA(A, I2, e.paddingTop), this.paddingRight = xA(A, S2, e.paddingRight), this.paddingBottom = xA(A, H2, e.paddingBottom), this.paddingLeft = xA(A, N2, e.paddingLeft), this.paintOrder = xA(A, sp, e.paintOrder), this.position = xA(A, D2, e.position), this.textAlign = xA(A, _2, e.textAlign), this.textDecorationColor = xA(A, X2, (r = e.textDecorationColor) !== null && r !== void 0 ? r : e.color), this.textDecorationLine = xA(A, J2, (n = e.textDecorationLine) !== null && n !== void 0 ? n : e.textDecoration), this.textShadow = xA(A, T2, e.textShadow), this.textTransform = xA(A, O2, e.textTransform), this.transform = xA(A, k2, e.transform), this.transformOrigin = xA(A, G2, e.transformOrigin), this.visibility = xA(A, V2, e.visibility), this.webkitTextStrokeColor = xA(A, op, e.webkitTextStrokeColor), this.webkitTextStrokeWidth = xA(A, cp, e.webkitTextStrokeWidth), this.wordBreak = xA(A, j2, e.wordBreak), this.zIndex = xA(A, q2, e.zIndex);
    }
    return t.prototype.isVisible = function() {
      return this.display > 0 && this.opacity > 0 && this.visibility === 0;
    }, t.prototype.isTransparent = function() {
      return Kn(this.backgroundColor);
    }, t.prototype.isTransformed = function() {
      return this.transform !== null;
    }, t.prototype.isPositioned = function() {
      return this.position !== 0;
    }, t.prototype.isPositionedWithZIndex = function() {
      return this.isPositioned() && !this.zIndex.auto;
    }, t.prototype.isFloating = function() {
      return this.float !== 0;
    }, t.prototype.isInlineLevel = function() {
      return ht(
        this.display,
        4
        /* INLINE */
      ) || ht(
        this.display,
        33554432
        /* INLINE_BLOCK */
      ) || ht(
        this.display,
        268435456
        /* INLINE_FLEX */
      ) || ht(
        this.display,
        536870912
        /* INLINE_GRID */
      ) || ht(
        this.display,
        67108864
        /* INLINE_LIST_ITEM */
      ) || ht(
        this.display,
        134217728
        /* INLINE_TABLE */
      );
    }, t;
  })()
), up = (
  /** @class */
  /* @__PURE__ */ (function() {
    function t(A, e) {
      this.content = xA(A, ep, e.content), this.quotes = xA(A, ip, e.quotes);
    }
    return t;
  })()
), Qf = (
  /** @class */
  /* @__PURE__ */ (function() {
    function t(A, e) {
      this.counterIncrement = xA(A, tp, e.counterIncrement), this.counterReset = xA(A, rp, e.counterReset);
    }
    return t;
  })()
), xA = function(t, A, e) {
  var r = new F0(), n = e !== null && typeof e < "u" ? e.toString() : A.initialValue;
  r.write(n);
  var i = new U0(r.read());
  switch (A.type) {
    case 2:
      var o = i.parseComponentValue();
      return A.parse(t, Le(o) ? o.value : A.initialValue);
    case 0:
      return A.parse(t, i.parseComponentValue());
    case 1:
      return A.parse(t, i.parseComponentValues());
    case 4:
      return i.parseComponentValue();
    case 3:
      switch (A.format) {
        case "angle":
          return jo.parse(t, i.parseComponentValue());
        case "color":
          return Mn.parse(t, i.parseComponentValue());
        case "image":
          return ru.parse(t, i.parseComponentValue());
        case "length":
          var s = i.parseComponentValue();
          return Rn(s) ? s : Ut;
        case "length-percentage":
          var c = i.parseComponentValue();
          return at(c) ? c : Ut;
        case "time":
          return R0.parse(t, i.parseComponentValue());
      }
      break;
  }
}, fp = "data-html2canvas-debug", hp = function(t) {
  var A = t.getAttribute(fp);
  switch (A) {
    case "all":
      return 1;
    case "clone":
      return 2;
    case "parse":
      return 3;
    case "render":
      return 4;
    default:
      return 0;
  }
}, Tl = function(t, A) {
  var e = hp(t);
  return e === 1 || A === e;
}, Kr = (
  /** @class */
  /* @__PURE__ */ (function() {
    function t(A, e) {
      if (this.context = A, this.textNodes = [], this.elements = [], this.flags = 0, Tl(
        e,
        3
        /* PARSE */
      ))
        debugger;
      this.styles = new lp(A, window.getComputedStyle(e, null)), Pl(e) && (this.styles.animationDuration.some(function(r) {
        return r > 0;
      }) && (e.style.animationDuration = "0s"), this.styles.transform !== null && (e.style.transform = "none")), this.bounds = Go(this.context, e), Tl(
        e,
        4
        /* RENDER */
      ) && (this.flags |= 16);
    }
    return t;
  })()
), Bp = "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", Ff = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Ka = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var ro = 0; ro < Ff.length; ro++)
  Ka[Ff.charCodeAt(ro)] = ro;
var dp = function(t) {
  var A = t.length * 0.75, e = t.length, r, n = 0, i, o, s, c;
  t[t.length - 1] === "=" && (A--, t[t.length - 2] === "=" && A--);
  var u = typeof ArrayBuffer < "u" && typeof Uint8Array < "u" && typeof Uint8Array.prototype.slice < "u" ? new ArrayBuffer(A) : new Array(A), h = Array.isArray(u) ? u : new Uint8Array(u);
  for (r = 0; r < e; r += 4)
    i = Ka[t.charCodeAt(r)], o = Ka[t.charCodeAt(r + 1)], s = Ka[t.charCodeAt(r + 2)], c = Ka[t.charCodeAt(r + 3)], h[n++] = i << 2 | o >> 4, h[n++] = (o & 15) << 4 | s >> 2, h[n++] = (s & 3) << 6 | c & 63;
  return u;
}, gp = function(t) {
  for (var A = t.length, e = [], r = 0; r < A; r += 2)
    e.push(t[r + 1] << 8 | t[r]);
  return e;
}, pp = function(t) {
  for (var A = t.length, e = [], r = 0; r < A; r += 4)
    e.push(t[r + 3] << 24 | t[r + 2] << 16 | t[r + 1] << 8 | t[r]);
  return e;
}, Bi = 5, nu = 11, Kc = 2, wp = nu - Bi, G0 = 65536 >> Bi, vp = 1 << Bi, Rc = vp - 1, Cp = 1024 >> Bi, mp = G0 + Cp, Qp = mp, Fp = 32, Up = Qp + Fp, bp = 65536 >> nu, yp = 1 << wp, Ep = yp - 1, Uf = function(t, A, e) {
  return t.slice ? t.slice(A, e) : new Uint16Array(Array.prototype.slice.call(t, A, e));
}, Lp = function(t, A, e) {
  return t.slice ? t.slice(A, e) : new Uint32Array(Array.prototype.slice.call(t, A, e));
}, xp = function(t, A) {
  var e = dp(t), r = Array.isArray(e) ? pp(e) : new Uint32Array(e), n = Array.isArray(e) ? gp(e) : new Uint16Array(e), i = 24, o = Uf(n, i / 2, r[4] / 2), s = r[5] === 2 ? Uf(n, (i + r[4]) / 2) : Lp(r, Math.ceil((i + r[4]) / 4));
  return new Ip(r[0], r[1], r[2], r[3], o, s);
}, Ip = (
  /** @class */
  (function() {
    function t(A, e, r, n, i, o) {
      this.initialValue = A, this.errorValue = e, this.highStart = r, this.highValueIndex = n, this.index = i, this.data = o;
    }
    return t.prototype.get = function(A) {
      var e;
      if (A >= 0) {
        if (A < 55296 || A > 56319 && A <= 65535)
          return e = this.index[A >> Bi], e = (e << Kc) + (A & Rc), this.data[e];
        if (A <= 65535)
          return e = this.index[G0 + (A - 55296 >> Bi)], e = (e << Kc) + (A & Rc), this.data[e];
        if (A < this.highStart)
          return e = Up - bp + (A >> nu), e = this.index[e], e += A >> Bi & Ep, e = this.index[e], e = (e << Kc) + (A & Rc), this.data[e];
        if (A <= 1114111)
          return this.data[this.highValueIndex];
      }
      return this.errorValue;
    }, t;
  })()
), bf = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Sp = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var no = 0; no < bf.length; no++)
  Sp[bf.charCodeAt(no)] = no;
var Hp = 1, Gc = 2, Vc = 3, yf = 4, Ef = 5, Np = 7, Lf = 8, jc = 9, qc = 10, xf = 11, If = 12, Sf = 13, Hf = 14, Wc = 15, _p = function(t) {
  for (var A = [], e = 0, r = t.length; e < r; ) {
    var n = t.charCodeAt(e++);
    if (n >= 55296 && n <= 56319 && e < r) {
      var i = t.charCodeAt(e++);
      (i & 64512) === 56320 ? A.push(((n & 1023) << 10) + (i & 1023) + 65536) : (A.push(n), e--);
    } else
      A.push(n);
  }
  return A;
}, Dp = function() {
  for (var t = [], A = 0; A < arguments.length; A++)
    t[A] = arguments[A];
  if (String.fromCodePoint)
    return String.fromCodePoint.apply(String, t);
  var e = t.length;
  if (!e)
    return "";
  for (var r = [], n = -1, i = ""; ++n < e; ) {
    var o = t[n];
    o <= 65535 ? r.push(o) : (o -= 65536, r.push((o >> 10) + 55296, o % 1024 + 56320)), (n + 1 === e || r.length > 16384) && (i += String.fromCharCode.apply(String, r), r.length = 0);
  }
  return i;
}, Tp = xp(Bp), or = "×", Xc = "÷", Op = function(t) {
  return Tp.get(t);
}, kp = function(t, A, e) {
  var r = e - 2, n = A[r], i = A[e - 1], o = A[e];
  if (i === Gc && o === Vc)
    return or;
  if (i === Gc || i === Vc || i === yf || o === Gc || o === Vc || o === yf)
    return Xc;
  if (i === Lf && [Lf, jc, xf, If].indexOf(o) !== -1 || (i === xf || i === jc) && (o === jc || o === qc) || (i === If || i === qc) && o === qc || o === Sf || o === Ef || o === Np || i === Hp)
    return or;
  if (i === Sf && o === Hf) {
    for (; n === Ef; )
      n = A[--r];
    if (n === Hf)
      return or;
  }
  if (i === Wc && o === Wc) {
    for (var s = 0; n === Wc; )
      s++, n = A[--r];
    if (s % 2 === 0)
      return or;
  }
  return Xc;
}, Pp = function(t) {
  var A = _p(t), e = A.length, r = 0, n = 0, i = A.map(Op);
  return {
    next: function() {
      if (r >= e)
        return { done: !0, value: null };
      for (var o = or; r < e && (o = kp(A, i, ++r)) === or; )
        ;
      if (o !== or || r === e) {
        var s = Dp.apply(null, A.slice(n, r));
        return n = r, { value: s, done: !1 };
      }
      return { done: !0, value: null };
    }
  };
}, Mp = function(t) {
  for (var A = Pp(t), e = [], r; !(r = A.next()).done; )
    r.value && e.push(r.value.slice());
  return e;
}, Kp = function(t) {
  var A = 123;
  if (t.createRange) {
    var e = t.createRange();
    if (e.getBoundingClientRect) {
      var r = t.createElement("boundtest");
      r.style.height = A + "px", r.style.display = "block", t.body.appendChild(r), e.selectNode(r);
      var n = e.getBoundingClientRect(), i = Math.round(n.height);
      if (t.body.removeChild(r), i === A)
        return !0;
    }
  }
  return !1;
}, Rp = function(t) {
  var A = t.createElement("boundtest");
  A.style.width = "50px", A.style.display = "block", A.style.fontSize = "12px", A.style.letterSpacing = "0px", A.style.wordSpacing = "0px", t.body.appendChild(A);
  var e = t.createRange();
  A.innerHTML = typeof "".repeat == "function" ? "&#128104;".repeat(10) : "";
  var r = A.firstChild, n = Vo(r.data).map(function(c) {
    return $e(c);
  }), i = 0, o = {}, s = n.every(function(c, u) {
    e.setStart(r, i), e.setEnd(r, i + c.length);
    var h = e.getBoundingClientRect();
    i += c.length;
    var p = h.x > o.x || h.y > o.y;
    return o = h, u === 0 ? !0 : p;
  });
  return t.body.removeChild(A), s;
}, Gp = function() {
  return typeof new Image().crossOrigin < "u";
}, Vp = function() {
  return typeof new XMLHttpRequest().responseType == "string";
}, jp = function(t) {
  var A = new Image(), e = t.createElement("canvas"), r = e.getContext("2d");
  if (!r)
    return !1;
  A.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
  try {
    r.drawImage(A, 0, 0), e.toDataURL();
  } catch {
    return !1;
  }
  return !0;
}, Nf = function(t) {
  return t[0] === 0 && t[1] === 255 && t[2] === 0 && t[3] === 255;
}, qp = function(t) {
  var A = t.createElement("canvas"), e = 100;
  A.width = e, A.height = e;
  var r = A.getContext("2d");
  if (!r)
    return Promise.reject(!1);
  r.fillStyle = "rgb(0, 255, 0)", r.fillRect(0, 0, e, e);
  var n = new Image(), i = A.toDataURL();
  n.src = i;
  var o = Ol(e, e, 0, 0, n);
  return r.fillStyle = "red", r.fillRect(0, 0, e, e), _f(o).then(function(s) {
    r.drawImage(s, 0, 0);
    var c = r.getImageData(0, 0, e, e).data;
    r.fillStyle = "red", r.fillRect(0, 0, e, e);
    var u = t.createElement("div");
    return u.style.backgroundImage = "url(" + i + ")", u.style.height = e + "px", Nf(c) ? _f(Ol(e, e, 0, 0, u)) : Promise.reject(!1);
  }).then(function(s) {
    return r.drawImage(s, 0, 0), Nf(r.getImageData(0, 0, e, e).data);
  }).catch(function() {
    return !1;
  });
}, Ol = function(t, A, e, r, n) {
  var i = "http://www.w3.org/2000/svg", o = document.createElementNS(i, "svg"), s = document.createElementNS(i, "foreignObject");
  return o.setAttributeNS(null, "width", t.toString()), o.setAttributeNS(null, "height", A.toString()), s.setAttributeNS(null, "width", "100%"), s.setAttributeNS(null, "height", "100%"), s.setAttributeNS(null, "x", e.toString()), s.setAttributeNS(null, "y", r.toString()), s.setAttributeNS(null, "externalResourcesRequired", "true"), o.appendChild(s), s.appendChild(n), o;
}, _f = function(t) {
  return new Promise(function(A, e) {
    var r = new Image();
    r.onload = function() {
      return A(r);
    }, r.onerror = e, r.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(t));
  });
}, Ft = {
  get SUPPORT_RANGE_BOUNDS() {
    var t = Kp(document);
    return Object.defineProperty(Ft, "SUPPORT_RANGE_BOUNDS", { value: t }), t;
  },
  get SUPPORT_WORD_BREAKING() {
    var t = Ft.SUPPORT_RANGE_BOUNDS && Rp(document);
    return Object.defineProperty(Ft, "SUPPORT_WORD_BREAKING", { value: t }), t;
  },
  get SUPPORT_SVG_DRAWING() {
    var t = jp(document);
    return Object.defineProperty(Ft, "SUPPORT_SVG_DRAWING", { value: t }), t;
  },
  get SUPPORT_FOREIGNOBJECT_DRAWING() {
    var t = typeof Array.from == "function" && typeof window.fetch == "function" ? qp(document) : Promise.resolve(!1);
    return Object.defineProperty(Ft, "SUPPORT_FOREIGNOBJECT_DRAWING", { value: t }), t;
  },
  get SUPPORT_CORS_IMAGES() {
    var t = Gp();
    return Object.defineProperty(Ft, "SUPPORT_CORS_IMAGES", { value: t }), t;
  },
  get SUPPORT_RESPONSE_TYPE() {
    var t = Vp();
    return Object.defineProperty(Ft, "SUPPORT_RESPONSE_TYPE", { value: t }), t;
  },
  get SUPPORT_CORS_XHR() {
    var t = "withCredentials" in new XMLHttpRequest();
    return Object.defineProperty(Ft, "SUPPORT_CORS_XHR", { value: t }), t;
  },
  get SUPPORT_NATIVE_TEXT_SEGMENTATION() {
    var t = !!(typeof Intl < "u" && Intl.Segmenter);
    return Object.defineProperty(Ft, "SUPPORT_NATIVE_TEXT_SEGMENTATION", { value: t }), t;
  }
}, qa = (
  /** @class */
  /* @__PURE__ */ (function() {
    function t(A, e) {
      this.text = A, this.bounds = e;
    }
    return t;
  })()
), Wp = function(t, A, e, r) {
  var n = Yp(A, e), i = [], o = 0;
  return n.forEach(function(s) {
    if (e.textDecorationLine.length || s.trim().length > 0)
      if (Ft.SUPPORT_RANGE_BOUNDS) {
        var c = Df(r, o, s.length).getClientRects();
        if (c.length > 1) {
          var u = iu(s), h = 0;
          u.forEach(function(w) {
            i.push(new qa(w, Bn.fromDOMRectList(t, Df(r, h + o, w.length).getClientRects()))), h += w.length;
          });
        } else
          i.push(new qa(s, Bn.fromDOMRectList(t, c)));
      } else {
        var p = r.splitText(s.length);
        i.push(new qa(s, Xp(t, r))), r = p;
      }
    else Ft.SUPPORT_RANGE_BOUNDS || (r = r.splitText(s.length));
    o += s.length;
  }), i;
}, Xp = function(t, A) {
  var e = A.ownerDocument;
  if (e) {
    var r = e.createElement("html2canvaswrapper");
    r.appendChild(A.cloneNode(!0));
    var n = A.parentNode;
    if (n) {
      n.replaceChild(r, A);
      var i = Go(t, r);
      return r.firstChild && n.replaceChild(r.firstChild, r), i;
    }
  }
  return Bn.EMPTY;
}, Df = function(t, A, e) {
  var r = t.ownerDocument;
  if (!r)
    throw new Error("Node has no owner document");
  var n = r.createRange();
  return n.setStart(t, A), n.setEnd(t, A + e), n;
}, iu = function(t) {
  if (Ft.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
    var A = new Intl.Segmenter(void 0, { granularity: "grapheme" });
    return Array.from(A.segment(t)).map(function(e) {
      return e.segment;
    });
  }
  return Mp(t);
}, Jp = function(t, A) {
  if (Ft.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
    var e = new Intl.Segmenter(void 0, {
      granularity: "word"
    });
    return Array.from(e.segment(t)).map(function(r) {
      return r.segment;
    });
  }
  return Zp(t, A);
}, Yp = function(t, A) {
  return A.letterSpacing !== 0 ? iu(t) : Jp(t, A);
}, zp = [32, 160, 4961, 65792, 65793, 4153, 4241], Zp = function(t, A) {
  for (var e = bd(t, {
    lineBreak: A.lineBreak,
    wordBreak: A.overflowWrap === "break-word" ? "break-word" : A.wordBreak
  }), r = [], n, i = function() {
    if (n.value) {
      var o = n.value.slice(), s = Vo(o), c = "";
      s.forEach(function(u) {
        zp.indexOf(u) === -1 ? c += $e(u) : (c.length && r.push(c), r.push($e(u)), c = "");
      }), c.length && r.push(c);
    }
  }; !(n = e.next()).done; )
    i();
  return r;
}, $p = (
  /** @class */
  /* @__PURE__ */ (function() {
    function t(A, e, r) {
      this.text = Aw(e.data, r.textTransform), this.textBounds = Wp(A, this.text, r, e);
    }
    return t;
  })()
), Aw = function(t, A) {
  switch (A) {
    case 1:
      return t.toLowerCase();
    case 3:
      return t.replace(ew, tw);
    case 2:
      return t.toUpperCase();
    default:
      return t;
  }
}, ew = /(^|\s|:|-|\(|\))([a-z])/g, tw = function(t, A, e) {
  return t.length > 0 ? A + e.toUpperCase() : t;
}, V0 = (
  /** @class */
  (function(t) {
    Ur(A, t);
    function A(e, r) {
      var n = t.call(this, e, r) || this;
      return n.src = r.currentSrc || r.src, n.intrinsicWidth = r.naturalWidth, n.intrinsicHeight = r.naturalHeight, n.context.cache.addImage(n.src), n;
    }
    return A;
  })(Kr)
), j0 = (
  /** @class */
  (function(t) {
    Ur(A, t);
    function A(e, r) {
      var n = t.call(this, e, r) || this;
      return n.canvas = r, n.intrinsicWidth = r.width, n.intrinsicHeight = r.height, n;
    }
    return A;
  })(Kr)
), q0 = (
  /** @class */
  (function(t) {
    Ur(A, t);
    function A(e, r) {
      var n = t.call(this, e, r) || this, i = new XMLSerializer(), o = Go(e, r);
      return r.setAttribute("width", o.width + "px"), r.setAttribute("height", o.height + "px"), n.svg = "data:image/svg+xml," + encodeURIComponent(i.serializeToString(r)), n.intrinsicWidth = r.width.baseVal.value, n.intrinsicHeight = r.height.baseVal.value, n.context.cache.addImage(n.svg), n;
    }
    return A;
  })(Kr)
), W0 = (
  /** @class */
  (function(t) {
    Ur(A, t);
    function A(e, r) {
      var n = t.call(this, e, r) || this;
      return n.value = r.value, n;
    }
    return A;
  })(Kr)
), kl = (
  /** @class */
  (function(t) {
    Ur(A, t);
    function A(e, r) {
      var n = t.call(this, e, r) || this;
      return n.start = r.start, n.reversed = typeof r.reversed == "boolean" && r.reversed === !0, n;
    }
    return A;
  })(Kr)
), rw = [
  {
    type: 15,
    flags: 0,
    unit: "px",
    number: 3
  }
], nw = [
  {
    type: 16,
    flags: 0,
    number: 50
  }
], iw = function(t) {
  return t.width > t.height ? new Bn(t.left + (t.width - t.height) / 2, t.top, t.height, t.height) : t.width < t.height ? new Bn(t.left, t.top + (t.height - t.width) / 2, t.width, t.width) : t;
}, aw = function(t) {
  var A = t.type === sw ? new Array(t.value.length + 1).join("•") : t.value;
  return A.length === 0 ? t.placeholder || "" : A;
}, Ho = "checkbox", No = "radio", sw = "password", Tf = 707406591, au = (
  /** @class */
  (function(t) {
    Ur(A, t);
    function A(e, r) {
      var n = t.call(this, e, r) || this;
      switch (n.type = r.type.toLowerCase(), n.checked = r.checked, n.value = aw(r), (n.type === Ho || n.type === No) && (n.styles.backgroundColor = 3739148031, n.styles.borderTopColor = n.styles.borderRightColor = n.styles.borderBottomColor = n.styles.borderLeftColor = 2779096575, n.styles.borderTopWidth = n.styles.borderRightWidth = n.styles.borderBottomWidth = n.styles.borderLeftWidth = 1, n.styles.borderTopStyle = n.styles.borderRightStyle = n.styles.borderBottomStyle = n.styles.borderLeftStyle = 1, n.styles.backgroundClip = [
        0
        /* BORDER_BOX */
      ], n.styles.backgroundOrigin = [
        0
        /* BORDER_BOX */
      ], n.bounds = iw(n.bounds)), n.type) {
        case Ho:
          n.styles.borderTopRightRadius = n.styles.borderTopLeftRadius = n.styles.borderBottomRightRadius = n.styles.borderBottomLeftRadius = rw;
          break;
        case No:
          n.styles.borderTopRightRadius = n.styles.borderTopLeftRadius = n.styles.borderBottomRightRadius = n.styles.borderBottomLeftRadius = nw;
          break;
      }
      return n;
    }
    return A;
  })(Kr)
), X0 = (
  /** @class */
  (function(t) {
    Ur(A, t);
    function A(e, r) {
      var n = t.call(this, e, r) || this, i = r.options[r.selectedIndex || 0];
      return n.value = i && i.text || "", n;
    }
    return A;
  })(Kr)
), J0 = (
  /** @class */
  (function(t) {
    Ur(A, t);
    function A(e, r) {
      var n = t.call(this, e, r) || this;
      return n.value = r.value, n;
    }
    return A;
  })(Kr)
), Y0 = (
  /** @class */
  (function(t) {
    Ur(A, t);
    function A(e, r) {
      var n = t.call(this, e, r) || this;
      n.src = r.src, n.width = parseInt(r.width, 10) || 0, n.height = parseInt(r.height, 10) || 0, n.backgroundColor = n.styles.backgroundColor;
      try {
        if (r.contentWindow && r.contentWindow.document && r.contentWindow.document.documentElement) {
          n.tree = Z0(e, r.contentWindow.document.documentElement);
          var i = r.contentWindow.document.documentElement ? Va(e, getComputedStyle(r.contentWindow.document.documentElement).backgroundColor) : hn.TRANSPARENT, o = r.contentWindow.document.body ? Va(e, getComputedStyle(r.contentWindow.document.body).backgroundColor) : hn.TRANSPARENT;
          n.backgroundColor = Kn(i) ? Kn(o) ? n.styles.backgroundColor : o : i;
        }
      } catch {
      }
      return n;
    }
    return A;
  })(Kr)
), ow = ["OL", "UL", "MENU"], mo = function(t, A, e, r) {
  for (var n = A.firstChild, i = void 0; n; n = i)
    if (i = n.nextSibling, $0(n) && n.data.trim().length > 0)
      e.textNodes.push(new $p(t, n, e.styles));
    else if (qi(n))
      if (r1(n) && n.assignedNodes)
        n.assignedNodes().forEach(function(s) {
          return mo(t, s, e, r);
        });
      else {
        var o = z0(t, n);
        o.styles.isVisible() && (cw(n, o, r) ? o.flags |= 4 : lw(o.styles) && (o.flags |= 2), ow.indexOf(n.tagName) !== -1 && (o.flags |= 8), e.elements.push(o), n.slot, n.shadowRoot ? mo(t, n.shadowRoot, o, r) : !_o(n) && !A1(n) && !Do(n) && mo(t, n, o, r));
      }
}, z0 = function(t, A) {
  return Ml(A) ? new V0(t, A) : e1(A) ? new j0(t, A) : A1(A) ? new q0(t, A) : uw(A) ? new W0(t, A) : fw(A) ? new kl(t, A) : hw(A) ? new au(t, A) : Do(A) ? new X0(t, A) : _o(A) ? new J0(t, A) : t1(A) ? new Y0(t, A) : new Kr(t, A);
}, Z0 = function(t, A) {
  var e = z0(t, A);
  return e.flags |= 4, mo(t, A, e, e), e;
}, cw = function(t, A, e) {
  return A.styles.isPositionedWithZIndex() || A.styles.opacity < 1 || A.styles.isTransformed() || su(t) && e.styles.isTransparent();
}, lw = function(t) {
  return t.isPositioned() || t.isFloating();
}, $0 = function(t) {
  return t.nodeType === Node.TEXT_NODE;
}, qi = function(t) {
  return t.nodeType === Node.ELEMENT_NODE;
}, Pl = function(t) {
  return qi(t) && typeof t.style < "u" && !Qo(t);
}, Qo = function(t) {
  return typeof t.className == "object";
}, uw = function(t) {
  return t.tagName === "LI";
}, fw = function(t) {
  return t.tagName === "OL";
}, hw = function(t) {
  return t.tagName === "INPUT";
}, Bw = function(t) {
  return t.tagName === "HTML";
}, A1 = function(t) {
  return t.tagName === "svg";
}, su = function(t) {
  return t.tagName === "BODY";
}, e1 = function(t) {
  return t.tagName === "CANVAS";
}, Of = function(t) {
  return t.tagName === "VIDEO";
}, Ml = function(t) {
  return t.tagName === "IMG";
}, t1 = function(t) {
  return t.tagName === "IFRAME";
}, kf = function(t) {
  return t.tagName === "STYLE";
}, dw = function(t) {
  return t.tagName === "SCRIPT";
}, _o = function(t) {
  return t.tagName === "TEXTAREA";
}, Do = function(t) {
  return t.tagName === "SELECT";
}, r1 = function(t) {
  return t.tagName === "SLOT";
}, Pf = function(t) {
  return t.tagName.indexOf("-") > 0;
}, gw = (
  /** @class */
  (function() {
    function t() {
      this.counters = {};
    }
    return t.prototype.getCounterValue = function(A) {
      var e = this.counters[A];
      return e && e.length ? e[e.length - 1] : 1;
    }, t.prototype.getCounterValues = function(A) {
      var e = this.counters[A];
      return e || [];
    }, t.prototype.pop = function(A) {
      var e = this;
      A.forEach(function(r) {
        return e.counters[r].pop();
      });
    }, t.prototype.parse = function(A) {
      var e = this, r = A.counterIncrement, n = A.counterReset, i = !0;
      r !== null && r.forEach(function(s) {
        var c = e.counters[s.counter];
        c && s.increment !== 0 && (i = !1, c.length || c.push(1), c[Math.max(0, c.length - 1)] += s.increment);
      });
      var o = [];
      return i && n.forEach(function(s) {
        var c = e.counters[s.counter];
        o.push(s.counter), c || (c = e.counters[s.counter] = []), c.push(s.reset);
      }), o;
    }, t;
  })()
), Mf = {
  integers: [1e3, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1],
  values: ["M", "CM", "D", "CD", "C", "XC", "L", "XL", "X", "IX", "V", "IV", "I"]
}, Kf = {
  integers: [
    9e3,
    8e3,
    7e3,
    6e3,
    5e3,
    4e3,
    3e3,
    2e3,
    1e3,
    900,
    800,
    700,
    600,
    500,
    400,
    300,
    200,
    100,
    90,
    80,
    70,
    60,
    50,
    40,
    30,
    20,
    10,
    9,
    8,
    7,
    6,
    5,
    4,
    3,
    2,
    1
  ],
  values: [
    "Ք",
    "Փ",
    "Ւ",
    "Ց",
    "Ր",
    "Տ",
    "Վ",
    "Ս",
    "Ռ",
    "Ջ",
    "Պ",
    "Չ",
    "Ո",
    "Շ",
    "Ն",
    "Յ",
    "Մ",
    "Ճ",
    "Ղ",
    "Ձ",
    "Հ",
    "Կ",
    "Ծ",
    "Խ",
    "Լ",
    "Ի",
    "Ժ",
    "Թ",
    "Ը",
    "Է",
    "Զ",
    "Ե",
    "Դ",
    "Գ",
    "Բ",
    "Ա"
  ]
}, pw = {
  integers: [
    1e4,
    9e3,
    8e3,
    7e3,
    6e3,
    5e3,
    4e3,
    3e3,
    2e3,
    1e3,
    400,
    300,
    200,
    100,
    90,
    80,
    70,
    60,
    50,
    40,
    30,
    20,
    19,
    18,
    17,
    16,
    15,
    10,
    9,
    8,
    7,
    6,
    5,
    4,
    3,
    2,
    1
  ],
  values: [
    "י׳",
    "ט׳",
    "ח׳",
    "ז׳",
    "ו׳",
    "ה׳",
    "ד׳",
    "ג׳",
    "ב׳",
    "א׳",
    "ת",
    "ש",
    "ר",
    "ק",
    "צ",
    "פ",
    "ע",
    "ס",
    "נ",
    "מ",
    "ל",
    "כ",
    "יט",
    "יח",
    "יז",
    "טז",
    "טו",
    "י",
    "ט",
    "ח",
    "ז",
    "ו",
    "ה",
    "ד",
    "ג",
    "ב",
    "א"
  ]
}, ww = {
  integers: [
    1e4,
    9e3,
    8e3,
    7e3,
    6e3,
    5e3,
    4e3,
    3e3,
    2e3,
    1e3,
    900,
    800,
    700,
    600,
    500,
    400,
    300,
    200,
    100,
    90,
    80,
    70,
    60,
    50,
    40,
    30,
    20,
    10,
    9,
    8,
    7,
    6,
    5,
    4,
    3,
    2,
    1
  ],
  values: [
    "ჵ",
    "ჰ",
    "ჯ",
    "ჴ",
    "ხ",
    "ჭ",
    "წ",
    "ძ",
    "ც",
    "ჩ",
    "შ",
    "ყ",
    "ღ",
    "ქ",
    "ფ",
    "ჳ",
    "ტ",
    "ს",
    "რ",
    "ჟ",
    "პ",
    "ო",
    "ჲ",
    "ნ",
    "მ",
    "ლ",
    "კ",
    "ი",
    "თ",
    "ჱ",
    "ზ",
    "ვ",
    "ე",
    "დ",
    "გ",
    "ბ",
    "ა"
  ]
}, Ti = function(t, A, e, r, n, i) {
  return t < A || t > e ? Za(t, n, i.length > 0) : r.integers.reduce(function(o, s, c) {
    for (; t >= s; )
      t -= s, o += r.values[c];
    return o;
  }, "") + i;
}, n1 = function(t, A, e, r) {
  var n = "";
  do
    e || t--, n = r(t) + n, t /= A;
  while (t * A >= A);
  return n;
}, Ze = function(t, A, e, r, n) {
  var i = e - A + 1;
  return (t < 0 ? "-" : "") + (n1(Math.abs(t), i, r, function(o) {
    return $e(Math.floor(o % i) + A);
  }) + n);
}, oi = function(t, A, e) {
  e === void 0 && (e = ". ");
  var r = A.length;
  return n1(Math.abs(t), r, !1, function(n) {
    return A[Math.floor(n % r)];
  }) + e;
}, Ri = 1, Nn = 2, _n = 4, Ra = 8, cn = function(t, A, e, r, n, i) {
  if (t < -9999 || t > 9999)
    return Za(t, 4, n.length > 0);
  var o = Math.abs(t), s = n;
  if (o === 0)
    return A[0] + s;
  for (var c = 0; o > 0 && c <= 4; c++) {
    var u = o % 10;
    u === 0 && ht(i, Ri) && s !== "" ? s = A[u] + s : u > 1 || u === 1 && c === 0 || u === 1 && c === 1 && ht(i, Nn) || u === 1 && c === 1 && ht(i, _n) && t > 100 || u === 1 && c > 1 && ht(i, Ra) ? s = A[u] + (c > 0 ? e[c - 1] : "") + s : u === 1 && c > 0 && (s = e[c - 1] + s), o = Math.floor(o / 10);
  }
  return (t < 0 ? r : "") + s;
}, Rf = "十百千萬", Gf = "拾佰仟萬", Vf = "マイナス", Jc = "마이너스", Za = function(t, A, e) {
  var r = e ? ". " : "", n = e ? "、" : "", i = e ? ", " : "", o = e ? " " : "";
  switch (A) {
    case 0:
      return "•" + o;
    case 1:
      return "◦" + o;
    case 2:
      return "◾" + o;
    case 5:
      var s = Ze(t, 48, 57, !0, r);
      return s.length < 4 ? "0" + s : s;
    case 4:
      return oi(t, "〇一二三四五六七八九", n);
    case 6:
      return Ti(t, 1, 3999, Mf, 3, r).toLowerCase();
    case 7:
      return Ti(t, 1, 3999, Mf, 3, r);
    case 8:
      return Ze(t, 945, 969, !1, r);
    case 9:
      return Ze(t, 97, 122, !1, r);
    case 10:
      return Ze(t, 65, 90, !1, r);
    case 11:
      return Ze(t, 1632, 1641, !0, r);
    case 12:
    case 49:
      return Ti(t, 1, 9999, Kf, 3, r);
    case 35:
      return Ti(t, 1, 9999, Kf, 3, r).toLowerCase();
    case 13:
      return Ze(t, 2534, 2543, !0, r);
    case 14:
    case 30:
      return Ze(t, 6112, 6121, !0, r);
    case 15:
      return oi(t, "子丑寅卯辰巳午未申酉戌亥", n);
    case 16:
      return oi(t, "甲乙丙丁戊己庚辛壬癸", n);
    case 17:
    case 48:
      return cn(t, "零一二三四五六七八九", Rf, "負", n, Nn | _n | Ra);
    case 47:
      return cn(t, "零壹貳參肆伍陸柒捌玖", Gf, "負", n, Ri | Nn | _n | Ra);
    case 42:
      return cn(t, "零一二三四五六七八九", Rf, "负", n, Nn | _n | Ra);
    case 41:
      return cn(t, "零壹贰叁肆伍陆柒捌玖", Gf, "负", n, Ri | Nn | _n | Ra);
    case 26:
      return cn(t, "〇一二三四五六七八九", "十百千万", Vf, n, 0);
    case 25:
      return cn(t, "零壱弐参四伍六七八九", "拾百千万", Vf, n, Ri | Nn | _n);
    case 31:
      return cn(t, "영일이삼사오육칠팔구", "십백천만", Jc, i, Ri | Nn | _n);
    case 33:
      return cn(t, "零一二三四五六七八九", "十百千萬", Jc, i, 0);
    case 32:
      return cn(t, "零壹貳參四五六七八九", "拾百千", Jc, i, Ri | Nn | _n);
    case 18:
      return Ze(t, 2406, 2415, !0, r);
    case 20:
      return Ti(t, 1, 19999, ww, 3, r);
    case 21:
      return Ze(t, 2790, 2799, !0, r);
    case 22:
      return Ze(t, 2662, 2671, !0, r);
    case 22:
      return Ti(t, 1, 10999, pw, 3, r);
    case 23:
      return oi(t, "あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん");
    case 24:
      return oi(t, "いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす");
    case 27:
      return Ze(t, 3302, 3311, !0, r);
    case 28:
      return oi(t, "アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン", n);
    case 29:
      return oi(t, "イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス", n);
    case 34:
      return Ze(t, 3792, 3801, !0, r);
    case 37:
      return Ze(t, 6160, 6169, !0, r);
    case 38:
      return Ze(t, 4160, 4169, !0, r);
    case 39:
      return Ze(t, 2918, 2927, !0, r);
    case 40:
      return Ze(t, 1776, 1785, !0, r);
    case 43:
      return Ze(t, 3046, 3055, !0, r);
    case 44:
      return Ze(t, 3174, 3183, !0, r);
    case 45:
      return Ze(t, 3664, 3673, !0, r);
    case 46:
      return Ze(t, 3872, 3881, !0, r);
    case 3:
    default:
      return Ze(t, 48, 57, !0, r);
  }
}, i1 = "data-html2canvas-ignore", jf = (
  /** @class */
  (function() {
    function t(A, e, r) {
      if (this.context = A, this.options = r, this.scrolledElements = [], this.referenceElement = e, this.counters = new gw(), this.quoteDepth = 0, !e.ownerDocument)
        throw new Error("Cloned element does not have an owner document");
      this.documentElement = this.cloneNode(e.ownerDocument.documentElement, !1);
    }
    return t.prototype.toIFrame = function(A, e) {
      var r = this, n = vw(A, e);
      if (!n.contentWindow)
        return Promise.reject("Unable to find iframe window");
      var i = A.defaultView.pageXOffset, o = A.defaultView.pageYOffset, s = n.contentWindow, c = s.document, u = Qw(n).then(function() {
        return Ot(r, void 0, void 0, function() {
          var h, p;
          return St(this, function(w) {
            switch (w.label) {
              case 0:
                return this.scrolledElements.forEach(yw), s && (s.scrollTo(e.left, e.top), /(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (s.scrollY !== e.top || s.scrollX !== e.left) && (this.context.logger.warn("Unable to restore scroll position for cloned document"), this.context.windowBounds = this.context.windowBounds.add(s.scrollX - e.left, s.scrollY - e.top, 0, 0))), h = this.options.onclone, p = this.clonedReferenceElement, typeof p > "u" ? [2, Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")] : c.fonts && c.fonts.ready ? [4, c.fonts.ready] : [3, 2];
              case 1:
                w.sent(), w.label = 2;
              case 2:
                return /(AppleWebKit)/g.test(navigator.userAgent) ? [4, mw(c)] : [3, 4];
              case 3:
                w.sent(), w.label = 4;
              case 4:
                return typeof h == "function" ? [2, Promise.resolve().then(function() {
                  return h(c, p);
                }).then(function() {
                  return n;
                })] : [2, n];
            }
          });
        });
      });
      return c.open(), c.write(Uw(document.doctype) + "<html></html>"), bw(this.referenceElement.ownerDocument, i, o), c.replaceChild(c.adoptNode(this.documentElement), c.documentElement), c.close(), u;
    }, t.prototype.createElementClone = function(A) {
      if (Tl(
        A,
        2
        /* CLONE */
      ))
        debugger;
      if (e1(A))
        return this.createCanvasClone(A);
      if (Of(A))
        return this.createVideoClone(A);
      if (kf(A))
        return this.createStyleClone(A);
      var e = A.cloneNode(!1);
      return Ml(e) && (Ml(A) && A.currentSrc && A.currentSrc !== A.src && (e.src = A.currentSrc, e.srcset = ""), e.loading === "lazy" && (e.loading = "eager")), Pf(e) ? this.createCustomElementClone(e) : e;
    }, t.prototype.createCustomElementClone = function(A) {
      var e = document.createElement("html2canvascustomelement");
      return Yc(A.style, e), e;
    }, t.prototype.createStyleClone = function(A) {
      try {
        var e = A.sheet;
        if (e && e.cssRules) {
          var r = [].slice.call(e.cssRules, 0).reduce(function(i, o) {
            return o && typeof o.cssText == "string" ? i + o.cssText : i;
          }, ""), n = A.cloneNode(!1);
          return n.textContent = r, n;
        }
      } catch (i) {
        if (this.context.logger.error("Unable to access cssRules property", i), i.name !== "SecurityError")
          throw i;
      }
      return A.cloneNode(!1);
    }, t.prototype.createCanvasClone = function(A) {
      var e;
      if (this.options.inlineImages && A.ownerDocument) {
        var r = A.ownerDocument.createElement("img");
        try {
          return r.src = A.toDataURL(), r;
        } catch {
          this.context.logger.info("Unable to inline canvas contents, canvas is tainted", A);
        }
      }
      var n = A.cloneNode(!1);
      try {
        n.width = A.width, n.height = A.height;
        var i = A.getContext("2d"), o = n.getContext("2d");
        if (o)
          if (!this.options.allowTaint && i)
            o.putImageData(i.getImageData(0, 0, A.width, A.height), 0, 0);
          else {
            var s = (e = A.getContext("webgl2")) !== null && e !== void 0 ? e : A.getContext("webgl");
            if (s) {
              var c = s.getContextAttributes();
              (c == null ? void 0 : c.preserveDrawingBuffer) === !1 && this.context.logger.warn("Unable to clone WebGL context as it has preserveDrawingBuffer=false", A);
            }
            o.drawImage(A, 0, 0);
          }
        return n;
      } catch {
        this.context.logger.info("Unable to clone canvas as it is tainted", A);
      }
      return n;
    }, t.prototype.createVideoClone = function(A) {
      var e = A.ownerDocument.createElement("canvas");
      e.width = A.offsetWidth, e.height = A.offsetHeight;
      var r = e.getContext("2d");
      try {
        return r && (r.drawImage(A, 0, 0, e.width, e.height), this.options.allowTaint || r.getImageData(0, 0, e.width, e.height)), e;
      } catch {
        this.context.logger.info("Unable to clone video as it is tainted", A);
      }
      var n = A.ownerDocument.createElement("canvas");
      return n.width = A.offsetWidth, n.height = A.offsetHeight, n;
    }, t.prototype.appendChildNode = function(A, e, r) {
      (!qi(e) || !dw(e) && !e.hasAttribute(i1) && (typeof this.options.ignoreElements != "function" || !this.options.ignoreElements(e))) && (!this.options.copyStyles || !qi(e) || !kf(e)) && A.appendChild(this.cloneNode(e, r));
    }, t.prototype.cloneChildNodes = function(A, e, r) {
      for (var n = this, i = A.shadowRoot ? A.shadowRoot.firstChild : A.firstChild; i; i = i.nextSibling)
        if (qi(i) && r1(i) && typeof i.assignedNodes == "function") {
          var o = i.assignedNodes();
          o.length && o.forEach(function(s) {
            return n.appendChildNode(e, s, r);
          });
        } else
          this.appendChildNode(e, i, r);
    }, t.prototype.cloneNode = function(A, e) {
      if ($0(A))
        return document.createTextNode(A.data);
      if (!A.ownerDocument)
        return A.cloneNode(!1);
      var r = A.ownerDocument.defaultView;
      if (r && qi(A) && (Pl(A) || Qo(A))) {
        var n = this.createElementClone(A);
        n.style.transitionProperty = "none";
        var i = r.getComputedStyle(A), o = r.getComputedStyle(A, ":before"), s = r.getComputedStyle(A, ":after");
        this.referenceElement === A && Pl(n) && (this.clonedReferenceElement = n), su(n) && xw(n);
        var c = this.counters.parse(new Qf(this.context, i)), u = this.resolvePseudoContent(A, n, o, Wa.BEFORE);
        Pf(A) && (e = !0), Of(A) || this.cloneChildNodes(A, n, e), u && n.insertBefore(u, n.firstChild);
        var h = this.resolvePseudoContent(A, n, s, Wa.AFTER);
        return h && n.appendChild(h), this.counters.pop(c), (i && (this.options.copyStyles || Qo(A)) && !t1(A) || e) && Yc(i, n), (A.scrollTop !== 0 || A.scrollLeft !== 0) && this.scrolledElements.push([n, A.scrollLeft, A.scrollTop]), (_o(A) || Do(A)) && (_o(n) || Do(n)) && (n.value = A.value), n;
      }
      return A.cloneNode(!1);
    }, t.prototype.resolvePseudoContent = function(A, e, r, n) {
      var i = this;
      if (r) {
        var o = r.content, s = e.ownerDocument;
        if (!(!s || !o || o === "none" || o === "-moz-alt-content" || r.display === "none")) {
          this.counters.parse(new Qf(this.context, r));
          var c = new up(this.context, r), u = s.createElement("html2canvaspseudoelement");
          Yc(r, u), c.content.forEach(function(p) {
            if (p.type === 0)
              u.appendChild(s.createTextNode(p.value));
            else if (p.type === 22) {
              var w = s.createElement("img");
              w.src = p.value, w.style.opacity = "1", u.appendChild(w);
            } else if (p.type === 18) {
              if (p.name === "attr") {
                var d = p.values.filter(Le);
                d.length && u.appendChild(s.createTextNode(A.getAttribute(d[0].value) || ""));
              } else if (p.name === "counter") {
                var y = p.values.filter($i), b = y[0], S = y[1];
                if (b && Le(b)) {
                  var Q = i.counters.getCounterValue(b.value), P = S && Le(S) ? Dl.parse(i.context, S.value) : 3;
                  u.appendChild(s.createTextNode(Za(Q, P, !1)));
                }
              } else if (p.name === "counters") {
                var G = p.values.filter($i), b = G[0], k = G[1], S = G[2];
                if (b && Le(b)) {
                  var Y = i.counters.getCounterValues(b.value), z = S && Le(S) ? Dl.parse(i.context, S.value) : 3, iA = k && k.type === 0 ? k.value : "", j = Y.map(function(E) {
                    return Za(E, z, !1);
                  }).join(iA);
                  u.appendChild(s.createTextNode(j));
                }
              }
            } else if (p.type === 20)
              switch (p.value) {
                case "open-quote":
                  u.appendChild(s.createTextNode(mf(c.quotes, i.quoteDepth++, !0)));
                  break;
                case "close-quote":
                  u.appendChild(s.createTextNode(mf(c.quotes, --i.quoteDepth, !1)));
                  break;
                default:
                  u.appendChild(s.createTextNode(p.value));
              }
          }), u.className = Kl + " " + Rl;
          var h = n === Wa.BEFORE ? " " + Kl : " " + Rl;
          return Qo(e) ? e.className.baseValue += h : e.className += h, u;
        }
      }
    }, t.destroy = function(A) {
      return A.parentNode ? (A.parentNode.removeChild(A), !0) : !1;
    }, t;
  })()
), Wa;
(function(t) {
  t[t.BEFORE = 0] = "BEFORE", t[t.AFTER = 1] = "AFTER";
})(Wa || (Wa = {}));
var vw = function(t, A) {
  var e = t.createElement("iframe");
  return e.className = "html2canvas-container", e.style.visibility = "hidden", e.style.position = "fixed", e.style.left = "-10000px", e.style.top = "0px", e.style.border = "0", e.width = A.width.toString(), e.height = A.height.toString(), e.scrolling = "no", e.setAttribute(i1, "true"), t.body.appendChild(e), e;
}, Cw = function(t) {
  return new Promise(function(A) {
    if (t.complete) {
      A();
      return;
    }
    if (!t.src) {
      A();
      return;
    }
    t.onload = A, t.onerror = A;
  });
}, mw = function(t) {
  return Promise.all([].slice.call(t.images, 0).map(Cw));
}, Qw = function(t) {
  return new Promise(function(A, e) {
    var r = t.contentWindow;
    if (!r)
      return e("No window assigned for iframe");
    var n = r.document;
    r.onload = t.onload = function() {
      r.onload = t.onload = null;
      var i = setInterval(function() {
        n.body.childNodes.length > 0 && n.readyState === "complete" && (clearInterval(i), A(t));
      }, 50);
    };
  });
}, Fw = [
  "all",
  "d",
  "content"
  // Safari shows pseudoelements if content is set
], Yc = function(t, A) {
  for (var e = t.length - 1; e >= 0; e--) {
    var r = t.item(e);
    Fw.indexOf(r) === -1 && A.style.setProperty(r, t.getPropertyValue(r));
  }
  return A;
}, Uw = function(t) {
  var A = "";
  return t && (A += "<!DOCTYPE ", t.name && (A += t.name), t.internalSubset && (A += t.internalSubset), t.publicId && (A += '"' + t.publicId + '"'), t.systemId && (A += '"' + t.systemId + '"'), A += ">"), A;
}, bw = function(t, A, e) {
  t && t.defaultView && (A !== t.defaultView.pageXOffset || e !== t.defaultView.pageYOffset) && t.defaultView.scrollTo(A, e);
}, yw = function(t) {
  var A = t[0], e = t[1], r = t[2];
  A.scrollLeft = e, A.scrollTop = r;
}, Ew = ":before", Lw = ":after", Kl = "___html2canvas___pseudoelement_before", Rl = "___html2canvas___pseudoelement_after", qf = `{
    content: "" !important;
    display: none !important;
}`, xw = function(t) {
  Iw(t, "." + Kl + Ew + qf + `
         .` + Rl + Lw + qf);
}, Iw = function(t, A) {
  var e = t.ownerDocument;
  if (e) {
    var r = e.createElement("style");
    r.textContent = A, t.appendChild(r);
  }
}, a1 = (
  /** @class */
  (function() {
    function t() {
    }
    return t.getOrigin = function(A) {
      var e = t._link;
      return e ? (e.href = A, e.href = e.href, e.protocol + e.hostname + e.port) : "about:blank";
    }, t.isSameOrigin = function(A) {
      return t.getOrigin(A) === t._origin;
    }, t.setContext = function(A) {
      t._link = A.document.createElement("a"), t._origin = t.getOrigin(A.location.href);
    }, t._origin = "about:blank", t;
  })()
), Sw = (
  /** @class */
  (function() {
    function t(A, e) {
      this.context = A, this._options = e, this._cache = {};
    }
    return t.prototype.addImage = function(A) {
      var e = Promise.resolve();
      return this.has(A) || (Zc(A) || Dw(A)) && (this._cache[A] = this.loadImage(A)).catch(function() {
      }), e;
    }, t.prototype.match = function(A) {
      return this._cache[A];
    }, t.prototype.loadImage = function(A) {
      return Ot(this, void 0, void 0, function() {
        var e, r, n, i, o = this;
        return St(this, function(s) {
          switch (s.label) {
            case 0:
              return e = a1.isSameOrigin(A), r = !zc(A) && this._options.useCORS === !0 && Ft.SUPPORT_CORS_IMAGES && !e, n = !zc(A) && !e && !Zc(A) && typeof this._options.proxy == "string" && Ft.SUPPORT_CORS_XHR && !r, !e && this._options.allowTaint === !1 && !zc(A) && !Zc(A) && !n && !r ? [
                2
                /*return*/
              ] : (i = A, n ? [4, this.proxy(i)] : [3, 2]);
            case 1:
              i = s.sent(), s.label = 2;
            case 2:
              return this.context.logger.debug("Added image " + A.substring(0, 256)), [4, new Promise(function(c, u) {
                var h = new Image();
                h.onload = function() {
                  return c(h);
                }, h.onerror = u, (Tw(i) || r) && (h.crossOrigin = "anonymous"), h.src = i, h.complete === !0 && setTimeout(function() {
                  return c(h);
                }, 500), o._options.imageTimeout > 0 && setTimeout(function() {
                  return u("Timed out (" + o._options.imageTimeout + "ms) loading image");
                }, o._options.imageTimeout);
              })];
            case 3:
              return [2, s.sent()];
          }
        });
      });
    }, t.prototype.has = function(A) {
      return typeof this._cache[A] < "u";
    }, t.prototype.keys = function() {
      return Promise.resolve(Object.keys(this._cache));
    }, t.prototype.proxy = function(A) {
      var e = this, r = this._options.proxy;
      if (!r)
        throw new Error("No proxy defined");
      var n = A.substring(0, 256);
      return new Promise(function(i, o) {
        var s = Ft.SUPPORT_RESPONSE_TYPE ? "blob" : "text", c = new XMLHttpRequest();
        c.onload = function() {
          if (c.status === 200)
            if (s === "text")
              i(c.response);
            else {
              var p = new FileReader();
              p.addEventListener("load", function() {
                return i(p.result);
              }, !1), p.addEventListener("error", function(w) {
                return o(w);
              }, !1), p.readAsDataURL(c.response);
            }
          else
            o("Failed to proxy resource " + n + " with status code " + c.status);
        }, c.onerror = o;
        var u = r.indexOf("?") > -1 ? "&" : "?";
        if (c.open("GET", "" + r + u + "url=" + encodeURIComponent(A) + "&responseType=" + s), s !== "text" && c instanceof XMLHttpRequest && (c.responseType = s), e._options.imageTimeout) {
          var h = e._options.imageTimeout;
          c.timeout = h, c.ontimeout = function() {
            return o("Timed out (" + h + "ms) proxying " + n);
          };
        }
        c.send();
      });
    }, t;
  })()
), Hw = /^data:image\/svg\+xml/i, Nw = /^data:image\/.*;base64,/i, _w = /^data:image\/.*/i, Dw = function(t) {
  return Ft.SUPPORT_SVG_DRAWING || !Ow(t);
}, zc = function(t) {
  return _w.test(t);
}, Tw = function(t) {
  return Nw.test(t);
}, Zc = function(t) {
  return t.substr(0, 4) === "blob";
}, Ow = function(t) {
  return t.substr(-3).toLowerCase() === "svg" || Hw.test(t);
}, EA = (
  /** @class */
  (function() {
    function t(A, e) {
      this.type = 0, this.x = A, this.y = e;
    }
    return t.prototype.add = function(A, e) {
      return new t(this.x + A, this.y + e);
    }, t;
  })()
), Oi = function(t, A, e) {
  return new EA(t.x + (A.x - t.x) * e, t.y + (A.y - t.y) * e);
}, io = (
  /** @class */
  (function() {
    function t(A, e, r, n) {
      this.type = 1, this.start = A, this.startControl = e, this.endControl = r, this.end = n;
    }
    return t.prototype.subdivide = function(A, e) {
      var r = Oi(this.start, this.startControl, A), n = Oi(this.startControl, this.endControl, A), i = Oi(this.endControl, this.end, A), o = Oi(r, n, A), s = Oi(n, i, A), c = Oi(o, s, A);
      return e ? new t(this.start, r, o, c) : new t(c, s, i, this.end);
    }, t.prototype.add = function(A, e) {
      return new t(this.start.add(A, e), this.startControl.add(A, e), this.endControl.add(A, e), this.end.add(A, e));
    }, t.prototype.reverse = function() {
      return new t(this.end, this.endControl, this.startControl, this.start);
    }, t;
  })()
), cr = function(t) {
  return t.type === 1;
}, kw = (
  /** @class */
  /* @__PURE__ */ (function() {
    function t(A) {
      var e = A.styles, r = A.bounds, n = Ma(e.borderTopLeftRadius, r.width, r.height), i = n[0], o = n[1], s = Ma(e.borderTopRightRadius, r.width, r.height), c = s[0], u = s[1], h = Ma(e.borderBottomRightRadius, r.width, r.height), p = h[0], w = h[1], d = Ma(e.borderBottomLeftRadius, r.width, r.height), y = d[0], b = d[1], S = [];
      S.push((i + c) / r.width), S.push((y + p) / r.width), S.push((o + b) / r.height), S.push((u + w) / r.height);
      var Q = Math.max.apply(Math, S);
      Q > 1 && (i /= Q, o /= Q, c /= Q, u /= Q, p /= Q, w /= Q, y /= Q, b /= Q);
      var P = r.width - c, G = r.height - w, k = r.width - p, Y = r.height - b, z = e.borderTopWidth, iA = e.borderRightWidth, j = e.borderBottomWidth, N = e.borderLeftWidth, Z = De(e.paddingTop, A.bounds.width), E = De(e.paddingRight, A.bounds.width), I = De(e.paddingBottom, A.bounds.width), K = De(e.paddingLeft, A.bounds.width);
      this.topLeftBorderDoubleOuterBox = i > 0 || o > 0 ? Me(r.left + N / 3, r.top + z / 3, i - N / 3, o - z / 3, Fe.TOP_LEFT) : new EA(r.left + N / 3, r.top + z / 3), this.topRightBorderDoubleOuterBox = i > 0 || o > 0 ? Me(r.left + P, r.top + z / 3, c - iA / 3, u - z / 3, Fe.TOP_RIGHT) : new EA(r.left + r.width - iA / 3, r.top + z / 3), this.bottomRightBorderDoubleOuterBox = p > 0 || w > 0 ? Me(r.left + k, r.top + G, p - iA / 3, w - j / 3, Fe.BOTTOM_RIGHT) : new EA(r.left + r.width - iA / 3, r.top + r.height - j / 3), this.bottomLeftBorderDoubleOuterBox = y > 0 || b > 0 ? Me(r.left + N / 3, r.top + Y, y - N / 3, b - j / 3, Fe.BOTTOM_LEFT) : new EA(r.left + N / 3, r.top + r.height - j / 3), this.topLeftBorderDoubleInnerBox = i > 0 || o > 0 ? Me(r.left + N * 2 / 3, r.top + z * 2 / 3, i - N * 2 / 3, o - z * 2 / 3, Fe.TOP_LEFT) : new EA(r.left + N * 2 / 3, r.top + z * 2 / 3), this.topRightBorderDoubleInnerBox = i > 0 || o > 0 ? Me(r.left + P, r.top + z * 2 / 3, c - iA * 2 / 3, u - z * 2 / 3, Fe.TOP_RIGHT) : new EA(r.left + r.width - iA * 2 / 3, r.top + z * 2 / 3), this.bottomRightBorderDoubleInnerBox = p > 0 || w > 0 ? Me(r.left + k, r.top + G, p - iA * 2 / 3, w - j * 2 / 3, Fe.BOTTOM_RIGHT) : new EA(r.left + r.width - iA * 2 / 3, r.top + r.height - j * 2 / 3), this.bottomLeftBorderDoubleInnerBox = y > 0 || b > 0 ? Me(r.left + N * 2 / 3, r.top + Y, y - N * 2 / 3, b - j * 2 / 3, Fe.BOTTOM_LEFT) : new EA(r.left + N * 2 / 3, r.top + r.height - j * 2 / 3), this.topLeftBorderStroke = i > 0 || o > 0 ? Me(r.left + N / 2, r.top + z / 2, i - N / 2, o - z / 2, Fe.TOP_LEFT) : new EA(r.left + N / 2, r.top + z / 2), this.topRightBorderStroke = i > 0 || o > 0 ? Me(r.left + P, r.top + z / 2, c - iA / 2, u - z / 2, Fe.TOP_RIGHT) : new EA(r.left + r.width - iA / 2, r.top + z / 2), this.bottomRightBorderStroke = p > 0 || w > 0 ? Me(r.left + k, r.top + G, p - iA / 2, w - j / 2, Fe.BOTTOM_RIGHT) : new EA(r.left + r.width - iA / 2, r.top + r.height - j / 2), this.bottomLeftBorderStroke = y > 0 || b > 0 ? Me(r.left + N / 2, r.top + Y, y - N / 2, b - j / 2, Fe.BOTTOM_LEFT) : new EA(r.left + N / 2, r.top + r.height - j / 2), this.topLeftBorderBox = i > 0 || o > 0 ? Me(r.left, r.top, i, o, Fe.TOP_LEFT) : new EA(r.left, r.top), this.topRightBorderBox = c > 0 || u > 0 ? Me(r.left + P, r.top, c, u, Fe.TOP_RIGHT) : new EA(r.left + r.width, r.top), this.bottomRightBorderBox = p > 0 || w > 0 ? Me(r.left + k, r.top + G, p, w, Fe.BOTTOM_RIGHT) : new EA(r.left + r.width, r.top + r.height), this.bottomLeftBorderBox = y > 0 || b > 0 ? Me(r.left, r.top + Y, y, b, Fe.BOTTOM_LEFT) : new EA(r.left, r.top + r.height), this.topLeftPaddingBox = i > 0 || o > 0 ? Me(r.left + N, r.top + z, Math.max(0, i - N), Math.max(0, o - z), Fe.TOP_LEFT) : new EA(r.left + N, r.top + z), this.topRightPaddingBox = c > 0 || u > 0 ? Me(r.left + Math.min(P, r.width - iA), r.top + z, P > r.width + iA ? 0 : Math.max(0, c - iA), Math.max(0, u - z), Fe.TOP_RIGHT) : new EA(r.left + r.width - iA, r.top + z), this.bottomRightPaddingBox = p > 0 || w > 0 ? Me(r.left + Math.min(k, r.width - N), r.top + Math.min(G, r.height - j), Math.max(0, p - iA), Math.max(0, w - j), Fe.BOTTOM_RIGHT) : new EA(r.left + r.width - iA, r.top + r.height - j), this.bottomLeftPaddingBox = y > 0 || b > 0 ? Me(r.left + N, r.top + Math.min(Y, r.height - j), Math.max(0, y - N), Math.max(0, b - j), Fe.BOTTOM_LEFT) : new EA(r.left + N, r.top + r.height - j), this.topLeftContentBox = i > 0 || o > 0 ? Me(r.left + N + K, r.top + z + Z, Math.max(0, i - (N + K)), Math.max(0, o - (z + Z)), Fe.TOP_LEFT) : new EA(r.left + N + K, r.top + z + Z), this.topRightContentBox = c > 0 || u > 0 ? Me(r.left + Math.min(P, r.width + N + K), r.top + z + Z, P > r.width + N + K ? 0 : c - N + K, u - (z + Z), Fe.TOP_RIGHT) : new EA(r.left + r.width - (iA + E), r.top + z + Z), this.bottomRightContentBox = p > 0 || w > 0 ? Me(r.left + Math.min(k, r.width - (N + K)), r.top + Math.min(G, r.height + z + Z), Math.max(0, p - (iA + E)), w - (j + I), Fe.BOTTOM_RIGHT) : new EA(r.left + r.width - (iA + E), r.top + r.height - (j + I)), this.bottomLeftContentBox = y > 0 || b > 0 ? Me(r.left + N + K, r.top + Y, Math.max(0, y - (N + K)), b - (j + I), Fe.BOTTOM_LEFT) : new EA(r.left + N + K, r.top + r.height - (j + I));
    }
    return t;
  })()
), Fe;
(function(t) {
  t[t.TOP_LEFT = 0] = "TOP_LEFT", t[t.TOP_RIGHT = 1] = "TOP_RIGHT", t[t.BOTTOM_RIGHT = 2] = "BOTTOM_RIGHT", t[t.BOTTOM_LEFT = 3] = "BOTTOM_LEFT";
})(Fe || (Fe = {}));
var Me = function(t, A, e, r, n) {
  var i = 4 * ((Math.sqrt(2) - 1) / 3), o = e * i, s = r * i, c = t + e, u = A + r;
  switch (n) {
    case Fe.TOP_LEFT:
      return new io(new EA(t, u), new EA(t, u - s), new EA(c - o, A), new EA(c, A));
    case Fe.TOP_RIGHT:
      return new io(new EA(t, A), new EA(t + o, A), new EA(c, u - s), new EA(c, u));
    case Fe.BOTTOM_RIGHT:
      return new io(new EA(c, A), new EA(c, A + s), new EA(t + o, u), new EA(t, u));
    case Fe.BOTTOM_LEFT:
    default:
      return new io(new EA(c, u), new EA(c - o, u), new EA(t, A + s), new EA(t, A));
  }
}, To = function(t) {
  return [t.topLeftBorderBox, t.topRightBorderBox, t.bottomRightBorderBox, t.bottomLeftBorderBox];
}, Pw = function(t) {
  return [
    t.topLeftContentBox,
    t.topRightContentBox,
    t.bottomRightContentBox,
    t.bottomLeftContentBox
  ];
}, Oo = function(t) {
  return [
    t.topLeftPaddingBox,
    t.topRightPaddingBox,
    t.bottomRightPaddingBox,
    t.bottomLeftPaddingBox
  ];
}, Mw = (
  /** @class */
  /* @__PURE__ */ (function() {
    function t(A, e, r) {
      this.offsetX = A, this.offsetY = e, this.matrix = r, this.type = 0, this.target = 6;
    }
    return t;
  })()
), ao = (
  /** @class */
  /* @__PURE__ */ (function() {
    function t(A, e) {
      this.path = A, this.target = e, this.type = 1;
    }
    return t;
  })()
), Kw = (
  /** @class */
  /* @__PURE__ */ (function() {
    function t(A) {
      this.opacity = A, this.type = 2, this.target = 6;
    }
    return t;
  })()
), Rw = function(t) {
  return t.type === 0;
}, s1 = function(t) {
  return t.type === 1;
}, Gw = function(t) {
  return t.type === 2;
}, Wf = function(t, A) {
  return t.length === A.length ? t.some(function(e, r) {
    return e === A[r];
  }) : !1;
}, Vw = function(t, A, e, r, n) {
  return t.map(function(i, o) {
    switch (o) {
      case 0:
        return i.add(A, e);
      case 1:
        return i.add(A + r, e);
      case 2:
        return i.add(A + r, e + n);
      case 3:
        return i.add(A, e + n);
    }
    return i;
  });
}, o1 = (
  /** @class */
  /* @__PURE__ */ (function() {
    function t(A) {
      this.element = A, this.inlineLevel = [], this.nonInlineLevel = [], this.negativeZIndex = [], this.zeroOrAutoZIndexOrTransformedOrOpacity = [], this.positiveZIndex = [], this.nonPositionedFloats = [], this.nonPositionedInlineLevel = [];
    }
    return t;
  })()
), c1 = (
  /** @class */
  (function() {
    function t(A, e) {
      if (this.container = A, this.parent = e, this.effects = [], this.curves = new kw(this.container), this.container.styles.opacity < 1 && this.effects.push(new Kw(this.container.styles.opacity)), this.container.styles.transform !== null) {
        var r = this.container.bounds.left + this.container.styles.transformOrigin[0].number, n = this.container.bounds.top + this.container.styles.transformOrigin[1].number, i = this.container.styles.transform;
        this.effects.push(new Mw(r, n, i));
      }
      if (this.container.styles.overflowX !== 0) {
        var o = To(this.curves), s = Oo(this.curves);
        Wf(o, s) ? this.effects.push(new ao(
          o,
          6
          /* CONTENT */
        )) : (this.effects.push(new ao(
          o,
          2
          /* BACKGROUND_BORDERS */
        )), this.effects.push(new ao(
          s,
          4
          /* CONTENT */
        )));
      }
    }
    return t.prototype.getEffects = function(A) {
      for (var e = [
        2,
        3
        /* FIXED */
      ].indexOf(this.container.styles.position) === -1, r = this.parent, n = this.effects.slice(0); r; ) {
        var i = r.effects.filter(function(c) {
          return !s1(c);
        });
        if (e || r.container.styles.position !== 0 || !r.parent) {
          if (n.unshift.apply(n, i), e = [
            2,
            3
            /* FIXED */
          ].indexOf(r.container.styles.position) === -1, r.container.styles.overflowX !== 0) {
            var o = To(r.curves), s = Oo(r.curves);
            Wf(o, s) || n.unshift(new ao(
              s,
              6
              /* CONTENT */
            ));
          }
        } else
          n.unshift.apply(n, i);
        r = r.parent;
      }
      return n.filter(function(c) {
        return ht(c.target, A);
      });
    }, t;
  })()
), Gl = function(t, A, e, r) {
  t.container.elements.forEach(function(n) {
    var i = ht(
      n.flags,
      4
      /* CREATES_REAL_STACKING_CONTEXT */
    ), o = ht(
      n.flags,
      2
      /* CREATES_STACKING_CONTEXT */
    ), s = new c1(n, t);
    ht(
      n.styles.display,
      2048
      /* LIST_ITEM */
    ) && r.push(s);
    var c = ht(
      n.flags,
      8
      /* IS_LIST_OWNER */
    ) ? [] : r;
    if (i || o) {
      var u = i || n.styles.isPositioned() ? e : A, h = new o1(s);
      if (n.styles.isPositioned() || n.styles.opacity < 1 || n.styles.isTransformed()) {
        var p = n.styles.zIndex.order;
        if (p < 0) {
          var w = 0;
          u.negativeZIndex.some(function(y, b) {
            return p > y.element.container.styles.zIndex.order ? (w = b, !1) : w > 0;
          }), u.negativeZIndex.splice(w, 0, h);
        } else if (p > 0) {
          var d = 0;
          u.positiveZIndex.some(function(y, b) {
            return p >= y.element.container.styles.zIndex.order ? (d = b + 1, !1) : d > 0;
          }), u.positiveZIndex.splice(d, 0, h);
        } else
          u.zeroOrAutoZIndexOrTransformedOrOpacity.push(h);
      } else
        n.styles.isFloating() ? u.nonPositionedFloats.push(h) : u.nonPositionedInlineLevel.push(h);
      Gl(s, h, i ? h : e, c);
    } else
      n.styles.isInlineLevel() ? A.inlineLevel.push(s) : A.nonInlineLevel.push(s), Gl(s, A, e, c);
    ht(
      n.flags,
      8
      /* IS_LIST_OWNER */
    ) && l1(n, c);
  });
}, l1 = function(t, A) {
  for (var e = t instanceof kl ? t.start : 1, r = t instanceof kl ? t.reversed : !1, n = 0; n < A.length; n++) {
    var i = A[n];
    i.container instanceof W0 && typeof i.container.value == "number" && i.container.value !== 0 && (e = i.container.value), i.listValue = Za(e, i.container.styles.listStyleType, !0), e += r ? -1 : 1;
  }
}, jw = function(t) {
  var A = new c1(t, null), e = new o1(A), r = [];
  return Gl(A, e, e, r), l1(A.container, r), e;
}, Xf = function(t, A) {
  switch (A) {
    case 0:
      return ur(t.topLeftBorderBox, t.topLeftPaddingBox, t.topRightBorderBox, t.topRightPaddingBox);
    case 1:
      return ur(t.topRightBorderBox, t.topRightPaddingBox, t.bottomRightBorderBox, t.bottomRightPaddingBox);
    case 2:
      return ur(t.bottomRightBorderBox, t.bottomRightPaddingBox, t.bottomLeftBorderBox, t.bottomLeftPaddingBox);
    case 3:
    default:
      return ur(t.bottomLeftBorderBox, t.bottomLeftPaddingBox, t.topLeftBorderBox, t.topLeftPaddingBox);
  }
}, qw = function(t, A) {
  switch (A) {
    case 0:
      return ur(t.topLeftBorderBox, t.topLeftBorderDoubleOuterBox, t.topRightBorderBox, t.topRightBorderDoubleOuterBox);
    case 1:
      return ur(t.topRightBorderBox, t.topRightBorderDoubleOuterBox, t.bottomRightBorderBox, t.bottomRightBorderDoubleOuterBox);
    case 2:
      return ur(t.bottomRightBorderBox, t.bottomRightBorderDoubleOuterBox, t.bottomLeftBorderBox, t.bottomLeftBorderDoubleOuterBox);
    case 3:
    default:
      return ur(t.bottomLeftBorderBox, t.bottomLeftBorderDoubleOuterBox, t.topLeftBorderBox, t.topLeftBorderDoubleOuterBox);
  }
}, Ww = function(t, A) {
  switch (A) {
    case 0:
      return ur(t.topLeftBorderDoubleInnerBox, t.topLeftPaddingBox, t.topRightBorderDoubleInnerBox, t.topRightPaddingBox);
    case 1:
      return ur(t.topRightBorderDoubleInnerBox, t.topRightPaddingBox, t.bottomRightBorderDoubleInnerBox, t.bottomRightPaddingBox);
    case 2:
      return ur(t.bottomRightBorderDoubleInnerBox, t.bottomRightPaddingBox, t.bottomLeftBorderDoubleInnerBox, t.bottomLeftPaddingBox);
    case 3:
    default:
      return ur(t.bottomLeftBorderDoubleInnerBox, t.bottomLeftPaddingBox, t.topLeftBorderDoubleInnerBox, t.topLeftPaddingBox);
  }
}, Xw = function(t, A) {
  switch (A) {
    case 0:
      return so(t.topLeftBorderStroke, t.topRightBorderStroke);
    case 1:
      return so(t.topRightBorderStroke, t.bottomRightBorderStroke);
    case 2:
      return so(t.bottomRightBorderStroke, t.bottomLeftBorderStroke);
    case 3:
    default:
      return so(t.bottomLeftBorderStroke, t.topLeftBorderStroke);
  }
}, so = function(t, A) {
  var e = [];
  return cr(t) ? e.push(t.subdivide(0.5, !1)) : e.push(t), cr(A) ? e.push(A.subdivide(0.5, !0)) : e.push(A), e;
}, ur = function(t, A, e, r) {
  var n = [];
  return cr(t) ? n.push(t.subdivide(0.5, !1)) : n.push(t), cr(e) ? n.push(e.subdivide(0.5, !0)) : n.push(e), cr(r) ? n.push(r.subdivide(0.5, !0).reverse()) : n.push(r), cr(A) ? n.push(A.subdivide(0.5, !1).reverse()) : n.push(A), n;
}, u1 = function(t) {
  var A = t.bounds, e = t.styles;
  return A.add(e.borderLeftWidth, e.borderTopWidth, -(e.borderRightWidth + e.borderLeftWidth), -(e.borderTopWidth + e.borderBottomWidth));
}, ko = function(t) {
  var A = t.styles, e = t.bounds, r = De(A.paddingLeft, e.width), n = De(A.paddingRight, e.width), i = De(A.paddingTop, e.width), o = De(A.paddingBottom, e.width);
  return e.add(r + A.borderLeftWidth, i + A.borderTopWidth, -(A.borderRightWidth + A.borderLeftWidth + r + n), -(A.borderTopWidth + A.borderBottomWidth + i + o));
}, Jw = function(t, A) {
  return t === 0 ? A.bounds : t === 2 ? ko(A) : u1(A);
}, Yw = function(t, A) {
  return t === 0 ? A.bounds : t === 2 ? ko(A) : u1(A);
}, $c = function(t, A, e) {
  var r = Jw(Gi(t.styles.backgroundOrigin, A), t), n = Yw(Gi(t.styles.backgroundClip, A), t), i = zw(Gi(t.styles.backgroundSize, A), e, r), o = i[0], s = i[1], c = Ma(Gi(t.styles.backgroundPosition, A), r.width - o, r.height - s), u = Zw(Gi(t.styles.backgroundRepeat, A), c, i, r, n), h = Math.round(r.left + c[0]), p = Math.round(r.top + c[1]);
  return [u, h, p, o, s];
}, ki = function(t) {
  return Le(t) && t.value === Xi.AUTO;
}, oo = function(t) {
  return typeof t == "number";
}, zw = function(t, A, e) {
  var r = A[0], n = A[1], i = A[2], o = t[0], s = t[1];
  if (!o)
    return [0, 0];
  if (at(o) && s && at(s))
    return [De(o, e.width), De(s, e.height)];
  var c = oo(i);
  if (Le(o) && (o.value === Xi.CONTAIN || o.value === Xi.COVER)) {
    if (oo(i)) {
      var u = e.width / e.height;
      return u < i != (o.value === Xi.COVER) ? [e.width, e.width / i] : [e.height * i, e.height];
    }
    return [e.width, e.height];
  }
  var h = oo(r), p = oo(n), w = h || p;
  if (ki(o) && (!s || ki(s))) {
    if (h && p)
      return [r, n];
    if (!c && !w)
      return [e.width, e.height];
    if (w && c) {
      var d = h ? r : n * i, y = p ? n : r / i;
      return [d, y];
    }
    var b = h ? r : e.width, S = p ? n : e.height;
    return [b, S];
  }
  if (c) {
    var Q = 0, P = 0;
    return at(o) ? Q = De(o, e.width) : at(s) && (P = De(s, e.height)), ki(o) ? Q = P * i : (!s || ki(s)) && (P = Q / i), [Q, P];
  }
  var G = null, k = null;
  if (at(o) ? G = De(o, e.width) : s && at(s) && (k = De(s, e.height)), G !== null && (!s || ki(s)) && (k = h && p ? G / r * n : e.height), k !== null && ki(o) && (G = h && p ? k / n * r : e.width), G !== null && k !== null)
    return [G, k];
  throw new Error("Unable to calculate background-size for element");
}, Gi = function(t, A) {
  var e = t[A];
  return typeof e > "u" ? t[0] : e;
}, Zw = function(t, A, e, r, n) {
  var i = A[0], o = A[1], s = e[0], c = e[1];
  switch (t) {
    case 2:
      return [
        new EA(Math.round(r.left), Math.round(r.top + o)),
        new EA(Math.round(r.left + r.width), Math.round(r.top + o)),
        new EA(Math.round(r.left + r.width), Math.round(c + r.top + o)),
        new EA(Math.round(r.left), Math.round(c + r.top + o))
      ];
    case 3:
      return [
        new EA(Math.round(r.left + i), Math.round(r.top)),
        new EA(Math.round(r.left + i + s), Math.round(r.top)),
        new EA(Math.round(r.left + i + s), Math.round(r.height + r.top)),
        new EA(Math.round(r.left + i), Math.round(r.height + r.top))
      ];
    case 1:
      return [
        new EA(Math.round(r.left + i), Math.round(r.top + o)),
        new EA(Math.round(r.left + i + s), Math.round(r.top + o)),
        new EA(Math.round(r.left + i + s), Math.round(r.top + o + c)),
        new EA(Math.round(r.left + i), Math.round(r.top + o + c))
      ];
    default:
      return [
        new EA(Math.round(n.left), Math.round(n.top)),
        new EA(Math.round(n.left + n.width), Math.round(n.top)),
        new EA(Math.round(n.left + n.width), Math.round(n.height + n.top)),
        new EA(Math.round(n.left), Math.round(n.height + n.top))
      ];
  }
}, $w = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7", Jf = "Hidden Text", A5 = (
  /** @class */
  (function() {
    function t(A) {
      this._data = {}, this._document = A;
    }
    return t.prototype.parseMetrics = function(A, e) {
      var r = this._document.createElement("div"), n = this._document.createElement("img"), i = this._document.createElement("span"), o = this._document.body;
      r.style.visibility = "hidden", r.style.fontFamily = A, r.style.fontSize = e, r.style.margin = "0", r.style.padding = "0", r.style.whiteSpace = "nowrap", o.appendChild(r), n.src = $w, n.width = 1, n.height = 1, n.style.margin = "0", n.style.padding = "0", n.style.verticalAlign = "baseline", i.style.fontFamily = A, i.style.fontSize = e, i.style.margin = "0", i.style.padding = "0", i.appendChild(this._document.createTextNode(Jf)), r.appendChild(i), r.appendChild(n);
      var s = n.offsetTop - i.offsetTop + 2;
      r.removeChild(i), r.appendChild(this._document.createTextNode(Jf)), r.style.lineHeight = "normal", n.style.verticalAlign = "super";
      var c = n.offsetTop - r.offsetTop + 2;
      return o.removeChild(r), { baseline: s, middle: c };
    }, t.prototype.getMetrics = function(A, e) {
      var r = A + " " + e;
      return typeof this._data[r] > "u" && (this._data[r] = this.parseMetrics(A, e)), this._data[r];
    }, t;
  })()
), f1 = (
  /** @class */
  /* @__PURE__ */ (function() {
    function t(A, e) {
      this.context = A, this.options = e;
    }
    return t;
  })()
), e5 = 1e4, t5 = (
  /** @class */
  (function(t) {
    Ur(A, t);
    function A(e, r) {
      var n = t.call(this, e, r) || this;
      return n._activeEffects = [], n.canvas = r.canvas ? r.canvas : document.createElement("canvas"), n.ctx = n.canvas.getContext("2d"), r.canvas || (n.canvas.width = Math.floor(r.width * r.scale), n.canvas.height = Math.floor(r.height * r.scale), n.canvas.style.width = r.width + "px", n.canvas.style.height = r.height + "px"), n.fontMetrics = new A5(document), n.ctx.scale(n.options.scale, n.options.scale), n.ctx.translate(-r.x, -r.y), n.ctx.textBaseline = "bottom", n._activeEffects = [], n.context.logger.debug("Canvas renderer initialized (" + r.width + "x" + r.height + ") with scale " + r.scale), n;
    }
    return A.prototype.applyEffects = function(e) {
      for (var r = this; this._activeEffects.length; )
        this.popEffect();
      e.forEach(function(n) {
        return r.applyEffect(n);
      });
    }, A.prototype.applyEffect = function(e) {
      this.ctx.save(), Gw(e) && (this.ctx.globalAlpha = e.opacity), Rw(e) && (this.ctx.translate(e.offsetX, e.offsetY), this.ctx.transform(e.matrix[0], e.matrix[1], e.matrix[2], e.matrix[3], e.matrix[4], e.matrix[5]), this.ctx.translate(-e.offsetX, -e.offsetY)), s1(e) && (this.path(e.path), this.ctx.clip()), this._activeEffects.push(e);
    }, A.prototype.popEffect = function() {
      this._activeEffects.pop(), this.ctx.restore();
    }, A.prototype.renderStack = function(e) {
      return Ot(this, void 0, void 0, function() {
        var r;
        return St(this, function(n) {
          switch (n.label) {
            case 0:
              return r = e.element.container.styles, r.isVisible() ? [4, this.renderStackContent(e)] : [3, 2];
            case 1:
              n.sent(), n.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, A.prototype.renderNode = function(e) {
      return Ot(this, void 0, void 0, function() {
        return St(this, function(r) {
          switch (r.label) {
            case 0:
              if (ht(
                e.container.flags,
                16
                /* DEBUG_RENDER */
              ))
                debugger;
              return e.container.styles.isVisible() ? [4, this.renderNodeBackgroundAndBorders(e)] : [3, 3];
            case 1:
              return r.sent(), [4, this.renderNodeContent(e)];
            case 2:
              r.sent(), r.label = 3;
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, A.prototype.renderTextWithLetterSpacing = function(e, r, n) {
      var i = this;
      if (r === 0)
        this.ctx.fillText(e.text, e.bounds.left, e.bounds.top + n);
      else {
        var o = iu(e.text);
        o.reduce(function(s, c) {
          return i.ctx.fillText(c, s, e.bounds.top + n), s + i.ctx.measureText(c).width;
        }, e.bounds.left);
      }
    }, A.prototype.createFontStyle = function(e) {
      var r = e.fontVariant.filter(function(o) {
        return o === "normal" || o === "small-caps";
      }).join(""), n = s5(e.fontFamily).join(", "), i = ts(e.fontSize) ? "" + e.fontSize.number + e.fontSize.unit : e.fontSize.number + "px";
      return [
        [e.fontStyle, r, e.fontWeight, i, n].join(" "),
        n,
        i
      ];
    }, A.prototype.renderTextNode = function(e, r) {
      return Ot(this, void 0, void 0, function() {
        var n, i, o, s, c, u, h, p, w = this;
        return St(this, function(d) {
          return n = this.createFontStyle(r), i = n[0], o = n[1], s = n[2], this.ctx.font = i, this.ctx.direction = r.direction === 1 ? "rtl" : "ltr", this.ctx.textAlign = "left", this.ctx.textBaseline = "alphabetic", c = this.fontMetrics.getMetrics(o, s), u = c.baseline, h = c.middle, p = r.paintOrder, e.textBounds.forEach(function(y) {
            p.forEach(function(b) {
              switch (b) {
                case 0:
                  w.ctx.fillStyle = dt(r.color), w.renderTextWithLetterSpacing(y, r.letterSpacing, u);
                  var S = r.textShadow;
                  S.length && y.text.trim().length && (S.slice(0).reverse().forEach(function(Q) {
                    w.ctx.shadowColor = dt(Q.color), w.ctx.shadowOffsetX = Q.offsetX.number * w.options.scale, w.ctx.shadowOffsetY = Q.offsetY.number * w.options.scale, w.ctx.shadowBlur = Q.blur.number, w.renderTextWithLetterSpacing(y, r.letterSpacing, u);
                  }), w.ctx.shadowColor = "", w.ctx.shadowOffsetX = 0, w.ctx.shadowOffsetY = 0, w.ctx.shadowBlur = 0), r.textDecorationLine.length && (w.ctx.fillStyle = dt(r.textDecorationColor || r.color), r.textDecorationLine.forEach(function(Q) {
                    switch (Q) {
                      case 1:
                        w.ctx.fillRect(y.bounds.left, Math.round(y.bounds.top + u), y.bounds.width, 1);
                        break;
                      case 2:
                        w.ctx.fillRect(y.bounds.left, Math.round(y.bounds.top), y.bounds.width, 1);
                        break;
                      case 3:
                        w.ctx.fillRect(y.bounds.left, Math.ceil(y.bounds.top + h), y.bounds.width, 1);
                        break;
                    }
                  }));
                  break;
                case 1:
                  r.webkitTextStrokeWidth && y.text.trim().length && (w.ctx.strokeStyle = dt(r.webkitTextStrokeColor), w.ctx.lineWidth = r.webkitTextStrokeWidth, w.ctx.lineJoin = window.chrome ? "miter" : "round", w.ctx.strokeText(y.text, y.bounds.left, y.bounds.top + u)), w.ctx.strokeStyle = "", w.ctx.lineWidth = 0, w.ctx.lineJoin = "miter";
                  break;
              }
            });
          }), [
            2
            /*return*/
          ];
        });
      });
    }, A.prototype.renderReplacedElement = function(e, r, n) {
      if (n && e.intrinsicWidth > 0 && e.intrinsicHeight > 0) {
        var i = ko(e), o = Oo(r);
        this.path(o), this.ctx.save(), this.ctx.clip(), this.ctx.drawImage(n, 0, 0, e.intrinsicWidth, e.intrinsicHeight, i.left, i.top, i.width, i.height), this.ctx.restore();
      }
    }, A.prototype.renderNodeContent = function(e) {
      return Ot(this, void 0, void 0, function() {
        var r, n, i, o, s, c, P, P, u, h, p, w, k, d, y, Y, b, S, Q, P, G, k, Y;
        return St(this, function(z) {
          switch (z.label) {
            case 0:
              this.applyEffects(e.getEffects(
                4
                /* CONTENT */
              )), r = e.container, n = e.curves, i = r.styles, o = 0, s = r.textNodes, z.label = 1;
            case 1:
              return o < s.length ? (c = s[o], [4, this.renderTextNode(c, i)]) : [3, 4];
            case 2:
              z.sent(), z.label = 3;
            case 3:
              return o++, [3, 1];
            case 4:
              if (!(r instanceof V0)) return [3, 8];
              z.label = 5;
            case 5:
              return z.trys.push([5, 7, , 8]), [4, this.context.cache.match(r.src)];
            case 6:
              return P = z.sent(), this.renderReplacedElement(r, n, P), [3, 8];
            case 7:
              return z.sent(), this.context.logger.error("Error loading image " + r.src), [3, 8];
            case 8:
              if (r instanceof j0 && this.renderReplacedElement(r, n, r.canvas), !(r instanceof q0)) return [3, 12];
              z.label = 9;
            case 9:
              return z.trys.push([9, 11, , 12]), [4, this.context.cache.match(r.svg)];
            case 10:
              return P = z.sent(), this.renderReplacedElement(r, n, P), [3, 12];
            case 11:
              return z.sent(), this.context.logger.error("Error loading svg " + r.svg.substring(0, 255)), [3, 12];
            case 12:
              return r instanceof Y0 && r.tree ? (u = new A(this.context, {
                scale: this.options.scale,
                backgroundColor: r.backgroundColor,
                x: 0,
                y: 0,
                width: r.width,
                height: r.height
              }), [4, u.render(r.tree)]) : [3, 14];
            case 13:
              h = z.sent(), r.width && r.height && this.ctx.drawImage(h, 0, 0, r.width, r.height, r.bounds.left, r.bounds.top, r.bounds.width, r.bounds.height), z.label = 14;
            case 14:
              if (r instanceof au && (p = Math.min(r.bounds.width, r.bounds.height), r.type === Ho ? r.checked && (this.ctx.save(), this.path([
                new EA(r.bounds.left + p * 0.39363, r.bounds.top + p * 0.79),
                new EA(r.bounds.left + p * 0.16, r.bounds.top + p * 0.5549),
                new EA(r.bounds.left + p * 0.27347, r.bounds.top + p * 0.44071),
                new EA(r.bounds.left + p * 0.39694, r.bounds.top + p * 0.5649),
                new EA(r.bounds.left + p * 0.72983, r.bounds.top + p * 0.23),
                new EA(r.bounds.left + p * 0.84, r.bounds.top + p * 0.34085),
                new EA(r.bounds.left + p * 0.39363, r.bounds.top + p * 0.79)
              ]), this.ctx.fillStyle = dt(Tf), this.ctx.fill(), this.ctx.restore()) : r.type === No && r.checked && (this.ctx.save(), this.ctx.beginPath(), this.ctx.arc(r.bounds.left + p / 2, r.bounds.top + p / 2, p / 4, 0, Math.PI * 2, !0), this.ctx.fillStyle = dt(Tf), this.ctx.fill(), this.ctx.restore())), r5(r) && r.value.length) {
                switch (w = this.createFontStyle(i), k = w[0], d = w[1], y = this.fontMetrics.getMetrics(k, d).baseline, this.ctx.font = k, this.ctx.fillStyle = dt(i.color), this.ctx.textBaseline = "alphabetic", this.ctx.textAlign = i5(r.styles.textAlign), Y = ko(r), b = 0, r.styles.textAlign) {
                  case 1:
                    b += Y.width / 2;
                    break;
                  case 2:
                    b += Y.width;
                    break;
                }
                S = Y.add(b, 0, 0, -Y.height / 2 + 1), this.ctx.save(), this.path([
                  new EA(Y.left, Y.top),
                  new EA(Y.left + Y.width, Y.top),
                  new EA(Y.left + Y.width, Y.top + Y.height),
                  new EA(Y.left, Y.top + Y.height)
                ]), this.ctx.clip(), this.renderTextWithLetterSpacing(new qa(r.value, S), i.letterSpacing, y), this.ctx.restore(), this.ctx.textBaseline = "alphabetic", this.ctx.textAlign = "left";
              }
              if (!ht(
                r.styles.display,
                2048
                /* LIST_ITEM */
              )) return [3, 20];
              if (r.styles.listStyleImage === null) return [3, 19];
              if (Q = r.styles.listStyleImage, Q.type !== 0) return [3, 18];
              P = void 0, G = Q.url, z.label = 15;
            case 15:
              return z.trys.push([15, 17, , 18]), [4, this.context.cache.match(G)];
            case 16:
              return P = z.sent(), this.ctx.drawImage(P, r.bounds.left - (P.width + 10), r.bounds.top), [3, 18];
            case 17:
              return z.sent(), this.context.logger.error("Error loading list-style-image " + G), [3, 18];
            case 18:
              return [3, 20];
            case 19:
              e.listValue && r.styles.listStyleType !== -1 && (k = this.createFontStyle(i)[0], this.ctx.font = k, this.ctx.fillStyle = dt(i.color), this.ctx.textBaseline = "middle", this.ctx.textAlign = "right", Y = new Bn(r.bounds.left, r.bounds.top + De(r.styles.paddingTop, r.bounds.width), r.bounds.width, vf(i.lineHeight, i.fontSize.number) / 2 + 1), this.renderTextWithLetterSpacing(new qa(e.listValue, Y), i.letterSpacing, vf(i.lineHeight, i.fontSize.number) / 2 + 2), this.ctx.textBaseline = "bottom", this.ctx.textAlign = "left"), z.label = 20;
            case 20:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, A.prototype.renderStackContent = function(e) {
      return Ot(this, void 0, void 0, function() {
        var r, n, Q, i, o, Q, s, c, Q, u, h, Q, p, w, Q, d, y, Q, b, S, Q;
        return St(this, function(P) {
          switch (P.label) {
            case 0:
              if (ht(
                e.element.container.flags,
                16
                /* DEBUG_RENDER */
              ))
                debugger;
              return [4, this.renderNodeBackgroundAndBorders(e.element)];
            case 1:
              P.sent(), r = 0, n = e.negativeZIndex, P.label = 2;
            case 2:
              return r < n.length ? (Q = n[r], [4, this.renderStack(Q)]) : [3, 5];
            case 3:
              P.sent(), P.label = 4;
            case 4:
              return r++, [3, 2];
            case 5:
              return [4, this.renderNodeContent(e.element)];
            case 6:
              P.sent(), i = 0, o = e.nonInlineLevel, P.label = 7;
            case 7:
              return i < o.length ? (Q = o[i], [4, this.renderNode(Q)]) : [3, 10];
            case 8:
              P.sent(), P.label = 9;
            case 9:
              return i++, [3, 7];
            case 10:
              s = 0, c = e.nonPositionedFloats, P.label = 11;
            case 11:
              return s < c.length ? (Q = c[s], [4, this.renderStack(Q)]) : [3, 14];
            case 12:
              P.sent(), P.label = 13;
            case 13:
              return s++, [3, 11];
            case 14:
              u = 0, h = e.nonPositionedInlineLevel, P.label = 15;
            case 15:
              return u < h.length ? (Q = h[u], [4, this.renderStack(Q)]) : [3, 18];
            case 16:
              P.sent(), P.label = 17;
            case 17:
              return u++, [3, 15];
            case 18:
              p = 0, w = e.inlineLevel, P.label = 19;
            case 19:
              return p < w.length ? (Q = w[p], [4, this.renderNode(Q)]) : [3, 22];
            case 20:
              P.sent(), P.label = 21;
            case 21:
              return p++, [3, 19];
            case 22:
              d = 0, y = e.zeroOrAutoZIndexOrTransformedOrOpacity, P.label = 23;
            case 23:
              return d < y.length ? (Q = y[d], [4, this.renderStack(Q)]) : [3, 26];
            case 24:
              P.sent(), P.label = 25;
            case 25:
              return d++, [3, 23];
            case 26:
              b = 0, S = e.positiveZIndex, P.label = 27;
            case 27:
              return b < S.length ? (Q = S[b], [4, this.renderStack(Q)]) : [3, 30];
            case 28:
              P.sent(), P.label = 29;
            case 29:
              return b++, [3, 27];
            case 30:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, A.prototype.mask = function(e) {
      this.ctx.beginPath(), this.ctx.moveTo(0, 0), this.ctx.lineTo(this.canvas.width, 0), this.ctx.lineTo(this.canvas.width, this.canvas.height), this.ctx.lineTo(0, this.canvas.height), this.ctx.lineTo(0, 0), this.formatPath(e.slice(0).reverse()), this.ctx.closePath();
    }, A.prototype.path = function(e) {
      this.ctx.beginPath(), this.formatPath(e), this.ctx.closePath();
    }, A.prototype.formatPath = function(e) {
      var r = this;
      e.forEach(function(n, i) {
        var o = cr(n) ? n.start : n;
        i === 0 ? r.ctx.moveTo(o.x, o.y) : r.ctx.lineTo(o.x, o.y), cr(n) && r.ctx.bezierCurveTo(n.startControl.x, n.startControl.y, n.endControl.x, n.endControl.y, n.end.x, n.end.y);
      });
    }, A.prototype.renderRepeat = function(e, r, n, i) {
      this.path(e), this.ctx.fillStyle = r, this.ctx.translate(n, i), this.ctx.fill(), this.ctx.translate(-n, -i);
    }, A.prototype.resizeImage = function(e, r, n) {
      var i;
      if (e.width === r && e.height === n)
        return e;
      var o = (i = this.canvas.ownerDocument) !== null && i !== void 0 ? i : document, s = o.createElement("canvas");
      s.width = Math.max(1, r), s.height = Math.max(1, n);
      var c = s.getContext("2d");
      return c.drawImage(e, 0, 0, e.width, e.height, 0, 0, r, n), s;
    }, A.prototype.renderBackgroundImage = function(e) {
      return Ot(this, void 0, void 0, function() {
        var r, n, i, o, s, c;
        return St(this, function(u) {
          switch (u.label) {
            case 0:
              r = e.styles.backgroundImage.length - 1, n = function(h) {
                var p, w, d, Z, sA, oA, K, R, j, y, Z, sA, oA, K, R, b, S, Q, P, G, k, Y, z, iA, j, N, Z, E, I, K, R, aA, sA, oA, tA, cA, QA, pA, F, O, M, q;
                return St(this, function(X) {
                  switch (X.label) {
                    case 0:
                      if (h.type !== 0) return [3, 5];
                      p = void 0, w = h.url, X.label = 1;
                    case 1:
                      return X.trys.push([1, 3, , 4]), [4, i.context.cache.match(w)];
                    case 2:
                      return p = X.sent(), [3, 4];
                    case 3:
                      return X.sent(), i.context.logger.error("Error loading background-image " + w), [3, 4];
                    case 4:
                      return p && (d = $c(e, r, [
                        p.width,
                        p.height,
                        p.width / p.height
                      ]), Z = d[0], sA = d[1], oA = d[2], K = d[3], R = d[4], j = i.ctx.createPattern(i.resizeImage(p, K, R), "repeat"), i.renderRepeat(Z, j, sA, oA)), [3, 6];
                    case 5:
                      Rg(h) ? (y = $c(e, r, [null, null, null]), Z = y[0], sA = y[1], oA = y[2], K = y[3], R = y[4], b = Og(h.angle, K, R), S = b[0], Q = b[1], P = b[2], G = b[3], k = b[4], Y = document.createElement("canvas"), Y.width = K, Y.height = R, z = Y.getContext("2d"), iA = z.createLinearGradient(Q, G, P, k), pf(h.stops, S).forEach(function(eA) {
                        return iA.addColorStop(eA.stop, dt(eA.color));
                      }), z.fillStyle = iA, z.fillRect(0, 0, K, R), K > 0 && R > 0 && (j = i.ctx.createPattern(Y, "repeat"), i.renderRepeat(Z, j, sA, oA))) : Gg(h) && (N = $c(e, r, [
                        null,
                        null,
                        null
                      ]), Z = N[0], E = N[1], I = N[2], K = N[3], R = N[4], aA = h.position.length === 0 ? [tu] : h.position, sA = De(aA[0], K), oA = De(aA[aA.length - 1], R), tA = kg(h, sA, oA, K, R), cA = tA[0], QA = tA[1], cA > 0 && QA > 0 && (pA = i.ctx.createRadialGradient(E + sA, I + oA, 0, E + sA, I + oA, cA), pf(h.stops, cA * 2).forEach(function(eA) {
                        return pA.addColorStop(eA.stop, dt(eA.color));
                      }), i.path(Z), i.ctx.fillStyle = pA, cA !== QA ? (F = e.bounds.left + 0.5 * e.bounds.width, O = e.bounds.top + 0.5 * e.bounds.height, M = QA / cA, q = 1 / M, i.ctx.save(), i.ctx.translate(F, O), i.ctx.transform(1, 0, 0, M, 0, 0), i.ctx.translate(-F, -O), i.ctx.fillRect(E, q * (I - O) + O, K, R * q), i.ctx.restore()) : i.ctx.fill())), X.label = 6;
                    case 6:
                      return r--, [
                        2
                        /*return*/
                      ];
                  }
                });
              }, i = this, o = 0, s = e.styles.backgroundImage.slice(0).reverse(), u.label = 1;
            case 1:
              return o < s.length ? (c = s[o], [5, n(c)]) : [3, 4];
            case 2:
              u.sent(), u.label = 3;
            case 3:
              return o++, [3, 1];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, A.prototype.renderSolidBorder = function(e, r, n) {
      return Ot(this, void 0, void 0, function() {
        return St(this, function(i) {
          return this.path(Xf(n, r)), this.ctx.fillStyle = dt(e), this.ctx.fill(), [
            2
            /*return*/
          ];
        });
      });
    }, A.prototype.renderDoubleBorder = function(e, r, n, i) {
      return Ot(this, void 0, void 0, function() {
        var o, s;
        return St(this, function(c) {
          switch (c.label) {
            case 0:
              return r < 3 ? [4, this.renderSolidBorder(e, n, i)] : [3, 2];
            case 1:
              return c.sent(), [
                2
                /*return*/
              ];
            case 2:
              return o = qw(i, n), this.path(o), this.ctx.fillStyle = dt(e), this.ctx.fill(), s = Ww(i, n), this.path(s), this.ctx.fill(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, A.prototype.renderNodeBackgroundAndBorders = function(e) {
      return Ot(this, void 0, void 0, function() {
        var r, n, i, o, s, c, u, h, p = this;
        return St(this, function(w) {
          switch (w.label) {
            case 0:
              return this.applyEffects(e.getEffects(
                2
                /* BACKGROUND_BORDERS */
              )), r = e.container.styles, n = !Kn(r.backgroundColor) || r.backgroundImage.length, i = [
                { style: r.borderTopStyle, color: r.borderTopColor, width: r.borderTopWidth },
                { style: r.borderRightStyle, color: r.borderRightColor, width: r.borderRightWidth },
                { style: r.borderBottomStyle, color: r.borderBottomColor, width: r.borderBottomWidth },
                { style: r.borderLeftStyle, color: r.borderLeftColor, width: r.borderLeftWidth }
              ], o = n5(Gi(r.backgroundClip, 0), e.curves), n || r.boxShadow.length ? (this.ctx.save(), this.path(o), this.ctx.clip(), Kn(r.backgroundColor) || (this.ctx.fillStyle = dt(r.backgroundColor), this.ctx.fill()), [4, this.renderBackgroundImage(e.container)]) : [3, 2];
            case 1:
              w.sent(), this.ctx.restore(), r.boxShadow.slice(0).reverse().forEach(function(d) {
                p.ctx.save();
                var y = To(e.curves), b = d.inset ? 0 : e5, S = Vw(y, -b + (d.inset ? 1 : -1) * d.spread.number, (d.inset ? 1 : -1) * d.spread.number, d.spread.number * (d.inset ? -2 : 2), d.spread.number * (d.inset ? -2 : 2));
                d.inset ? (p.path(y), p.ctx.clip(), p.mask(S)) : (p.mask(y), p.ctx.clip(), p.path(S)), p.ctx.shadowOffsetX = d.offsetX.number + b, p.ctx.shadowOffsetY = d.offsetY.number, p.ctx.shadowColor = dt(d.color), p.ctx.shadowBlur = d.blur.number, p.ctx.fillStyle = d.inset ? dt(d.color) : "rgba(0,0,0,1)", p.ctx.fill(), p.ctx.restore();
              }), w.label = 2;
            case 2:
              s = 0, c = 0, u = i, w.label = 3;
            case 3:
              return c < u.length ? (h = u[c], h.style !== 0 && !Kn(h.color) && h.width > 0 ? h.style !== 2 ? [3, 5] : [4, this.renderDashedDottedBorder(
                h.color,
                h.width,
                s,
                e.curves,
                2
                /* DASHED */
              )] : [3, 11]) : [3, 13];
            case 4:
              return w.sent(), [3, 11];
            case 5:
              return h.style !== 3 ? [3, 7] : [4, this.renderDashedDottedBorder(
                h.color,
                h.width,
                s,
                e.curves,
                3
                /* DOTTED */
              )];
            case 6:
              return w.sent(), [3, 11];
            case 7:
              return h.style !== 4 ? [3, 9] : [4, this.renderDoubleBorder(h.color, h.width, s, e.curves)];
            case 8:
              return w.sent(), [3, 11];
            case 9:
              return [4, this.renderSolidBorder(h.color, s, e.curves)];
            case 10:
              w.sent(), w.label = 11;
            case 11:
              s++, w.label = 12;
            case 12:
              return c++, [3, 3];
            case 13:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, A.prototype.renderDashedDottedBorder = function(e, r, n, i, o) {
      return Ot(this, void 0, void 0, function() {
        var s, c, u, h, p, w, d, y, b, S, Q, P, G, k, Y, z, Y, z;
        return St(this, function(iA) {
          return this.ctx.save(), s = Xw(i, n), c = Xf(i, n), o === 2 && (this.path(c), this.ctx.clip()), cr(c[0]) ? (u = c[0].start.x, h = c[0].start.y) : (u = c[0].x, h = c[0].y), cr(c[1]) ? (p = c[1].end.x, w = c[1].end.y) : (p = c[1].x, w = c[1].y), n === 0 || n === 2 ? d = Math.abs(u - p) : d = Math.abs(h - w), this.ctx.beginPath(), o === 3 ? this.formatPath(s) : this.formatPath(c.slice(0, 2)), y = r < 3 ? r * 3 : r * 2, b = r < 3 ? r * 2 : r, o === 3 && (y = r, b = r), S = !0, d <= y * 2 ? S = !1 : d <= y * 2 + b ? (Q = d / (2 * y + b), y *= Q, b *= Q) : (P = Math.floor((d + b) / (y + b)), G = (d - P * y) / (P - 1), k = (d - (P + 1) * y) / P, b = k <= 0 || Math.abs(b - G) < Math.abs(b - k) ? G : k), S && (o === 3 ? this.ctx.setLineDash([0, y + b]) : this.ctx.setLineDash([y, b])), o === 3 ? (this.ctx.lineCap = "round", this.ctx.lineWidth = r) : this.ctx.lineWidth = r * 2 + 1.1, this.ctx.strokeStyle = dt(e), this.ctx.stroke(), this.ctx.setLineDash([]), o === 2 && (cr(c[0]) && (Y = c[3], z = c[0], this.ctx.beginPath(), this.formatPath([new EA(Y.end.x, Y.end.y), new EA(z.start.x, z.start.y)]), this.ctx.stroke()), cr(c[1]) && (Y = c[1], z = c[2], this.ctx.beginPath(), this.formatPath([new EA(Y.end.x, Y.end.y), new EA(z.start.x, z.start.y)]), this.ctx.stroke())), this.ctx.restore(), [
            2
            /*return*/
          ];
        });
      });
    }, A.prototype.render = function(e) {
      return Ot(this, void 0, void 0, function() {
        var r;
        return St(this, function(n) {
          switch (n.label) {
            case 0:
              return this.options.backgroundColor && (this.ctx.fillStyle = dt(this.options.backgroundColor), this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height)), r = jw(e), [4, this.renderStack(r)];
            case 1:
              return n.sent(), this.applyEffects([]), [2, this.canvas];
          }
        });
      });
    }, A;
  })(f1)
), r5 = function(t) {
  return t instanceof J0 || t instanceof X0 ? !0 : t instanceof au && t.type !== No && t.type !== Ho;
}, n5 = function(t, A) {
  switch (t) {
    case 0:
      return To(A);
    case 2:
      return Pw(A);
    case 1:
    default:
      return Oo(A);
  }
}, i5 = function(t) {
  switch (t) {
    case 1:
      return "center";
    case 2:
      return "right";
    case 0:
    default:
      return "left";
  }
}, a5 = ["-apple-system", "system-ui"], s5 = function(t) {
  return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? t.filter(function(A) {
    return a5.indexOf(A) === -1;
  }) : t;
}, o5 = (
  /** @class */
  (function(t) {
    Ur(A, t);
    function A(e, r) {
      var n = t.call(this, e, r) || this;
      return n.canvas = r.canvas ? r.canvas : document.createElement("canvas"), n.ctx = n.canvas.getContext("2d"), n.options = r, n.canvas.width = Math.floor(r.width * r.scale), n.canvas.height = Math.floor(r.height * r.scale), n.canvas.style.width = r.width + "px", n.canvas.style.height = r.height + "px", n.ctx.scale(n.options.scale, n.options.scale), n.ctx.translate(-r.x, -r.y), n.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + r.width + "x" + r.height + " at " + r.x + "," + r.y + ") with scale " + r.scale), n;
    }
    return A.prototype.render = function(e) {
      return Ot(this, void 0, void 0, function() {
        var r, n;
        return St(this, function(i) {
          switch (i.label) {
            case 0:
              return r = Ol(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, e), [4, c5(r)];
            case 1:
              return n = i.sent(), this.options.backgroundColor && (this.ctx.fillStyle = dt(this.options.backgroundColor), this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale)), this.ctx.drawImage(n, -this.options.x * this.options.scale, -this.options.y * this.options.scale), [2, this.canvas];
          }
        });
      });
    }, A;
  })(f1)
), c5 = function(t) {
  return new Promise(function(A, e) {
    var r = new Image();
    r.onload = function() {
      A(r);
    }, r.onerror = e, r.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(t));
  });
}, l5 = (
  /** @class */
  (function() {
    function t(A) {
      var e = A.id, r = A.enabled;
      this.id = e, this.enabled = r, this.start = Date.now();
    }
    return t.prototype.debug = function() {
      for (var A = [], e = 0; e < arguments.length; e++)
        A[e] = arguments[e];
      this.enabled && (typeof window < "u" && window.console && typeof console.debug == "function" ? console.debug.apply(console, Ms([this.id, this.getTime() + "ms"], A)) : this.info.apply(this, A));
    }, t.prototype.getTime = function() {
      return Date.now() - this.start;
    }, t.prototype.info = function() {
      for (var A = [], e = 0; e < arguments.length; e++)
        A[e] = arguments[e];
      this.enabled && typeof window < "u" && window.console && typeof console.info == "function" && console.info.apply(console, Ms([this.id, this.getTime() + "ms"], A));
    }, t.prototype.warn = function() {
      for (var A = [], e = 0; e < arguments.length; e++)
        A[e] = arguments[e];
      this.enabled && (typeof window < "u" && window.console && typeof console.warn == "function" ? console.warn.apply(console, Ms([this.id, this.getTime() + "ms"], A)) : this.info.apply(this, A));
    }, t.prototype.error = function() {
      for (var A = [], e = 0; e < arguments.length; e++)
        A[e] = arguments[e];
      this.enabled && (typeof window < "u" && window.console && typeof console.error == "function" ? console.error.apply(console, Ms([this.id, this.getTime() + "ms"], A)) : this.info.apply(this, A));
    }, t.instances = {}, t;
  })()
), u5 = (
  /** @class */
  (function() {
    function t(A, e) {
      var r;
      this.windowBounds = e, this.instanceName = "#" + t.instanceCount++, this.logger = new l5({ id: this.instanceName, enabled: A.logging }), this.cache = (r = A.cache) !== null && r !== void 0 ? r : new Sw(this, A);
    }
    return t.instanceCount = 1, t;
  })()
), h1 = function(t, A) {
  return A === void 0 && (A = {}), f5(t, A);
};
typeof window < "u" && a1.setContext(window);
var f5 = function(t, A) {
  return Ot(void 0, void 0, void 0, function() {
    var e, r, n, i, o, s, c, u, h, p, w, d, y, b, S, Q, P, G, k, Y, iA, z, iA, j, N, Z, E, I, K, R, aA, sA, oA, tA, cA, QA, pA, F, O, M;
    return St(this, function(q) {
      switch (q.label) {
        case 0:
          if (!t || typeof t != "object")
            return [2, Promise.reject("Invalid element provided as first argument")];
          if (e = t.ownerDocument, !e)
            throw new Error("Element is not attached to a Document");
          if (r = e.defaultView, !r)
            throw new Error("Document is not attached to a Window");
          return n = {
            allowTaint: (j = A.allowTaint) !== null && j !== void 0 ? j : !1,
            imageTimeout: (N = A.imageTimeout) !== null && N !== void 0 ? N : 15e3,
            proxy: A.proxy,
            useCORS: (Z = A.useCORS) !== null && Z !== void 0 ? Z : !1
          }, i = Ql({ logging: (E = A.logging) !== null && E !== void 0 ? E : !0, cache: A.cache }, n), o = {
            windowWidth: (I = A.windowWidth) !== null && I !== void 0 ? I : r.innerWidth,
            windowHeight: (K = A.windowHeight) !== null && K !== void 0 ? K : r.innerHeight,
            scrollX: (R = A.scrollX) !== null && R !== void 0 ? R : r.pageXOffset,
            scrollY: (aA = A.scrollY) !== null && aA !== void 0 ? aA : r.pageYOffset
          }, s = new Bn(o.scrollX, o.scrollY, o.windowWidth, o.windowHeight), c = new u5(i, s), u = (sA = A.foreignObjectRendering) !== null && sA !== void 0 ? sA : !1, h = {
            allowTaint: (oA = A.allowTaint) !== null && oA !== void 0 ? oA : !1,
            onclone: A.onclone,
            ignoreElements: A.ignoreElements,
            inlineImages: u,
            copyStyles: u
          }, c.logger.debug("Starting document clone with size " + s.width + "x" + s.height + " scrolled to " + -s.left + "," + -s.top), p = new jf(c, t, h), w = p.clonedReferenceElement, w ? [4, p.toIFrame(e, s)] : [2, Promise.reject("Unable to find element in cloned iframe")];
        case 1:
          return d = q.sent(), y = su(w) || Bw(w) ? VB(w.ownerDocument) : Go(c, w), b = y.width, S = y.height, Q = y.left, P = y.top, G = h5(c, w, A.backgroundColor), k = {
            canvas: A.canvas,
            backgroundColor: G,
            scale: (cA = (tA = A.scale) !== null && tA !== void 0 ? tA : r.devicePixelRatio) !== null && cA !== void 0 ? cA : 1,
            x: ((QA = A.x) !== null && QA !== void 0 ? QA : 0) + Q,
            y: ((pA = A.y) !== null && pA !== void 0 ? pA : 0) + P,
            width: (F = A.width) !== null && F !== void 0 ? F : Math.ceil(b),
            height: (O = A.height) !== null && O !== void 0 ? O : Math.ceil(S)
          }, u ? (c.logger.debug("Document cloned, using foreign object rendering"), iA = new o5(c, k), [4, iA.render(w)]) : [3, 3];
        case 2:
          return Y = q.sent(), [3, 5];
        case 3:
          return c.logger.debug("Document cloned, element located at " + Q + "," + P + " with size " + b + "x" + S + " using computed rendering"), c.logger.debug("Starting DOM parsing"), z = Z0(c, w), G === z.styles.backgroundColor && (z.styles.backgroundColor = hn.TRANSPARENT), c.logger.debug("Starting renderer for element at " + k.x + "," + k.y + " with size " + k.width + "x" + k.height), iA = new t5(c, k), [4, iA.render(z)];
        case 4:
          Y = q.sent(), q.label = 5;
        case 5:
          return (!((M = A.removeContainer) !== null && M !== void 0) || M) && (jf.destroy(d) || c.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore")), c.logger.debug("Finished rendering"), [2, Y];
      }
    });
  });
}, h5 = function(t, A, e) {
  var r = A.ownerDocument, n = r.documentElement ? Va(t, getComputedStyle(r.documentElement).backgroundColor) : hn.TRANSPARENT, i = r.body ? Va(t, getComputedStyle(r.body).backgroundColor) : hn.TRANSPARENT, o = typeof e == "string" ? Va(t, e) : e === null ? hn.TRANSPARENT : 4294967295;
  return A === r.documentElement ? Kn(n) ? Kn(i) ? o : i : n : o;
};
const B5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: h1
}, Symbol.toStringTag, { value: "Module" }));
function Ee(t) {
  "@babel/helpers - typeof";
  return Ee = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(A) {
    return typeof A;
  } : function(A) {
    return A && typeof Symbol == "function" && A.constructor === Symbol && A !== Symbol.prototype ? "symbol" : typeof A;
  }, Ee(t);
}
var Fr = Uint8Array, Zt = Uint16Array, ou = Int32Array, cu = new Fr([
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1,
  1,
  1,
  1,
  2,
  2,
  2,
  2,
  3,
  3,
  3,
  3,
  4,
  4,
  4,
  4,
  5,
  5,
  5,
  5,
  0,
  /* unused */
  0,
  0,
  /* impossible */
  0
]), lu = new Fr([
  0,
  0,
  0,
  0,
  1,
  1,
  2,
  2,
  3,
  3,
  4,
  4,
  5,
  5,
  6,
  6,
  7,
  7,
  8,
  8,
  9,
  9,
  10,
  10,
  11,
  11,
  12,
  12,
  13,
  13,
  /* unused */
  0,
  0
]), Yf = new Fr([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), B1 = function(t, A) {
  for (var e = new Zt(31), r = 0; r < 31; ++r)
    e[r] = A += 1 << t[r - 1];
  for (var n = new ou(e[30]), r = 1; r < 30; ++r)
    for (var i = e[r]; i < e[r + 1]; ++i)
      n[i] = i - e[r] << 5 | r;
  return { b: e, r: n };
}, d1 = B1(cu, 2), d5 = d1.b, Vl = d1.r;
d5[28] = 258, Vl[258] = 28;
var g5 = B1(lu, 0), zf = g5.r, jl = new Zt(32768);
for (var Oe = 0; Oe < 32768; ++Oe) {
  var Sn = (Oe & 43690) >> 1 | (Oe & 21845) << 1;
  Sn = (Sn & 52428) >> 2 | (Sn & 13107) << 2, Sn = (Sn & 61680) >> 4 | (Sn & 3855) << 4, jl[Oe] = ((Sn & 65280) >> 8 | (Sn & 255) << 8) >> 1;
}
var Xa = (function(t, A, e) {
  for (var r = t.length, n = 0, i = new Zt(A); n < r; ++n)
    t[n] && ++i[t[n] - 1];
  var o = new Zt(A);
  for (n = 1; n < A; ++n)
    o[n] = o[n - 1] + i[n - 1] << 1;
  var s;
  if (e) {
    s = new Zt(1 << A);
    var c = 15 - A;
    for (n = 0; n < r; ++n)
      if (t[n])
        for (var u = n << 4 | t[n], h = A - t[n], p = o[t[n] - 1]++ << h, w = p | (1 << h) - 1; p <= w; ++p)
          s[jl[p] >> c] = u;
  } else
    for (s = new Zt(r), n = 0; n < r; ++n)
      t[n] && (s[n] = jl[o[t[n] - 1]++] >> 15 - t[n]);
  return s;
}), gi = new Fr(288);
for (var Oe = 0; Oe < 144; ++Oe)
  gi[Oe] = 8;
for (var Oe = 144; Oe < 256; ++Oe)
  gi[Oe] = 9;
for (var Oe = 256; Oe < 280; ++Oe)
  gi[Oe] = 7;
for (var Oe = 280; Oe < 288; ++Oe)
  gi[Oe] = 8;
var Po = new Fr(32);
for (var Oe = 0; Oe < 32; ++Oe)
  Po[Oe] = 5;
var p5 = /* @__PURE__ */ Xa(gi, 9, 0), w5 = /* @__PURE__ */ Xa(Po, 5, 0), g1 = function(t) {
  return (t + 7) / 8 | 0;
}, v5 = function(t, A, e) {
  return (e == null || e > t.length) && (e = t.length), new Fr(t.subarray(A, e));
}, ln = function(t, A, e) {
  e <<= A & 7;
  var r = A / 8 | 0;
  t[r] |= e, t[r + 1] |= e >> 8;
}, _a = function(t, A, e) {
  e <<= A & 7;
  var r = A / 8 | 0;
  t[r] |= e, t[r + 1] |= e >> 8, t[r + 2] |= e >> 16;
}, Al = function(t, A) {
  for (var e = [], r = 0; r < t.length; ++r)
    t[r] && e.push({ s: r, f: t[r] });
  var n = e.length, i = e.slice();
  if (!n)
    return { t: w1, l: 0 };
  if (n == 1) {
    var o = new Fr(e[0].s + 1);
    return o[e[0].s] = 1, { t: o, l: 1 };
  }
  e.sort(function(Y, z) {
    return Y.f - z.f;
  }), e.push({ s: -1, f: 25001 });
  var s = e[0], c = e[1], u = 0, h = 1, p = 2;
  for (e[0] = { s: -1, f: s.f + c.f, l: s, r: c }; h != n - 1; )
    s = e[e[u].f < e[p].f ? u++ : p++], c = e[u != h && e[u].f < e[p].f ? u++ : p++], e[h++] = { s: -1, f: s.f + c.f, l: s, r: c };
  for (var w = i[0].s, r = 1; r < n; ++r)
    i[r].s > w && (w = i[r].s);
  var d = new Zt(w + 1), y = ql(e[h - 1], d, 0);
  if (y > A) {
    var r = 0, b = 0, S = y - A, Q = 1 << S;
    for (i.sort(function(z, iA) {
      return d[iA.s] - d[z.s] || z.f - iA.f;
    }); r < n; ++r) {
      var P = i[r].s;
      if (d[P] > A)
        b += Q - (1 << y - d[P]), d[P] = A;
      else
        break;
    }
    for (b >>= S; b > 0; ) {
      var G = i[r].s;
      d[G] < A ? b -= 1 << A - d[G]++ - 1 : ++r;
    }
    for (; r >= 0 && b; --r) {
      var k = i[r].s;
      d[k] == A && (--d[k], ++b);
    }
    y = A;
  }
  return { t: new Fr(d), l: y };
}, ql = function(t, A, e) {
  return t.s == -1 ? Math.max(ql(t.l, A, e + 1), ql(t.r, A, e + 1)) : A[t.s] = e;
}, Zf = function(t) {
  for (var A = t.length; A && !t[--A]; )
    ;
  for (var e = new Zt(++A), r = 0, n = t[0], i = 1, o = function(c) {
    e[r++] = c;
  }, s = 1; s <= A; ++s)
    if (t[s] == n && s != A)
      ++i;
    else {
      if (!n && i > 2) {
        for (; i > 138; i -= 138)
          o(32754);
        i > 2 && (o(i > 10 ? i - 11 << 5 | 28690 : i - 3 << 5 | 12305), i = 0);
      } else if (i > 3) {
        for (o(n), --i; i > 6; i -= 6)
          o(8304);
        i > 2 && (o(i - 3 << 5 | 8208), i = 0);
      }
      for (; i--; )
        o(n);
      i = 1, n = t[s];
    }
  return { c: e.subarray(0, r), n: A };
}, Da = function(t, A) {
  for (var e = 0, r = 0; r < A.length; ++r)
    e += t[r] * A[r];
  return e;
}, p1 = function(t, A, e) {
  var r = e.length, n = g1(A + 2);
  t[n] = r & 255, t[n + 1] = r >> 8, t[n + 2] = t[n] ^ 255, t[n + 3] = t[n + 1] ^ 255;
  for (var i = 0; i < r; ++i)
    t[n + i + 4] = e[i];
  return (n + 4 + r) * 8;
}, $f = function(t, A, e, r, n, i, o, s, c, u, h) {
  ln(A, h++, e), ++n[256];
  for (var p = Al(n, 15), w = p.t, d = p.l, y = Al(i, 15), b = y.t, S = y.l, Q = Zf(w), P = Q.c, G = Q.n, k = Zf(b), Y = k.c, z = k.n, iA = new Zt(19), j = 0; j < P.length; ++j)
    ++iA[P[j] & 31];
  for (var j = 0; j < Y.length; ++j)
    ++iA[Y[j] & 31];
  for (var N = Al(iA, 7), Z = N.t, E = N.l, I = 19; I > 4 && !Z[Yf[I - 1]]; --I)
    ;
  var K = u + 5 << 3, R = Da(n, gi) + Da(i, Po) + o, aA = Da(n, w) + Da(i, b) + o + 14 + 3 * I + Da(iA, Z) + 2 * iA[16] + 3 * iA[17] + 7 * iA[18];
  if (c >= 0 && K <= R && K <= aA)
    return p1(A, h, t.subarray(c, c + u));
  var sA, oA, tA, cA;
  if (ln(A, h, 1 + (aA < R)), h += 2, aA < R) {
    sA = Xa(w, d, 0), oA = w, tA = Xa(b, S, 0), cA = b;
    var QA = Xa(Z, E, 0);
    ln(A, h, G - 257), ln(A, h + 5, z - 1), ln(A, h + 10, I - 4), h += 14;
    for (var j = 0; j < I; ++j)
      ln(A, h + 3 * j, Z[Yf[j]]);
    h += 3 * I;
    for (var pA = [P, Y], F = 0; F < 2; ++F)
      for (var O = pA[F], j = 0; j < O.length; ++j) {
        var M = O[j] & 31;
        ln(A, h, QA[M]), h += Z[M], M > 15 && (ln(A, h, O[j] >> 5 & 127), h += O[j] >> 12);
      }
  } else
    sA = p5, oA = gi, tA = w5, cA = Po;
  for (var j = 0; j < s; ++j) {
    var q = r[j];
    if (q > 255) {
      var M = q >> 18 & 31;
      _a(A, h, sA[M + 257]), h += oA[M + 257], M > 7 && (ln(A, h, q >> 23 & 31), h += cu[M]);
      var X = q & 31;
      _a(A, h, tA[X]), h += cA[X], X > 3 && (_a(A, h, q >> 5 & 8191), h += lu[X]);
    } else
      _a(A, h, sA[q]), h += oA[q];
  }
  return _a(A, h, sA[256]), h + oA[256];
}, C5 = /* @__PURE__ */ new ou([65540, 131080, 131088, 131104, 262176, 1048704, 1048832, 2114560, 2117632]), w1 = /* @__PURE__ */ new Fr(0), m5 = function(t, A, e, r, n, i) {
  var o = i.z || t.length, s = new Fr(r + o + 5 * (1 + Math.ceil(o / 7e3)) + n), c = s.subarray(r, s.length - n), u = i.l, h = (i.r || 0) & 7;
  if (A) {
    h && (c[0] = i.r >> 3);
    for (var p = C5[A - 1], w = p >> 13, d = p & 8191, y = (1 << e) - 1, b = i.p || new Zt(32768), S = i.h || new Zt(y + 1), Q = Math.ceil(e / 3), P = 2 * Q, G = function(KA) {
      return (t[KA] ^ t[KA + 1] << Q ^ t[KA + 2] << P) & y;
    }, k = new ou(25e3), Y = new Zt(288), z = new Zt(32), iA = 0, j = 0, N = i.i || 0, Z = 0, E = i.w || 0, I = 0; N + 2 < o; ++N) {
      var K = G(N), R = N & 32767, aA = S[K];
      if (b[R] = aA, S[K] = R, E <= N) {
        var sA = o - N;
        if ((iA > 7e3 || Z > 24576) && (sA > 423 || !u)) {
          h = $f(t, c, 0, k, Y, z, j, Z, I, N - I, h), Z = iA = j = 0, I = N;
          for (var oA = 0; oA < 286; ++oA)
            Y[oA] = 0;
          for (var oA = 0; oA < 30; ++oA)
            z[oA] = 0;
        }
        var tA = 2, cA = 0, QA = d, pA = R - aA & 32767;
        if (sA > 2 && K == G(N - pA))
          for (var F = Math.min(w, sA) - 1, O = Math.min(32767, N), M = Math.min(258, sA); pA <= O && --QA && R != aA; ) {
            if (t[N + tA] == t[N + tA - pA]) {
              for (var q = 0; q < M && t[N + q] == t[N + q - pA]; ++q)
                ;
              if (q > tA) {
                if (tA = q, cA = pA, q > F)
                  break;
                for (var X = Math.min(pA, q - 2), eA = 0, oA = 0; oA < X; ++oA) {
                  var lA = N - pA + oA & 32767, uA = b[lA], gA = lA - uA & 32767;
                  gA > eA && (eA = gA, aA = lA);
                }
              }
            }
            R = aA, aA = b[R], pA += R - aA & 32767;
          }
        if (cA) {
          k[Z++] = 268435456 | Vl[tA] << 18 | zf[cA];
          var FA = Vl[tA] & 31, LA = zf[cA] & 31;
          j += cu[FA] + lu[LA], ++Y[257 + FA], ++z[LA], E = N + tA, ++iA;
        } else
          k[Z++] = t[N], ++Y[t[N]];
      }
    }
    for (N = Math.max(N, E); N < o; ++N)
      k[Z++] = t[N], ++Y[t[N]];
    h = $f(t, c, u, k, Y, z, j, Z, I, N - I, h), u || (i.r = h & 7 | c[h / 8 | 0] << 3, h -= 7, i.h = S, i.p = b, i.i = N, i.w = E);
  } else {
    for (var N = i.w || 0; N < o + u; N += 65535) {
      var yA = N + 65535;
      yA >= o && (c[h / 8 | 0] = u, yA = o), h = p1(c, h + 1, t.subarray(N, yA));
    }
    i.i = o;
  }
  return v5(s, 0, r + g1(h) + n);
}, v1 = function() {
  var t = 1, A = 0;
  return {
    p: function(e) {
      for (var r = t, n = A, i = e.length | 0, o = 0; o != i; ) {
        for (var s = Math.min(o + 2655, i); o < s; ++o)
          n += r += e[o];
        r = (r & 65535) + 15 * (r >> 16), n = (n & 65535) + 15 * (n >> 16);
      }
      t = r, A = n;
    },
    d: function() {
      return t %= 65521, A %= 65521, (t & 255) << 24 | (t & 65280) << 8 | (A & 255) << 8 | A >> 8;
    }
  };
}, Q5 = function(t, A, e, r, n) {
  if (!n && (n = { l: 1 }, A.dictionary)) {
    var i = A.dictionary.subarray(-32768), o = new Fr(i.length + t.length);
    o.set(i), o.set(t, i.length), t = o, n.w = i.length;
  }
  return m5(t, A.level == null ? 6 : A.level, A.mem == null ? n.l ? Math.ceil(Math.max(8, Math.min(13, Math.log(t.length))) * 1.5) : 20 : 12 + A.mem, e, r, n);
}, C1 = function(t, A, e) {
  for (; e; ++A)
    t[A] = e, e >>>= 8;
}, F5 = function(t, A) {
  var e = A.level, r = e == 0 ? 0 : e < 6 ? 1 : e == 9 ? 3 : 2;
  if (t[0] = 120, t[1] = r << 6 | (A.dictionary && 32), t[1] |= 31 - (t[0] << 8 | t[1]) % 31, A.dictionary) {
    var n = v1();
    n.p(A.dictionary), C1(t, 2, n.d());
  }
};
function Wl(t, A) {
  A || (A = {});
  var e = v1();
  e.p(t);
  var r = Q5(t, A, A.dictionary ? 6 : 2, 4);
  return F5(r, A), C1(r, r.length - 4, e.d()), r;
}
var U5 = typeof TextDecoder < "u" && /* @__PURE__ */ new TextDecoder(), b5 = 0;
try {
  U5.decode(w1, { stream: !0 }), b5 = 1;
} catch {
}
function y5(t) {
  if (Array.isArray(t)) return t;
}
function E5(t, A) {
  var e = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (e != null) {
    var r, n, i, o, s = [], c = !0, u = !1;
    try {
      if (i = (e = e.call(t)).next, A !== 0) for (; !(c = (r = i.call(e)).done) && (s.push(r.value), s.length !== A); c = !0) ;
    } catch (h) {
      u = !0, n = h;
    } finally {
      try {
        if (!c && e.return != null && (o = e.return(), Object(o) !== o)) return;
      } finally {
        if (u) throw n;
      }
    }
    return s;
  }
}
function Ah(t, A) {
  (A == null || A > t.length) && (A = t.length);
  for (var e = 0, r = Array(A); e < A; e++) r[e] = t[e];
  return r;
}
function L5(t, A) {
  if (t) {
    if (typeof t == "string") return Ah(t, A);
    var e = {}.toString.call(t).slice(8, -1);
    return e === "Object" && t.constructor && (e = t.constructor.name), e === "Map" || e === "Set" ? Array.from(t) : e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e) ? Ah(t, A) : void 0;
  }
}
function x5() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function eh(t, A) {
  return y5(t) || E5(t, A) || L5(t, A) || x5();
}
function th(t, A = "utf8") {
  return new TextDecoder(A).decode(t);
}
const I5 = new TextEncoder();
function S5(t) {
  return I5.encode(t);
}
const H5 = 1024 * 8, N5 = (() => {
  const t = new Uint8Array(4), A = new Uint32Array(t.buffer);
  return !((A[0] = 1) & t[0]);
})(), el = {
  int8: globalThis.Int8Array,
  uint8: globalThis.Uint8Array,
  int16: globalThis.Int16Array,
  uint16: globalThis.Uint16Array,
  int32: globalThis.Int32Array,
  uint32: globalThis.Uint32Array,
  uint64: globalThis.BigUint64Array,
  int64: globalThis.BigInt64Array,
  float32: globalThis.Float32Array,
  float64: globalThis.Float64Array
};
class uu {
  /**
   * Create a new IOBuffer.
   * @param data - The data to construct the IOBuffer with.
   * If data is a number, it will be the new buffer's length<br>
   * If data is `undefined`, the buffer will be initialized with a default length of 8Kb<br>
   * If data is an ArrayBuffer, SharedArrayBuffer, an ArrayBufferView (Typed Array), an IOBuffer instance,
   * or a Node.js Buffer, a view will be created over the underlying ArrayBuffer.
   * @param options - An object for the options.
   * @returns A new IOBuffer instance.
   */
  constructor(A = H5, e = {}) {
    /**
     * Reference to the internal ArrayBuffer object.
     */
    ye(this, "buffer");
    /**
     * Byte length of the internal ArrayBuffer.
     */
    ye(this, "byteLength");
    /**
     * Byte offset of the internal ArrayBuffer.
     */
    ye(this, "byteOffset");
    /**
     * Byte length of the internal ArrayBuffer.
     */
    ye(this, "length");
    /**
     * The current offset of the buffer's pointer.
     */
    ye(this, "offset");
    ye(this, "lastWrittenByte");
    ye(this, "littleEndian");
    ye(this, "_data");
    ye(this, "_mark");
    ye(this, "_marks");
    let r = !1;
    typeof A == "number" ? A = new ArrayBuffer(A) : (r = !0, this.lastWrittenByte = A.byteLength);
    const n = e.offset ? e.offset >>> 0 : 0, i = A.byteLength - n;
    let o = n;
    (ArrayBuffer.isView(A) || A instanceof uu) && (A.byteLength !== A.buffer.byteLength && (o = A.byteOffset + n), A = A.buffer), r ? this.lastWrittenByte = i : this.lastWrittenByte = 0, this.buffer = A, this.length = i, this.byteLength = i, this.byteOffset = o, this.offset = 0, this.littleEndian = !0, this._data = new DataView(this.buffer, o, i), this._mark = 0, this._marks = [];
  }
  /**
   * Checks if the memory allocated to the buffer is sufficient to store more
   * bytes after the offset.
   * @param byteLength - The needed memory in bytes.
   * @returns `true` if there is sufficient space and `false` otherwise.
   */
  available(A = 1) {
    return this.offset + A <= this.length;
  }
  /**
   * Check if little-endian mode is used for reading and writing multi-byte
   * values.
   * @returns `true` if little-endian mode is used, `false` otherwise.
   */
  isLittleEndian() {
    return this.littleEndian;
  }
  /**
   * Set little-endian mode for reading and writing multi-byte values.
   * @returns This.
   */
  setLittleEndian() {
    return this.littleEndian = !0, this;
  }
  /**
   * Check if big-endian mode is used for reading and writing multi-byte values.
   * @returns `true` if big-endian mode is used, `false` otherwise.
   */
  isBigEndian() {
    return !this.littleEndian;
  }
  /**
   * Switches to big-endian mode for reading and writing multi-byte values.
   * @returns This.
   */
  setBigEndian() {
    return this.littleEndian = !1, this;
  }
  /**
   * Move the pointer n bytes forward.
   * @param n - Number of bytes to skip.
   * @returns This.
   */
  skip(A = 1) {
    return this.offset += A, this;
  }
  /**
   * Move the pointer n bytes backward.
   * @param n - Number of bytes to move back.
   * @returns This.
   */
  back(A = 1) {
    return this.offset -= A, this;
  }
  /**
   * Move the pointer to the given offset.
   * @param offset - The offset to move to.
   * @returns This.
   */
  seek(A) {
    return this.offset = A, this;
  }
  /**
   * Store the current pointer offset.
   * @see {@link IOBuffer#reset}
   * @returns This.
   */
  mark() {
    return this._mark = this.offset, this;
  }
  /**
   * Move the pointer back to the last pointer offset set by mark.
   * @see {@link IOBuffer#mark}
   * @returns This.
   */
  reset() {
    return this.offset = this._mark, this;
  }
  /**
   * Push the current pointer offset to the mark stack.
   * @see {@link IOBuffer#popMark}
   * @returns This.
   */
  pushMark() {
    return this._marks.push(this.offset), this;
  }
  /**
   * Pop the last pointer offset from the mark stack, and set the current
   * pointer offset to the popped value.
   * @see {@link IOBuffer#pushMark}
   * @returns This.
   */
  popMark() {
    const A = this._marks.pop();
    if (A === void 0)
      throw new Error("Mark stack empty");
    return this.seek(A), this;
  }
  /**
   * Move the pointer offset back to 0.
   * @returns This.
   */
  rewind() {
    return this.offset = 0, this;
  }
  /**
   * Make sure the buffer has sufficient memory to write a given byteLength at
   * the current pointer offset.
   * If the buffer's memory is insufficient, this method will create a new
   * buffer (a copy) with a length that is twice (byteLength + current offset).
   * @param byteLength - The needed memory in bytes.
   * @returns This.
   */
  ensureAvailable(A = 1) {
    if (!this.available(A)) {
      const r = (this.offset + A) * 2, n = new Uint8Array(r);
      n.set(new Uint8Array(this.buffer)), this.buffer = n.buffer, this.length = r, this.byteLength = r, this._data = new DataView(this.buffer);
    }
    return this;
  }
  /**
   * Read a byte and return false if the byte's value is 0, or true otherwise.
   * Moves pointer forward by one byte.
   * @returns The read boolean.
   */
  readBoolean() {
    return this.readUint8() !== 0;
  }
  /**
   * Read a signed 8-bit integer and move pointer forward by 1 byte.
   * @returns The read byte.
   */
  readInt8() {
    return this._data.getInt8(this.offset++);
  }
  /**
   * Read an unsigned 8-bit integer and move pointer forward by 1 byte.
   * @returns The read byte.
   */
  readUint8() {
    return this._data.getUint8(this.offset++);
  }
  /**
   * Alias for {@link IOBuffer#readUint8}.
   * @returns The read byte.
   */
  readByte() {
    return this.readUint8();
  }
  /**
   * Read `n` bytes and move pointer forward by `n` bytes.
   * @param n - Number of bytes to read.
   * @returns The read bytes.
   */
  readBytes(A = 1) {
    return this.readArray(A, "uint8");
  }
  /**
   * Creates an array of corresponding to the type `type` and size `size`.
   * For example type `uint8` will create a `Uint8Array`.
   * @param size - size of the resulting array
   * @param type - number type of elements to read
   * @returns The read array.
   */
  readArray(A, e) {
    const r = el[e].BYTES_PER_ELEMENT * A, n = this.byteOffset + this.offset, i = this.buffer.slice(n, n + r);
    if (this.littleEndian === N5 && e !== "uint8" && e !== "int8") {
      const s = new Uint8Array(this.buffer.slice(n, n + r));
      s.reverse();
      const c = new el[e](s.buffer);
      return this.offset += r, c.reverse(), c;
    }
    const o = new el[e](i);
    return this.offset += r, o;
  }
  /**
   * Read a 16-bit signed integer and move pointer forward by 2 bytes.
   * @returns The read value.
   */
  readInt16() {
    const A = this._data.getInt16(this.offset, this.littleEndian);
    return this.offset += 2, A;
  }
  /**
   * Read a 16-bit unsigned integer and move pointer forward by 2 bytes.
   * @returns The read value.
   */
  readUint16() {
    const A = this._data.getUint16(this.offset, this.littleEndian);
    return this.offset += 2, A;
  }
  /**
   * Read a 32-bit signed integer and move pointer forward by 4 bytes.
   * @returns The read value.
   */
  readInt32() {
    const A = this._data.getInt32(this.offset, this.littleEndian);
    return this.offset += 4, A;
  }
  /**
   * Read a 32-bit unsigned integer and move pointer forward by 4 bytes.
   * @returns The read value.
   */
  readUint32() {
    const A = this._data.getUint32(this.offset, this.littleEndian);
    return this.offset += 4, A;
  }
  /**
   * Read a 32-bit floating number and move pointer forward by 4 bytes.
   * @returns The read value.
   */
  readFloat32() {
    const A = this._data.getFloat32(this.offset, this.littleEndian);
    return this.offset += 4, A;
  }
  /**
   * Read a 64-bit floating number and move pointer forward by 8 bytes.
   * @returns The read value.
   */
  readFloat64() {
    const A = this._data.getFloat64(this.offset, this.littleEndian);
    return this.offset += 8, A;
  }
  /**
   * Read a 64-bit signed integer number and move pointer forward by 8 bytes.
   * @returns The read value.
   */
  readBigInt64() {
    const A = this._data.getBigInt64(this.offset, this.littleEndian);
    return this.offset += 8, A;
  }
  /**
   * Read a 64-bit unsigned integer number and move pointer forward by 8 bytes.
   * @returns The read value.
   */
  readBigUint64() {
    const A = this._data.getBigUint64(this.offset, this.littleEndian);
    return this.offset += 8, A;
  }
  /**
   * Read a 1-byte ASCII character and move pointer forward by 1 byte.
   * @returns The read character.
   */
  readChar() {
    return String.fromCharCode(this.readInt8());
  }
  /**
   * Read `n` 1-byte ASCII characters and move pointer forward by `n` bytes.
   * @param n - Number of characters to read.
   * @returns The read characters.
   */
  readChars(A = 1) {
    let e = "";
    for (let r = 0; r < A; r++)
      e += this.readChar();
    return e;
  }
  /**
   * Read the next `n` bytes, return a UTF-8 decoded string and move pointer
   * forward by `n` bytes.
   * @param n - Number of bytes to read.
   * @returns The decoded string.
   */
  readUtf8(A = 1) {
    return th(this.readBytes(A));
  }
  /**
   * Read the next `n` bytes, return a string decoded with `encoding` and move pointer
   * forward by `n` bytes.
   * If no encoding is passed, the function is equivalent to @see {@link IOBuffer#readUtf8}
   * @param n - Number of bytes to read.
   * @param encoding - The encoding to use. Default is 'utf8'.
   * @returns The decoded string.
   */
  decodeText(A = 1, e = "utf8") {
    return th(this.readBytes(A), e);
  }
  /**
   * Write 0xff if the passed value is truthy, 0x00 otherwise and move pointer
   * forward by 1 byte.
   * @param value - The value to write.
   * @returns This.
   */
  writeBoolean(A) {
    return this.writeUint8(A ? 255 : 0), this;
  }
  /**
   * Write `value` as an 8-bit signed integer and move pointer forward by 1 byte.
   * @param value - The value to write.
   * @returns This.
   */
  writeInt8(A) {
    return this.ensureAvailable(1), this._data.setInt8(this.offset++, A), this._updateLastWrittenByte(), this;
  }
  /**
   * Write `value` as an 8-bit unsigned integer and move pointer forward by 1
   * byte.
   * @param value - The value to write.
   * @returns This.
   */
  writeUint8(A) {
    return this.ensureAvailable(1), this._data.setUint8(this.offset++, A), this._updateLastWrittenByte(), this;
  }
  /**
   * An alias for {@link IOBuffer#writeUint8}.
   * @param value - The value to write.
   * @returns This.
   */
  writeByte(A) {
    return this.writeUint8(A);
  }
  /**
   * Write all elements of `bytes` as uint8 values and move pointer forward by
   * `bytes.length` bytes.
   * @param bytes - The array of bytes to write.
   * @returns This.
   */
  writeBytes(A) {
    this.ensureAvailable(A.length);
    for (let e = 0; e < A.length; e++)
      this._data.setUint8(this.offset++, A[e]);
    return this._updateLastWrittenByte(), this;
  }
  /**
   * Write `value` as a 16-bit signed integer and move pointer forward by 2
   * bytes.
   * @param value - The value to write.
   * @returns This.
   */
  writeInt16(A) {
    return this.ensureAvailable(2), this._data.setInt16(this.offset, A, this.littleEndian), this.offset += 2, this._updateLastWrittenByte(), this;
  }
  /**
   * Write `value` as a 16-bit unsigned integer and move pointer forward by 2
   * bytes.
   * @param value - The value to write.
   * @returns This.
   */
  writeUint16(A) {
    return this.ensureAvailable(2), this._data.setUint16(this.offset, A, this.littleEndian), this.offset += 2, this._updateLastWrittenByte(), this;
  }
  /**
   * Write `value` as a 32-bit signed integer and move pointer forward by 4
   * bytes.
   * @param value - The value to write.
   * @returns This.
   */
  writeInt32(A) {
    return this.ensureAvailable(4), this._data.setInt32(this.offset, A, this.littleEndian), this.offset += 4, this._updateLastWrittenByte(), this;
  }
  /**
   * Write `value` as a 32-bit unsigned integer and move pointer forward by 4
   * bytes.
   * @param value - The value to write.
   * @returns This.
   */
  writeUint32(A) {
    return this.ensureAvailable(4), this._data.setUint32(this.offset, A, this.littleEndian), this.offset += 4, this._updateLastWrittenByte(), this;
  }
  /**
   * Write `value` as a 32-bit floating number and move pointer forward by 4
   * bytes.
   * @param value - The value to write.
   * @returns This.
   */
  writeFloat32(A) {
    return this.ensureAvailable(4), this._data.setFloat32(this.offset, A, this.littleEndian), this.offset += 4, this._updateLastWrittenByte(), this;
  }
  /**
   * Write `value` as a 64-bit floating number and move pointer forward by 8
   * bytes.
   * @param value - The value to write.
   * @returns This.
   */
  writeFloat64(A) {
    return this.ensureAvailable(8), this._data.setFloat64(this.offset, A, this.littleEndian), this.offset += 8, this._updateLastWrittenByte(), this;
  }
  /**
   * Write `value` as a 64-bit signed bigint and move pointer forward by 8
   * bytes.
   * @param value - The value to write.
   * @returns This.
   */
  writeBigInt64(A) {
    return this.ensureAvailable(8), this._data.setBigInt64(this.offset, A, this.littleEndian), this.offset += 8, this._updateLastWrittenByte(), this;
  }
  /**
   * Write `value` as a 64-bit unsigned bigint and move pointer forward by 8
   * bytes.
   * @param value - The value to write.
   * @returns This.
   */
  writeBigUint64(A) {
    return this.ensureAvailable(8), this._data.setBigUint64(this.offset, A, this.littleEndian), this.offset += 8, this._updateLastWrittenByte(), this;
  }
  /**
   * Write the charCode of `str`'s first character as an 8-bit unsigned integer
   * and move pointer forward by 1 byte.
   * @param str - The character to write.
   * @returns This.
   */
  writeChar(A) {
    return this.writeUint8(A.charCodeAt(0));
  }
  /**
   * Write the charCodes of all `str`'s characters as 8-bit unsigned integers
   * and move pointer forward by `str.length` bytes.
   * @param str - The characters to write.
   * @returns This.
   */
  writeChars(A) {
    for (let e = 0; e < A.length; e++)
      this.writeUint8(A.charCodeAt(e));
    return this;
  }
  /**
   * UTF-8 encode and write `str` to the current pointer offset and move pointer
   * forward according to the encoded length.
   * @param str - The string to write.
   * @returns This.
   */
  writeUtf8(A) {
    return this.writeBytes(S5(A));
  }
  /**
   * Export a Uint8Array view of the internal buffer.
   * The view starts at the byte offset and its length
   * is calculated to stop at the last written byte or the original length.
   * @returns A new Uint8Array view.
   */
  toArray() {
    return new Uint8Array(this.buffer, this.byteOffset, this.lastWrittenByte);
  }
  /**
   *  Get the total number of bytes written so far, regardless of the current offset.
   * @returns - Total number of bytes.
   */
  getWrittenByteLength() {
    return this.lastWrittenByte - this.byteOffset;
  }
  /**
   * Update the last written byte offset
   * @private
   */
  _updateLastWrittenByte() {
    this.offset > this.lastWrittenByte && (this.lastWrittenByte = this.offset);
  }
}
function ea(t) {
  let A = t.length;
  for (; --A >= 0; )
    t[A] = 0;
}
const _5 = 3, D5 = 258, m1 = 29, T5 = 256, O5 = T5 + 1 + m1, Q1 = 30, k5 = 512, P5 = new Array((O5 + 2) * 2);
ea(P5);
const M5 = new Array(Q1 * 2);
ea(M5);
const K5 = new Array(k5);
ea(K5);
const R5 = new Array(D5 - _5 + 1);
ea(R5);
const G5 = new Array(m1);
ea(G5);
const V5 = new Array(Q1);
ea(V5);
const j5 = (t, A, e, r) => {
  let n = t & 65535 | 0, i = t >>> 16 & 65535 | 0, o = 0;
  for (; e !== 0; ) {
    o = e > 2e3 ? 2e3 : e, e -= o;
    do
      n = n + A[r++] | 0, i = i + n | 0;
    while (--o);
    n %= 65521, i %= 65521;
  }
  return n | i << 16 | 0;
};
var Xl = j5;
const q5 = () => {
  let t, A = [];
  for (var e = 0; e < 256; e++) {
    t = e;
    for (var r = 0; r < 8; r++)
      t = t & 1 ? 3988292384 ^ t >>> 1 : t >>> 1;
    A[e] = t;
  }
  return A;
}, W5 = new Uint32Array(q5()), X5 = (t, A, e, r) => {
  const n = W5, i = r + e;
  t ^= -1;
  for (let o = r; o < i; o++)
    t = t >>> 8 ^ n[(t ^ A[o]) & 255];
  return t ^ -1;
};
var Or = X5, Jl = {
  2: "need dictionary",
  /* Z_NEED_DICT       2  */
  1: "stream end",
  /* Z_STREAM_END      1  */
  0: "",
  /* Z_OK              0  */
  "-1": "file error",
  /* Z_ERRNO         (-1) */
  "-2": "stream error",
  /* Z_STREAM_ERROR  (-2) */
  "-3": "data error",
  /* Z_DATA_ERROR    (-3) */
  "-4": "insufficient memory",
  /* Z_MEM_ERROR     (-4) */
  "-5": "buffer error",
  /* Z_BUF_ERROR     (-5) */
  "-6": "incompatible version"
  /* Z_VERSION_ERROR (-6) */
}, F1 = {
  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH: 0,
  Z_FINISH: 4,
  Z_BLOCK: 5,
  Z_TREES: 6,
  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK: 0,
  Z_STREAM_END: 1,
  Z_NEED_DICT: 2,
  Z_STREAM_ERROR: -2,
  Z_DATA_ERROR: -3,
  Z_MEM_ERROR: -4,
  Z_BUF_ERROR: -5,
  /* The deflate compression method */
  Z_DEFLATED: 8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};
const J5 = (t, A) => Object.prototype.hasOwnProperty.call(t, A);
var Y5 = function(t) {
  const A = Array.prototype.slice.call(arguments, 1);
  for (; A.length; ) {
    const e = A.shift();
    if (e) {
      if (typeof e != "object")
        throw new TypeError(e + "must be non-object");
      for (const r in e)
        J5(e, r) && (t[r] = e[r]);
    }
  }
  return t;
}, z5 = (t) => {
  let A = 0;
  for (let r = 0, n = t.length; r < n; r++)
    A += t[r].length;
  const e = new Uint8Array(A);
  for (let r = 0, n = 0, i = t.length; r < i; r++) {
    let o = t[r];
    e.set(o, n), n += o.length;
  }
  return e;
}, U1 = {
  assign: Y5,
  flattenChunks: z5
};
let b1 = !0;
try {
  String.fromCharCode.apply(null, new Uint8Array(1));
} catch {
  b1 = !1;
}
const $a = new Uint8Array(256);
for (let t = 0; t < 256; t++)
  $a[t] = t >= 252 ? 6 : t >= 248 ? 5 : t >= 240 ? 4 : t >= 224 ? 3 : t >= 192 ? 2 : 1;
$a[254] = $a[254] = 1;
var Z5 = (t) => {
  if (typeof TextEncoder == "function" && TextEncoder.prototype.encode)
    return new TextEncoder().encode(t);
  let A, e, r, n, i, o = t.length, s = 0;
  for (n = 0; n < o; n++)
    e = t.charCodeAt(n), (e & 64512) === 55296 && n + 1 < o && (r = t.charCodeAt(n + 1), (r & 64512) === 56320 && (e = 65536 + (e - 55296 << 10) + (r - 56320), n++)), s += e < 128 ? 1 : e < 2048 ? 2 : e < 65536 ? 3 : 4;
  for (A = new Uint8Array(s), i = 0, n = 0; i < s; n++)
    e = t.charCodeAt(n), (e & 64512) === 55296 && n + 1 < o && (r = t.charCodeAt(n + 1), (r & 64512) === 56320 && (e = 65536 + (e - 55296 << 10) + (r - 56320), n++)), e < 128 ? A[i++] = e : e < 2048 ? (A[i++] = 192 | e >>> 6, A[i++] = 128 | e & 63) : e < 65536 ? (A[i++] = 224 | e >>> 12, A[i++] = 128 | e >>> 6 & 63, A[i++] = 128 | e & 63) : (A[i++] = 240 | e >>> 18, A[i++] = 128 | e >>> 12 & 63, A[i++] = 128 | e >>> 6 & 63, A[i++] = 128 | e & 63);
  return A;
};
const $5 = (t, A) => {
  if (A < 65534 && t.subarray && b1)
    return String.fromCharCode.apply(null, t.length === A ? t : t.subarray(0, A));
  let e = "";
  for (let r = 0; r < A; r++)
    e += String.fromCharCode(t[r]);
  return e;
};
var Av = (t, A) => {
  const e = A || t.length;
  if (typeof TextDecoder == "function" && TextDecoder.prototype.decode)
    return new TextDecoder().decode(t.subarray(0, A));
  let r, n;
  const i = new Array(e * 2);
  for (n = 0, r = 0; r < e; ) {
    let o = t[r++];
    if (o < 128) {
      i[n++] = o;
      continue;
    }
    let s = $a[o];
    if (s > 4) {
      i[n++] = 65533, r += s - 1;
      continue;
    }
    for (o &= s === 2 ? 31 : s === 3 ? 15 : 7; s > 1 && r < e; )
      o = o << 6 | t[r++] & 63, s--;
    if (s > 1) {
      i[n++] = 65533;
      continue;
    }
    o < 65536 ? i[n++] = o : (o -= 65536, i[n++] = 55296 | o >> 10 & 1023, i[n++] = 56320 | o & 1023);
  }
  return $5(i, n);
}, ev = (t, A) => {
  A = A || t.length, A > t.length && (A = t.length);
  let e = A - 1;
  for (; e >= 0 && (t[e] & 192) === 128; )
    e--;
  return e < 0 || e === 0 ? A : e + $a[t[e]] > A ? e : A;
}, Yl = {
  string2buf: Z5,
  buf2string: Av,
  utf8border: ev
};
function tv() {
  this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
}
var rv = tv;
const co = 16209, nv = 16191;
var iv = function(A, e) {
  let r, n, i, o, s, c, u, h, p, w, d, y, b, S, Q, P, G, k, Y, z, iA, j, N, Z;
  const E = A.state;
  r = A.next_in, N = A.input, n = r + (A.avail_in - 5), i = A.next_out, Z = A.output, o = i - (e - A.avail_out), s = i + (A.avail_out - 257), c = E.dmax, u = E.wsize, h = E.whave, p = E.wnext, w = E.window, d = E.hold, y = E.bits, b = E.lencode, S = E.distcode, Q = (1 << E.lenbits) - 1, P = (1 << E.distbits) - 1;
  A:
    do {
      y < 15 && (d += N[r++] << y, y += 8, d += N[r++] << y, y += 8), G = b[d & Q];
      e:
        for (; ; ) {
          if (k = G >>> 24, d >>>= k, y -= k, k = G >>> 16 & 255, k === 0)
            Z[i++] = G & 65535;
          else if (k & 16) {
            Y = G & 65535, k &= 15, k && (y < k && (d += N[r++] << y, y += 8), Y += d & (1 << k) - 1, d >>>= k, y -= k), y < 15 && (d += N[r++] << y, y += 8, d += N[r++] << y, y += 8), G = S[d & P];
            t:
              for (; ; ) {
                if (k = G >>> 24, d >>>= k, y -= k, k = G >>> 16 & 255, k & 16) {
                  if (z = G & 65535, k &= 15, y < k && (d += N[r++] << y, y += 8, y < k && (d += N[r++] << y, y += 8)), z += d & (1 << k) - 1, z > c) {
                    A.msg = "invalid distance too far back", E.mode = co;
                    break A;
                  }
                  if (d >>>= k, y -= k, k = i - o, z > k) {
                    if (k = z - k, k > h && E.sane) {
                      A.msg = "invalid distance too far back", E.mode = co;
                      break A;
                    }
                    if (iA = 0, j = w, p === 0) {
                      if (iA += u - k, k < Y) {
                        Y -= k;
                        do
                          Z[i++] = w[iA++];
                        while (--k);
                        iA = i - z, j = Z;
                      }
                    } else if (p < k) {
                      if (iA += u + p - k, k -= p, k < Y) {
                        Y -= k;
                        do
                          Z[i++] = w[iA++];
                        while (--k);
                        if (iA = 0, p < Y) {
                          k = p, Y -= k;
                          do
                            Z[i++] = w[iA++];
                          while (--k);
                          iA = i - z, j = Z;
                        }
                      }
                    } else if (iA += p - k, k < Y) {
                      Y -= k;
                      do
                        Z[i++] = w[iA++];
                      while (--k);
                      iA = i - z, j = Z;
                    }
                    for (; Y > 2; )
                      Z[i++] = j[iA++], Z[i++] = j[iA++], Z[i++] = j[iA++], Y -= 3;
                    Y && (Z[i++] = j[iA++], Y > 1 && (Z[i++] = j[iA++]));
                  } else {
                    iA = i - z;
                    do
                      Z[i++] = Z[iA++], Z[i++] = Z[iA++], Z[i++] = Z[iA++], Y -= 3;
                    while (Y > 2);
                    Y && (Z[i++] = Z[iA++], Y > 1 && (Z[i++] = Z[iA++]));
                  }
                } else if ((k & 64) === 0) {
                  G = S[(G & 65535) + (d & (1 << k) - 1)];
                  continue t;
                } else {
                  A.msg = "invalid distance code", E.mode = co;
                  break A;
                }
                break;
              }
          } else if ((k & 64) === 0) {
            G = b[(G & 65535) + (d & (1 << k) - 1)];
            continue e;
          } else if (k & 32) {
            E.mode = nv;
            break A;
          } else {
            A.msg = "invalid literal/length code", E.mode = co;
            break A;
          }
          break;
        }
    } while (r < n && i < s);
  Y = y >> 3, r -= Y, y -= Y << 3, d &= (1 << y) - 1, A.next_in = r, A.next_out = i, A.avail_in = r < n ? 5 + (n - r) : 5 - (r - n), A.avail_out = i < s ? 257 + (s - i) : 257 - (i - s), E.hold = d, E.bits = y;
};
const Pi = 15, rh = 852, nh = 592, ih = 0, tl = 1, ah = 2, av = new Uint16Array([
  /* Length codes 257..285 base */
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  13,
  15,
  17,
  19,
  23,
  27,
  31,
  35,
  43,
  51,
  59,
  67,
  83,
  99,
  115,
  131,
  163,
  195,
  227,
  258,
  0,
  0
]), sv = new Uint8Array([
  /* Length codes 257..285 extra */
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  17,
  17,
  17,
  17,
  18,
  18,
  18,
  18,
  19,
  19,
  19,
  19,
  20,
  20,
  20,
  20,
  21,
  21,
  21,
  21,
  16,
  72,
  78
]), ov = new Uint16Array([
  /* Distance codes 0..29 base */
  1,
  2,
  3,
  4,
  5,
  7,
  9,
  13,
  17,
  25,
  33,
  49,
  65,
  97,
  129,
  193,
  257,
  385,
  513,
  769,
  1025,
  1537,
  2049,
  3073,
  4097,
  6145,
  8193,
  12289,
  16385,
  24577,
  0,
  0
]), cv = new Uint8Array([
  /* Distance codes 0..29 extra */
  16,
  16,
  16,
  16,
  17,
  17,
  18,
  18,
  19,
  19,
  20,
  20,
  21,
  21,
  22,
  22,
  23,
  23,
  24,
  24,
  25,
  25,
  26,
  26,
  27,
  27,
  28,
  28,
  29,
  29,
  64,
  64
]), lv = (t, A, e, r, n, i, o, s) => {
  const c = s.bits;
  let u = 0, h = 0, p = 0, w = 0, d = 0, y = 0, b = 0, S = 0, Q = 0, P = 0, G, k, Y, z, iA, j = null, N;
  const Z = new Uint16Array(Pi + 1), E = new Uint16Array(Pi + 1);
  let I = null, K, R, aA;
  for (u = 0; u <= Pi; u++)
    Z[u] = 0;
  for (h = 0; h < r; h++)
    Z[A[e + h]]++;
  for (d = c, w = Pi; w >= 1 && Z[w] === 0; w--)
    ;
  if (d > w && (d = w), w === 0)
    return n[i++] = 1 << 24 | 64 << 16 | 0, n[i++] = 1 << 24 | 64 << 16 | 0, s.bits = 1, 0;
  for (p = 1; p < w && Z[p] === 0; p++)
    ;
  for (d < p && (d = p), S = 1, u = 1; u <= Pi; u++)
    if (S <<= 1, S -= Z[u], S < 0)
      return -1;
  if (S > 0 && (t === ih || w !== 1))
    return -1;
  for (E[1] = 0, u = 1; u < Pi; u++)
    E[u + 1] = E[u] + Z[u];
  for (h = 0; h < r; h++)
    A[e + h] !== 0 && (o[E[A[e + h]]++] = h);
  if (t === ih ? (j = I = o, N = 20) : t === tl ? (j = av, I = sv, N = 257) : (j = ov, I = cv, N = 0), P = 0, h = 0, u = p, iA = i, y = d, b = 0, Y = -1, Q = 1 << d, z = Q - 1, t === tl && Q > rh || t === ah && Q > nh)
    return 1;
  for (; ; ) {
    K = u - b, o[h] + 1 < N ? (R = 0, aA = o[h]) : o[h] >= N ? (R = I[o[h] - N], aA = j[o[h] - N]) : (R = 96, aA = 0), G = 1 << u - b, k = 1 << y, p = k;
    do
      k -= G, n[iA + (P >> b) + k] = K << 24 | R << 16 | aA | 0;
    while (k !== 0);
    for (G = 1 << u - 1; P & G; )
      G >>= 1;
    if (G !== 0 ? (P &= G - 1, P += G) : P = 0, h++, --Z[u] === 0) {
      if (u === w)
        break;
      u = A[e + o[h]];
    }
    if (u > d && (P & z) !== Y) {
      for (b === 0 && (b = d), iA += p, y = u - b, S = 1 << y; y + b < w && (S -= Z[y + b], !(S <= 0)); )
        y++, S <<= 1;
      if (Q += 1 << y, t === tl && Q > rh || t === ah && Q > nh)
        return 1;
      Y = P & z, n[Y] = d << 24 | y << 16 | iA - i | 0;
    }
  }
  return P !== 0 && (n[iA + P] = u - b << 24 | 64 << 16 | 0), s.bits = d, 0;
};
var Ja = lv;
const uv = 0, y1 = 1, E1 = 2, {
  Z_FINISH: sh,
  Z_BLOCK: fv,
  Z_TREES: lo,
  Z_OK: pi,
  Z_STREAM_END: hv,
  Z_NEED_DICT: Bv,
  Z_STREAM_ERROR: fr,
  Z_DATA_ERROR: L1,
  Z_MEM_ERROR: x1,
  Z_BUF_ERROR: dv,
  Z_DEFLATED: oh
} = F1, $o = 16180, ch = 16181, lh = 16182, uh = 16183, fh = 16184, hh = 16185, Bh = 16186, dh = 16187, gh = 16188, ph = 16189, Mo = 16190, un = 16191, rl = 16192, wh = 16193, nl = 16194, vh = 16195, Ch = 16196, mh = 16197, Qh = 16198, uo = 16199, fo = 16200, Fh = 16201, Uh = 16202, bh = 16203, yh = 16204, Eh = 16205, il = 16206, Lh = 16207, xh = 16208, Ke = 16209, I1 = 16210, S1 = 16211, gv = 852, pv = 592, wv = 15, vv = wv, Ih = (t) => (t >>> 24 & 255) + (t >>> 8 & 65280) + ((t & 65280) << 8) + ((t & 255) << 24);
function Cv() {
  this.strm = null, this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new Uint16Array(320), this.work = new Uint16Array(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
}
const wi = (t) => {
  if (!t)
    return 1;
  const A = t.state;
  return !A || A.strm !== t || A.mode < $o || A.mode > S1 ? 1 : 0;
}, H1 = (t) => {
  if (wi(t))
    return fr;
  const A = t.state;
  return t.total_in = t.total_out = A.total = 0, t.msg = "", A.wrap && (t.adler = A.wrap & 1), A.mode = $o, A.last = 0, A.havedict = 0, A.flags = -1, A.dmax = 32768, A.head = null, A.hold = 0, A.bits = 0, A.lencode = A.lendyn = new Int32Array(gv), A.distcode = A.distdyn = new Int32Array(pv), A.sane = 1, A.back = -1, pi;
}, N1 = (t) => {
  if (wi(t))
    return fr;
  const A = t.state;
  return A.wsize = 0, A.whave = 0, A.wnext = 0, H1(t);
}, _1 = (t, A) => {
  let e;
  if (wi(t))
    return fr;
  const r = t.state;
  return A < 0 ? (e = 0, A = -A) : (e = (A >> 4) + 5, A < 48 && (A &= 15)), A && (A < 8 || A > 15) ? fr : (r.window !== null && r.wbits !== A && (r.window = null), r.wrap = e, r.wbits = A, N1(t));
}, D1 = (t, A) => {
  if (!t)
    return fr;
  const e = new Cv();
  t.state = e, e.strm = t, e.window = null, e.mode = $o;
  const r = _1(t, A);
  return r !== pi && (t.state = null), r;
}, mv = (t) => D1(t, vv);
let Sh = !0, al, sl;
const Qv = (t) => {
  if (Sh) {
    al = new Int32Array(512), sl = new Int32Array(32);
    let A = 0;
    for (; A < 144; )
      t.lens[A++] = 8;
    for (; A < 256; )
      t.lens[A++] = 9;
    for (; A < 280; )
      t.lens[A++] = 7;
    for (; A < 288; )
      t.lens[A++] = 8;
    for (Ja(y1, t.lens, 0, 288, al, 0, t.work, { bits: 9 }), A = 0; A < 32; )
      t.lens[A++] = 5;
    Ja(E1, t.lens, 0, 32, sl, 0, t.work, { bits: 5 }), Sh = !1;
  }
  t.lencode = al, t.lenbits = 9, t.distcode = sl, t.distbits = 5;
}, T1 = (t, A, e, r) => {
  let n;
  const i = t.state;
  return i.window === null && (i.wsize = 1 << i.wbits, i.wnext = 0, i.whave = 0, i.window = new Uint8Array(i.wsize)), r >= i.wsize ? (i.window.set(A.subarray(e - i.wsize, e), 0), i.wnext = 0, i.whave = i.wsize) : (n = i.wsize - i.wnext, n > r && (n = r), i.window.set(A.subarray(e - r, e - r + n), i.wnext), r -= n, r ? (i.window.set(A.subarray(e - r, e), 0), i.wnext = r, i.whave = i.wsize) : (i.wnext += n, i.wnext === i.wsize && (i.wnext = 0), i.whave < i.wsize && (i.whave += n))), 0;
}, Fv = (t, A) => {
  let e, r, n, i, o, s, c, u, h, p, w, d, y, b, S = 0, Q, P, G, k, Y, z, iA, j;
  const N = new Uint8Array(4);
  let Z, E;
  const I = (
    /* permutation of code lengths */
    new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15])
  );
  if (wi(t) || !t.output || !t.input && t.avail_in !== 0)
    return fr;
  e = t.state, e.mode === un && (e.mode = rl), o = t.next_out, n = t.output, c = t.avail_out, i = t.next_in, r = t.input, s = t.avail_in, u = e.hold, h = e.bits, p = s, w = c, j = pi;
  A:
    for (; ; )
      switch (e.mode) {
        case $o:
          if (e.wrap === 0) {
            e.mode = rl;
            break;
          }
          for (; h < 16; ) {
            if (s === 0)
              break A;
            s--, u += r[i++] << h, h += 8;
          }
          if (e.wrap & 2 && u === 35615) {
            e.wbits === 0 && (e.wbits = 15), e.check = 0, N[0] = u & 255, N[1] = u >>> 8 & 255, e.check = Or(e.check, N, 2, 0), u = 0, h = 0, e.mode = ch;
            break;
          }
          if (e.head && (e.head.done = !1), !(e.wrap & 1) || /* check if zlib header allowed */
          (((u & 255) << 8) + (u >> 8)) % 31) {
            t.msg = "incorrect header check", e.mode = Ke;
            break;
          }
          if ((u & 15) !== oh) {
            t.msg = "unknown compression method", e.mode = Ke;
            break;
          }
          if (u >>>= 4, h -= 4, iA = (u & 15) + 8, e.wbits === 0 && (e.wbits = iA), iA > 15 || iA > e.wbits) {
            t.msg = "invalid window size", e.mode = Ke;
            break;
          }
          e.dmax = 1 << e.wbits, e.flags = 0, t.adler = e.check = 1, e.mode = u & 512 ? ph : un, u = 0, h = 0;
          break;
        case ch:
          for (; h < 16; ) {
            if (s === 0)
              break A;
            s--, u += r[i++] << h, h += 8;
          }
          if (e.flags = u, (e.flags & 255) !== oh) {
            t.msg = "unknown compression method", e.mode = Ke;
            break;
          }
          if (e.flags & 57344) {
            t.msg = "unknown header flags set", e.mode = Ke;
            break;
          }
          e.head && (e.head.text = u >> 8 & 1), e.flags & 512 && e.wrap & 4 && (N[0] = u & 255, N[1] = u >>> 8 & 255, e.check = Or(e.check, N, 2, 0)), u = 0, h = 0, e.mode = lh;
        /* falls through */
        case lh:
          for (; h < 32; ) {
            if (s === 0)
              break A;
            s--, u += r[i++] << h, h += 8;
          }
          e.head && (e.head.time = u), e.flags & 512 && e.wrap & 4 && (N[0] = u & 255, N[1] = u >>> 8 & 255, N[2] = u >>> 16 & 255, N[3] = u >>> 24 & 255, e.check = Or(e.check, N, 4, 0)), u = 0, h = 0, e.mode = uh;
        /* falls through */
        case uh:
          for (; h < 16; ) {
            if (s === 0)
              break A;
            s--, u += r[i++] << h, h += 8;
          }
          e.head && (e.head.xflags = u & 255, e.head.os = u >> 8), e.flags & 512 && e.wrap & 4 && (N[0] = u & 255, N[1] = u >>> 8 & 255, e.check = Or(e.check, N, 2, 0)), u = 0, h = 0, e.mode = fh;
        /* falls through */
        case fh:
          if (e.flags & 1024) {
            for (; h < 16; ) {
              if (s === 0)
                break A;
              s--, u += r[i++] << h, h += 8;
            }
            e.length = u, e.head && (e.head.extra_len = u), e.flags & 512 && e.wrap & 4 && (N[0] = u & 255, N[1] = u >>> 8 & 255, e.check = Or(e.check, N, 2, 0)), u = 0, h = 0;
          } else e.head && (e.head.extra = null);
          e.mode = hh;
        /* falls through */
        case hh:
          if (e.flags & 1024 && (d = e.length, d > s && (d = s), d && (e.head && (iA = e.head.extra_len - e.length, e.head.extra || (e.head.extra = new Uint8Array(e.head.extra_len)), e.head.extra.set(
            r.subarray(
              i,
              // extra field is limited to 65536 bytes
              // - no need for additional size check
              i + d
            ),
            /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
            iA
          )), e.flags & 512 && e.wrap & 4 && (e.check = Or(e.check, r, d, i)), s -= d, i += d, e.length -= d), e.length))
            break A;
          e.length = 0, e.mode = Bh;
        /* falls through */
        case Bh:
          if (e.flags & 2048) {
            if (s === 0)
              break A;
            d = 0;
            do
              iA = r[i + d++], e.head && iA && e.length < 65536 && (e.head.name += String.fromCharCode(iA));
            while (iA && d < s);
            if (e.flags & 512 && e.wrap & 4 && (e.check = Or(e.check, r, d, i)), s -= d, i += d, iA)
              break A;
          } else e.head && (e.head.name = null);
          e.length = 0, e.mode = dh;
        /* falls through */
        case dh:
          if (e.flags & 4096) {
            if (s === 0)
              break A;
            d = 0;
            do
              iA = r[i + d++], e.head && iA && e.length < 65536 && (e.head.comment += String.fromCharCode(iA));
            while (iA && d < s);
            if (e.flags & 512 && e.wrap & 4 && (e.check = Or(e.check, r, d, i)), s -= d, i += d, iA)
              break A;
          } else e.head && (e.head.comment = null);
          e.mode = gh;
        /* falls through */
        case gh:
          if (e.flags & 512) {
            for (; h < 16; ) {
              if (s === 0)
                break A;
              s--, u += r[i++] << h, h += 8;
            }
            if (e.wrap & 4 && u !== (e.check & 65535)) {
              t.msg = "header crc mismatch", e.mode = Ke;
              break;
            }
            u = 0, h = 0;
          }
          e.head && (e.head.hcrc = e.flags >> 9 & 1, e.head.done = !0), t.adler = e.check = 0, e.mode = un;
          break;
        case ph:
          for (; h < 32; ) {
            if (s === 0)
              break A;
            s--, u += r[i++] << h, h += 8;
          }
          t.adler = e.check = Ih(u), u = 0, h = 0, e.mode = Mo;
        /* falls through */
        case Mo:
          if (e.havedict === 0)
            return t.next_out = o, t.avail_out = c, t.next_in = i, t.avail_in = s, e.hold = u, e.bits = h, Bv;
          t.adler = e.check = 1, e.mode = un;
        /* falls through */
        case un:
          if (A === fv || A === lo)
            break A;
        /* falls through */
        case rl:
          if (e.last) {
            u >>>= h & 7, h -= h & 7, e.mode = il;
            break;
          }
          for (; h < 3; ) {
            if (s === 0)
              break A;
            s--, u += r[i++] << h, h += 8;
          }
          switch (e.last = u & 1, u >>>= 1, h -= 1, u & 3) {
            case 0:
              e.mode = wh;
              break;
            case 1:
              if (Qv(e), e.mode = uo, A === lo) {
                u >>>= 2, h -= 2;
                break A;
              }
              break;
            case 2:
              e.mode = Ch;
              break;
            case 3:
              t.msg = "invalid block type", e.mode = Ke;
          }
          u >>>= 2, h -= 2;
          break;
        case wh:
          for (u >>>= h & 7, h -= h & 7; h < 32; ) {
            if (s === 0)
              break A;
            s--, u += r[i++] << h, h += 8;
          }
          if ((u & 65535) !== (u >>> 16 ^ 65535)) {
            t.msg = "invalid stored block lengths", e.mode = Ke;
            break;
          }
          if (e.length = u & 65535, u = 0, h = 0, e.mode = nl, A === lo)
            break A;
        /* falls through */
        case nl:
          e.mode = vh;
        /* falls through */
        case vh:
          if (d = e.length, d) {
            if (d > s && (d = s), d > c && (d = c), d === 0)
              break A;
            n.set(r.subarray(i, i + d), o), s -= d, i += d, c -= d, o += d, e.length -= d;
            break;
          }
          e.mode = un;
          break;
        case Ch:
          for (; h < 14; ) {
            if (s === 0)
              break A;
            s--, u += r[i++] << h, h += 8;
          }
          if (e.nlen = (u & 31) + 257, u >>>= 5, h -= 5, e.ndist = (u & 31) + 1, u >>>= 5, h -= 5, e.ncode = (u & 15) + 4, u >>>= 4, h -= 4, e.nlen > 286 || e.ndist > 30) {
            t.msg = "too many length or distance symbols", e.mode = Ke;
            break;
          }
          e.have = 0, e.mode = mh;
        /* falls through */
        case mh:
          for (; e.have < e.ncode; ) {
            for (; h < 3; ) {
              if (s === 0)
                break A;
              s--, u += r[i++] << h, h += 8;
            }
            e.lens[I[e.have++]] = u & 7, u >>>= 3, h -= 3;
          }
          for (; e.have < 19; )
            e.lens[I[e.have++]] = 0;
          if (e.lencode = e.lendyn, e.lenbits = 7, Z = { bits: e.lenbits }, j = Ja(uv, e.lens, 0, 19, e.lencode, 0, e.work, Z), e.lenbits = Z.bits, j) {
            t.msg = "invalid code lengths set", e.mode = Ke;
            break;
          }
          e.have = 0, e.mode = Qh;
        /* falls through */
        case Qh:
          for (; e.have < e.nlen + e.ndist; ) {
            for (; S = e.lencode[u & (1 << e.lenbits) - 1], Q = S >>> 24, P = S >>> 16 & 255, G = S & 65535, !(Q <= h); ) {
              if (s === 0)
                break A;
              s--, u += r[i++] << h, h += 8;
            }
            if (G < 16)
              u >>>= Q, h -= Q, e.lens[e.have++] = G;
            else {
              if (G === 16) {
                for (E = Q + 2; h < E; ) {
                  if (s === 0)
                    break A;
                  s--, u += r[i++] << h, h += 8;
                }
                if (u >>>= Q, h -= Q, e.have === 0) {
                  t.msg = "invalid bit length repeat", e.mode = Ke;
                  break;
                }
                iA = e.lens[e.have - 1], d = 3 + (u & 3), u >>>= 2, h -= 2;
              } else if (G === 17) {
                for (E = Q + 3; h < E; ) {
                  if (s === 0)
                    break A;
                  s--, u += r[i++] << h, h += 8;
                }
                u >>>= Q, h -= Q, iA = 0, d = 3 + (u & 7), u >>>= 3, h -= 3;
              } else {
                for (E = Q + 7; h < E; ) {
                  if (s === 0)
                    break A;
                  s--, u += r[i++] << h, h += 8;
                }
                u >>>= Q, h -= Q, iA = 0, d = 11 + (u & 127), u >>>= 7, h -= 7;
              }
              if (e.have + d > e.nlen + e.ndist) {
                t.msg = "invalid bit length repeat", e.mode = Ke;
                break;
              }
              for (; d--; )
                e.lens[e.have++] = iA;
            }
          }
          if (e.mode === Ke)
            break;
          if (e.lens[256] === 0) {
            t.msg = "invalid code -- missing end-of-block", e.mode = Ke;
            break;
          }
          if (e.lenbits = 9, Z = { bits: e.lenbits }, j = Ja(y1, e.lens, 0, e.nlen, e.lencode, 0, e.work, Z), e.lenbits = Z.bits, j) {
            t.msg = "invalid literal/lengths set", e.mode = Ke;
            break;
          }
          if (e.distbits = 6, e.distcode = e.distdyn, Z = { bits: e.distbits }, j = Ja(E1, e.lens, e.nlen, e.ndist, e.distcode, 0, e.work, Z), e.distbits = Z.bits, j) {
            t.msg = "invalid distances set", e.mode = Ke;
            break;
          }
          if (e.mode = uo, A === lo)
            break A;
        /* falls through */
        case uo:
          e.mode = fo;
        /* falls through */
        case fo:
          if (s >= 6 && c >= 258) {
            t.next_out = o, t.avail_out = c, t.next_in = i, t.avail_in = s, e.hold = u, e.bits = h, iv(t, w), o = t.next_out, n = t.output, c = t.avail_out, i = t.next_in, r = t.input, s = t.avail_in, u = e.hold, h = e.bits, e.mode === un && (e.back = -1);
            break;
          }
          for (e.back = 0; S = e.lencode[u & (1 << e.lenbits) - 1], Q = S >>> 24, P = S >>> 16 & 255, G = S & 65535, !(Q <= h); ) {
            if (s === 0)
              break A;
            s--, u += r[i++] << h, h += 8;
          }
          if (P && (P & 240) === 0) {
            for (k = Q, Y = P, z = G; S = e.lencode[z + ((u & (1 << k + Y) - 1) >> k)], Q = S >>> 24, P = S >>> 16 & 255, G = S & 65535, !(k + Q <= h); ) {
              if (s === 0)
                break A;
              s--, u += r[i++] << h, h += 8;
            }
            u >>>= k, h -= k, e.back += k;
          }
          if (u >>>= Q, h -= Q, e.back += Q, e.length = G, P === 0) {
            e.mode = Eh;
            break;
          }
          if (P & 32) {
            e.back = -1, e.mode = un;
            break;
          }
          if (P & 64) {
            t.msg = "invalid literal/length code", e.mode = Ke;
            break;
          }
          e.extra = P & 15, e.mode = Fh;
        /* falls through */
        case Fh:
          if (e.extra) {
            for (E = e.extra; h < E; ) {
              if (s === 0)
                break A;
              s--, u += r[i++] << h, h += 8;
            }
            e.length += u & (1 << e.extra) - 1, u >>>= e.extra, h -= e.extra, e.back += e.extra;
          }
          e.was = e.length, e.mode = Uh;
        /* falls through */
        case Uh:
          for (; S = e.distcode[u & (1 << e.distbits) - 1], Q = S >>> 24, P = S >>> 16 & 255, G = S & 65535, !(Q <= h); ) {
            if (s === 0)
              break A;
            s--, u += r[i++] << h, h += 8;
          }
          if ((P & 240) === 0) {
            for (k = Q, Y = P, z = G; S = e.distcode[z + ((u & (1 << k + Y) - 1) >> k)], Q = S >>> 24, P = S >>> 16 & 255, G = S & 65535, !(k + Q <= h); ) {
              if (s === 0)
                break A;
              s--, u += r[i++] << h, h += 8;
            }
            u >>>= k, h -= k, e.back += k;
          }
          if (u >>>= Q, h -= Q, e.back += Q, P & 64) {
            t.msg = "invalid distance code", e.mode = Ke;
            break;
          }
          e.offset = G, e.extra = P & 15, e.mode = bh;
        /* falls through */
        case bh:
          if (e.extra) {
            for (E = e.extra; h < E; ) {
              if (s === 0)
                break A;
              s--, u += r[i++] << h, h += 8;
            }
            e.offset += u & (1 << e.extra) - 1, u >>>= e.extra, h -= e.extra, e.back += e.extra;
          }
          if (e.offset > e.dmax) {
            t.msg = "invalid distance too far back", e.mode = Ke;
            break;
          }
          e.mode = yh;
        /* falls through */
        case yh:
          if (c === 0)
            break A;
          if (d = w - c, e.offset > d) {
            if (d = e.offset - d, d > e.whave && e.sane) {
              t.msg = "invalid distance too far back", e.mode = Ke;
              break;
            }
            d > e.wnext ? (d -= e.wnext, y = e.wsize - d) : y = e.wnext - d, d > e.length && (d = e.length), b = e.window;
          } else
            b = n, y = o - e.offset, d = e.length;
          d > c && (d = c), c -= d, e.length -= d;
          do
            n[o++] = b[y++];
          while (--d);
          e.length === 0 && (e.mode = fo);
          break;
        case Eh:
          if (c === 0)
            break A;
          n[o++] = e.length, c--, e.mode = fo;
          break;
        case il:
          if (e.wrap) {
            for (; h < 32; ) {
              if (s === 0)
                break A;
              s--, u |= r[i++] << h, h += 8;
            }
            if (w -= c, t.total_out += w, e.total += w, e.wrap & 4 && w && (t.adler = e.check = /*UPDATE_CHECK(state.check, put - _out, _out);*/
            e.flags ? Or(e.check, n, w, o - w) : Xl(e.check, n, w, o - w)), w = c, e.wrap & 4 && (e.flags ? u : Ih(u)) !== e.check) {
              t.msg = "incorrect data check", e.mode = Ke;
              break;
            }
            u = 0, h = 0;
          }
          e.mode = Lh;
        /* falls through */
        case Lh:
          if (e.wrap && e.flags) {
            for (; h < 32; ) {
              if (s === 0)
                break A;
              s--, u += r[i++] << h, h += 8;
            }
            if (e.wrap & 4 && u !== (e.total & 4294967295)) {
              t.msg = "incorrect length check", e.mode = Ke;
              break;
            }
            u = 0, h = 0;
          }
          e.mode = xh;
        /* falls through */
        case xh:
          j = hv;
          break A;
        case Ke:
          j = L1;
          break A;
        case I1:
          return x1;
        case S1:
        /* falls through */
        default:
          return fr;
      }
  return t.next_out = o, t.avail_out = c, t.next_in = i, t.avail_in = s, e.hold = u, e.bits = h, (e.wsize || w !== t.avail_out && e.mode < Ke && (e.mode < il || A !== sh)) && T1(t, t.output, t.next_out, w - t.avail_out), p -= t.avail_in, w -= t.avail_out, t.total_in += p, t.total_out += w, e.total += w, e.wrap & 4 && w && (t.adler = e.check = /*UPDATE_CHECK(state.check, strm.next_out - _out, _out);*/
  e.flags ? Or(e.check, n, w, t.next_out - w) : Xl(e.check, n, w, t.next_out - w)), t.data_type = e.bits + (e.last ? 64 : 0) + (e.mode === un ? 128 : 0) + (e.mode === uo || e.mode === nl ? 256 : 0), (p === 0 && w === 0 || A === sh) && j === pi && (j = dv), j;
}, Uv = (t) => {
  if (wi(t))
    return fr;
  let A = t.state;
  return A.window && (A.window = null), t.state = null, pi;
}, bv = (t, A) => {
  if (wi(t))
    return fr;
  const e = t.state;
  return (e.wrap & 2) === 0 ? fr : (e.head = A, A.done = !1, pi);
}, yv = (t, A) => {
  const e = A.length;
  let r, n, i;
  return wi(t) || (r = t.state, r.wrap !== 0 && r.mode !== Mo) ? fr : r.mode === Mo && (n = 1, n = Xl(n, A, e, 0), n !== r.check) ? L1 : (i = T1(t, A, e, e), i ? (r.mode = I1, x1) : (r.havedict = 1, pi));
};
var Ev = N1, Lv = _1, xv = H1, Iv = mv, Sv = D1, Hv = Fv, Nv = Uv, _v = bv, Dv = yv, Tv = "pako inflate (from Nodeca project)", fn = {
  inflateReset: Ev,
  inflateReset2: Lv,
  inflateResetKeep: xv,
  inflateInit: Iv,
  inflateInit2: Sv,
  inflate: Hv,
  inflateEnd: Nv,
  inflateGetHeader: _v,
  inflateSetDictionary: Dv,
  inflateInfo: Tv
};
function Ov() {
  this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
}
var kv = Ov;
const O1 = Object.prototype.toString, {
  Z_NO_FLUSH: Pv,
  Z_FINISH: Mv,
  Z_OK: As,
  Z_STREAM_END: ol,
  Z_NEED_DICT: cl,
  Z_STREAM_ERROR: Kv,
  Z_DATA_ERROR: Hh,
  Z_MEM_ERROR: Rv
} = F1;
function rs(t) {
  this.options = U1.assign({
    chunkSize: 1024 * 64,
    windowBits: 15,
    to: ""
  }, t || {});
  const A = this.options;
  A.raw && A.windowBits >= 0 && A.windowBits < 16 && (A.windowBits = -A.windowBits, A.windowBits === 0 && (A.windowBits = -15)), A.windowBits >= 0 && A.windowBits < 16 && !(t && t.windowBits) && (A.windowBits += 32), A.windowBits > 15 && A.windowBits < 48 && (A.windowBits & 15) === 0 && (A.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new rv(), this.strm.avail_out = 0;
  let e = fn.inflateInit2(
    this.strm,
    A.windowBits
  );
  if (e !== As)
    throw new Error(Jl[e]);
  if (this.header = new kv(), fn.inflateGetHeader(this.strm, this.header), A.dictionary && (typeof A.dictionary == "string" ? A.dictionary = Yl.string2buf(A.dictionary) : O1.call(A.dictionary) === "[object ArrayBuffer]" && (A.dictionary = new Uint8Array(A.dictionary)), A.raw && (e = fn.inflateSetDictionary(this.strm, A.dictionary), e !== As)))
    throw new Error(Jl[e]);
}
rs.prototype.push = function(t, A) {
  const e = this.strm, r = this.options.chunkSize, n = this.options.dictionary;
  let i, o, s;
  if (this.ended) return !1;
  for (A === ~~A ? o = A : o = A === !0 ? Mv : Pv, O1.call(t) === "[object ArrayBuffer]" ? e.input = new Uint8Array(t) : e.input = t, e.next_in = 0, e.avail_in = e.input.length; ; ) {
    for (e.avail_out === 0 && (e.output = new Uint8Array(r), e.next_out = 0, e.avail_out = r), i = fn.inflate(e, o), i === cl && n && (i = fn.inflateSetDictionary(e, n), i === As ? i = fn.inflate(e, o) : i === Hh && (i = cl)); e.avail_in > 0 && i === ol && e.state.wrap > 0 && t[e.next_in] !== 0; )
      fn.inflateReset(e), i = fn.inflate(e, o);
    switch (i) {
      case Kv:
      case Hh:
      case cl:
      case Rv:
        return this.onEnd(i), this.ended = !0, !1;
    }
    if (s = e.avail_out, e.next_out && (e.avail_out === 0 || i === ol))
      if (this.options.to === "string") {
        let c = Yl.utf8border(e.output, e.next_out), u = e.next_out - c, h = Yl.buf2string(e.output, c);
        e.next_out = u, e.avail_out = r - u, u && e.output.set(e.output.subarray(c, c + u), 0), this.onData(h);
      } else
        this.onData(e.output.length === e.next_out ? e.output : e.output.subarray(0, e.next_out));
    if (!(i === As && s === 0)) {
      if (i === ol)
        return i = fn.inflateEnd(this.strm), this.onEnd(i), this.ended = !0, !0;
      if (e.avail_in === 0) break;
    }
  }
  return !0;
};
rs.prototype.onData = function(t) {
  this.chunks.push(t);
};
rs.prototype.onEnd = function(t) {
  t === As && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = U1.flattenChunks(this.chunks)), this.chunks = [], this.err = t, this.msg = this.strm.msg;
};
function Gv(t, A) {
  const e = new rs(A);
  if (e.push(t), e.err) throw e.msg || Jl[e.err];
  return e.result;
}
var Vv = rs, jv = Gv, qv = {
  Inflate: Vv,
  inflate: jv
};
const { Inflate: Wv, inflate: Xv } = qv;
var Nh = Wv, Jv = Xv;
const k1 = [];
for (let t = 0; t < 256; t++) {
  let A = t;
  for (let e = 0; e < 8; e++)
    A & 1 ? A = 3988292384 ^ A >>> 1 : A = A >>> 1;
  k1[t] = A;
}
const _h = 4294967295;
function Yv(t, A, e) {
  let r = t;
  for (let n = 0; n < e; n++)
    r = k1[(r ^ A[n]) & 255] ^ r >>> 8;
  return r;
}
function zv(t, A) {
  return (Yv(_h, t, A) ^ _h) >>> 0;
}
function Dh(t, A, e) {
  const r = t.readUint32(), n = zv(new Uint8Array(t.buffer, t.byteOffset + t.offset - A - 4, A), A);
  if (n !== r)
    throw new Error(`CRC mismatch for chunk ${e}. Expected ${r}, found ${n}`);
}
function P1(t, A, e) {
  for (let r = 0; r < e; r++)
    A[r] = t[r];
}
function M1(t, A, e, r) {
  let n = 0;
  for (; n < r; n++)
    A[n] = t[n];
  for (; n < e; n++)
    A[n] = t[n] + A[n - r] & 255;
}
function K1(t, A, e, r) {
  let n = 0;
  if (e.length === 0)
    for (; n < r; n++)
      A[n] = t[n];
  else
    for (; n < r; n++)
      A[n] = t[n] + e[n] & 255;
}
function R1(t, A, e, r, n) {
  let i = 0;
  if (e.length === 0) {
    for (; i < n; i++)
      A[i] = t[i];
    for (; i < r; i++)
      A[i] = t[i] + (A[i - n] >> 1) & 255;
  } else {
    for (; i < n; i++)
      A[i] = t[i] + (e[i] >> 1) & 255;
    for (; i < r; i++)
      A[i] = t[i] + (A[i - n] + e[i] >> 1) & 255;
  }
}
function G1(t, A, e, r, n) {
  let i = 0;
  if (e.length === 0) {
    for (; i < n; i++)
      A[i] = t[i];
    for (; i < r; i++)
      A[i] = t[i] + A[i - n] & 255;
  } else {
    for (; i < n; i++)
      A[i] = t[i] + e[i] & 255;
    for (; i < r; i++)
      A[i] = t[i] + Zv(A[i - n], e[i], e[i - n]) & 255;
  }
}
function Zv(t, A, e) {
  const r = t + A - e, n = Math.abs(r - t), i = Math.abs(r - A), o = Math.abs(r - e);
  return n <= i && n <= o ? t : i <= o ? A : e;
}
function $v(t, A, e, r, n, i) {
  switch (t) {
    case 0:
      P1(A, e, n);
      break;
    case 1:
      M1(A, e, n, i);
      break;
    case 2:
      K1(A, e, r, n);
      break;
    case 3:
      R1(A, e, r, n, i);
      break;
    case 4:
      G1(A, e, r, n, i);
      break;
    default:
      throw new Error(`Unsupported filter: ${t}`);
  }
}
const A4 = new Uint16Array([255]), e4 = new Uint8Array(A4.buffer), t4 = e4[0] === 255;
function r4(t) {
  const { data: A, width: e, height: r, channels: n, depth: i } = t, o = [
    { x: 0, y: 0, xStep: 8, yStep: 8 },
    // Pass 1
    { x: 4, y: 0, xStep: 8, yStep: 8 },
    // Pass 2
    { x: 0, y: 4, xStep: 4, yStep: 8 },
    // Pass 3
    { x: 2, y: 0, xStep: 4, yStep: 4 },
    // Pass 4
    { x: 0, y: 2, xStep: 2, yStep: 4 },
    // Pass 5
    { x: 1, y: 0, xStep: 2, yStep: 2 },
    // Pass 6
    { x: 0, y: 1, xStep: 1, yStep: 2 }
    // Pass 7
  ], s = Math.ceil(i / 8) * n, c = new Uint8Array(r * e * s);
  let u = 0;
  for (let h = 0; h < 7; h++) {
    const p = o[h], w = Math.ceil((e - p.x) / p.xStep), d = Math.ceil((r - p.y) / p.yStep);
    if (w <= 0 || d <= 0)
      continue;
    const y = w * s, b = new Uint8Array(y);
    for (let S = 0; S < d; S++) {
      const Q = A[u++], P = A.subarray(u, u + y);
      u += y;
      const G = new Uint8Array(y);
      $v(Q, P, G, b, y, s), b.set(G);
      for (let k = 0; k < w; k++) {
        const Y = p.x + k * p.xStep, z = p.y + S * p.yStep;
        if (!(Y >= e || z >= r))
          for (let iA = 0; iA < s; iA++)
            c[(z * e + Y) * s + iA] = G[k * s + iA];
      }
    }
  }
  if (i === 16) {
    const h = new Uint16Array(c.buffer);
    if (t4)
      for (let p = 0; p < h.length; p++)
        h[p] = n4(h[p]);
    return h;
  } else
    return c;
}
function n4(t) {
  return (t & 255) << 8 | t >> 8 & 255;
}
const i4 = new Uint16Array([255]), a4 = new Uint8Array(i4.buffer), s4 = a4[0] === 255, o4 = new Uint8Array(0);
function Th(t) {
  const { data: A, width: e, height: r, channels: n, depth: i } = t, o = Math.ceil(i / 8) * n, s = Math.ceil(i / 8 * n * e), c = new Uint8Array(r * s);
  let u = o4, h = 0, p, w;
  for (let d = 0; d < r; d++) {
    switch (p = A.subarray(h + 1, h + 1 + s), w = c.subarray(d * s, (d + 1) * s), A[h]) {
      case 0:
        P1(p, w, s);
        break;
      case 1:
        M1(p, w, s, o);
        break;
      case 2:
        K1(p, w, u, s);
        break;
      case 3:
        R1(p, w, u, s, o);
        break;
      case 4:
        G1(p, w, u, s, o);
        break;
      default:
        throw new Error(`Unsupported filter: ${A[h]}`);
    }
    u = w, h += s + 1;
  }
  if (i === 16) {
    const d = new Uint16Array(c.buffer);
    if (s4)
      for (let y = 0; y < d.length; y++)
        d[y] = c4(d[y]);
    return d;
  } else
    return c;
}
function c4(t) {
  return (t & 255) << 8 | t >> 8 & 255;
}
const Fo = Uint8Array.of(137, 80, 78, 71, 13, 10, 26, 10);
function Oh(t) {
  if (!l4(t.readBytes(Fo.length)))
    throw new Error("wrong PNG signature");
}
function l4(t) {
  if (t.length < Fo.length)
    return !1;
  for (let A = 0; A < Fo.length; A++)
    if (t[A] !== Fo[A])
      return !1;
  return !0;
}
const u4 = "tEXt", f4 = 0, V1 = new TextDecoder("latin1");
function h4(t) {
  if (d4(t), t.length === 0 || t.length > 79)
    throw new Error("keyword length must be between 1 and 79");
}
const B4 = /^[\u0000-\u00FF]*$/;
function d4(t) {
  if (!B4.test(t))
    throw new Error("invalid latin1 text");
}
function g4(t, A, e) {
  const r = j1(A);
  t[r] = p4(A, e - r.length - 1);
}
function j1(t) {
  for (t.mark(); t.readByte() !== f4; )
    ;
  const A = t.offset;
  t.reset();
  const e = V1.decode(t.readBytes(A - t.offset - 1));
  return t.skip(1), h4(e), e;
}
function p4(t, A) {
  return V1.decode(t.readBytes(A));
}
const Yt = {
  UNKNOWN: -1,
  GREYSCALE: 0,
  TRUECOLOUR: 2,
  INDEXED_COLOUR: 3,
  GREYSCALE_ALPHA: 4,
  TRUECOLOUR_ALPHA: 6
}, ll = {
  UNKNOWN: -1,
  DEFLATE: 0
}, kh = {
  UNKNOWN: -1,
  ADAPTIVE: 0
}, ul = {
  UNKNOWN: -1,
  NO_INTERLACE: 0,
  ADAM7: 1
}, ho = {
  NONE: 0,
  BACKGROUND: 1,
  PREVIOUS: 2
}, fl = {
  SOURCE: 0,
  OVER: 1
};
class w4 extends uu {
  constructor(e, r = {}) {
    super(e);
    ye(this, "_checkCrc");
    ye(this, "_inflator");
    ye(this, "_png");
    ye(this, "_apng");
    ye(this, "_end");
    ye(this, "_hasPalette");
    ye(this, "_palette");
    ye(this, "_hasTransparency");
    ye(this, "_transparency");
    ye(this, "_compressionMethod");
    ye(this, "_filterMethod");
    ye(this, "_interlaceMethod");
    ye(this, "_colorType");
    ye(this, "_isAnimated");
    ye(this, "_numberOfFrames");
    ye(this, "_numberOfPlays");
    ye(this, "_frames");
    ye(this, "_writingDataChunks");
    const { checkCrc: n = !1 } = r;
    this._checkCrc = n, this._inflator = new Nh(), this._png = {
      width: -1,
      height: -1,
      channels: -1,
      data: new Uint8Array(0),
      depth: 1,
      text: {}
    }, this._apng = {
      width: -1,
      height: -1,
      channels: -1,
      depth: 1,
      numberOfFrames: 1,
      numberOfPlays: 0,
      text: {},
      frames: []
    }, this._end = !1, this._hasPalette = !1, this._palette = [], this._hasTransparency = !1, this._transparency = new Uint16Array(0), this._compressionMethod = ll.UNKNOWN, this._filterMethod = kh.UNKNOWN, this._interlaceMethod = ul.UNKNOWN, this._colorType = Yt.UNKNOWN, this._isAnimated = !1, this._numberOfFrames = 1, this._numberOfPlays = 0, this._frames = [], this._writingDataChunks = !1, this.setBigEndian();
  }
  decode() {
    for (Oh(this); !this._end; ) {
      const e = this.readUint32(), r = this.readChars(4);
      this.decodeChunk(e, r);
    }
    return this.decodeImage(), this._png;
  }
  decodeApng() {
    for (Oh(this); !this._end; ) {
      const e = this.readUint32(), r = this.readChars(4);
      this.decodeApngChunk(e, r);
    }
    return this.decodeApngImage(), this._apng;
  }
  // https://www.w3.org/TR/PNG/#5Chunk-layout
  decodeChunk(e, r) {
    const n = this.offset;
    switch (r) {
      // 11.2 Critical chunks
      case "IHDR":
        this.decodeIHDR();
        break;
      case "PLTE":
        this.decodePLTE(e);
        break;
      case "IDAT":
        this.decodeIDAT(e);
        break;
      case "IEND":
        this._end = !0;
        break;
      // 11.3 Ancillary chunks
      case "tRNS":
        this.decodetRNS(e);
        break;
      case "iCCP":
        this.decodeiCCP(e);
        break;
      case u4:
        g4(this._png.text, this, e);
        break;
      case "pHYs":
        this.decodepHYs();
        break;
      default:
        this.skip(e);
        break;
    }
    if (this.offset - n !== e)
      throw new Error(`Length mismatch while decoding chunk ${r}`);
    this._checkCrc ? Dh(this, e + 4, r) : this.skip(4);
  }
  decodeApngChunk(e, r) {
    const n = this.offset;
    switch (r !== "fdAT" && r !== "IDAT" && this._writingDataChunks && this.pushDataToFrame(), r) {
      case "acTL":
        this.decodeACTL();
        break;
      case "fcTL":
        this.decodeFCTL();
        break;
      case "fdAT":
        this.decodeFDAT(e);
        break;
      default:
        this.decodeChunk(e, r), this.offset = n + e;
        break;
    }
    if (this.offset - n !== e)
      throw new Error(`Length mismatch while decoding chunk ${r}`);
    this._checkCrc ? Dh(this, e + 4, r) : this.skip(4);
  }
  // https://www.w3.org/TR/PNG/#11IHDR
  decodeIHDR() {
    const e = this._png;
    e.width = this.readUint32(), e.height = this.readUint32(), e.depth = v4(this.readUint8());
    const r = this.readUint8();
    this._colorType = r;
    let n;
    switch (r) {
      case Yt.GREYSCALE:
        n = 1;
        break;
      case Yt.TRUECOLOUR:
        n = 3;
        break;
      case Yt.INDEXED_COLOUR:
        n = 1;
        break;
      case Yt.GREYSCALE_ALPHA:
        n = 2;
        break;
      case Yt.TRUECOLOUR_ALPHA:
        n = 4;
        break;
      // Kept for exhaustiveness.
      // eslint-disable-next-line unicorn/no-useless-switch-case
      case Yt.UNKNOWN:
      default:
        throw new Error(`Unknown color type: ${r}`);
    }
    if (this._png.channels = n, this._compressionMethod = this.readUint8(), this._compressionMethod !== ll.DEFLATE)
      throw new Error(`Unsupported compression method: ${this._compressionMethod}`);
    this._filterMethod = this.readUint8(), this._interlaceMethod = this.readUint8();
  }
  decodeACTL() {
    this._numberOfFrames = this.readUint32(), this._numberOfPlays = this.readUint32(), this._isAnimated = !0;
  }
  decodeFCTL() {
    const e = {
      sequenceNumber: this.readUint32(),
      width: this.readUint32(),
      height: this.readUint32(),
      xOffset: this.readUint32(),
      yOffset: this.readUint32(),
      delayNumber: this.readUint16(),
      delayDenominator: this.readUint16(),
      disposeOp: this.readUint8(),
      blendOp: this.readUint8(),
      data: new Uint8Array(0)
    };
    this._frames.push(e);
  }
  // https://www.w3.org/TR/PNG/#11PLTE
  decodePLTE(e) {
    if (e % 3 !== 0)
      throw new RangeError(`PLTE field length must be a multiple of 3. Got ${e}`);
    const r = e / 3;
    this._hasPalette = !0;
    const n = [];
    this._palette = n;
    for (let i = 0; i < r; i++)
      n.push([this.readUint8(), this.readUint8(), this.readUint8()]);
  }
  // https://www.w3.org/TR/PNG/#11IDAT
  decodeIDAT(e) {
    this._writingDataChunks = !0;
    const r = e, n = this.offset + this.byteOffset;
    if (this._inflator.push(new Uint8Array(this.buffer, n, r)), this._inflator.err)
      throw new Error(`Error while decompressing the data: ${this._inflator.err}`);
    this.skip(e);
  }
  decodeFDAT(e) {
    this._writingDataChunks = !0;
    let r = e, n = this.offset + this.byteOffset;
    if (n += 4, r -= 4, this._inflator.push(new Uint8Array(this.buffer, n, r)), this._inflator.err)
      throw new Error(`Error while decompressing the data: ${this._inflator.err}`);
    this.skip(e);
  }
  // https://www.w3.org/TR/PNG/#11tRNS
  decodetRNS(e) {
    switch (this._colorType) {
      case Yt.GREYSCALE:
      case Yt.TRUECOLOUR: {
        if (e % 2 !== 0)
          throw new RangeError(`tRNS chunk length must be a multiple of 2. Got ${e}`);
        if (e / 2 > this._png.width * this._png.height)
          throw new Error(`tRNS chunk contains more alpha values than there are pixels (${e / 2} vs ${this._png.width * this._png.height})`);
        this._hasTransparency = !0, this._transparency = new Uint16Array(e / 2);
        for (let r = 0; r < e / 2; r++)
          this._transparency[r] = this.readUint16();
        break;
      }
      case Yt.INDEXED_COLOUR: {
        if (e > this._palette.length)
          throw new Error(`tRNS chunk contains more alpha values than there are palette colors (${e} vs ${this._palette.length})`);
        let r = 0;
        for (; r < e; r++) {
          const n = this.readByte();
          this._palette[r].push(n);
        }
        for (; r < this._palette.length; r++)
          this._palette[r].push(255);
        break;
      }
      // Kept for exhaustiveness.
      /* eslint-disable unicorn/no-useless-switch-case */
      case Yt.UNKNOWN:
      case Yt.GREYSCALE_ALPHA:
      case Yt.TRUECOLOUR_ALPHA:
      default:
        throw new Error(`tRNS chunk is not supported for color type ${this._colorType}`);
    }
  }
  // https://www.w3.org/TR/PNG/#11iCCP
  decodeiCCP(e) {
    const r = j1(this), n = this.readUint8();
    if (n !== ll.DEFLATE)
      throw new Error(`Unsupported iCCP compression method: ${n}`);
    const i = this.readBytes(e - r.length - 2);
    this._png.iccEmbeddedProfile = {
      name: r,
      profile: Jv(i)
    };
  }
  // https://www.w3.org/TR/PNG/#11pHYs
  decodepHYs() {
    const e = this.readUint32(), r = this.readUint32(), n = this.readByte();
    this._png.resolution = { x: e, y: r, unit: n };
  }
  decodeApngImage() {
    this._apng.width = this._png.width, this._apng.height = this._png.height, this._apng.channels = this._png.channels, this._apng.depth = this._png.depth, this._apng.numberOfFrames = this._numberOfFrames, this._apng.numberOfPlays = this._numberOfPlays, this._apng.text = this._png.text, this._apng.resolution = this._png.resolution;
    for (let e = 0; e < this._numberOfFrames; e++) {
      const r = {
        sequenceNumber: this._frames[e].sequenceNumber,
        delayNumber: this._frames[e].delayNumber,
        delayDenominator: this._frames[e].delayDenominator,
        data: this._apng.depth === 8 ? new Uint8Array(this._apng.width * this._apng.height * this._apng.channels) : new Uint16Array(this._apng.width * this._apng.height * this._apng.channels)
      }, n = this._frames.at(e);
      if (n) {
        if (n.data = Th({
          data: n.data,
          width: n.width,
          height: n.height,
          channels: this._apng.channels,
          depth: this._apng.depth
        }), this._hasPalette && (this._apng.palette = this._palette), this._hasTransparency && (this._apng.transparency = this._transparency), e === 0 || n.xOffset === 0 && n.yOffset === 0 && n.width === this._png.width && n.height === this._png.height)
          r.data = n.data;
        else {
          const i = this._apng.frames.at(e - 1);
          this.disposeFrame(n, i, r), this.addFrameDataToCanvas(r, n);
        }
        this._apng.frames.push(r);
      }
    }
    return this._apng;
  }
  disposeFrame(e, r, n) {
    switch (e.disposeOp) {
      case ho.NONE:
        break;
      case ho.BACKGROUND:
        for (let i = 0; i < this._png.height; i++)
          for (let o = 0; o < this._png.width; o++) {
            const s = (i * e.width + o) * this._png.channels;
            for (let c = 0; c < this._png.channels; c++)
              n.data[s + c] = 0;
          }
        break;
      case ho.PREVIOUS:
        n.data.set(r.data);
        break;
      default:
        throw new Error("Unknown disposeOp");
    }
  }
  addFrameDataToCanvas(e, r) {
    const n = 1 << this._png.depth, i = (o, s) => {
      const c = ((o + r.yOffset) * this._png.width + r.xOffset + s) * this._png.channels, u = (o * r.width + s) * this._png.channels;
      return { index: c, frameIndex: u };
    };
    switch (r.blendOp) {
      case fl.SOURCE:
        for (let o = 0; o < r.height; o++)
          for (let s = 0; s < r.width; s++) {
            const { index: c, frameIndex: u } = i(o, s);
            for (let h = 0; h < this._png.channels; h++)
              e.data[c + h] = r.data[u + h];
          }
        break;
      // https://www.w3.org/TR/png-3/#13Alpha-channel-processing
      case fl.OVER:
        for (let o = 0; o < r.height; o++)
          for (let s = 0; s < r.width; s++) {
            const { index: c, frameIndex: u } = i(o, s);
            for (let h = 0; h < this._png.channels; h++) {
              const p = r.data[u + this._png.channels - 1] / n, w = h % (this._png.channels - 1) === 0 ? 1 : r.data[u + h], d = Math.floor(p * w + (1 - p) * e.data[c + h]);
              e.data[c + h] += d;
            }
          }
        break;
      default:
        throw new Error("Unknown blendOp");
    }
  }
  decodeImage() {
    var r;
    if (this._inflator.err)
      throw new Error(`Error while decompressing the data: ${this._inflator.err}`);
    const e = this._isAnimated ? ((r = this._frames) == null ? void 0 : r.at(0)).data : this._inflator.result;
    if (this._filterMethod !== kh.ADAPTIVE)
      throw new Error(`Filter method ${this._filterMethod} not supported`);
    if (this._interlaceMethod === ul.NO_INTERLACE)
      this._png.data = Th({
        data: e,
        width: this._png.width,
        height: this._png.height,
        channels: this._png.channels,
        depth: this._png.depth
      });
    else if (this._interlaceMethod === ul.ADAM7)
      this._png.data = r4({
        data: e,
        width: this._png.width,
        height: this._png.height,
        channels: this._png.channels,
        depth: this._png.depth
      });
    else
      throw new Error(`Interlace method ${this._interlaceMethod} not supported`);
    this._hasPalette && (this._png.palette = this._palette), this._hasTransparency && (this._png.transparency = this._transparency);
  }
  pushDataToFrame() {
    const e = this._inflator.result, r = this._frames.at(-1);
    r ? r.data = e : this._frames.push({
      sequenceNumber: 0,
      width: this._png.width,
      height: this._png.height,
      xOffset: 0,
      yOffset: 0,
      delayNumber: 0,
      delayDenominator: 0,
      disposeOp: ho.NONE,
      blendOp: fl.SOURCE,
      data: e
    }), this._inflator = new Nh(), this._writingDataChunks = !1;
  }
}
function v4(t) {
  if (t !== 1 && t !== 2 && t !== 4 && t !== 8 && t !== 16)
    throw new Error(`invalid bit depth: ${t}`);
  return t;
}
var Ph;
(function(t) {
  t[t.UNKNOWN = 0] = "UNKNOWN", t[t.METRE = 1] = "METRE";
})(Ph || (Ph = {}));
function C4(t, A) {
  return new w4(t, A).decode();
}
/** @license
 *
 * jsPDF - PDF Document creation from JavaScript
 * Version 3.0.4 Built on 2025-11-19T12:48:37.232Z
 *                      CommitID 00000000
 *
 * Copyright (c) 2010-2025 James Hall <james@parall.ax>, https://github.com/MrRio/jsPDF
 *               2015-2025 yWorks GmbH, http://www.yworks.com
 *               2015-2025 Lukas Holländer <lukas.hollaender@yworks.com>, https://github.com/HackbrettXXX
 *               2016-2018 Aras Abbasi <aras.abbasi@gmail.com>
 *               2010 Aaron Spike, https://github.com/acspike
 *               2012 Willow Systems Corporation, https://github.com/willowsystems
 *               2012 Pablo Hess, https://github.com/pablohess
 *               2012 Florian Jenett, https://github.com/fjenett
 *               2013 Warren Weckesser, https://github.com/warrenweckesser
 *               2013 Youssef Beddad, https://github.com/lifof
 *               2013 Lee Driscoll, https://github.com/lsdriscoll
 *               2013 Stefan Slonevskiy, https://github.com/stefslon
 *               2013 Jeremy Morel, https://github.com/jmorel
 *               2013 Christoph Hartmann, https://github.com/chris-rock
 *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
 *               2014 James Makes, https://github.com/dollaruw
 *               2014 Diego Casorran, https://github.com/diegocr
 *               2014 Steven Spungin, https://github.com/Flamenco
 *               2014 Kenneth Glassey, https://github.com/Gavvers
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 * Contributor(s):
 *    siefkenj, ahwolf, rickygu, Midnith, saintclair, eaparango,
 *    kim3er, mfo, alnorth, Flamenco
 */
var YA = /* @__PURE__ */ (function() {
  return typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : this;
})();
function hl() {
  YA.console && typeof YA.console.log == "function" && YA.console.log.apply(YA.console, arguments);
}
var Se = { log: hl, warn: function(t) {
  YA.console && (typeof YA.console.warn == "function" ? YA.console.warn.apply(YA.console, arguments) : hl.call(null, arguments));
}, error: function(t) {
  YA.console && (typeof YA.console.error == "function" ? YA.console.error.apply(YA.console, arguments) : hl(t));
} };
function Bl(t, A, e) {
  var r = new XMLHttpRequest();
  r.open("GET", t), r.responseType = "blob", r.onload = function() {
    ci(r.response, A, e);
  }, r.onerror = function() {
    Se.error("could not download file");
  }, r.send();
}
function Mh(t) {
  var A = new XMLHttpRequest();
  A.open("HEAD", t, !1);
  try {
    A.send();
  } catch {
  }
  return A.status >= 200 && A.status <= 299;
}
function Bo(t) {
  try {
    t.dispatchEvent(new MouseEvent("click"));
  } catch {
    var A = document.createEvent("MouseEvents");
    A.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), t.dispatchEvent(A);
  }
}
var ci = YA.saveAs || ((typeof window > "u" ? "undefined" : Ee(window)) !== "object" || window !== YA ? function() {
} : typeof HTMLAnchorElement < "u" && "download" in HTMLAnchorElement.prototype ? function(t, A, e) {
  var r = YA.URL || YA.webkitURL, n = document.createElement("a");
  A = A || t.name || "download", n.download = A, n.rel = "noopener", typeof t == "string" ? (n.href = t, n.origin !== location.origin ? Mh(n.href) ? Bl(t, A, e) : Bo(n, n.target = "_blank") : Bo(n)) : (n.href = r.createObjectURL(t), setTimeout(function() {
    r.revokeObjectURL(n.href);
  }, 4e4), setTimeout(function() {
    Bo(n);
  }, 0));
} : "msSaveOrOpenBlob" in navigator ? function(t, A, e) {
  if (A = A || t.name || "download", typeof t == "string") if (Mh(t)) Bl(t, A, e);
  else {
    var r = document.createElement("a");
    r.href = t, r.target = "_blank", setTimeout(function() {
      Bo(r);
    });
  }
  else navigator.msSaveOrOpenBlob((function(n, i) {
    return i === void 0 ? i = { autoBom: !1 } : Ee(i) !== "object" && (Se.warn("Deprecated: Expected third argument to be a object"), i = { autoBom: !i }), i.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(n.type) ? new Blob(["\uFEFF", n], { type: n.type }) : n;
  })(t, e), A);
} : function(t, A, e, r) {
  if ((r = r || open("", "_blank")) && (r.document.title = r.document.body.innerText = "downloading..."), typeof t == "string") return Bl(t, A, e);
  var n = t.type === "application/octet-stream", i = /constructor/i.test(YA.HTMLElement) || YA.safari, o = /CriOS\/[\d]+/.test(navigator.userAgent);
  if ((o || n && i) && (typeof FileReader > "u" ? "undefined" : Ee(FileReader)) === "object") {
    var s = new FileReader();
    s.onloadend = function() {
      var h = s.result;
      h = o ? h : h.replace(/^data:[^;]*;/, "data:attachment/file;"), r ? r.location.href = h : location = h, r = null;
    }, s.readAsDataURL(t);
  } else {
    var c = YA.URL || YA.webkitURL, u = c.createObjectURL(t);
    r ? r.location = u : location.href = u, r = null, setTimeout(function() {
      c.revokeObjectURL(u);
    }, 4e4);
  }
});
/**
 * A class to parse color values
 * @author Stoyan Stefanov <sstoo@gmail.com>
 * {@link   http://www.phpied.com/rgb-color-parser-in-javascript/}
 * @license Use it if you like it
 */
function q1(t) {
  var A;
  t = t || "", this.ok = !1, t.charAt(0) == "#" && (t = t.substr(1, 6)), t = { aliceblue: "f0f8ff", antiquewhite: "faebd7", aqua: "00ffff", aquamarine: "7fffd4", azure: "f0ffff", beige: "f5f5dc", bisque: "ffe4c4", black: "000000", blanchedalmond: "ffebcd", blue: "0000ff", blueviolet: "8a2be2", brown: "a52a2a", burlywood: "deb887", cadetblue: "5f9ea0", chartreuse: "7fff00", chocolate: "d2691e", coral: "ff7f50", cornflowerblue: "6495ed", cornsilk: "fff8dc", crimson: "dc143c", cyan: "00ffff", darkblue: "00008b", darkcyan: "008b8b", darkgoldenrod: "b8860b", darkgray: "a9a9a9", darkgreen: "006400", darkkhaki: "bdb76b", darkmagenta: "8b008b", darkolivegreen: "556b2f", darkorange: "ff8c00", darkorchid: "9932cc", darkred: "8b0000", darksalmon: "e9967a", darkseagreen: "8fbc8f", darkslateblue: "483d8b", darkslategray: "2f4f4f", darkturquoise: "00ced1", darkviolet: "9400d3", deeppink: "ff1493", deepskyblue: "00bfff", dimgray: "696969", dodgerblue: "1e90ff", feldspar: "d19275", firebrick: "b22222", floralwhite: "fffaf0", forestgreen: "228b22", fuchsia: "ff00ff", gainsboro: "dcdcdc", ghostwhite: "f8f8ff", gold: "ffd700", goldenrod: "daa520", gray: "808080", green: "008000", greenyellow: "adff2f", honeydew: "f0fff0", hotpink: "ff69b4", indianred: "cd5c5c", indigo: "4b0082", ivory: "fffff0", khaki: "f0e68c", lavender: "e6e6fa", lavenderblush: "fff0f5", lawngreen: "7cfc00", lemonchiffon: "fffacd", lightblue: "add8e6", lightcoral: "f08080", lightcyan: "e0ffff", lightgoldenrodyellow: "fafad2", lightgrey: "d3d3d3", lightgreen: "90ee90", lightpink: "ffb6c1", lightsalmon: "ffa07a", lightseagreen: "20b2aa", lightskyblue: "87cefa", lightslateblue: "8470ff", lightslategray: "778899", lightsteelblue: "b0c4de", lightyellow: "ffffe0", lime: "00ff00", limegreen: "32cd32", linen: "faf0e6", magenta: "ff00ff", maroon: "800000", mediumaquamarine: "66cdaa", mediumblue: "0000cd", mediumorchid: "ba55d3", mediumpurple: "9370d8", mediumseagreen: "3cb371", mediumslateblue: "7b68ee", mediumspringgreen: "00fa9a", mediumturquoise: "48d1cc", mediumvioletred: "c71585", midnightblue: "191970", mintcream: "f5fffa", mistyrose: "ffe4e1", moccasin: "ffe4b5", navajowhite: "ffdead", navy: "000080", oldlace: "fdf5e6", olive: "808000", olivedrab: "6b8e23", orange: "ffa500", orangered: "ff4500", orchid: "da70d6", palegoldenrod: "eee8aa", palegreen: "98fb98", paleturquoise: "afeeee", palevioletred: "d87093", papayawhip: "ffefd5", peachpuff: "ffdab9", peru: "cd853f", pink: "ffc0cb", plum: "dda0dd", powderblue: "b0e0e6", purple: "800080", red: "ff0000", rosybrown: "bc8f8f", royalblue: "4169e1", saddlebrown: "8b4513", salmon: "fa8072", sandybrown: "f4a460", seagreen: "2e8b57", seashell: "fff5ee", sienna: "a0522d", silver: "c0c0c0", skyblue: "87ceeb", slateblue: "6a5acd", slategray: "708090", snow: "fffafa", springgreen: "00ff7f", steelblue: "4682b4", tan: "d2b48c", teal: "008080", thistle: "d8bfd8", tomato: "ff6347", turquoise: "40e0d0", violet: "ee82ee", violetred: "d02090", wheat: "f5deb3", white: "ffffff", whitesmoke: "f5f5f5", yellow: "ffff00", yellowgreen: "9acd32" }[t = (t = t.replace(/ /g, "")).toLowerCase()] || t;
  for (var e = [{ re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/, example: ["rgb(123, 234, 45)", "rgb(255,234,245)"], process: function(s) {
    return [parseInt(s[1]), parseInt(s[2]), parseInt(s[3])];
  } }, { re: /^(\w{2})(\w{2})(\w{2})$/, example: ["#00ff00", "336699"], process: function(s) {
    return [parseInt(s[1], 16), parseInt(s[2], 16), parseInt(s[3], 16)];
  } }, { re: /^(\w{1})(\w{1})(\w{1})$/, example: ["#fb0", "f0f"], process: function(s) {
    return [parseInt(s[1] + s[1], 16), parseInt(s[2] + s[2], 16), parseInt(s[3] + s[3], 16)];
  } }], r = 0; r < e.length; r++) {
    var n = e[r].re, i = e[r].process, o = n.exec(t);
    o && (A = i(o), this.r = A[0], this.g = A[1], this.b = A[2], this.ok = !0);
  }
  this.r = this.r < 0 || isNaN(this.r) ? 0 : this.r > 255 ? 255 : this.r, this.g = this.g < 0 || isNaN(this.g) ? 0 : this.g > 255 ? 255 : this.g, this.b = this.b < 0 || isNaN(this.b) ? 0 : this.b > 255 ? 255 : this.b, this.toRGB = function() {
    return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
  }, this.toHex = function() {
    var s = this.r.toString(16), c = this.g.toString(16), u = this.b.toString(16);
    return s.length == 1 && (s = "0" + s), c.length == 1 && (c = "0" + c), u.length == 1 && (u = "0" + u), "#" + s + c + u;
  };
}
var Uo = YA.atob.bind(YA), Kh = YA.btoa.bind(YA);
/**
 * @license
 * Joseph Myers does not specify a particular license for his work.
 *
 * Author: Joseph Myers
 * Accessed from: http://www.myersdaily.org/joseph/javascript/md5.js
 *
 * Modified by: Owen Leong
 */
function dl(t, A) {
  var e = t[0], r = t[1], n = t[2], i = t[3];
  e = Et(e, r, n, i, A[0], 7, -680876936), i = Et(i, e, r, n, A[1], 12, -389564586), n = Et(n, i, e, r, A[2], 17, 606105819), r = Et(r, n, i, e, A[3], 22, -1044525330), e = Et(e, r, n, i, A[4], 7, -176418897), i = Et(i, e, r, n, A[5], 12, 1200080426), n = Et(n, i, e, r, A[6], 17, -1473231341), r = Et(r, n, i, e, A[7], 22, -45705983), e = Et(e, r, n, i, A[8], 7, 1770035416), i = Et(i, e, r, n, A[9], 12, -1958414417), n = Et(n, i, e, r, A[10], 17, -42063), r = Et(r, n, i, e, A[11], 22, -1990404162), e = Et(e, r, n, i, A[12], 7, 1804603682), i = Et(i, e, r, n, A[13], 12, -40341101), n = Et(n, i, e, r, A[14], 17, -1502002290), e = Lt(e, r = Et(r, n, i, e, A[15], 22, 1236535329), n, i, A[1], 5, -165796510), i = Lt(i, e, r, n, A[6], 9, -1069501632), n = Lt(n, i, e, r, A[11], 14, 643717713), r = Lt(r, n, i, e, A[0], 20, -373897302), e = Lt(e, r, n, i, A[5], 5, -701558691), i = Lt(i, e, r, n, A[10], 9, 38016083), n = Lt(n, i, e, r, A[15], 14, -660478335), r = Lt(r, n, i, e, A[4], 20, -405537848), e = Lt(e, r, n, i, A[9], 5, 568446438), i = Lt(i, e, r, n, A[14], 9, -1019803690), n = Lt(n, i, e, r, A[3], 14, -187363961), r = Lt(r, n, i, e, A[8], 20, 1163531501), e = Lt(e, r, n, i, A[13], 5, -1444681467), i = Lt(i, e, r, n, A[2], 9, -51403784), n = Lt(n, i, e, r, A[7], 14, 1735328473), e = xt(e, r = Lt(r, n, i, e, A[12], 20, -1926607734), n, i, A[5], 4, -378558), i = xt(i, e, r, n, A[8], 11, -2022574463), n = xt(n, i, e, r, A[11], 16, 1839030562), r = xt(r, n, i, e, A[14], 23, -35309556), e = xt(e, r, n, i, A[1], 4, -1530992060), i = xt(i, e, r, n, A[4], 11, 1272893353), n = xt(n, i, e, r, A[7], 16, -155497632), r = xt(r, n, i, e, A[10], 23, -1094730640), e = xt(e, r, n, i, A[13], 4, 681279174), i = xt(i, e, r, n, A[0], 11, -358537222), n = xt(n, i, e, r, A[3], 16, -722521979), r = xt(r, n, i, e, A[6], 23, 76029189), e = xt(e, r, n, i, A[9], 4, -640364487), i = xt(i, e, r, n, A[12], 11, -421815835), n = xt(n, i, e, r, A[15], 16, 530742520), e = It(e, r = xt(r, n, i, e, A[2], 23, -995338651), n, i, A[0], 6, -198630844), i = It(i, e, r, n, A[7], 10, 1126891415), n = It(n, i, e, r, A[14], 15, -1416354905), r = It(r, n, i, e, A[5], 21, -57434055), e = It(e, r, n, i, A[12], 6, 1700485571), i = It(i, e, r, n, A[3], 10, -1894986606), n = It(n, i, e, r, A[10], 15, -1051523), r = It(r, n, i, e, A[1], 21, -2054922799), e = It(e, r, n, i, A[8], 6, 1873313359), i = It(i, e, r, n, A[15], 10, -30611744), n = It(n, i, e, r, A[6], 15, -1560198380), r = It(r, n, i, e, A[13], 21, 1309151649), e = It(e, r, n, i, A[4], 6, -145523070), i = It(i, e, r, n, A[11], 10, -1120210379), n = It(n, i, e, r, A[2], 15, 718787259), r = It(r, n, i, e, A[9], 21, -343485551), t[0] = Pn(e, t[0]), t[1] = Pn(r, t[1]), t[2] = Pn(n, t[2]), t[3] = Pn(i, t[3]);
}
function Ac(t, A, e, r, n, i) {
  return A = Pn(Pn(A, t), Pn(r, i)), Pn(A << n | A >>> 32 - n, e);
}
function Et(t, A, e, r, n, i, o) {
  return Ac(A & e | ~A & r, t, A, n, i, o);
}
function Lt(t, A, e, r, n, i, o) {
  return Ac(A & r | e & ~r, t, A, n, i, o);
}
function xt(t, A, e, r, n, i, o) {
  return Ac(A ^ e ^ r, t, A, n, i, o);
}
function It(t, A, e, r, n, i, o) {
  return Ac(e ^ (A | ~r), t, A, n, i, o);
}
function W1(t) {
  var A, e = t.length, r = [1732584193, -271733879, -1732584194, 271733878];
  for (A = 64; A <= t.length; A += 64) dl(r, m4(t.substring(A - 64, A)));
  t = t.substring(A - 64);
  var n = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  for (A = 0; A < t.length; A++) n[A >> 2] |= t.charCodeAt(A) << (A % 4 << 3);
  if (n[A >> 2] |= 128 << (A % 4 << 3), A > 55) for (dl(r, n), A = 0; A < 16; A++) n[A] = 0;
  return n[14] = 8 * e, dl(r, n), r;
}
function m4(t) {
  var A, e = [];
  for (A = 0; A < 64; A += 4) e[A >> 2] = t.charCodeAt(A) + (t.charCodeAt(A + 1) << 8) + (t.charCodeAt(A + 2) << 16) + (t.charCodeAt(A + 3) << 24);
  return e;
}
var Rh = "0123456789abcdef".split("");
function Q4(t) {
  for (var A = "", e = 0; e < 4; e++) A += Rh[t >> 8 * e + 4 & 15] + Rh[t >> 8 * e & 15];
  return A;
}
function F4(t) {
  return String.fromCharCode(255 & t, (65280 & t) >> 8, (16711680 & t) >> 16, (4278190080 & t) >> 24);
}
function zl(t) {
  return W1(t).map(F4).join("");
}
var U4 = (function(t) {
  for (var A = 0; A < t.length; A++) t[A] = Q4(t[A]);
  return t.join("");
})(W1("hello")) != "5d41402abc4b2a76b9719d911017c592";
function Pn(t, A) {
  if (U4) {
    var e = (65535 & t) + (65535 & A);
    return (t >> 16) + (A >> 16) + (e >> 16) << 16 | 65535 & e;
  }
  return t + A & 4294967295;
}
/**
 * @license
 * FPDF is released under a permissive license: there is no usage restriction.
 * You may embed it freely in your application (commercial or not), with or
 * without modifications.
 *
 * Reference: http://www.fpdf.org/en/script/script37.php
 */
function Zl(t, A) {
  var e, r, n, i;
  if (t !== e) {
    for (var o = (n = t, i = 1 + (256 / t.length | 0), new Array(i + 1).join(n)), s = [], c = 0; c < 256; c++) s[c] = c;
    var u = 0;
    for (c = 0; c < 256; c++) {
      var h = s[c];
      u = (u + h + o.charCodeAt(c)) % 256, s[c] = s[u], s[u] = h;
    }
    e = t, r = s;
  } else s = r;
  var p = A.length, w = 0, d = 0, y = "";
  for (c = 0; c < p; c++) d = (d + (h = s[w = (w + 1) % 256])) % 256, s[w] = s[d], s[d] = h, o = s[(s[w] + s[d]) % 256], y += String.fromCharCode(A.charCodeAt(c) ^ o);
  return y;
}
/**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 * Author: Owen Leong (@owenl131)
 * Date: 15 Oct 2020
 * References:
 * https://www.cs.cmu.edu/~dst/Adobe/Gallery/anon21jul01-pdf-encryption.txt
 * https://github.com/foliojs/pdfkit/blob/master/lib/security.js
 * http://www.fpdf.org/en/script/script37.php
 */
var Gh = { print: 4, modify: 8, copy: 16, "annot-forms": 32 };
function Vi(t, A, e, r) {
  this.v = 1, this.r = 2;
  var n = 192;
  t.forEach(function(s) {
    if (Gh.perm !== void 0) throw new Error("Invalid permission: " + s);
    n += Gh[s];
  }), this.padding = "(¿N^NuAd\0NVÿú\b..\0¶Ðh>/\f©þdSiz";
  var i = (A + this.padding).substr(0, 32), o = (e + this.padding).substr(0, 32);
  this.O = this.processOwnerPassword(i, o), this.P = -(1 + (255 ^ n)), this.encryptionKey = zl(i + this.O + this.lsbFirstWord(this.P) + this.hexToBytes(r)).substr(0, 5), this.U = Zl(this.encryptionKey, this.padding);
}
function ji(t) {
  if (/[^\u0000-\u00ff]/.test(t)) throw new Error("Invalid PDF Name Object: " + t + ", Only accept ASCII characters.");
  for (var A = "", e = t.length, r = 0; r < e; r++) {
    var n = t.charCodeAt(r);
    A += n < 33 || n === 35 || n === 37 || n === 40 || n === 41 || n === 47 || n === 60 || n === 62 || n === 91 || n === 93 || n === 123 || n === 125 || n > 126 ? "#" + ("0" + n.toString(16)).slice(-2) : t[r];
  }
  return A;
}
function Vh(t) {
  if (Ee(t) !== "object") throw new Error("Invalid Context passed to initialize PubSub (jsPDF-module)");
  var A = {};
  this.subscribe = function(e, r, n) {
    if (n = n || !1, typeof e != "string" || typeof r != "function" || typeof n != "boolean") throw new Error("Invalid arguments passed to PubSub.subscribe (jsPDF-module)");
    A.hasOwnProperty(e) || (A[e] = {});
    var i = Math.random().toString(35);
    return A[e][i] = [r, !!n], i;
  }, this.unsubscribe = function(e) {
    for (var r in A) if (A[r][e]) return delete A[r][e], Object.keys(A[r]).length === 0 && delete A[r], !0;
    return !1;
  }, this.publish = function(e) {
    if (A.hasOwnProperty(e)) {
      var r = Array.prototype.slice.call(arguments, 1), n = [];
      for (var i in A[e]) {
        var o = A[e][i];
        try {
          o[0].apply(t, r);
        } catch (s) {
          YA.console && Se.error("jsPDF PubSub Error", s.message, s);
        }
        o[1] && n.push(i);
      }
      n.length && n.forEach(this.unsubscribe);
    }
  }, this.getTopics = function() {
    return A;
  };
}
function Ko(t) {
  if (!(this instanceof Ko)) return new Ko(t);
  var A = "opacity,stroke-opacity".split(",");
  for (var e in t) t.hasOwnProperty(e) && A.indexOf(e) >= 0 && (this[e] = t[e]);
  this.id = "", this.objectNumber = -1;
}
function X1(t, A) {
  this.gState = t, this.matrix = A, this.id = "", this.objectNumber = -1;
}
function ui(t, A, e, r, n) {
  if (!(this instanceof ui)) return new ui(t, A, e, r, n);
  this.type = t === "axial" ? 2 : 3, this.coords = A, this.colors = e, X1.call(this, r, n);
}
function Wi(t, A, e, r, n) {
  if (!(this instanceof Wi)) return new Wi(t, A, e, r, n);
  this.boundingBox = t, this.xStep = A, this.yStep = e, this.stream = "", this.cloneIndex = 0, X1.call(this, r, n);
}
function PA(t) {
  var A, e = typeof arguments[0] == "string" ? arguments[0] : "p", r = arguments[1], n = arguments[2], i = arguments[3], o = [], s = 1, c = 16, u = "S", h = null;
  Ee(t = t || {}) === "object" && (e = t.orientation, r = t.unit || r, n = t.format || n, i = t.compress || t.compressPdf || i, (h = t.encryption || null) !== null && (h.userPassword = h.userPassword || "", h.ownerPassword = h.ownerPassword || "", h.userPermissions = h.userPermissions || []), s = typeof t.userUnit == "number" ? Math.abs(t.userUnit) : 1, t.precision !== void 0 && (A = t.precision), t.floatPrecision !== void 0 && (c = t.floatPrecision), u = t.defaultPathOperation || "S"), o = t.filters || (i === !0 ? ["FlateEncode"] : o), r = r || "mm", e = ("" + (e || "P")).toLowerCase();
  var p = t.putOnlyUsedFonts || !1, w = {}, d = { internal: {}, __private__: {} };
  d.__private__.PubSub = Vh;
  var y = "1.3", b = d.__private__.getPdfVersion = function() {
    return y;
  };
  d.__private__.setPdfVersion = function(f) {
    y = f;
  };
  var S = { a0: [2383.94, 3370.39], a1: [1683.78, 2383.94], a2: [1190.55, 1683.78], a3: [841.89, 1190.55], a4: [595.28, 841.89], a5: [419.53, 595.28], a6: [297.64, 419.53], a7: [209.76, 297.64], a8: [147.4, 209.76], a9: [104.88, 147.4], a10: [73.7, 104.88], b0: [2834.65, 4008.19], b1: [2004.09, 2834.65], b2: [1417.32, 2004.09], b3: [1000.63, 1417.32], b4: [708.66, 1000.63], b5: [498.9, 708.66], b6: [354.33, 498.9], b7: [249.45, 354.33], b8: [175.75, 249.45], b9: [124.72, 175.75], b10: [87.87, 124.72], c0: [2599.37, 3676.54], c1: [1836.85, 2599.37], c2: [1298.27, 1836.85], c3: [918.43, 1298.27], c4: [649.13, 918.43], c5: [459.21, 649.13], c6: [323.15, 459.21], c7: [229.61, 323.15], c8: [161.57, 229.61], c9: [113.39, 161.57], c10: [79.37, 113.39], dl: [311.81, 623.62], letter: [612, 792], "government-letter": [576, 756], legal: [612, 1008], "junior-legal": [576, 360], ledger: [1224, 792], tabloid: [792, 1224], "credit-card": [153, 243] };
  d.__private__.getPageFormats = function() {
    return S;
  };
  var Q = d.__private__.getPageFormat = function(f) {
    return S[f];
  };
  n = n || "a4";
  var P = "compat", G = "advanced", k = P;
  function Y() {
    this.saveGraphicsState(), H(new XA(re, 0, 0, -re, 0, Zn() * re).toString() + " cm"), this.setFontSize(this.getFontSize() / re), u = "n", k = G;
  }
  function z() {
    this.restoreGraphicsState(), u = "S", k = P;
  }
  var iA = d.__private__.combineFontStyleAndFontWeight = function(f, v) {
    if (f == "bold" && v == "normal" || f == "bold" && v == 400 || f == "normal" && v == "italic" || f == "bold" && v == "italic") throw new Error("Invalid Combination of fontweight and fontstyle");
    return v && (f = v == 400 || v === "normal" ? f === "italic" ? "italic" : "normal" : v != 700 && v !== "bold" || f !== "normal" ? (v == 700 ? "bold" : v) + "" + f : "bold"), f;
  };
  d.advancedAPI = function(f) {
    var v = k === P;
    return v && Y.call(this), typeof f != "function" || (f(this), v && z.call(this)), this;
  }, d.compatAPI = function(f) {
    var v = k === G;
    return v && z.call(this), typeof f != "function" || (f(this), v && Y.call(this)), this;
  }, d.isAdvancedAPI = function() {
    return k === G;
  };
  var j, N = function(f) {
    if (k !== G) throw new Error(f + " is only available in 'advanced' API mode. You need to call advancedAPI() first.");
  }, Z = d.roundToPrecision = d.__private__.roundToPrecision = function(f, v) {
    var T = A || v;
    if (isNaN(f) || isNaN(T)) throw new Error("Invalid argument passed to jsPDF.roundToPrecision");
    return f.toFixed(T).replace(/0+$/, "");
  };
  j = d.hpf = d.__private__.hpf = typeof c == "number" ? function(f) {
    if (isNaN(f)) throw new Error("Invalid argument passed to jsPDF.hpf");
    return Z(f, c);
  } : c === "smart" ? function(f) {
    if (isNaN(f)) throw new Error("Invalid argument passed to jsPDF.hpf");
    return Z(f, f > -1 && f < 1 ? 16 : 5);
  } : function(f) {
    if (isNaN(f)) throw new Error("Invalid argument passed to jsPDF.hpf");
    return Z(f, 16);
  };
  var E = d.f2 = d.__private__.f2 = function(f) {
    if (isNaN(f)) throw new Error("Invalid argument passed to jsPDF.f2");
    return Z(f, 2);
  }, I = d.__private__.f3 = function(f) {
    if (isNaN(f)) throw new Error("Invalid argument passed to jsPDF.f3");
    return Z(f, 3);
  }, K = d.scale = d.__private__.scale = function(f) {
    if (isNaN(f)) throw new Error("Invalid argument passed to jsPDF.scale");
    return k === P ? f * re : k === G ? f : void 0;
  }, R = function(f) {
    return K((function(v) {
      return k === P ? Zn() - v : k === G ? v : void 0;
    })(f));
  };
  d.__private__.setPrecision = d.setPrecision = function(f) {
    typeof parseInt(f, 10) == "number" && (A = parseInt(f, 10));
  };
  var aA, sA = "00000000000000000000000000000000", oA = d.__private__.getFileId = function() {
    return sA;
  }, tA = d.__private__.setFileId = function(f) {
    return sA = f !== void 0 && /^[a-fA-F0-9]{32}$/.test(f) ? f.toUpperCase() : sA.split("").map(function() {
      return "ABCDEF0123456789".charAt(Math.floor(16 * Math.random()));
    }).join(""), h !== null && (st = new Vi(h.userPermissions, h.userPassword, h.ownerPassword, sA)), sA;
  };
  d.setFileId = function(f) {
    return tA(f), this;
  }, d.getFileId = function() {
    return oA();
  };
  var cA = d.__private__.convertDateToPDFDate = function(f) {
    var v = f.getTimezoneOffset(), T = v < 0 ? "+" : "-", V = Math.floor(Math.abs(v / 60)), $ = Math.abs(v % 60), BA = [T, M(V), "'", M($), "'"].join("");
    return ["D:", f.getFullYear(), M(f.getMonth() + 1), M(f.getDate()), M(f.getHours()), M(f.getMinutes()), M(f.getSeconds()), BA].join("");
  }, QA = d.__private__.convertPDFDateToDate = function(f) {
    var v = parseInt(f.substr(2, 4), 10), T = parseInt(f.substr(6, 2), 10) - 1, V = parseInt(f.substr(8, 2), 10), $ = parseInt(f.substr(10, 2), 10), BA = parseInt(f.substr(12, 2), 10), wA = parseInt(f.substr(14, 2), 10);
    return new Date(v, T, V, $, BA, wA, 0);
  }, pA = d.__private__.setCreationDate = function(f) {
    var v;
    if (f === void 0 && (f = /* @__PURE__ */ new Date()), f instanceof Date) v = cA(f);
    else {
      if (!/^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|-0[0-9]|-1[0-1])'(0[0-9]|[1-5][0-9])'?$/.test(f)) throw new Error("Invalid argument passed to jsPDF.setCreationDate");
      v = f;
    }
    return aA = v;
  }, F = d.__private__.getCreationDate = function(f) {
    var v = aA;
    return f === "jsDate" && (v = QA(aA)), v;
  };
  d.setCreationDate = function(f) {
    return pA(f), this;
  }, d.getCreationDate = function(f) {
    return F(f);
  };
  var O, M = d.__private__.padd2 = function(f) {
    return ("0" + parseInt(f)).slice(-2);
  }, q = d.__private__.padd2Hex = function(f) {
    return ("00" + (f = f.toString())).substr(f.length);
  }, X = 0, eA = [], lA = [], uA = 0, gA = [], FA = [], LA = !1, yA = lA;
  d.__private__.setCustomOutputDestination = function(f) {
    LA = !0, yA = f;
  };
  var KA = function(f) {
    LA || (yA = f);
  };
  d.__private__.resetCustomOutputDestination = function() {
    LA = !1, yA = lA;
  };
  var H = d.__private__.out = function(f) {
    return f = f.toString(), uA += f.length + 1, yA.push(f), yA;
  }, bA = d.__private__.write = function(f) {
    return H(arguments.length === 1 ? f.toString() : Array.prototype.join.call(arguments, " "));
  }, se = d.__private__.getArrayBuffer = function(f) {
    for (var v = f.length, T = new ArrayBuffer(v), V = new Uint8Array(T); v--; ) V[v] = f.charCodeAt(v);
    return T;
  }, jA = [["Helvetica", "helvetica", "normal", "WinAnsiEncoding"], ["Helvetica-Bold", "helvetica", "bold", "WinAnsiEncoding"], ["Helvetica-Oblique", "helvetica", "italic", "WinAnsiEncoding"], ["Helvetica-BoldOblique", "helvetica", "bolditalic", "WinAnsiEncoding"], ["Courier", "courier", "normal", "WinAnsiEncoding"], ["Courier-Bold", "courier", "bold", "WinAnsiEncoding"], ["Courier-Oblique", "courier", "italic", "WinAnsiEncoding"], ["Courier-BoldOblique", "courier", "bolditalic", "WinAnsiEncoding"], ["Times-Roman", "times", "normal", "WinAnsiEncoding"], ["Times-Bold", "times", "bold", "WinAnsiEncoding"], ["Times-Italic", "times", "italic", "WinAnsiEncoding"], ["Times-BoldItalic", "times", "bolditalic", "WinAnsiEncoding"], ["ZapfDingbats", "zapfdingbats", "normal", null], ["Symbol", "symbol", "normal", null]];
  d.__private__.getStandardFonts = function() {
    return jA;
  };
  var CA = t.fontSize || 16;
  d.__private__.setFontSize = d.setFontSize = function(f) {
    return CA = k === G ? f / re : f, this;
  };
  var qA, SA = d.__private__.getFontSize = d.getFontSize = function() {
    return k === P ? CA : CA * re;
  }, VA = t.R2L || !1;
  d.__private__.setR2L = d.setR2L = function(f) {
    return VA = f, this;
  }, d.__private__.getR2L = d.getR2L = function() {
    return VA;
  };
  var RA, Ce = d.__private__.setZoomMode = function(f) {
    if (/^(?:\d+\.\d*|\d*\.\d+|\d+)%$/.test(f)) qA = f;
    else if (isNaN(f)) {
      if ([void 0, null, "fullwidth", "fullheight", "fullpage", "original"].indexOf(f) === -1) throw new Error('zoom must be Integer (e.g. 2), a percentage Value (e.g. 300%) or fullwidth, fullheight, fullpage, original. "' + f + '" is not recognized.');
      qA = f;
    } else qA = parseInt(f, 10);
  };
  d.__private__.getZoomMode = function() {
    return qA;
  };
  var ue, Ae = d.__private__.setPageMode = function(f) {
    if ([void 0, null, "UseNone", "UseOutlines", "UseThumbs", "FullScreen"].indexOf(f) == -1) throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "' + f + '" is not recognized.');
    RA = f;
  };
  d.__private__.getPageMode = function() {
    return RA;
  };
  var Be = d.__private__.setLayoutMode = function(f) {
    if ([void 0, null, "continuous", "single", "twoleft", "tworight", "two"].indexOf(f) == -1) throw new Error('Layout mode must be one of continuous, single, twoleft, tworight. "' + f + '" is not recognized.');
    ue = f;
  };
  d.__private__.getLayoutMode = function() {
    return ue;
  }, d.__private__.setDisplayMode = d.setDisplayMode = function(f, v, T) {
    return Ce(f), Be(v), Ae(T), this;
  };
  var fe = { title: "", subject: "", author: "", keywords: "", creator: "" };
  d.__private__.getDocumentProperty = function(f) {
    if (Object.keys(fe).indexOf(f) === -1) throw new Error("Invalid argument passed to jsPDF.getDocumentProperty");
    return fe[f];
  }, d.__private__.getDocumentProperties = function() {
    return fe;
  }, d.__private__.setDocumentProperties = d.setProperties = d.setDocumentProperties = function(f) {
    for (var v in fe) fe.hasOwnProperty(v) && f[v] && (fe[v] = f[v]);
    return this;
  }, d.__private__.setDocumentProperty = function(f, v) {
    if (Object.keys(fe).indexOf(f) === -1) throw new Error("Invalid arguments passed to jsPDF.setDocumentProperty");
    return fe[f] = v;
  };
  var TA, re, MA, We, pe, oe = {}, ce = {}, ke = [], GA = {}, He = {}, JA = {}, ee = {}, Pe = null, le = 0, WA = [], me = new Vh(d), Vn = t.hotfixes || [], bt = {}, Gr = {}, Er = [], XA = function f(v, T, V, $, BA, wA) {
    if (!(this instanceof f)) return new f(v, T, V, $, BA, wA);
    isNaN(v) && (v = 1), isNaN(T) && (T = 0), isNaN(V) && (V = 0), isNaN($) && ($ = 1), isNaN(BA) && (BA = 0), isNaN(wA) && (wA = 0), this._matrix = [v, T, V, $, BA, wA];
  };
  Object.defineProperty(XA.prototype, "sx", { get: function() {
    return this._matrix[0];
  }, set: function(f) {
    this._matrix[0] = f;
  } }), Object.defineProperty(XA.prototype, "shy", { get: function() {
    return this._matrix[1];
  }, set: function(f) {
    this._matrix[1] = f;
  } }), Object.defineProperty(XA.prototype, "shx", { get: function() {
    return this._matrix[2];
  }, set: function(f) {
    this._matrix[2] = f;
  } }), Object.defineProperty(XA.prototype, "sy", { get: function() {
    return this._matrix[3];
  }, set: function(f) {
    this._matrix[3] = f;
  } }), Object.defineProperty(XA.prototype, "tx", { get: function() {
    return this._matrix[4];
  }, set: function(f) {
    this._matrix[4] = f;
  } }), Object.defineProperty(XA.prototype, "ty", { get: function() {
    return this._matrix[5];
  }, set: function(f) {
    this._matrix[5] = f;
  } }), Object.defineProperty(XA.prototype, "a", { get: function() {
    return this._matrix[0];
  }, set: function(f) {
    this._matrix[0] = f;
  } }), Object.defineProperty(XA.prototype, "b", { get: function() {
    return this._matrix[1];
  }, set: function(f) {
    this._matrix[1] = f;
  } }), Object.defineProperty(XA.prototype, "c", { get: function() {
    return this._matrix[2];
  }, set: function(f) {
    this._matrix[2] = f;
  } }), Object.defineProperty(XA.prototype, "d", { get: function() {
    return this._matrix[3];
  }, set: function(f) {
    this._matrix[3] = f;
  } }), Object.defineProperty(XA.prototype, "e", { get: function() {
    return this._matrix[4];
  }, set: function(f) {
    this._matrix[4] = f;
  } }), Object.defineProperty(XA.prototype, "f", { get: function() {
    return this._matrix[5];
  }, set: function(f) {
    this._matrix[5] = f;
  } }), Object.defineProperty(XA.prototype, "rotation", { get: function() {
    return Math.atan2(this.shx, this.sx);
  } }), Object.defineProperty(XA.prototype, "scaleX", { get: function() {
    return this.decompose().scale.sx;
  } }), Object.defineProperty(XA.prototype, "scaleY", { get: function() {
    return this.decompose().scale.sy;
  } }), Object.defineProperty(XA.prototype, "isIdentity", { get: function() {
    return this.sx === 1 && this.shy === 0 && this.shx === 0 && this.sy === 1 && this.tx === 0 && this.ty === 0;
  } }), XA.prototype.join = function(f) {
    return [this.sx, this.shy, this.shx, this.sy, this.tx, this.ty].map(j).join(f);
  }, XA.prototype.multiply = function(f) {
    var v = f.sx * this.sx + f.shy * this.shx, T = f.sx * this.shy + f.shy * this.sy, V = f.shx * this.sx + f.sy * this.shx, $ = f.shx * this.shy + f.sy * this.sy, BA = f.tx * this.sx + f.ty * this.shx + this.tx, wA = f.tx * this.shy + f.ty * this.sy + this.ty;
    return new XA(v, T, V, $, BA, wA);
  }, XA.prototype.decompose = function() {
    var f = this.sx, v = this.shy, T = this.shx, V = this.sy, $ = this.tx, BA = this.ty, wA = Math.sqrt(f * f + v * v), NA = (f /= wA) * T + (v /= wA) * V;
    T -= f * NA, V -= v * NA;
    var OA = Math.sqrt(T * T + V * V);
    return NA /= OA, f * (V /= OA) < v * (T /= OA) && (f = -f, v = -v, NA = -NA, wA = -wA), { scale: new XA(wA, 0, 0, OA, 0, 0), translate: new XA(1, 0, 0, 1, $, BA), rotate: new XA(f, v, -v, f, 0, 0), skew: new XA(1, 0, NA, 1, 0, 0) };
  }, XA.prototype.toString = function(f) {
    return this.join(" ");
  }, XA.prototype.inversed = function() {
    var f = this.sx, v = this.shy, T = this.shx, V = this.sy, $ = this.tx, BA = this.ty, wA = 1 / (f * V - v * T), NA = V * wA, OA = -v * wA, zA = -T * wA, ne = f * wA;
    return new XA(NA, OA, zA, ne, -NA * $ - zA * BA, -OA * $ - ne * BA);
  }, XA.prototype.applyToPoint = function(f) {
    var v = f.x * this.sx + f.y * this.shx + this.tx, T = f.x * this.shy + f.y * this.sy + this.ty;
    return new Yr(v, T);
  }, XA.prototype.applyToRectangle = function(f) {
    var v = this.applyToPoint(f), T = this.applyToPoint(new Yr(f.x + f.w, f.y + f.h));
    return new la(v.x, v.y, T.x - v.x, T.y - v.y);
  }, XA.prototype.clone = function() {
    var f = this.sx, v = this.shy, T = this.shx, V = this.sy, $ = this.tx, BA = this.ty;
    return new XA(f, v, T, V, $, BA);
  }, d.Matrix = XA;
  var Vr = d.matrixMult = function(f, v) {
    return v.multiply(f);
  }, jr = new XA(1, 0, 0, 1, 0, 0);
  d.unitMatrix = d.identityMatrix = jr;
  var $t = function(f, v) {
    if (!He[f]) {
      var T = (v instanceof ui ? "Sh" : "P") + (Object.keys(GA).length + 1).toString(10);
      v.id = T, He[f] = T, GA[T] = v, me.publish("addPattern", v);
    }
  };
  d.ShadingPattern = ui, d.TilingPattern = Wi, d.addShadingPattern = function(f, v) {
    return N("addShadingPattern()"), $t(f, v), this;
  }, d.beginTilingPattern = function(f) {
    N("beginTilingPattern()"), ua(f.boundingBox[0], f.boundingBox[1], f.boundingBox[2] - f.boundingBox[0], f.boundingBox[3] - f.boundingBox[1], f.matrix);
  }, d.endTilingPattern = function(f, v) {
    N("endTilingPattern()"), v.stream = FA[O].join(`
`), $t(f, v), me.publish("endTilingPattern", v), Er.pop().restore();
  };
  var Ar, Ge = d.__private__.newObject = function() {
    var f = Bt();
    return pt(f, !0), f;
  }, Bt = d.__private__.newObjectDeferred = function() {
    return X++, eA[X] = function() {
      return uA;
    }, X;
  }, pt = function(f, v) {
    return v = typeof v == "boolean" && v, eA[f] = uA, v && H(f + " 0 obj"), f;
  }, jn = d.__private__.newAdditionalObject = function() {
    var f = { objId: Bt(), content: "" };
    return gA.push(f), f;
  }, dn = Bt(), hr = Bt(), Lr = d.__private__.decodeColorString = function(f) {
    var v = f.split(" ");
    if (v.length !== 2 || v[1] !== "g" && v[1] !== "G") v.length !== 5 || v[4] !== "k" && v[4] !== "K" || (v = [(1 - v[0]) * (1 - v[3]), (1 - v[1]) * (1 - v[3]), (1 - v[2]) * (1 - v[3]), "r"]);
    else {
      var T = parseFloat(v[0]);
      v = [T, T, T, "r"];
    }
    for (var V = "#", $ = 0; $ < 3; $++) V += ("0" + Math.floor(255 * parseFloat(v[$])).toString(16)).slice(-2);
    return V;
  }, Br = d.__private__.encodeColorString = function(f) {
    var v;
    typeof f == "string" && (f = { ch1: f });
    var T = f.ch1, V = f.ch2, $ = f.ch3, BA = f.ch4, wA = f.pdfColorType === "draw" ? ["G", "RG", "K"] : ["g", "rg", "k"];
    if (typeof T == "string" && T.charAt(0) !== "#") {
      var NA = new q1(T);
      if (NA.ok) T = NA.toHex();
      else if (!/^\d*\.?\d*$/.test(T)) throw new Error('Invalid color "' + T + '" passed to jsPDF.encodeColorString.');
    }
    if (typeof T == "string" && /^#[0-9A-Fa-f]{3}$/.test(T) && (T = "#" + T[1] + T[1] + T[2] + T[2] + T[3] + T[3]), typeof T == "string" && /^#[0-9A-Fa-f]{6}$/.test(T)) {
      var OA = parseInt(T.substr(1), 16);
      T = OA >> 16 & 255, V = OA >> 8 & 255, $ = 255 & OA;
    }
    if (V === void 0 || BA === void 0 && T === V && V === $) v = typeof T == "string" ? T + " " + wA[0] : f.precision === 2 ? E(T / 255) + " " + wA[0] : I(T / 255) + " " + wA[0];
    else if (BA === void 0 || Ee(BA) === "object") {
      if (BA && !isNaN(BA.a) && BA.a === 0) return ["1.", "1.", "1.", wA[1]].join(" ");
      v = typeof T == "string" ? [T, V, $, wA[1]].join(" ") : f.precision === 2 ? [E(T / 255), E(V / 255), E($ / 255), wA[1]].join(" ") : [I(T / 255), I(V / 255), I($ / 255), wA[1]].join(" ");
    } else v = typeof T == "string" ? [T, V, $, BA, wA[2]].join(" ") : f.precision === 2 ? [E(T), E(V), E($), E(BA), wA[2]].join(" ") : [I(T), I(V), I($), I(BA), wA[2]].join(" ");
    return v;
  }, dr = d.__private__.getFilters = function() {
    return o;
  }, er = d.__private__.putStream = function(f) {
    var v = (f = f || {}).data || "", T = f.filters || dr(), V = f.alreadyAppliedFilters || [], $ = f.addLength1 || !1, BA = v.length, wA = f.objectId, NA = function(ot) {
      return ot;
    };
    if (h !== null && wA === void 0) throw new Error("ObjectId must be passed to putStream for file encryption");
    h !== null && (NA = st.encryptor(wA, 0));
    var OA = {};
    T === !0 && (T = ["FlateEncode"]);
    var zA = f.additionalKeyValues || [], ne = (OA = PA.API.processDataByFilters !== void 0 ? PA.API.processDataByFilters(v, T) : { data: v, reverseChain: [] }).reverseChain + (Array.isArray(V) ? V.join(" ") : V.toString());
    if (OA.data.length !== 0 && (zA.push({ key: "Length", value: OA.data.length }), $ === !0 && zA.push({ key: "Length1", value: BA })), ne.length != 0) if (ne.split("/").length - 1 == 1) zA.push({ key: "Filter", value: ne });
    else {
      zA.push({ key: "Filter", value: "[" + ne + "]" });
      for (var we = 0; we < zA.length; we += 1) if (zA[we].key === "DecodeParms") {
        for (var Re = [], nt = 0; nt < OA.reverseChain.split("/").length - 1; nt += 1) Re.push("null");
        Re.push(zA[we].value), zA[we].value = "[" + Re.join(" ") + "]";
      }
    }
    H("<<");
    for (var Ne = 0; Ne < zA.length; Ne++) H("/" + zA[Ne].key + " " + zA[Ne].value);
    H(">>"), OA.data.length !== 0 && (H("stream"), H(NA(OA.data)), H("endstream"));
  }, qn = d.__private__.putPage = function(f) {
    var v = f.number, T = f.data, V = f.objId, $ = f.contentsObjId;
    pt(V, !0), H("<</Type /Page"), H("/Parent " + f.rootDictionaryObjId + " 0 R"), H("/Resources " + f.resourceDictionaryObjId + " 0 R"), H("/MediaBox [" + parseFloat(j(f.mediaBox.bottomLeftX)) + " " + parseFloat(j(f.mediaBox.bottomLeftY)) + " " + j(f.mediaBox.topRightX) + " " + j(f.mediaBox.topRightY) + "]"), f.cropBox !== null && H("/CropBox [" + j(f.cropBox.bottomLeftX) + " " + j(f.cropBox.bottomLeftY) + " " + j(f.cropBox.topRightX) + " " + j(f.cropBox.topRightY) + "]"), f.bleedBox !== null && H("/BleedBox [" + j(f.bleedBox.bottomLeftX) + " " + j(f.bleedBox.bottomLeftY) + " " + j(f.bleedBox.topRightX) + " " + j(f.bleedBox.topRightY) + "]"), f.trimBox !== null && H("/TrimBox [" + j(f.trimBox.bottomLeftX) + " " + j(f.trimBox.bottomLeftY) + " " + j(f.trimBox.topRightX) + " " + j(f.trimBox.topRightY) + "]"), f.artBox !== null && H("/ArtBox [" + j(f.artBox.bottomLeftX) + " " + j(f.artBox.bottomLeftY) + " " + j(f.artBox.topRightX) + " " + j(f.artBox.topRightY) + "]"), typeof f.userUnit == "number" && f.userUnit !== 1 && H("/UserUnit " + f.userUnit), me.publish("putPage", { objId: V, pageContext: WA[v], pageNumber: v, page: T }), H("/Contents " + $ + " 0 R"), H(">>"), H("endobj");
    var BA = T.join(`
`);
    return k === G && (BA += `
Q`), pt($, !0), er({ data: BA, filters: dr(), objectId: $ }), H("endobj"), V;
  }, xr = d.__private__.putPages = function() {
    var f, v, T = [];
    for (f = 1; f <= le; f++) WA[f].objId = Bt(), WA[f].contentsObjId = Bt();
    for (f = 1; f <= le; f++) T.push(qn({ number: f, data: FA[f], objId: WA[f].objId, contentsObjId: WA[f].contentsObjId, mediaBox: WA[f].mediaBox, cropBox: WA[f].cropBox, bleedBox: WA[f].bleedBox, trimBox: WA[f].trimBox, artBox: WA[f].artBox, userUnit: WA[f].userUnit, rootDictionaryObjId: dn, resourceDictionaryObjId: hr }));
    pt(dn, !0), H("<</Type /Pages");
    var V = "/Kids [";
    for (v = 0; v < le; v++) V += T[v] + " 0 R ";
    H(V + "]"), H("/Count " + le), H(">>"), H("endobj"), me.publish("postPutPages");
  }, Wn = function(f) {
    me.publish("putFont", { font: f, out: H, newObject: Ge, putStream: er }), f.isAlreadyPutted !== !0 && (f.objectNumber = Ge(), H("<<"), H("/Type /Font"), H("/BaseFont /" + ji(f.postScriptName)), H("/Subtype /Type1"), typeof f.encoding == "string" && H("/Encoding /" + f.encoding), H("/FirstChar 32"), H("/LastChar 255"), H(">>"), H("endobj"));
  }, Ci = function(f) {
    f.objectNumber = Ge();
    var v = [];
    v.push({ key: "Type", value: "/XObject" }), v.push({ key: "Subtype", value: "/Form" }), v.push({ key: "BBox", value: "[" + [j(f.x), j(f.y), j(f.x + f.width), j(f.y + f.height)].join(" ") + "]" }), v.push({ key: "Matrix", value: "[" + f.matrix.toString() + "]" });
    var T = f.pages[1].join(`
`);
    er({ data: T, additionalKeyValues: v, objectId: f.objectNumber }), H("endobj");
  }, mi = function(f, v) {
    v || (v = 21);
    var T = Ge(), V = (function(wA, NA) {
      var OA, zA = [], ne = 1 / (NA - 1);
      for (OA = 0; OA < 1; OA += ne) zA.push(OA);
      if (zA.push(1), wA[0].offset != 0) {
        var we = { offset: 0, color: wA[0].color };
        wA.unshift(we);
      }
      if (wA[wA.length - 1].offset != 1) {
        var Re = { offset: 1, color: wA[wA.length - 1].color };
        wA.push(Re);
      }
      for (var nt = "", Ne = 0, ot = 0; ot < zA.length; ot++) {
        for (OA = zA[ot]; OA > wA[Ne + 1].offset; ) Ne++;
        var it = wA[Ne].offset, wt = (OA - it) / (wA[Ne + 1].offset - it), $r = wA[Ne].color, pr = wA[Ne + 1].color;
        nt += q(Math.round((1 - wt) * $r[0] + wt * pr[0]).toString(16)) + q(Math.round((1 - wt) * $r[1] + wt * pr[1]).toString(16)) + q(Math.round((1 - wt) * $r[2] + wt * pr[2]).toString(16));
      }
      return nt.trim();
    })(f.colors, v), $ = [];
    $.push({ key: "FunctionType", value: "0" }), $.push({ key: "Domain", value: "[0.0 1.0]" }), $.push({ key: "Size", value: "[" + v + "]" }), $.push({ key: "BitsPerSample", value: "8" }), $.push({ key: "Range", value: "[0.0 1.0 0.0 1.0 0.0 1.0]" }), $.push({ key: "Decode", value: "[0.0 1.0 0.0 1.0 0.0 1.0]" }), er({ data: V, additionalKeyValues: $, alreadyAppliedFilters: ["/ASCIIHexDecode"], objectId: T }), H("endobj"), f.objectNumber = Ge(), H("<< /ShadingType " + f.type), H("/ColorSpace /DeviceRGB");
    var BA = "/Coords [" + j(parseFloat(f.coords[0])) + " " + j(parseFloat(f.coords[1])) + " ";
    f.type === 2 ? BA += j(parseFloat(f.coords[2])) + " " + j(parseFloat(f.coords[3])) : BA += j(parseFloat(f.coords[2])) + " " + j(parseFloat(f.coords[3])) + " " + j(parseFloat(f.coords[4])) + " " + j(parseFloat(f.coords[5])), H(BA += "]"), f.matrix && H("/Matrix [" + f.matrix.toString() + "]"), H("/Function " + T + " 0 R"), H("/Extend [true true]"), H(">>"), H("endobj");
  }, Qi = function(f, v) {
    var T = Bt(), V = Ge();
    v.push({ resourcesOid: T, objectOid: V }), f.objectNumber = V;
    var $ = [];
    $.push({ key: "Type", value: "/Pattern" }), $.push({ key: "PatternType", value: "1" }), $.push({ key: "PaintType", value: "1" }), $.push({ key: "TilingType", value: "1" }), $.push({ key: "BBox", value: "[" + f.boundingBox.map(j).join(" ") + "]" }), $.push({ key: "XStep", value: j(f.xStep) }), $.push({ key: "YStep", value: j(f.yStep) }), $.push({ key: "Resources", value: T + " 0 R" }), f.matrix && $.push({ key: "Matrix", value: "[" + f.matrix.toString() + "]" }), er({ data: f.stream, additionalKeyValues: $, objectId: f.objectNumber }), H("endobj");
  }, ec = function(f) {
    for (var v in f.objectNumber = Ge(), H("<<"), f) switch (v) {
      case "opacity":
        H("/ca " + E(f[v]));
        break;
      case "stroke-opacity":
        H("/CA " + E(f[v]));
    }
    H(">>"), H("endobj");
  }, ta = function(f) {
    pt(f.resourcesOid, !0), H("<<"), H("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"), (function() {
      for (var v in H("/Font <<"), oe) oe.hasOwnProperty(v) && (p === !1 || p === !0 && w.hasOwnProperty(v)) && H("/" + v + " " + oe[v].objectNumber + " 0 R");
      H(">>");
    })(), (function() {
      if (Object.keys(GA).length > 0) {
        for (var v in H("/Shading <<"), GA) GA.hasOwnProperty(v) && GA[v] instanceof ui && GA[v].objectNumber >= 0 && H("/" + v + " " + GA[v].objectNumber + " 0 R");
        me.publish("putShadingPatternDict"), H(">>");
      }
    })(), (function(v) {
      if (Object.keys(GA).length > 0) {
        for (var T in H("/Pattern <<"), GA) GA.hasOwnProperty(T) && GA[T] instanceof d.TilingPattern && GA[T].objectNumber >= 0 && GA[T].objectNumber < v && H("/" + T + " " + GA[T].objectNumber + " 0 R");
        me.publish("putTilingPatternDict"), H(">>");
      }
    })(f.objectOid), (function() {
      if (Object.keys(JA).length > 0) {
        var v;
        for (v in H("/ExtGState <<"), JA) JA.hasOwnProperty(v) && JA[v].objectNumber >= 0 && H("/" + v + " " + JA[v].objectNumber + " 0 R");
        me.publish("putGStateDict"), H(">>");
      }
    })(), (function() {
      for (var v in H("/XObject <<"), bt) bt.hasOwnProperty(v) && bt[v].objectNumber >= 0 && H("/" + v + " " + bt[v].objectNumber + " 0 R");
      me.publish("putXobjectDict"), H(">>");
    })(), H(">>"), H("endobj");
  }, ns = function(f) {
    ce[f.fontName] = ce[f.fontName] || {}, ce[f.fontName][f.fontStyle] = f.id;
  }, is = function(f, v, T, V, $) {
    var BA = { id: "F" + (Object.keys(oe).length + 1).toString(10), postScriptName: f, fontName: v, fontStyle: T, encoding: V, isStandardFont: $ || !1, metadata: {} };
    return me.publish("addFont", { font: BA, instance: this }), oe[BA.id] = BA, ns(BA), BA.id;
  }, tr = d.__private__.pdfEscape = d.pdfEscape = function(f, v) {
    return (function(T, V) {
      var $, BA, wA, NA, OA, zA, ne, we, Re;
      if (wA = (V = V || {}).sourceEncoding || "Unicode", OA = V.outputEncoding, (V.autoencode || OA) && oe[TA].metadata && oe[TA].metadata[wA] && oe[TA].metadata[wA].encoding && (NA = oe[TA].metadata[wA].encoding, !OA && oe[TA].encoding && (OA = oe[TA].encoding), !OA && NA.codePages && (OA = NA.codePages[0]), typeof OA == "string" && (OA = NA[OA]), OA)) {
        for (ne = !1, zA = [], $ = 0, BA = T.length; $ < BA; $++) (we = OA[T.charCodeAt($)]) ? zA.push(String.fromCharCode(we)) : zA.push(T[$]), zA[$].charCodeAt(0) >> 8 && (ne = !0);
        T = zA.join("");
      }
      for ($ = T.length; ne === void 0 && $ !== 0; ) T.charCodeAt($ - 1) >> 8 && (ne = !0), $--;
      if (!ne) return T;
      for (zA = V.noBOM ? [] : [254, 255], $ = 0, BA = T.length; $ < BA; $++) {
        if ((Re = (we = T.charCodeAt($)) >> 8) >> 8) throw new Error("Character at position " + $ + " of string '" + T + "' exceeds 16bits. Cannot be encoded into UCS-2 BE");
        zA.push(Re), zA.push(we - (Re << 8));
      }
      return String.fromCharCode.apply(void 0, zA);
    })(f, v).replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
  }, ra = d.__private__.beginPage = function(f) {
    FA[++le] = [], WA[le] = { objId: 0, contentsObjId: 0, userUnit: Number(s), artBox: null, bleedBox: null, cropBox: null, trimBox: null, mediaBox: { bottomLeftX: 0, bottomLeftY: 0, topRightX: Number(f[0]), topRightY: Number(f[1]) } }, ss(le), KA(FA[O]);
  }, as = function(f, v) {
    var T, V, $;
    switch (e = v || e, typeof f == "string" && (T = Q(f.toLowerCase()), Array.isArray(T) && (V = T[0], $ = T[1])), Array.isArray(f) && (V = f[0] * re, $ = f[1] * re), isNaN(V) && (V = n[0], $ = n[1]), (V > 14400 || $ > 14400) && (Se.warn("A page in a PDF can not be wider or taller than 14400 userUnit. jsPDF limits the width/height to 14400"), V = Math.min(14400, V), $ = Math.min(14400, $)), n = [V, $], e.substr(0, 1)) {
      case "l":
        $ > V && (n = [$, V]);
        break;
      case "p":
        V > $ && (n = [$, V]);
    }
    ra(n), ZA(aa), H(yi), oa !== 0 && H(oa + " J"), ca !== 0 && H(ca + " j"), me.publish("addPage", { pageNumber: le });
  }, na = function(f) {
    f > 0 && f <= le && (FA.splice(f, 1), WA.splice(f, 1), le--, O > le && (O = le), this.setPage(O));
  }, ss = function(f) {
    f > 0 && f <= le && (O = f);
  }, os = d.__private__.getNumberOfPages = d.getNumberOfPages = function() {
    return FA.length - 1;
  }, cs = function(f, v, T) {
    var V, $ = void 0;
    return T = T || {}, f = f !== void 0 ? f : oe[TA].fontName, v = v !== void 0 ? v : oe[TA].fontStyle, V = f.toLowerCase(), ce[V] !== void 0 && ce[V][v] !== void 0 ? $ = ce[V][v] : ce[f] !== void 0 && ce[f][v] !== void 0 ? $ = ce[f][v] : T.disableWarning === !1 && Se.warn("Unable to look up font label for font '" + f + "', '" + v + "'. Refer to getFontList() for available fonts."), $ || T.noFallback || ($ = ce.times[v]) == null && ($ = ce.times.normal), $;
  }, Ir = d.__private__.putInfo = function() {
    var f = Ge(), v = function(V) {
      return V;
    };
    for (var T in h !== null && (v = st.encryptor(f, 0)), H("<<"), H("/Producer (" + tr(v("jsPDF " + PA.version)) + ")"), fe) fe.hasOwnProperty(T) && fe[T] && H("/" + T.substr(0, 1).toUpperCase() + T.substr(1) + " (" + tr(v(fe[T])) + ")");
    H("/CreationDate (" + tr(v(aA)) + ")"), H(">>"), H("endobj");
  }, Fi = d.__private__.putCatalog = function(f) {
    var v = (f = f || {}).rootDictionaryObjId || dn;
    switch (Ge(), H("<<"), H("/Type /Catalog"), H("/Pages " + v + " 0 R"), qA || (qA = "fullwidth"), qA) {
      case "fullwidth":
        H("/OpenAction [3 0 R /FitH null]");
        break;
      case "fullheight":
        H("/OpenAction [3 0 R /FitV null]");
        break;
      case "fullpage":
        H("/OpenAction [3 0 R /Fit]");
        break;
      case "original":
        H("/OpenAction [3 0 R /XYZ null null 1]");
        break;
      default:
        var T = "" + qA;
        T.substr(T.length - 1) === "%" && (qA = parseInt(qA) / 100), typeof qA == "number" && H("/OpenAction [3 0 R /XYZ null null " + E(qA) + "]");
    }
    switch (ue || (ue = "continuous"), ue) {
      case "continuous":
        H("/PageLayout /OneColumn");
        break;
      case "single":
        H("/PageLayout /SinglePage");
        break;
      case "two":
      case "twoleft":
        H("/PageLayout /TwoColumnLeft");
        break;
      case "tworight":
        H("/PageLayout /TwoColumnRight");
    }
    RA && H("/PageMode /" + RA), me.publish("putCatalog"), H(">>"), H("endobj");
  }, tc = d.__private__.putTrailer = function() {
    H("trailer"), H("<<"), H("/Size " + (X + 1)), H("/Root " + X + " 0 R"), H("/Info " + (X - 1) + " 0 R"), h !== null && H("/Encrypt " + st.oid + " 0 R"), H("/ID [ <" + sA + "> <" + sA + "> ]"), H(">>");
  }, rt = d.__private__.putHeader = function() {
    H("%PDF-" + y), H("%ºß¬à");
  }, ls = d.__private__.putXRef = function() {
    var f = "0000000000";
    H("xref"), H("0 " + (X + 1)), H("0000000000 65535 f ");
    for (var v = 1; v <= X; v++) typeof eA[v] == "function" ? H((f + eA[v]()).slice(-10) + " 00000 n ") : eA[v] !== void 0 ? H((f + eA[v]).slice(-10) + " 00000 n ") : H("0000000000 00000 n ");
  }, Sr = d.__private__.buildDocument = function() {
    var f;
    X = 0, uA = 0, lA = [], eA = [], gA = [], dn = Bt(), hr = Bt(), KA(lA), me.publish("buildDocument"), rt(), xr(), (function() {
      me.publish("putAdditionalObjects");
      for (var T = 0; T < gA.length; T++) {
        var V = gA[T];
        pt(V.objId, !0), H(V.content), H("endobj");
      }
      me.publish("postPutAdditionalObjects");
    })(), f = [], (function() {
      for (var T in oe) oe.hasOwnProperty(T) && (p === !1 || p === !0 && w.hasOwnProperty(T)) && Wn(oe[T]);
    })(), (function() {
      var T;
      for (T in JA) JA.hasOwnProperty(T) && ec(JA[T]);
    })(), (function() {
      for (var T in bt) bt.hasOwnProperty(T) && Ci(bt[T]);
    })(), (function(T) {
      var V;
      for (V in GA) GA.hasOwnProperty(V) && (GA[V] instanceof ui ? mi(GA[V]) : GA[V] instanceof Wi && Qi(GA[V], T));
    })(f), me.publish("putResources"), f.forEach(ta), ta({ resourcesOid: hr, objectOid: Number.MAX_SAFE_INTEGER }), me.publish("postPutResources"), h !== null && (st.oid = Ge(), H("<<"), H("/Filter /Standard"), H("/V " + st.v), H("/R " + st.r), H("/U <" + st.toHexString(st.U) + ">"), H("/O <" + st.toHexString(st.O) + ">"), H("/P " + st.P), H(">>"), H("endobj")), Ir(), Fi();
    var v = uA;
    return ls(), tc(), H("startxref"), H("" + v), H("%%EOF"), KA(FA[O]), lA.join(`
`);
  }, Ui = d.__private__.getBlob = function(f) {
    return new Blob([se(f)], { type: "application/pdf" });
  }, us = d.output = d.__private__.output = (Ar = function(f, v) {
    switch (typeof (v = v || {}) == "string" ? v = { filename: v } : v.filename = v.filename || "generated.pdf", f) {
      case void 0:
        return Sr();
      case "save":
        d.save(v.filename);
        break;
      case "arraybuffer":
        return se(Sr());
      case "blob":
        return Ui(Sr());
      case "bloburi":
      case "bloburl":
        if (YA.URL !== void 0 && typeof YA.URL.createObjectURL == "function") return YA.URL && YA.URL.createObjectURL(Ui(Sr())) || void 0;
        Se.warn("bloburl is not supported by your system, because URL.createObjectURL is not supported by your browser.");
        break;
      case "datauristring":
      case "dataurlstring":
        var T = "", V = Sr();
        try {
          T = Kh(V);
        } catch {
          T = Kh(unescape(encodeURIComponent(V)));
        }
        return "data:application/pdf;filename=" + v.filename + ";base64," + T;
      case "pdfobjectnewwindow":
        if (Object.prototype.toString.call(YA) === "[object Window]") {
          var $ = "https://cdnjs.cloudflare.com/ajax/libs/pdfobject/2.1.1/pdfobject.min.js", BA = ' integrity="sha512-4ze/a9/4jqu+tX9dfOqJYSvyYd5M6qum/3HpCLr+/Jqf0whc37VUbkpNGHR7/8pSnCFw47T1fmIpwBV7UySh3g==" crossorigin="anonymous"';
          v.pdfObjectUrl && ($ = v.pdfObjectUrl, BA = "");
          var wA = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><script src="' + $ + '"' + BA + '><\/script><script >PDFObject.embed("' + this.output("dataurlstring") + '", ' + JSON.stringify(v) + ");<\/script></body></html>", NA = YA.open();
          return NA !== null && NA.document.write(wA), NA;
        }
        throw new Error("The option pdfobjectnewwindow just works in a browser-environment.");
      case "pdfjsnewwindow":
        if (Object.prototype.toString.call(YA) === "[object Window]") {
          var OA = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe id="pdfViewer" src="' + (v.pdfJsUrl || "examples/PDF.js/web/viewer.html") + "?file=&downloadName=" + v.filename + '" width="500px" height="400px" /></body></html>', zA = YA.open();
          if (zA !== null) {
            zA.document.write(OA);
            var ne = this;
            zA.document.documentElement.querySelector("#pdfViewer").onload = function() {
              zA.document.title = v.filename, zA.document.documentElement.querySelector("#pdfViewer").contentWindow.PDFViewerApplication.open(ne.output("bloburl"));
            };
          }
          return zA;
        }
        throw new Error("The option pdfjsnewwindow just works in a browser-environment.");
      case "dataurlnewwindow":
        if (Object.prototype.toString.call(YA) !== "[object Window]") throw new Error("The option dataurlnewwindow just works in a browser-environment.");
        var we = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe src="' + this.output("datauristring", v) + '"></iframe></body></html>', Re = YA.open();
        if (Re !== null && (Re.document.write(we), Re.document.title = v.filename), Re || typeof safari > "u") return Re;
        break;
      case "datauri":
      case "dataurl":
        return YA.document.location.href = this.output("datauristring", v);
      default:
        return null;
    }
  }, Ar.foo = function() {
    try {
      return Ar.apply(this, arguments);
    } catch (T) {
      var f = T.stack || "";
      ~f.indexOf(" at ") && (f = f.split(" at ")[1]);
      var v = "Error in function " + f.split(`
`)[0].split("<")[0] + ": " + T.message;
      if (!YA.console) throw new Error(v);
      YA.console.error(v, T), YA.alert && alert(v);
    }
  }, Ar.foo.bar = Ar, Ar.foo), rr = function(f) {
    return Array.isArray(Vn) === !0 && Vn.indexOf(f) > -1;
  };
  switch (r) {
    case "pt":
      re = 1;
      break;
    case "mm":
      re = 72 / 25.4;
      break;
    case "cm":
      re = 72 / 2.54;
      break;
    case "in":
      re = 72;
      break;
    case "px":
      re = rr("px_scaling") == 1 ? 0.75 : 96 / 72;
      break;
    case "pc":
    case "em":
      re = 12;
      break;
    case "ex":
      re = 6;
      break;
    default:
      if (typeof r != "number") throw new Error("Invalid unit: " + r);
      re = r;
  }
  var st = null;
  pA(), tA();
  var qr = d.__private__.getPageInfo = d.getPageInfo = function(f) {
    if (isNaN(f) || f % 1 != 0) throw new Error("Invalid argument passed to jsPDF.getPageInfo");
    return { objId: WA[f].objId, pageNumber: f, pageContext: WA[f] };
  }, fs = d.__private__.getPageInfoByObjId = function(f) {
    if (isNaN(f) || f % 1 != 0) throw new Error("Invalid argument passed to jsPDF.getPageInfoByObjId");
    for (var v in WA) if (WA[v].objId === f) break;
    return qr(v);
  }, rc = d.__private__.getCurrentPageInfo = d.getCurrentPageInfo = function() {
    return { objId: WA[O].objId, pageNumber: O, pageContext: WA[O] };
  };
  d.addPage = function() {
    return as.apply(this, arguments), this;
  }, d.setPage = function() {
    return ss.apply(this, arguments), KA.call(this, FA[O]), this;
  }, d.insertPage = function(f) {
    return this.addPage(), this.movePage(O, f), this;
  }, d.movePage = function(f, v) {
    var T, V;
    if (f > v) {
      T = FA[f], V = WA[f];
      for (var $ = f; $ > v; $--) FA[$] = FA[$ - 1], WA[$] = WA[$ - 1];
      FA[v] = T, WA[v] = V, this.setPage(v);
    } else if (f < v) {
      T = FA[f], V = WA[f];
      for (var BA = f; BA < v; BA++) FA[BA] = FA[BA + 1], WA[BA] = WA[BA + 1];
      FA[v] = T, WA[v] = V, this.setPage(v);
    }
    return this;
  }, d.deletePage = function() {
    return na.apply(this, arguments), this;
  }, d.__private__.text = d.text = function(f, v, T, V, $) {
    var BA, wA, NA, OA, zA, ne, we, Re, nt, Ne = (V = V || {}).scope || this;
    if (typeof f == "number" && typeof v == "number" && (typeof T == "string" || Array.isArray(T))) {
      var ot = T;
      T = v, v = f, f = ot;
    }
    if (arguments[3] instanceof XA == 0 ? (NA = arguments[4], OA = arguments[5], Ee(we = arguments[3]) === "object" && we !== null || (typeof NA == "string" && (OA = NA, NA = null), typeof we == "string" && (OA = we, we = null), typeof we == "number" && (NA = we, we = null), V = { flags: we, angle: NA, align: OA })) : (N("The transform parameter of text() with a Matrix value"), nt = $), isNaN(v) || isNaN(T) || f == null) throw new Error("Invalid arguments passed to jsPDF.text");
    if (f.length === 0) return Ne;
    var it, wt = "", $r = typeof V.lineHeightFactor == "number" ? V.lineHeightFactor : Jn, pr = Ne.internal.scaleFactor;
    function An(Qe) {
      return Qe = Qe.split("	").join(Array(V.TabLen || 9).join(" ")), tr(Qe, we);
    }
    function ha(Qe) {
      for (var xe, Je = Qe.concat(), ct = [], rn = Je.length; rn--; ) typeof (xe = Je.shift()) == "string" ? ct.push(xe) : Array.isArray(Qe) && (xe.length === 1 || xe[1] === void 0 && xe[2] === void 0) ? ct.push(xe[0]) : ct.push([xe[0], xe[1], xe[2]]);
      return ct;
    }
    function Li(Qe, xe) {
      var Je;
      if (typeof Qe == "string") Je = xe(Qe)[0];
      else if (Array.isArray(Qe)) {
        for (var ct, rn, Fa = Qe.concat(), Si = [], Fs = Fa.length; Fs--; ) typeof (ct = Fa.shift()) == "string" ? Si.push(xe(ct)[0]) : Array.isArray(ct) && typeof ct[0] == "string" && (rn = xe(ct[0], ct[1], ct[2]), Si.push([rn[0], rn[1], rn[2]]));
        Je = Si;
      }
      return Je;
    }
    var gn = !1, $n = !0;
    if (typeof f == "string") gn = !0;
    else if (Array.isArray(f)) {
      var Ai = f.concat();
      wA = [];
      for (var pn, vt = Ai.length; vt--; ) (typeof (pn = Ai.shift()) != "string" || Array.isArray(pn) && typeof pn[0] != "string") && ($n = !1);
      gn = $n;
    }
    if (gn === !1) throw new Error('Type of text must be string or Array. "' + f + '" is not recognized.');
    typeof f == "string" && (f = f.match(/[\r?\n]/) ? f.split(/\r\n|\r|\n/g) : [f]);
    var ei = CA / Ne.internal.scaleFactor, ti = ei * ($r - 1);
    switch (V.baseline) {
      case "bottom":
        T -= ti;
        break;
      case "top":
        T += ei - ti;
        break;
      case "hanging":
        T += ei - 2 * ti;
        break;
      case "middle":
        T += ei / 2 - ti;
    }
    if ((ne = V.maxWidth || 0) > 0 && (typeof f == "string" ? f = Ne.splitTextToSize(f, ne) : Object.prototype.toString.call(f) === "[object Array]" && (f = f.reduce(function(Qe, xe) {
      return Qe.concat(Ne.splitTextToSize(xe, ne));
    }, []))), BA = { text: f, x: v, y: T, options: V, mutex: { pdfEscape: tr, activeFontKey: TA, fonts: oe, activeFontSize: CA } }, me.publish("preProcessText", BA), f = BA.text, NA = (V = BA.options).angle, nt instanceof XA == 0 && NA && typeof NA == "number") {
      NA *= Math.PI / 180, V.rotationDirection === 0 && (NA = -NA), k === G && (NA = -NA);
      var Ba = Math.cos(NA), da = Math.sin(NA);
      nt = new XA(Ba, da, -da, Ba, 0, 0);
    } else NA && NA instanceof XA && (nt = NA);
    k !== G || nt || (nt = jr), (zA = V.charSpace || Jr) !== void 0 && (wt += j(K(zA)) + ` Tc
`, this.setCharSpace(this.getCharSpace() || 0)), (Re = V.horizontalScale) !== void 0 && (wt += j(100 * Re) + ` Tz
`), V.lang;
    var Nt = -1, en = V.renderingMode !== void 0 ? V.renderingMode : V.stroke, xi = Ne.internal.getCurrentPageInfo().pageContext;
    switch (en) {
      case 0:
      case !1:
      case "fill":
        Nt = 0;
        break;
      case 1:
      case !0:
      case "stroke":
        Nt = 1;
        break;
      case 2:
      case "fillThenStroke":
        Nt = 2;
        break;
      case 3:
      case "invisible":
        Nt = 3;
        break;
      case 4:
      case "fillAndAddForClipping":
        Nt = 4;
        break;
      case 5:
      case "strokeAndAddPathForClipping":
        Nt = 5;
        break;
      case 6:
      case "fillThenStrokeAndAddToPathForClipping":
        Nt = 6;
        break;
      case 7:
      case "addToPathForClipping":
        Nt = 7;
    }
    var ms = xi.usedRenderingMode !== void 0 ? xi.usedRenderingMode : -1;
    Nt !== -1 ? wt += Nt + ` Tr
` : ms !== -1 && (wt += `0 Tr
`), Nt !== -1 && (xi.usedRenderingMode = Nt), OA = V.align || "left";
    var nr, ri = CA * $r, ga = Ne.internal.pageSize.getWidth(), pa = oe[TA];
    zA = V.charSpace || Jr, ne = V.maxWidth || 0, we = Object.assign({ autoencode: !0, noBOM: !0 }, V.flags);
    var wn = [], ni = function(Qe) {
      return Ne.getStringUnitWidth(Qe, { font: pa, charSpace: zA, fontSize: CA, doKerning: !1 }) * CA / pr;
    };
    if (Object.prototype.toString.call(f) === "[object Array]") {
      var Rt;
      wA = ha(f), OA !== "left" && (nr = wA.map(ni));
      var Gt, vn = 0;
      if (OA === "right") {
        v -= nr[0], f = [], vt = wA.length;
        for (var tn = 0; tn < vt; tn++) tn === 0 ? (Gt = Wr(v), Rt = Xr(T)) : (Gt = K(vn - nr[tn]), Rt = -ri), f.push([wA[tn], Gt, Rt]), vn = nr[tn];
      } else if (OA === "center") {
        v -= nr[0] / 2, f = [], vt = wA.length;
        for (var Cn = 0; Cn < vt; Cn++) Cn === 0 ? (Gt = Wr(v), Rt = Xr(T)) : (Gt = K((vn - nr[Cn]) / 2), Rt = -ri), f.push([wA[Cn], Gt, Rt]), vn = nr[Cn];
      } else if (OA === "left") {
        f = [], vt = wA.length;
        for (var wa = 0; wa < vt; wa++) f.push(wA[wa]);
      } else if (OA === "justify" && pa.encoding === "Identity-H") {
        f = [], vt = wA.length, ne = ne !== 0 ? ne : ga;
        for (var Ii = 0, Xe = 0; Xe < vt; Xe++) if (Rt = Xe === 0 ? Xr(T) : -ri, Gt = Xe === 0 ? Wr(v) : Ii, Xe < vt - 1) {
          var Qs = K((ne - nr[Xe]) / (wA[Xe].split(" ").length - 1)), Nr = wA[Xe].split(" ");
          f.push([Nr[0] + " ", Gt, Rt]), Ii = 0;
          for (var _r = 1; _r < Nr.length; _r++) {
            var va = (ni(Nr[_r - 1] + " " + Nr[_r]) - ni(Nr[_r])) * pr + Qs;
            _r == Nr.length - 1 ? f.push([Nr[_r], va, 0]) : f.push([Nr[_r] + " ", va, 0]), Ii -= va;
          }
        } else f.push([wA[Xe], Gt, Rt]);
        f.push(["", Ii, 0]);
      } else {
        if (OA !== "justify") throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');
        for (f = [], vt = wA.length, ne = ne !== 0 ? ne : ga, Xe = 0; Xe < vt; Xe++) {
          Rt = Xe === 0 ? Xr(T) : -ri, Gt = Xe === 0 ? Wr(v) : 0;
          var Ca = wA[Xe].split(" ").length - 1, ma = Ca > 0 ? (ne - nr[Xe]) / Ca : 0;
          Xe < vt - 1 ? wn.push(j(K(ma))) : wn.push(0), f.push([wA[Xe], Gt, Rt]);
        }
      }
    }
    (typeof V.R2L == "boolean" ? V.R2L : VA) === !0 && (f = Li(f, function(Qe, xe, Je) {
      return [Qe.split("").reverse().join(""), xe, Je];
    })), BA = { text: f, x: v, y: T, options: V, mutex: { pdfEscape: tr, activeFontKey: TA, fonts: oe, activeFontSize: CA } }, me.publish("postProcessText", BA), f = BA.text, it = BA.mutex.isHex || !1;
    var Qa = oe[TA].encoding;
    Qa !== "WinAnsiEncoding" && Qa !== "StandardEncoding" || (f = Li(f, function(Qe, xe, Je) {
      return [An(Qe), xe, Je];
    })), wA = ha(f), f = [];
    for (var mn, Qn, Fn, ii = Array.isArray(wA[0]) ? 1 : 0, Un = "", ai = function(Qe, xe, Je) {
      var ct = "";
      return Je instanceof XA ? (Je = typeof V.angle == "number" ? Vr(Je, new XA(1, 0, 0, 1, Qe, xe)) : Vr(new XA(1, 0, 0, 1, Qe, xe), Je), k === G && (Je = Vr(new XA(1, 0, 0, -1, 0, 0), Je)), ct = Je.join(" ") + ` Tm
`) : ct = j(Qe) + " " + j(xe) + ` Td
`, ct;
    }, ir = 0; ir < wA.length; ir++) {
      switch (Un = "", ii) {
        case 1:
          Fn = (it ? "<" : "(") + wA[ir][0] + (it ? ">" : ")"), mn = parseFloat(wA[ir][1]), Qn = parseFloat(wA[ir][2]);
          break;
        case 0:
          Fn = (it ? "<" : "(") + wA[ir] + (it ? ">" : ")"), mn = Wr(v), Qn = Xr(T);
      }
      wn !== void 0 && wn[ir] !== void 0 && (Un = wn[ir] + ` Tw
`), ir === 0 ? f.push(Un + ai(mn, Qn, nt) + Fn) : ii === 0 ? f.push(Un + Fn) : ii === 1 && f.push(Un + ai(mn, Qn, nt) + Fn);
    }
    f = ii === 0 ? f.join(` Tj
T* `) : f.join(` Tj
`), f += ` Tj
`;
    var Dr = `BT
/`;
    return Dr += TA + " " + CA + ` Tf
`, Dr += j(CA * $r) + ` TL
`, Dr += Yn + `
`, Dr += wt, Dr += f, H(Dr += "ET"), w[TA] = !0, Ne;
  };
  var nc = d.__private__.clip = d.clip = function(f) {
    return H(f === "evenodd" ? "W*" : "W"), this;
  };
  d.clipEvenOdd = function() {
    return nc("evenodd");
  }, d.__private__.discardPath = d.discardPath = function() {
    return H("n"), this;
  };
  var Hr = d.__private__.isValidStyle = function(f) {
    var v = !1;
    return [void 0, null, "S", "D", "F", "DF", "FD", "f", "f*", "B", "B*", "n"].indexOf(f) !== -1 && (v = !0), v;
  };
  d.__private__.setDefaultPathOperation = d.setDefaultPathOperation = function(f) {
    return Hr(f) && (u = f), this;
  };
  var hs = d.__private__.getStyle = d.getStyle = function(f) {
    var v = u;
    switch (f) {
      case "D":
      case "S":
        v = "S";
        break;
      case "F":
        v = "f";
        break;
      case "FD":
      case "DF":
        v = "B";
        break;
      case "f":
      case "f*":
      case "B":
      case "B*":
        v = f;
    }
    return v;
  }, Bs = d.close = function() {
    return H("h"), this;
  };
  d.stroke = function() {
    return H("S"), this;
  }, d.fill = function(f) {
    return bi("f", f), this;
  }, d.fillEvenOdd = function(f) {
    return bi("f*", f), this;
  }, d.fillStroke = function(f) {
    return bi("B", f), this;
  }, d.fillStrokeEvenOdd = function(f) {
    return bi("B*", f), this;
  };
  var bi = function(f, v) {
    Ee(v) === "object" ? ac(v, f) : H(f);
  }, Xn = function(f) {
    f === null || k === G && f === void 0 || (f = hs(f), H(f));
  };
  function ic(f, v, T, V, $) {
    var BA = new Wi(v || this.boundingBox, T || this.xStep, V || this.yStep, this.gState, $ || this.matrix);
    BA.stream = this.stream;
    var wA = f + "$$" + this.cloneIndex++ + "$$";
    return $t(wA, BA), BA;
  }
  var ac = function(f, v) {
    var T = He[f.key], V = GA[T];
    if (V instanceof ui) H("q"), H(sc(v)), V.gState && d.setGState(V.gState), H(f.matrix.toString() + " cm"), H("/" + T + " sh"), H("Q");
    else if (V instanceof Wi) {
      var $ = new XA(1, 0, 0, -1, 0, Zn());
      f.matrix && ($ = $.multiply(f.matrix || jr), T = ic.call(V, f.key, f.boundingBox, f.xStep, f.yStep, $).id), H("q"), H("/Pattern cs"), H("/" + T + " scn"), V.gState && d.setGState(V.gState), H(v), H("Q");
    }
  }, sc = function(f) {
    switch (f) {
      case "f":
      case "F":
      case "n":
        return "W n";
      case "f*":
        return "W* n";
      case "B":
      case "S":
        return "W S";
      case "B*":
        return "W* S";
    }
  }, ia = d.moveTo = function(f, v) {
    return H(j(K(f)) + " " + j(R(v)) + " m"), this;
  }, ds = d.lineTo = function(f, v) {
    return H(j(K(f)) + " " + j(R(v)) + " l"), this;
  }, gr = d.curveTo = function(f, v, T, V, $, BA) {
    return H([j(K(f)), j(R(v)), j(K(T)), j(R(V)), j(K($)), j(R(BA)), "c"].join(" ")), this;
  };
  d.__private__.line = d.line = function(f, v, T, V, $) {
    if (isNaN(f) || isNaN(v) || isNaN(T) || isNaN(V) || !Hr($)) throw new Error("Invalid arguments passed to jsPDF.line");
    return k === P ? this.lines([[T - f, V - v]], f, v, [1, 1], $ || "S") : this.lines([[T - f, V - v]], f, v, [1, 1]).stroke();
  }, d.__private__.lines = d.lines = function(f, v, T, V, $, BA) {
    var wA, NA, OA, zA, ne, we, Re, nt, Ne, ot, it, wt;
    if (typeof f == "number" && (wt = T, T = v, v = f, f = wt), V = V || [1, 1], BA = BA || !1, isNaN(v) || isNaN(T) || !Array.isArray(f) || !Array.isArray(V) || !Hr($) || typeof BA != "boolean") throw new Error("Invalid arguments passed to jsPDF.lines");
    for (ia(v, T), wA = V[0], NA = V[1], zA = f.length, ot = v, it = T, OA = 0; OA < zA; OA++) (ne = f[OA]).length === 2 ? (ot = ne[0] * wA + ot, it = ne[1] * NA + it, ds(ot, it)) : (we = ne[0] * wA + ot, Re = ne[1] * NA + it, nt = ne[2] * wA + ot, Ne = ne[3] * NA + it, ot = ne[4] * wA + ot, it = ne[5] * NA + it, gr(we, Re, nt, Ne, ot, it));
    return BA && Bs(), Xn($), this;
  }, d.path = function(f) {
    for (var v = 0; v < f.length; v++) {
      var T = f[v], V = T.c;
      switch (T.op) {
        case "m":
          ia(V[0], V[1]);
          break;
        case "l":
          ds(V[0], V[1]);
          break;
        case "c":
          gr.apply(this, V);
          break;
        case "h":
          Bs();
      }
    }
    return this;
  }, d.__private__.rect = d.rect = function(f, v, T, V, $) {
    if (isNaN(f) || isNaN(v) || isNaN(T) || isNaN(V) || !Hr($)) throw new Error("Invalid arguments passed to jsPDF.rect");
    return k === P && (V = -V), H([j(K(f)), j(R(v)), j(K(T)), j(K(V)), "re"].join(" ")), Xn($), this;
  }, d.__private__.triangle = d.triangle = function(f, v, T, V, $, BA, wA) {
    if (isNaN(f) || isNaN(v) || isNaN(T) || isNaN(V) || isNaN($) || isNaN(BA) || !Hr(wA)) throw new Error("Invalid arguments passed to jsPDF.triangle");
    return this.lines([[T - f, V - v], [$ - T, BA - V], [f - $, v - BA]], f, v, [1, 1], wA, !0), this;
  }, d.__private__.roundedRect = d.roundedRect = function(f, v, T, V, $, BA, wA) {
    if (isNaN(f) || isNaN(v) || isNaN(T) || isNaN(V) || isNaN($) || isNaN(BA) || !Hr(wA)) throw new Error("Invalid arguments passed to jsPDF.roundedRect");
    var NA = 4 / 3 * (Math.SQRT2 - 1);
    return $ = Math.min($, 0.5 * T), BA = Math.min(BA, 0.5 * V), this.lines([[T - 2 * $, 0], [$ * NA, 0, $, BA - BA * NA, $, BA], [0, V - 2 * BA], [0, BA * NA, -$ * NA, BA, -$, BA], [2 * $ - T, 0], [-$ * NA, 0, -$, -BA * NA, -$, -BA], [0, 2 * BA - V], [0, -BA * NA, $ * NA, -BA, $, -BA]], f + $, v, [1, 1], wA, !0), this;
  }, d.__private__.ellipse = d.ellipse = function(f, v, T, V, $) {
    if (isNaN(f) || isNaN(v) || isNaN(T) || isNaN(V) || !Hr($)) throw new Error("Invalid arguments passed to jsPDF.ellipse");
    var BA = 4 / 3 * (Math.SQRT2 - 1) * T, wA = 4 / 3 * (Math.SQRT2 - 1) * V;
    return ia(f + T, v), gr(f + T, v - wA, f + BA, v - V, f, v - V), gr(f - BA, v - V, f - T, v - wA, f - T, v), gr(f - T, v + wA, f - BA, v + V, f, v + V), gr(f + BA, v + V, f + T, v + wA, f + T, v), Xn($), this;
  }, d.__private__.circle = d.circle = function(f, v, T, V) {
    if (isNaN(f) || isNaN(v) || isNaN(T) || !Hr(V)) throw new Error("Invalid arguments passed to jsPDF.circle");
    return this.ellipse(f, v, T, T, V);
  }, d.setFont = function(f, v, T) {
    return T && (v = iA(v, T)), TA = cs(f, v, { disableWarning: !1 }), this;
  };
  var oc = d.__private__.getFont = d.getFont = function() {
    return oe[cs.apply(d, arguments)];
  };
  d.__private__.getFontList = d.getFontList = function() {
    var f, v, T = {};
    for (f in ce) if (ce.hasOwnProperty(f)) for (v in T[f] = [], ce[f]) ce[f].hasOwnProperty(v) && T[f].push(v);
    return T;
  }, d.addFont = function(f, v, T, V, $) {
    var BA = ["StandardEncoding", "MacRomanEncoding", "Identity-H", "WinAnsiEncoding"];
    return arguments[3] && BA.indexOf(arguments[3]) !== -1 ? $ = arguments[3] : arguments[3] && BA.indexOf(arguments[3]) == -1 && (T = iA(T, V)), is.call(this, f, v, T, $ = $ || "Identity-H");
  };
  var Jn, aa = t.lineWidth || 0.200025, cc = d.__private__.getLineWidth = d.getLineWidth = function() {
    return aa;
  }, ZA = d.__private__.setLineWidth = d.setLineWidth = function(f) {
    return aa = f, H(j(K(f)) + " w"), this;
  };
  d.__private__.setLineDash = PA.API.setLineDash = PA.API.setLineDashPattern = function(f, v) {
    if (f = f || [], v = v || 0, isNaN(v) || !Array.isArray(f)) throw new Error("Invalid arguments passed to jsPDF.setLineDash");
    return f = f.map(function(T) {
      return j(K(T));
    }).join(" "), v = j(K(v)), H("[" + f + "] " + v + " d"), this;
  };
  var lc = d.__private__.getLineHeight = d.getLineHeight = function() {
    return CA * Jn;
  };
  d.__private__.getLineHeight = d.getLineHeight = function() {
    return CA * Jn;
  };
  var uc = d.__private__.setLineHeightFactor = d.setLineHeightFactor = function(f) {
    return typeof (f = f || 1.15) == "number" && (Jn = f), this;
  }, fc = d.__private__.getLineHeightFactor = d.getLineHeightFactor = function() {
    return Jn;
  };
  uc(t.lineHeight);
  var Wr = d.__private__.getHorizontalCoordinate = function(f) {
    return K(f);
  }, Xr = d.__private__.getVerticalCoordinate = function(f) {
    return k === G ? f : WA[O].mediaBox.topRightY - WA[O].mediaBox.bottomLeftY - K(f);
  }, hc = d.__private__.getHorizontalCoordinateString = d.getHorizontalCoordinateString = function(f) {
    return j(Wr(f));
  }, Bc = d.__private__.getVerticalCoordinateString = d.getVerticalCoordinateString = function(f) {
    return j(Xr(f));
  }, yi = t.strokeColor || "0 G";
  d.__private__.getStrokeColor = d.getDrawColor = function() {
    return Lr(yi);
  }, d.__private__.setStrokeColor = d.setDrawColor = function(f, v, T, V) {
    return yi = Br({ ch1: f, ch2: v, ch3: T, ch4: V, pdfColorType: "draw", precision: 2 }), H(yi), this;
  };
  var sa = t.fillColor || "0 g";
  d.__private__.getFillColor = d.getFillColor = function() {
    return Lr(sa);
  }, d.__private__.setFillColor = d.setFillColor = function(f, v, T, V) {
    return sa = Br({ ch1: f, ch2: v, ch3: T, ch4: V, pdfColorType: "fill", precision: 2 }), H(sa), this;
  };
  var Yn = t.textColor || "0 g", dc = d.__private__.getTextColor = d.getTextColor = function() {
    return Lr(Yn);
  };
  d.__private__.setTextColor = d.setTextColor = function(f, v, T, V) {
    return Yn = Br({ ch1: f, ch2: v, ch3: T, ch4: V, pdfColorType: "text", precision: 3 }), this;
  };
  var Jr = t.charSpace, gc = d.__private__.getCharSpace = d.getCharSpace = function() {
    return parseFloat(Jr || 0);
  };
  d.__private__.setCharSpace = d.setCharSpace = function(f) {
    if (isNaN(f)) throw new Error("Invalid argument passed to jsPDF.setCharSpace");
    return Jr = f, this;
  };
  var oa = 0;
  d.CapJoinStyles = { 0: 0, butt: 0, but: 0, miter: 0, 1: 1, round: 1, rounded: 1, circle: 1, 2: 2, projecting: 2, project: 2, square: 2, bevel: 2 }, d.__private__.setLineCap = d.setLineCap = function(f) {
    var v = d.CapJoinStyles[f];
    if (v === void 0) throw new Error("Line cap style of '" + f + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
    return oa = v, H(v + " J"), this;
  };
  var ca = 0;
  d.__private__.setLineJoin = d.setLineJoin = function(f) {
    var v = d.CapJoinStyles[f];
    if (v === void 0) throw new Error("Line join style of '" + f + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
    return ca = v, H(v + " j"), this;
  }, d.__private__.setLineMiterLimit = d.__private__.setMiterLimit = d.setLineMiterLimit = d.setMiterLimit = function(f) {
    if (f = f || 0, isNaN(f)) throw new Error("Invalid argument passed to jsPDF.setLineMiterLimit");
    return H(j(K(f)) + " M"), this;
  }, d.GState = Ko, d.setGState = function(f) {
    (f = typeof f == "string" ? JA[ee[f]] : gs(null, f)).equals(Pe) || (H("/" + f.id + " gs"), Pe = f);
  };
  var gs = function(f, v) {
    if (!f || !ee[f]) {
      var T = !1;
      for (var V in JA) if (JA.hasOwnProperty(V) && JA[V].equals(v)) {
        T = !0;
        break;
      }
      if (T) v = JA[V];
      else {
        var $ = "GS" + (Object.keys(JA).length + 1).toString(10);
        JA[$] = v, v.id = $;
      }
      return f && (ee[f] = v.id), me.publish("addGState", v), v;
    }
  };
  d.addGState = function(f, v) {
    return gs(f, v), this;
  }, d.saveGraphicsState = function() {
    return H("q"), ke.push({ key: TA, size: CA, color: Yn }), this;
  }, d.restoreGraphicsState = function() {
    H("Q");
    var f = ke.pop();
    return TA = f.key, CA = f.size, Yn = f.color, Pe = null, this;
  }, d.setCurrentTransformationMatrix = function(f) {
    return H(f.toString() + " cm"), this;
  }, d.comment = function(f) {
    return H("#" + f), this;
  };
  var Yr = function(f, v) {
    var T = f || 0;
    Object.defineProperty(this, "x", { enumerable: !0, get: function() {
      return T;
    }, set: function(BA) {
      isNaN(BA) || (T = parseFloat(BA));
    } });
    var V = v || 0;
    Object.defineProperty(this, "y", { enumerable: !0, get: function() {
      return V;
    }, set: function(BA) {
      isNaN(BA) || (V = parseFloat(BA));
    } });
    var $ = "pt";
    return Object.defineProperty(this, "type", { enumerable: !0, get: function() {
      return $;
    }, set: function(BA) {
      $ = BA.toString();
    } }), this;
  }, la = function(f, v, T, V) {
    Yr.call(this, f, v), this.type = "rect";
    var $ = T || 0;
    Object.defineProperty(this, "w", { enumerable: !0, get: function() {
      return $;
    }, set: function(wA) {
      isNaN(wA) || ($ = parseFloat(wA));
    } });
    var BA = V || 0;
    return Object.defineProperty(this, "h", { enumerable: !0, get: function() {
      return BA;
    }, set: function(wA) {
      isNaN(wA) || (BA = parseFloat(wA));
    } }), this;
  }, Ei = function() {
    this.page = le, this.currentPage = O, this.pages = FA.slice(0), this.pagesContext = WA.slice(0), this.x = MA, this.y = We, this.matrix = pe, this.width = fa(O), this.height = ws(O), this.outputDestination = yA, this.id = "", this.objectNumber = -1;
  };
  Ei.prototype.restore = function() {
    le = this.page, O = this.currentPage, WA = this.pagesContext, FA = this.pages, MA = this.x, We = this.y, pe = this.matrix, ps(O, this.width), zr(O, this.height), yA = this.outputDestination;
  };
  var ua = function(f, v, T, V, $) {
    Er.push(new Ei()), le = O = 0, FA = [], MA = f, We = v, pe = $, ra([T, V]);
  };
  for (var zn in d.beginFormObject = function(f, v, T, V, $) {
    return ua(f, v, T, V, $), this;
  }, d.endFormObject = function(f) {
    return (function(v) {
      if (Gr[v]) Er.pop().restore();
      else {
        var T = new Ei(), V = "Xo" + (Object.keys(bt).length + 1).toString(10);
        T.id = V, Gr[v] = V, bt[V] = T, me.publish("addFormObject", T), Er.pop().restore();
      }
    })(f), this;
  }, d.doFormObject = function(f, v) {
    var T = bt[Gr[f]];
    return H("q"), H(v.toString() + " cm"), H("/" + T.id + " Do"), H("Q"), this;
  }, d.getFormObject = function(f) {
    var v = bt[Gr[f]];
    return { x: v.x, y: v.y, width: v.width, height: v.height, matrix: v.matrix };
  }, d.save = function(f, v) {
    return f = f || "generated.pdf", (v = v || {}).returnPromise = v.returnPromise || !1, v.returnPromise === !1 ? (ci(Ui(Sr()), f), typeof ci.unload == "function" && YA.setTimeout && setTimeout(ci.unload, 911), this) : new Promise(function(T, V) {
      try {
        var $ = ci(Ui(Sr()), f);
        typeof ci.unload == "function" && YA.setTimeout && setTimeout(ci.unload, 911), T($);
      } catch (BA) {
        V(BA.message);
      }
    });
  }, PA.API) PA.API.hasOwnProperty(zn) && (zn === "events" && PA.API.events.length ? (function(f, v) {
    var T, V, $;
    for ($ = v.length - 1; $ !== -1; $--) T = v[$][0], V = v[$][1], f.subscribe.apply(f, [T].concat(typeof V == "function" ? [V] : V));
  })(me, PA.API.events) : d[zn] = PA.API[zn]);
  function fa(f) {
    return WA[f].mediaBox.topRightX - WA[f].mediaBox.bottomLeftX;
  }
  function ps(f, v) {
    WA[f].mediaBox.topRightX = v + WA[f].mediaBox.bottomLeftX;
  }
  function ws(f) {
    return WA[f].mediaBox.topRightY - WA[f].mediaBox.bottomLeftY;
  }
  function zr(f, v) {
    WA[f].mediaBox.topRightY = v + WA[f].mediaBox.bottomLeftY;
  }
  var Zr = d.getPageWidth = function(f) {
    return fa(f = f || O) / re;
  }, vs = d.setPageWidth = function(f, v) {
    ps(f, v * re);
  }, Zn = d.getPageHeight = function(f) {
    return ws(f = f || O) / re;
  }, Cs = d.setPageHeight = function(f, v) {
    zr(f, v * re);
  };
  return d.internal = { pdfEscape: tr, getStyle: hs, getFont: oc, getFontSize: SA, getCharSpace: gc, getTextColor: dc, getLineHeight: lc, getLineHeightFactor: fc, getLineWidth: cc, write: bA, getHorizontalCoordinate: Wr, getVerticalCoordinate: Xr, getCoordinateString: hc, getVerticalCoordinateString: Bc, collections: {}, newObject: Ge, newAdditionalObject: jn, newObjectDeferred: Bt, newObjectDeferredBegin: pt, getFilters: dr, putStream: er, events: me, scaleFactor: re, pageSize: { getWidth: function() {
    return Zr(O);
  }, setWidth: function(f) {
    vs(O, f);
  }, getHeight: function() {
    return Zn(O);
  }, setHeight: function(f) {
    Cs(O, f);
  } }, encryptionOptions: h, encryption: st, getEncryptor: function(f) {
    return h !== null ? st.encryptor(f, 0) : function(v) {
      return v;
    };
  }, output: us, getNumberOfPages: os, get pages() {
    return FA;
  }, out: H, f2: E, f3: I, getPageInfo: qr, getPageInfoByObjId: fs, getCurrentPageInfo: rc, getPDFVersion: b, Point: Yr, Rectangle: la, Matrix: XA, hasHotfix: rr }, Object.defineProperty(d.internal.pageSize, "width", { get: function() {
    return Zr(O);
  }, set: function(f) {
    vs(O, f);
  }, enumerable: !0, configurable: !0 }), Object.defineProperty(d.internal.pageSize, "height", { get: function() {
    return Zn(O);
  }, set: function(f) {
    Cs(O, f);
  }, enumerable: !0, configurable: !0 }), (function(f) {
    for (var v = 0, T = jA.length; v < T; v++) {
      var V = is.call(this, f[v][0], f[v][1], f[v][2], jA[v][3], !0);
      p === !1 && (w[V] = !0);
      var $ = f[v][0].split("-");
      ns({ id: V, fontName: $[0], fontStyle: $[1] || "" });
    }
    me.publish("addFonts", { fonts: oe, dictionary: ce });
  }).call(d, jA), TA = "F1", as(n, e), me.publish("initialized"), d;
}
Vi.prototype.lsbFirstWord = function(t) {
  return String.fromCharCode(255 & t, t >> 8 & 255, t >> 16 & 255, t >> 24 & 255);
}, Vi.prototype.toHexString = function(t) {
  return t.split("").map(function(A) {
    return ("0" + (255 & A.charCodeAt(0)).toString(16)).slice(-2);
  }).join("");
}, Vi.prototype.hexToBytes = function(t) {
  for (var A = [], e = 0; e < t.length; e += 2) A.push(String.fromCharCode(parseInt(t.substr(e, 2), 16)));
  return A.join("");
}, Vi.prototype.processOwnerPassword = function(t, A) {
  return Zl(zl(A).substr(0, 5), t);
}, Vi.prototype.encryptor = function(t, A) {
  var e = zl(this.encryptionKey + String.fromCharCode(255 & t, t >> 8 & 255, t >> 16 & 255, 255 & A, A >> 8 & 255)).substr(0, 10);
  return function(r) {
    return Zl(e, r);
  };
}, Ko.prototype.equals = function(t) {
  var A, e = "id,objectNumber,equals";
  if (!t || Ee(t) !== Ee(this)) return !1;
  var r = 0;
  for (A in this) if (!(e.indexOf(A) >= 0)) {
    if (this.hasOwnProperty(A) && !t.hasOwnProperty(A) || this[A] !== t[A]) return !1;
    r++;
  }
  for (A in t) t.hasOwnProperty(A) && e.indexOf(A) < 0 && r--;
  return r === 0;
}, PA.API = { events: [] }, PA.version = "3.0.4";
var qe = PA.API, fu = 1, vi = function(t) {
  return t.replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
}, Mi = function(t) {
  return t.replace(/\\\\/g, "\\").replace(/\\\(/g, "(").replace(/\\\)/g, ")");
}, $A = function(t) {
  return t.toFixed(2);
}, Hn = function(t) {
  return t.toFixed(5);
};
qe.__acroform__ = {};
var Kt = function(t, A) {
  t.prototype = Object.create(A.prototype), t.prototype.constructor = t;
}, jh = function(t) {
  return t * fu;
}, kr = function(t) {
  var A = new Y1(), e = HA.internal.getHeight(t) || 0, r = HA.internal.getWidth(t) || 0;
  return A.BBox = [0, 0, Number($A(r)), Number($A(e))], A;
}, b4 = qe.__acroform__.setBit = function(t, A) {
  if (t = t || 0, A = A || 0, isNaN(t) || isNaN(A)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBit");
  return t | 1 << A;
}, y4 = qe.__acroform__.clearBit = function(t, A) {
  if (t = t || 0, A = A || 0, isNaN(t) || isNaN(A)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBit");
  return t & ~(1 << A);
}, E4 = qe.__acroform__.getBit = function(t, A) {
  if (isNaN(t) || isNaN(A)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBit");
  return t & 1 << A ? 1 : 0;
}, At = qe.__acroform__.getBitForPdf = function(t, A) {
  if (isNaN(t) || isNaN(A)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBitForPdf");
  return E4(t, A - 1);
}, et = qe.__acroform__.setBitForPdf = function(t, A) {
  if (isNaN(t) || isNaN(A)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBitForPdf");
  return b4(t, A - 1);
}, tt = qe.__acroform__.clearBitForPdf = function(t, A) {
  if (isNaN(t) || isNaN(A)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBitForPdf");
  return y4(t, A - 1);
}, L4 = qe.__acroform__.calculateCoordinates = function(t, A) {
  var e = A.internal.getHorizontalCoordinate, r = A.internal.getVerticalCoordinate, n = t[0], i = t[1], o = t[2], s = t[3], c = {};
  return c.lowerLeft_X = e(n) || 0, c.lowerLeft_Y = r(i + s) || 0, c.upperRight_X = e(n + o) || 0, c.upperRight_Y = r(i) || 0, [Number($A(c.lowerLeft_X)), Number($A(c.lowerLeft_Y)), Number($A(c.upperRight_X)), Number($A(c.upperRight_Y))];
}, x4 = function(t) {
  if (t.appearanceStreamContent) return t.appearanceStreamContent;
  if (t.V || t.DV) {
    var A = [], e = t._V || t.DV, r = $l(t, e), n = t.scope.internal.getFont(t.fontName, t.fontStyle).id;
    A.push("/Tx BMC"), A.push("q"), A.push("BT"), A.push(t.scope.__private__.encodeColorString(t.color)), A.push("/" + n + " " + $A(r.fontSize) + " Tf"), A.push("1 0 0 1 0 0 Tm"), A.push(r.text), A.push("ET"), A.push("Q"), A.push("EMC");
    var i = kr(t);
    return i.scope = t.scope, i.stream = A.join(`
`), i;
  }
}, $l = function(t, A) {
  var e = t.fontSize === 0 ? t.maxFontSize : t.fontSize, r = { text: "", fontSize: "" }, n = (A = (A = A.substr(0, 1) == "(" ? A.substr(1) : A).substr(A.length - 1) == ")" ? A.substr(0, A.length - 1) : A).split(" ");
  n = t.multiline ? n.map(function(E) {
    return E.split(`
`);
  }) : n.map(function(E) {
    return [E];
  });
  var i = e, o = HA.internal.getHeight(t) || 0;
  o = o < 0 ? -o : o;
  var s = HA.internal.getWidth(t) || 0;
  s = s < 0 ? -s : s;
  var c = function(E, I, K) {
    if (E + 1 < n.length) {
      var R = I + " " + n[E + 1][0];
      return go(R, t, K).width <= s - 4;
    }
    return !1;
  };
  i++;
  A: for (; i > 0; ) {
    A = "", i--;
    var u, h, p = go("3", t, i).height, w = t.multiline ? o - i : (o - p) / 2, d = w += 2, y = 0, b = 0, S = 0;
    if (i <= 0) {
      A = `(...) Tj
`, A += "% Width of Text: " + go(A, t, i = 12).width + ", FieldWidth:" + s + `
`;
      break;
    }
    for (var Q = "", P = 0, G = 0; G < n.length; G++) if (n.hasOwnProperty(G)) {
      var k = !1;
      if (n[G].length !== 1 && S !== n[G].length - 1) {
        if ((p + 2) * (P + 2) + 2 > o) continue A;
        Q += n[G][S], k = !0, b = G, G--;
      } else {
        Q = (Q += n[G][S] + " ").substr(Q.length - 1) == " " ? Q.substr(0, Q.length - 1) : Q;
        var Y = parseInt(G), z = c(Y, Q, i), iA = G >= n.length - 1;
        if (z && !iA) {
          Q += " ", S = 0;
          continue;
        }
        if (z || iA) {
          if (iA) b = Y;
          else if (t.multiline && (p + 2) * (P + 2) + 2 > o) continue A;
        } else {
          if (!t.multiline || (p + 2) * (P + 2) + 2 > o) continue A;
          b = Y;
        }
      }
      for (var j = "", N = y; N <= b; N++) {
        var Z = n[N];
        if (t.multiline) {
          if (N === b) {
            j += Z[S] + " ", S = (S + 1) % Z.length;
            continue;
          }
          if (N === y) {
            j += Z[Z.length - 1] + " ";
            continue;
          }
        }
        j += Z[0] + " ";
      }
      switch (j = j.substr(j.length - 1) == " " ? j.substr(0, j.length - 1) : j, h = go(j, t, i).width, t.textAlign) {
        case "right":
          u = s - h - 2;
          break;
        case "center":
          u = (s - h) / 2;
          break;
        default:
          u = 2;
      }
      A += $A(u) + " " + $A(d) + ` Td
`, A += "(" + vi(j) + `) Tj
`, A += -$A(u) + ` 0 Td
`, d = -(i + 2), h = 0, y = k ? b : b + 1, P++, Q = "";
    }
    break;
  }
  return r.text = A, r.fontSize = i, r;
}, go = function(t, A, e) {
  var r = A.scope.internal.getFont(A.fontName, A.fontStyle), n = A.scope.getStringUnitWidth(t, { font: r, fontSize: parseFloat(e), charSpace: 0 }) * parseFloat(e);
  return { height: A.scope.getStringUnitWidth("3", { font: r, fontSize: parseFloat(e), charSpace: 0 }) * parseFloat(e) * 1.5, width: n };
}, I4 = { fields: [], xForms: [], acroFormDictionaryRoot: null, printedOut: !1, internal: null, isInitialized: !1 }, S4 = function(t, A) {
  var e = { type: "reference", object: t };
  A.internal.getPageInfo(t.page).pageContext.annotations.find(function(r) {
    return r.type === e.type && r.object === e.object;
  }) === void 0 && A.internal.getPageInfo(t.page).pageContext.annotations.push(e);
}, H4 = function(t, A) {
  if (A.scope = t, t.internal !== void 0 && (t.internal.acroformPlugin === void 0 || t.internal.acroformPlugin.isInitialized === !1)) {
    if (br.FieldNum = 0, t.internal.acroformPlugin = JSON.parse(JSON.stringify(I4)), t.internal.acroformPlugin.acroFormDictionaryRoot) throw new Error("Exception while creating AcroformDictionary");
    fu = t.internal.scaleFactor, t.internal.acroformPlugin.acroFormDictionaryRoot = new z1(), t.internal.acroformPlugin.acroFormDictionaryRoot.scope = t, t.internal.acroformPlugin.acroFormDictionaryRoot._eventID = t.internal.events.subscribe("postPutResources", function() {
      (function(e) {
        e.internal.events.unsubscribe(e.internal.acroformPlugin.acroFormDictionaryRoot._eventID), delete e.internal.acroformPlugin.acroFormDictionaryRoot._eventID, e.internal.acroformPlugin.printedOut = !0;
      })(t);
    }), t.internal.events.subscribe("buildDocument", function() {
      (function(e) {
        e.internal.acroformPlugin.acroFormDictionaryRoot.objId = void 0;
        var r = e.internal.acroformPlugin.acroFormDictionaryRoot.Fields;
        for (var n in r) if (r.hasOwnProperty(n)) {
          var i = r[n];
          i.objId = void 0, i.hasAnnotation && S4(i, e);
        }
      })(t);
    }), t.internal.events.subscribe("putCatalog", function() {
      (function(e) {
        if (e.internal.acroformPlugin.acroFormDictionaryRoot === void 0) throw new Error("putCatalogCallback: Root missing.");
        e.internal.write("/AcroForm " + e.internal.acroformPlugin.acroFormDictionaryRoot.objId + " 0 R");
      })(t);
    }), t.internal.events.subscribe("postPutPages", function(e) {
      (function(r, n) {
        var i = !r;
        for (var o in r || (n.internal.newObjectDeferredBegin(n.internal.acroformPlugin.acroFormDictionaryRoot.objId, !0), n.internal.acroformPlugin.acroFormDictionaryRoot.putStream()), r = r || n.internal.acroformPlugin.acroFormDictionaryRoot.Kids) if (r.hasOwnProperty(o)) {
          var s = r[o], c = [], u = s.Rect;
          if (s.Rect && (s.Rect = L4(s.Rect, n)), n.internal.newObjectDeferredBegin(s.objId, !0), s.DA = HA.createDefaultAppearanceStream(s), Ee(s) === "object" && typeof s.getKeyValueListForStream == "function" && (c = s.getKeyValueListForStream()), s.Rect = u, s.hasAppearanceStream && !s.appearanceStreamContent) {
            var h = x4(s);
            c.push({ key: "AP", value: "<</N " + h + ">>" }), n.internal.acroformPlugin.xForms.push(h);
          }
          if (s.appearanceStreamContent) {
            var p = "";
            for (var w in s.appearanceStreamContent) if (s.appearanceStreamContent.hasOwnProperty(w)) {
              var d = s.appearanceStreamContent[w];
              if (p += "/" + w + " ", p += "<<", Object.keys(d).length >= 1 || Array.isArray(d)) {
                for (var o in d) if (d.hasOwnProperty(o)) {
                  var y = d[o];
                  typeof y == "function" && (y = y.call(n, s)), p += "/" + o + " " + y + " ", n.internal.acroformPlugin.xForms.indexOf(y) >= 0 || n.internal.acroformPlugin.xForms.push(y);
                }
              } else typeof (y = d) == "function" && (y = y.call(n, s)), p += "/" + o + " " + y, n.internal.acroformPlugin.xForms.indexOf(y) >= 0 || n.internal.acroformPlugin.xForms.push(y);
              p += ">>";
            }
            c.push({ key: "AP", value: `<<
` + p + ">>" });
          }
          n.internal.putStream({ additionalKeyValues: c, objectId: s.objId }), n.internal.out("endobj");
        }
        i && (function(b, S) {
          for (var Q in b) if (b.hasOwnProperty(Q)) {
            var P = Q, G = b[Q];
            S.internal.newObjectDeferredBegin(G.objId, !0), Ee(G) === "object" && typeof G.putStream == "function" && G.putStream(), delete b[P];
          }
        })(n.internal.acroformPlugin.xForms, n);
      })(e, t);
    }), t.internal.acroformPlugin.isInitialized = !0;
  }
}, J1 = qe.__acroform__.arrayToPdfArray = function(t, A, e) {
  var r = function(o) {
    return o;
  };
  if (Array.isArray(t)) {
    for (var n = "[", i = 0; i < t.length; i++) switch (i !== 0 && (n += " "), Ee(t[i])) {
      case "boolean":
      case "number":
      case "object":
        n += t[i].toString();
        break;
      case "string":
        t[i].substr(0, 1) !== "/" ? (A !== void 0 && e && (r = e.internal.getEncryptor(A)), n += "(" + vi(r(t[i].toString())) + ")") : n += t[i].toString();
    }
    return n + "]";
  }
  throw new Error("Invalid argument passed to jsPDF.__acroform__.arrayToPdfArray");
}, gl = function(t, A, e) {
  var r = function(n) {
    return n;
  };
  return A !== void 0 && e && (r = e.internal.getEncryptor(A)), (t = t || "").toString(), "(" + vi(r(t)) + ")";
}, Pr = function() {
  this._objId = void 0, this._scope = void 0, Object.defineProperty(this, "objId", { get: function() {
    if (this._objId === void 0) {
      if (this.scope === void 0) return;
      this._objId = this.scope.internal.newObjectDeferred();
    }
    return this._objId;
  }, set: function(t) {
    this._objId = t;
  } }), Object.defineProperty(this, "scope", { value: this._scope, writable: !0 });
};
Pr.prototype.toString = function() {
  return this.objId + " 0 R";
}, Pr.prototype.putStream = function() {
  var t = this.getKeyValueListForStream();
  this.scope.internal.putStream({ data: this.stream, additionalKeyValues: t, objectId: this.objId }), this.scope.internal.out("endobj");
}, Pr.prototype.getKeyValueListForStream = function() {
  var t = [], A = Object.getOwnPropertyNames(this).filter(function(i) {
    return i != "content" && i != "appearanceStreamContent" && i != "scope" && i != "objId" && i.substring(0, 1) != "_";
  });
  for (var e in A) if (Object.getOwnPropertyDescriptor(this, A[e]).configurable === !1) {
    var r = A[e], n = this[r];
    n && (Array.isArray(n) ? t.push({ key: r, value: J1(n, this.objId, this.scope) }) : n instanceof Pr ? (n.scope = this.scope, t.push({ key: r, value: n.objId + " 0 R" })) : typeof n != "function" && t.push({ key: r, value: n }));
  }
  return t;
};
var Y1 = function() {
  Pr.call(this), Object.defineProperty(this, "Type", { value: "/XObject", configurable: !1, writable: !0 }), Object.defineProperty(this, "Subtype", { value: "/Form", configurable: !1, writable: !0 }), Object.defineProperty(this, "FormType", { value: 1, configurable: !1, writable: !0 });
  var t, A = [];
  Object.defineProperty(this, "BBox", { configurable: !1, get: function() {
    return A;
  }, set: function(e) {
    A = e;
  } }), Object.defineProperty(this, "Resources", { value: "2 0 R", configurable: !1, writable: !0 }), Object.defineProperty(this, "stream", { enumerable: !1, configurable: !0, set: function(e) {
    t = e.trim();
  }, get: function() {
    return t || null;
  } });
};
Kt(Y1, Pr);
var z1 = function() {
  Pr.call(this);
  var t, A = [];
  Object.defineProperty(this, "Kids", { enumerable: !1, configurable: !0, get: function() {
    return A.length > 0 ? A : void 0;
  } }), Object.defineProperty(this, "Fields", { enumerable: !1, configurable: !1, get: function() {
    return A;
  } }), Object.defineProperty(this, "DA", { enumerable: !1, configurable: !1, get: function() {
    if (t) {
      var e = function(r) {
        return r;
      };
      return this.scope && (e = this.scope.internal.getEncryptor(this.objId)), "(" + vi(e(t)) + ")";
    }
  }, set: function(e) {
    t = e;
  } });
};
Kt(z1, Pr);
var br = function t() {
  Pr.call(this);
  var A = 4;
  Object.defineProperty(this, "F", { enumerable: !1, configurable: !1, get: function() {
    return A;
  }, set: function(Q) {
    if (isNaN(Q)) throw new Error('Invalid value "' + Q + '" for attribute F supplied.');
    A = Q;
  } }), Object.defineProperty(this, "showWhenPrinted", { enumerable: !0, configurable: !0, get: function() {
    return !!At(A, 3);
  }, set: function(Q) {
    Q ? this.F = et(A, 3) : this.F = tt(A, 3);
  } });
  var e = 0;
  Object.defineProperty(this, "Ff", { enumerable: !1, configurable: !1, get: function() {
    return e;
  }, set: function(Q) {
    if (isNaN(Q)) throw new Error('Invalid value "' + Q + '" for attribute Ff supplied.');
    e = Q;
  } });
  var r = [];
  Object.defineProperty(this, "Rect", { enumerable: !1, configurable: !1, get: function() {
    if (r.length !== 0) return r;
  }, set: function(Q) {
    r = Q !== void 0 ? Q : [];
  } }), Object.defineProperty(this, "x", { enumerable: !0, configurable: !0, get: function() {
    return !r || isNaN(r[0]) ? 0 : r[0];
  }, set: function(Q) {
    r[0] = Q;
  } }), Object.defineProperty(this, "y", { enumerable: !0, configurable: !0, get: function() {
    return !r || isNaN(r[1]) ? 0 : r[1];
  }, set: function(Q) {
    r[1] = Q;
  } }), Object.defineProperty(this, "width", { enumerable: !0, configurable: !0, get: function() {
    return !r || isNaN(r[2]) ? 0 : r[2];
  }, set: function(Q) {
    r[2] = Q;
  } }), Object.defineProperty(this, "height", { enumerable: !0, configurable: !0, get: function() {
    return !r || isNaN(r[3]) ? 0 : r[3];
  }, set: function(Q) {
    r[3] = Q;
  } });
  var n = "";
  Object.defineProperty(this, "FT", { enumerable: !0, configurable: !1, get: function() {
    return n;
  }, set: function(Q) {
    switch (Q) {
      case "/Btn":
      case "/Tx":
      case "/Ch":
      case "/Sig":
        n = Q;
        break;
      default:
        throw new Error('Invalid value "' + Q + '" for attribute FT supplied.');
    }
  } });
  var i = null;
  Object.defineProperty(this, "T", { enumerable: !0, configurable: !1, get: function() {
    if (!i || i.length < 1) {
      if (this instanceof Ro) return;
      i = "FieldObject" + t.FieldNum++;
    }
    var Q = function(P) {
      return P;
    };
    return this.scope && (Q = this.scope.internal.getEncryptor(this.objId)), "(" + vi(Q(i)) + ")";
  }, set: function(Q) {
    i = Q.toString();
  } }), Object.defineProperty(this, "fieldName", { configurable: !0, enumerable: !0, get: function() {
    return i;
  }, set: function(Q) {
    i = Q;
  } });
  var o = "helvetica";
  Object.defineProperty(this, "fontName", { enumerable: !0, configurable: !0, get: function() {
    return o;
  }, set: function(Q) {
    o = Q;
  } });
  var s = "normal";
  Object.defineProperty(this, "fontStyle", { enumerable: !0, configurable: !0, get: function() {
    return s;
  }, set: function(Q) {
    s = Q;
  } });
  var c = 0;
  Object.defineProperty(this, "fontSize", { enumerable: !0, configurable: !0, get: function() {
    return c;
  }, set: function(Q) {
    c = Q;
  } });
  var u = void 0;
  Object.defineProperty(this, "maxFontSize", { enumerable: !0, configurable: !0, get: function() {
    return u === void 0 ? 50 / fu : u;
  }, set: function(Q) {
    u = Q;
  } });
  var h = "black";
  Object.defineProperty(this, "color", { enumerable: !0, configurable: !0, get: function() {
    return h;
  }, set: function(Q) {
    h = Q;
  } });
  var p = "/F1 0 Tf 0 g";
  Object.defineProperty(this, "DA", { enumerable: !0, configurable: !1, get: function() {
    if (!(!p || this instanceof Ro || this instanceof di)) return gl(p, this.objId, this.scope);
  }, set: function(Q) {
    Q = Q.toString(), p = Q;
  } });
  var w = null;
  Object.defineProperty(this, "DV", { enumerable: !1, configurable: !1, get: function() {
    if (w) return this instanceof gt == 0 ? gl(w, this.objId, this.scope) : w;
  }, set: function(Q) {
    Q = Q.toString(), w = this instanceof gt == 0 ? Q.substr(0, 1) === "(" ? Mi(Q.substr(1, Q.length - 2)) : Mi(Q) : Q;
  } }), Object.defineProperty(this, "defaultValue", { enumerable: !0, configurable: !0, get: function() {
    return this instanceof gt == 1 ? Mi(w.substr(1, w.length - 1)) : w;
  }, set: function(Q) {
    Q = Q.toString(), w = this instanceof gt == 1 ? "/" + Q : Q;
  } });
  var d = null;
  Object.defineProperty(this, "_V", { enumerable: !1, configurable: !1, get: function() {
    if (d) return d;
  }, set: function(Q) {
    this.V = Q;
  } }), Object.defineProperty(this, "V", { enumerable: !1, configurable: !1, get: function() {
    if (d) return this instanceof gt == 0 ? gl(d, this.objId, this.scope) : d;
  }, set: function(Q) {
    Q = Q.toString(), d = this instanceof gt == 0 ? Q.substr(0, 1) === "(" ? Mi(Q.substr(1, Q.length - 2)) : Mi(Q) : Q;
  } }), Object.defineProperty(this, "value", { enumerable: !0, configurable: !0, get: function() {
    return this instanceof gt == 1 ? Mi(d.substr(1, d.length - 1)) : d;
  }, set: function(Q) {
    Q = Q.toString(), d = this instanceof gt == 1 ? "/" + Q : Q;
  } }), Object.defineProperty(this, "hasAnnotation", { enumerable: !0, configurable: !0, get: function() {
    return this.Rect;
  } }), Object.defineProperty(this, "Type", { enumerable: !0, configurable: !1, get: function() {
    return this.hasAnnotation ? "/Annot" : null;
  } }), Object.defineProperty(this, "Subtype", { enumerable: !0, configurable: !1, get: function() {
    return this.hasAnnotation ? "/Widget" : null;
  } });
  var y, b = !1;
  Object.defineProperty(this, "hasAppearanceStream", { enumerable: !0, configurable: !0, get: function() {
    return b;
  }, set: function(Q) {
    Q = !!Q, b = Q;
  } }), Object.defineProperty(this, "page", { enumerable: !0, configurable: !0, get: function() {
    if (y) return y;
  }, set: function(Q) {
    y = Q;
  } }), Object.defineProperty(this, "readOnly", { enumerable: !0, configurable: !0, get: function() {
    return !!At(this.Ff, 1);
  }, set: function(Q) {
    Q ? this.Ff = et(this.Ff, 1) : this.Ff = tt(this.Ff, 1);
  } }), Object.defineProperty(this, "required", { enumerable: !0, configurable: !0, get: function() {
    return !!At(this.Ff, 2);
  }, set: function(Q) {
    Q ? this.Ff = et(this.Ff, 2) : this.Ff = tt(this.Ff, 2);
  } }), Object.defineProperty(this, "noExport", { enumerable: !0, configurable: !0, get: function() {
    return !!At(this.Ff, 3);
  }, set: function(Q) {
    Q ? this.Ff = et(this.Ff, 3) : this.Ff = tt(this.Ff, 3);
  } });
  var S = null;
  Object.defineProperty(this, "Q", { enumerable: !0, configurable: !1, get: function() {
    if (S !== null) return S;
  }, set: function(Q) {
    if ([0, 1, 2].indexOf(Q) === -1) throw new Error('Invalid value "' + Q + '" for attribute Q supplied.');
    S = Q;
  } }), Object.defineProperty(this, "textAlign", { get: function() {
    var Q;
    switch (S) {
      case 0:
      default:
        Q = "left";
        break;
      case 1:
        Q = "center";
        break;
      case 2:
        Q = "right";
    }
    return Q;
  }, configurable: !0, enumerable: !0, set: function(Q) {
    switch (Q) {
      case "right":
      case 2:
        S = 2;
        break;
      case "center":
      case 1:
        S = 1;
        break;
      default:
        S = 0;
    }
  } });
};
Kt(br, Pr);
var Ji = function() {
  br.call(this), this.FT = "/Ch", this.V = "()", this.fontName = "zapfdingbats";
  var t = 0;
  Object.defineProperty(this, "TI", { enumerable: !0, configurable: !1, get: function() {
    return t;
  }, set: function(e) {
    t = e;
  } }), Object.defineProperty(this, "topIndex", { enumerable: !0, configurable: !0, get: function() {
    return t;
  }, set: function(e) {
    t = e;
  } });
  var A = [];
  Object.defineProperty(this, "Opt", { enumerable: !0, configurable: !1, get: function() {
    return J1(A, this.objId, this.scope);
  }, set: function(e) {
    var r, n;
    n = [], typeof (r = e) == "string" && (n = (function(i, o, s) {
      s || (s = 1);
      for (var c, u = []; c = o.exec(i); ) u.push(c[s]);
      return u;
    })(r, /\((.*?)\)/g)), A = n;
  } }), this.getOptions = function() {
    return A;
  }, this.setOptions = function(e) {
    A = e, this.sort && A.sort();
  }, this.addOption = function(e) {
    e = (e = e || "").toString(), A.push(e), this.sort && A.sort();
  }, this.removeOption = function(e, r) {
    for (r = r || !1, e = (e = e || "").toString(); A.indexOf(e) !== -1 && (A.splice(A.indexOf(e), 1), r !== !1); ) ;
  }, Object.defineProperty(this, "combo", { enumerable: !0, configurable: !0, get: function() {
    return !!At(this.Ff, 18);
  }, set: function(e) {
    e ? this.Ff = et(this.Ff, 18) : this.Ff = tt(this.Ff, 18);
  } }), Object.defineProperty(this, "edit", { enumerable: !0, configurable: !0, get: function() {
    return !!At(this.Ff, 19);
  }, set: function(e) {
    this.combo === !0 && (e ? this.Ff = et(this.Ff, 19) : this.Ff = tt(this.Ff, 19));
  } }), Object.defineProperty(this, "sort", { enumerable: !0, configurable: !0, get: function() {
    return !!At(this.Ff, 20);
  }, set: function(e) {
    e ? (this.Ff = et(this.Ff, 20), A.sort()) : this.Ff = tt(this.Ff, 20);
  } }), Object.defineProperty(this, "multiSelect", { enumerable: !0, configurable: !0, get: function() {
    return !!At(this.Ff, 22);
  }, set: function(e) {
    e ? this.Ff = et(this.Ff, 22) : this.Ff = tt(this.Ff, 22);
  } }), Object.defineProperty(this, "doNotSpellCheck", { enumerable: !0, configurable: !0, get: function() {
    return !!At(this.Ff, 23);
  }, set: function(e) {
    e ? this.Ff = et(this.Ff, 23) : this.Ff = tt(this.Ff, 23);
  } }), Object.defineProperty(this, "commitOnSelChange", { enumerable: !0, configurable: !0, get: function() {
    return !!At(this.Ff, 27);
  }, set: function(e) {
    e ? this.Ff = et(this.Ff, 27) : this.Ff = tt(this.Ff, 27);
  } }), this.hasAppearanceStream = !1;
};
Kt(Ji, br);
var Yi = function() {
  Ji.call(this), this.fontName = "helvetica", this.combo = !1;
};
Kt(Yi, Ji);
var zi = function() {
  Yi.call(this), this.combo = !0;
};
Kt(zi, Yi);
var bo = function() {
  zi.call(this), this.edit = !0;
};
Kt(bo, zi);
var gt = function() {
  br.call(this), this.FT = "/Btn", Object.defineProperty(this, "noToggleToOff", { enumerable: !0, configurable: !0, get: function() {
    return !!At(this.Ff, 15);
  }, set: function(e) {
    e ? this.Ff = et(this.Ff, 15) : this.Ff = tt(this.Ff, 15);
  } }), Object.defineProperty(this, "radio", { enumerable: !0, configurable: !0, get: function() {
    return !!At(this.Ff, 16);
  }, set: function(e) {
    e ? this.Ff = et(this.Ff, 16) : this.Ff = tt(this.Ff, 16);
  } }), Object.defineProperty(this, "pushButton", { enumerable: !0, configurable: !0, get: function() {
    return !!At(this.Ff, 17);
  }, set: function(e) {
    e ? this.Ff = et(this.Ff, 17) : this.Ff = tt(this.Ff, 17);
  } }), Object.defineProperty(this, "radioIsUnison", { enumerable: !0, configurable: !0, get: function() {
    return !!At(this.Ff, 26);
  }, set: function(e) {
    e ? this.Ff = et(this.Ff, 26) : this.Ff = tt(this.Ff, 26);
  } });
  var t, A = {};
  Object.defineProperty(this, "MK", { enumerable: !1, configurable: !1, get: function() {
    var e = function(i) {
      return i;
    };
    if (this.scope && (e = this.scope.internal.getEncryptor(this.objId)), Object.keys(A).length !== 0) {
      var r, n = [];
      for (r in n.push("<<"), A) n.push("/" + r + " (" + vi(e(A[r])) + ")");
      return n.push(">>"), n.join(`
`);
    }
  }, set: function(e) {
    Ee(e) === "object" && (A = e);
  } }), Object.defineProperty(this, "caption", { enumerable: !0, configurable: !0, get: function() {
    return A.CA || "";
  }, set: function(e) {
    typeof e == "string" && (A.CA = e);
  } }), Object.defineProperty(this, "AS", { enumerable: !1, configurable: !1, get: function() {
    return t;
  }, set: function(e) {
    t = e;
  } }), Object.defineProperty(this, "appearanceState", { enumerable: !0, configurable: !0, get: function() {
    return t.substr(1, t.length - 1);
  }, set: function(e) {
    t = "/" + e;
  } });
};
Kt(gt, br);
var yo = function() {
  gt.call(this), this.pushButton = !0;
};
Kt(yo, gt);
var Zi = function() {
  gt.call(this), this.radio = !0, this.pushButton = !1;
  var t = [];
  Object.defineProperty(this, "Kids", { enumerable: !0, configurable: !1, get: function() {
    return t;
  }, set: function(A) {
    t = A !== void 0 ? A : [];
  } });
};
Kt(Zi, gt);
var Ro = function() {
  var t, A;
  br.call(this), Object.defineProperty(this, "Parent", { enumerable: !1, configurable: !1, get: function() {
    return t;
  }, set: function(n) {
    t = n;
  } }), Object.defineProperty(this, "optionName", { enumerable: !1, configurable: !0, get: function() {
    return A;
  }, set: function(n) {
    A = n;
  } });
  var e, r = {};
  Object.defineProperty(this, "MK", { enumerable: !1, configurable: !1, get: function() {
    var n = function(s) {
      return s;
    };
    this.scope && (n = this.scope.internal.getEncryptor(this.objId));
    var i, o = [];
    for (i in o.push("<<"), r) o.push("/" + i + " (" + vi(n(r[i])) + ")");
    return o.push(">>"), o.join(`
`);
  }, set: function(n) {
    Ee(n) === "object" && (r = n);
  } }), Object.defineProperty(this, "caption", { enumerable: !0, configurable: !0, get: function() {
    return r.CA || "";
  }, set: function(n) {
    typeof n == "string" && (r.CA = n);
  } }), Object.defineProperty(this, "AS", { enumerable: !1, configurable: !1, get: function() {
    return e;
  }, set: function(n) {
    e = n;
  } }), Object.defineProperty(this, "appearanceState", { enumerable: !0, configurable: !0, get: function() {
    return e.substr(1, e.length - 1);
  }, set: function(n) {
    e = "/" + n;
  } }), this.caption = "l", this.appearanceState = "Off", this._AppearanceType = HA.RadioButton.Circle, this.appearanceStreamContent = this._AppearanceType.createAppearanceStream(this.optionName);
};
Kt(Ro, br), Zi.prototype.setAppearance = function(t) {
  if (!("createAppearanceStream" in t) || !("getCA" in t)) throw new Error("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");
  for (var A in this.Kids) if (this.Kids.hasOwnProperty(A)) {
    var e = this.Kids[A];
    e.appearanceStreamContent = t.createAppearanceStream(e.optionName), e.caption = t.getCA();
  }
}, Zi.prototype.createOption = function(t) {
  var A = new Ro();
  return A.Parent = this, A.optionName = t, this.Kids.push(A), N4.call(this.scope, A), A;
};
var Eo = function() {
  gt.call(this), this.fontName = "zapfdingbats", this.caption = "3", this.appearanceState = "On", this.value = "On", this.textAlign = "center", this.appearanceStreamContent = HA.CheckBox.createAppearanceStream();
};
Kt(Eo, gt);
var di = function() {
  br.call(this), this.FT = "/Tx", Object.defineProperty(this, "multiline", { enumerable: !0, configurable: !0, get: function() {
    return !!At(this.Ff, 13);
  }, set: function(A) {
    A ? this.Ff = et(this.Ff, 13) : this.Ff = tt(this.Ff, 13);
  } }), Object.defineProperty(this, "fileSelect", { enumerable: !0, configurable: !0, get: function() {
    return !!At(this.Ff, 21);
  }, set: function(A) {
    A ? this.Ff = et(this.Ff, 21) : this.Ff = tt(this.Ff, 21);
  } }), Object.defineProperty(this, "doNotSpellCheck", { enumerable: !0, configurable: !0, get: function() {
    return !!At(this.Ff, 23);
  }, set: function(A) {
    A ? this.Ff = et(this.Ff, 23) : this.Ff = tt(this.Ff, 23);
  } }), Object.defineProperty(this, "doNotScroll", { enumerable: !0, configurable: !0, get: function() {
    return !!At(this.Ff, 24);
  }, set: function(A) {
    A ? this.Ff = et(this.Ff, 24) : this.Ff = tt(this.Ff, 24);
  } }), Object.defineProperty(this, "comb", { enumerable: !0, configurable: !0, get: function() {
    return !!At(this.Ff, 25);
  }, set: function(A) {
    A ? this.Ff = et(this.Ff, 25) : this.Ff = tt(this.Ff, 25);
  } }), Object.defineProperty(this, "richText", { enumerable: !0, configurable: !0, get: function() {
    return !!At(this.Ff, 26);
  }, set: function(A) {
    A ? this.Ff = et(this.Ff, 26) : this.Ff = tt(this.Ff, 26);
  } });
  var t = null;
  Object.defineProperty(this, "MaxLen", { enumerable: !0, configurable: !1, get: function() {
    return t;
  }, set: function(A) {
    t = A;
  } }), Object.defineProperty(this, "maxLength", { enumerable: !0, configurable: !0, get: function() {
    return t;
  }, set: function(A) {
    Number.isInteger(A) && (t = A);
  } }), Object.defineProperty(this, "hasAppearanceStream", { enumerable: !0, configurable: !0, get: function() {
    return this.V || this.DV;
  } });
};
Kt(di, br);
var Lo = function() {
  di.call(this), Object.defineProperty(this, "password", { enumerable: !0, configurable: !0, get: function() {
    return !!At(this.Ff, 14);
  }, set: function(t) {
    t ? this.Ff = et(this.Ff, 14) : this.Ff = tt(this.Ff, 14);
  } }), this.password = !0;
};
Kt(Lo, di);
var HA = { CheckBox: { createAppearanceStream: function() {
  return { N: { On: HA.CheckBox.YesNormal }, D: { On: HA.CheckBox.YesPushDown, Off: HA.CheckBox.OffPushDown } };
}, YesPushDown: function(t) {
  var A = kr(t);
  A.scope = t.scope;
  var e = [], r = t.scope.internal.getFont(t.fontName, t.fontStyle).id, n = t.scope.__private__.encodeColorString(t.color), i = $l(t, t.caption);
  return e.push("0.749023 g"), e.push("0 0 " + $A(HA.internal.getWidth(t)) + " " + $A(HA.internal.getHeight(t)) + " re"), e.push("f"), e.push("BMC"), e.push("q"), e.push("0 0 1 rg"), e.push("/" + r + " " + $A(i.fontSize) + " Tf " + n), e.push("BT"), e.push(i.text), e.push("ET"), e.push("Q"), e.push("EMC"), A.stream = e.join(`
`), A;
}, YesNormal: function(t) {
  var A = kr(t);
  A.scope = t.scope;
  var e = t.scope.internal.getFont(t.fontName, t.fontStyle).id, r = t.scope.__private__.encodeColorString(t.color), n = [], i = HA.internal.getHeight(t), o = HA.internal.getWidth(t), s = $l(t, t.caption);
  return n.push("1 g"), n.push("0 0 " + $A(o) + " " + $A(i) + " re"), n.push("f"), n.push("q"), n.push("0 0 1 rg"), n.push("0 0 " + $A(o - 1) + " " + $A(i - 1) + " re"), n.push("W"), n.push("n"), n.push("0 g"), n.push("BT"), n.push("/" + e + " " + $A(s.fontSize) + " Tf " + r), n.push(s.text), n.push("ET"), n.push("Q"), A.stream = n.join(`
`), A;
}, OffPushDown: function(t) {
  var A = kr(t);
  A.scope = t.scope;
  var e = [];
  return e.push("0.749023 g"), e.push("0 0 " + $A(HA.internal.getWidth(t)) + " " + $A(HA.internal.getHeight(t)) + " re"), e.push("f"), A.stream = e.join(`
`), A;
} }, RadioButton: { Circle: { createAppearanceStream: function(t) {
  var A = { D: { Off: HA.RadioButton.Circle.OffPushDown }, N: {} };
  return A.N[t] = HA.RadioButton.Circle.YesNormal, A.D[t] = HA.RadioButton.Circle.YesPushDown, A;
}, getCA: function() {
  return "l";
}, YesNormal: function(t) {
  var A = kr(t);
  A.scope = t.scope;
  var e = [], r = HA.internal.getWidth(t) <= HA.internal.getHeight(t) ? HA.internal.getWidth(t) / 4 : HA.internal.getHeight(t) / 4;
  r = Number((0.9 * r).toFixed(5));
  var n = HA.internal.Bezier_C, i = Number((r * n).toFixed(5));
  return e.push("q"), e.push("1 0 0 1 " + Hn(HA.internal.getWidth(t) / 2) + " " + Hn(HA.internal.getHeight(t) / 2) + " cm"), e.push(r + " 0 m"), e.push(r + " " + i + " " + i + " " + r + " 0 " + r + " c"), e.push("-" + i + " " + r + " -" + r + " " + i + " -" + r + " 0 c"), e.push("-" + r + " -" + i + " -" + i + " -" + r + " 0 -" + r + " c"), e.push(i + " -" + r + " " + r + " -" + i + " " + r + " 0 c"), e.push("f"), e.push("Q"), A.stream = e.join(`
`), A;
}, YesPushDown: function(t) {
  var A = kr(t);
  A.scope = t.scope;
  var e = [], r = HA.internal.getWidth(t) <= HA.internal.getHeight(t) ? HA.internal.getWidth(t) / 4 : HA.internal.getHeight(t) / 4;
  r = Number((0.9 * r).toFixed(5));
  var n = Number((2 * r).toFixed(5)), i = Number((n * HA.internal.Bezier_C).toFixed(5)), o = Number((r * HA.internal.Bezier_C).toFixed(5));
  return e.push("0.749023 g"), e.push("q"), e.push("1 0 0 1 " + Hn(HA.internal.getWidth(t) / 2) + " " + Hn(HA.internal.getHeight(t) / 2) + " cm"), e.push(n + " 0 m"), e.push(n + " " + i + " " + i + " " + n + " 0 " + n + " c"), e.push("-" + i + " " + n + " -" + n + " " + i + " -" + n + " 0 c"), e.push("-" + n + " -" + i + " -" + i + " -" + n + " 0 -" + n + " c"), e.push(i + " -" + n + " " + n + " -" + i + " " + n + " 0 c"), e.push("f"), e.push("Q"), e.push("0 g"), e.push("q"), e.push("1 0 0 1 " + Hn(HA.internal.getWidth(t) / 2) + " " + Hn(HA.internal.getHeight(t) / 2) + " cm"), e.push(r + " 0 m"), e.push(r + " " + o + " " + o + " " + r + " 0 " + r + " c"), e.push("-" + o + " " + r + " -" + r + " " + o + " -" + r + " 0 c"), e.push("-" + r + " -" + o + " -" + o + " -" + r + " 0 -" + r + " c"), e.push(o + " -" + r + " " + r + " -" + o + " " + r + " 0 c"), e.push("f"), e.push("Q"), A.stream = e.join(`
`), A;
}, OffPushDown: function(t) {
  var A = kr(t);
  A.scope = t.scope;
  var e = [], r = HA.internal.getWidth(t) <= HA.internal.getHeight(t) ? HA.internal.getWidth(t) / 4 : HA.internal.getHeight(t) / 4;
  r = Number((0.9 * r).toFixed(5));
  var n = Number((2 * r).toFixed(5)), i = Number((n * HA.internal.Bezier_C).toFixed(5));
  return e.push("0.749023 g"), e.push("q"), e.push("1 0 0 1 " + Hn(HA.internal.getWidth(t) / 2) + " " + Hn(HA.internal.getHeight(t) / 2) + " cm"), e.push(n + " 0 m"), e.push(n + " " + i + " " + i + " " + n + " 0 " + n + " c"), e.push("-" + i + " " + n + " -" + n + " " + i + " -" + n + " 0 c"), e.push("-" + n + " -" + i + " -" + i + " -" + n + " 0 -" + n + " c"), e.push(i + " -" + n + " " + n + " -" + i + " " + n + " 0 c"), e.push("f"), e.push("Q"), A.stream = e.join(`
`), A;
} }, Cross: { createAppearanceStream: function(t) {
  var A = { D: { Off: HA.RadioButton.Cross.OffPushDown }, N: {} };
  return A.N[t] = HA.RadioButton.Cross.YesNormal, A.D[t] = HA.RadioButton.Cross.YesPushDown, A;
}, getCA: function() {
  return "8";
}, YesNormal: function(t) {
  var A = kr(t);
  A.scope = t.scope;
  var e = [], r = HA.internal.calculateCross(t);
  return e.push("q"), e.push("1 1 " + $A(HA.internal.getWidth(t) - 2) + " " + $A(HA.internal.getHeight(t) - 2) + " re"), e.push("W"), e.push("n"), e.push($A(r.x1.x) + " " + $A(r.x1.y) + " m"), e.push($A(r.x2.x) + " " + $A(r.x2.y) + " l"), e.push($A(r.x4.x) + " " + $A(r.x4.y) + " m"), e.push($A(r.x3.x) + " " + $A(r.x3.y) + " l"), e.push("s"), e.push("Q"), A.stream = e.join(`
`), A;
}, YesPushDown: function(t) {
  var A = kr(t);
  A.scope = t.scope;
  var e = HA.internal.calculateCross(t), r = [];
  return r.push("0.749023 g"), r.push("0 0 " + $A(HA.internal.getWidth(t)) + " " + $A(HA.internal.getHeight(t)) + " re"), r.push("f"), r.push("q"), r.push("1 1 " + $A(HA.internal.getWidth(t) - 2) + " " + $A(HA.internal.getHeight(t) - 2) + " re"), r.push("W"), r.push("n"), r.push($A(e.x1.x) + " " + $A(e.x1.y) + " m"), r.push($A(e.x2.x) + " " + $A(e.x2.y) + " l"), r.push($A(e.x4.x) + " " + $A(e.x4.y) + " m"), r.push($A(e.x3.x) + " " + $A(e.x3.y) + " l"), r.push("s"), r.push("Q"), A.stream = r.join(`
`), A;
}, OffPushDown: function(t) {
  var A = kr(t);
  A.scope = t.scope;
  var e = [];
  return e.push("0.749023 g"), e.push("0 0 " + $A(HA.internal.getWidth(t)) + " " + $A(HA.internal.getHeight(t)) + " re"), e.push("f"), A.stream = e.join(`
`), A;
} } }, createDefaultAppearanceStream: function(t) {
  var A = t.scope.internal.getFont(t.fontName, t.fontStyle).id, e = t.scope.__private__.encodeColorString(t.color);
  return "/" + A + " " + t.fontSize + " Tf " + e;
} };
HA.internal = { Bezier_C: 0.551915024494, calculateCross: function(t) {
  var A = HA.internal.getWidth(t), e = HA.internal.getHeight(t), r = Math.min(A, e);
  return { x1: { x: (A - r) / 2, y: (e - r) / 2 + r }, x2: { x: (A - r) / 2 + r, y: (e - r) / 2 }, x3: { x: (A - r) / 2, y: (e - r) / 2 }, x4: { x: (A - r) / 2 + r, y: (e - r) / 2 + r } };
} }, HA.internal.getWidth = function(t) {
  var A = 0;
  return Ee(t) === "object" && (A = jh(t.Rect[2])), A;
}, HA.internal.getHeight = function(t) {
  var A = 0;
  return Ee(t) === "object" && (A = jh(t.Rect[3])), A;
};
var N4 = qe.addField = function(t) {
  if (H4(this, t), !(t instanceof br)) throw new Error("Invalid argument passed to jsPDF.addField.");
  var A;
  return (A = t).scope.internal.acroformPlugin.printedOut && (A.scope.internal.acroformPlugin.printedOut = !1, A.scope.internal.acroformPlugin.acroFormDictionaryRoot = null), A.scope.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(A), t.page = t.scope.internal.getCurrentPageInfo().pageNumber, this;
};
qe.AcroFormChoiceField = Ji, qe.AcroFormListBox = Yi, qe.AcroFormComboBox = zi, qe.AcroFormEditBox = bo, qe.AcroFormButton = gt, qe.AcroFormPushButton = yo, qe.AcroFormRadioButton = Zi, qe.AcroFormCheckBox = Eo, qe.AcroFormTextField = di, qe.AcroFormPasswordField = Lo, qe.AcroFormAppearance = HA, qe.AcroForm = { ChoiceField: Ji, ListBox: Yi, ComboBox: zi, EditBox: bo, Button: gt, PushButton: yo, RadioButton: Zi, CheckBox: Eo, TextField: di, PasswordField: Lo, Appearance: HA }, PA.AcroForm = { ChoiceField: Ji, ListBox: Yi, ComboBox: zi, EditBox: bo, Button: gt, PushButton: yo, RadioButton: Zi, CheckBox: Eo, TextField: di, PasswordField: Lo, Appearance: HA };
PA.AcroForm;
function Z1(t) {
  return t.reduce(function(A, e, r) {
    return A[e] = r, A;
  }, {});
}
(function(t) {
  var A = "addImage_";
  t.__addimage__ = {};
  var e = "UNKNOWN", r = { PNG: [[137, 80, 78, 71]], TIFF: [[77, 77, 0, 42], [73, 73, 42, 0]], JPEG: [[255, 216, 255, 224, void 0, void 0, 74, 70, 73, 70, 0], [255, 216, 255, 225, void 0, void 0, 69, 120, 105, 102, 0, 0], [255, 216, 255, 219], [255, 216, 255, 238]], JPEG2000: [[0, 0, 0, 12, 106, 80, 32, 32]], GIF87a: [[71, 73, 70, 56, 55, 97]], GIF89a: [[71, 73, 70, 56, 57, 97]], WEBP: [[82, 73, 70, 70, void 0, void 0, void 0, void 0, 87, 69, 66, 80]], BMP: [[66, 77], [66, 65], [67, 73], [67, 80], [73, 67], [80, 84]] }, n = t.__addimage__.getImageFileTypeByImageData = function(E, I) {
    var K, R, aA, sA, oA, tA = e;
    if ((I = I || e) === "RGBA" || E.data !== void 0 && E.data instanceof Uint8ClampedArray && "height" in E && "width" in E) return "RGBA";
    if (z(E)) for (oA in r) for (aA = r[oA], K = 0; K < aA.length; K += 1) {
      for (sA = !0, R = 0; R < aA[K].length; R += 1) if (aA[K][R] !== void 0 && aA[K][R] !== E[R]) {
        sA = !1;
        break;
      }
      if (sA === !0) {
        tA = oA;
        break;
      }
    }
    else for (oA in r) for (aA = r[oA], K = 0; K < aA.length; K += 1) {
      for (sA = !0, R = 0; R < aA[K].length; R += 1) if (aA[K][R] !== void 0 && aA[K][R] !== E.charCodeAt(R)) {
        sA = !1;
        break;
      }
      if (sA === !0) {
        tA = oA;
        break;
      }
    }
    return tA === e && I !== e && (tA = I), tA;
  }, i = function E(I) {
    for (var K = this.internal.write, R = this.internal.putStream, aA = (0, this.internal.getFilters)(); aA.indexOf("FlateEncode") !== -1; ) aA.splice(aA.indexOf("FlateEncode"), 1);
    I.objectId = this.internal.newObject();
    var sA = [];
    if (sA.push({ key: "Type", value: "/XObject" }), sA.push({ key: "Subtype", value: "/Image" }), sA.push({ key: "Width", value: I.width }), sA.push({ key: "Height", value: I.height }), I.colorSpace === Q.INDEXED ? sA.push({ key: "ColorSpace", value: "[/Indexed /DeviceRGB " + (I.palette.length / 3 - 1) + " " + ("sMask" in I && I.sMask !== void 0 ? I.objectId + 2 : I.objectId + 1) + " 0 R]" }) : (sA.push({ key: "ColorSpace", value: "/" + I.colorSpace }), I.colorSpace === Q.DEVICE_CMYK && sA.push({ key: "Decode", value: "[1 0 1 0 1 0 1 0]" })), sA.push({ key: "BitsPerComponent", value: I.bitsPerComponent }), "decodeParameters" in I && I.decodeParameters !== void 0 && sA.push({ key: "DecodeParms", value: "<<" + I.decodeParameters + ">>" }), "transparency" in I && Array.isArray(I.transparency) && I.transparency.length > 0) {
      for (var oA = "", tA = 0, cA = I.transparency.length; tA < cA; tA++) oA += I.transparency[tA] + " " + I.transparency[tA] + " ";
      sA.push({ key: "Mask", value: "[" + oA + "]" });
    }
    I.sMask !== void 0 && sA.push({ key: "SMask", value: I.objectId + 1 + " 0 R" });
    var QA = I.filter !== void 0 ? ["/" + I.filter] : void 0;
    if (R({ data: I.data, additionalKeyValues: sA, alreadyAppliedFilters: QA, objectId: I.objectId }), K("endobj"), "sMask" in I && I.sMask !== void 0) {
      var pA, F = (pA = I.sMaskBitsPerComponent) !== null && pA !== void 0 ? pA : I.bitsPerComponent, O = { width: I.width, height: I.height, colorSpace: "DeviceGray", bitsPerComponent: F, data: I.sMask };
      "filter" in I && (O.decodeParameters = "/Predictor ".concat(I.predictor, " /Colors 1 /BitsPerComponent ").concat(F, " /Columns ").concat(I.width), O.filter = I.filter), E.call(this, O);
    }
    if (I.colorSpace === Q.INDEXED) {
      var M = this.internal.newObject();
      R({ data: j(new Uint8Array(I.palette)), objectId: M }), K("endobj");
    }
  }, o = function() {
    var E = this.internal.collections[A + "images"];
    for (var I in E) i.call(this, E[I]);
  }, s = function() {
    var E, I = this.internal.collections[A + "images"], K = this.internal.write;
    for (var R in I) K("/I" + (E = I[R]).index, E.objectId, "0", "R");
  }, c = function() {
    this.internal.collections[A + "images"] || (this.internal.collections[A + "images"] = {}, this.internal.events.subscribe("putResources", o), this.internal.events.subscribe("putXobjectDict", s));
  }, u = function() {
    var E = this.internal.collections[A + "images"];
    return c.call(this), E;
  }, h = function() {
    return Object.keys(this.internal.collections[A + "images"]).length;
  }, p = function(E) {
    return typeof t["process" + E.toUpperCase()] == "function";
  }, w = function(E) {
    return Ee(E) === "object" && E.nodeType === 1;
  }, d = function(E, I) {
    if (E.nodeName === "IMG" && E.hasAttribute("src")) {
      var K = "" + E.getAttribute("src");
      if (K.indexOf("data:image/") === 0) return Uo(unescape(K).split("base64,").pop());
      var R = t.loadFile(K, !0);
      if (R !== void 0) return R;
    }
    if (E.nodeName === "CANVAS") {
      if (E.width === 0 || E.height === 0) throw new Error("Given canvas must have data. Canvas width: " + E.width + ", height: " + E.height);
      var aA;
      switch (I) {
        case "PNG":
          aA = "image/png";
          break;
        case "WEBP":
          aA = "image/webp";
          break;
        default:
          aA = "image/jpeg";
      }
      return Uo(E.toDataURL(aA, 1).split("base64,").pop());
    }
  }, y = function(E) {
    var I = this.internal.collections[A + "images"];
    if (I) {
      for (var K in I) if (E === I[K].alias) return I[K];
    }
  }, b = function(E, I, K) {
    return E || I || (E = -96, I = -96), E < 0 && (E = -1 * K.width * 72 / E / this.internal.scaleFactor), I < 0 && (I = -1 * K.height * 72 / I / this.internal.scaleFactor), E === 0 && (E = I * K.width / K.height), I === 0 && (I = E * K.height / K.width), [E, I];
  }, S = function(E, I, K, R, aA, sA) {
    var oA = b.call(this, K, R, aA), tA = this.internal.getCoordinateString, cA = this.internal.getVerticalCoordinateString, QA = u.call(this);
    if (K = oA[0], R = oA[1], QA[aA.index] = aA, sA) {
      sA *= Math.PI / 180;
      var pA = Math.cos(sA), F = Math.sin(sA), O = function(q) {
        return q.toFixed(4);
      }, M = [O(pA), O(F), O(-1 * F), O(pA), 0, 0, "cm"];
    }
    this.internal.write("q"), sA ? (this.internal.write([1, "0", "0", 1, tA(E), cA(I + R), "cm"].join(" ")), this.internal.write(M.join(" ")), this.internal.write([tA(K), "0", "0", tA(R), "0", "0", "cm"].join(" "))) : this.internal.write([tA(K), "0", "0", tA(R), tA(E), cA(I + R), "cm"].join(" ")), this.isAdvancedAPI() && this.internal.write([1, 0, 0, -1, 0, 0, "cm"].join(" ")), this.internal.write("/I" + aA.index + " Do"), this.internal.write("Q");
  }, Q = t.color_spaces = { DEVICE_RGB: "DeviceRGB", DEVICE_GRAY: "DeviceGray", DEVICE_CMYK: "DeviceCMYK", CAL_GREY: "CalGray", CAL_RGB: "CalRGB", LAB: "Lab", ICC_BASED: "ICCBased", INDEXED: "Indexed", PATTERN: "Pattern", SEPARATION: "Separation", DEVICE_N: "DeviceN" };
  t.decode = { DCT_DECODE: "DCTDecode", FLATE_DECODE: "FlateDecode", LZW_DECODE: "LZWDecode", JPX_DECODE: "JPXDecode", JBIG2_DECODE: "JBIG2Decode", ASCII85_DECODE: "ASCII85Decode", ASCII_HEX_DECODE: "ASCIIHexDecode", RUN_LENGTH_DECODE: "RunLengthDecode", CCITT_FAX_DECODE: "CCITTFaxDecode" };
  var P = t.image_compression = { NONE: "NONE", FAST: "FAST", MEDIUM: "MEDIUM", SLOW: "SLOW" }, G = t.__addimage__.sHashCode = function(E) {
    var I, K, R = 0;
    if (typeof E == "string") for (K = E.length, I = 0; I < K; I++) R = (R << 5) - R + E.charCodeAt(I), R |= 0;
    else if (z(E)) for (K = E.byteLength / 2, I = 0; I < K; I++) R = (R << 5) - R + E[I], R |= 0;
    return R;
  }, k = t.__addimage__.validateStringAsBase64 = function(E) {
    (E = E || "").toString().trim();
    var I = !0;
    return E.length === 0 && (I = !1), E.length % 4 != 0 && (I = !1), /^[A-Za-z0-9+/]+$/.test(E.substr(0, E.length - 2)) === !1 && (I = !1), /^[A-Za-z0-9/][A-Za-z0-9+/]|[A-Za-z0-9+/]=|==$/.test(E.substr(-2)) === !1 && (I = !1), I;
  }, Y = t.__addimage__.extractImageFromDataUrl = function(E) {
    if (E == null || !(E = E.trim()).startsWith("data:")) return null;
    var I = E.indexOf(",");
    return I < 0 ? null : E.substring(0, I).trim().endsWith("base64") ? E.substring(I + 1) : null;
  };
  t.__addimage__.isArrayBuffer = function(E) {
    return E instanceof ArrayBuffer;
  };
  var z = t.__addimage__.isArrayBufferView = function(E) {
    return E instanceof Int8Array || E instanceof Uint8Array || E instanceof Uint8ClampedArray || E instanceof Int16Array || E instanceof Uint16Array || E instanceof Int32Array || E instanceof Uint32Array || E instanceof Float32Array || E instanceof Float64Array;
  }, iA = t.__addimage__.binaryStringToUint8Array = function(E) {
    for (var I = E.length, K = new Uint8Array(I), R = 0; R < I; R++) K[R] = E.charCodeAt(R);
    return K;
  }, j = t.__addimage__.arrayBufferToBinaryString = function(E) {
    for (var I = "", K = z(E) ? E : new Uint8Array(E), R = 0; R < K.length; R += 8192) I += String.fromCharCode.apply(null, K.subarray(R, R + 8192));
    return I;
  };
  t.addImage = function() {
    var E, I, K, R, aA, sA, oA, tA, cA;
    if (typeof arguments[1] == "number" ? (I = e, K = arguments[1], R = arguments[2], aA = arguments[3], sA = arguments[4], oA = arguments[5], tA = arguments[6], cA = arguments[7]) : (I = arguments[1], K = arguments[2], R = arguments[3], aA = arguments[4], sA = arguments[5], oA = arguments[6], tA = arguments[7], cA = arguments[8]), Ee(E = arguments[0]) === "object" && !w(E) && "imageData" in E) {
      var QA = E;
      E = QA.imageData, I = QA.format || I || e, K = QA.x || K || 0, R = QA.y || R || 0, aA = QA.w || QA.width || aA, sA = QA.h || QA.height || sA, oA = QA.alias || oA, tA = QA.compression || tA, cA = QA.rotation || QA.angle || cA;
    }
    var pA = this.internal.getFilters();
    if (tA === void 0 && pA.indexOf("FlateEncode") !== -1 && (tA = "SLOW"), isNaN(K) || isNaN(R)) throw new Error("Invalid coordinates passed to jsPDF.addImage");
    c.call(this);
    var F = N.call(this, E, I, oA, tA);
    return S.call(this, K, R, aA, sA, F, cA), this;
  };
  var N = function(E, I, K, R) {
    var aA, sA, oA;
    if (typeof E == "string" && n(E) === e) {
      E = unescape(E);
      var tA = Z(E, !1);
      (tA !== "" || (tA = t.loadFile(E, !0)) !== void 0) && (E = tA);
    }
    if (w(E) && (E = d(E, I)), I = n(E, I), !p(I)) throw new Error("addImage does not support files of type '" + I + "', please ensure that a plugin for '" + I + "' support is added.");
    if (((oA = K) == null || oA.length === 0) && (K = (function(cA) {
      return typeof cA == "string" || z(cA) ? G(cA) : z(cA.data) ? G(cA.data) : null;
    })(E)), (aA = y.call(this, K)) || (E instanceof Uint8Array || I === "RGBA" || (sA = E, E = iA(E)), aA = this["process" + I.toUpperCase()](E, h.call(this), K, (function(cA) {
      return cA && typeof cA == "string" && (cA = cA.toUpperCase()), cA in t.image_compression ? cA : P.NONE;
    })(R), sA)), !aA) throw new Error("An unknown error occurred whilst processing the image.");
    return aA;
  }, Z = t.__addimage__.convertBase64ToBinaryString = function(E, I) {
    I = typeof I != "boolean" || I;
    var K, R = "";
    if (typeof E == "string") {
      var aA;
      K = (aA = Y(E)) !== null && aA !== void 0 ? aA : E;
      try {
        R = Uo(K);
      } catch (sA) {
        if (I) throw k(K) ? new Error("atob-Error in jsPDF.convertBase64ToBinaryString " + sA.message) : new Error("Supplied Data is not a valid base64-String jsPDF.convertBase64ToBinaryString ");
      }
    }
    return R;
  };
  t.getImageProperties = function(E) {
    var I, K, R = "";
    if (w(E) && (E = d(E)), typeof E == "string" && n(E) === e && ((R = Z(E, !1)) === "" && (R = t.loadFile(E) || ""), E = R), K = n(E), !p(K)) throw new Error("addImage does not support files of type '" + K + "', please ensure that a plugin for '" + K + "' support is added.");
    if (E instanceof Uint8Array || (E = iA(E)), !(I = this["process" + K.toUpperCase()](E))) throw new Error("An unknown error occurred whilst processing the image");
    return I.fileType = K, I;
  };
})(PA.API), /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(t) {
  var A = function(e) {
    if (e !== void 0 && e != "") return !0;
  };
  PA.API.events.push(["addPage", function(e) {
    this.internal.getPageInfo(e.pageNumber).pageContext.annotations = [];
  }]), t.events.push(["putPage", function(e) {
    for (var r, n, i, o = this.internal.getCoordinateString, s = this.internal.getVerticalCoordinateString, c = this.internal.getPageInfoByObjId(e.objId), u = e.pageContext.annotations, h = !1, p = 0; p < u.length && !h; p++) switch ((r = u[p]).type) {
      case "link":
        (A(r.options.url) || A(r.options.pageNumber)) && (h = !0);
        break;
      case "reference":
      case "text":
      case "freetext":
        h = !0;
    }
    if (h != 0) {
      this.internal.write("/Annots [");
      for (var w = 0; w < u.length; w++) {
        r = u[w];
        var d = this.internal.pdfEscape, y = this.internal.getEncryptor(e.objId);
        switch (r.type) {
          case "reference":
            this.internal.write(" " + r.object.objId + " 0 R ");
            break;
          case "text":
            var b = this.internal.newAdditionalObject(), S = this.internal.newAdditionalObject(), Q = this.internal.getEncryptor(b.objId), P = r.title || "Note";
            i = "<</Type /Annot /Subtype /Text " + (n = "/Rect [" + o(r.bounds.x) + " " + s(r.bounds.y + r.bounds.h) + " " + o(r.bounds.x + r.bounds.w) + " " + s(r.bounds.y) + "] ") + "/Contents (" + d(Q(r.contents)) + ")", i += " /Popup " + S.objId + " 0 R", i += " /P " + c.objId + " 0 R", i += " /T (" + d(Q(P)) + ") >>", b.content = i;
            var G = b.objId + " 0 R";
            i = "<</Type /Annot /Subtype /Popup " + (n = "/Rect [" + o(r.bounds.x + 30) + " " + s(r.bounds.y + r.bounds.h) + " " + o(r.bounds.x + r.bounds.w + 30) + " " + s(r.bounds.y) + "] ") + " /Parent " + G, r.open && (i += " /Open true"), i += " >>", S.content = i, this.internal.write(b.objId, "0 R", S.objId, "0 R");
            break;
          case "freetext":
            n = "/Rect [" + o(r.bounds.x) + " " + s(r.bounds.y) + " " + o(r.bounds.x + r.bounds.w) + " " + s(r.bounds.y + r.bounds.h) + "] ";
            var k = r.color || "#000000";
            i = "<</Type /Annot /Subtype /FreeText " + n + "/Contents (" + d(y(r.contents)) + ")", i += " /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#" + k + ")", i += " /Border [0 0 0]", i += " >>", this.internal.write(i);
            break;
          case "link":
            if (r.options.name) {
              var Y = this.annotations._nameMap[r.options.name];
              r.options.pageNumber = Y.page, r.options.top = Y.y;
            } else r.options.top || (r.options.top = 0);
            if (n = "/Rect [" + r.finalBounds.x + " " + r.finalBounds.y + " " + r.finalBounds.w + " " + r.finalBounds.h + "] ", i = "", r.options.url) i = "<</Type /Annot /Subtype /Link " + n + "/Border [0 0 0] /A <</S /URI /URI (" + d(y(r.options.url)) + ") >>";
            else if (r.options.pageNumber) switch (i = "<</Type /Annot /Subtype /Link " + n + "/Border [0 0 0] /Dest [" + this.internal.getPageInfo(r.options.pageNumber).objId + " 0 R", r.options.magFactor = r.options.magFactor || "XYZ", r.options.magFactor) {
              case "Fit":
                i += " /Fit]";
                break;
              case "FitH":
                i += " /FitH " + r.options.top + "]";
                break;
              case "FitV":
                r.options.left = r.options.left || 0, i += " /FitV " + r.options.left + "]";
                break;
              default:
                var z = s(r.options.top);
                r.options.left = r.options.left || 0, r.options.zoom === void 0 && (r.options.zoom = 0), i += " /XYZ " + r.options.left + " " + z + " " + r.options.zoom + "]";
            }
            i != "" && (i += " >>", this.internal.write(i));
        }
      }
      this.internal.write("]");
    }
  }]), t.createAnnotation = function(e) {
    var r = this.internal.getCurrentPageInfo();
    switch (e.type) {
      case "link":
        this.link(e.bounds.x, e.bounds.y, e.bounds.w, e.bounds.h, e);
        break;
      case "text":
      case "freetext":
        r.pageContext.annotations.push(e);
    }
  }, t.link = function(e, r, n, i, o) {
    var s = this.internal.getCurrentPageInfo(), c = this.internal.getCoordinateString, u = this.internal.getVerticalCoordinateString;
    s.pageContext.annotations.push({ finalBounds: { x: c(e), y: u(r), w: c(e + n), h: u(r + i) }, options: o, type: "link" });
  }, t.textWithLink = function(e, r, n, i) {
    var o, s, c = this.getTextWidth(e), u = this.internal.getLineHeight() / this.internal.scaleFactor;
    if (i.maxWidth !== void 0) {
      s = i.maxWidth;
      var h = this.splitTextToSize(e, s).length;
      o = Math.ceil(u * h);
    } else s = c, o = u;
    return this.text(e, r, n, i), n += 0.2 * u, i.align === "center" && (r -= c / 2), i.align === "right" && (r -= c), this.link(r, n - u, s, o, i), c;
  }, t.getTextWidth = function(e) {
    var r = this.internal.getFontSize();
    return this.getStringUnitWidth(e) * r / this.internal.scaleFactor;
  };
})(PA.API), /**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(t) {
  var A = { 1569: [65152], 1570: [65153, 65154], 1571: [65155, 65156], 1572: [65157, 65158], 1573: [65159, 65160], 1574: [65161, 65162, 65163, 65164], 1575: [65165, 65166], 1576: [65167, 65168, 65169, 65170], 1577: [65171, 65172], 1578: [65173, 65174, 65175, 65176], 1579: [65177, 65178, 65179, 65180], 1580: [65181, 65182, 65183, 65184], 1581: [65185, 65186, 65187, 65188], 1582: [65189, 65190, 65191, 65192], 1583: [65193, 65194], 1584: [65195, 65196], 1585: [65197, 65198], 1586: [65199, 65200], 1587: [65201, 65202, 65203, 65204], 1588: [65205, 65206, 65207, 65208], 1589: [65209, 65210, 65211, 65212], 1590: [65213, 65214, 65215, 65216], 1591: [65217, 65218, 65219, 65220], 1592: [65221, 65222, 65223, 65224], 1593: [65225, 65226, 65227, 65228], 1594: [65229, 65230, 65231, 65232], 1601: [65233, 65234, 65235, 65236], 1602: [65237, 65238, 65239, 65240], 1603: [65241, 65242, 65243, 65244], 1604: [65245, 65246, 65247, 65248], 1605: [65249, 65250, 65251, 65252], 1606: [65253, 65254, 65255, 65256], 1607: [65257, 65258, 65259, 65260], 1608: [65261, 65262], 1609: [65263, 65264, 64488, 64489], 1610: [65265, 65266, 65267, 65268], 1649: [64336, 64337], 1655: [64477], 1657: [64358, 64359, 64360, 64361], 1658: [64350, 64351, 64352, 64353], 1659: [64338, 64339, 64340, 64341], 1662: [64342, 64343, 64344, 64345], 1663: [64354, 64355, 64356, 64357], 1664: [64346, 64347, 64348, 64349], 1667: [64374, 64375, 64376, 64377], 1668: [64370, 64371, 64372, 64373], 1670: [64378, 64379, 64380, 64381], 1671: [64382, 64383, 64384, 64385], 1672: [64392, 64393], 1676: [64388, 64389], 1677: [64386, 64387], 1678: [64390, 64391], 1681: [64396, 64397], 1688: [64394, 64395], 1700: [64362, 64363, 64364, 64365], 1702: [64366, 64367, 64368, 64369], 1705: [64398, 64399, 64400, 64401], 1709: [64467, 64468, 64469, 64470], 1711: [64402, 64403, 64404, 64405], 1713: [64410, 64411, 64412, 64413], 1715: [64406, 64407, 64408, 64409], 1722: [64414, 64415], 1723: [64416, 64417, 64418, 64419], 1726: [64426, 64427, 64428, 64429], 1728: [64420, 64421], 1729: [64422, 64423, 64424, 64425], 1733: [64480, 64481], 1734: [64473, 64474], 1735: [64471, 64472], 1736: [64475, 64476], 1737: [64482, 64483], 1739: [64478, 64479], 1740: [64508, 64509, 64510, 64511], 1744: [64484, 64485, 64486, 64487], 1746: [64430, 64431], 1747: [64432, 64433] }, e = { 65247: { 65154: 65269, 65156: 65271, 65160: 65273, 65166: 65275 }, 65248: { 65154: 65270, 65156: 65272, 65160: 65274, 65166: 65276 }, 65165: { 65247: { 65248: { 65258: 65010 } } }, 1617: { 1612: 64606, 1613: 64607, 1614: 64608, 1615: 64609, 1616: 64610 } }, r = { 1612: 64606, 1613: 64607, 1614: 64608, 1615: 64609, 1616: 64610 }, n = [1570, 1571, 1573, 1575];
  t.__arabicParser__ = {};
  var i = t.__arabicParser__.isInArabicSubstitutionA = function(b) {
    return A[b.charCodeAt(0)] !== void 0;
  }, o = t.__arabicParser__.isArabicLetter = function(b) {
    return typeof b == "string" && /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+$/.test(b);
  }, s = t.__arabicParser__.isArabicEndLetter = function(b) {
    return o(b) && i(b) && A[b.charCodeAt(0)].length <= 2;
  }, c = t.__arabicParser__.isArabicAlfLetter = function(b) {
    return o(b) && n.indexOf(b.charCodeAt(0)) >= 0;
  };
  t.__arabicParser__.arabicLetterHasIsolatedForm = function(b) {
    return o(b) && i(b) && A[b.charCodeAt(0)].length >= 1;
  };
  var u = t.__arabicParser__.arabicLetterHasFinalForm = function(b) {
    return o(b) && i(b) && A[b.charCodeAt(0)].length >= 2;
  };
  t.__arabicParser__.arabicLetterHasInitialForm = function(b) {
    return o(b) && i(b) && A[b.charCodeAt(0)].length >= 3;
  };
  var h = t.__arabicParser__.arabicLetterHasMedialForm = function(b) {
    return o(b) && i(b) && A[b.charCodeAt(0)].length == 4;
  }, p = t.__arabicParser__.resolveLigatures = function(b) {
    var S = 0, Q = e, P = "", G = 0;
    for (S = 0; S < b.length; S += 1) Q[b.charCodeAt(S)] !== void 0 ? (G++, typeof (Q = Q[b.charCodeAt(S)]) == "number" && (P += String.fromCharCode(Q), Q = e, G = 0), S === b.length - 1 && (Q = e, P += b.charAt(S - (G - 1)), S -= G - 1, G = 0)) : (Q = e, P += b.charAt(S - G), S -= G, G = 0);
    return P;
  };
  t.__arabicParser__.isArabicDiacritic = function(b) {
    return b !== void 0 && r[b.charCodeAt(0)] !== void 0;
  };
  var w = t.__arabicParser__.getCorrectForm = function(b, S, Q) {
    return o(b) ? i(b) === !1 ? -1 : !u(b) || !o(S) && !o(Q) || !o(Q) && s(S) || s(b) && !o(S) || s(b) && c(S) || s(b) && s(S) ? 0 : h(b) && o(S) && !s(S) && o(Q) && u(Q) ? 3 : s(b) || !o(Q) ? 1 : 2 : -1;
  }, d = function(b) {
    var S = 0, Q = 0, P = 0, G = "", k = "", Y = "", z = (b = b || "").split("\\s+"), iA = [];
    for (S = 0; S < z.length; S += 1) {
      for (iA.push(""), Q = 0; Q < z[S].length; Q += 1) G = z[S][Q], k = z[S][Q - 1], Y = z[S][Q + 1], o(G) ? (P = w(G, k, Y), iA[S] += P !== -1 ? String.fromCharCode(A[G.charCodeAt(0)][P]) : G) : iA[S] += G;
      iA[S] = p(iA[S]);
    }
    return iA.join(" ");
  }, y = t.__arabicParser__.processArabic = t.processArabic = function() {
    var b, S = typeof arguments[0] == "string" ? arguments[0] : arguments[0].text, Q = [];
    if (Array.isArray(S)) {
      var P = 0;
      for (Q = [], P = 0; P < S.length; P += 1) Array.isArray(S[P]) ? Q.push([d(S[P][0]), S[P][1], S[P][2]]) : Q.push([d(S[P])]);
      b = Q;
    } else b = d(S);
    return typeof arguments[0] == "string" ? b : (arguments[0].text = b, arguments[0]);
  };
  t.events.push(["preProcessText", y]);
})(PA.API), PA.API.autoPrint = function(t) {
  var A;
  return (t = t || {}).variant = t.variant || "non-conform", t.variant === "javascript" ? this.addJS("print({});") : (this.internal.events.subscribe("postPutResources", function() {
    A = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /Named"), this.internal.out("/Type /Action"), this.internal.out("/N /Print"), this.internal.out(">>"), this.internal.out("endobj");
  }), this.internal.events.subscribe("putCatalog", function() {
    this.internal.out("/OpenAction " + A + " 0 R");
  })), this;
}, /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(t) {
  var A = function() {
    var e = void 0;
    Object.defineProperty(this, "pdf", { get: function() {
      return e;
    }, set: function(s) {
      e = s;
    } });
    var r = 150;
    Object.defineProperty(this, "width", { get: function() {
      return r;
    }, set: function(s) {
      r = isNaN(s) || Number.isInteger(s) === !1 || s < 0 ? 150 : s, this.getContext("2d").pageWrapXEnabled && (this.getContext("2d").pageWrapX = r + 1);
    } });
    var n = 300;
    Object.defineProperty(this, "height", { get: function() {
      return n;
    }, set: function(s) {
      n = isNaN(s) || Number.isInteger(s) === !1 || s < 0 ? 300 : s, this.getContext("2d").pageWrapYEnabled && (this.getContext("2d").pageWrapY = n + 1);
    } });
    var i = [];
    Object.defineProperty(this, "childNodes", { get: function() {
      return i;
    }, set: function(s) {
      i = s;
    } });
    var o = {};
    Object.defineProperty(this, "style", { get: function() {
      return o;
    }, set: function(s) {
      o = s;
    } }), Object.defineProperty(this, "parentNode", {});
  };
  A.prototype.getContext = function(e, r) {
    var n;
    if ((e = e || "2d") !== "2d") return null;
    for (n in r) this.pdf.context2d.hasOwnProperty(n) && (this.pdf.context2d[n] = r[n]);
    return this.pdf.context2d._canvas = this, this.pdf.context2d;
  }, A.prototype.toDataURL = function() {
    throw new Error("toDataURL is not implemented.");
  }, t.events.push(["initialized", function() {
    this.canvas = new A(), this.canvas.pdf = this;
  }]);
})(PA.API), (function(t) {
  var A = { left: 0, top: 0, bottom: 0, right: 0 }, e = !1, r = function() {
    this.internal.__cell__ === void 0 && (this.internal.__cell__ = {}, this.internal.__cell__.padding = 3, this.internal.__cell__.headerFunction = void 0, this.internal.__cell__.margins = Object.assign({}, A), this.internal.__cell__.margins.width = this.getPageWidth(), n.call(this));
  }, n = function() {
    this.internal.__cell__.lastCell = new i(), this.internal.__cell__.pages = 1;
  }, i = function() {
    var c = arguments[0];
    Object.defineProperty(this, "x", { enumerable: !0, get: function() {
      return c;
    }, set: function(b) {
      c = b;
    } });
    var u = arguments[1];
    Object.defineProperty(this, "y", { enumerable: !0, get: function() {
      return u;
    }, set: function(b) {
      u = b;
    } });
    var h = arguments[2];
    Object.defineProperty(this, "width", { enumerable: !0, get: function() {
      return h;
    }, set: function(b) {
      h = b;
    } });
    var p = arguments[3];
    Object.defineProperty(this, "height", { enumerable: !0, get: function() {
      return p;
    }, set: function(b) {
      p = b;
    } });
    var w = arguments[4];
    Object.defineProperty(this, "text", { enumerable: !0, get: function() {
      return w;
    }, set: function(b) {
      w = b;
    } });
    var d = arguments[5];
    Object.defineProperty(this, "lineNumber", { enumerable: !0, get: function() {
      return d;
    }, set: function(b) {
      d = b;
    } });
    var y = arguments[6];
    return Object.defineProperty(this, "align", { enumerable: !0, get: function() {
      return y;
    }, set: function(b) {
      y = b;
    } }), this;
  };
  i.prototype.clone = function() {
    return new i(this.x, this.y, this.width, this.height, this.text, this.lineNumber, this.align);
  }, i.prototype.toArray = function() {
    return [this.x, this.y, this.width, this.height, this.text, this.lineNumber, this.align];
  }, t.setHeaderFunction = function(c) {
    return r.call(this), this.internal.__cell__.headerFunction = typeof c == "function" ? c : void 0, this;
  }, t.getTextDimensions = function(c, u) {
    r.call(this);
    var h = (u = u || {}).fontSize || this.getFontSize(), p = u.font || this.getFont(), w = u.scaleFactor || this.internal.scaleFactor, d = 0, y = 0, b = 0, S = this;
    if (!Array.isArray(c) && typeof c != "string") {
      if (typeof c != "number") throw new Error("getTextDimensions expects text-parameter to be of type String or type Number or an Array of Strings.");
      c = String(c);
    }
    var Q = u.maxWidth;
    Q > 0 ? typeof c == "string" ? c = this.splitTextToSize(c, Q) : Object.prototype.toString.call(c) === "[object Array]" && (c = c.reduce(function(G, k) {
      return G.concat(S.splitTextToSize(k, Q));
    }, [])) : c = Array.isArray(c) ? c : [c];
    for (var P = 0; P < c.length; P++) d < (b = this.getStringUnitWidth(c[P], { font: p }) * h) && (d = b);
    return d !== 0 && (y = c.length), { w: d /= w, h: Math.max((y * h * this.getLineHeightFactor() - h * (this.getLineHeightFactor() - 1)) / w, 0) };
  }, t.cellAddPage = function() {
    r.call(this), this.addPage();
    var c = this.internal.__cell__.margins || A;
    return this.internal.__cell__.lastCell = new i(c.left, c.top, void 0, void 0), this.internal.__cell__.pages += 1, this;
  };
  var o = t.cell = function() {
    var c;
    c = arguments[0] instanceof i ? arguments[0] : new i(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6]), r.call(this);
    var u = this.internal.__cell__.lastCell, h = this.internal.__cell__.padding, p = this.internal.__cell__.margins || A, w = this.internal.__cell__.tableHeaderRow, d = this.internal.__cell__.printHeaders;
    return u.lineNumber !== void 0 && (u.lineNumber === c.lineNumber ? (c.x = (u.x || 0) + (u.width || 0), c.y = u.y || 0) : u.y + u.height + c.height + p.bottom > this.getPageHeight() ? (this.cellAddPage(), c.y = p.top, d && w && (this.printHeaderRow(c.lineNumber, !0), c.y += w[0].height)) : c.y = u.y + u.height || c.y), c.text[0] !== void 0 && (this.rect(c.x, c.y, c.width, c.height, e === !0 ? "FD" : void 0), c.align === "right" ? this.text(c.text, c.x + c.width - h, c.y + h, { align: "right", baseline: "top" }) : c.align === "center" ? this.text(c.text, c.x + c.width / 2, c.y + h, { align: "center", baseline: "top", maxWidth: c.width - h - h }) : this.text(c.text, c.x + h, c.y + h, { align: "left", baseline: "top", maxWidth: c.width - h - h })), this.internal.__cell__.lastCell = c, this;
  };
  t.table = function(c, u, h, p, w) {
    if (r.call(this), !h) throw new Error("No data for PDF table.");
    var d, y, b, S, Q = [], P = [], G = [], k = {}, Y = {}, z = [], iA = [], j = (w = w || {}).autoSize || !1, N = w.printHeaders !== !1, Z = w.css && w.css["font-size"] !== void 0 ? 16 * w.css["font-size"] : w.fontSize || 12, E = w.margins || Object.assign({ width: this.getPageWidth() }, A), I = typeof w.padding == "number" ? w.padding : 3, K = w.headerBackgroundColor || "#c8c8c8", R = w.headerTextColor || "#000";
    if (n.call(this), this.internal.__cell__.printHeaders = N, this.internal.__cell__.margins = E, this.internal.__cell__.table_font_size = Z, this.internal.__cell__.padding = I, this.internal.__cell__.headerBackgroundColor = K, this.internal.__cell__.headerTextColor = R, this.setFontSize(Z), p == null) P = Q = Object.keys(h[0]), G = Q.map(function() {
      return "left";
    });
    else if (Array.isArray(p) && Ee(p[0]) === "object") for (Q = p.map(function(QA) {
      return QA.name;
    }), P = p.map(function(QA) {
      return QA.prompt || QA.name || "";
    }), G = p.map(function(QA) {
      return QA.align || "left";
    }), d = 0; d < p.length; d += 1) Y[p[d].name] = 0.7499990551181103 * p[d].width;
    else Array.isArray(p) && typeof p[0] == "string" && (P = Q = p, G = Q.map(function() {
      return "left";
    }));
    if (j || Array.isArray(p) && typeof p[0] == "string") for (d = 0; d < Q.length; d += 1) {
      for (k[S = Q[d]] = h.map(function(QA) {
        return QA[S];
      }), this.setFont(void 0, "bold"), z.push(this.getTextDimensions(P[d], { fontSize: this.internal.__cell__.table_font_size, scaleFactor: this.internal.scaleFactor }).w), y = k[S], this.setFont(void 0, "normal"), b = 0; b < y.length; b += 1) z.push(this.getTextDimensions(y[b], { fontSize: this.internal.__cell__.table_font_size, scaleFactor: this.internal.scaleFactor }).w);
      Y[S] = Math.max.apply(null, z) + I + I, z = [];
    }
    if (N) {
      var aA = {};
      for (d = 0; d < Q.length; d += 1) aA[Q[d]] = {}, aA[Q[d]].text = P[d], aA[Q[d]].align = G[d];
      var sA = s.call(this, aA, Y);
      iA = Q.map(function(QA) {
        return new i(c, u, Y[QA], sA, aA[QA].text, void 0, aA[QA].align);
      }), this.setTableHeaderRow(iA), this.printHeaderRow(1, !1);
    }
    var oA = p.reduce(function(QA, pA) {
      return QA[pA.name] = pA.align, QA;
    }, {});
    for (d = 0; d < h.length; d += 1) {
      "rowStart" in w && w.rowStart instanceof Function && w.rowStart({ row: d, data: h[d] }, this);
      var tA = s.call(this, h[d], Y);
      for (b = 0; b < Q.length; b += 1) {
        var cA = h[d][Q[b]];
        "cellStart" in w && w.cellStart instanceof Function && w.cellStart({ row: d, col: b, data: cA }, this), o.call(this, new i(c, u, Y[Q[b]], tA, cA, d + 2, oA[Q[b]]));
      }
    }
    return this.internal.__cell__.table_x = c, this.internal.__cell__.table_y = u, this;
  };
  var s = function(c, u) {
    var h = this.internal.__cell__.padding, p = this.internal.__cell__.table_font_size, w = this.internal.scaleFactor;
    return Object.keys(c).map(function(d) {
      var y = c[d];
      return this.splitTextToSize(y.hasOwnProperty("text") ? y.text : y, u[d] - h - h);
    }, this).map(function(d) {
      return this.getLineHeightFactor() * d.length * p / w + h + h;
    }, this).reduce(function(d, y) {
      return Math.max(d, y);
    }, 0);
  };
  t.setTableHeaderRow = function(c) {
    r.call(this), this.internal.__cell__.tableHeaderRow = c;
  }, t.printHeaderRow = function(c, u) {
    if (r.call(this), !this.internal.__cell__.tableHeaderRow) throw new Error("Property tableHeaderRow does not exist.");
    var h;
    if (e = !0, typeof this.internal.__cell__.headerFunction == "function") {
      var p = this.internal.__cell__.headerFunction(this, this.internal.__cell__.pages);
      this.internal.__cell__.lastCell = new i(p[0], p[1], p[2], p[3], void 0, -1);
    }
    this.setFont(void 0, "bold");
    for (var w = [], d = 0; d < this.internal.__cell__.tableHeaderRow.length; d += 1) {
      h = this.internal.__cell__.tableHeaderRow[d].clone(), u && (h.y = this.internal.__cell__.margins.top || 0, w.push(h)), h.lineNumber = c;
      var y = this.getTextColor();
      this.setTextColor(this.internal.__cell__.headerTextColor), this.setFillColor(this.internal.__cell__.headerBackgroundColor), o.call(this, h), this.setTextColor(y);
    }
    w.length > 0 && this.setTableHeaderRow(w), this.setFont(void 0, "normal"), e = !1;
  };
})(PA.API);
var $1 = { italic: ["italic", "oblique", "normal"], oblique: ["oblique", "italic", "normal"], normal: ["normal", "oblique", "italic"] }, AB = ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded"], Au = Z1(AB), eB = [100, 200, 300, 400, 500, 600, 700, 800, 900], _4 = Z1(eB);
function pl(t) {
  var A = t.family.replace(/"|'/g, "").toLowerCase(), e = (function(i) {
    return $1[i = i || "normal"] ? i : "normal";
  })(t.style), r = (function(i) {
    return i ? typeof i == "number" ? i >= 100 && i <= 900 && i % 100 == 0 ? i : 400 : /^\d00$/.test(i) ? parseInt(i) : i === "bold" ? 700 : 400 : 400;
  })(t.weight), n = (function(i) {
    return typeof Au[i = i || "normal"] == "number" ? i : "normal";
  })(t.stretch);
  return { family: A, style: e, weight: r, stretch: n, src: t.src || [], ref: t.ref || { name: A, style: [n, e, r].join(" ") } };
}
function qh(t, A, e, r) {
  var n;
  for (n = e; n >= 0 && n < A.length; n += r) if (t[A[n]]) return t[A[n]];
  for (n = e; n >= 0 && n < A.length; n -= r) if (t[A[n]]) return t[A[n]];
}
var D4 = { "sans-serif": "helvetica", fixed: "courier", monospace: "courier", terminal: "courier", cursive: "times", fantasy: "times", serif: "times" }, Wh = { caption: "times", icon: "times", menu: "times", "message-box": "times", "small-caption": "times", "status-bar": "times" };
function Xh(t) {
  return [t.stretch, t.style, t.weight, t.family].join(" ");
}
function Jh(t) {
  return t.trimLeft();
}
function T4(t, A) {
  for (var e = 0; e < t.length; ) {
    if (t.charAt(e) === A) return [t.substring(0, e), t.substring(e + 1)];
    e += 1;
  }
  return null;
}
function O4(t) {
  var A = t.match(/^(-[a-z_]|[a-z_])[a-z0-9_-]*/i);
  return A === null ? null : [A[0], t.substring(A[0].length)];
}
var po, Yh, zh, Ki, wo, Zh, $h, A0, wl = ["times"];
function e0(t, A, e, r, n) {
  var i = 4, o = r0;
  switch (n) {
    case PA.API.image_compression.FAST:
      i = 1, o = t0;
      break;
    case PA.API.image_compression.MEDIUM:
      i = 6, o = n0;
      break;
    case PA.API.image_compression.SLOW:
      i = 9, o = i0;
  }
  t = (function(c, u, h, p) {
    for (var w, d = c.length / u, y = new Uint8Array(c.length + d), b = [k4, t0, r0, n0, i0], S = 0; S < d; S += 1) {
      var Q = S * u, P = c.subarray(Q, Q + u);
      if (p) y.set(p(P, h, w), Q + S);
      else {
        for (var G = b.length, k = [], Y = 0; Y < G; Y += 1) k[Y] = b[Y](P, h, w);
        var z = M4(k.concat());
        y.set(k[z], Q + S);
      }
      w = P;
    }
    return y;
  })(t, A, Math.ceil(e * r / 8), o);
  var s = Wl(t, { level: i });
  return PA.API.__addimage__.arrayBufferToBinaryString(s);
}
function k4(t) {
  var A = Array.apply([], t);
  return A.unshift(0), A;
}
function t0(t, A) {
  var e = t.length, r = [];
  r[0] = 1;
  for (var n = 0; n < e; n += 1) {
    var i = t[n - A] || 0;
    r[n + 1] = t[n] - i + 256 & 255;
  }
  return r;
}
function r0(t, A, e) {
  var r = t.length, n = [];
  n[0] = 2;
  for (var i = 0; i < r; i += 1) {
    var o = e && e[i] || 0;
    n[i + 1] = t[i] - o + 256 & 255;
  }
  return n;
}
function n0(t, A, e) {
  var r = t.length, n = [];
  n[0] = 3;
  for (var i = 0; i < r; i += 1) {
    var o = t[i - A] || 0, s = e && e[i] || 0;
    n[i + 1] = t[i] + 256 - (o + s >>> 1) & 255;
  }
  return n;
}
function i0(t, A, e) {
  var r = t.length, n = [];
  n[0] = 4;
  for (var i = 0; i < r; i += 1) {
    var o = P4(t[i - A] || 0, e && e[i] || 0, e && e[i - A] || 0);
    n[i + 1] = t[i] - o + 256 & 255;
  }
  return n;
}
function P4(t, A, e) {
  if (t === A && A === e) return t;
  var r = Math.abs(A - e), n = Math.abs(t - e), i = Math.abs(t + A - e - e);
  return r <= n && r <= i ? t : n <= i ? A : e;
}
function M4(t) {
  var A = t.map(function(e) {
    return e.reduce(function(r, n) {
      return r + Math.abs(n);
    }, 0);
  });
  return A.indexOf(Math.min.apply(null, A));
}
function vl(t, A, e) {
  var r = A * e, n = Math.floor(r / 8), i = 16 - (r - 8 * n + e), o = (1 << e) - 1;
  return tB(t, n) >> i & o;
}
function a0(t, A, e, r) {
  var n = e * r, i = Math.floor(n / 8), o = 16 - (n - 8 * i + r), s = (1 << r) - 1, c = (A & s) << o;
  (function(u, h, p) {
    if (h + 1 < u.byteLength) u.setUint16(h, p, !1);
    else {
      var w = p >> 8 & 255;
      u.setUint8(h, w);
    }
  })(t, i, tB(t, i) & ~(s << o) & 65535 | c);
}
function tB(t, A) {
  return A + 1 < t.byteLength ? t.getUint16(A, !1) : t.getUint8(A) << 8;
}
function K4(t) {
  var A = 0;
  if (t[A++] !== 71 || t[A++] !== 73 || t[A++] !== 70 || t[A++] !== 56 || (t[A++] + 1 & 253) != 56 || t[A++] !== 97) throw new Error("Invalid GIF 87a/89a header.");
  var e = t[A++] | t[A++] << 8, r = t[A++] | t[A++] << 8, n = t[A++], i = n >> 7, o = 1 << 1 + (7 & n);
  t[A++], t[A++];
  var s = null, c = null;
  i && (s = A, c = o, A += 3 * o);
  var u = !0, h = [], p = 0, w = null, d = 0, y = null;
  for (this.width = e, this.height = r; u && A < t.length; ) switch (t[A++]) {
    case 33:
      switch (t[A++]) {
        case 255:
          if (t[A] !== 11 || t[A + 1] == 78 && t[A + 2] == 69 && t[A + 3] == 84 && t[A + 4] == 83 && t[A + 5] == 67 && t[A + 6] == 65 && t[A + 7] == 80 && t[A + 8] == 69 && t[A + 9] == 50 && t[A + 10] == 46 && t[A + 11] == 48 && t[A + 12] == 3 && t[A + 13] == 1 && t[A + 16] == 0) A += 14, y = t[A++] | t[A++] << 8, A++;
          else for (A += 12; ; ) {
            if (!((E = t[A++]) >= 0)) throw Error("Invalid block size");
            if (E === 0) break;
            A += E;
          }
          break;
        case 249:
          if (t[A++] !== 4 || t[A + 4] !== 0) throw new Error("Invalid graphics extension block.");
          var b = t[A++];
          p = t[A++] | t[A++] << 8, w = t[A++], 1 & b || (w = null), d = b >> 2 & 7, A++;
          break;
        case 254:
          for (; ; ) {
            if (!((E = t[A++]) >= 0)) throw Error("Invalid block size");
            if (E === 0) break;
            A += E;
          }
          break;
        default:
          throw new Error("Unknown graphic control label: 0x" + t[A - 1].toString(16));
      }
      break;
    case 44:
      var S = t[A++] | t[A++] << 8, Q = t[A++] | t[A++] << 8, P = t[A++] | t[A++] << 8, G = t[A++] | t[A++] << 8, k = t[A++], Y = k >> 6 & 1, z = 1 << 1 + (7 & k), iA = s, j = c, N = !1;
      k >> 7 && (N = !0, iA = A, j = z, A += 3 * z);
      var Z = A;
      for (A++; ; ) {
        var E;
        if (!((E = t[A++]) >= 0)) throw Error("Invalid block size");
        if (E === 0) break;
        A += E;
      }
      h.push({ x: S, y: Q, width: P, height: G, has_local_palette: N, palette_offset: iA, palette_size: j, data_offset: Z, data_length: A - Z, transparent_index: w, interlaced: !!Y, delay: p, disposal: d });
      break;
    case 59:
      u = !1;
      break;
    default:
      throw new Error("Unknown gif block: 0x" + t[A - 1].toString(16));
  }
  this.numFrames = function() {
    return h.length;
  }, this.loopCount = function() {
    return y;
  }, this.frameInfo = function(I) {
    if (I < 0 || I >= h.length) throw new Error("Frame index out of range.");
    return h[I];
  }, this.decodeAndBlitFrameBGRA = function(I, K) {
    var R = this.frameInfo(I), aA = R.width * R.height, sA = new Uint8Array(aA);
    s0(t, R.data_offset, sA, aA);
    var oA = R.palette_offset, tA = R.transparent_index;
    tA === null && (tA = 256);
    var cA = R.width, QA = e - cA, pA = cA, F = 4 * (R.y * e + R.x), O = 4 * ((R.y + R.height) * e + R.x), M = F, q = 4 * QA;
    R.interlaced === !0 && (q += 4 * e * 7);
    for (var X = 8, eA = 0, lA = sA.length; eA < lA; ++eA) {
      var uA = sA[eA];
      if (pA === 0 && (pA = cA, (M += q) >= O && (q = 4 * QA + 4 * e * (X - 1), M = F + (cA + QA) * (X << 1), X >>= 1)), uA === tA) M += 4;
      else {
        var gA = t[oA + 3 * uA], FA = t[oA + 3 * uA + 1], LA = t[oA + 3 * uA + 2];
        K[M++] = LA, K[M++] = FA, K[M++] = gA, K[M++] = 255;
      }
      --pA;
    }
  }, this.decodeAndBlitFrameRGBA = function(I, K) {
    var R = this.frameInfo(I), aA = R.width * R.height, sA = new Uint8Array(aA);
    s0(t, R.data_offset, sA, aA);
    var oA = R.palette_offset, tA = R.transparent_index;
    tA === null && (tA = 256);
    var cA = R.width, QA = e - cA, pA = cA, F = 4 * (R.y * e + R.x), O = 4 * ((R.y + R.height) * e + R.x), M = F, q = 4 * QA;
    R.interlaced === !0 && (q += 4 * e * 7);
    for (var X = 8, eA = 0, lA = sA.length; eA < lA; ++eA) {
      var uA = sA[eA];
      if (pA === 0 && (pA = cA, (M += q) >= O && (q = 4 * QA + 4 * e * (X - 1), M = F + (cA + QA) * (X << 1), X >>= 1)), uA === tA) M += 4;
      else {
        var gA = t[oA + 3 * uA], FA = t[oA + 3 * uA + 1], LA = t[oA + 3 * uA + 2];
        K[M++] = gA, K[M++] = FA, K[M++] = LA, K[M++] = 255;
      }
      --pA;
    }
  };
}
function s0(t, A, e, r) {
  for (var n = t[A++], i = 1 << n, o = i + 1, s = o + 1, c = n + 1, u = (1 << c) - 1, h = 0, p = 0, w = 0, d = t[A++], y = new Int32Array(4096), b = null; ; ) {
    for (; h < 16 && d !== 0; ) p |= t[A++] << h, h += 8, d === 1 ? d = t[A++] : --d;
    if (h < c) break;
    var S = p & u;
    if (p >>= c, h -= c, S !== i) {
      if (S === o) break;
      for (var Q = S < s ? S : b, P = 0, G = Q; G > i; ) G = y[G] >> 8, ++P;
      var k = G;
      if (w + P + (Q !== S ? 1 : 0) > r) return void Se.log("Warning, gif stream longer than expected.");
      e[w++] = k;
      var Y = w += P;
      for (Q !== S && (e[w++] = k), G = Q; P--; ) G = y[G], e[--Y] = 255 & G, G >>= 8;
      b !== null && s < 4096 && (y[s++] = b << 8 | k, s >= u + 1 && c < 12 && (++c, u = u << 1 | 1)), b = S;
    } else s = o + 1, u = (1 << (c = n + 1)) - 1, b = null;
  }
  return w !== r && Se.log("Warning, gif stream shorter than expected."), e;
}
/**
 * @license
  Copyright (c) 2008, Adobe Systems Incorporated
  All rights reserved.

  Redistribution and use in source and binary forms, with or without 
  modification, are permitted provided that the following conditions are
  met:

  * Redistributions of source code must retain the above copyright notice, 
    this list of conditions and the following disclaimer.
  
  * Redistributions in binary form must reproduce the above copyright
    notice, this list of conditions and the following disclaimer in the 
    documentation and/or other materials provided with the distribution.
  
  * Neither the name of Adobe Systems Incorporated nor the names of its 
    contributors may be used to endorse or promote products derived from 
    this software without specific prior written permission.

  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
  IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
  THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
  PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR 
  CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
  PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
  LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
  SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/
function Cl(t) {
  var A, e, r, n, i, o = Math.floor, s = new Array(64), c = new Array(64), u = new Array(64), h = new Array(64), p = new Array(65535), w = new Array(65535), d = new Array(64), y = new Array(64), b = [], S = 0, Q = 7, P = new Array(64), G = new Array(64), k = new Array(64), Y = new Array(256), z = new Array(2048), iA = [0, 1, 5, 6, 14, 15, 27, 28, 2, 4, 7, 13, 16, 26, 29, 42, 3, 8, 12, 17, 25, 30, 41, 43, 9, 11, 18, 24, 31, 40, 44, 53, 10, 19, 23, 32, 39, 45, 52, 54, 20, 22, 33, 38, 46, 51, 55, 60, 21, 34, 37, 47, 50, 56, 59, 61, 35, 36, 48, 49, 57, 58, 62, 63], j = [0, 0, 1, 5, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0], N = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], Z = [0, 0, 2, 1, 3, 3, 2, 4, 3, 5, 5, 4, 4, 0, 0, 1, 125], E = [1, 2, 3, 0, 4, 17, 5, 18, 33, 49, 65, 6, 19, 81, 97, 7, 34, 113, 20, 50, 129, 145, 161, 8, 35, 66, 177, 193, 21, 82, 209, 240, 36, 51, 98, 114, 130, 9, 10, 22, 23, 24, 25, 26, 37, 38, 39, 40, 41, 42, 52, 53, 54, 55, 56, 57, 58, 67, 68, 69, 70, 71, 72, 73, 74, 83, 84, 85, 86, 87, 88, 89, 90, 99, 100, 101, 102, 103, 104, 105, 106, 115, 116, 117, 118, 119, 120, 121, 122, 131, 132, 133, 134, 135, 136, 137, 138, 146, 147, 148, 149, 150, 151, 152, 153, 154, 162, 163, 164, 165, 166, 167, 168, 169, 170, 178, 179, 180, 181, 182, 183, 184, 185, 186, 194, 195, 196, 197, 198, 199, 200, 201, 202, 210, 211, 212, 213, 214, 215, 216, 217, 218, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250], I = [0, 0, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0], K = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], R = [0, 0, 2, 1, 2, 4, 4, 3, 4, 7, 5, 4, 4, 0, 1, 2, 119], aA = [0, 1, 2, 3, 17, 4, 5, 33, 49, 6, 18, 65, 81, 7, 97, 113, 19, 34, 50, 129, 8, 20, 66, 145, 161, 177, 193, 9, 35, 51, 82, 240, 21, 98, 114, 209, 10, 22, 36, 52, 225, 37, 241, 23, 24, 25, 26, 38, 39, 40, 41, 42, 53, 54, 55, 56, 57, 58, 67, 68, 69, 70, 71, 72, 73, 74, 83, 84, 85, 86, 87, 88, 89, 90, 99, 100, 101, 102, 103, 104, 105, 106, 115, 116, 117, 118, 119, 120, 121, 122, 130, 131, 132, 133, 134, 135, 136, 137, 138, 146, 147, 148, 149, 150, 151, 152, 153, 154, 162, 163, 164, 165, 166, 167, 168, 169, 170, 178, 179, 180, 181, 182, 183, 184, 185, 186, 194, 195, 196, 197, 198, 199, 200, 201, 202, 210, 211, 212, 213, 214, 215, 216, 217, 218, 226, 227, 228, 229, 230, 231, 232, 233, 234, 242, 243, 244, 245, 246, 247, 248, 249, 250];
  function sA(F, O) {
    for (var M = 0, q = 0, X = new Array(), eA = 1; eA <= 16; eA++) {
      for (var lA = 1; lA <= F[eA]; lA++) X[O[q]] = [], X[O[q]][0] = M, X[O[q]][1] = eA, q++, M++;
      M *= 2;
    }
    return X;
  }
  function oA(F) {
    for (var O = F[0], M = F[1] - 1; M >= 0; ) O & 1 << M && (S |= 1 << Q), M--, --Q < 0 && (S == 255 ? (tA(255), tA(0)) : tA(S), Q = 7, S = 0);
  }
  function tA(F) {
    b.push(F);
  }
  function cA(F) {
    tA(F >> 8 & 255), tA(255 & F);
  }
  function QA(F, O, M, q, X) {
    for (var eA, lA = X[0], uA = X[240], gA = (function(CA, qA) {
      var SA, VA, RA, Ce, ue, Ae, Be, fe, TA, re, MA = 0;
      for (TA = 0; TA < 8; ++TA) {
        SA = CA[MA], VA = CA[MA + 1], RA = CA[MA + 2], Ce = CA[MA + 3], ue = CA[MA + 4], Ae = CA[MA + 5], Be = CA[MA + 6];
        var We = SA + (fe = CA[MA + 7]), pe = SA - fe, oe = VA + Be, ce = VA - Be, ke = RA + Ae, GA = RA - Ae, He = Ce + ue, JA = Ce - ue, ee = We + He, Pe = We - He, le = oe + ke, WA = oe - ke;
        CA[MA] = ee + le, CA[MA + 4] = ee - le;
        var me = 0.707106781 * (WA + Pe);
        CA[MA + 2] = Pe + me, CA[MA + 6] = Pe - me;
        var Vn = 0.382683433 * ((ee = JA + GA) - (WA = ce + pe)), bt = 0.5411961 * ee + Vn, Gr = 1.306562965 * WA + Vn, Er = 0.707106781 * (le = GA + ce), XA = pe + Er, Vr = pe - Er;
        CA[MA + 5] = Vr + bt, CA[MA + 3] = Vr - bt, CA[MA + 1] = XA + Gr, CA[MA + 7] = XA - Gr, MA += 8;
      }
      for (MA = 0, TA = 0; TA < 8; ++TA) {
        SA = CA[MA], VA = CA[MA + 8], RA = CA[MA + 16], Ce = CA[MA + 24], ue = CA[MA + 32], Ae = CA[MA + 40], Be = CA[MA + 48];
        var jr = SA + (fe = CA[MA + 56]), $t = SA - fe, Ar = VA + Be, Ge = VA - Be, Bt = RA + Ae, pt = RA - Ae, jn = Ce + ue, dn = Ce - ue, hr = jr + jn, Lr = jr - jn, Br = Ar + Bt, dr = Ar - Bt;
        CA[MA] = hr + Br, CA[MA + 32] = hr - Br;
        var er = 0.707106781 * (dr + Lr);
        CA[MA + 16] = Lr + er, CA[MA + 48] = Lr - er;
        var qn = 0.382683433 * ((hr = dn + pt) - (dr = Ge + $t)), xr = 0.5411961 * hr + qn, Wn = 1.306562965 * dr + qn, Ci = 0.707106781 * (Br = pt + Ge), mi = $t + Ci, Qi = $t - Ci;
        CA[MA + 40] = Qi + xr, CA[MA + 24] = Qi - xr, CA[MA + 8] = mi + Wn, CA[MA + 56] = mi - Wn, MA++;
      }
      for (TA = 0; TA < 64; ++TA) re = CA[TA] * qA[TA], d[TA] = re > 0 ? re + 0.5 | 0 : re - 0.5 | 0;
      return d;
    })(F, O), FA = 0; FA < 64; ++FA) y[iA[FA]] = gA[FA];
    var LA = y[0] - M;
    M = y[0], LA == 0 ? oA(q[0]) : (oA(q[w[eA = 32767 + LA]]), oA(p[eA]));
    for (var yA = 63; yA > 0 && y[yA] == 0; ) yA--;
    if (yA == 0) return oA(lA), M;
    for (var KA, H = 1; H <= yA; ) {
      for (var bA = H; y[H] == 0 && H <= yA; ) ++H;
      var se = H - bA;
      if (se >= 16) {
        KA = se >> 4;
        for (var jA = 1; jA <= KA; ++jA) oA(uA);
        se &= 15;
      }
      eA = 32767 + y[H], oA(X[(se << 4) + w[eA]]), oA(p[eA]), H++;
    }
    return yA != 63 && oA(lA), M;
  }
  function pA(F) {
    F = Math.min(Math.max(F, 1), 100), i != F && ((function(O) {
      for (var M = [16, 11, 10, 16, 24, 40, 51, 61, 12, 12, 14, 19, 26, 58, 60, 55, 14, 13, 16, 24, 40, 57, 69, 56, 14, 17, 22, 29, 51, 87, 80, 62, 18, 22, 37, 56, 68, 109, 103, 77, 24, 35, 55, 64, 81, 104, 113, 92, 49, 64, 78, 87, 103, 121, 120, 101, 72, 92, 95, 98, 112, 100, 103, 99], q = 0; q < 64; q++) {
        var X = o((M[q] * O + 50) / 100);
        X = Math.min(Math.max(X, 1), 255), s[iA[q]] = X;
      }
      for (var eA = [17, 18, 24, 47, 99, 99, 99, 99, 18, 21, 26, 66, 99, 99, 99, 99, 24, 26, 56, 99, 99, 99, 99, 99, 47, 66, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99], lA = 0; lA < 64; lA++) {
        var uA = o((eA[lA] * O + 50) / 100);
        uA = Math.min(Math.max(uA, 1), 255), c[iA[lA]] = uA;
      }
      for (var gA = [1, 1.387039845, 1.306562965, 1.175875602, 1, 0.785694958, 0.5411961, 0.275899379], FA = 0, LA = 0; LA < 8; LA++) for (var yA = 0; yA < 8; yA++) u[FA] = 1 / (s[iA[FA]] * gA[LA] * gA[yA] * 8), h[FA] = 1 / (c[iA[FA]] * gA[LA] * gA[yA] * 8), FA++;
    })(F < 50 ? Math.floor(5e3 / F) : Math.floor(200 - 2 * F)), i = F);
  }
  this.encode = function(F, O) {
    O && pA(O), b = new Array(), S = 0, Q = 7, cA(65496), cA(65504), cA(16), tA(74), tA(70), tA(73), tA(70), tA(0), tA(1), tA(1), tA(0), cA(1), cA(1), tA(0), tA(0), (function() {
      cA(65499), cA(132), tA(0);
      for (var VA = 0; VA < 64; VA++) tA(s[VA]);
      tA(1);
      for (var RA = 0; RA < 64; RA++) tA(c[RA]);
    })(), (function(VA, RA) {
      cA(65472), cA(17), tA(8), cA(RA), cA(VA), tA(3), tA(1), tA(17), tA(0), tA(2), tA(17), tA(1), tA(3), tA(17), tA(1);
    })(F.width, F.height), (function() {
      cA(65476), cA(418), tA(0);
      for (var VA = 0; VA < 16; VA++) tA(j[VA + 1]);
      for (var RA = 0; RA <= 11; RA++) tA(N[RA]);
      tA(16);
      for (var Ce = 0; Ce < 16; Ce++) tA(Z[Ce + 1]);
      for (var ue = 0; ue <= 161; ue++) tA(E[ue]);
      tA(1);
      for (var Ae = 0; Ae < 16; Ae++) tA(I[Ae + 1]);
      for (var Be = 0; Be <= 11; Be++) tA(K[Be]);
      tA(17);
      for (var fe = 0; fe < 16; fe++) tA(R[fe + 1]);
      for (var TA = 0; TA <= 161; TA++) tA(aA[TA]);
    })(), cA(65498), cA(12), tA(3), tA(1), tA(0), tA(2), tA(17), tA(3), tA(17), tA(0), tA(63), tA(0);
    var M = 0, q = 0, X = 0;
    S = 0, Q = 7, this.encode.displayName = "_encode_";
    for (var eA, lA, uA, gA, FA, LA, yA, KA, H, bA = F.data, se = F.width, jA = F.height, CA = 4 * se, qA = 0; qA < jA; ) {
      for (eA = 0; eA < CA; ) {
        for (FA = CA * qA + eA, yA = -1, KA = 0, H = 0; H < 64; H++) LA = FA + (KA = H >> 3) * CA + (yA = 4 * (7 & H)), qA + KA >= jA && (LA -= CA * (qA + 1 + KA - jA)), eA + yA >= CA && (LA -= eA + yA - CA + 4), lA = bA[LA++], uA = bA[LA++], gA = bA[LA++], P[H] = (z[lA] + z[uA + 256 | 0] + z[gA + 512 | 0] >> 16) - 128, G[H] = (z[lA + 768 | 0] + z[uA + 1024 | 0] + z[gA + 1280 | 0] >> 16) - 128, k[H] = (z[lA + 1280 | 0] + z[uA + 1536 | 0] + z[gA + 1792 | 0] >> 16) - 128;
        M = QA(P, u, M, A, r), q = QA(G, h, q, e, n), X = QA(k, h, X, e, n), eA += 32;
      }
      qA += 8;
    }
    if (Q >= 0) {
      var SA = [];
      SA[1] = Q + 1, SA[0] = (1 << Q + 1) - 1, oA(SA);
    }
    return cA(65497), new Uint8Array(b);
  }, t = t || 50, (function() {
    for (var F = String.fromCharCode, O = 0; O < 256; O++) Y[O] = F(O);
  })(), A = sA(j, N), e = sA(I, K), r = sA(Z, E), n = sA(R, aA), (function() {
    for (var F = 1, O = 2, M = 1; M <= 15; M++) {
      for (var q = F; q < O; q++) w[32767 + q] = M, p[32767 + q] = [], p[32767 + q][1] = M, p[32767 + q][0] = q;
      for (var X = -(O - 1); X <= -F; X++) w[32767 + X] = M, p[32767 + X] = [], p[32767 + X][1] = M, p[32767 + X][0] = O - 1 + X;
      F <<= 1, O <<= 1;
    }
  })(), (function() {
    for (var F = 0; F < 256; F++) z[F] = 19595 * F, z[F + 256 | 0] = 38470 * F, z[F + 512 | 0] = 7471 * F + 32768, z[F + 768 | 0] = -11059 * F, z[F + 1024 | 0] = -21709 * F, z[F + 1280 | 0] = 32768 * F + 8421375, z[F + 1536 | 0] = -27439 * F, z[F + 1792 | 0] = -5329 * F;
  })(), pA(t);
}
/**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function mr(t, A) {
  if (this.pos = 0, this.buffer = t, this.datav = new DataView(t.buffer), this.is_with_alpha = !!A, this.bottom_up = !0, this.flag = String.fromCharCode(this.buffer[0]) + String.fromCharCode(this.buffer[1]), this.pos += 2, ["BM", "BA", "CI", "CP", "IC", "PT"].indexOf(this.flag) === -1) throw new Error("Invalid BMP File");
  this.parseHeader(), this.parseBGR();
}
function o0(t) {
  function A(N) {
    if (!N) throw Error("assert :P");
  }
  function e(N, Z, E) {
    for (var I = 0; 4 > I; I++) if (N[Z + I] != E.charCodeAt(I)) return !0;
    return !1;
  }
  function r(N, Z, E, I, K) {
    for (var R = 0; R < K; R++) N[Z + R] = E[I + R];
  }
  function n(N, Z, E, I) {
    for (var K = 0; K < I; K++) N[Z + K] = E;
  }
  function i(N) {
    return new Int32Array(N);
  }
  function o(N, Z) {
    for (var E = [], I = 0; I < N; I++) E.push(new Z());
    return E;
  }
  function s(N, Z) {
    var E = [];
    return (function I(K, R, aA) {
      for (var sA = aA[R], oA = 0; oA < sA && (K.push(aA.length > R + 1 ? [] : new Z()), !(aA.length < R + 1)); oA++) I(K[oA], R + 1, aA);
    })(E, 0, N), E;
  }
  var c = function() {
    var N = this;
    function Z(a, l) {
      for (var B = 1 << l - 1 >>> 0; a & B; ) B >>>= 1;
      return B ? (a & B - 1) + B : a;
    }
    function E(a, l, B, g, C) {
      A(!(g % B));
      do
        a[l + (g -= B)] = C;
      while (0 < g);
    }
    function I(a, l, B, g, C) {
      if (A(2328 >= C), 512 >= C) var m = i(512);
      else if ((m = i(C)) == null) return 0;
      return (function(U, L, x, _, W, nA) {
        var D, J, AA = L, fA = 1 << x, rA = i(16), hA = i(16);
        for (A(W != 0), A(_ != null), A(U != null), A(0 < x), J = 0; J < W; ++J) {
          if (15 < _[J]) return 0;
          ++rA[_[J]];
        }
        if (rA[0] == W) return 0;
        for (hA[1] = 0, D = 1; 15 > D; ++D) {
          if (rA[D] > 1 << D) return 0;
          hA[D + 1] = hA[D] + rA[D];
        }
        for (J = 0; J < W; ++J) D = _[J], 0 < _[J] && (nA[hA[D]++] = J);
        if (hA[15] == 1) return (_ = new K()).g = 0, _.value = nA[0], E(U, AA, 1, fA, _), fA;
        var dA, mA = -1, vA = fA - 1, kA = 0, IA = 1, ie = 1, _A = 1 << x;
        for (J = 0, D = 1, W = 2; D <= x; ++D, W <<= 1) {
          if (IA += ie <<= 1, 0 > (ie -= rA[D])) return 0;
          for (; 0 < rA[D]; --rA[D]) (_ = new K()).g = D, _.value = nA[J++], E(U, AA + kA, W, _A, _), kA = Z(kA, D);
        }
        for (D = x + 1, W = 2; 15 >= D; ++D, W <<= 1) {
          if (IA += ie <<= 1, 0 > (ie -= rA[D])) return 0;
          for (; 0 < rA[D]; --rA[D]) {
            if (_ = new K(), (kA & vA) != mA) {
              for (AA += _A, dA = 1 << (mA = D) - x; 15 > mA && !(0 >= (dA -= rA[mA])); ) ++mA, dA <<= 1;
              fA += _A = 1 << (dA = mA - x), U[L + (mA = kA & vA)].g = dA + x, U[L + mA].value = AA - L - mA;
            }
            _.g = D - x, _.value = nA[J++], E(U, AA + (kA >> x), W, _A, _), kA = Z(kA, D);
          }
        }
        return IA != 2 * hA[15] - 1 ? 0 : fA;
      })(a, l, B, g, C, m);
    }
    function K() {
      this.value = this.g = 0;
    }
    function R() {
      this.value = this.g = 0;
    }
    function aA() {
      this.G = o(5, K), this.H = i(5), this.jc = this.Qb = this.qb = this.nd = 0, this.pd = o(ni, R);
    }
    function sA(a, l, B, g) {
      A(a != null), A(l != null), A(2147483648 > g), a.Ca = 254, a.I = 0, a.b = -8, a.Ka = 0, a.oa = l, a.pa = B, a.Jd = l, a.Yc = B + g, a.Zc = 4 <= g ? B + g - 4 + 1 : B, lA(a);
    }
    function oA(a, l) {
      for (var B = 0; 0 < l--; ) B |= gA(a, 128) << l;
      return B;
    }
    function tA(a, l) {
      var B = oA(a, l);
      return uA(a) ? -B : B;
    }
    function cA(a, l, B, g) {
      var C, m = 0;
      for (A(a != null), A(l != null), A(4294967288 > g), a.Sb = g, a.Ra = 0, a.u = 0, a.h = 0, 4 < g && (g = 4), C = 0; C < g; ++C) m += l[B + C] << 8 * C;
      a.Ra = m, a.bb = g, a.oa = l, a.pa = B;
    }
    function QA(a) {
      for (; 8 <= a.u && a.bb < a.Sb; ) a.Ra >>>= 8, a.Ra += a.oa[a.pa + a.bb] << vn - 8 >>> 0, ++a.bb, a.u -= 8;
      q(a) && (a.h = 1, a.u = 0);
    }
    function pA(a, l) {
      if (A(0 <= l), !a.h && l <= Gt) {
        var B = M(a) & Rt[l];
        return a.u += l, QA(a), B;
      }
      return a.h = 1, a.u = 0;
    }
    function F() {
      this.b = this.Ca = this.I = 0, this.oa = [], this.pa = 0, this.Jd = [], this.Yc = 0, this.Zc = [], this.Ka = 0;
    }
    function O() {
      this.Ra = 0, this.oa = [], this.h = this.u = this.bb = this.Sb = this.pa = 0;
    }
    function M(a) {
      return a.Ra >>> (a.u & vn - 1) >>> 0;
    }
    function q(a) {
      return A(a.bb <= a.Sb), a.h || a.bb == a.Sb && a.u > vn;
    }
    function X(a, l) {
      a.u = l, a.h = q(a);
    }
    function eA(a) {
      a.u >= tn && (A(a.u >= tn), QA(a));
    }
    function lA(a) {
      A(a != null && a.oa != null), a.pa < a.Zc ? (a.I = (a.oa[a.pa++] | a.I << 8) >>> 0, a.b += 8) : (A(a != null && a.oa != null), a.pa < a.Yc ? (a.b += 8, a.I = a.oa[a.pa++] | a.I << 8) : a.Ka ? a.b = 0 : (a.I <<= 8, a.b += 8, a.Ka = 1));
    }
    function uA(a) {
      return oA(a, 1);
    }
    function gA(a, l) {
      var B = a.Ca;
      0 > a.b && lA(a);
      var g = a.b, C = B * l >>> 8, m = (a.I >>> g > C) + 0;
      for (m ? (B -= C, a.I -= C + 1 << g >>> 0) : B = C + 1, g = B, C = 0; 256 <= g; ) C += 8, g >>= 8;
      return g = 7 ^ C + Cn[g], a.b -= g, a.Ca = (B << g) - 1, m;
    }
    function FA(a, l, B) {
      a[l + 0] = B >> 24 & 255, a[l + 1] = B >> 16 & 255, a[l + 2] = B >> 8 & 255, a[l + 3] = 255 & B;
    }
    function LA(a, l) {
      return a[l + 0] | a[l + 1] << 8;
    }
    function yA(a, l) {
      return LA(a, l) | a[l + 2] << 16;
    }
    function KA(a, l) {
      return LA(a, l) | LA(a, l + 2) << 16;
    }
    function H(a, l) {
      var B = 1 << l;
      return A(a != null), A(0 < l), a.X = i(B), a.X == null ? 0 : (a.Mb = 32 - l, a.Xa = l, 1);
    }
    function bA(a, l) {
      A(a != null), A(l != null), A(a.Xa == l.Xa), r(l.X, 0, a.X, 0, 1 << l.Xa);
    }
    function se() {
      this.X = [], this.Xa = this.Mb = 0;
    }
    function jA(a, l, B, g) {
      A(B != null), A(g != null);
      var C = B[0], m = g[0];
      return C == 0 && (C = (a * m + l / 2) / l), m == 0 && (m = (l * C + a / 2) / a), 0 >= C || 0 >= m ? 0 : (B[0] = C, g[0] = m, 1);
    }
    function CA(a, l) {
      return a + (1 << l) - 1 >>> l;
    }
    function qA(a, l) {
      return ((4278255360 & a) + (4278255360 & l) >>> 0 & 4278255360) + ((16711935 & a) + (16711935 & l) >>> 0 & 16711935) >>> 0;
    }
    function SA(a, l) {
      N[l] = function(B, g, C, m, U, L, x) {
        var _;
        for (_ = 0; _ < U; ++_) {
          var W = N[a](L[x + _ - 1], C, m + _);
          L[x + _] = qA(B[g + _], W);
        }
      };
    }
    function VA() {
      this.ud = this.hd = this.jd = 0;
    }
    function RA(a, l) {
      return ((4278124286 & (a ^ l)) >>> 1) + (a & l) >>> 0;
    }
    function Ce(a) {
      return 0 <= a && 256 > a ? a : 0 > a ? 0 : 255 < a ? 255 : void 0;
    }
    function ue(a, l) {
      return Ce(a + (a - l + 0.5 >> 1));
    }
    function Ae(a, l, B) {
      return Math.abs(l - B) - Math.abs(a - B);
    }
    function Be(a, l, B, g, C, m, U) {
      for (g = m[U - 1], B = 0; B < C; ++B) m[U + B] = g = qA(a[l + B], g);
    }
    function fe(a, l, B, g, C) {
      var m;
      for (m = 0; m < B; ++m) {
        var U = a[l + m], L = U >> 8 & 255, x = 16711935 & (x = (x = 16711935 & U) + ((L << 16) + L));
        g[C + m] = (4278255360 & U) + x >>> 0;
      }
    }
    function TA(a, l) {
      l.jd = 255 & a, l.hd = a >> 8 & 255, l.ud = a >> 16 & 255;
    }
    function re(a, l, B, g, C, m) {
      var U;
      for (U = 0; U < g; ++U) {
        var L = l[B + U], x = L >>> 8, _ = L, W = 255 & (W = (W = L >>> 16) + ((a.jd << 24 >> 24) * (x << 24 >> 24) >>> 5));
        _ = 255 & (_ = (_ += (a.hd << 24 >> 24) * (x << 24 >> 24) >>> 5) + ((a.ud << 24 >> 24) * (W << 24 >> 24) >>> 5)), C[m + U] = (4278255360 & L) + (W << 16) + _;
      }
    }
    function MA(a, l, B, g, C) {
      N[l] = function(m, U, L, x, _, W, nA, D, J) {
        for (x = nA; x < D; ++x) for (nA = 0; nA < J; ++nA) _[W++] = C(L[g(m[U++])]);
      }, N[a] = function(m, U, L, x, _, W, nA) {
        var D = 8 >> m.b, J = m.Ea, AA = m.K[0], fA = m.w;
        if (8 > D) for (m = (1 << m.b) - 1, fA = (1 << D) - 1; U < L; ++U) {
          var rA, hA = 0;
          for (rA = 0; rA < J; ++rA) rA & m || (hA = g(x[_++])), W[nA++] = C(AA[hA & fA]), hA >>= D;
        }
        else N["VP8LMapColor" + B](x, _, AA, fA, W, nA, U, L, J);
      };
    }
    function We(a, l, B, g, C) {
      for (B = l + B; l < B; ) {
        var m = a[l++];
        g[C++] = m >> 16 & 255, g[C++] = m >> 8 & 255, g[C++] = 255 & m;
      }
    }
    function pe(a, l, B, g, C) {
      for (B = l + B; l < B; ) {
        var m = a[l++];
        g[C++] = m >> 16 & 255, g[C++] = m >> 8 & 255, g[C++] = 255 & m, g[C++] = m >> 24 & 255;
      }
    }
    function oe(a, l, B, g, C) {
      for (B = l + B; l < B; ) {
        var m = (U = a[l++]) >> 16 & 240 | U >> 12 & 15, U = 240 & U | U >> 28 & 15;
        g[C++] = m, g[C++] = U;
      }
    }
    function ce(a, l, B, g, C) {
      for (B = l + B; l < B; ) {
        var m = (U = a[l++]) >> 16 & 248 | U >> 13 & 7, U = U >> 5 & 224 | U >> 3 & 31;
        g[C++] = m, g[C++] = U;
      }
    }
    function ke(a, l, B, g, C) {
      for (B = l + B; l < B; ) {
        var m = a[l++];
        g[C++] = 255 & m, g[C++] = m >> 8 & 255, g[C++] = m >> 16 & 255;
      }
    }
    function GA(a, l, B, g, C, m) {
      if (m == 0) for (B = l + B; l < B; ) FA(g, ((m = a[l++])[0] >> 24 | m[1] >> 8 & 65280 | m[2] << 8 & 16711680 | m[3] << 24) >>> 0), C += 32;
      else r(g, C, a, l, B);
    }
    function He(a, l) {
      N[l][0] = N[a + "0"], N[l][1] = N[a + "1"], N[l][2] = N[a + "2"], N[l][3] = N[a + "3"], N[l][4] = N[a + "4"], N[l][5] = N[a + "5"], N[l][6] = N[a + "6"], N[l][7] = N[a + "7"], N[l][8] = N[a + "8"], N[l][9] = N[a + "9"], N[l][10] = N[a + "10"], N[l][11] = N[a + "11"], N[l][12] = N[a + "12"], N[l][13] = N[a + "13"], N[l][14] = N[a + "0"], N[l][15] = N[a + "0"];
    }
    function JA(a) {
      return a == vc || a == Cc || a == xs || a == mc;
    }
    function ee() {
      this.eb = [], this.size = this.A = this.fb = 0;
    }
    function Pe() {
      this.y = [], this.f = [], this.ea = [], this.F = [], this.Tc = this.Ed = this.Cd = this.Fd = this.lb = this.Db = this.Ab = this.fa = this.J = this.W = this.N = this.O = 0;
    }
    function le() {
      this.Rd = this.height = this.width = this.S = 0, this.f = {}, this.f.RGBA = new ee(), this.f.kb = new Pe(), this.sd = null;
    }
    function WA() {
      this.width = [0], this.height = [0], this.Pd = [0], this.Qd = [0], this.format = [0];
    }
    function me() {
      this.Id = this.fd = this.Md = this.hb = this.ib = this.da = this.bd = this.cd = this.j = this.v = this.Da = this.Sd = this.ob = 0;
    }
    function Vn(a) {
      return alert("todo:WebPSamplerProcessPlane"), a.T;
    }
    function bt(a, l) {
      var B = a.T, g = l.ba.f.RGBA, C = g.eb, m = g.fb + a.ka * g.A, U = sr[l.ba.S], L = a.y, x = a.O, _ = a.f, W = a.N, nA = a.ea, D = a.W, J = l.cc, AA = l.dc, fA = l.Mc, rA = l.Nc, hA = a.ka, dA = a.ka + a.T, mA = a.U, vA = mA + 1 >> 1;
      for (hA == 0 ? U(L, x, null, null, _, W, nA, D, _, W, nA, D, C, m, null, null, mA) : (U(l.ec, l.fc, L, x, J, AA, fA, rA, _, W, nA, D, C, m - g.A, C, m, mA), ++B); hA + 2 < dA; hA += 2) J = _, AA = W, fA = nA, rA = D, W += a.Rc, D += a.Rc, m += 2 * g.A, U(L, (x += 2 * a.fa) - a.fa, L, x, J, AA, fA, rA, _, W, nA, D, C, m - g.A, C, m, mA);
      return x += a.fa, a.j + dA < a.o ? (r(l.ec, l.fc, L, x, mA), r(l.cc, l.dc, _, W, vA), r(l.Mc, l.Nc, nA, D, vA), B--) : 1 & dA || U(L, x, null, null, _, W, nA, D, _, W, nA, D, C, m + g.A, null, null, mA), B;
    }
    function Gr(a, l, B) {
      var g = a.F, C = [a.J];
      if (g != null) {
        var m = a.U, U = l.ba.S, L = U == Ls || U == xs;
        l = l.ba.f.RGBA;
        var x = [0], _ = a.ka;
        x[0] = a.T, a.Kb && (_ == 0 ? --x[0] : (--_, C[0] -= a.width), a.j + a.ka + a.T == a.o && (x[0] = a.o - a.j - _));
        var W = l.eb;
        _ = l.fb + _ * l.A, a = Cu(g, C[0], a.width, m, x, W, _ + (L ? 0 : 3), l.A), A(B == x), a && JA(U) && Ua(W, _, L, m, x, l.A);
      }
      return 0;
    }
    function Er(a) {
      var l = a.ma, B = l.ba.S, g = 11 > B, C = B == ys || B == Es || B == Ls || B == wc || B == 12 || JA(B);
      if (l.memory = null, l.Ib = null, l.Jb = null, l.Nd = null, !ga(l.Oa, a, C ? 11 : 12)) return 0;
      if (C && JA(B) && ha(), a.da) alert("todo:use_scaling");
      else {
        if (g) {
          if (l.Ib = Vn, a.Kb) {
            if (B = a.U + 1 >> 1, l.memory = i(a.U + 2 * B), l.memory == null) return 0;
            l.ec = l.memory, l.fc = 0, l.cc = l.ec, l.dc = l.fc + a.U, l.Mc = l.cc, l.Nc = l.dc + B, l.Ib = bt, ha();
          }
        } else alert("todo:EmitYUV");
        C && (l.Jb = Gr, g && pr());
      }
      if (g && !Tu) {
        for (a = 0; 256 > a; ++a) FB[a] = 89858 * (a - 128) + Ss >> Is, yB[a] = -22014 * (a - 128) + Ss, bB[a] = -45773 * (a - 128), UB[a] = 113618 * (a - 128) + Ss >> Is;
        for (a = ya; a < Uc; ++a) l = 76283 * (a - 16) + Ss >> Is, EB[a - ya] = Ir(l, 255), LB[a - ya] = Ir(l + 8 >> 4, 15);
        Tu = 1;
      }
      return 1;
    }
    function XA(a) {
      var l = a.ma, B = a.U, g = a.T;
      return A(!(1 & a.ka)), 0 >= B || 0 >= g ? 0 : (B = l.Ib(a, l), l.Jb != null && l.Jb(a, l, B), l.Dc += B, 1);
    }
    function Vr(a) {
      a.ma.memory = null;
    }
    function jr(a, l, B, g) {
      return pA(a, 8) != 47 ? 0 : (l[0] = pA(a, 14) + 1, B[0] = pA(a, 14) + 1, g[0] = pA(a, 1), pA(a, 3) != 0 ? 0 : !a.h);
    }
    function $t(a, l) {
      if (4 > a) return a + 1;
      var B = a - 2 >> 1;
      return (2 + (1 & a) << B) + pA(l, B) + 1;
    }
    function Ar(a, l) {
      return 120 < l ? l - 120 : 1 <= (B = ((B = cB[l - 1]) >> 4) * a + (8 - (15 & B))) ? B : 1;
      var B;
    }
    function Ge(a, l, B) {
      var g = M(B), C = a[l += 255 & g].g - 8;
      return 0 < C && (X(B, B.u + 8), g = M(B), l += a[l].value, l += g & (1 << C) - 1), X(B, B.u + a[l].g), a[l].value;
    }
    function Bt(a, l, B) {
      return B.g += a.g, B.value += a.value << l >>> 0, A(8 >= B.g), a.g;
    }
    function pt(a, l, B) {
      var g = a.xc;
      return A((l = g == 0 ? 0 : a.vc[a.md * (B >> g) + (l >> g)]) < a.Wb), a.Ya[l];
    }
    function jn(a, l, B, g) {
      var C = a.ab, m = a.c * l, U = a.C;
      l = U + l;
      var L = B, x = g;
      for (g = a.Ta, B = a.Ua; 0 < C--; ) {
        var _ = a.gc[C], W = U, nA = l, D = L, J = x, AA = (x = g, L = B, _.Ea);
        switch (A(W < nA), A(nA <= _.nc), _.hc) {
          case 2:
            Xe(D, J, (nA - W) * AA, x, L);
            break;
          case 0:
            var fA = W, rA = nA, hA = x, dA = L, mA = (_A = _).Ea;
            fA == 0 && (wa(D, J, null, null, 1, hA, dA), Be(D, J + 1, 0, 0, mA - 1, hA, dA + 1), J += mA, dA += mA, ++fA);
            for (var vA = 1 << _A.b, kA = vA - 1, IA = CA(mA, _A.b), ie = _A.K, _A = _A.w + (fA >> _A.b) * IA; fA < rA; ) {
              var de = ie, lt = _A, ae = 1;
              for (Ii(D, J, hA, dA - mA, 1, hA, dA); ae < mA; ) {
                var DA = (ae & ~kA) + vA;
                DA > mA && (DA = mA), (0, Ca[de[lt++] >> 8 & 15])(D, J + +ae, hA, dA + ae - mA, DA - ae, hA, dA + ae), ae = DA;
              }
              J += mA, dA += mA, ++fA & kA || (_A += IA);
            }
            nA != _.nc && r(x, L - AA, x, L + (nA - W - 1) * AA, AA);
            break;
          case 1:
            for (AA = D, rA = J, mA = (D = _.Ea) - (dA = D & ~(hA = (J = 1 << _.b) - 1)), fA = CA(D, _.b), vA = _.K, _ = _.w + (W >> _.b) * fA; W < nA; ) {
              for (kA = vA, IA = _, ie = new VA(), _A = rA + dA, de = rA + D; rA < _A; ) TA(kA[IA++], ie), ma(ie, AA, rA, J, x, L), rA += J, L += J;
              rA < de && (TA(kA[IA++], ie), ma(ie, AA, rA, mA, x, L), rA += mA, L += mA), ++W & hA || (_ += fA);
            }
            break;
          case 3:
            if (D == x && J == L && 0 < _.b) {
              for (rA = x, D = AA = L + (nA - W) * AA - (dA = (nA - W) * CA(_.Ea, _.b)), J = x, hA = L, fA = [], dA = (mA = dA) - 1; 0 <= dA; --dA) fA[dA] = J[hA + dA];
              for (dA = mA - 1; 0 <= dA; --dA) rA[D + dA] = fA[dA];
              Qs(_, W, nA, x, AA, x, L);
            } else Qs(_, W, nA, D, J, x, L);
        }
        L = g, x = B;
      }
      x != B && r(g, B, L, x, m);
    }
    function dn(a, l) {
      var B = a.V, g = a.Ba + a.c * a.C, C = l - a.C;
      if (A(l <= a.l.o), A(16 >= C), 0 < C) {
        var m = a.l, U = a.Ta, L = a.Ua, x = m.width;
        if (jn(a, C, B, g), C = L = [L], A((B = a.C) < (g = l)), A(m.v < m.va), g > m.o && (g = m.o), B < m.j) {
          var _ = m.j - B;
          B = m.j, C[0] += _ * x;
        }
        if (B >= g ? B = 0 : (C[0] += 4 * m.v, m.ka = B - m.j, m.U = m.va - m.v, m.T = g - B, B = 1), B) {
          if (L = L[0], 11 > (B = a.ca).S) {
            var W = B.f.RGBA, nA = (g = B.S, C = m.U, m = m.T, _ = W.eb, W.A), D = m;
            for (W = W.fb + a.Ma * W.A; 0 < D--; ) {
              var J = U, AA = L, fA = C, rA = _, hA = W;
              switch (g) {
                case bs:
                  Qa(J, AA, fA, rA, hA);
                  break;
                case ys:
                  mn(J, AA, fA, rA, hA);
                  break;
                case vc:
                  mn(J, AA, fA, rA, hA), Ua(rA, hA, 0, fA, 1, 0);
                  break;
                case Eu:
                  ii(J, AA, fA, rA, hA);
                  break;
                case Es:
                  GA(J, AA, fA, rA, hA, 1);
                  break;
                case Cc:
                  GA(J, AA, fA, rA, hA, 1), Ua(rA, hA, 0, fA, 1, 0);
                  break;
                case Ls:
                  GA(J, AA, fA, rA, hA, 0);
                  break;
                case xs:
                  GA(J, AA, fA, rA, hA, 0), Ua(rA, hA, 1, fA, 1, 0);
                  break;
                case wc:
                  Qn(J, AA, fA, rA, hA);
                  break;
                case mc:
                  Qn(J, AA, fA, rA, hA), vu(rA, hA, fA, 1, 0);
                  break;
                case Lu:
                  Fn(J, AA, fA, rA, hA);
                  break;
                default:
                  A(0);
              }
              L += x, W += nA;
            }
            a.Ma += m;
          } else alert("todo:EmitRescaledRowsYUVA");
          A(a.Ma <= B.height);
        }
      }
      a.C = l, A(a.C <= a.i);
    }
    function hr(a) {
      var l;
      if (0 < a.ua) return 0;
      for (l = 0; l < a.Wb; ++l) {
        var B = a.Ya[l].G, g = a.Ya[l].H;
        if (0 < B[1][g[1] + 0].g || 0 < B[2][g[2] + 0].g || 0 < B[3][g[3] + 0].g) return 0;
      }
      return 1;
    }
    function Lr(a, l, B, g, C, m) {
      if (a.Z != 0) {
        var U = a.qd, L = a.rd;
        for (A(yn[a.Z] != null); l < B; ++l) yn[a.Z](U, L, g, C, g, C, m), U = g, L = C, C += m;
        a.qd = U, a.rd = L;
      }
    }
    function Br(a, l) {
      var B = a.l.ma, g = B.Z == 0 || B.Z == 1 ? a.l.j : a.C;
      if (g = a.C < g ? g : a.C, A(l <= a.l.o), l > g) {
        var C = a.l.width, m = B.ca, U = B.tb + C * g, L = a.V, x = a.Ba + a.c * g, _ = a.gc;
        A(a.ab == 1), A(_[0].hc == 3), _r(_[0], g, l, L, x, m, U), Lr(B, g, l, m, U, C);
      }
      a.C = a.Ma = l;
    }
    function dr(a, l, B, g, C, m, U) {
      var L = a.$ / g, x = a.$ % g, _ = a.m, W = a.s, nA = B + a.$, D = nA;
      C = B + g * C;
      var J = B + g * m, AA = 280 + W.ua, fA = a.Pb ? L : 16777216, rA = 0 < W.ua ? W.Wa : null, hA = W.wc, dA = nA < J ? pt(W, x, L) : null;
      A(a.C < m), A(J <= C);
      var mA = !1;
      A: for (; ; ) {
        for (; mA || nA < J; ) {
          var vA = 0;
          if (L >= fA) {
            var kA = nA - B;
            A((fA = a).Pb), fA.wd = fA.m, fA.xd = kA, 0 < fA.s.ua && bA(fA.s.Wa, fA.s.vb), fA = L + uB;
          }
          if (x & hA || (dA = pt(W, x, L)), A(dA != null), dA.Qb && (l[nA] = dA.qb, mA = !0), !mA) if (eA(_), dA.jc) {
            vA = _, kA = l;
            var IA = nA, ie = dA.pd[M(vA) & ni - 1];
            A(dA.jc), 256 > ie.g ? (X(vA, vA.u + ie.g), kA[IA] = ie.value, vA = 0) : (X(vA, vA.u + ie.g - 256), A(256 <= ie.value), vA = ie.value), vA == 0 && (mA = !0);
          } else vA = Ge(dA.G[0], dA.H[0], _);
          if (_.h) break;
          if (mA || 256 > vA) {
            if (!mA) if (dA.nd) l[nA] = (dA.qb | vA << 8) >>> 0;
            else {
              if (eA(_), mA = Ge(dA.G[1], dA.H[1], _), eA(_), kA = Ge(dA.G[2], dA.H[2], _), IA = Ge(dA.G[3], dA.H[3], _), _.h) break;
              l[nA] = (IA << 24 | mA << 16 | vA << 8 | kA) >>> 0;
            }
            if (mA = !1, ++nA, ++x >= g && (x = 0, ++L, U != null && L <= m && !(L % 16) && U(a, L), rA != null)) for (; D < nA; ) vA = l[D++], rA.X[(506832829 * vA & 4294967295) >>> rA.Mb] = vA;
          } else if (280 > vA) {
            if (vA = $t(vA - 256, _), kA = Ge(dA.G[4], dA.H[4], _), eA(_), kA = Ar(g, kA = $t(kA, _)), _.h) break;
            if (nA - B < kA || C - nA < vA) break A;
            for (IA = 0; IA < vA; ++IA) l[nA + IA] = l[nA + IA - kA];
            for (nA += vA, x += vA; x >= g; ) x -= g, ++L, U != null && L <= m && !(L % 16) && U(a, L);
            if (A(nA <= C), x & hA && (dA = pt(W, x, L)), rA != null) for (; D < nA; ) vA = l[D++], rA.X[(506832829 * vA & 4294967295) >>> rA.Mb] = vA;
          } else {
            if (!(vA < AA)) break A;
            for (mA = vA - 280, A(rA != null); D < nA; ) vA = l[D++], rA.X[(506832829 * vA & 4294967295) >>> rA.Mb] = vA;
            vA = nA, A(!(mA >>> (kA = rA).Xa)), l[vA] = kA.X[mA], mA = !0;
          }
          mA || A(_.h == q(_));
        }
        if (a.Pb && _.h && nA < C) A(a.m.h), a.a = 5, a.m = a.wd, a.$ = a.xd, 0 < a.s.ua && bA(a.s.vb, a.s.Wa);
        else {
          if (_.h) break A;
          U != null && U(a, L > m ? m : L), a.a = 0, a.$ = nA - B;
        }
        return 1;
      }
      return a.a = 3, 0;
    }
    function er(a) {
      A(a != null), a.vc = null, a.yc = null, a.Ya = null;
      var l = a.Wa;
      l != null && (l.X = null), a.vb = null, A(a != null);
    }
    function qn() {
      var a = new zA();
      return a == null ? null : (a.a = 0, a.xb = Su, He("Predictor", "VP8LPredictors"), He("Predictor", "VP8LPredictors_C"), He("PredictorAdd", "VP8LPredictorsAdd"), He("PredictorAdd", "VP8LPredictorsAdd_C"), Xe = fe, ma = re, Qa = We, mn = pe, Qn = oe, Fn = ce, ii = ke, N.VP8LMapColor32b = Nr, N.VP8LMapColor8b = va, a);
    }
    function xr(a, l, B, g, C) {
      var m = 1, U = [a], L = [l], x = g.m, _ = g.s, W = null, nA = 0;
      A: for (; ; ) {
        if (B) for (; m && pA(x, 1); ) {
          var D = U, J = L, AA = g, fA = 1, rA = AA.m, hA = AA.gc[AA.ab], dA = pA(rA, 2);
          if (AA.Oc & 1 << dA) m = 0;
          else {
            switch (AA.Oc |= 1 << dA, hA.hc = dA, hA.Ea = D[0], hA.nc = J[0], hA.K = [null], ++AA.ab, A(4 >= AA.ab), dA) {
              case 0:
              case 1:
                hA.b = pA(rA, 3) + 2, fA = xr(CA(hA.Ea, hA.b), CA(hA.nc, hA.b), 0, AA, hA.K), hA.K = hA.K[0];
                break;
              case 3:
                var mA, vA = pA(rA, 8) + 1, kA = 16 < vA ? 0 : 4 < vA ? 1 : 2 < vA ? 2 : 3;
                if (D[0] = CA(hA.Ea, kA), hA.b = kA, mA = fA = xr(vA, 1, 0, AA, hA.K)) {
                  var IA, ie = vA, _A = hA, de = 1 << (8 >> _A.b), lt = i(de);
                  if (lt == null) mA = 0;
                  else {
                    var ae = _A.K[0], DA = _A.w;
                    for (lt[0] = _A.K[0][0], IA = 1; IA < 1 * ie; ++IA) lt[IA] = qA(ae[DA + IA], lt[IA - 1]);
                    for (; IA < 4 * de; ++IA) lt[IA] = 0;
                    _A.K[0] = null, _A.K[0] = lt, mA = 1;
                  }
                }
                fA = mA;
                break;
              case 2:
                break;
              default:
                A(0);
            }
            m = fA;
          }
        }
        if (U = U[0], L = L[0], m && pA(x, 1) && !(m = 1 <= (nA = pA(x, 4)) && 11 >= nA)) {
          g.a = 3;
          break A;
        }
        var UA;
        if (UA = m) e: {
          var Ye, te, ge, Te = g, Ct = U, _t = L, Ve = nA, yt = B, Dt = Te.m, ut = Te.s, ve = [null], Ue = 1, je = 0, be = lB[Ve];
          t: for (; ; ) {
            if (yt && pA(Dt, 1)) {
              var mt = pA(Dt, 3) + 2, vr = CA(Ct, mt), ze = CA(_t, mt), kt = vr * ze;
              if (!xr(vr, ze, 0, Te, ve)) break t;
              for (ve = ve[0], ut.xc = mt, Ye = 0; Ye < kt; ++Ye) {
                var Ie = ve[Ye] >> 8 & 65535;
                ve[Ye] = Ie, Ie >= Ue && (Ue = Ie + 1);
              }
            }
            if (Dt.h) break t;
            for (te = 0; 5 > te; ++te) {
              var ft = xu[te];
              !te && 0 < Ve && (ft += 1 << Ve), je < ft && (je = ft);
            }
            var jt = o(Ue * be, K), Tt = Ue, qt = o(Tt, aA);
            if (qt == null) var Wt = null;
            else A(65536 >= Tt), Wt = qt;
            var Pt = i(je);
            if (Wt == null || Pt == null || jt == null) {
              Te.a = 1;
              break t;
            }
            var Xt = jt;
            for (Ye = ge = 0; Ye < Ue; ++Ye) {
              var _e = Wt[Ye], Jt = _e.G, Cr = _e.H, si = 0, an = 1, Qt = 0;
              for (te = 0; 5 > te; ++te) {
                ft = xu[te], Jt[te] = Xt, Cr[te] = ge, !te && 0 < Ve && (ft += 1 << Ve);
                n: {
                  var Ns, bc = ft, _s = Te, Ea = Pt, SB = Xt, HB = ge, yc = 0, En = _s.m, NB = pA(En, 1);
                  if (n(Ea, 0, 0, bc), NB) {
                    var _B = pA(En, 1) + 1, DB = pA(En, 1), Pu = pA(En, DB == 0 ? 1 : 8);
                    Ea[Pu] = 1, _B == 2 && (Ea[Pu = pA(En, 8)] = 1);
                    var Ds = 1;
                  } else {
                    var Mu = i(19), Ku = pA(En, 4) + 4;
                    if (19 < Ku) {
                      _s.a = 3;
                      var Ts = 0;
                      break n;
                    }
                    for (Ns = 0; Ns < Ku; ++Ns) Mu[oB[Ns]] = pA(En, 3);
                    var Ec = void 0, La = void 0, Ru = _s, TB = Mu, Os = bc, Gu = Ea, Lc = 0, Ln = Ru.m, Vu = 8, ju = o(128, K);
                    r: for (; I(ju, 0, 7, TB, 19); ) {
                      if (pA(Ln, 1)) {
                        var OB = 2 + 2 * pA(Ln, 3);
                        if ((Ec = 2 + pA(Ln, OB)) > Os) break r;
                      } else Ec = Os;
                      for (La = 0; La < Os && Ec--; ) {
                        eA(Ln);
                        var qu = ju[0 + (127 & M(Ln))];
                        X(Ln, Ln.u + qu.g);
                        var Hi = qu.value;
                        if (16 > Hi) Gu[La++] = Hi, Hi != 0 && (Vu = Hi);
                        else {
                          var kB = Hi == 16, Wu = Hi - 16, PB = aB[Wu], Xu = pA(Ln, iB[Wu]) + PB;
                          if (La + Xu > Os) break r;
                          for (var MB = kB ? Vu : 0; 0 < Xu--; ) Gu[La++] = MB;
                        }
                      }
                      Lc = 1;
                      break r;
                    }
                    Lc || (Ru.a = 3), Ds = Lc;
                  }
                  (Ds = Ds && !En.h) && (yc = I(SB, HB, 8, Ea, bc)), Ds && yc != 0 ? Ts = yc : (_s.a = 3, Ts = 0);
                }
                if (Ts == 0) break t;
                if (an && sB[te] == 1 && (an = Xt[ge].g == 0), si += Xt[ge].g, ge += Ts, 3 >= te) {
                  var xa, xc = Pt[0];
                  for (xa = 1; xa < ft; ++xa) Pt[xa] > xc && (xc = Pt[xa]);
                  Qt += xc;
                }
              }
              if (_e.nd = an, _e.Qb = 0, an && (_e.qb = (Jt[3][Cr[3] + 0].value << 24 | Jt[1][Cr[1] + 0].value << 16 | Jt[2][Cr[2] + 0].value) >>> 0, si == 0 && 256 > Jt[0][Cr[0] + 0].value && (_e.Qb = 1, _e.qb += Jt[0][Cr[0] + 0].value << 8)), _e.jc = !_e.Qb && 6 > Qt, _e.jc) {
                var ks, sn = _e;
                for (ks = 0; ks < ni; ++ks) {
                  var xn = ks, In = sn.pd[xn], Ps = sn.G[0][sn.H[0] + xn];
                  256 <= Ps.value ? (In.g = Ps.g + 256, In.value = Ps.value) : (In.g = 0, In.value = 0, xn >>= Bt(Ps, 8, In), xn >>= Bt(sn.G[1][sn.H[1] + xn], 16, In), xn >>= Bt(sn.G[2][sn.H[2] + xn], 0, In), Bt(sn.G[3][sn.H[3] + xn], 24, In));
                }
              }
            }
            ut.vc = ve, ut.Wb = Ue, ut.Ya = Wt, ut.yc = jt, UA = 1;
            break e;
          }
          UA = 0;
        }
        if (!(m = UA)) {
          g.a = 3;
          break A;
        }
        if (0 < nA) {
          if (_.ua = 1 << nA, !H(_.Wa, nA)) {
            g.a = 1, m = 0;
            break A;
          }
        } else _.ua = 0;
        var Ic = g, Ju = U, KB = L, Sc = Ic.s, Hc = Sc.xc;
        if (Ic.c = Ju, Ic.i = KB, Sc.md = CA(Ju, Hc), Sc.wc = Hc == 0 ? -1 : (1 << Hc) - 1, B) {
          g.xb = wB;
          break A;
        }
        if ((W = i(U * L)) == null) {
          g.a = 1, m = 0;
          break A;
        }
        m = (m = dr(g, W, 0, U, L, L, null)) && !x.h;
        break A;
      }
      return m ? (C != null ? C[0] = W : (A(W == null), A(B)), g.$ = 0, B || er(_)) : er(_), m;
    }
    function Wn(a, l) {
      var B = a.c * a.i, g = B + l + 16 * l;
      return A(a.c <= l), a.V = i(g), a.V == null ? (a.Ta = null, a.Ua = 0, a.a = 1, 0) : (a.Ta = a.V, a.Ua = a.Ba + B + l, 1);
    }
    function Ci(a, l) {
      var B = a.C, g = l - B, C = a.V, m = a.Ba + a.c * B;
      for (A(l <= a.l.o); 0 < g; ) {
        var U = 16 < g ? 16 : g, L = a.l.ma, x = a.l.width, _ = x * U, W = L.ca, nA = L.tb + x * B, D = a.Ta, J = a.Ua;
        jn(a, U, C, m), mu(D, J, W, nA, _), Lr(L, B, B + U, W, nA, x), g -= U, C += U * a.c, B += U;
      }
      A(B == l), a.C = a.Ma = l;
    }
    function mi() {
      this.ub = this.yd = this.td = this.Rb = 0;
    }
    function Qi() {
      this.Kd = this.Ld = this.Ud = this.Td = this.i = this.c = 0;
    }
    function ec() {
      this.Fb = this.Bb = this.Cb = 0, this.Zb = i(4), this.Lb = i(4);
    }
    function ta() {
      this.Yb = (function() {
        var a = [];
        return (function l(B, g, C) {
          for (var m = C[g], U = 0; U < m && (B.push(C.length > g + 1 ? [] : 0), !(C.length < g + 1)); U++) l(B[U], g + 1, C);
        })(a, 0, [3, 11]), a;
      })();
    }
    function ns() {
      this.jb = i(3), this.Wc = s([4, 8], ta), this.Xc = s([4, 17], ta);
    }
    function is() {
      this.Pc = this.wb = this.Tb = this.zd = 0, this.vd = new i(4), this.od = new i(4);
    }
    function tr() {
      this.ld = this.La = this.dd = this.tc = 0;
    }
    function ra() {
      this.Na = this.la = 0;
    }
    function as() {
      this.Sc = [0, 0], this.Eb = [0, 0], this.Qc = [0, 0], this.ia = this.lc = 0;
    }
    function na() {
      this.ad = i(384), this.Za = 0, this.Ob = i(16), this.$b = this.Ad = this.ia = this.Gc = this.Hc = this.Dd = 0;
    }
    function ss() {
      this.uc = this.M = this.Nb = 0, this.wa = Array(new tr()), this.Y = 0, this.ya = Array(new na()), this.aa = 0, this.l = new Fi();
    }
    function os() {
      this.y = i(16), this.f = i(8), this.ea = i(8);
    }
    function cs() {
      this.cb = this.a = 0, this.sc = "", this.m = new F(), this.Od = new mi(), this.Kc = new Qi(), this.ed = new is(), this.Qa = new ec(), this.Ic = this.$c = this.Aa = 0, this.D = new ss(), this.Xb = this.Va = this.Hb = this.zb = this.yb = this.Ub = this.za = 0, this.Jc = o(8, F), this.ia = 0, this.pb = o(4, as), this.Pa = new ns(), this.Bd = this.kc = 0, this.Ac = [], this.Bc = 0, this.zc = [0, 0, 0, 0], this.Gd = Array(new os()), this.Hd = 0, this.rb = Array(new ra()), this.sb = 0, this.wa = Array(new tr()), this.Y = 0, this.oc = [], this.pc = 0, this.sa = [], this.ta = 0, this.qa = [], this.ra = 0, this.Ha = [], this.B = this.R = this.Ia = 0, this.Ec = [], this.M = this.ja = this.Vb = this.Fc = 0, this.ya = Array(new na()), this.L = this.aa = 0, this.gd = s([4, 2], tr), this.ga = null, this.Fa = [], this.Cc = this.qc = this.P = 0, this.Gb = [], this.Uc = 0, this.mb = [], this.nb = 0, this.rc = [], this.Ga = this.Vc = 0;
    }
    function Ir(a, l) {
      return 0 > a ? 0 : a > l ? l : a;
    }
    function Fi() {
      this.T = this.U = this.ka = this.height = this.width = 0, this.y = [], this.f = [], this.ea = [], this.Rc = this.fa = this.W = this.N = this.O = 0, this.ma = "void", this.put = "VP8IoPutHook", this.ac = "VP8IoSetupHook", this.bc = "VP8IoTeardownHook", this.ha = this.Kb = 0, this.data = [], this.hb = this.ib = this.da = this.o = this.j = this.va = this.v = this.Da = this.ob = this.w = 0, this.F = [], this.J = 0;
    }
    function tc() {
      var a = new cs();
      return a != null && (a.a = 0, a.sc = "OK", a.cb = 0, a.Xb = 0, ba || (ba = Ui)), a;
    }
    function rt(a, l, B) {
      return a.a == 0 && (a.a = l, a.sc = B, a.cb = 0), 0;
    }
    function ls(a, l, B) {
      return 3 <= B && a[l + 0] == 157 && a[l + 1] == 1 && a[l + 2] == 42;
    }
    function Sr(a, l) {
      if (a == null) return 0;
      if (a.a = 0, a.sc = "OK", l == null) return rt(a, 2, "null VP8Io passed to VP8GetHeaders()");
      var B = l.data, g = l.w, C = l.ha;
      if (4 > C) return rt(a, 7, "Truncated header.");
      var m = B[g + 0] | B[g + 1] << 8 | B[g + 2] << 16, U = a.Od;
      if (U.Rb = !(1 & m), U.td = m >> 1 & 7, U.yd = m >> 4 & 1, U.ub = m >> 5, 3 < U.td) return rt(a, 3, "Incorrect keyframe parameters.");
      if (!U.yd) return rt(a, 4, "Frame not displayable.");
      g += 3, C -= 3;
      var L = a.Kc;
      if (U.Rb) {
        if (7 > C) return rt(a, 7, "cannot parse picture header");
        if (!ls(B, g, C)) return rt(a, 3, "Bad code word");
        L.c = 16383 & (B[g + 4] << 8 | B[g + 3]), L.Td = B[g + 4] >> 6, L.i = 16383 & (B[g + 6] << 8 | B[g + 5]), L.Ud = B[g + 6] >> 6, g += 7, C -= 7, a.za = L.c + 15 >> 4, a.Ub = L.i + 15 >> 4, l.width = L.c, l.height = L.i, l.Da = 0, l.j = 0, l.v = 0, l.va = l.width, l.o = l.height, l.da = 0, l.ib = l.width, l.hb = l.height, l.U = l.width, l.T = l.height, n((m = a.Pa).jb, 0, 255, m.jb.length), A((m = a.Qa) != null), m.Cb = 0, m.Bb = 0, m.Fb = 1, n(m.Zb, 0, 0, m.Zb.length), n(m.Lb, 0, 0, m.Lb);
      }
      if (U.ub > C) return rt(a, 7, "bad partition length");
      sA(m = a.m, B, g, U.ub), g += U.ub, C -= U.ub, U.Rb && (L.Ld = uA(m), L.Kd = uA(m)), L = a.Qa;
      var x, _ = a.Pa;
      if (A(m != null), A(L != null), L.Cb = uA(m), L.Cb) {
        if (L.Bb = uA(m), uA(m)) {
          for (L.Fb = uA(m), x = 0; 4 > x; ++x) L.Zb[x] = uA(m) ? tA(m, 7) : 0;
          for (x = 0; 4 > x; ++x) L.Lb[x] = uA(m) ? tA(m, 6) : 0;
        }
        if (L.Bb) for (x = 0; 3 > x; ++x) _.jb[x] = uA(m) ? oA(m, 8) : 255;
      } else L.Bb = 0;
      if (m.Ka) return rt(a, 3, "cannot parse segment header");
      if ((L = a.ed).zd = uA(m), L.Tb = oA(m, 6), L.wb = oA(m, 3), L.Pc = uA(m), L.Pc && uA(m)) {
        for (_ = 0; 4 > _; ++_) uA(m) && (L.vd[_] = tA(m, 6));
        for (_ = 0; 4 > _; ++_) uA(m) && (L.od[_] = tA(m, 6));
      }
      if (a.L = L.Tb == 0 ? 0 : L.zd ? 1 : 2, m.Ka) return rt(a, 3, "cannot parse filter header");
      var W = C;
      if (C = x = g, g = x + W, L = W, a.Xb = (1 << oA(a.m, 2)) - 1, W < 3 * (_ = a.Xb)) B = 7;
      else {
        for (x += 3 * _, L -= 3 * _, W = 0; W < _; ++W) {
          var nA = B[C + 0] | B[C + 1] << 8 | B[C + 2] << 16;
          nA > L && (nA = L), sA(a.Jc[+W], B, x, nA), x += nA, L -= nA, C += 3;
        }
        sA(a.Jc[+_], B, x, L), B = x < g ? 0 : 5;
      }
      if (B != 0) return rt(a, B, "cannot parse partitions");
      for (B = oA(x = a.m, 7), C = uA(x) ? tA(x, 4) : 0, g = uA(x) ? tA(x, 4) : 0, L = uA(x) ? tA(x, 4) : 0, _ = uA(x) ? tA(x, 4) : 0, x = uA(x) ? tA(x, 4) : 0, W = a.Qa, nA = 0; 4 > nA; ++nA) {
        if (W.Cb) {
          var D = W.Zb[nA];
          W.Fb || (D += B);
        } else {
          if (0 < nA) {
            a.pb[nA] = a.pb[0];
            continue;
          }
          D = B;
        }
        var J = a.pb[nA];
        J.Sc[0] = Qc[Ir(D + C, 127)], J.Sc[1] = Fc[Ir(D + 0, 127)], J.Eb[0] = 2 * Qc[Ir(D + g, 127)], J.Eb[1] = 101581 * Fc[Ir(D + L, 127)] >> 16, 8 > J.Eb[1] && (J.Eb[1] = 8), J.Qc[0] = Qc[Ir(D + _, 117)], J.Qc[1] = Fc[Ir(D + x, 127)], J.lc = D + x;
      }
      if (!U.Rb) return rt(a, 4, "Not a key frame.");
      for (uA(m), U = a.Pa, B = 0; 4 > B; ++B) {
        for (C = 0; 8 > C; ++C) for (g = 0; 3 > g; ++g) for (L = 0; 11 > L; ++L) _ = gA(m, gB[B][C][g][L]) ? oA(m, 8) : BB[B][C][g][L], U.Wc[B][C].Yb[g][L] = _;
        for (C = 0; 17 > C; ++C) U.Xc[B][C] = U.Wc[B][pB[C]];
      }
      return a.kc = uA(m), a.kc && (a.Bd = oA(m, 8)), a.cb = 1;
    }
    function Ui(a, l, B, g, C, m, U) {
      var L = l[C].Yb[B];
      for (B = 0; 16 > C; ++C) {
        if (!gA(a, L[B + 0])) return C;
        for (; !gA(a, L[B + 1]); ) if (L = l[++C].Yb[0], B = 0, C == 16) return 16;
        var x = l[C + 1].Yb;
        if (gA(a, L[B + 2])) {
          var _ = a, W = 0;
          if (gA(_, (D = L)[(nA = B) + 3])) if (gA(_, D[nA + 6])) {
            for (L = 0, nA = 2 * (W = gA(_, D[nA + 8])) + (D = gA(_, D[nA + 9 + W])), W = 0, D = fB[nA]; D[L]; ++L) W += W + gA(_, D[L]);
            W += 3 + (8 << nA);
          } else gA(_, D[nA + 7]) ? (W = 7 + 2 * gA(_, 165), W += gA(_, 145)) : W = 5 + gA(_, 159);
          else W = gA(_, D[nA + 4]) ? 3 + gA(_, D[nA + 5]) : 2;
          L = x[2];
        } else W = 1, L = x[1];
        x = U + hB[C], 0 > (_ = a).b && lA(_);
        var nA, D = _.b, J = (nA = _.Ca >> 1) - (_.I >> D) >> 31;
        --_.b, _.Ca += J, _.Ca |= 1, _.I -= (nA + 1 & J) << D, m[x] = ((W ^ J) - J) * g[(0 < C) + 0];
      }
      return 16;
    }
    function us(a) {
      var l = a.rb[a.sb - 1];
      l.la = 0, l.Na = 0, n(a.zc, 0, 0, a.zc.length), a.ja = 0;
    }
    function rr(a, l, B, g, C) {
      C = a[l + B + 32 * g] + (C >> 3), a[l + B + 32 * g] = -256 & C ? 0 > C ? 0 : 255 : C;
    }
    function st(a, l, B, g, C, m) {
      rr(a, l, 0, B, g + C), rr(a, l, 1, B, g + m), rr(a, l, 2, B, g - m), rr(a, l, 3, B, g - C);
    }
    function qr(a) {
      return (20091 * a >> 16) + a;
    }
    function fs(a, l, B, g) {
      var C, m = 0, U = i(16);
      for (C = 0; 4 > C; ++C) {
        var L = a[l + 0] + a[l + 8], x = a[l + 0] - a[l + 8], _ = (35468 * a[l + 4] >> 16) - qr(a[l + 12]), W = qr(a[l + 4]) + (35468 * a[l + 12] >> 16);
        U[m + 0] = L + W, U[m + 1] = x + _, U[m + 2] = x - _, U[m + 3] = L - W, m += 4, l++;
      }
      for (C = m = 0; 4 > C; ++C) L = (a = U[m + 0] + 4) + U[m + 8], x = a - U[m + 8], _ = (35468 * U[m + 4] >> 16) - qr(U[m + 12]), rr(B, g, 0, 0, L + (W = qr(U[m + 4]) + (35468 * U[m + 12] >> 16))), rr(B, g, 1, 0, x + _), rr(B, g, 2, 0, x - _), rr(B, g, 3, 0, L - W), m++, g += 32;
    }
    function rc(a, l, B, g) {
      var C = a[l + 0] + 4, m = 35468 * a[l + 4] >> 16, U = qr(a[l + 4]), L = 35468 * a[l + 1] >> 16;
      st(B, g, 0, C + U, a = qr(a[l + 1]), L), st(B, g, 1, C + m, a, L), st(B, g, 2, C - m, a, L), st(B, g, 3, C - U, a, L);
    }
    function nc(a, l, B, g, C) {
      fs(a, l, B, g), C && fs(a, l + 16, B, g + 4);
    }
    function Hr(a, l, B, g) {
      ai(a, l + 0, B, g, 1), ai(a, l + 32, B, g + 128, 1);
    }
    function hs(a, l, B, g) {
      var C;
      for (a = a[l + 0] + 4, C = 0; 4 > C; ++C) for (l = 0; 4 > l; ++l) rr(B, g, l, C, a);
    }
    function Bs(a, l, B, g) {
      a[l + 0] && Qe(a, l + 0, B, g), a[l + 16] && Qe(a, l + 16, B, g + 4), a[l + 32] && Qe(a, l + 32, B, g + 128), a[l + 48] && Qe(a, l + 48, B, g + 128 + 4);
    }
    function bi(a, l, B, g) {
      var C, m = i(16);
      for (C = 0; 4 > C; ++C) {
        var U = a[l + 0 + C] + a[l + 12 + C], L = a[l + 4 + C] + a[l + 8 + C], x = a[l + 4 + C] - a[l + 8 + C], _ = a[l + 0 + C] - a[l + 12 + C];
        m[0 + C] = U + L, m[8 + C] = U - L, m[4 + C] = _ + x, m[12 + C] = _ - x;
      }
      for (C = 0; 4 > C; ++C) U = (a = m[0 + 4 * C] + 3) + m[3 + 4 * C], L = m[1 + 4 * C] + m[2 + 4 * C], x = m[1 + 4 * C] - m[2 + 4 * C], _ = a - m[3 + 4 * C], B[g + 0] = U + L >> 3, B[g + 16] = _ + x >> 3, B[g + 32] = U - L >> 3, B[g + 48] = _ - x >> 3, g += 64;
    }
    function Xn(a, l, B) {
      var g, C = l - 32, m = Vt, U = 255 - a[C - 1];
      for (g = 0; g < B; ++g) {
        var L, x = m, _ = U + a[l - 1];
        for (L = 0; L < B; ++L) a[l + L] = x[_ + a[C + L]];
        l += 32;
      }
    }
    function ic(a, l) {
      Xn(a, l, 4);
    }
    function ac(a, l) {
      Xn(a, l, 8);
    }
    function sc(a, l) {
      Xn(a, l, 16);
    }
    function ia(a, l) {
      var B;
      for (B = 0; 16 > B; ++B) r(a, l + 32 * B, a, l - 32, 16);
    }
    function ds(a, l) {
      var B;
      for (B = 16; 0 < B; --B) n(a, l, a[l - 1], 16), l += 32;
    }
    function gr(a, l, B) {
      var g;
      for (g = 0; 16 > g; ++g) n(l, B + 32 * g, a, 16);
    }
    function oc(a, l) {
      var B, g = 16;
      for (B = 0; 16 > B; ++B) g += a[l - 1 + 32 * B] + a[l + B - 32];
      gr(g >> 5, a, l);
    }
    function Jn(a, l) {
      var B, g = 8;
      for (B = 0; 16 > B; ++B) g += a[l - 1 + 32 * B];
      gr(g >> 4, a, l);
    }
    function aa(a, l) {
      var B, g = 8;
      for (B = 0; 16 > B; ++B) g += a[l + B - 32];
      gr(g >> 4, a, l);
    }
    function cc(a, l) {
      gr(128, a, l);
    }
    function ZA(a, l, B) {
      return a + 2 * l + B + 2 >> 2;
    }
    function lc(a, l) {
      var B, g = l - 32;
      for (g = new Uint8Array([ZA(a[g - 1], a[g + 0], a[g + 1]), ZA(a[g + 0], a[g + 1], a[g + 2]), ZA(a[g + 1], a[g + 2], a[g + 3]), ZA(a[g + 2], a[g + 3], a[g + 4])]), B = 0; 4 > B; ++B) r(a, l + 32 * B, g, 0, g.length);
    }
    function uc(a, l) {
      var B = a[l - 1], g = a[l - 1 + 32], C = a[l - 1 + 64], m = a[l - 1 + 96];
      FA(a, l + 0, 16843009 * ZA(a[l - 1 - 32], B, g)), FA(a, l + 32, 16843009 * ZA(B, g, C)), FA(a, l + 64, 16843009 * ZA(g, C, m)), FA(a, l + 96, 16843009 * ZA(C, m, m));
    }
    function fc(a, l) {
      var B, g = 4;
      for (B = 0; 4 > B; ++B) g += a[l + B - 32] + a[l - 1 + 32 * B];
      for (g >>= 3, B = 0; 4 > B; ++B) n(a, l + 32 * B, g, 4);
    }
    function Wr(a, l) {
      var B = a[l - 1 + 0], g = a[l - 1 + 32], C = a[l - 1 + 64], m = a[l - 1 - 32], U = a[l + 0 - 32], L = a[l + 1 - 32], x = a[l + 2 - 32], _ = a[l + 3 - 32];
      a[l + 0 + 96] = ZA(g, C, a[l - 1 + 96]), a[l + 1 + 96] = a[l + 0 + 64] = ZA(B, g, C), a[l + 2 + 96] = a[l + 1 + 64] = a[l + 0 + 32] = ZA(m, B, g), a[l + 3 + 96] = a[l + 2 + 64] = a[l + 1 + 32] = a[l + 0 + 0] = ZA(U, m, B), a[l + 3 + 64] = a[l + 2 + 32] = a[l + 1 + 0] = ZA(L, U, m), a[l + 3 + 32] = a[l + 2 + 0] = ZA(x, L, U), a[l + 3 + 0] = ZA(_, x, L);
    }
    function Xr(a, l) {
      var B = a[l + 1 - 32], g = a[l + 2 - 32], C = a[l + 3 - 32], m = a[l + 4 - 32], U = a[l + 5 - 32], L = a[l + 6 - 32], x = a[l + 7 - 32];
      a[l + 0 + 0] = ZA(a[l + 0 - 32], B, g), a[l + 1 + 0] = a[l + 0 + 32] = ZA(B, g, C), a[l + 2 + 0] = a[l + 1 + 32] = a[l + 0 + 64] = ZA(g, C, m), a[l + 3 + 0] = a[l + 2 + 32] = a[l + 1 + 64] = a[l + 0 + 96] = ZA(C, m, U), a[l + 3 + 32] = a[l + 2 + 64] = a[l + 1 + 96] = ZA(m, U, L), a[l + 3 + 64] = a[l + 2 + 96] = ZA(U, L, x), a[l + 3 + 96] = ZA(L, x, x);
    }
    function hc(a, l) {
      var B = a[l - 1 + 0], g = a[l - 1 + 32], C = a[l - 1 + 64], m = a[l - 1 - 32], U = a[l + 0 - 32], L = a[l + 1 - 32], x = a[l + 2 - 32], _ = a[l + 3 - 32];
      a[l + 0 + 0] = a[l + 1 + 64] = m + U + 1 >> 1, a[l + 1 + 0] = a[l + 2 + 64] = U + L + 1 >> 1, a[l + 2 + 0] = a[l + 3 + 64] = L + x + 1 >> 1, a[l + 3 + 0] = x + _ + 1 >> 1, a[l + 0 + 96] = ZA(C, g, B), a[l + 0 + 64] = ZA(g, B, m), a[l + 0 + 32] = a[l + 1 + 96] = ZA(B, m, U), a[l + 1 + 32] = a[l + 2 + 96] = ZA(m, U, L), a[l + 2 + 32] = a[l + 3 + 96] = ZA(U, L, x), a[l + 3 + 32] = ZA(L, x, _);
    }
    function Bc(a, l) {
      var B = a[l + 0 - 32], g = a[l + 1 - 32], C = a[l + 2 - 32], m = a[l + 3 - 32], U = a[l + 4 - 32], L = a[l + 5 - 32], x = a[l + 6 - 32], _ = a[l + 7 - 32];
      a[l + 0 + 0] = B + g + 1 >> 1, a[l + 1 + 0] = a[l + 0 + 64] = g + C + 1 >> 1, a[l + 2 + 0] = a[l + 1 + 64] = C + m + 1 >> 1, a[l + 3 + 0] = a[l + 2 + 64] = m + U + 1 >> 1, a[l + 0 + 32] = ZA(B, g, C), a[l + 1 + 32] = a[l + 0 + 96] = ZA(g, C, m), a[l + 2 + 32] = a[l + 1 + 96] = ZA(C, m, U), a[l + 3 + 32] = a[l + 2 + 96] = ZA(m, U, L), a[l + 3 + 64] = ZA(U, L, x), a[l + 3 + 96] = ZA(L, x, _);
    }
    function yi(a, l) {
      var B = a[l - 1 + 0], g = a[l - 1 + 32], C = a[l - 1 + 64], m = a[l - 1 + 96];
      a[l + 0 + 0] = B + g + 1 >> 1, a[l + 2 + 0] = a[l + 0 + 32] = g + C + 1 >> 1, a[l + 2 + 32] = a[l + 0 + 64] = C + m + 1 >> 1, a[l + 1 + 0] = ZA(B, g, C), a[l + 3 + 0] = a[l + 1 + 32] = ZA(g, C, m), a[l + 3 + 32] = a[l + 1 + 64] = ZA(C, m, m), a[l + 3 + 64] = a[l + 2 + 64] = a[l + 0 + 96] = a[l + 1 + 96] = a[l + 2 + 96] = a[l + 3 + 96] = m;
    }
    function sa(a, l) {
      var B = a[l - 1 + 0], g = a[l - 1 + 32], C = a[l - 1 + 64], m = a[l - 1 + 96], U = a[l - 1 - 32], L = a[l + 0 - 32], x = a[l + 1 - 32], _ = a[l + 2 - 32];
      a[l + 0 + 0] = a[l + 2 + 32] = B + U + 1 >> 1, a[l + 0 + 32] = a[l + 2 + 64] = g + B + 1 >> 1, a[l + 0 + 64] = a[l + 2 + 96] = C + g + 1 >> 1, a[l + 0 + 96] = m + C + 1 >> 1, a[l + 3 + 0] = ZA(L, x, _), a[l + 2 + 0] = ZA(U, L, x), a[l + 1 + 0] = a[l + 3 + 32] = ZA(B, U, L), a[l + 1 + 32] = a[l + 3 + 64] = ZA(g, B, U), a[l + 1 + 64] = a[l + 3 + 96] = ZA(C, g, B), a[l + 1 + 96] = ZA(m, C, g);
    }
    function Yn(a, l) {
      var B;
      for (B = 0; 8 > B; ++B) r(a, l + 32 * B, a, l - 32, 8);
    }
    function dc(a, l) {
      var B;
      for (B = 0; 8 > B; ++B) n(a, l, a[l - 1], 8), l += 32;
    }
    function Jr(a, l, B) {
      var g;
      for (g = 0; 8 > g; ++g) n(l, B + 32 * g, a, 8);
    }
    function gc(a, l) {
      var B, g = 8;
      for (B = 0; 8 > B; ++B) g += a[l + B - 32] + a[l - 1 + 32 * B];
      Jr(g >> 4, a, l);
    }
    function oa(a, l) {
      var B, g = 4;
      for (B = 0; 8 > B; ++B) g += a[l + B - 32];
      Jr(g >> 3, a, l);
    }
    function ca(a, l) {
      var B, g = 4;
      for (B = 0; 8 > B; ++B) g += a[l - 1 + 32 * B];
      Jr(g >> 3, a, l);
    }
    function gs(a, l) {
      Jr(128, a, l);
    }
    function Yr(a, l, B) {
      var g = a[l - B], C = a[l + 0], m = 3 * (C - g) + pc[1020 + a[l - 2 * B] - a[l + B]], U = Us[112 + (m + 4 >> 3)];
      a[l - B] = Vt[255 + g + Us[112 + (m + 3 >> 3)]], a[l + 0] = Vt[255 + C - U];
    }
    function la(a, l, B, g) {
      var C = a[l + 0], m = a[l + B];
      return ar[255 + a[l - 2 * B] - a[l - B]] > g || ar[255 + m - C] > g;
    }
    function Ei(a, l, B, g) {
      return 4 * ar[255 + a[l - B] - a[l + 0]] + ar[255 + a[l - 2 * B] - a[l + B]] <= g;
    }
    function ua(a, l, B, g, C) {
      var m = a[l - 3 * B], U = a[l - 2 * B], L = a[l - B], x = a[l + 0], _ = a[l + B], W = a[l + 2 * B], nA = a[l + 3 * B];
      return 4 * ar[255 + L - x] + ar[255 + U - _] > g ? 0 : ar[255 + a[l - 4 * B] - m] <= C && ar[255 + m - U] <= C && ar[255 + U - L] <= C && ar[255 + nA - W] <= C && ar[255 + W - _] <= C && ar[255 + _ - x] <= C;
    }
    function zn(a, l, B, g) {
      var C = 2 * g + 1;
      for (g = 0; 16 > g; ++g) Ei(a, l + g, B, C) && Yr(a, l + g, B);
    }
    function fa(a, l, B, g) {
      var C = 2 * g + 1;
      for (g = 0; 16 > g; ++g) Ei(a, l + g * B, 1, C) && Yr(a, l + g * B, 1);
    }
    function ps(a, l, B, g) {
      var C;
      for (C = 3; 0 < C; --C) zn(a, l += 4 * B, B, g);
    }
    function ws(a, l, B, g) {
      var C;
      for (C = 3; 0 < C; --C) fa(a, l += 4, B, g);
    }
    function zr(a, l, B, g, C, m, U, L) {
      for (m = 2 * m + 1; 0 < C--; ) {
        if (ua(a, l, B, m, U)) if (la(a, l, B, L)) Yr(a, l, B);
        else {
          var x = a, _ = l, W = B, nA = x[_ - 2 * W], D = x[_ - W], J = x[_ + 0], AA = x[_ + W], fA = x[_ + 2 * W], rA = 27 * (dA = pc[1020 + 3 * (J - D) + pc[1020 + nA - AA]]) + 63 >> 7, hA = 18 * dA + 63 >> 7, dA = 9 * dA + 63 >> 7;
          x[_ - 3 * W] = Vt[255 + x[_ - 3 * W] + dA], x[_ - 2 * W] = Vt[255 + nA + hA], x[_ - W] = Vt[255 + D + rA], x[_ + 0] = Vt[255 + J - rA], x[_ + W] = Vt[255 + AA - hA], x[_ + 2 * W] = Vt[255 + fA - dA];
        }
        l += g;
      }
    }
    function Zr(a, l, B, g, C, m, U, L) {
      for (m = 2 * m + 1; 0 < C--; ) {
        if (ua(a, l, B, m, U)) if (la(a, l, B, L)) Yr(a, l, B);
        else {
          var x = a, _ = l, W = B, nA = x[_ - W], D = x[_ + 0], J = x[_ + W], AA = Us[112 + (4 + (fA = 3 * (D - nA)) >> 3)], fA = Us[112 + (fA + 3 >> 3)], rA = AA + 1 >> 1;
          x[_ - 2 * W] = Vt[255 + x[_ - 2 * W] + rA], x[_ - W] = Vt[255 + nA + fA], x[_ + 0] = Vt[255 + D - AA], x[_ + W] = Vt[255 + J - rA];
        }
        l += g;
      }
    }
    function vs(a, l, B, g, C, m) {
      zr(a, l, B, 1, 16, g, C, m);
    }
    function Zn(a, l, B, g, C, m) {
      zr(a, l, 1, B, 16, g, C, m);
    }
    function Cs(a, l, B, g, C, m) {
      var U;
      for (U = 3; 0 < U; --U) Zr(a, l += 4 * B, B, 1, 16, g, C, m);
    }
    function f(a, l, B, g, C, m) {
      var U;
      for (U = 3; 0 < U; --U) Zr(a, l += 4, 1, B, 16, g, C, m);
    }
    function v(a, l, B, g, C, m, U, L) {
      zr(a, l, C, 1, 8, m, U, L), zr(B, g, C, 1, 8, m, U, L);
    }
    function T(a, l, B, g, C, m, U, L) {
      zr(a, l, 1, C, 8, m, U, L), zr(B, g, 1, C, 8, m, U, L);
    }
    function V(a, l, B, g, C, m, U, L) {
      Zr(a, l + 4 * C, C, 1, 8, m, U, L), Zr(B, g + 4 * C, C, 1, 8, m, U, L);
    }
    function $(a, l, B, g, C, m, U, L) {
      Zr(a, l + 4, 1, C, 8, m, U, L), Zr(B, g + 4, 1, C, 8, m, U, L);
    }
    function BA() {
      this.ba = new le(), this.ec = [], this.cc = [], this.Mc = [], this.Dc = this.Nc = this.dc = this.fc = 0, this.Oa = new me(), this.memory = 0, this.Ib = "OutputFunc", this.Jb = "OutputAlphaFunc", this.Nd = "OutputRowFunc";
    }
    function wA() {
      this.data = [], this.offset = this.kd = this.ha = this.w = 0, this.na = [], this.xa = this.gb = this.Ja = this.Sa = this.P = 0;
    }
    function NA() {
      this.nc = this.Ea = this.b = this.hc = 0, this.K = [], this.w = 0;
    }
    function OA() {
      this.ua = 0, this.Wa = new se(), this.vb = new se(), this.md = this.xc = this.wc = 0, this.vc = [], this.Wb = 0, this.Ya = new aA(), this.yc = new K();
    }
    function zA() {
      this.xb = this.a = 0, this.l = new Fi(), this.ca = new le(), this.V = [], this.Ba = 0, this.Ta = [], this.Ua = 0, this.m = new O(), this.Pb = 0, this.wd = new O(), this.Ma = this.$ = this.C = this.i = this.c = this.xd = 0, this.s = new OA(), this.ab = 0, this.gc = o(4, NA), this.Oc = 0;
    }
    function ne() {
      this.Lc = this.Z = this.$a = this.i = this.c = 0, this.l = new Fi(), this.ic = 0, this.ca = [], this.tb = 0, this.qd = null, this.rd = 0;
    }
    function we(a, l, B, g, C, m, U) {
      for (a = a == null ? 0 : a[l + 0], l = 0; l < U; ++l) C[m + l] = a + B[g + l] & 255, a = C[m + l];
    }
    function Re(a, l, B, g, C, m, U) {
      var L;
      if (a == null) we(null, null, B, g, C, m, U);
      else for (L = 0; L < U; ++L) C[m + L] = a[l + L] + B[g + L] & 255;
    }
    function nt(a, l, B, g, C, m, U) {
      if (a == null) we(null, null, B, g, C, m, U);
      else {
        var L, x = a[l + 0], _ = x, W = x;
        for (L = 0; L < U; ++L) _ = W + (x = a[l + L]) - _, W = B[g + L] + (-256 & _ ? 0 > _ ? 0 : 255 : _) & 255, _ = x, C[m + L] = W;
      }
    }
    function Ne(a, l, B, g) {
      var C = l.width, m = l.o;
      if (A(a != null && l != null), 0 > B || 0 >= g || B + g > m) return null;
      if (!a.Cc) {
        if (a.ga == null) {
          var U;
          if (a.ga = new ne(), (U = a.ga == null) || (U = l.width * l.o, A(a.Gb.length == 0), a.Gb = i(U), a.Uc = 0, a.Gb == null ? U = 0 : (a.mb = a.Gb, a.nb = a.Uc, a.rc = null, U = 1), U = !U), !U) {
            U = a.ga;
            var L = a.Fa, x = a.P, _ = a.qc, W = a.mb, nA = a.nb, D = x + 1, J = _ - 1, AA = U.l;
            if (A(L != null && W != null && l != null), yn[0] = null, yn[1] = we, yn[2] = Re, yn[3] = nt, U.ca = W, U.tb = nA, U.c = l.width, U.i = l.height, A(0 < U.c && 0 < U.i), 1 >= _) l = 0;
            else if (U.$a = 3 & L[x + 0], U.Z = L[x + 0] >> 2 & 3, U.Lc = L[x + 0] >> 4 & 3, x = L[x + 0] >> 6 & 3, 0 > U.$a || 1 < U.$a || 4 <= U.Z || 1 < U.Lc || x) l = 0;
            else if (AA.put = XA, AA.ac = Er, AA.bc = Vr, AA.ma = U, AA.width = l.width, AA.height = l.height, AA.Da = l.Da, AA.v = l.v, AA.va = l.va, AA.j = l.j, AA.o = l.o, U.$a) A: {
              A(U.$a == 1), l = qn();
              e: for (; ; ) {
                if (l == null) {
                  l = 0;
                  break A;
                }
                if (A(U != null), U.mc = l, l.c = U.c, l.i = U.i, l.l = U.l, l.l.ma = U, l.l.width = U.c, l.l.height = U.i, l.a = 0, cA(l.m, L, D, J), !xr(U.c, U.i, 1, l, null) || (l.ab == 1 && l.gc[0].hc == 3 && hr(l.s) ? (U.ic = 1, L = l.c * l.i, l.Ta = null, l.Ua = 0, l.V = i(L), l.Ba = 0, l.V == null ? (l.a = 1, l = 0) : l = 1) : (U.ic = 0, l = Wn(l, U.c)), !l)) break e;
                l = 1;
                break A;
              }
              U.mc = null, l = 0;
            }
            else l = J >= U.c * U.i;
            U = !l;
          }
          if (U) return null;
          a.ga.Lc != 1 ? a.Ga = 0 : g = m - B;
        }
        A(a.ga != null), A(B + g <= m);
        A: {
          if (l = (L = a.ga).c, m = L.l.o, L.$a == 0) {
            if (D = a.rc, J = a.Vc, AA = a.Fa, x = a.P + 1 + B * l, _ = a.mb, W = a.nb + B * l, A(x <= a.P + a.qc), L.Z != 0) for (A(yn[L.Z] != null), U = 0; U < g; ++U) yn[L.Z](D, J, AA, x, _, W, l), D = _, J = W, W += l, x += l;
            else for (U = 0; U < g; ++U) r(_, W, AA, x, l), D = _, J = W, W += l, x += l;
            a.rc = D, a.Vc = J;
          } else {
            if (A(L.mc != null), l = B + g, A((U = L.mc) != null), A(l <= U.i), U.C >= l) l = 1;
            else if (L.ic || pr(), L.ic) {
              L = U.V, D = U.Ba, J = U.c;
              var fA = U.i, rA = (AA = 1, x = U.$ / J, _ = U.$ % J, W = U.m, nA = U.s, U.$), hA = J * fA, dA = J * l, mA = nA.wc, vA = rA < dA ? pt(nA, _, x) : null;
              A(rA <= hA), A(l <= fA), A(hr(nA));
              e: for (; ; ) {
                for (; !W.h && rA < dA; ) {
                  if (_ & mA || (vA = pt(nA, _, x)), A(vA != null), eA(W), 256 > (fA = Ge(vA.G[0], vA.H[0], W))) L[D + rA] = fA, ++rA, ++_ >= J && (_ = 0, ++x <= l && !(x % 16) && Br(U, x));
                  else {
                    if (!(280 > fA)) {
                      AA = 0;
                      break e;
                    }
                    fA = $t(fA - 256, W);
                    var kA, IA = Ge(vA.G[4], vA.H[4], W);
                    if (eA(W), !(rA >= (IA = Ar(J, IA = $t(IA, W))) && hA - rA >= fA)) {
                      AA = 0;
                      break e;
                    }
                    for (kA = 0; kA < fA; ++kA) L[D + rA + kA] = L[D + rA + kA - IA];
                    for (rA += fA, _ += fA; _ >= J; ) _ -= J, ++x <= l && !(x % 16) && Br(U, x);
                    rA < dA && _ & mA && (vA = pt(nA, _, x));
                  }
                  A(W.h == q(W));
                }
                Br(U, x > l ? l : x);
                break e;
              }
              !AA || W.h && rA < hA ? (AA = 0, U.a = W.h ? 5 : 3) : U.$ = rA, l = AA;
            } else l = dr(U, U.V, U.Ba, U.c, U.i, l, Ci);
            if (!l) {
              g = 0;
              break A;
            }
          }
          B + g >= m && (a.Cc = 1), g = 1;
        }
        if (!g) return null;
        if (a.Cc && ((g = a.ga) != null && (g.mc = null), a.ga = null, 0 < a.Ga)) return alert("todo:WebPDequantizeLevels"), null;
      }
      return a.nb + B * C;
    }
    function ot(a, l, B, g, C, m) {
      for (; 0 < C--; ) {
        var U, L = a, x = l + (B ? 1 : 0), _ = a, W = l + (B ? 0 : 3);
        for (U = 0; U < g; ++U) {
          var nA = _[W + 4 * U];
          nA != 255 && (nA *= 32897, L[x + 4 * U + 0] = L[x + 4 * U + 0] * nA >> 23, L[x + 4 * U + 1] = L[x + 4 * U + 1] * nA >> 23, L[x + 4 * U + 2] = L[x + 4 * U + 2] * nA >> 23);
        }
        l += m;
      }
    }
    function it(a, l, B, g, C) {
      for (; 0 < g--; ) {
        var m;
        for (m = 0; m < B; ++m) {
          var U = a[l + 2 * m + 0], L = 15 & (_ = a[l + 2 * m + 1]), x = 4369 * L, _ = (240 & _ | _ >> 4) * x >> 16;
          a[l + 2 * m + 0] = (240 & U | U >> 4) * x >> 16 & 240 | (15 & U | U << 4) * x >> 16 >> 4 & 15, a[l + 2 * m + 1] = 240 & _ | L;
        }
        l += C;
      }
    }
    function wt(a, l, B, g, C, m, U, L) {
      var x, _, W = 255;
      for (_ = 0; _ < C; ++_) {
        for (x = 0; x < g; ++x) {
          var nA = a[l + x];
          m[U + 4 * x] = nA, W &= nA;
        }
        l += B, U += L;
      }
      return W != 255;
    }
    function $r(a, l, B, g, C) {
      var m;
      for (m = 0; m < C; ++m) B[g + m] = a[l + m] >> 8;
    }
    function pr() {
      Ua = ot, vu = it, Cu = wt, mu = $r;
    }
    function An(a, l, B) {
      N[a] = function(g, C, m, U, L, x, _, W, nA, D, J, AA, fA, rA, hA, dA, mA) {
        var vA, kA = mA - 1 >> 1, IA = L[x + 0] | _[W + 0] << 16, ie = nA[D + 0] | J[AA + 0] << 16;
        A(g != null);
        var _A = 3 * IA + ie + 131074 >> 2;
        for (l(g[C + 0], 255 & _A, _A >> 16, fA, rA), m != null && (_A = 3 * ie + IA + 131074 >> 2, l(m[U + 0], 255 & _A, _A >> 16, hA, dA)), vA = 1; vA <= kA; ++vA) {
          var de = L[x + vA] | _[W + vA] << 16, lt = nA[D + vA] | J[AA + vA] << 16, ae = IA + de + ie + lt + 524296, DA = ae + 2 * (de + ie) >> 3;
          _A = DA + IA >> 1, IA = (ae = ae + 2 * (IA + lt) >> 3) + de >> 1, l(g[C + 2 * vA - 1], 255 & _A, _A >> 16, fA, rA + (2 * vA - 1) * B), l(g[C + 2 * vA - 0], 255 & IA, IA >> 16, fA, rA + (2 * vA - 0) * B), m != null && (_A = ae + ie >> 1, IA = DA + lt >> 1, l(m[U + 2 * vA - 1], 255 & _A, _A >> 16, hA, dA + (2 * vA - 1) * B), l(m[U + 2 * vA + 0], 255 & IA, IA >> 16, hA, dA + (2 * vA + 0) * B)), IA = de, ie = lt;
        }
        1 & mA || (_A = 3 * IA + ie + 131074 >> 2, l(g[C + mA - 1], 255 & _A, _A >> 16, fA, rA + (mA - 1) * B), m != null && (_A = 3 * ie + IA + 131074 >> 2, l(m[U + mA - 1], 255 & _A, _A >> 16, hA, dA + (mA - 1) * B)));
      };
    }
    function ha() {
      sr[bs] = vB, sr[ys] = Hu, sr[Eu] = CB, sr[Es] = Nu, sr[Ls] = _u, sr[wc] = Du, sr[Lu] = mB, sr[vc] = Hu, sr[Cc] = Nu, sr[xs] = _u, sr[mc] = Du;
    }
    function Li(a) {
      return a & -16384 ? 0 > a ? 0 : 255 : a >> QB;
    }
    function gn(a, l) {
      return Li((19077 * a >> 8) + (26149 * l >> 8) - 14234);
    }
    function $n(a, l, B) {
      return Li((19077 * a >> 8) - (6419 * l >> 8) - (13320 * B >> 8) + 8708);
    }
    function Ai(a, l) {
      return Li((19077 * a >> 8) + (33050 * l >> 8) - 17685);
    }
    function pn(a, l, B, g, C) {
      g[C + 0] = gn(a, B), g[C + 1] = $n(a, l, B), g[C + 2] = Ai(a, l);
    }
    function vt(a, l, B, g, C) {
      g[C + 0] = Ai(a, l), g[C + 1] = $n(a, l, B), g[C + 2] = gn(a, B);
    }
    function ei(a, l, B, g, C) {
      var m = $n(a, l, B);
      l = m << 3 & 224 | Ai(a, l) >> 3, g[C + 0] = 248 & gn(a, B) | m >> 5, g[C + 1] = l;
    }
    function ti(a, l, B, g, C) {
      var m = 240 & Ai(a, l) | 15;
      g[C + 0] = 240 & gn(a, B) | $n(a, l, B) >> 4, g[C + 1] = m;
    }
    function Ba(a, l, B, g, C) {
      g[C + 0] = 255, pn(a, l, B, g, C + 1);
    }
    function da(a, l, B, g, C) {
      vt(a, l, B, g, C), g[C + 3] = 255;
    }
    function Nt(a, l, B, g, C) {
      pn(a, l, B, g, C), g[C + 3] = 255;
    }
    function en(a, l, B) {
      N[a] = function(g, C, m, U, L, x, _, W, nA) {
        for (var D = W + (-2 & nA) * B; W != D; ) l(g[C + 0], m[U + 0], L[x + 0], _, W), l(g[C + 1], m[U + 0], L[x + 0], _, W + B), C += 2, ++U, ++x, W += 2 * B;
        1 & nA && l(g[C + 0], m[U + 0], L[x + 0], _, W);
      };
    }
    function xi(a, l, B) {
      return B == 0 ? a == 0 ? l == 0 ? 6 : 5 : l == 0 ? 4 : 0 : B;
    }
    function ms(a, l, B, g, C) {
      switch (a >>> 30) {
        case 3:
          ai(l, B, g, C, 0);
          break;
        case 2:
          ir(l, B, g, C);
          break;
        case 1:
          Qe(l, B, g, C);
      }
    }
    function nr(a, l) {
      var B, g, C = l.M, m = l.Nb, U = a.oc, L = a.pc + 40, x = a.oc, _ = a.pc + 584, W = a.oc, nA = a.pc + 600;
      for (B = 0; 16 > B; ++B) U[L + 32 * B - 1] = 129;
      for (B = 0; 8 > B; ++B) x[_ + 32 * B - 1] = 129, W[nA + 32 * B - 1] = 129;
      for (0 < C ? U[L - 1 - 32] = x[_ - 1 - 32] = W[nA - 1 - 32] = 129 : (n(U, L - 32 - 1, 127, 21), n(x, _ - 32 - 1, 127, 9), n(W, nA - 32 - 1, 127, 9)), g = 0; g < a.za; ++g) {
        var D = l.ya[l.aa + g];
        if (0 < g) {
          for (B = -1; 16 > B; ++B) r(U, L + 32 * B - 4, U, L + 32 * B + 12, 4);
          for (B = -1; 8 > B; ++B) r(x, _ + 32 * B - 4, x, _ + 32 * B + 4, 4), r(W, nA + 32 * B - 4, W, nA + 32 * B + 4, 4);
        }
        var J = a.Gd, AA = a.Hd + g, fA = D.ad, rA = D.Hc;
        if (0 < C && (r(U, L - 32, J[AA].y, 0, 16), r(x, _ - 32, J[AA].f, 0, 8), r(W, nA - 32, J[AA].ea, 0, 8)), D.Za) {
          var hA = U, dA = L - 32 + 16;
          for (0 < C && (g >= a.za - 1 ? n(hA, dA, J[AA].y[15], 4) : r(hA, dA, J[AA + 1].y, 0, 4)), B = 0; 4 > B; B++) hA[dA + 128 + B] = hA[dA + 256 + B] = hA[dA + 384 + B] = hA[dA + 0 + B];
          for (B = 0; 16 > B; ++B, rA <<= 2) hA = U, dA = L + Ou[B], wr[D.Ob[B]](hA, dA), ms(rA, fA, 16 * +B, hA, dA);
        } else if (hA = xi(g, C, D.Ob[0]), bn[hA](U, L), rA != 0) for (B = 0; 16 > B; ++B, rA <<= 2) ms(rA, fA, 16 * +B, U, L + Ou[B]);
        for (B = D.Gc, hA = xi(g, C, D.Dd), nn[hA](x, _), nn[hA](W, nA), rA = fA, hA = x, dA = _, 255 & (D = 0 | B) && (170 & D ? Dr(rA, 256, hA, dA) : xe(rA, 256, hA, dA)), D = W, rA = nA, 255 & (B >>= 8) && (170 & B ? Dr(fA, 320, D, rA) : xe(fA, 320, D, rA)), C < a.Ub - 1 && (r(J[AA].y, 0, U, L + 480, 16), r(J[AA].f, 0, x, _ + 224, 8), r(J[AA].ea, 0, W, nA + 224, 8)), B = 8 * m * a.B, J = a.sa, AA = a.ta + 16 * g + 16 * m * a.R, fA = a.qa, D = a.ra + 8 * g + B, rA = a.Ha, hA = a.Ia + 8 * g + B, B = 0; 16 > B; ++B) r(J, AA + B * a.R, U, L + 32 * B, 16);
        for (B = 0; 8 > B; ++B) r(fA, D + B * a.B, x, _ + 32 * B, 8), r(rA, hA + B * a.B, W, nA + 32 * B, 8);
      }
    }
    function ri(a, l, B, g, C, m, U, L, x) {
      var _ = [0], W = [0], nA = 0, D = x != null ? x.kd : 0, J = x ?? new wA();
      if (a == null || 12 > B) return 7;
      J.data = a, J.w = l, J.ha = B, l = [l], B = [B], J.gb = [J.gb];
      A: {
        var AA = l, fA = B, rA = J.gb;
        if (A(a != null), A(fA != null), A(rA != null), rA[0] = 0, 12 <= fA[0] && !e(a, AA[0], "RIFF")) {
          if (e(a, AA[0] + 8, "WEBP")) {
            rA = 3;
            break A;
          }
          var hA = KA(a, AA[0] + 4);
          if (12 > hA || 4294967286 < hA) {
            rA = 3;
            break A;
          }
          if (D && hA > fA[0] - 8) {
            rA = 7;
            break A;
          }
          rA[0] = hA, AA[0] += 12, fA[0] -= 12;
        }
        rA = 0;
      }
      if (rA != 0) return rA;
      for (hA = 0 < J.gb[0], B = B[0]; ; ) {
        A: {
          var dA = a;
          fA = l, rA = B;
          var mA = _, vA = W, kA = AA = [0];
          if ((_A = nA = [nA])[0] = 0, 8 > rA[0]) rA = 7;
          else {
            if (!e(dA, fA[0], "VP8X")) {
              if (KA(dA, fA[0] + 4) != 10) {
                rA = 3;
                break A;
              }
              if (18 > rA[0]) {
                rA = 7;
                break A;
              }
              var IA = KA(dA, fA[0] + 8), ie = 1 + yA(dA, fA[0] + 12);
              if (2147483648 <= ie * (dA = 1 + yA(dA, fA[0] + 15))) {
                rA = 3;
                break A;
              }
              kA != null && (kA[0] = IA), mA != null && (mA[0] = ie), vA != null && (vA[0] = dA), fA[0] += 18, rA[0] -= 18, _A[0] = 1;
            }
            rA = 0;
          }
        }
        if (nA = nA[0], AA = AA[0], rA != 0) return rA;
        if (fA = !!(2 & AA), !hA && nA) return 3;
        if (m != null && (m[0] = !!(16 & AA)), U != null && (U[0] = fA), L != null && (L[0] = 0), U = _[0], AA = W[0], nA && fA && x == null) {
          rA = 0;
          break;
        }
        if (4 > B) {
          rA = 7;
          break;
        }
        if (hA && nA || !hA && !nA && !e(a, l[0], "ALPH")) {
          B = [B], J.na = [J.na], J.P = [J.P], J.Sa = [J.Sa];
          A: {
            IA = a, rA = l, hA = B;
            var _A = J.gb;
            mA = J.na, vA = J.P, kA = J.Sa, ie = 22, A(IA != null), A(hA != null), dA = rA[0];
            var de = hA[0];
            for (A(mA != null), A(kA != null), mA[0] = null, vA[0] = null, kA[0] = 0; ; ) {
              if (rA[0] = dA, hA[0] = de, 8 > de) {
                rA = 7;
                break A;
              }
              var lt = KA(IA, dA + 4);
              if (4294967286 < lt) {
                rA = 3;
                break A;
              }
              var ae = 8 + lt + 1 & -2;
              if (ie += ae, 0 < _A && ie > _A) {
                rA = 3;
                break A;
              }
              if (!e(IA, dA, "VP8 ") || !e(IA, dA, "VP8L")) {
                rA = 0;
                break A;
              }
              if (de[0] < ae) {
                rA = 7;
                break A;
              }
              e(IA, dA, "ALPH") || (mA[0] = IA, vA[0] = dA + 8, kA[0] = lt), dA += ae, de -= ae;
            }
          }
          if (B = B[0], J.na = J.na[0], J.P = J.P[0], J.Sa = J.Sa[0], rA != 0) break;
        }
        B = [B], J.Ja = [J.Ja], J.xa = [J.xa];
        A: if (_A = a, rA = l, hA = B, mA = J.gb[0], vA = J.Ja, kA = J.xa, IA = rA[0], dA = !e(_A, IA, "VP8 "), ie = !e(_A, IA, "VP8L"), A(_A != null), A(hA != null), A(vA != null), A(kA != null), 8 > hA[0]) rA = 7;
        else {
          if (dA || ie) {
            if (_A = KA(_A, IA + 4), 12 <= mA && _A > mA - 12) {
              rA = 3;
              break A;
            }
            if (D && _A > hA[0] - 8) {
              rA = 7;
              break A;
            }
            vA[0] = _A, rA[0] += 8, hA[0] -= 8, kA[0] = ie;
          } else kA[0] = 5 <= hA[0] && _A[IA + 0] == 47 && !(_A[IA + 4] >> 5), vA[0] = hA[0];
          rA = 0;
        }
        if (B = B[0], J.Ja = J.Ja[0], J.xa = J.xa[0], l = l[0], rA != 0) break;
        if (4294967286 < J.Ja) return 3;
        if (L == null || fA || (L[0] = J.xa ? 2 : 1), U = [U], AA = [AA], J.xa) {
          if (5 > B) {
            rA = 7;
            break;
          }
          L = U, D = AA, fA = m, a == null || 5 > B ? a = 0 : 5 <= B && a[l + 0] == 47 && !(a[l + 4] >> 5) ? (hA = [0], _A = [0], mA = [0], cA(vA = new O(), a, l, B), jr(vA, hA, _A, mA) ? (L != null && (L[0] = hA[0]), D != null && (D[0] = _A[0]), fA != null && (fA[0] = mA[0]), a = 1) : a = 0) : a = 0;
        } else {
          if (10 > B) {
            rA = 7;
            break;
          }
          L = AA, a == null || 10 > B || !ls(a, l + 3, B - 3) ? a = 0 : (D = a[l + 0] | a[l + 1] << 8 | a[l + 2] << 16, fA = 16383 & (a[l + 7] << 8 | a[l + 6]), a = 16383 & (a[l + 9] << 8 | a[l + 8]), 1 & D || 3 < (D >> 1 & 7) || !(D >> 4 & 1) || D >> 5 >= J.Ja || !fA || !a ? a = 0 : (U && (U[0] = fA), L && (L[0] = a), a = 1));
        }
        if (!a || (U = U[0], AA = AA[0], nA && (_[0] != U || W[0] != AA))) return 3;
        x != null && (x[0] = J, x.offset = l - x.w, A(4294967286 > l - x.w), A(x.offset == x.ha - B));
        break;
      }
      return rA == 0 || rA == 7 && nA && x == null ? (m != null && (m[0] |= J.na != null && 0 < J.na.length), g != null && (g[0] = U), C != null && (C[0] = AA), 0) : rA;
    }
    function ga(a, l, B) {
      var g = l.width, C = l.height, m = 0, U = 0, L = g, x = C;
      if (l.Da = a != null && 0 < a.Da, l.Da && (L = a.cd, x = a.bd, m = a.v, U = a.j, 11 > B || (m &= -2, U &= -2), 0 > m || 0 > U || 0 >= L || 0 >= x || m + L > g || U + x > C)) return 0;
      if (l.v = m, l.j = U, l.va = m + L, l.o = U + x, l.U = L, l.T = x, l.da = a != null && 0 < a.da, l.da) {
        if (!jA(L, x, B = [a.ib], m = [a.hb])) return 0;
        l.ib = B[0], l.hb = m[0];
      }
      return l.ob = a != null && a.ob, l.Kb = a == null || !a.Sd, l.da && (l.ob = l.ib < 3 * g / 4 && l.hb < 3 * C / 4, l.Kb = 0), 1;
    }
    function pa(a) {
      if (a == null) return 2;
      if (11 > a.S) {
        var l = a.f.RGBA;
        l.fb += (a.height - 1) * l.A, l.A = -l.A;
      } else l = a.f.kb, a = a.height, l.O += (a - 1) * l.fa, l.fa = -l.fa, l.N += (a - 1 >> 1) * l.Ab, l.Ab = -l.Ab, l.W += (a - 1 >> 1) * l.Db, l.Db = -l.Db, l.F != null && (l.J += (a - 1) * l.lb, l.lb = -l.lb);
      return 0;
    }
    function wn(a, l, B, g) {
      if (g == null || 0 >= a || 0 >= l) return 2;
      if (B != null) {
        if (B.Da) {
          var C = B.cd, m = B.bd, U = -2 & B.v, L = -2 & B.j;
          if (0 > U || 0 > L || 0 >= C || 0 >= m || U + C > a || L + m > l) return 2;
          a = C, l = m;
        }
        if (B.da) {
          if (!jA(a, l, C = [B.ib], m = [B.hb])) return 2;
          a = C[0], l = m[0];
        }
      }
      g.width = a, g.height = l;
      A: {
        var x = g.width, _ = g.height;
        if (a = g.S, 0 >= x || 0 >= _ || !(a >= bs && 13 > a)) a = 2;
        else {
          if (0 >= g.Rd && g.sd == null) {
            U = m = C = l = 0;
            var W = (L = x * ku[a]) * _;
            if (11 > a || (m = (_ + 1) / 2 * (l = (x + 1) / 2), a == 12 && (U = (C = x) * _)), (_ = i(W + 2 * m + U)) == null) {
              a = 1;
              break A;
            }
            g.sd = _, 11 > a ? ((x = g.f.RGBA).eb = _, x.fb = 0, x.A = L, x.size = W) : ((x = g.f.kb).y = _, x.O = 0, x.fa = L, x.Fd = W, x.f = _, x.N = 0 + W, x.Ab = l, x.Cd = m, x.ea = _, x.W = 0 + W + m, x.Db = l, x.Ed = m, a == 12 && (x.F = _, x.J = 0 + W + 2 * m), x.Tc = U, x.lb = C);
          }
          if (l = 1, C = g.S, m = g.width, U = g.height, C >= bs && 13 > C) if (11 > C) a = g.f.RGBA, l &= (L = Math.abs(a.A)) * (U - 1) + m <= a.size, l &= L >= m * ku[C], l &= a.eb != null;
          else {
            a = g.f.kb, L = (m + 1) / 2, W = (U + 1) / 2, x = Math.abs(a.fa), _ = Math.abs(a.Ab);
            var nA = Math.abs(a.Db), D = Math.abs(a.lb), J = D * (U - 1) + m;
            l &= x * (U - 1) + m <= a.Fd, l &= _ * (W - 1) + L <= a.Cd, l = (l &= nA * (W - 1) + L <= a.Ed) & x >= m & _ >= L & nA >= L, l &= a.y != null, l &= a.f != null, l &= a.ea != null, C == 12 && (l &= D >= m, l &= J <= a.Tc, l &= a.F != null);
          }
          else l = 0;
          a = l ? 0 : 2;
        }
      }
      return a != 0 || B != null && B.fd && (a = pa(g)), a;
    }
    var ni = 64, Rt = [0, 1, 3, 7, 15, 31, 63, 127, 255, 511, 1023, 2047, 4095, 8191, 16383, 32767, 65535, 131071, 262143, 524287, 1048575, 2097151, 4194303, 8388607, 16777215], Gt = 24, vn = 32, tn = 8, Cn = [0, 0, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7];
    SA("Predictor0", "PredictorAdd0"), N.Predictor0 = function() {
      return 4278190080;
    }, N.Predictor1 = function(a) {
      return a;
    }, N.Predictor2 = function(a, l, B) {
      return l[B + 0];
    }, N.Predictor3 = function(a, l, B) {
      return l[B + 1];
    }, N.Predictor4 = function(a, l, B) {
      return l[B - 1];
    }, N.Predictor5 = function(a, l, B) {
      return RA(RA(a, l[B + 1]), l[B + 0]);
    }, N.Predictor6 = function(a, l, B) {
      return RA(a, l[B - 1]);
    }, N.Predictor7 = function(a, l, B) {
      return RA(a, l[B + 0]);
    }, N.Predictor8 = function(a, l, B) {
      return RA(l[B - 1], l[B + 0]);
    }, N.Predictor9 = function(a, l, B) {
      return RA(l[B + 0], l[B + 1]);
    }, N.Predictor10 = function(a, l, B) {
      return RA(RA(a, l[B - 1]), RA(l[B + 0], l[B + 1]));
    }, N.Predictor11 = function(a, l, B) {
      var g = l[B + 0];
      return 0 >= Ae(g >> 24 & 255, a >> 24 & 255, (l = l[B - 1]) >> 24 & 255) + Ae(g >> 16 & 255, a >> 16 & 255, l >> 16 & 255) + Ae(g >> 8 & 255, a >> 8 & 255, l >> 8 & 255) + Ae(255 & g, 255 & a, 255 & l) ? g : a;
    }, N.Predictor12 = function(a, l, B) {
      var g = l[B + 0];
      return (Ce((a >> 24 & 255) + (g >> 24 & 255) - ((l = l[B - 1]) >> 24 & 255)) << 24 | Ce((a >> 16 & 255) + (g >> 16 & 255) - (l >> 16 & 255)) << 16 | Ce((a >> 8 & 255) + (g >> 8 & 255) - (l >> 8 & 255)) << 8 | Ce((255 & a) + (255 & g) - (255 & l))) >>> 0;
    }, N.Predictor13 = function(a, l, B) {
      var g = l[B - 1];
      return (ue((a = RA(a, l[B + 0])) >> 24 & 255, g >> 24 & 255) << 24 | ue(a >> 16 & 255, g >> 16 & 255) << 16 | ue(a >> 8 & 255, g >> 8 & 255) << 8 | ue(255 & a, 255 & g)) >>> 0;
    };
    var wa = N.PredictorAdd0;
    N.PredictorAdd1 = Be, SA("Predictor2", "PredictorAdd2"), SA("Predictor3", "PredictorAdd3"), SA("Predictor4", "PredictorAdd4"), SA("Predictor5", "PredictorAdd5"), SA("Predictor6", "PredictorAdd6"), SA("Predictor7", "PredictorAdd7"), SA("Predictor8", "PredictorAdd8"), SA("Predictor9", "PredictorAdd9"), SA("Predictor10", "PredictorAdd10"), SA("Predictor11", "PredictorAdd11"), SA("Predictor12", "PredictorAdd12"), SA("Predictor13", "PredictorAdd13");
    var Ii = N.PredictorAdd2;
    MA("ColorIndexInverseTransform", "MapARGB", "32b", function(a) {
      return a >> 8 & 255;
    }, function(a) {
      return a;
    }), MA("VP8LColorIndexInverseTransformAlpha", "MapAlpha", "8b", function(a) {
      return a;
    }, function(a) {
      return a >> 8 & 255;
    });
    var Xe, Qs = N.ColorIndexInverseTransform, Nr = N.MapARGB, _r = N.VP8LColorIndexInverseTransformAlpha, va = N.MapAlpha, Ca = N.VP8LPredictorsAdd = [];
    Ca.length = 16, (N.VP8LPredictors = []).length = 16, (N.VP8LPredictorsAdd_C = []).length = 16, (N.VP8LPredictors_C = []).length = 16;
    var ma, Qa, mn, Qn, Fn, ii, Un, ai, ir, Dr, Qe, xe, Je, ct, rn, Fa, Si, Fs, hu, Bu, du, gu, pu, wu, Ua, vu, Cu, mu, Qu = i(511), Fu = i(2041), Uu = i(225), bu = i(767), yu = 0, pc = Fu, Us = Uu, Vt = bu, ar = Qu, bs = 0, ys = 1, Eu = 2, Es = 3, Ls = 4, wc = 5, Lu = 6, vc = 7, Cc = 8, xs = 9, mc = 10, iB = [2, 3, 7], aB = [3, 3, 11], xu = [280, 256, 256, 256, 40], sB = [0, 1, 1, 1, 0], oB = [17, 18, 0, 1, 2, 3, 4, 5, 16, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], cB = [24, 7, 23, 25, 40, 6, 39, 41, 22, 26, 38, 42, 56, 5, 55, 57, 21, 27, 54, 58, 37, 43, 72, 4, 71, 73, 20, 28, 53, 59, 70, 74, 36, 44, 88, 69, 75, 52, 60, 3, 87, 89, 19, 29, 86, 90, 35, 45, 68, 76, 85, 91, 51, 61, 104, 2, 103, 105, 18, 30, 102, 106, 34, 46, 84, 92, 67, 77, 101, 107, 50, 62, 120, 1, 119, 121, 83, 93, 17, 31, 100, 108, 66, 78, 118, 122, 33, 47, 117, 123, 49, 63, 99, 109, 82, 94, 0, 116, 124, 65, 79, 16, 32, 98, 110, 48, 115, 125, 81, 95, 64, 114, 126, 97, 111, 80, 113, 127, 96, 112], lB = [2954, 2956, 2958, 2962, 2970, 2986, 3018, 3082, 3212, 3468, 3980, 5004], uB = 8, Qc = [4, 5, 6, 7, 8, 9, 10, 10, 11, 12, 13, 14, 15, 16, 17, 17, 18, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 25, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 91, 93, 95, 96, 98, 100, 101, 102, 104, 106, 108, 110, 112, 114, 116, 118, 122, 124, 126, 128, 130, 132, 134, 136, 138, 140, 143, 145, 148, 151, 154, 157], Fc = [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 60, 62, 64, 66, 68, 70, 72, 74, 76, 78, 80, 82, 84, 86, 88, 90, 92, 94, 96, 98, 100, 102, 104, 106, 108, 110, 112, 114, 116, 119, 122, 125, 128, 131, 134, 137, 140, 143, 146, 149, 152, 155, 158, 161, 164, 167, 170, 173, 177, 181, 185, 189, 193, 197, 201, 205, 209, 213, 217, 221, 225, 229, 234, 239, 245, 249, 254, 259, 264, 269, 274, 279, 284], ba = null, fB = [[173, 148, 140, 0], [176, 155, 140, 135, 0], [180, 157, 141, 134, 130, 0], [254, 254, 243, 230, 196, 177, 153, 140, 133, 130, 129, 0]], hB = [0, 1, 4, 8, 5, 2, 3, 6, 9, 12, 13, 10, 7, 11, 14, 15], Iu = [-0, 1, -1, 2, -2, 3, 4, 6, -3, 5, -4, -5, -6, 7, -7, 8, -8, -9], BB = [[[[128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128], [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128], [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128]], [[253, 136, 254, 255, 228, 219, 128, 128, 128, 128, 128], [189, 129, 242, 255, 227, 213, 255, 219, 128, 128, 128], [106, 126, 227, 252, 214, 209, 255, 255, 128, 128, 128]], [[1, 98, 248, 255, 236, 226, 255, 255, 128, 128, 128], [181, 133, 238, 254, 221, 234, 255, 154, 128, 128, 128], [78, 134, 202, 247, 198, 180, 255, 219, 128, 128, 128]], [[1, 185, 249, 255, 243, 255, 128, 128, 128, 128, 128], [184, 150, 247, 255, 236, 224, 128, 128, 128, 128, 128], [77, 110, 216, 255, 236, 230, 128, 128, 128, 128, 128]], [[1, 101, 251, 255, 241, 255, 128, 128, 128, 128, 128], [170, 139, 241, 252, 236, 209, 255, 255, 128, 128, 128], [37, 116, 196, 243, 228, 255, 255, 255, 128, 128, 128]], [[1, 204, 254, 255, 245, 255, 128, 128, 128, 128, 128], [207, 160, 250, 255, 238, 128, 128, 128, 128, 128, 128], [102, 103, 231, 255, 211, 171, 128, 128, 128, 128, 128]], [[1, 152, 252, 255, 240, 255, 128, 128, 128, 128, 128], [177, 135, 243, 255, 234, 225, 128, 128, 128, 128, 128], [80, 129, 211, 255, 194, 224, 128, 128, 128, 128, 128]], [[1, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128], [246, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128], [255, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128]]], [[[198, 35, 237, 223, 193, 187, 162, 160, 145, 155, 62], [131, 45, 198, 221, 172, 176, 220, 157, 252, 221, 1], [68, 47, 146, 208, 149, 167, 221, 162, 255, 223, 128]], [[1, 149, 241, 255, 221, 224, 255, 255, 128, 128, 128], [184, 141, 234, 253, 222, 220, 255, 199, 128, 128, 128], [81, 99, 181, 242, 176, 190, 249, 202, 255, 255, 128]], [[1, 129, 232, 253, 214, 197, 242, 196, 255, 255, 128], [99, 121, 210, 250, 201, 198, 255, 202, 128, 128, 128], [23, 91, 163, 242, 170, 187, 247, 210, 255, 255, 128]], [[1, 200, 246, 255, 234, 255, 128, 128, 128, 128, 128], [109, 178, 241, 255, 231, 245, 255, 255, 128, 128, 128], [44, 130, 201, 253, 205, 192, 255, 255, 128, 128, 128]], [[1, 132, 239, 251, 219, 209, 255, 165, 128, 128, 128], [94, 136, 225, 251, 218, 190, 255, 255, 128, 128, 128], [22, 100, 174, 245, 186, 161, 255, 199, 128, 128, 128]], [[1, 182, 249, 255, 232, 235, 128, 128, 128, 128, 128], [124, 143, 241, 255, 227, 234, 128, 128, 128, 128, 128], [35, 77, 181, 251, 193, 211, 255, 205, 128, 128, 128]], [[1, 157, 247, 255, 236, 231, 255, 255, 128, 128, 128], [121, 141, 235, 255, 225, 227, 255, 255, 128, 128, 128], [45, 99, 188, 251, 195, 217, 255, 224, 128, 128, 128]], [[1, 1, 251, 255, 213, 255, 128, 128, 128, 128, 128], [203, 1, 248, 255, 255, 128, 128, 128, 128, 128, 128], [137, 1, 177, 255, 224, 255, 128, 128, 128, 128, 128]]], [[[253, 9, 248, 251, 207, 208, 255, 192, 128, 128, 128], [175, 13, 224, 243, 193, 185, 249, 198, 255, 255, 128], [73, 17, 171, 221, 161, 179, 236, 167, 255, 234, 128]], [[1, 95, 247, 253, 212, 183, 255, 255, 128, 128, 128], [239, 90, 244, 250, 211, 209, 255, 255, 128, 128, 128], [155, 77, 195, 248, 188, 195, 255, 255, 128, 128, 128]], [[1, 24, 239, 251, 218, 219, 255, 205, 128, 128, 128], [201, 51, 219, 255, 196, 186, 128, 128, 128, 128, 128], [69, 46, 190, 239, 201, 218, 255, 228, 128, 128, 128]], [[1, 191, 251, 255, 255, 128, 128, 128, 128, 128, 128], [223, 165, 249, 255, 213, 255, 128, 128, 128, 128, 128], [141, 124, 248, 255, 255, 128, 128, 128, 128, 128, 128]], [[1, 16, 248, 255, 255, 128, 128, 128, 128, 128, 128], [190, 36, 230, 255, 236, 255, 128, 128, 128, 128, 128], [149, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128]], [[1, 226, 255, 128, 128, 128, 128, 128, 128, 128, 128], [247, 192, 255, 128, 128, 128, 128, 128, 128, 128, 128], [240, 128, 255, 128, 128, 128, 128, 128, 128, 128, 128]], [[1, 134, 252, 255, 255, 128, 128, 128, 128, 128, 128], [213, 62, 250, 255, 255, 128, 128, 128, 128, 128, 128], [55, 93, 255, 128, 128, 128, 128, 128, 128, 128, 128]], [[128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128], [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128], [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128]]], [[[202, 24, 213, 235, 186, 191, 220, 160, 240, 175, 255], [126, 38, 182, 232, 169, 184, 228, 174, 255, 187, 128], [61, 46, 138, 219, 151, 178, 240, 170, 255, 216, 128]], [[1, 112, 230, 250, 199, 191, 247, 159, 255, 255, 128], [166, 109, 228, 252, 211, 215, 255, 174, 128, 128, 128], [39, 77, 162, 232, 172, 180, 245, 178, 255, 255, 128]], [[1, 52, 220, 246, 198, 199, 249, 220, 255, 255, 128], [124, 74, 191, 243, 183, 193, 250, 221, 255, 255, 128], [24, 71, 130, 219, 154, 170, 243, 182, 255, 255, 128]], [[1, 182, 225, 249, 219, 240, 255, 224, 128, 128, 128], [149, 150, 226, 252, 216, 205, 255, 171, 128, 128, 128], [28, 108, 170, 242, 183, 194, 254, 223, 255, 255, 128]], [[1, 81, 230, 252, 204, 203, 255, 192, 128, 128, 128], [123, 102, 209, 247, 188, 196, 255, 233, 128, 128, 128], [20, 95, 153, 243, 164, 173, 255, 203, 128, 128, 128]], [[1, 222, 248, 255, 216, 213, 128, 128, 128, 128, 128], [168, 175, 246, 252, 235, 205, 255, 255, 128, 128, 128], [47, 116, 215, 255, 211, 212, 255, 255, 128, 128, 128]], [[1, 121, 236, 253, 212, 214, 255, 255, 128, 128, 128], [141, 84, 213, 252, 201, 202, 255, 219, 128, 128, 128], [42, 80, 160, 240, 162, 185, 255, 205, 128, 128, 128]], [[1, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128], [244, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128], [238, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128]]]], dB = [[[231, 120, 48, 89, 115, 113, 120, 152, 112], [152, 179, 64, 126, 170, 118, 46, 70, 95], [175, 69, 143, 80, 85, 82, 72, 155, 103], [56, 58, 10, 171, 218, 189, 17, 13, 152], [114, 26, 17, 163, 44, 195, 21, 10, 173], [121, 24, 80, 195, 26, 62, 44, 64, 85], [144, 71, 10, 38, 171, 213, 144, 34, 26], [170, 46, 55, 19, 136, 160, 33, 206, 71], [63, 20, 8, 114, 114, 208, 12, 9, 226], [81, 40, 11, 96, 182, 84, 29, 16, 36]], [[134, 183, 89, 137, 98, 101, 106, 165, 148], [72, 187, 100, 130, 157, 111, 32, 75, 80], [66, 102, 167, 99, 74, 62, 40, 234, 128], [41, 53, 9, 178, 241, 141, 26, 8, 107], [74, 43, 26, 146, 73, 166, 49, 23, 157], [65, 38, 105, 160, 51, 52, 31, 115, 128], [104, 79, 12, 27, 217, 255, 87, 17, 7], [87, 68, 71, 44, 114, 51, 15, 186, 23], [47, 41, 14, 110, 182, 183, 21, 17, 194], [66, 45, 25, 102, 197, 189, 23, 18, 22]], [[88, 88, 147, 150, 42, 46, 45, 196, 205], [43, 97, 183, 117, 85, 38, 35, 179, 61], [39, 53, 200, 87, 26, 21, 43, 232, 171], [56, 34, 51, 104, 114, 102, 29, 93, 77], [39, 28, 85, 171, 58, 165, 90, 98, 64], [34, 22, 116, 206, 23, 34, 43, 166, 73], [107, 54, 32, 26, 51, 1, 81, 43, 31], [68, 25, 106, 22, 64, 171, 36, 225, 114], [34, 19, 21, 102, 132, 188, 16, 76, 124], [62, 18, 78, 95, 85, 57, 50, 48, 51]], [[193, 101, 35, 159, 215, 111, 89, 46, 111], [60, 148, 31, 172, 219, 228, 21, 18, 111], [112, 113, 77, 85, 179, 255, 38, 120, 114], [40, 42, 1, 196, 245, 209, 10, 25, 109], [88, 43, 29, 140, 166, 213, 37, 43, 154], [61, 63, 30, 155, 67, 45, 68, 1, 209], [100, 80, 8, 43, 154, 1, 51, 26, 71], [142, 78, 78, 16, 255, 128, 34, 197, 171], [41, 40, 5, 102, 211, 183, 4, 1, 221], [51, 50, 17, 168, 209, 192, 23, 25, 82]], [[138, 31, 36, 171, 27, 166, 38, 44, 229], [67, 87, 58, 169, 82, 115, 26, 59, 179], [63, 59, 90, 180, 59, 166, 93, 73, 154], [40, 40, 21, 116, 143, 209, 34, 39, 175], [47, 15, 16, 183, 34, 223, 49, 45, 183], [46, 17, 33, 183, 6, 98, 15, 32, 183], [57, 46, 22, 24, 128, 1, 54, 17, 37], [65, 32, 73, 115, 28, 128, 23, 128, 205], [40, 3, 9, 115, 51, 192, 18, 6, 223], [87, 37, 9, 115, 59, 77, 64, 21, 47]], [[104, 55, 44, 218, 9, 54, 53, 130, 226], [64, 90, 70, 205, 40, 41, 23, 26, 57], [54, 57, 112, 184, 5, 41, 38, 166, 213], [30, 34, 26, 133, 152, 116, 10, 32, 134], [39, 19, 53, 221, 26, 114, 32, 73, 255], [31, 9, 65, 234, 2, 15, 1, 118, 73], [75, 32, 12, 51, 192, 255, 160, 43, 51], [88, 31, 35, 67, 102, 85, 55, 186, 85], [56, 21, 23, 111, 59, 205, 45, 37, 192], [55, 38, 70, 124, 73, 102, 1, 34, 98]], [[125, 98, 42, 88, 104, 85, 117, 175, 82], [95, 84, 53, 89, 128, 100, 113, 101, 45], [75, 79, 123, 47, 51, 128, 81, 171, 1], [57, 17, 5, 71, 102, 57, 53, 41, 49], [38, 33, 13, 121, 57, 73, 26, 1, 85], [41, 10, 67, 138, 77, 110, 90, 47, 114], [115, 21, 2, 10, 102, 255, 166, 23, 6], [101, 29, 16, 10, 85, 128, 101, 196, 26], [57, 18, 10, 102, 102, 213, 34, 20, 43], [117, 20, 15, 36, 163, 128, 68, 1, 26]], [[102, 61, 71, 37, 34, 53, 31, 243, 192], [69, 60, 71, 38, 73, 119, 28, 222, 37], [68, 45, 128, 34, 1, 47, 11, 245, 171], [62, 17, 19, 70, 146, 85, 55, 62, 70], [37, 43, 37, 154, 100, 163, 85, 160, 1], [63, 9, 92, 136, 28, 64, 32, 201, 85], [75, 15, 9, 9, 64, 255, 184, 119, 16], [86, 6, 28, 5, 64, 255, 25, 248, 1], [56, 8, 17, 132, 137, 255, 55, 116, 128], [58, 15, 20, 82, 135, 57, 26, 121, 40]], [[164, 50, 31, 137, 154, 133, 25, 35, 218], [51, 103, 44, 131, 131, 123, 31, 6, 158], [86, 40, 64, 135, 148, 224, 45, 183, 128], [22, 26, 17, 131, 240, 154, 14, 1, 209], [45, 16, 21, 91, 64, 222, 7, 1, 197], [56, 21, 39, 155, 60, 138, 23, 102, 213], [83, 12, 13, 54, 192, 255, 68, 47, 28], [85, 26, 85, 85, 128, 128, 32, 146, 171], [18, 11, 7, 63, 144, 171, 4, 4, 246], [35, 27, 10, 146, 174, 171, 12, 26, 128]], [[190, 80, 35, 99, 180, 80, 126, 54, 45], [85, 126, 47, 87, 176, 51, 41, 20, 32], [101, 75, 128, 139, 118, 146, 116, 128, 85], [56, 41, 15, 176, 236, 85, 37, 9, 62], [71, 30, 17, 119, 118, 255, 17, 18, 138], [101, 38, 60, 138, 55, 70, 43, 26, 142], [146, 36, 19, 30, 171, 255, 97, 27, 20], [138, 45, 61, 62, 219, 1, 81, 188, 64], [32, 41, 20, 117, 151, 142, 20, 21, 163], [112, 19, 12, 61, 195, 128, 48, 4, 24]]], gB = [[[[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[176, 246, 255, 255, 255, 255, 255, 255, 255, 255, 255], [223, 241, 252, 255, 255, 255, 255, 255, 255, 255, 255], [249, 253, 253, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 244, 252, 255, 255, 255, 255, 255, 255, 255, 255], [234, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [253, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 246, 254, 255, 255, 255, 255, 255, 255, 255, 255], [239, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 248, 254, 255, 255, 255, 255, 255, 255, 255, 255], [251, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [251, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 254, 253, 255, 254, 255, 255, 255, 255, 255, 255], [250, 255, 254, 255, 254, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]]], [[[217, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [225, 252, 241, 253, 255, 255, 254, 255, 255, 255, 255], [234, 250, 241, 250, 253, 255, 253, 254, 255, 255, 255]], [[255, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [223, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [238, 253, 254, 254, 255, 255, 255, 255, 255, 255, 255]], [[255, 248, 254, 255, 255, 255, 255, 255, 255, 255, 255], [249, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 253, 255, 255, 255, 255, 255, 255, 255, 255, 255], [247, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [252, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [253, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 254, 253, 255, 255, 255, 255, 255, 255, 255, 255], [250, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]]], [[[186, 251, 250, 255, 255, 255, 255, 255, 255, 255, 255], [234, 251, 244, 254, 255, 255, 255, 255, 255, 255, 255], [251, 251, 243, 253, 254, 255, 254, 255, 255, 255, 255]], [[255, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [236, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [251, 253, 253, 254, 254, 255, 255, 255, 255, 255, 255]], [[255, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [254, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]]], [[[248, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [250, 254, 252, 254, 255, 255, 255, 255, 255, 255, 255], [248, 254, 249, 253, 255, 255, 255, 255, 255, 255, 255]], [[255, 253, 253, 255, 255, 255, 255, 255, 255, 255, 255], [246, 253, 253, 255, 255, 255, 255, 255, 255, 255, 255], [252, 254, 251, 254, 254, 255, 255, 255, 255, 255, 255]], [[255, 254, 252, 255, 255, 255, 255, 255, 255, 255, 255], [248, 254, 253, 255, 255, 255, 255, 255, 255, 255, 255], [253, 255, 254, 254, 255, 255, 255, 255, 255, 255, 255]], [[255, 251, 254, 255, 255, 255, 255, 255, 255, 255, 255], [245, 251, 254, 255, 255, 255, 255, 255, 255, 255, 255], [253, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 251, 253, 255, 255, 255, 255, 255, 255, 255, 255], [252, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [255, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 252, 255, 255, 255, 255, 255, 255, 255, 255, 255], [249, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 253, 255, 255, 255, 255, 255, 255, 255, 255], [250, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]]]], pB = [0, 1, 2, 3, 6, 4, 5, 6, 6, 6, 6, 6, 6, 6, 6, 7, 0], bn = [], wr = [], nn = [], wB = 1, Su = 2, yn = [], sr = [];
    An("UpsampleRgbLinePair", pn, 3), An("UpsampleBgrLinePair", vt, 3), An("UpsampleRgbaLinePair", Nt, 4), An("UpsampleBgraLinePair", da, 4), An("UpsampleArgbLinePair", Ba, 4), An("UpsampleRgba4444LinePair", ti, 2), An("UpsampleRgb565LinePair", ei, 2);
    var vB = N.UpsampleRgbLinePair, CB = N.UpsampleBgrLinePair, Hu = N.UpsampleRgbaLinePair, Nu = N.UpsampleBgraLinePair, _u = N.UpsampleArgbLinePair, Du = N.UpsampleRgba4444LinePair, mB = N.UpsampleRgb565LinePair, Is = 16, Ss = 1 << Is - 1, ya = -227, Uc = 482, QB = 6, Tu = 0, FB = i(256), UB = i(256), bB = i(256), yB = i(256), EB = i(Uc - ya), LB = i(Uc - ya);
    en("YuvToRgbRow", pn, 3), en("YuvToBgrRow", vt, 3), en("YuvToRgbaRow", Nt, 4), en("YuvToBgraRow", da, 4), en("YuvToArgbRow", Ba, 4), en("YuvToRgba4444Row", ti, 2), en("YuvToRgb565Row", ei, 2);
    var Ou = [0, 4, 8, 12, 128, 132, 136, 140, 256, 260, 264, 268, 384, 388, 392, 396], Hs = [0, 2, 8], xB = [8, 7, 6, 4, 4, 2, 2, 2, 1, 1, 1, 1], IB = 1;
    this.WebPDecodeRGBA = function(a, l, B, g, C) {
      var m = ys, U = new BA(), L = new le();
      U.ba = L, L.S = m, L.width = [L.width], L.height = [L.height];
      var x = L.width, _ = L.height, W = new WA();
      if (W == null || a == null) var nA = 2;
      else A(W != null), nA = ri(a, l, B, W.width, W.height, W.Pd, W.Qd, W.format, null);
      if (nA != 0 ? x = 0 : (x != null && (x[0] = W.width[0]), _ != null && (_[0] = W.height[0]), x = 1), x) {
        L.width = L.width[0], L.height = L.height[0], g != null && (g[0] = L.width), C != null && (C[0] = L.height);
        A: {
          if (g = new Fi(), (C = new wA()).data = a, C.w = l, C.ha = B, C.kd = 1, l = [0], A(C != null), ((a = ri(C.data, C.w, C.ha, null, null, null, l, null, C)) == 0 || a == 7) && l[0] && (a = 4), (l = a) == 0) {
            if (A(U != null), g.data = C.data, g.w = C.w + C.offset, g.ha = C.ha - C.offset, g.put = XA, g.ac = Er, g.bc = Vr, g.ma = U, C.xa) {
              if ((a = qn()) == null) {
                U = 1;
                break A;
              }
              if ((function(D, J) {
                var AA = [0], fA = [0], rA = [0];
                e: for (; ; ) {
                  if (D == null) return 0;
                  if (J == null) return D.a = 2, 0;
                  if (D.l = J, D.a = 0, cA(D.m, J.data, J.w, J.ha), !jr(D.m, AA, fA, rA)) {
                    D.a = 3;
                    break e;
                  }
                  if (D.xb = Su, J.width = AA[0], J.height = fA[0], !xr(AA[0], fA[0], 1, D, null)) break e;
                  return 1;
                }
                return A(D.a != 0), 0;
              })(a, g)) {
                if (g = (l = wn(g.width, g.height, U.Oa, U.ba)) == 0) {
                  e: {
                    g = a;
                    t: for (; ; ) {
                      if (g == null) {
                        g = 0;
                        break e;
                      }
                      if (A(g.s.yc != null), A(g.s.Ya != null), A(0 < g.s.Wb), A((B = g.l) != null), A((C = B.ma) != null), g.xb != 0) {
                        if (g.ca = C.ba, g.tb = C.tb, A(g.ca != null), !ga(C.Oa, B, Es)) {
                          g.a = 2;
                          break t;
                        }
                        if (!Wn(g, B.width) || B.da) break t;
                        if ((B.da || JA(g.ca.S)) && pr(), 11 > g.ca.S || (alert("todo:WebPInitConvertARGBToYUV"), g.ca.f.kb.F != null && pr()), g.Pb && 0 < g.s.ua && g.s.vb.X == null && !H(g.s.vb, g.s.Wa.Xa)) {
                          g.a = 1;
                          break t;
                        }
                        g.xb = 0;
                      }
                      if (!dr(g, g.V, g.Ba, g.c, g.i, B.o, dn)) break t;
                      C.Dc = g.Ma, g = 1;
                      break e;
                    }
                    A(g.a != 0), g = 0;
                  }
                  g = !g;
                }
                g && (l = a.a);
              } else l = a.a;
            } else {
              if ((a = new tc()) == null) {
                U = 1;
                break A;
              }
              if (a.Fa = C.na, a.P = C.P, a.qc = C.Sa, Sr(a, g)) {
                if ((l = wn(g.width, g.height, U.Oa, U.ba)) == 0) {
                  if (a.Aa = 0, B = U.Oa, A((C = a) != null), B != null) {
                    if (0 < (x = 0 > (x = B.Md) ? 0 : 100 < x ? 255 : 255 * x / 100)) {
                      for (_ = W = 0; 4 > _; ++_) 12 > (nA = C.pb[_]).lc && (nA.ia = x * xB[0 > nA.lc ? 0 : nA.lc] >> 3), W |= nA.ia;
                      W && (alert("todo:VP8InitRandom"), C.ia = 1);
                    }
                    C.Ga = B.Id, 100 < C.Ga ? C.Ga = 100 : 0 > C.Ga && (C.Ga = 0);
                  }
                  (function(D, J) {
                    if (D == null) return 0;
                    if (J == null) return rt(D, 2, "NULL VP8Io parameter in VP8Decode().");
                    if (!D.cb && !Sr(D, J)) return 0;
                    if (A(D.cb), J.ac == null || J.ac(J)) {
                      J.ob && (D.L = 0);
                      var AA = Hs[D.L];
                      if (D.L == 2 ? (D.yb = 0, D.zb = 0) : (D.yb = J.v - AA >> 4, D.zb = J.j - AA >> 4, 0 > D.yb && (D.yb = 0), 0 > D.zb && (D.zb = 0)), D.Va = J.o + 15 + AA >> 4, D.Hb = J.va + 15 + AA >> 4, D.Hb > D.za && (D.Hb = D.za), D.Va > D.Ub && (D.Va = D.Ub), 0 < D.L) {
                        var fA = D.ed;
                        for (AA = 0; 4 > AA; ++AA) {
                          var rA;
                          if (D.Qa.Cb) {
                            var hA = D.Qa.Lb[AA];
                            D.Qa.Fb || (hA += fA.Tb);
                          } else hA = fA.Tb;
                          for (rA = 0; 1 >= rA; ++rA) {
                            var dA = D.gd[AA][rA], mA = hA;
                            if (fA.Pc && (mA += fA.vd[0], rA && (mA += fA.od[0])), 0 < (mA = 0 > mA ? 0 : 63 < mA ? 63 : mA)) {
                              var vA = mA;
                              0 < fA.wb && (vA = 4 < fA.wb ? vA >> 2 : vA >> 1) > 9 - fA.wb && (vA = 9 - fA.wb), 1 > vA && (vA = 1), dA.dd = vA, dA.tc = 2 * mA + vA, dA.ld = 40 <= mA ? 2 : 15 <= mA ? 1 : 0;
                            } else dA.tc = 0;
                            dA.La = rA;
                          }
                        }
                      }
                      AA = 0;
                    } else rt(D, 6, "Frame setup failed"), AA = D.a;
                    if (AA = AA == 0) {
                      if (AA) {
                        D.$c = 0, 0 < D.Aa || (D.Ic = IB);
                        e: {
                          AA = D.Ic, fA = 4 * (vA = D.za);
                          var kA = 32 * vA, IA = vA + 1, ie = 0 < D.L ? vA * (0 < D.Aa ? 2 : 1) : 0, _A = (D.Aa == 2 ? 2 : 1) * vA;
                          if ((dA = fA + 832 + (rA = 3 * (16 * AA + Hs[D.L]) / 2 * kA) + (hA = D.Fa != null && 0 < D.Fa.length ? D.Kc.c * D.Kc.i : 0)) != dA) AA = 0;
                          else {
                            if (dA > D.Vb) {
                              if (D.Vb = 0, D.Ec = i(dA), D.Fc = 0, D.Ec == null) {
                                AA = rt(D, 1, "no memory during frame initialization.");
                                break e;
                              }
                              D.Vb = dA;
                            }
                            dA = D.Ec, mA = D.Fc, D.Ac = dA, D.Bc = mA, mA += fA, D.Gd = o(kA, os), D.Hd = 0, D.rb = o(IA + 1, ra), D.sb = 1, D.wa = ie ? o(ie, tr) : null, D.Y = 0, D.D.Nb = 0, D.D.wa = D.wa, D.D.Y = D.Y, 0 < D.Aa && (D.D.Y += vA), A(!0), D.oc = dA, D.pc = mA, mA += 832, D.ya = o(_A, na), D.aa = 0, D.D.ya = D.ya, D.D.aa = D.aa, D.Aa == 2 && (D.D.aa += vA), D.R = 16 * vA, D.B = 8 * vA, vA = (kA = Hs[D.L]) * D.R, kA = kA / 2 * D.B, D.sa = dA, D.ta = mA + vA, D.qa = D.sa, D.ra = D.ta + 16 * AA * D.R + kA, D.Ha = D.qa, D.Ia = D.ra + 8 * AA * D.B + kA, D.$c = 0, mA += rA, D.mb = hA ? dA : null, D.nb = hA ? mA : null, A(mA + hA <= D.Fc + D.Vb), us(D), n(D.Ac, D.Bc, 0, fA), AA = 1;
                          }
                        }
                        if (AA) {
                          if (J.ka = 0, J.y = D.sa, J.O = D.ta, J.f = D.qa, J.N = D.ra, J.ea = D.Ha, J.Vd = D.Ia, J.fa = D.R, J.Rc = D.B, J.F = null, J.J = 0, !yu) {
                            for (AA = -255; 255 >= AA; ++AA) Qu[255 + AA] = 0 > AA ? -AA : AA;
                            for (AA = -1020; 1020 >= AA; ++AA) Fu[1020 + AA] = -128 > AA ? -128 : 127 < AA ? 127 : AA;
                            for (AA = -112; 112 >= AA; ++AA) Uu[112 + AA] = -16 > AA ? -16 : 15 < AA ? 15 : AA;
                            for (AA = -255; 510 >= AA; ++AA) bu[255 + AA] = 0 > AA ? 0 : 255 < AA ? 255 : AA;
                            yu = 1;
                          }
                          Un = bi, ai = nc, Dr = Hr, Qe = hs, xe = Bs, ir = rc, Je = vs, ct = Zn, rn = v, Fa = T, Si = Cs, Fs = f, hu = V, Bu = $, du = zn, gu = fa, pu = ps, wu = ws, wr[0] = fc, wr[1] = ic, wr[2] = lc, wr[3] = uc, wr[4] = Wr, wr[5] = hc, wr[6] = Xr, wr[7] = Bc, wr[8] = sa, wr[9] = yi, bn[0] = oc, bn[1] = sc, bn[2] = ia, bn[3] = ds, bn[4] = Jn, bn[5] = aa, bn[6] = cc, nn[0] = gc, nn[1] = ac, nn[2] = Yn, nn[3] = dc, nn[4] = ca, nn[5] = oa, nn[6] = gs, AA = 1;
                        } else AA = 0;
                      }
                      AA && (AA = (function(de, lt) {
                        for (de.M = 0; de.M < de.Va; ++de.M) {
                          var ae, DA = de.Jc[de.M & de.Xb], UA = de.m, Ye = de;
                          for (ae = 0; ae < Ye.za; ++ae) {
                            var te = UA, ge = Ye, Te = ge.Ac, Ct = ge.Bc + 4 * ae, _t = ge.zc, Ve = ge.ya[ge.aa + ae];
                            if (ge.Qa.Bb ? Ve.$b = gA(te, ge.Pa.jb[0]) ? 2 + gA(te, ge.Pa.jb[2]) : gA(te, ge.Pa.jb[1]) : Ve.$b = 0, ge.kc && (Ve.Ad = gA(te, ge.Bd)), Ve.Za = !gA(te, 145) + 0, Ve.Za) {
                              var yt = Ve.Ob, Dt = 0;
                              for (ge = 0; 4 > ge; ++ge) {
                                var ut, ve = _t[0 + ge];
                                for (ut = 0; 4 > ut; ++ut) {
                                  ve = dB[Te[Ct + ut]][ve];
                                  for (var Ue = Iu[gA(te, ve[0])]; 0 < Ue; ) Ue = Iu[2 * Ue + gA(te, ve[Ue])];
                                  ve = -Ue, Te[Ct + ut] = ve;
                                }
                                r(yt, Dt, Te, Ct, 4), Dt += 4, _t[0 + ge] = ve;
                              }
                            } else ve = gA(te, 156) ? gA(te, 128) ? 1 : 3 : gA(te, 163) ? 2 : 0, Ve.Ob[0] = ve, n(Te, Ct, ve, 4), n(_t, 0, ve, 4);
                            Ve.Dd = gA(te, 142) ? gA(te, 114) ? gA(te, 183) ? 1 : 3 : 2 : 0;
                          }
                          if (Ye.m.Ka) return rt(de, 7, "Premature end-of-partition0 encountered.");
                          for (; de.ja < de.za; ++de.ja) {
                            if (Ye = DA, te = (UA = de).rb[UA.sb - 1], Te = UA.rb[UA.sb + UA.ja], ae = UA.ya[UA.aa + UA.ja], Ct = UA.kc ? ae.Ad : 0) te.la = Te.la = 0, ae.Za || (te.Na = Te.Na = 0), ae.Hc = 0, ae.Gc = 0, ae.ia = 0;
                            else {
                              var je, be;
                              if (te = Te, Te = Ye, Ct = UA.Pa.Xc, _t = UA.ya[UA.aa + UA.ja], Ve = UA.pb[_t.$b], ge = _t.ad, yt = 0, Dt = UA.rb[UA.sb - 1], ve = ut = 0, n(ge, yt, 0, 384), _t.Za) var mt = 0, vr = Ct[3];
                              else {
                                Ue = i(16);
                                var ze = te.Na + Dt.Na;
                                if (ze = ba(Te, Ct[1], ze, Ve.Eb, 0, Ue, 0), te.Na = Dt.Na = (0 < ze) + 0, 1 < ze) Un(Ue, 0, ge, yt);
                                else {
                                  var kt = Ue[0] + 3 >> 3;
                                  for (Ue = 0; 256 > Ue; Ue += 16) ge[yt + Ue] = kt;
                                }
                                mt = 1, vr = Ct[0];
                              }
                              var Ie = 15 & te.la, ft = 15 & Dt.la;
                              for (Ue = 0; 4 > Ue; ++Ue) {
                                var jt = 1 & ft;
                                for (kt = be = 0; 4 > kt; ++kt) Ie = Ie >> 1 | (jt = (ze = ba(Te, vr, ze = jt + (1 & Ie), Ve.Sc, mt, ge, yt)) > mt) << 7, be = be << 2 | (3 < ze ? 3 : 1 < ze ? 2 : ge[yt + 0] != 0), yt += 16;
                                Ie >>= 4, ft = ft >> 1 | jt << 7, ut = (ut << 8 | be) >>> 0;
                              }
                              for (vr = Ie, mt = ft >> 4, je = 0; 4 > je; je += 2) {
                                for (be = 0, Ie = te.la >> 4 + je, ft = Dt.la >> 4 + je, Ue = 0; 2 > Ue; ++Ue) {
                                  for (jt = 1 & ft, kt = 0; 2 > kt; ++kt) ze = jt + (1 & Ie), Ie = Ie >> 1 | (jt = 0 < (ze = ba(Te, Ct[2], ze, Ve.Qc, 0, ge, yt))) << 3, be = be << 2 | (3 < ze ? 3 : 1 < ze ? 2 : ge[yt + 0] != 0), yt += 16;
                                  Ie >>= 2, ft = ft >> 1 | jt << 5;
                                }
                                ve |= be << 4 * je, vr |= Ie << 4 << je, mt |= (240 & ft) << je;
                              }
                              te.la = vr, Dt.la = mt, _t.Hc = ut, _t.Gc = ve, _t.ia = 43690 & ve ? 0 : Ve.ia, Ct = !(ut | ve);
                            }
                            if (0 < UA.L && (UA.wa[UA.Y + UA.ja] = UA.gd[ae.$b][ae.Za], UA.wa[UA.Y + UA.ja].La |= !Ct), Ye.Ka) return rt(de, 7, "Premature end-of-file encountered.");
                          }
                          if (us(de), UA = lt, Ye = 1, ae = (DA = de).D, te = 0 < DA.L && DA.M >= DA.zb && DA.M <= DA.Va, DA.Aa == 0) e: {
                            if (ae.M = DA.M, ae.uc = te, nr(DA, ae), Ye = 1, ae = (be = DA.D).Nb, te = (ve = Hs[DA.L]) * DA.R, Te = ve / 2 * DA.B, Ue = 16 * ae * DA.R, kt = 8 * ae * DA.B, Ct = DA.sa, _t = DA.ta - te + Ue, Ve = DA.qa, ge = DA.ra - Te + kt, yt = DA.Ha, Dt = DA.Ia - Te + kt, ft = (Ie = be.M) == 0, ut = Ie >= DA.Va - 1, DA.Aa == 2 && nr(DA, be), be.uc) for (jt = (ze = DA).D.M, A(ze.D.uc), be = ze.yb; be < ze.Hb; ++be) {
                              mt = be, vr = jt;
                              var Tt = (qt = (Qt = ze).D).Nb;
                              je = Qt.R;
                              var qt = qt.wa[qt.Y + mt], Wt = Qt.sa, Pt = Qt.ta + 16 * Tt * je + 16 * mt, Xt = qt.dd, _e = qt.tc;
                              if (_e != 0) if (A(3 <= _e), Qt.L == 1) 0 < mt && gu(Wt, Pt, je, _e + 4), qt.La && wu(Wt, Pt, je, _e), 0 < vr && du(Wt, Pt, je, _e + 4), qt.La && pu(Wt, Pt, je, _e);
                              else {
                                var Jt = Qt.B, Cr = Qt.qa, si = Qt.ra + 8 * Tt * Jt + 8 * mt, an = Qt.Ha, Qt = Qt.Ia + 8 * Tt * Jt + 8 * mt;
                                Tt = qt.ld, 0 < mt && (ct(Wt, Pt, je, _e + 4, Xt, Tt), Fa(Cr, si, an, Qt, Jt, _e + 4, Xt, Tt)), qt.La && (Fs(Wt, Pt, je, _e, Xt, Tt), Bu(Cr, si, an, Qt, Jt, _e, Xt, Tt)), 0 < vr && (Je(Wt, Pt, je, _e + 4, Xt, Tt), rn(Cr, si, an, Qt, Jt, _e + 4, Xt, Tt)), qt.La && (Si(Wt, Pt, je, _e, Xt, Tt), hu(Cr, si, an, Qt, Jt, _e, Xt, Tt));
                              }
                            }
                            if (DA.ia && alert("todo:DitherRow"), UA.put != null) {
                              if (be = 16 * Ie, Ie = 16 * (Ie + 1), ft ? (UA.y = DA.sa, UA.O = DA.ta + Ue, UA.f = DA.qa, UA.N = DA.ra + kt, UA.ea = DA.Ha, UA.W = DA.Ia + kt) : (be -= ve, UA.y = Ct, UA.O = _t, UA.f = Ve, UA.N = ge, UA.ea = yt, UA.W = Dt), ut || (Ie -= ve), Ie > UA.o && (Ie = UA.o), UA.F = null, UA.J = null, DA.Fa != null && 0 < DA.Fa.length && be < Ie && (UA.J = Ne(DA, UA, be, Ie - be), UA.F = DA.mb, UA.F == null && UA.F.length == 0)) {
                                Ye = rt(DA, 3, "Could not decode alpha data.");
                                break e;
                              }
                              be < UA.j && (ve = UA.j - be, be = UA.j, A(!(1 & ve)), UA.O += DA.R * ve, UA.N += DA.B * (ve >> 1), UA.W += DA.B * (ve >> 1), UA.F != null && (UA.J += UA.width * ve)), be < Ie && (UA.O += UA.v, UA.N += UA.v >> 1, UA.W += UA.v >> 1, UA.F != null && (UA.J += UA.v), UA.ka = be - UA.j, UA.U = UA.va - UA.v, UA.T = Ie - be, Ye = UA.put(UA));
                            }
                            ae + 1 != DA.Ic || ut || (r(DA.sa, DA.ta - te, Ct, _t + 16 * DA.R, te), r(DA.qa, DA.ra - Te, Ve, ge + 8 * DA.B, Te), r(DA.Ha, DA.Ia - Te, yt, Dt + 8 * DA.B, Te));
                          }
                          if (!Ye) return rt(de, 6, "Output aborted.");
                        }
                        return 1;
                      })(D, J)), J.bc != null && J.bc(J), AA &= 1;
                    }
                    return AA ? (D.cb = 0, AA) : 0;
                  })(a, g) || (l = a.a);
                }
              } else l = a.a;
            }
            l == 0 && U.Oa != null && U.Oa.fd && (l = pa(U.ba));
          }
          U = l;
        }
        m = U != 0 ? null : 11 > m ? L.f.RGBA.eb : L.f.kb.y;
      } else m = null;
      return m;
    };
    var ku = [3, 4, 3, 4, 4, 2, 2, 4, 4, 4, 2, 1, 1];
  };
  function u(N, Z) {
    for (var E = "", I = 0; I < 4; I++) E += String.fromCharCode(N[Z++]);
    return E;
  }
  function h(N, Z) {
    return N[Z + 0] | N[Z + 1] << 8;
  }
  function p(N, Z) {
    return (N[Z + 0] | N[Z + 1] << 8 | N[Z + 2] << 16) >>> 0;
  }
  function w(N, Z) {
    return (N[Z + 0] | N[Z + 1] << 8 | N[Z + 2] << 16 | N[Z + 3] << 24) >>> 0;
  }
  new c();
  var d = [0], y = [0], b = [], S = new c(), Q = t, P = (function(N, Z) {
    var E = {}, I = 0, K = !1, R = 0, aA = 0;
    if (E.frames = [], !/** @license
       * Copyright (c) 2017 Dominik Homberger
      Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
      The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
      THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
      https://webpjs.appspot.com
      WebPRiffParser dominikhlbg@gmail.com
      */
    (function(F, O) {
      for (var M = 0; M < 4; M++) if (F[O + M] != "RIFF".charCodeAt(M)) return !0;
      return !1;
    })(N, Z)) {
      for (w(N, Z += 4), Z += 8; Z < N.length; ) {
        var sA = u(N, Z), oA = w(N, Z += 4);
        Z += 4;
        var tA = oA + (1 & oA);
        switch (sA) {
          case "VP8 ":
          case "VP8L":
            E.frames[I] === void 0 && (E.frames[I] = {}), (pA = E.frames[I]).src_off = K ? aA : Z - 8, pA.src_size = R + oA + 8, I++, K && (K = !1, R = 0, aA = 0);
            break;
          case "VP8X":
            (pA = E.header = {}).feature_flags = N[Z];
            var cA = Z + 4;
            pA.canvas_width = 1 + p(N, cA), cA += 3, pA.canvas_height = 1 + p(N, cA), cA += 3;
            break;
          case "ALPH":
            K = !0, R = tA + 8, aA = Z - 8;
            break;
          case "ANIM":
            (pA = E.header).bgcolor = w(N, Z), cA = Z + 4, pA.loop_count = h(N, cA), cA += 2;
            break;
          case "ANMF":
            var QA, pA;
            (pA = E.frames[I] = {}).offset_x = 2 * p(N, Z), Z += 3, pA.offset_y = 2 * p(N, Z), Z += 3, pA.width = 1 + p(N, Z), Z += 3, pA.height = 1 + p(N, Z), Z += 3, pA.duration = p(N, Z), Z += 3, QA = N[Z++], pA.dispose = 1 & QA, pA.blend = QA >> 1 & 1;
        }
        sA != "ANMF" && (Z += tA);
      }
      return E;
    }
  })(Q, 0);
  P.response = Q, P.rgbaoutput = !0, P.dataurl = !1;
  var G = P.header ? P.header : null, k = P.frames ? P.frames : null;
  if (G) {
    G.loop_counter = G.loop_count, d = [G.canvas_height], y = [G.canvas_width];
    for (var Y = 0; Y < k.length && k[Y].blend != 0; Y++) ;
  }
  var z = k[0], iA = S.WebPDecodeRGBA(Q, z.src_off, z.src_size, y, d);
  z.rgba = iA, z.imgwidth = y[0], z.imgheight = d[0];
  for (var j = 0; j < y[0] * d[0] * 4; j++) b[j] = iA[j];
  return this.width = y, this.height = d, this.data = b, this;
}
(function(t) {
  var A, e, r, n, i, o, s, c, u, h = function(F) {
    return F = F || {}, this.isStrokeTransparent = F.isStrokeTransparent || !1, this.strokeOpacity = F.strokeOpacity || 1, this.strokeStyle = F.strokeStyle || "#000000", this.fillStyle = F.fillStyle || "#000000", this.isFillTransparent = F.isFillTransparent || !1, this.fillOpacity = F.fillOpacity || 1, this.font = F.font || "10px sans-serif", this.textBaseline = F.textBaseline || "alphabetic", this.textAlign = F.textAlign || "left", this.lineWidth = F.lineWidth || 1, this.lineJoin = F.lineJoin || "miter", this.lineCap = F.lineCap || "butt", this.path = F.path || [], this.transform = F.transform !== void 0 ? F.transform.clone() : new c(), this.globalCompositeOperation = F.globalCompositeOperation || "normal", this.globalAlpha = F.globalAlpha || 1, this.clip_path = F.clip_path || [], this.currentPoint = F.currentPoint || new o(), this.miterLimit = F.miterLimit || 10, this.lastPoint = F.lastPoint || new o(), this.lineDashOffset = F.lineDashOffset || 0, this.lineDash = F.lineDash || [], this.margin = F.margin || [0, 0, 0, 0], this.prevPageLastElemOffset = F.prevPageLastElemOffset || 0, this.ignoreClearRect = typeof F.ignoreClearRect != "boolean" || F.ignoreClearRect, this;
  };
  t.events.push(["initialized", function() {
    this.context2d = new p(this), A = this.internal.f2, e = this.internal.getCoordinateString, r = this.internal.getVerticalCoordinateString, n = this.internal.getHorizontalCoordinate, i = this.internal.getVerticalCoordinate, o = this.internal.Point, s = this.internal.Rectangle, c = this.internal.Matrix, u = new h();
  }]);
  var p = function(F) {
    Object.defineProperty(this, "canvas", { get: function() {
      return { parentNode: !1, style: !1 };
    } });
    var O = F;
    Object.defineProperty(this, "pdf", { get: function() {
      return O;
    } });
    var M = !1;
    Object.defineProperty(this, "pageWrapXEnabled", { get: function() {
      return M;
    }, set: function(H) {
      M = !!H;
    } });
    var q = !1;
    Object.defineProperty(this, "pageWrapYEnabled", { get: function() {
      return q;
    }, set: function(H) {
      q = !!H;
    } });
    var X = 0;
    Object.defineProperty(this, "posX", { get: function() {
      return X;
    }, set: function(H) {
      isNaN(H) || (X = H);
    } });
    var eA = 0;
    Object.defineProperty(this, "posY", { get: function() {
      return eA;
    }, set: function(H) {
      isNaN(H) || (eA = H);
    } }), Object.defineProperty(this, "margin", { get: function() {
      return u.margin;
    }, set: function(H) {
      var bA;
      typeof H == "number" ? bA = [H, H, H, H] : ((bA = new Array(4))[0] = H[0], bA[1] = H.length >= 2 ? H[1] : bA[0], bA[2] = H.length >= 3 ? H[2] : bA[0], bA[3] = H.length >= 4 ? H[3] : bA[1]), u.margin = bA;
    } });
    var lA = !1;
    Object.defineProperty(this, "autoPaging", { get: function() {
      return lA;
    }, set: function(H) {
      lA = H;
    } });
    var uA = 0;
    Object.defineProperty(this, "lastBreak", { get: function() {
      return uA;
    }, set: function(H) {
      uA = H;
    } });
    var gA = [];
    Object.defineProperty(this, "pageBreaks", { get: function() {
      return gA;
    }, set: function(H) {
      gA = H;
    } }), Object.defineProperty(this, "ctx", { get: function() {
      return u;
    }, set: function(H) {
      H instanceof h && (u = H);
    } }), Object.defineProperty(this, "path", { get: function() {
      return u.path;
    }, set: function(H) {
      u.path = H;
    } });
    var FA = [];
    Object.defineProperty(this, "ctxStack", { get: function() {
      return FA;
    }, set: function(H) {
      FA = H;
    } }), Object.defineProperty(this, "fillStyle", { get: function() {
      return this.ctx.fillStyle;
    }, set: function(H) {
      var bA;
      bA = w(H), this.ctx.fillStyle = bA.style, this.ctx.isFillTransparent = bA.a === 0, this.ctx.fillOpacity = bA.a, this.pdf.setFillColor(bA.r, bA.g, bA.b, { a: bA.a }), this.pdf.setTextColor(bA.r, bA.g, bA.b, { a: bA.a });
    } }), Object.defineProperty(this, "strokeStyle", { get: function() {
      return this.ctx.strokeStyle;
    }, set: function(H) {
      var bA = w(H);
      this.ctx.strokeStyle = bA.style, this.ctx.isStrokeTransparent = bA.a === 0, this.ctx.strokeOpacity = bA.a, bA.a === 0 ? this.pdf.setDrawColor(255, 255, 255) : (bA.a, this.pdf.setDrawColor(bA.r, bA.g, bA.b));
    } }), Object.defineProperty(this, "lineCap", { get: function() {
      return this.ctx.lineCap;
    }, set: function(H) {
      ["butt", "round", "square"].indexOf(H) !== -1 && (this.ctx.lineCap = H, this.pdf.setLineCap(H));
    } }), Object.defineProperty(this, "lineWidth", { get: function() {
      return this.ctx.lineWidth;
    }, set: function(H) {
      isNaN(H) || (this.ctx.lineWidth = H, this.pdf.setLineWidth(H));
    } }), Object.defineProperty(this, "lineJoin", { get: function() {
      return this.ctx.lineJoin;
    }, set: function(H) {
      ["bevel", "round", "miter"].indexOf(H) !== -1 && (this.ctx.lineJoin = H, this.pdf.setLineJoin(H));
    } }), Object.defineProperty(this, "miterLimit", { get: function() {
      return this.ctx.miterLimit;
    }, set: function(H) {
      isNaN(H) || (this.ctx.miterLimit = H, this.pdf.setMiterLimit(H));
    } }), Object.defineProperty(this, "textBaseline", { get: function() {
      return this.ctx.textBaseline;
    }, set: function(H) {
      this.ctx.textBaseline = H;
    } }), Object.defineProperty(this, "textAlign", { get: function() {
      return this.ctx.textAlign;
    }, set: function(H) {
      ["right", "end", "center", "left", "start"].indexOf(H) !== -1 && (this.ctx.textAlign = H);
    } });
    var LA = null, yA = null, KA = null;
    Object.defineProperty(this, "fontFaces", { get: function() {
      return KA;
    }, set: function(H) {
      LA = null, yA = null, KA = H;
    } }), Object.defineProperty(this, "font", { get: function() {
      return this.ctx.font;
    }, set: function(H) {
      var bA;
      if (this.ctx.font = H, (bA = /^\s*(?=(?:(?:[-a-z]+\s*){0,2}(italic|oblique))?)(?=(?:(?:[-a-z]+\s*){0,2}(small-caps))?)(?=(?:(?:[-a-z]+\s*){0,2}(bold(?:er)?|lighter|[1-9]00))?)(?:(?:normal|\1|\2|\3)\s*){0,3}((?:xx?-)?(?:small|large)|medium|smaller|larger|[.\d]+(?:\%|in|[cem]m|ex|p[ctx]))(?:\s*\/\s*(normal|[.\d]+(?:\%|in|[cem]m|ex|p[ctx])))?\s*([-_,\"\'\sa-z0-9]+?)\s*$/i.exec(H)) !== null) {
        var se = bA[1];
        bA[2];
        var jA = bA[3], CA = bA[4];
        bA[5];
        var qA = bA[6], SA = /^([.\d]+)((?:%|in|[cem]m|ex|p[ctx]))$/i.exec(CA)[2];
        CA = Math.floor(SA === "px" ? parseFloat(CA) * this.pdf.internal.scaleFactor : SA === "em" ? parseFloat(CA) * this.pdf.getFontSize() : parseFloat(CA) * this.pdf.internal.scaleFactor), this.pdf.setFontSize(CA);
        var VA = (function(MA) {
          var We, pe, oe = [], ce = MA.trim();
          if (ce === "") return wl;
          if (ce in Wh) return [Wh[ce]];
          for (; ce !== ""; ) {
            switch (pe = null, We = (ce = Jh(ce)).charAt(0)) {
              case '"':
              case "'":
                pe = T4(ce.substring(1), We);
                break;
              default:
                pe = O4(ce);
            }
            if (pe === null || (oe.push(pe[0]), (ce = Jh(pe[1])) !== "" && ce.charAt(0) !== ",")) return wl;
            ce = ce.replace(/^,/, "");
          }
          return oe;
        })(qA);
        if (this.fontFaces) {
          var RA = (function(MA, We) {
            var pe = MA.getFontList(), oe = JSON.stringify(pe);
            if (LA === null || yA !== oe) {
              var ce = (function(ke) {
                var GA = [];
                return Object.keys(ke).forEach(function(He) {
                  ke[He].forEach(function(JA) {
                    var ee = null;
                    switch (JA) {
                      case "bold":
                        ee = { family: He, weight: "bold" };
                        break;
                      case "italic":
                        ee = { family: He, style: "italic" };
                        break;
                      case "bolditalic":
                        ee = { family: He, weight: "bold", style: "italic" };
                        break;
                      case "":
                      case "normal":
                        ee = { family: He };
                    }
                    ee !== null && (ee.ref = { name: He, style: JA }, GA.push(ee));
                  });
                }), GA;
              })(pe);
              LA = (function(ke) {
                for (var GA = {}, He = 0; He < ke.length; ++He) {
                  var JA = pl(ke[He]), ee = JA.family, Pe = JA.stretch, le = JA.style, WA = JA.weight;
                  GA[ee] = GA[ee] || {}, GA[ee][Pe] = GA[ee][Pe] || {}, GA[ee][Pe][le] = GA[ee][Pe][le] || {}, GA[ee][Pe][le][WA] = JA;
                }
                return GA;
              })(ce.concat(We)), yA = oe;
            }
            return LA;
          })(this.pdf, this.fontFaces), Ce = VA.map(function(MA) {
            return { family: MA, stretch: "normal", weight: jA, style: se };
          }), ue = (function(MA, We, pe) {
            for (var oe = (pe = pe || {}).defaultFontFamily || "times", ce = Object.assign({}, D4, pe.genericFontFamilies || {}), ke = null, GA = null, He = 0; He < We.length; ++He) if (ce[(ke = pl(We[He])).family] && (ke.family = ce[ke.family]), MA.hasOwnProperty(ke.family)) {
              GA = MA[ke.family];
              break;
            }
            if (!(GA = GA || MA[oe])) throw new Error("Could not find a font-family for the rule '" + Xh(ke) + "' and default family '" + oe + "'.");
            if (GA = (function(JA, ee) {
              if (ee[JA]) return ee[JA];
              var Pe = Au[JA], le = Pe <= Au.normal ? -1 : 1, WA = qh(ee, AB, Pe, le);
              if (!WA) throw new Error("Could not find a matching font-stretch value for " + JA);
              return WA;
            })(ke.stretch, GA), GA = (function(JA, ee) {
              if (ee[JA]) return ee[JA];
              for (var Pe = $1[JA], le = 0; le < Pe.length; ++le) if (ee[Pe[le]]) return ee[Pe[le]];
              throw new Error("Could not find a matching font-style for " + JA);
            })(ke.style, GA), !(GA = (function(JA, ee) {
              if (ee[JA]) return ee[JA];
              if (JA === 400 && ee[500]) return ee[500];
              if (JA === 500 && ee[400]) return ee[400];
              var Pe = _4[JA], le = qh(ee, eB, Pe, JA < 400 ? -1 : 1);
              if (!le) throw new Error("Could not find a matching font-weight for value " + JA);
              return le;
            })(ke.weight, GA))) throw new Error("Failed to resolve a font for the rule '" + Xh(ke) + "'.");
            return GA;
          })(RA, Ce);
          this.pdf.setFont(ue.ref.name, ue.ref.style);
        } else {
          var Ae = "";
          (jA === "bold" || parseInt(jA, 10) >= 700 || se === "bold") && (Ae = "bold"), se === "italic" && (Ae += "italic"), Ae.length === 0 && (Ae = "normal");
          for (var Be = "", fe = { arial: "Helvetica", Arial: "Helvetica", verdana: "Helvetica", Verdana: "Helvetica", helvetica: "Helvetica", Helvetica: "Helvetica", "sans-serif": "Helvetica", fixed: "Courier", monospace: "Courier", terminal: "Courier", cursive: "Times", fantasy: "Times", serif: "Times" }, TA = 0; TA < VA.length; TA++) {
            if (this.pdf.internal.getFont(VA[TA], Ae, { noFallback: !0, disableWarning: !0 }) !== void 0) {
              Be = VA[TA];
              break;
            }
            if (Ae === "bolditalic" && this.pdf.internal.getFont(VA[TA], "bold", { noFallback: !0, disableWarning: !0 }) !== void 0) Be = VA[TA], Ae = "bold";
            else if (this.pdf.internal.getFont(VA[TA], "normal", { noFallback: !0, disableWarning: !0 }) !== void 0) {
              Be = VA[TA], Ae = "normal";
              break;
            }
          }
          if (Be === "") {
            for (var re = 0; re < VA.length; re++) if (fe[VA[re]]) {
              Be = fe[VA[re]];
              break;
            }
          }
          Be = Be === "" ? "Times" : Be, this.pdf.setFont(Be, Ae);
        }
      }
    } }), Object.defineProperty(this, "globalCompositeOperation", { get: function() {
      return this.ctx.globalCompositeOperation;
    }, set: function(H) {
      this.ctx.globalCompositeOperation = H;
    } }), Object.defineProperty(this, "globalAlpha", { get: function() {
      return this.ctx.globalAlpha;
    }, set: function(H) {
      this.ctx.globalAlpha = H;
    } }), Object.defineProperty(this, "lineDashOffset", { get: function() {
      return this.ctx.lineDashOffset;
    }, set: function(H) {
      this.ctx.lineDashOffset = H, pA.call(this);
    } }), Object.defineProperty(this, "lineDash", { get: function() {
      return this.ctx.lineDash;
    }, set: function(H) {
      this.ctx.lineDash = H, pA.call(this);
    } }), Object.defineProperty(this, "ignoreClearRect", { get: function() {
      return this.ctx.ignoreClearRect;
    }, set: function(H) {
      this.ctx.ignoreClearRect = !!H;
    } });
  };
  p.prototype.setLineDash = function(F) {
    this.lineDash = F;
  }, p.prototype.getLineDash = function() {
    return this.lineDash.length % 2 ? this.lineDash.concat(this.lineDash) : this.lineDash.slice();
  }, p.prototype.fill = function() {
    k.call(this, "fill", !1);
  }, p.prototype.stroke = function() {
    k.call(this, "stroke", !1);
  }, p.prototype.beginPath = function() {
    this.path = [{ type: "begin" }];
  }, p.prototype.moveTo = function(F, O) {
    if (isNaN(F) || isNaN(O)) throw Se.error("jsPDF.context2d.moveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.moveTo");
    var M = this.ctx.transform.applyToPoint(new o(F, O));
    this.path.push({ type: "mt", x: M.x, y: M.y }), this.ctx.lastPoint = new o(F, O);
  }, p.prototype.closePath = function() {
    var F = new o(0, 0), O = 0;
    for (O = this.path.length - 1; O !== -1; O--) if (this.path[O].type === "begin" && Ee(this.path[O + 1]) === "object" && typeof this.path[O + 1].x == "number") {
      F = new o(this.path[O + 1].x, this.path[O + 1].y);
      break;
    }
    this.path.push({ type: "close" }), this.ctx.lastPoint = new o(F.x, F.y);
  }, p.prototype.lineTo = function(F, O) {
    if (isNaN(F) || isNaN(O)) throw Se.error("jsPDF.context2d.lineTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.lineTo");
    var M = this.ctx.transform.applyToPoint(new o(F, O));
    this.path.push({ type: "lt", x: M.x, y: M.y }), this.ctx.lastPoint = new o(M.x, M.y);
  }, p.prototype.clip = function() {
    this.ctx.clip_path = JSON.parse(JSON.stringify(this.path)), k.call(this, null, !0);
  }, p.prototype.quadraticCurveTo = function(F, O, M, q) {
    if (isNaN(M) || isNaN(q) || isNaN(F) || isNaN(O)) throw Se.error("jsPDF.context2d.quadraticCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.quadraticCurveTo");
    var X = this.ctx.transform.applyToPoint(new o(M, q)), eA = this.ctx.transform.applyToPoint(new o(F, O));
    this.path.push({ type: "qct", x1: eA.x, y1: eA.y, x: X.x, y: X.y }), this.ctx.lastPoint = new o(X.x, X.y);
  }, p.prototype.bezierCurveTo = function(F, O, M, q, X, eA) {
    if (isNaN(X) || isNaN(eA) || isNaN(F) || isNaN(O) || isNaN(M) || isNaN(q)) throw Se.error("jsPDF.context2d.bezierCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.bezierCurveTo");
    var lA = this.ctx.transform.applyToPoint(new o(X, eA)), uA = this.ctx.transform.applyToPoint(new o(F, O)), gA = this.ctx.transform.applyToPoint(new o(M, q));
    this.path.push({ type: "bct", x1: uA.x, y1: uA.y, x2: gA.x, y2: gA.y, x: lA.x, y: lA.y }), this.ctx.lastPoint = new o(lA.x, lA.y);
  }, p.prototype.arc = function(F, O, M, q, X, eA) {
    if (isNaN(F) || isNaN(O) || isNaN(M) || isNaN(q) || isNaN(X)) throw Se.error("jsPDF.context2d.arc: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.arc");
    if (eA = !!eA, !this.ctx.transform.isIdentity) {
      var lA = this.ctx.transform.applyToPoint(new o(F, O));
      F = lA.x, O = lA.y;
      var uA = this.ctx.transform.applyToPoint(new o(0, M)), gA = this.ctx.transform.applyToPoint(new o(0, 0));
      M = Math.sqrt(Math.pow(uA.x - gA.x, 2) + Math.pow(uA.y - gA.y, 2));
    }
    Math.abs(X - q) >= 2 * Math.PI && (q = 0, X = 2 * Math.PI), this.path.push({ type: "arc", x: F, y: O, radius: M, startAngle: q, endAngle: X, counterclockwise: eA });
  }, p.prototype.arcTo = function(F, O, M, q, X) {
    throw new Error("arcTo not implemented.");
  }, p.prototype.rect = function(F, O, M, q) {
    if (isNaN(F) || isNaN(O) || isNaN(M) || isNaN(q)) throw Se.error("jsPDF.context2d.rect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rect");
    this.moveTo(F, O), this.lineTo(F + M, O), this.lineTo(F + M, O + q), this.lineTo(F, O + q), this.lineTo(F, O), this.lineTo(F + M, O), this.lineTo(F, O);
  }, p.prototype.fillRect = function(F, O, M, q) {
    if (isNaN(F) || isNaN(O) || isNaN(M) || isNaN(q)) throw Se.error("jsPDF.context2d.fillRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillRect");
    if (!d.call(this)) {
      var X = {};
      this.lineCap !== "butt" && (X.lineCap = this.lineCap, this.lineCap = "butt"), this.lineJoin !== "miter" && (X.lineJoin = this.lineJoin, this.lineJoin = "miter"), this.beginPath(), this.rect(F, O, M, q), this.fill(), X.hasOwnProperty("lineCap") && (this.lineCap = X.lineCap), X.hasOwnProperty("lineJoin") && (this.lineJoin = X.lineJoin);
    }
  }, p.prototype.strokeRect = function(F, O, M, q) {
    if (isNaN(F) || isNaN(O) || isNaN(M) || isNaN(q)) throw Se.error("jsPDF.context2d.strokeRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeRect");
    y.call(this) || (this.beginPath(), this.rect(F, O, M, q), this.stroke());
  }, p.prototype.clearRect = function(F, O, M, q) {
    if (isNaN(F) || isNaN(O) || isNaN(M) || isNaN(q)) throw Se.error("jsPDF.context2d.clearRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.clearRect");
    this.ignoreClearRect || (this.fillStyle = "#ffffff", this.fillRect(F, O, M, q));
  }, p.prototype.save = function(F) {
    F = typeof F != "boolean" || F;
    for (var O = this.pdf.internal.getCurrentPageInfo().pageNumber, M = 0; M < this.pdf.internal.getNumberOfPages(); M++) this.pdf.setPage(M + 1), this.pdf.internal.out("q");
    if (this.pdf.setPage(O), F) {
      this.ctx.fontSize = this.pdf.internal.getFontSize();
      var q = new h(this.ctx);
      this.ctxStack.push(this.ctx), this.ctx = q;
    }
  }, p.prototype.restore = function(F) {
    F = typeof F != "boolean" || F;
    for (var O = this.pdf.internal.getCurrentPageInfo().pageNumber, M = 0; M < this.pdf.internal.getNumberOfPages(); M++) this.pdf.setPage(M + 1), this.pdf.internal.out("Q");
    this.pdf.setPage(O), F && this.ctxStack.length !== 0 && (this.ctx = this.ctxStack.pop(), this.fillStyle = this.ctx.fillStyle, this.strokeStyle = this.ctx.strokeStyle, this.font = this.ctx.font, this.lineCap = this.ctx.lineCap, this.lineWidth = this.ctx.lineWidth, this.lineJoin = this.ctx.lineJoin, this.lineDash = this.ctx.lineDash, this.lineDashOffset = this.ctx.lineDashOffset);
  }, p.prototype.toDataURL = function() {
    throw new Error("toDataUrl not implemented.");
  };
  var w = function(F) {
    var O, M, q, X;
    if (F.isCanvasGradient === !0 && (F = F.getColor()), !F) return { r: 0, g: 0, b: 0, a: 0, style: F };
    if (/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/.test(F)) O = 0, M = 0, q = 0, X = 0;
    else {
      var eA = /rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/.exec(F);
      if (eA !== null) O = parseInt(eA[1]), M = parseInt(eA[2]), q = parseInt(eA[3]), X = 1;
      else if ((eA = /rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d.]+)\s*\)/.exec(F)) !== null) O = parseInt(eA[1]), M = parseInt(eA[2]), q = parseInt(eA[3]), X = parseFloat(eA[4]);
      else {
        if (X = 1, typeof F == "string" && F.charAt(0) !== "#") {
          var lA = new q1(F);
          F = lA.ok ? lA.toHex() : "#000000";
        }
        F.length === 4 ? (O = F.substring(1, 2), O += O, M = F.substring(2, 3), M += M, q = F.substring(3, 4), q += q) : (O = F.substring(1, 3), M = F.substring(3, 5), q = F.substring(5, 7)), O = parseInt(O, 16), M = parseInt(M, 16), q = parseInt(q, 16);
      }
    }
    return { r: O, g: M, b: q, a: X, style: F };
  }, d = function() {
    return this.ctx.isFillTransparent || this.globalAlpha == 0;
  }, y = function() {
    return !!(this.ctx.isStrokeTransparent || this.globalAlpha == 0);
  };
  p.prototype.fillText = function(F, O, M, q) {
    if (isNaN(O) || isNaN(M) || typeof F != "string") throw Se.error("jsPDF.context2d.fillText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillText");
    if (q = isNaN(q) ? void 0 : q, !d.call(this)) {
      var X = tA(this.ctx.transform.rotation), eA = this.ctx.transform.scaleX;
      I.call(this, { text: F, x: O, y: M, scale: eA, angle: X, align: this.textAlign, maxWidth: q });
    }
  }, p.prototype.strokeText = function(F, O, M, q) {
    if (isNaN(O) || isNaN(M) || typeof F != "string") throw Se.error("jsPDF.context2d.strokeText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeText");
    if (!y.call(this)) {
      q = isNaN(q) ? void 0 : q;
      var X = tA(this.ctx.transform.rotation), eA = this.ctx.transform.scaleX;
      I.call(this, { text: F, x: O, y: M, scale: eA, renderingMode: "stroke", angle: X, align: this.textAlign, maxWidth: q });
    }
  }, p.prototype.measureText = function(F) {
    if (typeof F != "string") throw Se.error("jsPDF.context2d.measureText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.measureText");
    var O = this.pdf, M = this.pdf.internal.scaleFactor, q = O.internal.getFontSize(), X = O.getStringUnitWidth(F) * q / O.internal.scaleFactor;
    return new function(eA) {
      var lA = (eA = eA || {}).width || 0;
      return Object.defineProperty(this, "width", { get: function() {
        return lA;
      } }), this;
    }({ width: X *= Math.round(96 * M / 72 * 1e4) / 1e4 });
  }, p.prototype.scale = function(F, O) {
    if (isNaN(F) || isNaN(O)) throw Se.error("jsPDF.context2d.scale: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.scale");
    var M = new c(F, 0, 0, O, 0, 0);
    this.ctx.transform = this.ctx.transform.multiply(M);
  }, p.prototype.rotate = function(F) {
    if (isNaN(F)) throw Se.error("jsPDF.context2d.rotate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rotate");
    var O = new c(Math.cos(F), Math.sin(F), -Math.sin(F), Math.cos(F), 0, 0);
    this.ctx.transform = this.ctx.transform.multiply(O);
  }, p.prototype.translate = function(F, O) {
    if (isNaN(F) || isNaN(O)) throw Se.error("jsPDF.context2d.translate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.translate");
    var M = new c(1, 0, 0, 1, F, O);
    this.ctx.transform = this.ctx.transform.multiply(M);
  }, p.prototype.transform = function(F, O, M, q, X, eA) {
    if (isNaN(F) || isNaN(O) || isNaN(M) || isNaN(q) || isNaN(X) || isNaN(eA)) throw Se.error("jsPDF.context2d.transform: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.transform");
    var lA = new c(F, O, M, q, X, eA);
    this.ctx.transform = this.ctx.transform.multiply(lA);
  }, p.prototype.setTransform = function(F, O, M, q, X, eA) {
    F = isNaN(F) ? 1 : F, O = isNaN(O) ? 0 : O, M = isNaN(M) ? 0 : M, q = isNaN(q) ? 1 : q, X = isNaN(X) ? 0 : X, eA = isNaN(eA) ? 0 : eA, this.ctx.transform = new c(F, O, M, q, X, eA);
  };
  var b = function() {
    return this.margin[0] > 0 || this.margin[1] > 0 || this.margin[2] > 0 || this.margin[3] > 0;
  };
  p.prototype.drawImage = function(F, O, M, q, X, eA, lA, uA, gA) {
    var FA = this.pdf.getImageProperties(F), LA = 1, yA = 1, KA = 1, H = 1;
    q !== void 0 && uA !== void 0 && (KA = uA / q, H = gA / X, LA = FA.width / q * uA / q, yA = FA.height / X * gA / X), eA === void 0 && (eA = O, lA = M, O = 0, M = 0), q !== void 0 && uA === void 0 && (uA = q, gA = X), q === void 0 && uA === void 0 && (uA = FA.width, gA = FA.height);
    var bA = this.ctx.transform.decompose(), se = tA(bA.rotate.shx), jA = new c(), CA = (jA = (jA = (jA = jA.multiply(bA.translate)).multiply(bA.skew)).multiply(bA.scale)).applyToRectangle(new s(eA - O * KA, lA - M * H, q * LA, X * yA));
    if (this.autoPaging) {
      for (var qA, SA = S.call(this, CA), VA = [], RA = 0; RA < SA.length; RA += 1) VA.indexOf(SA[RA]) === -1 && VA.push(SA[RA]);
      G(VA);
      for (var Ce = VA[0], ue = VA[VA.length - 1], Ae = Ce; Ae < ue + 1; Ae++) {
        this.pdf.setPage(Ae);
        var Be = this.pdf.internal.pageSize.width - this.margin[3] - this.margin[1], fe = Ae === 1 ? this.posY + this.margin[0] : this.margin[0], TA = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], re = this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2], MA = Ae === 1 ? 0 : TA + (Ae - 2) * re;
        if (this.ctx.clip_path.length !== 0) {
          var We = this.path;
          qA = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = P(qA, this.posX + this.margin[3], -MA + fe + this.ctx.prevPageLastElemOffset), Y.call(this, "fill", !0), this.path = We;
        }
        var pe = JSON.parse(JSON.stringify(CA));
        pe = P([pe], this.posX + this.margin[3], -MA + fe + this.ctx.prevPageLastElemOffset)[0];
        var oe = (Ae > Ce || Ae < ue) && b.call(this);
        oe && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], Be, re, null).clip().discardPath()), this.pdf.addImage(F, "JPEG", pe.x, pe.y, pe.w, pe.h, null, null, se), oe && this.pdf.restoreGraphicsState();
      }
    } else this.pdf.addImage(F, "JPEG", CA.x, CA.y, CA.w, CA.h, null, null, se);
  };
  var S = function(F, O, M) {
    var q = [];
    O = O || this.pdf.internal.pageSize.width, M = M || this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2];
    var X = this.posY + this.ctx.prevPageLastElemOffset;
    switch (F.type) {
      default:
      case "mt":
      case "lt":
        q.push(Math.floor((F.y + X) / M) + 1);
        break;
      case "arc":
        q.push(Math.floor((F.y + X - F.radius) / M) + 1), q.push(Math.floor((F.y + X + F.radius) / M) + 1);
        break;
      case "qct":
        var eA = cA(this.ctx.lastPoint.x, this.ctx.lastPoint.y, F.x1, F.y1, F.x, F.y);
        q.push(Math.floor((eA.y + X) / M) + 1), q.push(Math.floor((eA.y + eA.h + X) / M) + 1);
        break;
      case "bct":
        var lA = QA(this.ctx.lastPoint.x, this.ctx.lastPoint.y, F.x1, F.y1, F.x2, F.y2, F.x, F.y);
        q.push(Math.floor((lA.y + X) / M) + 1), q.push(Math.floor((lA.y + lA.h + X) / M) + 1);
        break;
      case "rect":
        q.push(Math.floor((F.y + X) / M) + 1), q.push(Math.floor((F.y + F.h + X) / M) + 1);
    }
    for (var uA = 0; uA < q.length; uA += 1) for (; this.pdf.internal.getNumberOfPages() < q[uA]; ) Q.call(this);
    return q;
  }, Q = function() {
    var F = this.fillStyle, O = this.strokeStyle, M = this.font, q = this.lineCap, X = this.lineWidth, eA = this.lineJoin;
    this.pdf.addPage(), this.fillStyle = F, this.strokeStyle = O, this.font = M, this.lineCap = q, this.lineWidth = X, this.lineJoin = eA;
  }, P = function(F, O, M) {
    for (var q = 0; q < F.length; q++) switch (F[q].type) {
      case "bct":
        F[q].x2 += O, F[q].y2 += M;
      case "qct":
        F[q].x1 += O, F[q].y1 += M;
      default:
        F[q].x += O, F[q].y += M;
    }
    return F;
  }, G = function(F) {
    return F.sort(function(O, M) {
      return O - M;
    });
  }, k = function(F, O) {
    var M = this.fillStyle, q = this.strokeStyle, X = this.lineCap, eA = this.lineWidth, lA = Math.abs(eA * this.ctx.transform.scaleX), uA = this.lineJoin;
    if (this.autoPaging) {
      for (var gA, FA, LA = JSON.parse(JSON.stringify(this.path)), yA = JSON.parse(JSON.stringify(this.path)), KA = [], H = 0; H < yA.length; H++) if (yA[H].x !== void 0) for (var bA = S.call(this, yA[H]), se = 0; se < bA.length; se += 1) KA.indexOf(bA[se]) === -1 && KA.push(bA[se]);
      for (var jA = 0; jA < KA.length; jA++) for (; this.pdf.internal.getNumberOfPages() < KA[jA]; ) Q.call(this);
      G(KA);
      for (var CA = KA[0], qA = KA[KA.length - 1], SA = CA; SA < qA + 1; SA++) {
        this.pdf.setPage(SA), this.fillStyle = M, this.strokeStyle = q, this.lineCap = X, this.lineWidth = lA, this.lineJoin = uA;
        var VA = this.pdf.internal.pageSize.width - this.margin[3] - this.margin[1], RA = SA === 1 ? this.posY + this.margin[0] : this.margin[0], Ce = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], ue = this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2], Ae = SA === 1 ? 0 : Ce + (SA - 2) * ue;
        if (this.ctx.clip_path.length !== 0) {
          var Be = this.path;
          gA = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = P(gA, this.posX + this.margin[3], -Ae + RA + this.ctx.prevPageLastElemOffset), Y.call(this, F, !0), this.path = Be;
        }
        if (FA = JSON.parse(JSON.stringify(LA)), this.path = P(FA, this.posX + this.margin[3], -Ae + RA + this.ctx.prevPageLastElemOffset), O === !1 || SA === 0) {
          var fe = (SA > CA || SA < qA) && b.call(this);
          fe && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], VA, ue, null).clip().discardPath()), Y.call(this, F, O), fe && this.pdf.restoreGraphicsState();
        }
        this.lineWidth = eA;
      }
      this.path = LA;
    } else this.lineWidth = lA, Y.call(this, F, O), this.lineWidth = eA;
  }, Y = function(F, O) {
    if ((F !== "stroke" || O || !y.call(this)) && (F === "stroke" || O || !d.call(this))) {
      for (var M, q, X = [], eA = this.path, lA = 0; lA < eA.length; lA++) {
        var uA = eA[lA];
        switch (uA.type) {
          case "begin":
            X.push({ begin: !0 });
            break;
          case "close":
            X.push({ close: !0 });
            break;
          case "mt":
            X.push({ start: uA, deltas: [], abs: [] });
            break;
          case "lt":
            var gA = X.length;
            if (eA[lA - 1] && !isNaN(eA[lA - 1].x) && (M = [uA.x - eA[lA - 1].x, uA.y - eA[lA - 1].y], gA > 0)) {
              for (; gA >= 0; gA--) if (X[gA - 1].close !== !0 && X[gA - 1].begin !== !0) {
                X[gA - 1].deltas.push(M), X[gA - 1].abs.push(uA);
                break;
              }
            }
            break;
          case "bct":
            M = [uA.x1 - eA[lA - 1].x, uA.y1 - eA[lA - 1].y, uA.x2 - eA[lA - 1].x, uA.y2 - eA[lA - 1].y, uA.x - eA[lA - 1].x, uA.y - eA[lA - 1].y], X[X.length - 1].deltas.push(M);
            break;
          case "qct":
            var FA = eA[lA - 1].x + 2 / 3 * (uA.x1 - eA[lA - 1].x), LA = eA[lA - 1].y + 2 / 3 * (uA.y1 - eA[lA - 1].y), yA = uA.x + 2 / 3 * (uA.x1 - uA.x), KA = uA.y + 2 / 3 * (uA.y1 - uA.y), H = uA.x, bA = uA.y;
            M = [FA - eA[lA - 1].x, LA - eA[lA - 1].y, yA - eA[lA - 1].x, KA - eA[lA - 1].y, H - eA[lA - 1].x, bA - eA[lA - 1].y], X[X.length - 1].deltas.push(M);
            break;
          case "arc":
            X.push({ deltas: [], abs: [], arc: !0 }), Array.isArray(X[X.length - 1].abs) && X[X.length - 1].abs.push(uA);
        }
      }
      q = O ? null : F === "stroke" ? "stroke" : "fill";
      for (var se = !1, jA = 0; jA < X.length; jA++) if (X[jA].arc) for (var CA = X[jA].abs, qA = 0; qA < CA.length; qA++) {
        var SA = CA[qA];
        SA.type === "arc" ? j.call(this, SA.x, SA.y, SA.radius, SA.startAngle, SA.endAngle, SA.counterclockwise, void 0, O, !se) : K.call(this, SA.x, SA.y), se = !0;
      }
      else if (X[jA].close === !0) this.pdf.internal.out("h"), se = !1;
      else if (X[jA].begin !== !0) {
        var VA = X[jA].start.x, RA = X[jA].start.y;
        R.call(this, X[jA].deltas, VA, RA), se = !0;
      }
      q && N.call(this, q), O && Z.call(this);
    }
  }, z = function(F) {
    var O = this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor, M = O * (this.pdf.internal.getLineHeightFactor() - 1);
    switch (this.ctx.textBaseline) {
      case "bottom":
        return F - M;
      case "top":
        return F + O - M;
      case "hanging":
        return F + O - 2 * M;
      case "middle":
        return F + O / 2 - M;
      default:
        return F;
    }
  }, iA = function(F) {
    return F + this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor * (this.pdf.internal.getLineHeightFactor() - 1);
  };
  p.prototype.createLinearGradient = function() {
    var F = function() {
    };
    return F.colorStops = [], F.addColorStop = function(O, M) {
      this.colorStops.push([O, M]);
    }, F.getColor = function() {
      return this.colorStops.length === 0 ? "#000000" : this.colorStops[0][1];
    }, F.isCanvasGradient = !0, F;
  }, p.prototype.createPattern = function() {
    return this.createLinearGradient();
  }, p.prototype.createRadialGradient = function() {
    return this.createLinearGradient();
  };
  var j = function(F, O, M, q, X, eA, lA, uA, gA) {
    for (var FA = sA.call(this, M, q, X, eA), LA = 0; LA < FA.length; LA++) {
      var yA = FA[LA];
      LA === 0 && (gA ? E.call(this, yA.x1 + F, yA.y1 + O) : K.call(this, yA.x1 + F, yA.y1 + O)), aA.call(this, F, O, yA.x2, yA.y2, yA.x3, yA.y3, yA.x4, yA.y4);
    }
    uA ? Z.call(this) : N.call(this, lA);
  }, N = function(F) {
    switch (F) {
      case "stroke":
        this.pdf.internal.out("S");
        break;
      case "fill":
        this.pdf.internal.out("f");
    }
  }, Z = function() {
    this.pdf.clip(), this.pdf.discardPath();
  }, E = function(F, O) {
    this.pdf.internal.out(e(F) + " " + r(O) + " m");
  }, I = function(F) {
    var O;
    switch (F.align) {
      case "right":
      case "end":
        O = "right";
        break;
      case "center":
        O = "center";
        break;
      default:
        O = "left";
    }
    var M, q, X, eA = this.pdf.getTextDimensions(F.text), lA = z.call(this, F.y), uA = iA.call(this, lA) - eA.h, gA = this.ctx.transform.applyToPoint(new o(F.x, lA));
    if (this.autoPaging) {
      var FA = this.ctx.transform.decompose(), LA = new c();
      LA = (LA = (LA = LA.multiply(FA.translate)).multiply(FA.skew)).multiply(FA.scale);
      for (var yA = this.ctx.transform.applyToRectangle(new s(F.x, lA, eA.w, eA.h)), KA = LA.applyToRectangle(new s(F.x, uA, eA.w, eA.h)), H = S.call(this, KA), bA = [], se = 0; se < H.length; se += 1) bA.indexOf(H[se]) === -1 && bA.push(H[se]);
      G(bA);
      for (var jA = bA[0], CA = bA[bA.length - 1], qA = jA; qA < CA + 1; qA++) {
        this.pdf.setPage(qA);
        var SA = qA === 1 ? this.posY + this.margin[0] : this.margin[0], VA = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], RA = this.pdf.internal.pageSize.height - this.margin[2], Ce = RA - this.margin[0], ue = this.pdf.internal.pageSize.width - this.margin[1], Ae = ue - this.margin[3], Be = qA === 1 ? 0 : VA + (qA - 2) * Ce;
        if (this.ctx.clip_path.length !== 0) {
          var fe = this.path;
          M = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = P(M, this.posX + this.margin[3], -1 * Be + SA), Y.call(this, "fill", !0), this.path = fe;
        }
        var TA = P([JSON.parse(JSON.stringify(KA))], this.posX + this.margin[3], -Be + SA + this.ctx.prevPageLastElemOffset)[0];
        F.scale >= 0.01 && (q = this.pdf.internal.getFontSize(), this.pdf.setFontSize(q * F.scale), X = this.lineWidth, this.lineWidth = X * F.scale);
        var re = this.autoPaging !== "text";
        if (re || TA.y + TA.h <= RA) {
          if (re || TA.y >= SA && TA.x <= ue) {
            var MA = re ? F.text : this.pdf.splitTextToSize(F.text, F.maxWidth || ue - TA.x)[0], We = P([JSON.parse(JSON.stringify(yA))], this.posX + this.margin[3], -Be + SA + this.ctx.prevPageLastElemOffset)[0], pe = re && (qA > jA || qA < CA) && b.call(this);
            pe && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], Ae, Ce, null).clip().discardPath()), this.pdf.text(MA, We.x, We.y, { angle: F.angle, align: O, renderingMode: F.renderingMode }), pe && this.pdf.restoreGraphicsState();
          }
        } else TA.y < RA && (this.ctx.prevPageLastElemOffset += RA - TA.y);
        F.scale >= 0.01 && (this.pdf.setFontSize(q), this.lineWidth = X);
      }
    } else F.scale >= 0.01 && (q = this.pdf.internal.getFontSize(), this.pdf.setFontSize(q * F.scale), X = this.lineWidth, this.lineWidth = X * F.scale), this.pdf.text(F.text, gA.x + this.posX, gA.y + this.posY, { angle: F.angle, align: O, renderingMode: F.renderingMode, maxWidth: F.maxWidth }), F.scale >= 0.01 && (this.pdf.setFontSize(q), this.lineWidth = X);
  }, K = function(F, O, M, q) {
    M = M || 0, q = q || 0, this.pdf.internal.out(e(F + M) + " " + r(O + q) + " l");
  }, R = function(F, O, M) {
    return this.pdf.lines(F, O, M, null, null);
  }, aA = function(F, O, M, q, X, eA, lA, uA) {
    this.pdf.internal.out([A(n(M + F)), A(i(q + O)), A(n(X + F)), A(i(eA + O)), A(n(lA + F)), A(i(uA + O)), "c"].join(" "));
  }, sA = function(F, O, M, q) {
    for (var X = 2 * Math.PI, eA = Math.PI / 2; O > M; ) O -= X;
    var lA = Math.abs(M - O);
    lA < X && q && (lA = X - lA);
    for (var uA = [], gA = q ? -1 : 1, FA = O; lA > 1e-5; ) {
      var LA = FA + gA * Math.min(lA, eA);
      uA.push(oA.call(this, F, FA, LA)), lA -= Math.abs(LA - FA), FA = LA;
    }
    return uA;
  }, oA = function(F, O, M) {
    var q = (M - O) / 2, X = F * Math.cos(q), eA = F * Math.sin(q), lA = X, uA = -eA, gA = lA * lA + uA * uA, FA = gA + lA * X + uA * eA, LA = 4 / 3 * (Math.sqrt(2 * gA * FA) - FA) / (lA * eA - uA * X), yA = lA - LA * uA, KA = uA + LA * lA, H = yA, bA = -KA, se = q + O, jA = Math.cos(se), CA = Math.sin(se);
    return { x1: F * Math.cos(O), y1: F * Math.sin(O), x2: yA * jA - KA * CA, y2: yA * CA + KA * jA, x3: H * jA - bA * CA, y3: H * CA + bA * jA, x4: F * Math.cos(M), y4: F * Math.sin(M) };
  }, tA = function(F) {
    return 180 * F / Math.PI;
  }, cA = function(F, O, M, q, X, eA) {
    var lA = F + 0.5 * (M - F), uA = O + 0.5 * (q - O), gA = X + 0.5 * (M - X), FA = eA + 0.5 * (q - eA), LA = Math.min(F, X, lA, gA), yA = Math.max(F, X, lA, gA), KA = Math.min(O, eA, uA, FA), H = Math.max(O, eA, uA, FA);
    return new s(LA, KA, yA - LA, H - KA);
  }, QA = function(F, O, M, q, X, eA, lA, uA) {
    var gA, FA, LA, yA, KA, H, bA, se, jA, CA, qA, SA, VA, RA, Ce = M - F, ue = q - O, Ae = X - M, Be = eA - q, fe = lA - X, TA = uA - eA;
    for (FA = 0; FA < 41; FA++) jA = (bA = (LA = F + (gA = FA / 40) * Ce) + gA * ((KA = M + gA * Ae) - LA)) + gA * (KA + gA * (X + gA * fe - KA) - bA), CA = (se = (yA = O + gA * ue) + gA * ((H = q + gA * Be) - yA)) + gA * (H + gA * (eA + gA * TA - H) - se), FA == 0 ? (qA = jA, SA = CA, VA = jA, RA = CA) : (qA = Math.min(qA, jA), SA = Math.min(SA, CA), VA = Math.max(VA, jA), RA = Math.max(RA, CA));
    return new s(Math.round(qA), Math.round(SA), Math.round(VA - qA), Math.round(RA - SA));
  }, pA = function() {
    if (this.prevLineDash || this.ctx.lineDash.length || this.ctx.lineDashOffset) {
      var F, O, M = (F = this.ctx.lineDash, O = this.ctx.lineDashOffset, JSON.stringify({ lineDash: F, lineDashOffset: O }));
      this.prevLineDash !== M && (this.pdf.setLineDash(this.ctx.lineDash, this.ctx.lineDashOffset), this.prevLineDash = M);
    }
  };
})(PA.API), /**
 * @license
 * jsPDF filters PlugIn
 * Copyright (c) 2014 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(t) {
  var A = function(o) {
    var s, c, u, h, p, w, d, y, b, S;
    for (c = [], u = 0, h = (o += s = "\0\0\0\0".slice(o.length % 4 || 4)).length; h > u; u += 4) (p = (o.charCodeAt(u) << 24) + (o.charCodeAt(u + 1) << 16) + (o.charCodeAt(u + 2) << 8) + o.charCodeAt(u + 3)) !== 0 ? (w = (p = ((p = ((p = ((p = (p - (S = p % 85)) / 85) - (b = p % 85)) / 85) - (y = p % 85)) / 85) - (d = p % 85)) / 85) % 85, c.push(w + 33, d + 33, y + 33, b + 33, S + 33)) : c.push(122);
    return (function(Q, P) {
      for (var G = P; G > 0; G--) Q.pop();
    })(c, s.length), String.fromCharCode.apply(String, c) + "~>";
  }, e = function(o) {
    var s, c, u, h, p, w = String, d = "length", y = 255, b = "charCodeAt", S = "slice", Q = "replace";
    for (o[S](-2), o = o[S](0, -2)[Q](/\s/g, "")[Q]("z", "!!!!!"), u = [], h = 0, p = (o += s = "uuuuu"[S](o[d] % 5 || 5))[d]; p > h; h += 5) c = 52200625 * (o[b](h) - 33) + 614125 * (o[b](h + 1) - 33) + 7225 * (o[b](h + 2) - 33) + 85 * (o[b](h + 3) - 33) + (o[b](h + 4) - 33), u.push(y & c >> 24, y & c >> 16, y & c >> 8, y & c);
    return (function(P, G) {
      for (var k = G; k > 0; k--) P.pop();
    })(u, s[d]), w.fromCharCode.apply(w, u);
  }, r = function(o) {
    return o.split("").map(function(s) {
      return ("0" + s.charCodeAt().toString(16)).slice(-2);
    }).join("") + ">";
  }, n = function(o) {
    var s = new RegExp(/^([0-9A-Fa-f]{2})+$/);
    if ((o = o.replace(/\s/g, "")).indexOf(">") !== -1 && (o = o.substr(0, o.indexOf(">"))), o.length % 2 && (o += "0"), s.test(o) === !1) return "";
    for (var c = "", u = 0; u < o.length; u += 2) c += String.fromCharCode("0x" + (o[u] + o[u + 1]));
    return c;
  }, i = function(o) {
    for (var s = new Uint8Array(o.length), c = o.length; c--; ) s[c] = o.charCodeAt(c);
    return (s = Wl(s)).reduce(function(u, h) {
      return u + String.fromCharCode(h);
    }, "");
  };
  t.processDataByFilters = function(o, s) {
    var c = 0, u = o || "", h = [];
    for (typeof (s = s || []) == "string" && (s = [s]), c = 0; c < s.length; c += 1) switch (s[c]) {
      case "ASCII85Decode":
      case "/ASCII85Decode":
        u = e(u), h.push("/ASCII85Encode");
        break;
      case "ASCII85Encode":
      case "/ASCII85Encode":
        u = A(u), h.push("/ASCII85Decode");
        break;
      case "ASCIIHexDecode":
      case "/ASCIIHexDecode":
        u = n(u), h.push("/ASCIIHexEncode");
        break;
      case "ASCIIHexEncode":
      case "/ASCIIHexEncode":
        u = r(u), h.push("/ASCIIHexDecode");
        break;
      case "FlateEncode":
      case "/FlateEncode":
        u = i(u), h.push("/FlateDecode");
        break;
      default:
        throw new Error('The filter: "' + s[c] + '" is not implemented');
    }
    return { data: u, reverseChain: h.reverse().join(" ") };
  };
})(PA.API), /**
 * @license
 * jsPDF fileloading PlugIn
 * Copyright (c) 2018 Aras Abbasi (aras.abbasi@gmail.com)
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(t) {
  t.loadFile = function(A, e, r) {
    return (function(n, i, o) {
      i = i !== !1, o = typeof o == "function" ? o : function() {
      };
      var s = void 0;
      try {
        s = (function(c, u, h) {
          var p = new XMLHttpRequest(), w = 0, d = function(y) {
            var b = y.length, S = [], Q = String.fromCharCode;
            for (w = 0; w < b; w += 1) S.push(Q(255 & y.charCodeAt(w)));
            return S.join("");
          };
          if (p.open("GET", c, !u), p.overrideMimeType("text/plain; charset=x-user-defined"), u === !1 && (p.onload = function() {
            p.status === 200 ? h(d(this.responseText)) : h(void 0);
          }), p.send(null), u && p.status === 200) return d(p.responseText);
        })(n, i, o);
      } catch {
      }
      return s;
    })(A, e, r);
  }, t.loadImageFile = t.loadFile;
})(PA.API), (function(t) {
  function A() {
    return (YA.html2canvas ? Promise.resolve(YA.html2canvas) : Promise.resolve().then(() => B5)).catch(function(s) {
      return Promise.reject(new Error("Could not load html2canvas: " + s));
    }).then(function(s) {
      return s.default ? s.default : s;
    });
  }
  function e() {
    return (YA.DOMPurify ? Promise.resolve(YA.DOMPurify) : import("dompurify")).catch(function(s) {
      return Promise.reject(new Error("Could not load dompurify: " + s));
    }).then(function(s) {
      return s.default ? s.default : s;
    });
  }
  var r = function(s) {
    var c = Ee(s);
    return c === "undefined" ? "undefined" : c === "string" || s instanceof String ? "string" : c === "number" || s instanceof Number ? "number" : c === "function" || s instanceof Function ? "function" : s && s.constructor === Array ? "array" : s && s.nodeType === 1 ? "element" : c === "object" ? "object" : "unknown";
  }, n = function(s, c) {
    var u = document.createElement(s);
    for (var h in c.className && (u.className = c.className), c.innerHTML && c.dompurify && (u.innerHTML = c.dompurify.sanitize(c.innerHTML)), c.style) u.style[h] = c.style[h];
    return u;
  }, i = function s(c, u) {
    for (var h = c.nodeType === 3 ? document.createTextNode(c.nodeValue) : c.cloneNode(!1), p = c.firstChild; p; p = p.nextSibling) u !== !0 && p.nodeType === 1 && p.nodeName === "SCRIPT" || h.appendChild(s(p, u));
    return c.nodeType === 1 && (c.nodeName === "CANVAS" ? (h.width = c.width, h.height = c.height, h.getContext("2d").drawImage(c, 0, 0)) : c.nodeName !== "TEXTAREA" && c.nodeName !== "SELECT" || (h.value = c.value), h.addEventListener("load", function() {
      h.scrollTop = c.scrollTop, h.scrollLeft = c.scrollLeft;
    }, !0)), h;
  }, o = function s(c) {
    var u = Object.assign(s.convert(Promise.resolve()), JSON.parse(JSON.stringify(s.template))), h = s.convert(Promise.resolve(), u);
    return (h = h.setProgress(1, s, 1, [s])).set(c);
  };
  (o.prototype = Object.create(Promise.prototype)).constructor = o, o.convert = function(s, c) {
    return s.__proto__ = c || o.prototype, s;
  }, o.template = { prop: { src: null, container: null, overlay: null, canvas: null, img: null, pdf: null, pageSize: null, callback: function() {
  } }, progress: { val: 0, state: null, n: 0, stack: [] }, opt: { filename: "file.pdf", margin: [0, 0, 0, 0], enableLinks: !0, x: 0, y: 0, html2canvas: {}, jsPDF: {}, backgroundColor: "transparent" } }, o.prototype.from = function(s, c) {
    return this.then(function() {
      switch (c = c || (function(u) {
        switch (r(u)) {
          case "string":
            return "string";
          case "element":
            return u.nodeName.toLowerCase() === "canvas" ? "canvas" : "element";
          default:
            return "unknown";
        }
      })(s), c) {
        case "string":
          return this.then(e).then(function(u) {
            return this.set({ src: n("div", { innerHTML: s, dompurify: u }) });
          });
        case "element":
          return this.set({ src: s });
        case "canvas":
          return this.set({ canvas: s });
        case "img":
          return this.set({ img: s });
        default:
          return this.error("Unknown source type.");
      }
    });
  }, o.prototype.to = function(s) {
    switch (s) {
      case "container":
        return this.toContainer();
      case "canvas":
        return this.toCanvas();
      case "img":
        return this.toImg();
      case "pdf":
        return this.toPdf();
      default:
        return this.error("Invalid target.");
    }
  }, o.prototype.toContainer = function() {
    return this.thenList([function() {
      return this.prop.src || this.error("Cannot duplicate - no source HTML.");
    }, function() {
      return this.prop.pageSize || this.setPageSize();
    }]).then(function() {
      var s = { position: "relative", display: "inline-block", width: (typeof this.opt.width != "number" || isNaN(this.opt.width) || typeof this.opt.windowWidth != "number" || isNaN(this.opt.windowWidth) ? Math.max(this.prop.src.clientWidth, this.prop.src.scrollWidth, this.prop.src.offsetWidth) : this.opt.windowWidth) + "px", left: 0, right: 0, top: 0, margin: "auto", backgroundColor: this.opt.backgroundColor }, c = i(this.prop.src, this.opt.html2canvas.javascriptEnabled);
      c.tagName === "BODY" && (s.height = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) + "px"), this.prop.overlay = n("div", { className: "html2pdf__overlay", style: { position: "fixed", overflow: "hidden", zIndex: 1e3, left: "-100000px", right: 0, bottom: 0, top: 0 } }), this.prop.container = n("div", { className: "html2pdf__container", style: s }), this.prop.container.appendChild(c), this.prop.container.firstChild.appendChild(n("div", { style: { clear: "both", border: "0 none transparent", margin: 0, padding: 0, height: 0 } })), this.prop.container.style.float = "none", this.prop.overlay.appendChild(this.prop.container), document.body.appendChild(this.prop.overlay), this.prop.container.firstChild.style.position = "relative", this.prop.container.height = Math.max(this.prop.container.firstChild.clientHeight, this.prop.container.firstChild.scrollHeight, this.prop.container.firstChild.offsetHeight) + "px";
    });
  }, o.prototype.toCanvas = function() {
    var s = [function() {
      return document.body.contains(this.prop.container) || this.toContainer();
    }];
    return this.thenList(s).then(A).then(function(c) {
      var u = Object.assign({}, this.opt.html2canvas);
      return delete u.onrendered, c(this.prop.container, u);
    }).then(function(c) {
      (this.opt.html2canvas.onrendered || function() {
      })(c), this.prop.canvas = c, document.body.removeChild(this.prop.overlay);
    });
  }, o.prototype.toContext2d = function() {
    var s = [function() {
      return document.body.contains(this.prop.container) || this.toContainer();
    }];
    return this.thenList(s).then(A).then(function(c) {
      var u = this.opt.jsPDF, h = this.opt.fontFaces, p = typeof this.opt.width != "number" || isNaN(this.opt.width) || typeof this.opt.windowWidth != "number" || isNaN(this.opt.windowWidth) ? 1 : this.opt.width / this.opt.windowWidth, w = Object.assign({ async: !0, allowTaint: !0, scale: p, scrollX: this.opt.scrollX || 0, scrollY: this.opt.scrollY || 0, backgroundColor: "#ffffff", imageTimeout: 15e3, logging: !0, proxy: null, removeContainer: !0, foreignObjectRendering: !1, useCORS: !1 }, this.opt.html2canvas);
      if (delete w.onrendered, u.context2d.autoPaging = this.opt.autoPaging === void 0 || this.opt.autoPaging, u.context2d.posX = this.opt.x, u.context2d.posY = this.opt.y, u.context2d.margin = this.opt.margin, u.context2d.fontFaces = h, h) for (var d = 0; d < h.length; ++d) {
        var y = h[d], b = y.src.find(function(S) {
          return S.format === "truetype";
        });
        b && u.addFont(b.url, y.ref.name, y.ref.style);
      }
      return w.windowHeight = w.windowHeight || 0, w.windowHeight = w.windowHeight == 0 ? Math.max(this.prop.container.clientHeight, this.prop.container.scrollHeight, this.prop.container.offsetHeight) : w.windowHeight, u.context2d.save(!0), c(this.prop.container, w);
    }).then(function(c) {
      this.opt.jsPDF.context2d.restore(!0), (this.opt.html2canvas.onrendered || function() {
      })(c), this.prop.canvas = c, document.body.removeChild(this.prop.overlay);
    });
  }, o.prototype.toImg = function() {
    return this.thenList([function() {
      return this.prop.canvas || this.toCanvas();
    }]).then(function() {
      var s = this.prop.canvas.toDataURL("image/" + this.opt.image.type, this.opt.image.quality);
      this.prop.img = document.createElement("img"), this.prop.img.src = s;
    });
  }, o.prototype.toPdf = function() {
    return this.thenList([function() {
      return this.toContext2d();
    }]).then(function() {
      this.prop.pdf = this.prop.pdf || this.opt.jsPDF;
    });
  }, o.prototype.output = function(s, c, u) {
    return (u = u || "pdf").toLowerCase() === "img" || u.toLowerCase() === "image" ? this.outputImg(s, c) : this.outputPdf(s, c);
  }, o.prototype.outputPdf = function(s, c) {
    return this.thenList([function() {
      return this.prop.pdf || this.toPdf();
    }]).then(function() {
      return this.prop.pdf.output(s, c);
    });
  }, o.prototype.outputImg = function(s) {
    return this.thenList([function() {
      return this.prop.img || this.toImg();
    }]).then(function() {
      switch (s) {
        case void 0:
        case "img":
          return this.prop.img;
        case "datauristring":
        case "dataurlstring":
          return this.prop.img.src;
        case "datauri":
        case "dataurl":
          return document.location.href = this.prop.img.src;
        default:
          throw 'Image output type "' + s + '" is not supported.';
      }
    });
  }, o.prototype.save = function(s) {
    return this.thenList([function() {
      return this.prop.pdf || this.toPdf();
    }]).set(s ? { filename: s } : null).then(function() {
      this.prop.pdf.save(this.opt.filename);
    });
  }, o.prototype.doCallback = function() {
    return this.thenList([function() {
      return this.prop.pdf || this.toPdf();
    }]).then(function() {
      this.prop.callback(this.prop.pdf);
    });
  }, o.prototype.set = function(s) {
    if (r(s) !== "object") return this;
    var c = Object.keys(s || {}).map(function(u) {
      if (u in o.template.prop) return function() {
        this.prop[u] = s[u];
      };
      switch (u) {
        case "margin":
          return this.setMargin.bind(this, s.margin);
        case "jsPDF":
          return function() {
            return this.opt.jsPDF = s.jsPDF, this.setPageSize();
          };
        case "pageSize":
          return this.setPageSize.bind(this, s.pageSize);
        default:
          return function() {
            this.opt[u] = s[u];
          };
      }
    }, this);
    return this.then(function() {
      return this.thenList(c);
    });
  }, o.prototype.get = function(s, c) {
    return this.then(function() {
      var u = s in o.template.prop ? this.prop[s] : this.opt[s];
      return c ? c(u) : u;
    });
  }, o.prototype.setMargin = function(s) {
    return this.then(function() {
      switch (r(s)) {
        case "number":
          s = [s, s, s, s];
        case "array":
          if (s.length === 2 && (s = [s[0], s[1], s[0], s[1]]), s.length === 4) break;
        default:
          return this.error("Invalid margin array.");
      }
      this.opt.margin = s;
    }).then(this.setPageSize);
  }, o.prototype.setPageSize = function(s) {
    function c(u, h) {
      return Math.floor(u * h / 72 * 96);
    }
    return this.then(function() {
      (s = s || PA.getPageSize(this.opt.jsPDF)).hasOwnProperty("inner") || (s.inner = { width: s.width - this.opt.margin[1] - this.opt.margin[3], height: s.height - this.opt.margin[0] - this.opt.margin[2] }, s.inner.px = { width: c(s.inner.width, s.k), height: c(s.inner.height, s.k) }, s.inner.ratio = s.inner.height / s.inner.width), this.prop.pageSize = s;
    });
  }, o.prototype.setProgress = function(s, c, u, h) {
    return s != null && (this.progress.val = s), c != null && (this.progress.state = c), u != null && (this.progress.n = u), h != null && (this.progress.stack = h), this.progress.ratio = this.progress.val / this.progress.state, this;
  }, o.prototype.updateProgress = function(s, c, u, h) {
    return this.setProgress(s ? this.progress.val + s : null, c || null, u ? this.progress.n + u : null, h ? this.progress.stack.concat(h) : null);
  }, o.prototype.then = function(s, c) {
    var u = this;
    return this.thenCore(s, c, function(h, p) {
      return u.updateProgress(null, null, 1, [h]), Promise.prototype.then.call(this, function(w) {
        return u.updateProgress(null, h), w;
      }).then(h, p).then(function(w) {
        return u.updateProgress(1), w;
      });
    });
  }, o.prototype.thenCore = function(s, c, u) {
    u = u || Promise.prototype.then;
    var h = this;
    s && (s = s.bind(h)), c && (c = c.bind(h));
    var p = Promise.toString().indexOf("[native code]") !== -1 && Promise.name === "Promise" ? h : o.convert(Object.assign({}, h), Promise.prototype), w = u.call(p, s, c);
    return o.convert(w, h.__proto__);
  }, o.prototype.thenExternal = function(s, c) {
    return Promise.prototype.then.call(this, s, c);
  }, o.prototype.thenList = function(s) {
    var c = this;
    return s.forEach(function(u) {
      c = c.thenCore(u);
    }), c;
  }, o.prototype.catch = function(s) {
    s && (s = s.bind(this));
    var c = Promise.prototype.catch.call(this, s);
    return o.convert(c, this);
  }, o.prototype.catchExternal = function(s) {
    return Promise.prototype.catch.call(this, s);
  }, o.prototype.error = function(s) {
    return this.then(function() {
      throw new Error(s);
    });
  }, o.prototype.using = o.prototype.set, o.prototype.saveAs = o.prototype.save, o.prototype.export = o.prototype.output, o.prototype.run = o.prototype.then, PA.getPageSize = function(s, c, u) {
    if (Ee(s) === "object") {
      var h = s;
      s = h.orientation, c = h.unit || c, u = h.format || u;
    }
    c = c || "mm", u = u || "a4", s = ("" + (s || "P")).toLowerCase();
    var p, w = ("" + u).toLowerCase(), d = { a0: [2383.94, 3370.39], a1: [1683.78, 2383.94], a2: [1190.55, 1683.78], a3: [841.89, 1190.55], a4: [595.28, 841.89], a5: [419.53, 595.28], a6: [297.64, 419.53], a7: [209.76, 297.64], a8: [147.4, 209.76], a9: [104.88, 147.4], a10: [73.7, 104.88], b0: [2834.65, 4008.19], b1: [2004.09, 2834.65], b2: [1417.32, 2004.09], b3: [1000.63, 1417.32], b4: [708.66, 1000.63], b5: [498.9, 708.66], b6: [354.33, 498.9], b7: [249.45, 354.33], b8: [175.75, 249.45], b9: [124.72, 175.75], b10: [87.87, 124.72], c0: [2599.37, 3676.54], c1: [1836.85, 2599.37], c2: [1298.27, 1836.85], c3: [918.43, 1298.27], c4: [649.13, 918.43], c5: [459.21, 649.13], c6: [323.15, 459.21], c7: [229.61, 323.15], c8: [161.57, 229.61], c9: [113.39, 161.57], c10: [79.37, 113.39], dl: [311.81, 623.62], letter: [612, 792], "government-letter": [576, 756], legal: [612, 1008], "junior-legal": [576, 360], ledger: [1224, 792], tabloid: [792, 1224], "credit-card": [153, 243] };
    switch (c) {
      case "pt":
        p = 1;
        break;
      case "mm":
        p = 72 / 25.4;
        break;
      case "cm":
        p = 72 / 2.54;
        break;
      case "in":
        p = 72;
        break;
      case "px":
        p = 0.75;
        break;
      case "pc":
      case "em":
        p = 12;
        break;
      case "ex":
        p = 6;
        break;
      default:
        throw "Invalid unit: " + c;
    }
    var y, b = 0, S = 0;
    if (d.hasOwnProperty(w)) b = d[w][1] / p, S = d[w][0] / p;
    else try {
      b = u[1], S = u[0];
    } catch {
      throw new Error("Invalid format: " + u);
    }
    if (s === "p" || s === "portrait") s = "p", S > b && (y = S, S = b, b = y);
    else {
      if (s !== "l" && s !== "landscape") throw "Invalid orientation: " + s;
      s = "l", b > S && (y = S, S = b, b = y);
    }
    return { width: S, height: b, unit: c, k: p, orientation: s };
  }, t.html = function(s, c) {
    (c = c || {}).callback = c.callback || function() {
    }, c.html2canvas = c.html2canvas || {}, c.html2canvas.canvas = c.html2canvas.canvas || this.canvas, c.jsPDF = c.jsPDF || this, c.fontFaces = c.fontFaces ? c.fontFaces.map(pl) : null;
    var u = new o(c);
    return c.worker ? u : u.from(s).doCallback();
  };
})(PA.API), PA.API.addJS = function(t) {
  return zh = t, this.internal.events.subscribe("postPutResources", function() {
    po = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/Names [(EmbeddedJS) " + (po + 1) + " 0 R]"), this.internal.out(">>"), this.internal.out("endobj"), Yh = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /JavaScript"), this.internal.out("/JS (" + zh + ")"), this.internal.out(">>"), this.internal.out("endobj");
  }), this.internal.events.subscribe("putCatalog", function() {
    po !== void 0 && Yh !== void 0 && this.internal.out("/Names <</JavaScript " + po + " 0 R>>");
  }), this;
}, /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(t) {
  var A;
  t.events.push(["postPutResources", function() {
    var e = this, r = /^(\d+) 0 obj$/;
    if (this.outline.root.children.length > 0) for (var n = e.outline.render().split(/\r\n/), i = 0; i < n.length; i++) {
      var o = n[i], s = r.exec(o);
      if (s != null) {
        var c = s[1];
        e.internal.newObjectDeferredBegin(c, !1);
      }
      e.internal.write(o);
    }
    if (this.outline.createNamedDestinations) {
      var u = this.internal.pages.length, h = [];
      for (i = 0; i < u; i++) {
        var p = e.internal.newObject();
        h.push(p);
        var w = e.internal.getPageInfo(i + 1);
        e.internal.write("<< /D[" + w.objId + " 0 R /XYZ null null null]>> endobj");
      }
      var d = e.internal.newObject();
      for (e.internal.write("<< /Names [ "), i = 0; i < h.length; i++) e.internal.write("(page_" + (i + 1) + ")" + h[i] + " 0 R");
      e.internal.write(" ] >>", "endobj"), A = e.internal.newObject(), e.internal.write("<< /Dests " + d + " 0 R"), e.internal.write(">>", "endobj");
    }
  }]), t.events.push(["putCatalog", function() {
    var e = this;
    e.outline.root.children.length > 0 && (e.internal.write("/Outlines", this.outline.makeRef(this.outline.root)), this.outline.createNamedDestinations && e.internal.write("/Names " + A + " 0 R"));
  }]), t.events.push(["initialized", function() {
    var e = this;
    e.outline = { createNamedDestinations: !1, root: { children: [] } }, e.outline.add = function(r, n, i) {
      var o = { title: n, options: i, children: [] };
      return r == null && (r = this.root), r.children.push(o), o;
    }, e.outline.render = function() {
      return this.ctx = {}, this.ctx.val = "", this.ctx.pdf = e, this.genIds_r(this.root), this.renderRoot(this.root), this.renderItems(this.root), this.ctx.val;
    }, e.outline.genIds_r = function(r) {
      r.id = e.internal.newObjectDeferred();
      for (var n = 0; n < r.children.length; n++) this.genIds_r(r.children[n]);
    }, e.outline.renderRoot = function(r) {
      this.objStart(r), this.line("/Type /Outlines"), r.children.length > 0 && (this.line("/First " + this.makeRef(r.children[0])), this.line("/Last " + this.makeRef(r.children[r.children.length - 1]))), this.line("/Count " + this.count_r({ count: 0 }, r)), this.objEnd();
    }, e.outline.renderItems = function(r) {
      for (var n = this.ctx.pdf.internal.getVerticalCoordinateString, i = 0; i < r.children.length; i++) {
        var o = r.children[i];
        this.objStart(o), this.line("/Title " + this.makeString(o.title)), this.line("/Parent " + this.makeRef(r)), i > 0 && this.line("/Prev " + this.makeRef(r.children[i - 1])), i < r.children.length - 1 && this.line("/Next " + this.makeRef(r.children[i + 1])), o.children.length > 0 && (this.line("/First " + this.makeRef(o.children[0])), this.line("/Last " + this.makeRef(o.children[o.children.length - 1])));
        var s = this.count = this.count_r({ count: 0 }, o);
        if (s > 0 && this.line("/Count " + s), o.options && o.options.pageNumber) {
          var c = e.internal.getPageInfo(o.options.pageNumber);
          this.line("/Dest [" + c.objId + " 0 R /XYZ 0 " + n(0) + " 0]");
        }
        this.objEnd();
      }
      for (var u = 0; u < r.children.length; u++) this.renderItems(r.children[u]);
    }, e.outline.line = function(r) {
      this.ctx.val += r + `\r
`;
    }, e.outline.makeRef = function(r) {
      return r.id + " 0 R";
    }, e.outline.makeString = function(r) {
      return "(" + e.internal.pdfEscape(r) + ")";
    }, e.outline.objStart = function(r) {
      this.ctx.val += `\r
` + r.id + ` 0 obj\r
<<\r
`;
    }, e.outline.objEnd = function() {
      this.ctx.val += `>> \r
endobj\r
`;
    }, e.outline.count_r = function(r, n) {
      for (var i = 0; i < n.children.length; i++) r.count++, this.count_r(r, n.children[i]);
      return r.count;
    };
  }]);
})(PA.API), /**
 * @license
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(t) {
  var A = [192, 193, 194, 195, 196, 197, 198, 199];
  t.processJPEG = function(e, r, n, i, o, s) {
    var c, u = this.decode.DCT_DECODE, h = null;
    if (typeof e == "string" || this.__addimage__.isArrayBuffer(e) || this.__addimage__.isArrayBufferView(e)) {
      switch (e = o || e, e = this.__addimage__.isArrayBuffer(e) ? new Uint8Array(e) : e, c = (function(p) {
        for (var w, d = 256 * p.charCodeAt(4) + p.charCodeAt(5), y = p.length, b = { width: 0, height: 0, numcomponents: 1 }, S = 4; S < y; S += 2) {
          if (S += d, A.indexOf(p.charCodeAt(S + 1)) !== -1) {
            w = 256 * p.charCodeAt(S + 5) + p.charCodeAt(S + 6), b = { width: 256 * p.charCodeAt(S + 7) + p.charCodeAt(S + 8), height: w, numcomponents: p.charCodeAt(S + 9) };
            break;
          }
          d = 256 * p.charCodeAt(S + 2) + p.charCodeAt(S + 3);
        }
        return b;
      })(e = this.__addimage__.isArrayBufferView(e) ? this.__addimage__.arrayBufferToBinaryString(e) : e), c.numcomponents) {
        case 1:
          s = this.color_spaces.DEVICE_GRAY;
          break;
        case 4:
          s = this.color_spaces.DEVICE_CMYK;
          break;
        case 3:
          s = this.color_spaces.DEVICE_RGB;
      }
      h = { data: e, width: c.width, height: c.height, colorSpace: s, bitsPerComponent: 8, filter: u, index: r, alias: n };
    }
    return h;
  };
})(PA.API), PA.API.processPNG = function(t, A, e, r) {
  if (this.__addimage__.isArrayBuffer(t) && (t = new Uint8Array(t)), this.__addimage__.isArrayBufferView(t)) {
    var n, i = C4(t, { checkCrc: !0 }), o = i.width, s = i.height, c = i.channels, u = i.palette, h = i.depth;
    n = u && c === 1 ? (function(j) {
      for (var N = j.width, Z = j.height, E = j.data, I = j.palette, K = j.depth, R = !1, aA = [], sA = [], oA = void 0, tA = !1, cA = 0, QA = 0; QA < I.length; QA++) {
        var pA = eh(I[QA], 4), F = pA[0], O = pA[1], M = pA[2], q = pA[3];
        aA.push(F, O, M), q != null && (q === 0 ? (cA++, sA.length < 1 && sA.push(QA)) : q < 255 && (tA = !0));
      }
      if (tA || cA > 1) {
        R = !0, sA = void 0;
        var X = N * Z;
        oA = new Uint8Array(X);
        for (var eA = new DataView(E.buffer), lA = 0; lA < X; lA++) {
          var uA = vl(eA, lA, K), gA = eh(I[uA], 4)[3];
          oA[lA] = gA;
        }
      } else cA === 0 && (sA = void 0);
      return { colorSpace: "Indexed", colorsPerPixel: 1, sMaskBitsPerComponent: R ? 8 : void 0, colorBytes: E, alphaBytes: oA, needSMask: R, palette: aA, mask: sA };
    })(i) : c === 2 || c === 4 ? (function(j) {
      for (var N = j.data, Z = j.width, E = j.height, I = j.channels, K = j.depth, R = I === 2 ? "DeviceGray" : "DeviceRGB", aA = I - 1, sA = Z * E, oA = aA, tA = sA * oA, cA = 1 * sA, QA = Math.ceil(tA * K / 8), pA = Math.ceil(cA * K / 8), F = new Uint8Array(QA), O = new Uint8Array(pA), M = new DataView(N.buffer), q = new DataView(F.buffer), X = new DataView(O.buffer), eA = !1, lA = 0; lA < sA; lA++) {
        for (var uA = lA * I, gA = 0; gA < oA; gA++) a0(q, vl(M, uA + gA, K), lA * oA + gA, K);
        var FA = vl(M, uA + oA, K);
        FA < (1 << K) - 1 && (eA = !0), a0(X, FA, 1 * lA, K);
      }
      return { colorSpace: R, colorsPerPixel: aA, sMaskBitsPerComponent: eA ? K : void 0, colorBytes: F, alphaBytes: O, needSMask: eA };
    })(i) : (function(j) {
      var N = j.data, Z = j.channels === 1 ? "DeviceGray" : "DeviceRGB";
      return { colorSpace: Z, colorsPerPixel: Z === "DeviceGray" ? 1 : 3, colorBytes: N instanceof Uint16Array ? (function(E) {
        for (var I = E.length, K = new Uint8Array(2 * I), R = new DataView(K.buffer, K.byteOffset, K.byteLength), aA = 0; aA < I; aA++) R.setUint16(2 * aA, E[aA], !1);
        return K;
      })(N) : N, needSMask: !1 };
    })(i);
    var p, w, d, y = n, b = y.colorSpace, S = y.colorsPerPixel, Q = y.sMaskBitsPerComponent, P = y.colorBytes, G = y.alphaBytes, k = y.needSMask, Y = y.palette, z = y.mask, iA = null;
    return r !== PA.API.image_compression.NONE && typeof Wl == "function" ? (iA = (function(j) {
      var N;
      switch (j) {
        case PA.API.image_compression.FAST:
          N = 11;
          break;
        case PA.API.image_compression.MEDIUM:
          N = 13;
          break;
        case PA.API.image_compression.SLOW:
          N = 14;
          break;
        default:
          N = 12;
      }
      return N;
    })(r), p = this.decode.FLATE_DECODE, w = "/Predictor ".concat(iA, " /Colors ").concat(S, " /BitsPerComponent ").concat(h, " /Columns ").concat(o), t = e0(P, Math.ceil(o * S * h / 8), S, h, r), k && (d = e0(G, Math.ceil(o * Q / 8), 1, Q, r))) : (p = void 0, w = void 0, t = P, k && (d = G)), (this.__addimage__.isArrayBuffer(t) || this.__addimage__.isArrayBufferView(t)) && (t = this.__addimage__.arrayBufferToBinaryString(t)), (d && this.__addimage__.isArrayBuffer(d) || this.__addimage__.isArrayBufferView(d)) && (d = this.__addimage__.arrayBufferToBinaryString(d)), { alias: e, data: t, index: A, filter: p, decodeParameters: w, transparency: z, palette: Y, sMask: d, predictor: iA, width: o, height: s, bitsPerComponent: h, sMaskBitsPerComponent: Q, colorSpace: b };
  }
}, (function(t) {
  t.processGIF89A = function(A, e, r, n) {
    var i = new K4(A), o = i.width, s = i.height, c = [];
    i.decodeAndBlitFrameRGBA(0, c);
    var u = { data: c, width: o, height: s }, h = new Cl(100).encode(u, 100);
    return t.processJPEG.call(this, h, e, r, n);
  }, t.processGIF87A = t.processGIF89A;
})(PA.API), mr.prototype.parseHeader = function() {
  if (this.fileSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.reserved = this.datav.getUint32(this.pos, !0), this.pos += 4, this.offset = this.datav.getUint32(this.pos, !0), this.pos += 4, this.headerSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.width = this.datav.getUint32(this.pos, !0), this.pos += 4, this.height = this.datav.getInt32(this.pos, !0), this.pos += 4, this.planes = this.datav.getUint16(this.pos, !0), this.pos += 2, this.bitPP = this.datav.getUint16(this.pos, !0), this.pos += 2, this.compress = this.datav.getUint32(this.pos, !0), this.pos += 4, this.rawSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.hr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.vr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.colors = this.datav.getUint32(this.pos, !0), this.pos += 4, this.importantColors = this.datav.getUint32(this.pos, !0), this.pos += 4, this.bitPP === 16 && this.is_with_alpha && (this.bitPP = 15), this.bitPP < 15) {
    var t = this.colors === 0 ? 1 << this.bitPP : this.colors;
    this.palette = new Array(t);
    for (var A = 0; A < t; A++) {
      var e = this.datav.getUint8(this.pos++, !0), r = this.datav.getUint8(this.pos++, !0), n = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0);
      this.palette[A] = { red: n, green: r, blue: e, quad: i };
    }
  }
  this.height < 0 && (this.height *= -1, this.bottom_up = !1);
}, mr.prototype.parseBGR = function() {
  this.pos = this.offset;
  try {
    var t = "bit" + this.bitPP, A = this.width * this.height * 4;
    this.data = new Uint8Array(A), this[t]();
  } catch (e) {
    Se.log("bit decode error:" + e);
  }
}, mr.prototype.bit1 = function() {
  var t, A = Math.ceil(this.width / 8), e = A % 4;
  for (t = this.height - 1; t >= 0; t--) {
    for (var r = this.bottom_up ? t : this.height - 1 - t, n = 0; n < A; n++) for (var i = this.datav.getUint8(this.pos++, !0), o = r * this.width * 4 + 8 * n * 4, s = 0; s < 8 && 8 * n + s < this.width; s++) {
      var c = this.palette[i >> 7 - s & 1];
      this.data[o + 4 * s] = c.blue, this.data[o + 4 * s + 1] = c.green, this.data[o + 4 * s + 2] = c.red, this.data[o + 4 * s + 3] = 255;
    }
    e !== 0 && (this.pos += 4 - e);
  }
}, mr.prototype.bit4 = function() {
  for (var t = Math.ceil(this.width / 2), A = t % 4, e = this.height - 1; e >= 0; e--) {
    for (var r = this.bottom_up ? e : this.height - 1 - e, n = 0; n < t; n++) {
      var i = this.datav.getUint8(this.pos++, !0), o = r * this.width * 4 + 2 * n * 4, s = i >> 4, c = 15 & i, u = this.palette[s];
      if (this.data[o] = u.blue, this.data[o + 1] = u.green, this.data[o + 2] = u.red, this.data[o + 3] = 255, 2 * n + 1 >= this.width) break;
      u = this.palette[c], this.data[o + 4] = u.blue, this.data[o + 4 + 1] = u.green, this.data[o + 4 + 2] = u.red, this.data[o + 4 + 3] = 255;
    }
    A !== 0 && (this.pos += 4 - A);
  }
}, mr.prototype.bit8 = function() {
  for (var t = this.width % 4, A = this.height - 1; A >= 0; A--) {
    for (var e = this.bottom_up ? A : this.height - 1 - A, r = 0; r < this.width; r++) {
      var n = this.datav.getUint8(this.pos++, !0), i = e * this.width * 4 + 4 * r;
      if (n < this.palette.length) {
        var o = this.palette[n];
        this.data[i] = o.red, this.data[i + 1] = o.green, this.data[i + 2] = o.blue, this.data[i + 3] = 255;
      } else this.data[i] = 255, this.data[i + 1] = 255, this.data[i + 2] = 255, this.data[i + 3] = 255;
    }
    t !== 0 && (this.pos += 4 - t);
  }
}, mr.prototype.bit15 = function() {
  for (var t = this.width % 3, A = parseInt("11111", 2), e = this.height - 1; e >= 0; e--) {
    for (var r = this.bottom_up ? e : this.height - 1 - e, n = 0; n < this.width; n++) {
      var i = this.datav.getUint16(this.pos, !0);
      this.pos += 2;
      var o = (i & A) / A * 255 | 0, s = (i >> 5 & A) / A * 255 | 0, c = (i >> 10 & A) / A * 255 | 0, u = i >> 15 ? 255 : 0, h = r * this.width * 4 + 4 * n;
      this.data[h] = c, this.data[h + 1] = s, this.data[h + 2] = o, this.data[h + 3] = u;
    }
    this.pos += t;
  }
}, mr.prototype.bit16 = function() {
  for (var t = this.width % 3, A = parseInt("11111", 2), e = parseInt("111111", 2), r = this.height - 1; r >= 0; r--) {
    for (var n = this.bottom_up ? r : this.height - 1 - r, i = 0; i < this.width; i++) {
      var o = this.datav.getUint16(this.pos, !0);
      this.pos += 2;
      var s = (o & A) / A * 255 | 0, c = (o >> 5 & e) / e * 255 | 0, u = (o >> 11) / A * 255 | 0, h = n * this.width * 4 + 4 * i;
      this.data[h] = u, this.data[h + 1] = c, this.data[h + 2] = s, this.data[h + 3] = 255;
    }
    this.pos += t;
  }
}, mr.prototype.bit24 = function() {
  for (var t = this.height - 1; t >= 0; t--) {
    for (var A = this.bottom_up ? t : this.height - 1 - t, e = 0; e < this.width; e++) {
      var r = this.datav.getUint8(this.pos++, !0), n = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), o = A * this.width * 4 + 4 * e;
      this.data[o] = i, this.data[o + 1] = n, this.data[o + 2] = r, this.data[o + 3] = 255;
    }
    this.pos += this.width % 4;
  }
}, mr.prototype.bit32 = function() {
  for (var t = this.height - 1; t >= 0; t--) for (var A = this.bottom_up ? t : this.height - 1 - t, e = 0; e < this.width; e++) {
    var r = this.datav.getUint8(this.pos++, !0), n = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), o = this.datav.getUint8(this.pos++, !0), s = A * this.width * 4 + 4 * e;
    this.data[s] = i, this.data[s + 1] = n, this.data[s + 2] = r, this.data[s + 3] = o;
  }
}, mr.prototype.getData = function() {
  return this.data;
}, /**
 * @license
 * Copyright (c) 2018 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(t) {
  t.processBMP = function(A, e, r, n) {
    var i = new mr(A, !1), o = i.width, s = i.height, c = { data: i.getData(), width: o, height: s }, u = new Cl(100).encode(c, 100);
    return t.processJPEG.call(this, u, e, r, n);
  };
})(PA.API), o0.prototype.getData = function() {
  return this.data;
}, /**
 * @license
 * Copyright (c) 2019 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(t) {
  t.processWEBP = function(A, e, r, n) {
    var i = new o0(A), o = i.width, s = i.height, c = { data: i.getData(), width: o, height: s }, u = new Cl(100).encode(c, 100);
    return t.processJPEG.call(this, u, e, r, n);
  };
})(PA.API), PA.API.processRGBA = function(t, A, e) {
  for (var r = t.data, n = r.length, i = new Uint8Array(n / 4 * 3), o = new Uint8Array(n / 4), s = 0, c = 0, u = 0; u < n; u += 4) {
    var h = r[u], p = r[u + 1], w = r[u + 2], d = r[u + 3];
    i[s++] = h, i[s++] = p, i[s++] = w, o[c++] = d;
  }
  var y = this.__addimage__.arrayBufferToBinaryString(i);
  return { alpha: this.__addimage__.arrayBufferToBinaryString(o), data: y, index: A, alias: e, colorSpace: "DeviceRGB", bitsPerComponent: 8, width: t.width, height: t.height };
}, PA.API.setLanguage = function(t) {
  return this.internal.languageSettings === void 0 && (this.internal.languageSettings = {}, this.internal.languageSettings.isSubscribed = !1), { af: "Afrikaans", sq: "Albanian", ar: "Arabic (Standard)", "ar-DZ": "Arabic (Algeria)", "ar-BH": "Arabic (Bahrain)", "ar-EG": "Arabic (Egypt)", "ar-IQ": "Arabic (Iraq)", "ar-JO": "Arabic (Jordan)", "ar-KW": "Arabic (Kuwait)", "ar-LB": "Arabic (Lebanon)", "ar-LY": "Arabic (Libya)", "ar-MA": "Arabic (Morocco)", "ar-OM": "Arabic (Oman)", "ar-QA": "Arabic (Qatar)", "ar-SA": "Arabic (Saudi Arabia)", "ar-SY": "Arabic (Syria)", "ar-TN": "Arabic (Tunisia)", "ar-AE": "Arabic (U.A.E.)", "ar-YE": "Arabic (Yemen)", an: "Aragonese", hy: "Armenian", as: "Assamese", ast: "Asturian", az: "Azerbaijani", eu: "Basque", be: "Belarusian", bn: "Bengali", bs: "Bosnian", br: "Breton", bg: "Bulgarian", my: "Burmese", ca: "Catalan", ch: "Chamorro", ce: "Chechen", zh: "Chinese", "zh-HK": "Chinese (Hong Kong)", "zh-CN": "Chinese (PRC)", "zh-SG": "Chinese (Singapore)", "zh-TW": "Chinese (Taiwan)", cv: "Chuvash", co: "Corsican", cr: "Cree", hr: "Croatian", cs: "Czech", da: "Danish", nl: "Dutch (Standard)", "nl-BE": "Dutch (Belgian)", en: "English", "en-AU": "English (Australia)", "en-BZ": "English (Belize)", "en-CA": "English (Canada)", "en-IE": "English (Ireland)", "en-JM": "English (Jamaica)", "en-NZ": "English (New Zealand)", "en-PH": "English (Philippines)", "en-ZA": "English (South Africa)", "en-TT": "English (Trinidad & Tobago)", "en-GB": "English (United Kingdom)", "en-US": "English (United States)", "en-ZW": "English (Zimbabwe)", eo: "Esperanto", et: "Estonian", fo: "Faeroese", fj: "Fijian", fi: "Finnish", fr: "French (Standard)", "fr-BE": "French (Belgium)", "fr-CA": "French (Canada)", "fr-FR": "French (France)", "fr-LU": "French (Luxembourg)", "fr-MC": "French (Monaco)", "fr-CH": "French (Switzerland)", fy: "Frisian", fur: "Friulian", gd: "Gaelic (Scots)", "gd-IE": "Gaelic (Irish)", gl: "Galacian", ka: "Georgian", de: "German (Standard)", "de-AT": "German (Austria)", "de-DE": "German (Germany)", "de-LI": "German (Liechtenstein)", "de-LU": "German (Luxembourg)", "de-CH": "German (Switzerland)", el: "Greek", gu: "Gujurati", ht: "Haitian", he: "Hebrew", hi: "Hindi", hu: "Hungarian", is: "Icelandic", id: "Indonesian", iu: "Inuktitut", ga: "Irish", it: "Italian (Standard)", "it-CH": "Italian (Switzerland)", ja: "Japanese", kn: "Kannada", ks: "Kashmiri", kk: "Kazakh", km: "Khmer", ky: "Kirghiz", tlh: "Klingon", ko: "Korean", "ko-KP": "Korean (North Korea)", "ko-KR": "Korean (South Korea)", la: "Latin", lv: "Latvian", lt: "Lithuanian", lb: "Luxembourgish", mk: "North Macedonia", ms: "Malay", ml: "Malayalam", mt: "Maltese", mi: "Maori", mr: "Marathi", mo: "Moldavian", nv: "Navajo", ng: "Ndonga", ne: "Nepali", no: "Norwegian", nb: "Norwegian (Bokmal)", nn: "Norwegian (Nynorsk)", oc: "Occitan", or: "Oriya", om: "Oromo", fa: "Persian", "fa-IR": "Persian/Iran", pl: "Polish", pt: "Portuguese", "pt-BR": "Portuguese (Brazil)", pa: "Punjabi", "pa-IN": "Punjabi (India)", "pa-PK": "Punjabi (Pakistan)", qu: "Quechua", rm: "Rhaeto-Romanic", ro: "Romanian", "ro-MO": "Romanian (Moldavia)", ru: "Russian", "ru-MO": "Russian (Moldavia)", sz: "Sami (Lappish)", sg: "Sango", sa: "Sanskrit", sc: "Sardinian", sd: "Sindhi", si: "Singhalese", sr: "Serbian", sk: "Slovak", sl: "Slovenian", so: "Somani", sb: "Sorbian", es: "Spanish", "es-AR": "Spanish (Argentina)", "es-BO": "Spanish (Bolivia)", "es-CL": "Spanish (Chile)", "es-CO": "Spanish (Colombia)", "es-CR": "Spanish (Costa Rica)", "es-DO": "Spanish (Dominican Republic)", "es-EC": "Spanish (Ecuador)", "es-SV": "Spanish (El Salvador)", "es-GT": "Spanish (Guatemala)", "es-HN": "Spanish (Honduras)", "es-MX": "Spanish (Mexico)", "es-NI": "Spanish (Nicaragua)", "es-PA": "Spanish (Panama)", "es-PY": "Spanish (Paraguay)", "es-PE": "Spanish (Peru)", "es-PR": "Spanish (Puerto Rico)", "es-ES": "Spanish (Spain)", "es-UY": "Spanish (Uruguay)", "es-VE": "Spanish (Venezuela)", sx: "Sutu", sw: "Swahili", sv: "Swedish", "sv-FI": "Swedish (Finland)", "sv-SV": "Swedish (Sweden)", ta: "Tamil", tt: "Tatar", te: "Teluga", th: "Thai", tig: "Tigre", ts: "Tsonga", tn: "Tswana", tr: "Turkish", tk: "Turkmen", uk: "Ukrainian", hsb: "Upper Sorbian", ur: "Urdu", ve: "Venda", vi: "Vietnamese", vo: "Volapuk", wa: "Walloon", cy: "Welsh", xh: "Xhosa", ji: "Yiddish", zu: "Zulu" }[t] !== void 0 && (this.internal.languageSettings.languageCode = t, this.internal.languageSettings.isSubscribed === !1 && (this.internal.events.subscribe("putCatalog", function() {
    this.internal.write("/Lang (" + this.internal.languageSettings.languageCode + ")");
  }), this.internal.languageSettings.isSubscribed = !0)), this;
}, Ki = PA.API, wo = Ki.getCharWidthsArray = function(t, A) {
  var e, r, n = (A = A || {}).font || this.internal.getFont(), i = A.fontSize || this.internal.getFontSize(), o = A.charSpace || this.internal.getCharSpace(), s = A.widths ? A.widths : n.metadata.Unicode.widths, c = s.fof ? s.fof : 1, u = A.kerning ? A.kerning : n.metadata.Unicode.kerning, h = u.fof ? u.fof : 1, p = A.doKerning !== !1, w = 0, d = t.length, y = 0, b = s[0] || c, S = [];
  for (e = 0; e < d; e++) r = t.charCodeAt(e), typeof n.metadata.widthOfString == "function" ? S.push((n.metadata.widthOfGlyph(n.metadata.characterToGlyph(r)) + o * (1e3 / i) || 0) / 1e3) : (w = p && Ee(u[r]) === "object" && !isNaN(parseInt(u[r][y], 10)) ? u[r][y] / h : 0, S.push((s[r] || b) / c + w)), y = r;
  return S;
}, Zh = Ki.getStringUnitWidth = function(t, A) {
  var e = (A = A || {}).fontSize || this.internal.getFontSize(), r = A.font || this.internal.getFont(), n = A.charSpace || this.internal.getCharSpace();
  return Ki.processArabic && (t = Ki.processArabic(t)), typeof r.metadata.widthOfString == "function" ? r.metadata.widthOfString(t, e, n) / e : wo.apply(this, arguments).reduce(function(i, o) {
    return i + o;
  }, 0);
}, $h = function(t, A, e, r) {
  for (var n = [], i = 0, o = t.length, s = 0; i !== o && s + A[i] < e; ) s += A[i], i++;
  n.push(t.slice(0, i));
  var c = i;
  for (s = 0; i !== o; ) s + A[i] > r && (n.push(t.slice(c, i)), s = 0, c = i), s += A[i], i++;
  return c !== i && n.push(t.slice(c, i)), n;
}, A0 = function(t, A, e) {
  e || (e = {});
  var r, n, i, o, s, c, u, h = [], p = [h], w = e.textIndent || 0, d = 0, y = 0, b = t.split(" "), S = wo.apply(this, [" ", e])[0];
  if (c = e.lineIndent === -1 ? b[0].length + 2 : e.lineIndent || 0) {
    var Q = Array(c).join(" "), P = [];
    b.map(function(k) {
      (k = k.split(/\s*\n/)).length > 1 ? P = P.concat(k.map(function(Y, z) {
        return (z && Y.length ? `
` : "") + Y;
      })) : P.push(k[0]);
    }), b = P, c = Zh.apply(this, [Q, e]);
  }
  for (i = 0, o = b.length; i < o; i++) {
    var G = 0;
    if (r = b[i], c && r[0] == `
` && (r = r.substr(1), G = 1), w + d + (y = (n = wo.apply(this, [r, e])).reduce(function(k, Y) {
      return k + Y;
    }, 0)) > A || G) {
      if (y > A) {
        for (s = $h.apply(this, [r, n, A - (w + d), A]), h.push(s.shift()), h = [s.pop()]; s.length; ) p.push([s.shift()]);
        y = n.slice(r.length - (h[0] ? h[0].length : 0)).reduce(function(k, Y) {
          return k + Y;
        }, 0);
      } else h = [r];
      p.push(h), w = y + c, d = S;
    } else h.push(r), w += d + y, d = S;
  }
  return u = c ? function(k, Y) {
    return (Y ? Q : "") + k.join(" ");
  } : function(k) {
    return k.join(" ");
  }, p.map(u);
}, Ki.splitTextToSize = function(t, A, e) {
  var r, n = (e = e || {}).fontSize || this.internal.getFontSize(), i = (function(h) {
    if (h.widths && h.kerning) return { widths: h.widths, kerning: h.kerning };
    var p = this.internal.getFont(h.fontName, h.fontStyle), w = "Unicode";
    return p.metadata[w] ? { widths: p.metadata[w].widths || { 0: 1 }, kerning: p.metadata[w].kerning || {} } : { font: p.metadata, fontSize: this.internal.getFontSize(), charSpace: this.internal.getCharSpace() };
  }).call(this, e);
  r = Array.isArray(t) ? t : String(t).split(/\r?\n/);
  var o = 1 * this.internal.scaleFactor * A / n;
  i.textIndent = e.textIndent ? 1 * e.textIndent * this.internal.scaleFactor / n : 0, i.lineIndent = e.lineIndent;
  var s, c, u = [];
  for (s = 0, c = r.length; s < c; s++) u = u.concat(A0.apply(this, [r[s], o, i]));
  return u;
}, (function(t) {
  t.__fontmetrics__ = t.__fontmetrics__ || {};
  for (var A = "0123456789abcdef", e = "klmnopqrstuvwxyz", r = {}, n = {}, i = 0; i < 16; i++) r[e[i]] = A[i], n[A[i]] = e[i];
  var o = function(w) {
    return "0x" + parseInt(w, 10).toString(16);
  }, s = t.__fontmetrics__.compress = function(w) {
    var d, y, b, S, Q = ["{"];
    for (var P in w) {
      if (d = w[P], isNaN(parseInt(P, 10)) ? y = "'" + P + "'" : (P = parseInt(P, 10), y = (y = o(P).slice(2)).slice(0, -1) + n[y.slice(-1)]), typeof d == "number") d < 0 ? (b = o(d).slice(3), S = "-") : (b = o(d).slice(2), S = ""), b = S + b.slice(0, -1) + n[b.slice(-1)];
      else {
        if (Ee(d) !== "object") throw new Error("Don't know what to do with value type " + Ee(d) + ".");
        b = s(d);
      }
      Q.push(y + b);
    }
    return Q.push("}"), Q.join("");
  }, c = t.__fontmetrics__.uncompress = function(w) {
    if (typeof w != "string") throw new Error("Invalid argument passed to uncompress.");
    for (var d, y, b, S, Q = {}, P = 1, G = Q, k = [], Y = "", z = "", iA = w.length - 1, j = 1; j < iA; j += 1) (S = w[j]) == "'" ? d ? (b = d.join(""), d = void 0) : d = [] : d ? d.push(S) : S == "{" ? (k.push([G, b]), G = {}, b = void 0) : S == "}" ? ((y = k.pop())[0][y[1]] = G, b = void 0, G = y[0]) : S == "-" ? P = -1 : b === void 0 ? r.hasOwnProperty(S) ? (Y += r[S], b = parseInt(Y, 16) * P, P = 1, Y = "") : Y += S : r.hasOwnProperty(S) ? (z += r[S], G[b] = parseInt(z, 16) * P, P = 1, b = void 0, z = "") : z += S;
    return Q;
  }, u = { codePages: ["WinAnsiEncoding"], WinAnsiEncoding: c("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}") }, h = { Unicode: { Courier: u, "Courier-Bold": u, "Courier-BoldOblique": u, "Courier-Oblique": u, Helvetica: u, "Helvetica-Bold": u, "Helvetica-BoldOblique": u, "Helvetica-Oblique": u, "Times-Roman": u, "Times-Bold": u, "Times-BoldItalic": u, "Times-Italic": u } }, p = { Unicode: { "Courier-Oblique": c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"), "Times-BoldItalic": c("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"), "Helvetica-Bold": c("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"), Courier: c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"), "Courier-BoldOblique": c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"), "Times-Bold": c("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"), Symbol: c("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"), Helvetica: c("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"), "Helvetica-BoldOblique": c("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"), ZapfDingbats: c("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"), "Courier-Bold": c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"), "Times-Italic": c("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"), "Times-Roman": c("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"), "Helvetica-Oblique": c("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}") } };
  t.events.push(["addFont", function(w) {
    var d = w.font, y = p.Unicode[d.postScriptName];
    y && (d.metadata.Unicode = {}, d.metadata.Unicode.widths = y.widths, d.metadata.Unicode.kerning = y.kerning);
    var b = h.Unicode[d.postScriptName];
    b && (d.metadata.Unicode.encoding = b, d.encoding = b.codePages[0]);
  }]);
})(PA.API), /**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(t) {
  var A = function(e) {
    for (var r = e.length, n = new Uint8Array(r), i = 0; i < r; i++) n[i] = e.charCodeAt(i);
    return n;
  };
  t.API.events.push(["addFont", function(e) {
    var r = void 0, n = e.font, i = e.instance;
    if (!n.isStandardFont) {
      if (i === void 0) throw new Error("Font does not exist in vFS, import fonts or remove declaration doc.addFont('" + n.postScriptName + "').");
      if (typeof (r = i.existsFileInVFS(n.postScriptName) === !1 ? i.loadFile(n.postScriptName) : i.getFileFromVFS(n.postScriptName)) != "string") throw new Error("Font is not stored as string-data in vFS, import fonts or remove declaration doc.addFont('" + n.postScriptName + "').");
      (function(o, s) {
        s = /^\x00\x01\x00\x00/.test(s) ? A(s) : A(Uo(s)), o.metadata = t.API.TTFFont.open(s), o.metadata.Unicode = o.metadata.Unicode || { encoding: {}, kerning: {}, widths: [] }, o.metadata.glyIdsUsed = [0];
      })(n, r);
    }
  }]);
})(PA), PA.API.addSvgAsImage = function(t, A, e, r, n, i, o, s) {
  if (isNaN(A) || isNaN(e)) throw Se.error("jsPDF.addSvgAsImage: Invalid coordinates", arguments), new Error("Invalid coordinates passed to jsPDF.addSvgAsImage");
  if (isNaN(r) || isNaN(n)) throw Se.error("jsPDF.addSvgAsImage: Invalid measurements", arguments), new Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");
  var c = document.createElement("canvas");
  c.width = r, c.height = n;
  var u = c.getContext("2d");
  u.fillStyle = "#fff", u.fillRect(0, 0, c.width, c.height);
  var h = { ignoreMouse: !0, ignoreAnimation: !0, ignoreDimensions: !0 }, p = this;
  return (YA.canvg ? Promise.resolve(YA.canvg) : import("./index.es-B06FagMx.js")).catch(function(w) {
    return Promise.reject(new Error("Could not load canvg: " + w));
  }).then(function(w) {
    return w.default ? w.default : w;
  }).then(function(w) {
    return w.fromString(u, t, h);
  }, function() {
    return Promise.reject(new Error("Could not load canvg."));
  }).then(function(w) {
    return w.render(h);
  }).then(function() {
    p.addImage(c.toDataURL("image/jpeg", 1), A, e, r, n, o, s);
  });
}, PA.API.putTotalPages = function(t) {
  var A, e = 0;
  parseInt(this.internal.getFont().id.substr(1), 10) < 15 ? (A = new RegExp(t, "g"), e = this.internal.getNumberOfPages()) : (A = new RegExp(this.pdfEscape16(t, this.internal.getFont()), "g"), e = this.pdfEscape16(this.internal.getNumberOfPages() + "", this.internal.getFont()));
  for (var r = 1; r <= this.internal.getNumberOfPages(); r++) for (var n = 0; n < this.internal.pages[r].length; n++) this.internal.pages[r][n] = this.internal.pages[r][n].replace(A, e);
  return this;
}, PA.API.viewerPreferences = function(t, A) {
  var e;
  t = t || {}, A = A || !1;
  var r, n, i, o = { HideToolbar: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.3 }, HideMenubar: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.3 }, HideWindowUI: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.3 }, FitWindow: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.3 }, CenterWindow: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.3 }, DisplayDocTitle: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.4 }, NonFullScreenPageMode: { defaultValue: "UseNone", value: "UseNone", type: "name", explicitSet: !1, valueSet: ["UseNone", "UseOutlines", "UseThumbs", "UseOC"], pdfVersion: 1.3 }, Direction: { defaultValue: "L2R", value: "L2R", type: "name", explicitSet: !1, valueSet: ["L2R", "R2L"], pdfVersion: 1.3 }, ViewArea: { defaultValue: "CropBox", value: "CropBox", type: "name", explicitSet: !1, valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"], pdfVersion: 1.4 }, ViewClip: { defaultValue: "CropBox", value: "CropBox", type: "name", explicitSet: !1, valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"], pdfVersion: 1.4 }, PrintArea: { defaultValue: "CropBox", value: "CropBox", type: "name", explicitSet: !1, valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"], pdfVersion: 1.4 }, PrintClip: { defaultValue: "CropBox", value: "CropBox", type: "name", explicitSet: !1, valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"], pdfVersion: 1.4 }, PrintScaling: { defaultValue: "AppDefault", value: "AppDefault", type: "name", explicitSet: !1, valueSet: ["AppDefault", "None"], pdfVersion: 1.6 }, Duplex: { defaultValue: "", value: "none", type: "name", explicitSet: !1, valueSet: ["Simplex", "DuplexFlipShortEdge", "DuplexFlipLongEdge", "none"], pdfVersion: 1.7 }, PickTrayByPDFSize: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.7 }, PrintPageRange: { defaultValue: "", value: "", type: "array", explicitSet: !1, valueSet: null, pdfVersion: 1.7 }, NumCopies: { defaultValue: 1, value: 1, type: "integer", explicitSet: !1, valueSet: null, pdfVersion: 1.7 } }, s = Object.keys(o), c = [], u = 0, h = 0, p = 0;
  function w(y, b) {
    var S, Q = !1;
    for (S = 0; S < y.length; S += 1) y[S] === b && (Q = !0);
    return Q;
  }
  if (this.internal.viewerpreferences === void 0 && (this.internal.viewerpreferences = {}, this.internal.viewerpreferences.configuration = JSON.parse(JSON.stringify(o)), this.internal.viewerpreferences.isSubscribed = !1), e = this.internal.viewerpreferences.configuration, t === "reset" || A === !0) {
    var d = s.length;
    for (p = 0; p < d; p += 1) e[s[p]].value = e[s[p]].defaultValue, e[s[p]].explicitSet = !1;
  }
  if (Ee(t) === "object") {
    for (n in t) if (i = t[n], w(s, n) && i !== void 0) {
      if (e[n].type === "boolean" && typeof i == "boolean") e[n].value = i;
      else if (e[n].type === "name" && w(e[n].valueSet, i)) e[n].value = i;
      else if (e[n].type === "integer" && Number.isInteger(i)) e[n].value = i;
      else if (e[n].type === "array") {
        for (u = 0; u < i.length; u += 1) if (r = !0, i[u].length === 1 && typeof i[u][0] == "number") c.push(String(i[u] - 1));
        else if (i[u].length > 1) {
          for (h = 0; h < i[u].length; h += 1) typeof i[u][h] != "number" && (r = !1);
          r === !0 && c.push([i[u][0] - 1, i[u][1] - 1].join(" "));
        }
        e[n].value = "[" + c.join(" ") + "]";
      } else e[n].value = e[n].defaultValue;
      e[n].explicitSet = !0;
    }
  }
  return this.internal.viewerpreferences.isSubscribed === !1 && (this.internal.events.subscribe("putCatalog", function() {
    var y, b = [];
    for (y in e) e[y].explicitSet === !0 && (e[y].type === "name" ? b.push("/" + y + " /" + e[y].value) : b.push("/" + y + " " + e[y].value));
    b.length !== 0 && this.internal.write(`/ViewerPreferences
<<
` + b.join(`
`) + `
>>`);
  }), this.internal.viewerpreferences.isSubscribed = !0), this.internal.viewerpreferences.configuration = e, this;
}, /** ====================================================================
 * @license
 * jsPDF XMP metadata plugin
 * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */
(function(t) {
  var A = function() {
    var r = '<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="' + this.internal.__metadata__.namespaceuri + '"><jspdf:metadata>', n = unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')), i = unescape(encodeURIComponent(r)), o = unescape(encodeURIComponent(this.internal.__metadata__.metadata)), s = unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")), c = unescape(encodeURIComponent("</x:xmpmeta>")), u = i.length + o.length + s.length + n.length + c.length;
    this.internal.__metadata__.metadata_object_number = this.internal.newObject(), this.internal.write("<< /Type /Metadata /Subtype /XML /Length " + u + " >>"), this.internal.write("stream"), this.internal.write(n + i + o + s + c), this.internal.write("endstream"), this.internal.write("endobj");
  }, e = function() {
    this.internal.__metadata__.metadata_object_number && this.internal.write("/Metadata " + this.internal.__metadata__.metadata_object_number + " 0 R");
  };
  t.addMetadata = function(r, n) {
    return this.internal.__metadata__ === void 0 && (this.internal.__metadata__ = { metadata: r, namespaceuri: n || "http://jspdf.default.namespaceuri/" }, this.internal.events.subscribe("putCatalog", e), this.internal.events.subscribe("postPutResources", A)), this;
  };
})(PA.API), (function(t) {
  var A = t.API, e = A.pdfEscape16 = function(i, o) {
    for (var s, c = o.metadata.Unicode.widths, u = ["", "0", "00", "000", "0000"], h = [""], p = 0, w = i.length; p < w; ++p) {
      if (s = o.metadata.characterToGlyph(i.charCodeAt(p)), o.metadata.glyIdsUsed.push(s), o.metadata.toUnicode[s] = i.charCodeAt(p), c.indexOf(s) == -1 && (c.push(s), c.push([parseInt(o.metadata.widthOfGlyph(s), 10)])), s == "0") return h.join("");
      s = s.toString(16), h.push(u[4 - s.length], s);
    }
    return h.join("");
  }, r = function(i) {
    var o, s, c, u, h, p, w;
    for (h = `/CIDInit /ProcSet findresource begin
12 dict begin
begincmap
/CIDSystemInfo <<
  /Registry (Adobe)
  /Ordering (UCS)
  /Supplement 0
>> def
/CMapName /Adobe-Identity-UCS def
/CMapType 2 def
1 begincodespacerange
<0000><ffff>
endcodespacerange`, c = [], p = 0, w = (s = Object.keys(i).sort(function(d, y) {
      return d - y;
    })).length; p < w; p++) o = s[p], c.length >= 100 && (h += `
` + c.length + ` beginbfchar
` + c.join(`
`) + `
endbfchar`, c = []), i[o] !== void 0 && i[o] !== null && typeof i[o].toString == "function" && (u = ("0000" + i[o].toString(16)).slice(-4), o = ("0000" + (+o).toString(16)).slice(-4), c.push("<" + o + "><" + u + ">"));
    return c.length && (h += `
` + c.length + ` beginbfchar
` + c.join(`
`) + `
endbfchar
`), h + `endcmap
CMapName currentdict /CMap defineresource pop
end
end`;
  };
  A.events.push(["putFont", function(i) {
    (function(o) {
      var s = o.font, c = o.out, u = o.newObject, h = o.putStream;
      if (s.metadata instanceof t.API.TTFFont && s.encoding === "Identity-H") {
        for (var p = s.metadata.Unicode.widths, w = s.metadata.subset.encode(s.metadata.glyIdsUsed, 1), d = "", y = 0; y < w.length; y++) d += String.fromCharCode(w[y]);
        var b = u();
        h({ data: d, addLength1: !0, objectId: b }), c("endobj");
        var S = u();
        h({ data: r(s.metadata.toUnicode), addLength1: !0, objectId: S }), c("endobj");
        var Q = u();
        c("<<"), c("/Type /FontDescriptor"), c("/FontName /" + ji(s.fontName)), c("/FontFile2 " + b + " 0 R"), c("/FontBBox " + t.API.PDFObject.convert(s.metadata.bbox)), c("/Flags " + s.metadata.flags), c("/StemV " + s.metadata.stemV), c("/ItalicAngle " + s.metadata.italicAngle), c("/Ascent " + s.metadata.ascender), c("/Descent " + s.metadata.decender), c("/CapHeight " + s.metadata.capHeight), c(">>"), c("endobj");
        var P = u();
        c("<<"), c("/Type /Font"), c("/BaseFont /" + ji(s.fontName)), c("/FontDescriptor " + Q + " 0 R"), c("/W " + t.API.PDFObject.convert(p)), c("/CIDToGIDMap /Identity"), c("/DW 1000"), c("/Subtype /CIDFontType2"), c("/CIDSystemInfo"), c("<<"), c("/Supplement 0"), c("/Registry (Adobe)"), c("/Ordering (" + s.encoding + ")"), c(">>"), c(">>"), c("endobj"), s.objectNumber = u(), c("<<"), c("/Type /Font"), c("/Subtype /Type0"), c("/ToUnicode " + S + " 0 R"), c("/BaseFont /" + ji(s.fontName)), c("/Encoding /" + s.encoding), c("/DescendantFonts [" + P + " 0 R]"), c(">>"), c("endobj"), s.isAlreadyPutted = !0;
      }
    })(i);
  }]), A.events.push(["putFont", function(i) {
    (function(o) {
      var s = o.font, c = o.out, u = o.newObject, h = o.putStream;
      if (s.metadata instanceof t.API.TTFFont && s.encoding === "WinAnsiEncoding") {
        for (var p = s.metadata.rawData, w = "", d = 0; d < p.length; d++) w += String.fromCharCode(p[d]);
        var y = u();
        h({ data: w, addLength1: !0, objectId: y }), c("endobj");
        var b = u();
        h({ data: r(s.metadata.toUnicode), addLength1: !0, objectId: b }), c("endobj");
        var S = u();
        c("<<"), c("/Descent " + s.metadata.decender), c("/CapHeight " + s.metadata.capHeight), c("/StemV " + s.metadata.stemV), c("/Type /FontDescriptor"), c("/FontFile2 " + y + " 0 R"), c("/Flags 96"), c("/FontBBox " + t.API.PDFObject.convert(s.metadata.bbox)), c("/FontName /" + ji(s.fontName)), c("/ItalicAngle " + s.metadata.italicAngle), c("/Ascent " + s.metadata.ascender), c(">>"), c("endobj"), s.objectNumber = u();
        for (var Q = 0; Q < s.metadata.hmtx.widths.length; Q++) s.metadata.hmtx.widths[Q] = parseInt(s.metadata.hmtx.widths[Q] * (1e3 / s.metadata.head.unitsPerEm));
        c("<</Subtype/TrueType/Type/Font/ToUnicode " + b + " 0 R/BaseFont/" + ji(s.fontName) + "/FontDescriptor " + S + " 0 R/Encoding/" + s.encoding + " /FirstChar 29 /LastChar 255 /Widths " + t.API.PDFObject.convert(s.metadata.hmtx.widths) + ">>"), c("endobj"), s.isAlreadyPutted = !0;
      }
    })(i);
  }]);
  var n = function(i) {
    var o, s = i.text || "", c = i.x, u = i.y, h = i.options || {}, p = i.mutex || {}, w = p.pdfEscape, d = p.activeFontKey, y = p.fonts, b = d, S = "", Q = 0, P = "", G = y[b].encoding;
    if (y[b].encoding !== "Identity-H") return { text: s, x: c, y: u, options: h, mutex: p };
    for (P = s, b = d, Array.isArray(s) && (P = s[0]), Q = 0; Q < P.length; Q += 1) y[b].metadata.hasOwnProperty("cmap") && (o = y[b].metadata.cmap.unicode.codeMap[P[Q].charCodeAt(0)]), o || P[Q].charCodeAt(0) < 256 && y[b].metadata.hasOwnProperty("Unicode") ? S += P[Q] : S += "";
    var k = "";
    return parseInt(b.slice(1)) < 14 || G === "WinAnsiEncoding" ? k = w(S, b).split("").map(function(Y) {
      return Y.charCodeAt(0).toString(16);
    }).join("") : G === "Identity-H" && (k = e(S, y[b])), p.isHex = !0, { text: k, x: c, y: u, options: h, mutex: p };
  };
  A.events.push(["postProcessText", function(i) {
    var o = i.text || "", s = [], c = { text: o, x: i.x, y: i.y, options: i.options, mutex: i.mutex };
    if (Array.isArray(o)) {
      var u = 0;
      for (u = 0; u < o.length; u += 1) Array.isArray(o[u]) && o[u].length === 3 ? s.push([n(Object.assign({}, c, { text: o[u][0] })).text, o[u][1], o[u][2]]) : s.push(n(Object.assign({}, c, { text: o[u] })).text);
      i.text = s;
    } else i.text = n(Object.assign({}, c, { text: o })).text;
  }]);
})(PA), /**
 * @license
 * jsPDF virtual FileSystem functionality
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(t) {
  var A = function() {
    return this.internal.vFS === void 0 && (this.internal.vFS = {}), !0;
  };
  t.existsFileInVFS = function(e) {
    return A.call(this), this.internal.vFS[e] !== void 0;
  }, t.addFileToVFS = function(e, r) {
    return A.call(this), this.internal.vFS[e] = r, this;
  }, t.getFileFromVFS = function(e) {
    return A.call(this), this.internal.vFS[e] !== void 0 ? this.internal.vFS[e] : null;
  };
})(PA.API), /**
 * @license
 * Unicode Bidi Engine based on the work of Alex Shensis (@asthensis)
 * MIT License
 */
(function(t) {
  t.__bidiEngine__ = t.prototype.__bidiEngine__ = function(r) {
    var n, i, o, s, c, u, h, p = A, w = [[0, 3, 0, 1, 0, 0, 0], [0, 3, 0, 1, 2, 2, 0], [0, 3, 0, 17, 2, 0, 1], [0, 3, 5, 5, 4, 1, 0], [0, 3, 21, 21, 4, 0, 1], [0, 3, 5, 5, 4, 2, 0]], d = [[2, 0, 1, 1, 0, 1, 0], [2, 0, 1, 1, 0, 2, 0], [2, 0, 2, 1, 3, 2, 0], [2, 0, 2, 33, 3, 1, 1]], y = { L: 0, R: 1, EN: 2, AN: 3, N: 4, B: 5, S: 6 }, b = { 0: 0, 5: 1, 6: 2, 7: 3, 32: 4, 251: 5, 254: 6, 255: 7 }, S = ["(", ")", "(", "<", ">", "<", "[", "]", "[", "{", "}", "{", "«", "»", "«", "‹", "›", "‹", "⁅", "⁆", "⁅", "⁽", "⁾", "⁽", "₍", "₎", "₍", "≤", "≥", "≤", "〈", "〉", "〈", "﹙", "﹚", "﹙", "﹛", "﹜", "﹛", "﹝", "﹞", "﹝", "﹤", "﹥", "﹤"], Q = new RegExp(/^([1-4|9]|1[0-9]|2[0-9]|3[0168]|4[04589]|5[012]|7[78]|159|16[0-9]|17[0-2]|21[569]|22[03489]|250)$/), P = !1, G = 0;
    this.__bidiEngine__ = {};
    var k = function(E) {
      var I = E.charCodeAt(), K = I >> 8, R = b[K];
      return R !== void 0 ? p[256 * R + (255 & I)] : K === 252 || K === 253 ? "AL" : Q.test(K) ? "L" : K === 8 ? "R" : "N";
    }, Y = function(E) {
      for (var I, K = 0; K < E.length; K++) {
        if ((I = k(E.charAt(K))) === "L") return !1;
        if (I === "R") return !0;
      }
      return !1;
    }, z = function(E, I, K, R) {
      var aA, sA, oA, tA, cA = I[R];
      switch (cA) {
        case "L":
        case "R":
        case "LRE":
        case "RLE":
        case "LRO":
        case "RLO":
        case "PDF":
          P = !1;
          break;
        case "N":
        case "AN":
          break;
        case "EN":
          P && (cA = "AN");
          break;
        case "AL":
          P = !0, cA = "R";
          break;
        case "WS":
        case "BN":
          cA = "N";
          break;
        case "CS":
          R < 1 || R + 1 >= I.length || (aA = K[R - 1]) !== "EN" && aA !== "AN" || (sA = I[R + 1]) !== "EN" && sA !== "AN" ? cA = "N" : P && (sA = "AN"), cA = sA === aA ? sA : "N";
          break;
        case "ES":
          cA = (aA = R > 0 ? K[R - 1] : "B") === "EN" && R + 1 < I.length && I[R + 1] === "EN" ? "EN" : "N";
          break;
        case "ET":
          if (R > 0 && K[R - 1] === "EN") {
            cA = "EN";
            break;
          }
          if (P) {
            cA = "N";
            break;
          }
          for (oA = R + 1, tA = I.length; oA < tA && I[oA] === "ET"; ) oA++;
          cA = oA < tA && I[oA] === "EN" ? "EN" : "N";
          break;
        case "NSM":
          if (o && !s) {
            for (tA = I.length, oA = R + 1; oA < tA && I[oA] === "NSM"; ) oA++;
            if (oA < tA) {
              var QA = E[R], pA = QA >= 1425 && QA <= 2303 || QA === 64286;
              if (aA = I[oA], pA && (aA === "R" || aA === "AL")) {
                cA = "R";
                break;
              }
            }
          }
          cA = R < 1 || (aA = I[R - 1]) === "B" ? "N" : K[R - 1];
          break;
        case "B":
          P = !1, n = !0, cA = G;
          break;
        case "S":
          i = !0, cA = "N";
      }
      return cA;
    }, iA = function(E, I, K) {
      var R = E.split("");
      return K && j(R, K, { hiLevel: G }), R.reverse(), I && I.reverse(), R.join("");
    }, j = function(E, I, K) {
      var R, aA, sA, oA, tA, cA = -1, QA = E.length, pA = 0, F = [], O = G ? d : w, M = [];
      for (P = !1, n = !1, i = !1, aA = 0; aA < QA; aA++) M[aA] = k(E[aA]);
      for (sA = 0; sA < QA; sA++) {
        if (tA = pA, F[sA] = z(E, M, F, sA), R = 240 & (pA = O[tA][y[F[sA]]]), pA &= 15, I[sA] = oA = O[pA][5], R > 0) if (R === 16) {
          for (aA = cA; aA < sA; aA++) I[aA] = 1;
          cA = -1;
        } else cA = -1;
        if (O[pA][6]) cA === -1 && (cA = sA);
        else if (cA > -1) {
          for (aA = cA; aA < sA; aA++) I[aA] = oA;
          cA = -1;
        }
        M[sA] === "B" && (I[sA] = 0), K.hiLevel |= oA;
      }
      i && (function(q, X, eA) {
        for (var lA = 0; lA < eA; lA++) if (q[lA] === "S") {
          X[lA] = G;
          for (var uA = lA - 1; uA >= 0 && q[uA] === "WS"; uA--) X[uA] = G;
        }
      })(M, I, QA);
    }, N = function(E, I, K, R, aA) {
      if (!(aA.hiLevel < E)) {
        if (E === 1 && G === 1 && !n) return I.reverse(), void (K && K.reverse());
        for (var sA, oA, tA, cA, QA = I.length, pA = 0; pA < QA; ) {
          if (R[pA] >= E) {
            for (tA = pA + 1; tA < QA && R[tA] >= E; ) tA++;
            for (cA = pA, oA = tA - 1; cA < oA; cA++, oA--) sA = I[cA], I[cA] = I[oA], I[oA] = sA, K && (sA = K[cA], K[cA] = K[oA], K[oA] = sA);
            pA = tA;
          }
          pA++;
        }
      }
    }, Z = function(E, I, K) {
      var R = E.split(""), aA = { hiLevel: G };
      return K || (K = []), j(R, K, aA), (function(sA, oA, tA) {
        if (tA.hiLevel !== 0 && h) for (var cA, QA = 0; QA < sA.length; QA++) oA[QA] === 1 && (cA = S.indexOf(sA[QA])) >= 0 && (sA[QA] = S[cA + 1]);
      })(R, K, aA), N(2, R, I, K, aA), N(1, R, I, K, aA), R.join("");
    };
    return this.__bidiEngine__.doBidiReorder = function(E, I, K) {
      if ((function(aA, sA) {
        if (sA) for (var oA = 0; oA < aA.length; oA++) sA[oA] = oA;
        s === void 0 && (s = Y(aA)), u === void 0 && (u = Y(aA));
      })(E, I), o || !c || u) if (o && c && s ^ u) G = s ? 1 : 0, E = iA(E, I, K);
      else if (!o && c && u) G = s ? 1 : 0, E = Z(E, I, K), E = iA(E, I);
      else if (!o || s || c || u) {
        if (o && !c && s ^ u) E = iA(E, I), s ? (G = 0, E = Z(E, I, K)) : (G = 1, E = Z(E, I, K), E = iA(E, I));
        else if (o && s && !c && u) G = 1, E = Z(E, I, K), E = iA(E, I);
        else if (!o && !c && s ^ u) {
          var R = h;
          s ? (G = 1, E = Z(E, I, K), G = 0, h = !1, E = Z(E, I, K), h = R) : (G = 0, E = Z(E, I, K), E = iA(E, I), G = 1, h = !1, E = Z(E, I, K), h = R, E = iA(E, I));
        }
      } else G = 0, E = Z(E, I, K);
      else G = s ? 1 : 0, E = Z(E, I, K);
      return E;
    }, this.__bidiEngine__.setOptions = function(E) {
      E && (o = E.isInputVisual, c = E.isOutputVisual, s = E.isInputRtl, u = E.isOutputRtl, h = E.isSymmetricSwapping);
    }, this.__bidiEngine__.setOptions(r), this.__bidiEngine__;
  };
  var A = ["BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "S", "B", "S", "WS", "B", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "B", "B", "B", "S", "WS", "N", "N", "ET", "ET", "ET", "N", "N", "N", "N", "N", "ES", "CS", "ES", "CS", "CS", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "CS", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "BN", "BN", "BN", "BN", "BN", "BN", "B", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "CS", "N", "ET", "ET", "ET", "ET", "N", "N", "N", "N", "L", "N", "N", "BN", "N", "N", "ET", "ET", "EN", "EN", "N", "L", "N", "N", "N", "EN", "L", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "N", "N", "N", "N", "N", "ET", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "R", "NSM", "R", "NSM", "NSM", "R", "NSM", "NSM", "R", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "N", "N", "N", "N", "N", "R", "R", "R", "R", "R", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "AN", "AN", "AN", "AN", "AN", "AN", "N", "N", "AL", "ET", "ET", "AL", "CS", "AL", "N", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "ET", "AN", "AN", "AL", "AL", "AL", "NSM", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AN", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "NSM", "NSM", "N", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "N", "AL", "AL", "NSM", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "R", "R", "N", "N", "N", "N", "R", "N", "N", "N", "N", "N", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "BN", "BN", "BN", "L", "R", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "WS", "B", "LRE", "RLE", "PDF", "LRO", "RLO", "CS", "ET", "ET", "ET", "ET", "ET", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "CS", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "WS", "BN", "BN", "BN", "BN", "BN", "N", "LRI", "RLI", "FSI", "PDI", "BN", "BN", "BN", "BN", "BN", "BN", "EN", "L", "N", "N", "EN", "EN", "EN", "EN", "EN", "EN", "ES", "ES", "N", "N", "N", "L", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "ES", "ES", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "R", "NSM", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "ES", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "N", "R", "R", "R", "R", "R", "N", "R", "N", "R", "R", "N", "R", "R", "N", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "CS", "N", "CS", "N", "N", "CS", "N", "N", "N", "N", "N", "N", "N", "N", "N", "ET", "N", "N", "ES", "ES", "N", "N", "N", "N", "N", "ET", "ET", "N", "N", "N", "N", "N", "AL", "AL", "AL", "AL", "AL", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "N", "N", "BN", "N", "N", "N", "ET", "ET", "ET", "N", "N", "N", "N", "N", "ES", "CS", "ES", "CS", "CS", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "CS", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "N", "N", "N", "ET", "ET", "N", "N", "N", "ET", "ET", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N"], e = new t.__bidiEngine__({ isInputVisual: !0 });
  t.API.events.push(["postProcessText", function(r) {
    var n = r.text;
    r.x, r.y;
    var i = r.options || {};
    r.mutex, i.lang;
    var o = [];
    if (i.isInputVisual = typeof i.isInputVisual != "boolean" || i.isInputVisual, e.setOptions(i), Object.prototype.toString.call(n) === "[object Array]") {
      var s = 0;
      for (o = [], s = 0; s < n.length; s += 1) Object.prototype.toString.call(n[s]) === "[object Array]" ? o.push([e.doBidiReorder(n[s][0]), n[s][1], n[s][2]]) : o.push([e.doBidiReorder(n[s])]);
      r.text = o;
    } else r.text = e.doBidiReorder(n);
    e.setOptions({ isInputVisual: !0 });
  }]);
})(PA), PA.API.TTFFont = (function() {
  function t(A) {
    var e;
    if (this.rawData = A, e = this.contents = new Gn(A), this.contents.pos = 4, e.readString(4) === "ttcf") throw new Error("TTCF not supported.");
    e.pos = 0, this.parse(), this.subset = new tC(this), this.registerTTF();
  }
  return t.open = function(A) {
    return new t(A);
  }, t.prototype.parse = function() {
    return this.directory = new R4(this.contents), this.head = new V4(this), this.name = new J4(this), this.cmap = new rB(this), this.toUnicode = {}, this.hhea = new j4(this), this.maxp = new Y4(this), this.hmtx = new z4(this), this.post = new W4(this), this.os2 = new q4(this), this.loca = new eC(this), this.glyf = new Z4(this), this.ascender = this.os2.exists && this.os2.ascender || this.hhea.ascender, this.decender = this.os2.exists && this.os2.decender || this.hhea.decender, this.lineGap = this.os2.exists && this.os2.lineGap || this.hhea.lineGap, this.bbox = [this.head.xMin, this.head.yMin, this.head.xMax, this.head.yMax];
  }, t.prototype.registerTTF = function() {
    var A, e, r, n, i;
    if (this.scaleFactor = 1e3 / this.head.unitsPerEm, this.bbox = (function() {
      var o, s, c, u;
      for (u = [], o = 0, s = (c = this.bbox).length; o < s; o++) A = c[o], u.push(Math.round(A * this.scaleFactor));
      return u;
    }).call(this), this.stemV = 0, this.post.exists ? (r = 255 & (n = this.post.italic_angle), 32768 & (e = n >> 16) && (e = -(1 + (65535 ^ e))), this.italicAngle = +(e + "." + r)) : this.italicAngle = 0, this.ascender = Math.round(this.ascender * this.scaleFactor), this.decender = Math.round(this.decender * this.scaleFactor), this.lineGap = Math.round(this.lineGap * this.scaleFactor), this.capHeight = this.os2.exists && this.os2.capHeight || this.ascender, this.xHeight = this.os2.exists && this.os2.xHeight || 0, this.familyClass = (this.os2.exists && this.os2.familyClass || 0) >> 8, this.isSerif = (i = this.familyClass) === 1 || i === 2 || i === 3 || i === 4 || i === 5 || i === 7, this.isScript = this.familyClass === 10, this.flags = 0, this.post.isFixedPitch && (this.flags |= 1), this.isSerif && (this.flags |= 2), this.isScript && (this.flags |= 8), this.italicAngle !== 0 && (this.flags |= 64), this.flags |= 32, !this.cmap.unicode) throw new Error("No unicode cmap for font");
  }, t.prototype.characterToGlyph = function(A) {
    var e;
    return ((e = this.cmap.unicode) != null ? e.codeMap[A] : void 0) || 0;
  }, t.prototype.widthOfGlyph = function(A) {
    var e;
    return e = 1e3 / this.head.unitsPerEm, this.hmtx.forGlyph(A).advance * e;
  }, t.prototype.widthOfString = function(A, e, r) {
    var n, i, o, s;
    for (o = 0, i = 0, s = (A = "" + A).length; 0 <= s ? i < s : i > s; i = 0 <= s ? ++i : --i) n = A.charCodeAt(i), o += this.widthOfGlyph(this.characterToGlyph(n)) + r * (1e3 / e) || 0;
    return o * (e / 1e3);
  }, t.prototype.lineHeight = function(A, e) {
    var r;
    return e == null && (e = !1), r = e ? this.lineGap : 0, (this.ascender + r - this.decender) / 1e3 * A;
  }, t;
})();
var yr, Gn = (function() {
  function t(A) {
    this.data = A ?? [], this.pos = 0, this.length = this.data.length;
  }
  return t.prototype.readByte = function() {
    return this.data[this.pos++];
  }, t.prototype.writeByte = function(A) {
    return this.data[this.pos++] = A;
  }, t.prototype.readUInt32 = function() {
    return 16777216 * this.readByte() + (this.readByte() << 16) + (this.readByte() << 8) + this.readByte();
  }, t.prototype.writeUInt32 = function(A) {
    return this.writeByte(A >>> 24 & 255), this.writeByte(A >> 16 & 255), this.writeByte(A >> 8 & 255), this.writeByte(255 & A);
  }, t.prototype.readInt32 = function() {
    var A;
    return (A = this.readUInt32()) >= 2147483648 ? A - 4294967296 : A;
  }, t.prototype.writeInt32 = function(A) {
    return A < 0 && (A += 4294967296), this.writeUInt32(A);
  }, t.prototype.readUInt16 = function() {
    return this.readByte() << 8 | this.readByte();
  }, t.prototype.writeUInt16 = function(A) {
    return this.writeByte(A >> 8 & 255), this.writeByte(255 & A);
  }, t.prototype.readInt16 = function() {
    var A;
    return (A = this.readUInt16()) >= 32768 ? A - 65536 : A;
  }, t.prototype.writeInt16 = function(A) {
    return A < 0 && (A += 65536), this.writeUInt16(A);
  }, t.prototype.readString = function(A) {
    var e, r;
    for (r = [], e = 0; 0 <= A ? e < A : e > A; e = 0 <= A ? ++e : --e) r[e] = String.fromCharCode(this.readByte());
    return r.join("");
  }, t.prototype.writeString = function(A) {
    var e, r, n;
    for (n = [], e = 0, r = A.length; 0 <= r ? e < r : e > r; e = 0 <= r ? ++e : --e) n.push(this.writeByte(A.charCodeAt(e)));
    return n;
  }, t.prototype.readShort = function() {
    return this.readInt16();
  }, t.prototype.writeShort = function(A) {
    return this.writeInt16(A);
  }, t.prototype.readLongLong = function() {
    var A, e, r, n, i, o, s, c;
    return A = this.readByte(), e = this.readByte(), r = this.readByte(), n = this.readByte(), i = this.readByte(), o = this.readByte(), s = this.readByte(), c = this.readByte(), 128 & A ? -1 * (72057594037927940 * (255 ^ A) + 281474976710656 * (255 ^ e) + 1099511627776 * (255 ^ r) + 4294967296 * (255 ^ n) + 16777216 * (255 ^ i) + 65536 * (255 ^ o) + 256 * (255 ^ s) + (255 ^ c) + 1) : 72057594037927940 * A + 281474976710656 * e + 1099511627776 * r + 4294967296 * n + 16777216 * i + 65536 * o + 256 * s + c;
  }, t.prototype.writeLongLong = function(A) {
    var e, r;
    return e = Math.floor(A / 4294967296), r = 4294967295 & A, this.writeByte(e >> 24 & 255), this.writeByte(e >> 16 & 255), this.writeByte(e >> 8 & 255), this.writeByte(255 & e), this.writeByte(r >> 24 & 255), this.writeByte(r >> 16 & 255), this.writeByte(r >> 8 & 255), this.writeByte(255 & r);
  }, t.prototype.readInt = function() {
    return this.readInt32();
  }, t.prototype.writeInt = function(A) {
    return this.writeInt32(A);
  }, t.prototype.read = function(A) {
    var e, r;
    for (e = [], r = 0; 0 <= A ? r < A : r > A; r = 0 <= A ? ++r : --r) e.push(this.readByte());
    return e;
  }, t.prototype.write = function(A) {
    var e, r, n, i;
    for (i = [], r = 0, n = A.length; r < n; r++) e = A[r], i.push(this.writeByte(e));
    return i;
  }, t;
})(), R4 = (function() {
  var t;
  function A(e) {
    var r, n, i;
    for (this.scalarType = e.readInt(), this.tableCount = e.readShort(), this.searchRange = e.readShort(), this.entrySelector = e.readShort(), this.rangeShift = e.readShort(), this.tables = {}, n = 0, i = this.tableCount; 0 <= i ? n < i : n > i; n = 0 <= i ? ++n : --n) r = { tag: e.readString(4), checksum: e.readInt(), offset: e.readInt(), length: e.readInt() }, this.tables[r.tag] = r;
  }
  return A.prototype.encode = function(e) {
    var r, n, i, o, s, c, u, h, p, w, d, y, b;
    for (b in d = Object.keys(e).length, c = Math.log(2), p = 16 * Math.floor(Math.log(d) / c), o = Math.floor(p / c), h = 16 * d - p, (n = new Gn()).writeInt(this.scalarType), n.writeShort(d), n.writeShort(p), n.writeShort(o), n.writeShort(h), i = 16 * d, u = n.pos + i, s = null, y = [], e) for (w = e[b], n.writeString(b), n.writeInt(t(w)), n.writeInt(u), n.writeInt(w.length), y = y.concat(w), b === "head" && (s = u), u += w.length; u % 4; ) y.push(0), u++;
    return n.write(y), r = 2981146554 - t(n.data), n.pos = s + 8, n.writeUInt32(r), n.data;
  }, t = function(e) {
    var r, n, i, o;
    for (e = nB.call(e); e.length % 4; ) e.push(0);
    for (i = new Gn(e), n = 0, r = 0, o = e.length; r < o; r = r += 4) n += i.readUInt32();
    return 4294967295 & n;
  }, A;
})(), G4 = {}.hasOwnProperty, Rr = function(t, A) {
  for (var e in A) G4.call(A, e) && (t[e] = A[e]);
  function r() {
    this.constructor = t;
  }
  return r.prototype = A.prototype, t.prototype = new r(), t.__super__ = A.prototype, t;
};
yr = (function() {
  function t(A) {
    var e;
    this.file = A, e = this.file.directory.tables[this.tag], this.exists = !!e, e && (this.offset = e.offset, this.length = e.length, this.parse(this.file.contents));
  }
  return t.prototype.parse = function() {
  }, t.prototype.encode = function() {
  }, t.prototype.raw = function() {
    return this.exists ? (this.file.contents.pos = this.offset, this.file.contents.read(this.length)) : null;
  }, t;
})();
var V4 = (function() {
  function t() {
    return t.__super__.constructor.apply(this, arguments);
  }
  return Rr(t, yr), t.prototype.tag = "head", t.prototype.parse = function(A) {
    return A.pos = this.offset, this.version = A.readInt(), this.revision = A.readInt(), this.checkSumAdjustment = A.readInt(), this.magicNumber = A.readInt(), this.flags = A.readShort(), this.unitsPerEm = A.readShort(), this.created = A.readLongLong(), this.modified = A.readLongLong(), this.xMin = A.readShort(), this.yMin = A.readShort(), this.xMax = A.readShort(), this.yMax = A.readShort(), this.macStyle = A.readShort(), this.lowestRecPPEM = A.readShort(), this.fontDirectionHint = A.readShort(), this.indexToLocFormat = A.readShort(), this.glyphDataFormat = A.readShort();
  }, t.prototype.encode = function(A) {
    var e;
    return (e = new Gn()).writeInt(this.version), e.writeInt(this.revision), e.writeInt(this.checkSumAdjustment), e.writeInt(this.magicNumber), e.writeShort(this.flags), e.writeShort(this.unitsPerEm), e.writeLongLong(this.created), e.writeLongLong(this.modified), e.writeShort(this.xMin), e.writeShort(this.yMin), e.writeShort(this.xMax), e.writeShort(this.yMax), e.writeShort(this.macStyle), e.writeShort(this.lowestRecPPEM), e.writeShort(this.fontDirectionHint), e.writeShort(A), e.writeShort(this.glyphDataFormat), e.data;
  }, t;
})(), c0 = (function() {
  function t(A, e) {
    var r, n, i, o, s, c, u, h, p, w, d, y, b, S, Q, P, G;
    switch (this.platformID = A.readUInt16(), this.encodingID = A.readShort(), this.offset = e + A.readInt(), p = A.pos, A.pos = this.offset, this.format = A.readUInt16(), this.length = A.readUInt16(), this.language = A.readUInt16(), this.isUnicode = this.platformID === 3 && this.encodingID === 1 && this.format === 4 || this.platformID === 0 && this.format === 4, this.codeMap = {}, this.format) {
      case 0:
        for (c = 0; c < 256; ++c) this.codeMap[c] = A.readByte();
        break;
      case 4:
        for (d = A.readUInt16(), w = d / 2, A.pos += 6, i = (function() {
          var k, Y;
          for (Y = [], c = k = 0; 0 <= w ? k < w : k > w; c = 0 <= w ? ++k : --k) Y.push(A.readUInt16());
          return Y;
        })(), A.pos += 2, b = (function() {
          var k, Y;
          for (Y = [], c = k = 0; 0 <= w ? k < w : k > w; c = 0 <= w ? ++k : --k) Y.push(A.readUInt16());
          return Y;
        })(), u = (function() {
          var k, Y;
          for (Y = [], c = k = 0; 0 <= w ? k < w : k > w; c = 0 <= w ? ++k : --k) Y.push(A.readUInt16());
          return Y;
        })(), h = (function() {
          var k, Y;
          for (Y = [], c = k = 0; 0 <= w ? k < w : k > w; c = 0 <= w ? ++k : --k) Y.push(A.readUInt16());
          return Y;
        })(), n = (this.length - A.pos + this.offset) / 2, s = (function() {
          var k, Y;
          for (Y = [], c = k = 0; 0 <= n ? k < n : k > n; c = 0 <= n ? ++k : --k) Y.push(A.readUInt16());
          return Y;
        })(), c = Q = 0, G = i.length; Q < G; c = ++Q) for (S = i[c], r = P = y = b[c]; y <= S ? P <= S : P >= S; r = y <= S ? ++P : --P) h[c] === 0 ? o = r + u[c] : (o = s[h[c] / 2 + (r - y) - (w - c)] || 0) !== 0 && (o += u[c]), this.codeMap[r] = 65535 & o;
    }
    A.pos = p;
  }
  return t.encode = function(A, e) {
    var r, n, i, o, s, c, u, h, p, w, d, y, b, S, Q, P, G, k, Y, z, iA, j, N, Z, E, I, K, R, aA, sA, oA, tA, cA, QA, pA, F, O, M, q, X, eA, lA, uA, gA, FA, LA;
    switch (R = new Gn(), o = Object.keys(A).sort(function(yA, KA) {
      return yA - KA;
    }), e) {
      case "macroman":
        for (b = 0, S = (function() {
          var yA = [];
          for (y = 0; y < 256; ++y) yA.push(0);
          return yA;
        })(), P = { 0: 0 }, i = {}, aA = 0, cA = o.length; aA < cA; aA++) P[uA = A[n = o[aA]]] == null && (P[uA] = ++b), i[n] = { old: A[n], new: P[A[n]] }, S[n] = P[A[n]];
        return R.writeUInt16(1), R.writeUInt16(0), R.writeUInt32(12), R.writeUInt16(0), R.writeUInt16(262), R.writeUInt16(0), R.write(S), { charMap: i, subtable: R.data, maxGlyphID: b + 1 };
      case "unicode":
        for (I = [], p = [], G = 0, P = {}, r = {}, Q = u = null, sA = 0, QA = o.length; sA < QA; sA++) P[Y = A[n = o[sA]]] == null && (P[Y] = ++G), r[n] = { old: Y, new: P[Y] }, s = P[Y] - n, Q != null && s === u || (Q && p.push(Q), I.push(n), u = s), Q = n;
        for (Q && p.push(Q), p.push(65535), I.push(65535), Z = 2 * (N = I.length), j = 2 * Math.pow(Math.log(N) / Math.LN2, 2), w = Math.log(j / 2) / Math.LN2, iA = 2 * N - j, c = [], z = [], d = [], y = oA = 0, pA = I.length; oA < pA; y = ++oA) {
          if (E = I[y], h = p[y], E === 65535) {
            c.push(0), z.push(0);
            break;
          }
          if (E - (K = r[E].new) >= 32768) for (c.push(0), z.push(2 * (d.length + N - y)), n = tA = E; E <= h ? tA <= h : tA >= h; n = E <= h ? ++tA : --tA) d.push(r[n].new);
          else c.push(K - E), z.push(0);
        }
        for (R.writeUInt16(3), R.writeUInt16(1), R.writeUInt32(12), R.writeUInt16(4), R.writeUInt16(16 + 8 * N + 2 * d.length), R.writeUInt16(0), R.writeUInt16(Z), R.writeUInt16(j), R.writeUInt16(w), R.writeUInt16(iA), eA = 0, F = p.length; eA < F; eA++) n = p[eA], R.writeUInt16(n);
        for (R.writeUInt16(0), lA = 0, O = I.length; lA < O; lA++) n = I[lA], R.writeUInt16(n);
        for (gA = 0, M = c.length; gA < M; gA++) s = c[gA], R.writeUInt16(s);
        for (FA = 0, q = z.length; FA < q; FA++) k = z[FA], R.writeUInt16(k);
        for (LA = 0, X = d.length; LA < X; LA++) b = d[LA], R.writeUInt16(b);
        return { charMap: r, subtable: R.data, maxGlyphID: G + 1 };
    }
  }, t;
})(), rB = (function() {
  function t() {
    return t.__super__.constructor.apply(this, arguments);
  }
  return Rr(t, yr), t.prototype.tag = "cmap", t.prototype.parse = function(A) {
    var e, r, n;
    for (A.pos = this.offset, this.version = A.readUInt16(), n = A.readUInt16(), this.tables = [], this.unicode = null, r = 0; 0 <= n ? r < n : r > n; r = 0 <= n ? ++r : --r) e = new c0(A, this.offset), this.tables.push(e), e.isUnicode && this.unicode == null && (this.unicode = e);
    return !0;
  }, t.encode = function(A, e) {
    var r, n;
    return e == null && (e = "macroman"), r = c0.encode(A, e), (n = new Gn()).writeUInt16(0), n.writeUInt16(1), r.table = n.data.concat(r.subtable), r;
  }, t;
})(), j4 = (function() {
  function t() {
    return t.__super__.constructor.apply(this, arguments);
  }
  return Rr(t, yr), t.prototype.tag = "hhea", t.prototype.parse = function(A) {
    return A.pos = this.offset, this.version = A.readInt(), this.ascender = A.readShort(), this.decender = A.readShort(), this.lineGap = A.readShort(), this.advanceWidthMax = A.readShort(), this.minLeftSideBearing = A.readShort(), this.minRightSideBearing = A.readShort(), this.xMaxExtent = A.readShort(), this.caretSlopeRise = A.readShort(), this.caretSlopeRun = A.readShort(), this.caretOffset = A.readShort(), A.pos += 8, this.metricDataFormat = A.readShort(), this.numberOfMetrics = A.readUInt16();
  }, t;
})(), q4 = (function() {
  function t() {
    return t.__super__.constructor.apply(this, arguments);
  }
  return Rr(t, yr), t.prototype.tag = "OS/2", t.prototype.parse = function(A) {
    if (A.pos = this.offset, this.version = A.readUInt16(), this.averageCharWidth = A.readShort(), this.weightClass = A.readUInt16(), this.widthClass = A.readUInt16(), this.type = A.readShort(), this.ySubscriptXSize = A.readShort(), this.ySubscriptYSize = A.readShort(), this.ySubscriptXOffset = A.readShort(), this.ySubscriptYOffset = A.readShort(), this.ySuperscriptXSize = A.readShort(), this.ySuperscriptYSize = A.readShort(), this.ySuperscriptXOffset = A.readShort(), this.ySuperscriptYOffset = A.readShort(), this.yStrikeoutSize = A.readShort(), this.yStrikeoutPosition = A.readShort(), this.familyClass = A.readShort(), this.panose = (function() {
      var e, r;
      for (r = [], e = 0; e < 10; ++e) r.push(A.readByte());
      return r;
    })(), this.charRange = (function() {
      var e, r;
      for (r = [], e = 0; e < 4; ++e) r.push(A.readInt());
      return r;
    })(), this.vendorID = A.readString(4), this.selection = A.readShort(), this.firstCharIndex = A.readShort(), this.lastCharIndex = A.readShort(), this.version > 0 && (this.ascent = A.readShort(), this.descent = A.readShort(), this.lineGap = A.readShort(), this.winAscent = A.readShort(), this.winDescent = A.readShort(), this.codePageRange = (function() {
      var e, r;
      for (r = [], e = 0; e < 2; e = ++e) r.push(A.readInt());
      return r;
    })(), this.version > 1)) return this.xHeight = A.readShort(), this.capHeight = A.readShort(), this.defaultChar = A.readShort(), this.breakChar = A.readShort(), this.maxContext = A.readShort();
  }, t;
})(), W4 = (function() {
  function t() {
    return t.__super__.constructor.apply(this, arguments);
  }
  return Rr(t, yr), t.prototype.tag = "post", t.prototype.parse = function(A) {
    var e, r, n;
    switch (A.pos = this.offset, this.format = A.readInt(), this.italicAngle = A.readInt(), this.underlinePosition = A.readShort(), this.underlineThickness = A.readShort(), this.isFixedPitch = A.readInt(), this.minMemType42 = A.readInt(), this.maxMemType42 = A.readInt(), this.minMemType1 = A.readInt(), this.maxMemType1 = A.readInt(), this.format) {
      case 65536:
      case 196608:
        break;
      case 131072:
        var i;
        for (r = A.readUInt16(), this.glyphNameIndex = [], i = 0; 0 <= r ? i < r : i > r; i = 0 <= r ? ++i : --i) this.glyphNameIndex.push(A.readUInt16());
        for (this.names = [], n = []; A.pos < this.offset + this.length; ) e = A.readByte(), n.push(this.names.push(A.readString(e)));
        return n;
      case 151552:
        return r = A.readUInt16(), this.offsets = A.read(r);
      case 262144:
        return this.map = (function() {
          var o, s, c;
          for (c = [], i = o = 0, s = this.file.maxp.numGlyphs; 0 <= s ? o < s : o > s; i = 0 <= s ? ++o : --o) c.push(A.readUInt32());
          return c;
        }).call(this);
    }
  }, t;
})(), X4 = function(t, A) {
  this.raw = t, this.length = t.length, this.platformID = A.platformID, this.encodingID = A.encodingID, this.languageID = A.languageID;
}, J4 = (function() {
  function t() {
    return t.__super__.constructor.apply(this, arguments);
  }
  return Rr(t, yr), t.prototype.tag = "name", t.prototype.parse = function(A) {
    var e, r, n, i, o, s, c, u, h, p, w;
    for (A.pos = this.offset, A.readShort(), e = A.readShort(), s = A.readShort(), r = [], i = 0; 0 <= e ? i < e : i > e; i = 0 <= e ? ++i : --i) r.push({ platformID: A.readShort(), encodingID: A.readShort(), languageID: A.readShort(), nameID: A.readShort(), length: A.readShort(), offset: this.offset + s + A.readShort() });
    for (c = {}, i = h = 0, p = r.length; h < p; i = ++h) n = r[i], A.pos = n.offset, u = A.readString(n.length), o = new X4(u, n), c[w = n.nameID] == null && (c[w] = []), c[n.nameID].push(o);
    this.strings = c, this.copyright = c[0], this.fontFamily = c[1], this.fontSubfamily = c[2], this.uniqueSubfamily = c[3], this.fontName = c[4], this.version = c[5];
    try {
      this.postscriptName = c[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
    } catch {
      this.postscriptName = c[4][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
    }
    return this.trademark = c[7], this.manufacturer = c[8], this.designer = c[9], this.description = c[10], this.vendorUrl = c[11], this.designerUrl = c[12], this.license = c[13], this.licenseUrl = c[14], this.preferredFamily = c[15], this.preferredSubfamily = c[17], this.compatibleFull = c[18], this.sampleText = c[19];
  }, t;
})(), Y4 = (function() {
  function t() {
    return t.__super__.constructor.apply(this, arguments);
  }
  return Rr(t, yr), t.prototype.tag = "maxp", t.prototype.parse = function(A) {
    return A.pos = this.offset, this.version = A.readInt(), this.numGlyphs = A.readUInt16(), this.maxPoints = A.readUInt16(), this.maxContours = A.readUInt16(), this.maxCompositePoints = A.readUInt16(), this.maxComponentContours = A.readUInt16(), this.maxZones = A.readUInt16(), this.maxTwilightPoints = A.readUInt16(), this.maxStorage = A.readUInt16(), this.maxFunctionDefs = A.readUInt16(), this.maxInstructionDefs = A.readUInt16(), this.maxStackElements = A.readUInt16(), this.maxSizeOfInstructions = A.readUInt16(), this.maxComponentElements = A.readUInt16(), this.maxComponentDepth = A.readUInt16();
  }, t;
})(), z4 = (function() {
  function t() {
    return t.__super__.constructor.apply(this, arguments);
  }
  return Rr(t, yr), t.prototype.tag = "hmtx", t.prototype.parse = function(A) {
    var e, r, n, i, o, s, c;
    for (A.pos = this.offset, this.metrics = [], e = 0, s = this.file.hhea.numberOfMetrics; 0 <= s ? e < s : e > s; e = 0 <= s ? ++e : --e) this.metrics.push({ advance: A.readUInt16(), lsb: A.readInt16() });
    for (n = this.file.maxp.numGlyphs - this.file.hhea.numberOfMetrics, this.leftSideBearings = (function() {
      var u, h;
      for (h = [], e = u = 0; 0 <= n ? u < n : u > n; e = 0 <= n ? ++u : --u) h.push(A.readInt16());
      return h;
    })(), this.widths = (function() {
      var u, h, p, w;
      for (w = [], u = 0, h = (p = this.metrics).length; u < h; u++) i = p[u], w.push(i.advance);
      return w;
    }).call(this), r = this.widths[this.widths.length - 1], c = [], e = o = 0; 0 <= n ? o < n : o > n; e = 0 <= n ? ++o : --o) c.push(this.widths.push(r));
    return c;
  }, t.prototype.forGlyph = function(A) {
    return A in this.metrics ? this.metrics[A] : { advance: this.metrics[this.metrics.length - 1].advance, lsb: this.leftSideBearings[A - this.metrics.length] };
  }, t;
})(), nB = [].slice, Z4 = (function() {
  function t() {
    return t.__super__.constructor.apply(this, arguments);
  }
  return Rr(t, yr), t.prototype.tag = "glyf", t.prototype.parse = function() {
    return this.cache = {};
  }, t.prototype.glyphFor = function(A) {
    var e, r, n, i, o, s, c, u, h, p;
    return A in this.cache ? this.cache[A] : (i = this.file.loca, e = this.file.contents, r = i.indexOf(A), (n = i.lengthOf(A)) === 0 ? this.cache[A] = null : (e.pos = this.offset + r, o = (s = new Gn(e.read(n))).readShort(), u = s.readShort(), p = s.readShort(), c = s.readShort(), h = s.readShort(), this.cache[A] = o === -1 ? new AC(s, u, p, c, h) : new $4(s, o, u, p, c, h), this.cache[A]));
  }, t.prototype.encode = function(A, e, r) {
    var n, i, o, s, c;
    for (o = [], i = [], s = 0, c = e.length; s < c; s++) n = A[e[s]], i.push(o.length), n && (o = o.concat(n.encode(r)));
    return i.push(o.length), { table: o, offsets: i };
  }, t;
})(), $4 = (function() {
  function t(A, e, r, n, i, o) {
    this.raw = A, this.numberOfContours = e, this.xMin = r, this.yMin = n, this.xMax = i, this.yMax = o, this.compound = !1;
  }
  return t.prototype.encode = function() {
    return this.raw.data;
  }, t;
})(), AC = (function() {
  function t(A, e, r, n, i) {
    var o, s;
    for (this.raw = A, this.xMin = e, this.yMin = r, this.xMax = n, this.yMax = i, this.compound = !0, this.glyphIDs = [], this.glyphOffsets = [], o = this.raw; s = o.readShort(), this.glyphOffsets.push(o.pos), this.glyphIDs.push(o.readUInt16()), 32 & s; ) o.pos += 1 & s ? 4 : 2, 128 & s ? o.pos += 8 : 64 & s ? o.pos += 4 : 8 & s && (o.pos += 2);
  }
  return t.prototype.encode = function() {
    var A, e, r;
    for (e = new Gn(nB.call(this.raw.data)), A = 0, r = this.glyphIDs.length; A < r; ++A) e.pos = this.glyphOffsets[A];
    return e.data;
  }, t;
})(), eC = (function() {
  function t() {
    return t.__super__.constructor.apply(this, arguments);
  }
  return Rr(t, yr), t.prototype.tag = "loca", t.prototype.parse = function(A) {
    var e, r;
    return A.pos = this.offset, e = this.file.head.indexToLocFormat, this.offsets = e === 0 ? (function() {
      var n, i;
      for (i = [], r = 0, n = this.length; r < n; r += 2) i.push(2 * A.readUInt16());
      return i;
    }).call(this) : (function() {
      var n, i;
      for (i = [], r = 0, n = this.length; r < n; r += 4) i.push(A.readUInt32());
      return i;
    }).call(this);
  }, t.prototype.indexOf = function(A) {
    return this.offsets[A];
  }, t.prototype.lengthOf = function(A) {
    return this.offsets[A + 1] - this.offsets[A];
  }, t.prototype.encode = function(A, e) {
    for (var r = new Uint32Array(this.offsets.length), n = 0, i = 0, o = 0; o < r.length; ++o) if (r[o] = n, i < e.length && e[i] == o) {
      ++i, r[o] = n;
      var s = this.offsets[o], c = this.offsets[o + 1] - s;
      c > 0 && (n += c);
    }
    for (var u = new Array(4 * r.length), h = 0; h < r.length; ++h) u[4 * h + 3] = 255 & r[h], u[4 * h + 2] = (65280 & r[h]) >> 8, u[4 * h + 1] = (16711680 & r[h]) >> 16, u[4 * h] = (4278190080 & r[h]) >> 24;
    return u;
  }, t;
})(), tC = (function() {
  function t(A) {
    this.font = A, this.subset = {}, this.unicodes = {}, this.next = 33;
  }
  return t.prototype.generateCmap = function() {
    var A, e, r, n, i;
    for (e in n = this.font.cmap.tables[0].codeMap, A = {}, i = this.subset) r = i[e], A[e] = n[r];
    return A;
  }, t.prototype.glyphsFor = function(A) {
    var e, r, n, i, o, s, c;
    for (n = {}, o = 0, s = A.length; o < s; o++) n[i = A[o]] = this.font.glyf.glyphFor(i);
    for (i in e = [], n) (r = n[i]) != null && r.compound && e.push.apply(e, r.glyphIDs);
    if (e.length > 0) for (i in c = this.glyphsFor(e)) r = c[i], n[i] = r;
    return n;
  }, t.prototype.encode = function(A, e) {
    var r, n, i, o, s, c, u, h, p, w, d, y, b, S, Q;
    for (n in r = rB.encode(this.generateCmap(), "unicode"), o = this.glyphsFor(A), d = { 0: 0 }, Q = r.charMap) d[(c = Q[n]).old] = c.new;
    for (y in w = r.maxGlyphID, o) y in d || (d[y] = w++);
    return h = (function(P) {
      var G, k;
      for (G in k = {}, P) k[P[G]] = G;
      return k;
    })(d), p = Object.keys(h).sort(function(P, G) {
      return P - G;
    }), b = (function() {
      var P, G, k;
      for (k = [], P = 0, G = p.length; P < G; P++) s = p[P], k.push(h[s]);
      return k;
    })(), i = this.font.glyf.encode(o, b, d), u = this.font.loca.encode(i.offsets, b), S = { cmap: this.font.cmap.raw(), glyf: i.table, loca: u, hmtx: this.font.hmtx.raw(), hhea: this.font.hhea.raw(), maxp: this.font.maxp.raw(), post: this.font.post.raw(), name: this.font.name.raw(), head: this.font.head.encode(e) }, this.font.os2.exists && (S["OS/2"] = this.font.os2.raw()), this.font.directory.encode(S);
  }, t;
})();
PA.API.PDFObject = (function() {
  var t;
  function A() {
  }
  return t = function(e, r) {
    return (Array(r + 1).join("0") + e).slice(-r);
  }, A.convert = function(e) {
    var r, n, i, o;
    if (Array.isArray(e)) return "[" + (function() {
      var s, c, u;
      for (u = [], s = 0, c = e.length; s < c; s++) r = e[s], u.push(A.convert(r));
      return u;
    })().join(" ") + "]";
    if (typeof e == "string") return "/" + e;
    if (e != null && e.isString) return "(" + e + ")";
    if (e instanceof Date) return "(D:" + t(e.getUTCFullYear(), 4) + t(e.getUTCMonth(), 2) + t(e.getUTCDate(), 2) + t(e.getUTCHours(), 2) + t(e.getUTCMinutes(), 2) + t(e.getUTCSeconds(), 2) + "Z)";
    if ({}.toString.call(e) === "[object Object]") {
      for (n in i = ["<<"], e) o = e[n], i.push("/" + n + " " + A.convert(o));
      return i.push(">>"), i.join(`
`);
    }
    return "" + e;
  }, A;
})();
const nC = async (t, A) => {
  const e = await h1(t, { scale: 2 }), r = e.toDataURL("image/png"), n = new PA({
    orientation: "portrait",
    unit: "px",
    format: [e.width, e.height]
  });
  n.addImage(r, "PNG", 0, 0, e.width, e.height), await n.save(`${A}.pdf`);
};
export {
  Ee as _,
  nC as h
};
//# sourceMappingURL=files-zqKMkTpV.js.map
